var Pc = (e) => {
  throw TypeError(e);
};
var Ac = (e, t, a) => t.has(e) || Pc("Cannot " + a);
var Qe = (e, t, a) => (Ac(e, t, "read from private field"), a ? a.call(e) : t.get(e)), Lc = (e, t, a) => t.has(e) ? Pc("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, a), ui = (e, t, a, o) => (Ac(e, t, "write to private field"), o ? o.call(e, a) : t.set(e, a), a);
import { jsx as s, jsxs as x, Fragment as ut } from "react/jsx-runtime";
import * as b from "react";
import W, { createContext as xa, useContext as $t, forwardRef as us, isValidElement as yi, useMemo as fe, useState as j, useRef as ve, useEffect as ne, useCallback as be, createElement as $i, useLayoutEffect as Ep, memo as Eb, useReducer as Db } from "react";
import * as wr from "react-dom";
import Fb, { unstable_batchedUpdates as zr, createPortal as Ib } from "react-dom";
import Ob from "react-dom/client";
const Dp = xa(null), ia = () => {
  const e = $t(Dp);
  if (!e) throw new Error("useConfig must be used inside ThemeBuilderEmbed");
  return e;
};
var Rb = (e) => {
  switch (e) {
    case "success":
      return Vb;
    case "info":
      return $b;
    case "warning":
      return Wb;
    case "error":
      return _b;
    default:
      return null;
  }
}, Bb = Array(12).fill(0), zb = ({ visible: e, className: t }) => W.createElement("div", { className: ["sonner-loading-wrapper", t].filter(Boolean).join(" "), "data-visible": e }, W.createElement("div", { className: "sonner-spinner" }, Bb.map((a, o) => W.createElement("div", { className: "sonner-loading-bar", key: `spinner-bar-${o}` })))), Vb = W.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, W.createElement("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z", clipRule: "evenodd" })), Wb = W.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", height: "20", width: "20" }, W.createElement("path", { fillRule: "evenodd", d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z", clipRule: "evenodd" })), $b = W.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, W.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z", clipRule: "evenodd" })), _b = W.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, W.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z", clipRule: "evenodd" })), Hb = W.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, W.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), W.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" })), Ub = () => {
  let [e, t] = W.useState(document.hidden);
  return W.useEffect(() => {
    let a = () => {
      t(document.hidden);
    };
    return document.addEventListener("visibilitychange", a), () => window.removeEventListener("visibilitychange", a);
  }, []), e;
}, _i = 1, Gb = class {
  constructor() {
    this.subscribe = (e) => (this.subscribers.push(e), () => {
      let t = this.subscribers.indexOf(e);
      this.subscribers.splice(t, 1);
    }), this.publish = (e) => {
      this.subscribers.forEach((t) => t(e));
    }, this.addToast = (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    }, this.create = (e) => {
      var t;
      let { message: a, ...o } = e, r = typeof (e == null ? void 0 : e.id) == "number" || ((t = e.id) == null ? void 0 : t.length) > 0 ? e.id : _i++, l = this.toasts.find((n) => n.id === r), i = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(r) && this.dismissedToasts.delete(r), l ? this.toasts = this.toasts.map((n) => n.id === r ? (this.publish({ ...n, ...e, id: r, title: a }), { ...n, ...e, id: r, dismissible: i, title: a }) : n) : this.addToast({ title: a, ...o, dismissible: i, id: r }), r;
    }, this.dismiss = (e) => (this.dismissedToasts.add(e), e || this.toasts.forEach((t) => {
      this.subscribers.forEach((a) => a({ id: t.id, dismiss: !0 }));
    }), this.subscribers.forEach((t) => t({ id: e, dismiss: !0 })), e), this.message = (e, t) => this.create({ ...t, message: e }), this.error = (e, t) => this.create({ ...t, message: e, type: "error" }), this.success = (e, t) => this.create({ ...t, type: "success", message: e }), this.info = (e, t) => this.create({ ...t, type: "info", message: e }), this.warning = (e, t) => this.create({ ...t, type: "warning", message: e }), this.loading = (e, t) => this.create({ ...t, type: "loading", message: e }), this.promise = (e, t) => {
      if (!t) return;
      let a;
      t.loading !== void 0 && (a = this.create({ ...t, promise: e, type: "loading", message: t.loading, description: typeof t.description != "function" ? t.description : void 0 }));
      let o = e instanceof Promise ? e : e(), r = a !== void 0, l, i = o.then(async (c) => {
        if (l = ["resolve", c], W.isValidElement(c)) r = !1, this.create({ id: a, type: "default", message: c });
        else if (Xb(c) && !c.ok) {
          r = !1;
          let d = typeof t.error == "function" ? await t.error(`HTTP error! status: ${c.status}`) : t.error, y = typeof t.description == "function" ? await t.description(`HTTP error! status: ${c.status}`) : t.description;
          this.create({ id: a, type: "error", message: d, description: y });
        } else if (t.success !== void 0) {
          r = !1;
          let d = typeof t.success == "function" ? await t.success(c) : t.success, y = typeof t.description == "function" ? await t.description(c) : t.description;
          this.create({ id: a, type: "success", message: d, description: y });
        }
      }).catch(async (c) => {
        if (l = ["reject", c], t.error !== void 0) {
          r = !1;
          let d = typeof t.error == "function" ? await t.error(c) : t.error, y = typeof t.description == "function" ? await t.description(c) : t.description;
          this.create({ id: a, type: "error", message: d, description: y });
        }
      }).finally(() => {
        var c;
        r && (this.dismiss(a), a = void 0), (c = t.finally) == null || c.call(t);
      }), n = () => new Promise((c, d) => i.then(() => l[0] === "reject" ? d(l[1]) : c(l[1])).catch(d));
      return typeof a != "string" && typeof a != "number" ? { unwrap: n } : Object.assign(a, { unwrap: n });
    }, this.custom = (e, t) => {
      let a = (t == null ? void 0 : t.id) || _i++;
      return this.create({ jsx: e(a), id: a, ...t }), a;
    }, this.getActiveToasts = () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}, rt = new Gb(), Yb = (e, t) => {
  let a = (t == null ? void 0 : t.id) || _i++;
  return rt.addToast({ title: e, ...t, id: a }), a;
}, Xb = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", jb = Yb, qb = () => rt.toasts, Zb = () => rt.getActiveToasts(), Me = Object.assign(jb, { success: rt.success, info: rt.info, warning: rt.warning, error: rt.error, custom: rt.custom, message: rt.message, promise: rt.promise, dismiss: rt.dismiss, loading: rt.loading }, { getHistory: qb, getToasts: Zb });
function Jb(e, { insertAt: t } = {}) {
  if (typeof document > "u") return;
  let a = document.head || document.getElementsByTagName("head")[0], o = document.createElement("style");
  o.type = "text/css", t === "top" && a.firstChild ? a.insertBefore(o, a.firstChild) : a.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
}
Jb(`:where(html[dir="ltr"]),:where([data-sonner-toaster][dir="ltr"]){--toast-icon-margin-start: -3px;--toast-icon-margin-end: 4px;--toast-svg-margin-start: -1px;--toast-svg-margin-end: 0px;--toast-button-margin-start: auto;--toast-button-margin-end: 0;--toast-close-button-start: 0;--toast-close-button-end: unset;--toast-close-button-transform: translate(-35%, -35%)}:where(html[dir="rtl"]),:where([data-sonner-toaster][dir="rtl"]){--toast-icon-margin-start: 4px;--toast-icon-margin-end: -3px;--toast-svg-margin-start: 0px;--toast-svg-margin-end: -1px;--toast-button-margin-start: 0;--toast-button-margin-end: auto;--toast-close-button-start: unset;--toast-close-button-end: 0;--toast-close-button-transform: translate(35%, -35%)}:where([data-sonner-toaster]){position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1: hsl(0, 0%, 99%);--gray2: hsl(0, 0%, 97.3%);--gray3: hsl(0, 0%, 95.1%);--gray4: hsl(0, 0%, 93%);--gray5: hsl(0, 0%, 90.9%);--gray6: hsl(0, 0%, 88.7%);--gray7: hsl(0, 0%, 85.8%);--gray8: hsl(0, 0%, 78%);--gray9: hsl(0, 0%, 56.1%);--gray10: hsl(0, 0%, 52.3%);--gray11: hsl(0, 0%, 43.5%);--gray12: hsl(0, 0%, 9%);--border-radius: 8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:none;z-index:999999999;transition:transform .4s ease}:where([data-sonner-toaster][data-lifted="true"]){transform:translateY(-10px)}@media (hover: none) and (pointer: coarse){:where([data-sonner-toaster][data-lifted="true"]){transform:none}}:where([data-sonner-toaster][data-x-position="right"]){right:var(--offset-right)}:where([data-sonner-toaster][data-x-position="left"]){left:var(--offset-left)}:where([data-sonner-toaster][data-x-position="center"]){left:50%;transform:translate(-50%)}:where([data-sonner-toaster][data-y-position="top"]){top:var(--offset-top)}:where([data-sonner-toaster][data-y-position="bottom"]){bottom:var(--offset-bottom)}:where([data-sonner-toast]){--y: translateY(100%);--lift-amount: calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);filter:blur(0);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:none;overflow-wrap:anywhere}:where([data-sonner-toast][data-styled="true"]){padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px #0000001a;width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}:where([data-sonner-toast]:focus-visible){box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast][data-y-position="top"]){top:0;--y: translateY(-100%);--lift: 1;--lift-amount: calc(1 * var(--gap))}:where([data-sonner-toast][data-y-position="bottom"]){bottom:0;--y: translateY(100%);--lift: -1;--lift-amount: calc(var(--lift) * var(--gap))}:where([data-sonner-toast]) :where([data-description]){font-weight:400;line-height:1.4;color:inherit}:where([data-sonner-toast]) :where([data-title]){font-weight:500;line-height:1.5;color:inherit}:where([data-sonner-toast]) :where([data-icon]){display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}:where([data-sonner-toast][data-promise="true"]) :where([data-icon])>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}:where([data-sonner-toast]) :where([data-icon])>*{flex-shrink:0}:where([data-sonner-toast]) :where([data-icon]) svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}:where([data-sonner-toast]) :where([data-content]){display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;cursor:pointer;outline:none;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}:where([data-sonner-toast]) :where([data-button]):focus-visible{box-shadow:0 0 0 2px #0006}:where([data-sonner-toast]) :where([data-button]):first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}:where([data-sonner-toast]) :where([data-cancel]){color:var(--normal-text);background:rgba(0,0,0,.08)}:where([data-sonner-toast][data-theme="dark"]) :where([data-cancel]){background:rgba(255,255,255,.3)}:where([data-sonner-toast]) :where([data-close-button]){position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast] [data-close-button]{background:var(--gray1)}:where([data-sonner-toast]) :where([data-close-button]):focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast]) :where([data-disabled="true"]){cursor:not-allowed}:where([data-sonner-toast]):hover :where([data-close-button]):hover{background:var(--gray2);border-color:var(--gray5)}:where([data-sonner-toast][data-swiping="true"]):before{content:"";position:absolute;left:-50%;right:-50%;height:100%;z-index:-1}:where([data-sonner-toast][data-y-position="top"][data-swiping="true"]):before{bottom:50%;transform:scaleY(3) translateY(50%)}:where([data-sonner-toast][data-y-position="bottom"][data-swiping="true"]):before{top:50%;transform:scaleY(3) translateY(-50%)}:where([data-sonner-toast][data-swiping="false"][data-removed="true"]):before{content:"";position:absolute;inset:0;transform:scaleY(2)}:where([data-sonner-toast]):after{content:"";position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}:where([data-sonner-toast][data-mounted="true"]){--y: translateY(0);opacity:1}:where([data-sonner-toast][data-expanded="false"][data-front="false"]){--scale: var(--toasts-before) * .05 + 1;--y: translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}:where([data-sonner-toast])>*{transition:opacity .4s}:where([data-sonner-toast][data-expanded="false"][data-front="false"][data-styled="true"])>*{opacity:0}:where([data-sonner-toast][data-visible="false"]){opacity:0;pointer-events:none}:where([data-sonner-toast][data-mounted="true"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}:where([data-sonner-toast][data-removed="true"][data-front="true"][data-swipe-out="false"]){--y: translateY(calc(var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="false"]){--y: translateY(40%);opacity:0;transition:transform .5s,opacity .2s}:where([data-sonner-toast][data-removed="true"][data-front="false"]):before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y, 0px)) translate(var(--swipe-amount-x, 0px));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width: 600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-theme=light]{--normal-bg: #fff;--normal-border: var(--gray4);--normal-text: var(--gray12);--success-bg: hsl(143, 85%, 96%);--success-border: hsl(145, 92%, 91%);--success-text: hsl(140, 100%, 27%);--info-bg: hsl(208, 100%, 97%);--info-border: hsl(221, 91%, 91%);--info-text: hsl(210, 92%, 45%);--warning-bg: hsl(49, 100%, 97%);--warning-border: hsl(49, 91%, 91%);--warning-text: hsl(31, 92%, 45%);--error-bg: hsl(359, 100%, 97%);--error-border: hsl(359, 100%, 94%);--error-text: hsl(360, 100%, 45%)}[data-sonner-toaster][data-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg: #fff;--normal-border: var(--gray3);--normal-text: var(--gray12)}[data-sonner-toaster][data-theme=dark]{--normal-bg: #000;--normal-bg-hover: hsl(0, 0%, 12%);--normal-border: hsl(0, 0%, 20%);--normal-border-hover: hsl(0, 0%, 25%);--normal-text: var(--gray1);--success-bg: hsl(150, 100%, 6%);--success-border: hsl(147, 100%, 12%);--success-text: hsl(150, 86%, 65%);--info-bg: hsl(215, 100%, 6%);--info-border: hsl(223, 100%, 12%);--info-text: hsl(216, 87%, 65%);--warning-bg: hsl(64, 100%, 6%);--warning-border: hsl(60, 100%, 12%);--warning-text: hsl(46, 87%, 65%);--error-bg: hsl(358, 76%, 10%);--error-border: hsl(357, 89%, 16%);--error-text: hsl(358, 100%, 81%)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success],[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info],[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning],[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error],[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size: 16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:nth-child(1){animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}to{opacity:.15}}@media (prefers-reduced-motion){[data-sonner-toast],[data-sonner-toast]>*,.sonner-loading-bar{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}
`);
function Vr(e) {
  return e.label !== void 0;
}
var Kb = 3, Qb = "32px", em = "16px", Mc = 4e3, tm = 356, am = 14, om = 20, rm = 200;
function kt(...e) {
  return e.filter(Boolean).join(" ");
}
function lm(e) {
  let [t, a] = e.split("-"), o = [];
  return t && o.push(t), a && o.push(a), o;
}
var im = (e) => {
  var t, a, o, r, l, i, n, c, d, y, u;
  let { invert: h, toast: p, unstyled: g, interacting: m, setHeights: f, visibleToasts: v, heights: k, index: w, toasts: S, expanded: T, removeToast: C, defaultRichColors: A, closeButton: M, style: E, cancelButtonStyle: F, actionButtonStyle: I, className: P = "", descriptionClassName: O = "", duration: z, position: U, gap: Y, loadingIcon: _, expandByDefault: H, classNames: N, icons: D, closeButtonAriaLabel: $ = "Close toast", pauseWhenPageIsHidden: V } = e, [X, oe] = W.useState(null), [pe, Se] = W.useState(null), [ae, q] = W.useState(!1), [re, Z] = W.useState(!1), [ie, K] = W.useState(!1), [se, Pe] = W.useState(!1), [G, L] = W.useState(!1), [B, Q] = W.useState(0), [xe, ue] = W.useState(0), Re = W.useRef(p.duration || z || Mc), Je = W.useRef(null), Rt = W.useRef(null), Ir = w === 0, si = w + 1 <= v, ot = p.type, nt = p.dismissible !== !1, pa = p.className || "", Aa = p.descriptionClassName || "", La = W.useMemo(() => k.findIndex((ee) => ee.toastId === p.id) || 0, [k, p.id]), Bt = W.useMemo(() => {
    var ee;
    return (ee = p.closeButton) != null ? ee : M;
  }, [p.closeButton, M]), Yo = W.useMemo(() => p.duration || z || Mc, [p.duration, z]), Xo = W.useRef(0), ua = W.useRef(0), po = W.useRef(0), jt = W.useRef(null), [ci, Or] = U.split("-"), Rr = W.useMemo(() => k.reduce((ee, ce, he) => he >= La ? ee : ee + ce.height, 0), [k, La]), Br = Ub(), di = p.invert || h, $e = ot === "loading";
  ua.current = W.useMemo(() => La * Y + Rr, [La, Rr]), W.useEffect(() => {
    Re.current = Yo;
  }, [Yo]), W.useEffect(() => {
    q(!0);
  }, []), W.useEffect(() => {
    let ee = Rt.current;
    if (ee) {
      let ce = ee.getBoundingClientRect().height;
      return ue(ce), f((he) => [{ toastId: p.id, height: ce, position: p.position }, ...he]), () => f((he) => he.filter((ze) => ze.toastId !== p.id));
    }
  }, [f, p.id]), W.useLayoutEffect(() => {
    if (!ae) return;
    let ee = Rt.current, ce = ee.style.height;
    ee.style.height = "auto";
    let he = ee.getBoundingClientRect().height;
    ee.style.height = ce, ue(he), f((ze) => ze.find((Ge) => Ge.toastId === p.id) ? ze.map((Ge) => Ge.toastId === p.id ? { ...Ge, height: he } : Ge) : [{ toastId: p.id, height: he, position: p.position }, ...ze]);
  }, [ae, p.title, p.description, f, p.id]);
  let Be = W.useCallback(() => {
    Z(!0), Q(ua.current), f((ee) => ee.filter((ce) => ce.toastId !== p.id)), setTimeout(() => {
      C(p);
    }, rm);
  }, [p, C, f, ua]);
  W.useEffect(() => {
    if (p.promise && ot === "loading" || p.duration === 1 / 0 || p.type === "loading") return;
    let ee;
    return T || m || V && Br ? (() => {
      if (po.current < Xo.current) {
        let ce = (/* @__PURE__ */ new Date()).getTime() - Xo.current;
        Re.current = Re.current - ce;
      }
      po.current = (/* @__PURE__ */ new Date()).getTime();
    })() : Re.current !== 1 / 0 && (Xo.current = (/* @__PURE__ */ new Date()).getTime(), ee = setTimeout(() => {
      var ce;
      (ce = p.onAutoClose) == null || ce.call(p, p), Be();
    }, Re.current)), () => clearTimeout(ee);
  }, [T, m, p, ot, V, Br, Be]), W.useEffect(() => {
    p.delete && Be();
  }, [Be, p.delete]);
  function et() {
    var ee, ce, he;
    return D != null && D.loading ? W.createElement("div", { className: kt(N == null ? void 0 : N.loader, (ee = p == null ? void 0 : p.classNames) == null ? void 0 : ee.loader, "sonner-loader"), "data-visible": ot === "loading" }, D.loading) : _ ? W.createElement("div", { className: kt(N == null ? void 0 : N.loader, (ce = p == null ? void 0 : p.classNames) == null ? void 0 : ce.loader, "sonner-loader"), "data-visible": ot === "loading" }, _) : W.createElement(zb, { className: kt(N == null ? void 0 : N.loader, (he = p == null ? void 0 : p.classNames) == null ? void 0 : he.loader), visible: ot === "loading" });
  }
  return W.createElement("li", { tabIndex: 0, ref: Rt, className: kt(P, pa, N == null ? void 0 : N.toast, (t = p == null ? void 0 : p.classNames) == null ? void 0 : t.toast, N == null ? void 0 : N.default, N == null ? void 0 : N[ot], (a = p == null ? void 0 : p.classNames) == null ? void 0 : a[ot]), "data-sonner-toast": "", "data-rich-colors": (o = p.richColors) != null ? o : A, "data-styled": !(p.jsx || p.unstyled || g), "data-mounted": ae, "data-promise": !!p.promise, "data-swiped": G, "data-removed": re, "data-visible": si, "data-y-position": ci, "data-x-position": Or, "data-index": w, "data-front": Ir, "data-swiping": ie, "data-dismissible": nt, "data-type": ot, "data-invert": di, "data-swipe-out": se, "data-swipe-direction": pe, "data-expanded": !!(T || H && ae), style: { "--index": w, "--toasts-before": w, "--z-index": S.length - w, "--offset": `${re ? B : ua.current}px`, "--initial-height": H ? "auto" : `${xe}px`, ...E, ...p.style }, onDragEnd: () => {
    K(!1), oe(null), jt.current = null;
  }, onPointerDown: (ee) => {
    $e || !nt || (Je.current = /* @__PURE__ */ new Date(), Q(ua.current), ee.target.setPointerCapture(ee.pointerId), ee.target.tagName !== "BUTTON" && (K(!0), jt.current = { x: ee.clientX, y: ee.clientY }));
  }, onPointerUp: () => {
    var ee, ce, he, ze;
    if (se || !nt) return;
    jt.current = null;
    let Ge = Number(((ee = Rt.current) == null ? void 0 : ee.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), Ae = Number(((ce = Rt.current) == null ? void 0 : ce.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), Ke = (/* @__PURE__ */ new Date()).getTime() - ((he = Je.current) == null ? void 0 : he.getTime()), Ve = X === "x" ? Ge : Ae, Ye = Math.abs(Ve) / Ke;
    if (Math.abs(Ve) >= om || Ye > 0.11) {
      Q(ua.current), (ze = p.onDismiss) == null || ze.call(p, p), Se(X === "x" ? Ge > 0 ? "right" : "left" : Ae > 0 ? "down" : "up"), Be(), Pe(!0), L(!1);
      return;
    }
    K(!1), oe(null);
  }, onPointerMove: (ee) => {
    var ce, he, ze, Ge;
    if (!jt.current || !nt || ((ce = window.getSelection()) == null ? void 0 : ce.toString().length) > 0) return;
    let Ae = ee.clientY - jt.current.y, Ke = ee.clientX - jt.current.x, Ve = (he = e.swipeDirections) != null ? he : lm(U);
    !X && (Math.abs(Ke) > 1 || Math.abs(Ae) > 1) && oe(Math.abs(Ke) > Math.abs(Ae) ? "x" : "y");
    let Ye = { x: 0, y: 0 };
    X === "y" ? (Ve.includes("top") || Ve.includes("bottom")) && (Ve.includes("top") && Ae < 0 || Ve.includes("bottom") && Ae > 0) && (Ye.y = Ae) : X === "x" && (Ve.includes("left") || Ve.includes("right")) && (Ve.includes("left") && Ke < 0 || Ve.includes("right") && Ke > 0) && (Ye.x = Ke), (Math.abs(Ye.x) > 0 || Math.abs(Ye.y) > 0) && L(!0), (ze = Rt.current) == null || ze.style.setProperty("--swipe-amount-x", `${Ye.x}px`), (Ge = Rt.current) == null || Ge.style.setProperty("--swipe-amount-y", `${Ye.y}px`);
  } }, Bt && !p.jsx ? W.createElement("button", { "aria-label": $, "data-disabled": $e, "data-close-button": !0, onClick: $e || !nt ? () => {
  } : () => {
    var ee;
    Be(), (ee = p.onDismiss) == null || ee.call(p, p);
  }, className: kt(N == null ? void 0 : N.closeButton, (r = p == null ? void 0 : p.classNames) == null ? void 0 : r.closeButton) }, (l = D == null ? void 0 : D.close) != null ? l : Hb) : null, p.jsx || yi(p.title) ? p.jsx ? p.jsx : typeof p.title == "function" ? p.title() : p.title : W.createElement(W.Fragment, null, ot || p.icon || p.promise ? W.createElement("div", { "data-icon": "", className: kt(N == null ? void 0 : N.icon, (i = p == null ? void 0 : p.classNames) == null ? void 0 : i.icon) }, p.promise || p.type === "loading" && !p.icon ? p.icon || et() : null, p.type !== "loading" ? p.icon || (D == null ? void 0 : D[ot]) || Rb(ot) : null) : null, W.createElement("div", { "data-content": "", className: kt(N == null ? void 0 : N.content, (n = p == null ? void 0 : p.classNames) == null ? void 0 : n.content) }, W.createElement("div", { "data-title": "", className: kt(N == null ? void 0 : N.title, (c = p == null ? void 0 : p.classNames) == null ? void 0 : c.title) }, typeof p.title == "function" ? p.title() : p.title), p.description ? W.createElement("div", { "data-description": "", className: kt(O, Aa, N == null ? void 0 : N.description, (d = p == null ? void 0 : p.classNames) == null ? void 0 : d.description) }, typeof p.description == "function" ? p.description() : p.description) : null), yi(p.cancel) ? p.cancel : p.cancel && Vr(p.cancel) ? W.createElement("button", { "data-button": !0, "data-cancel": !0, style: p.cancelButtonStyle || F, onClick: (ee) => {
    var ce, he;
    Vr(p.cancel) && nt && ((he = (ce = p.cancel).onClick) == null || he.call(ce, ee), Be());
  }, className: kt(N == null ? void 0 : N.cancelButton, (y = p == null ? void 0 : p.classNames) == null ? void 0 : y.cancelButton) }, p.cancel.label) : null, yi(p.action) ? p.action : p.action && Vr(p.action) ? W.createElement("button", { "data-button": !0, "data-action": !0, style: p.actionButtonStyle || I, onClick: (ee) => {
    var ce, he;
    Vr(p.action) && ((he = (ce = p.action).onClick) == null || he.call(ce, ee), !ee.defaultPrevented && Be());
  }, className: kt(N == null ? void 0 : N.actionButton, (u = p == null ? void 0 : p.classNames) == null ? void 0 : u.actionButton) }, p.action.label) : null));
};
function Nc() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  let e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function nm(e, t) {
  let a = {};
  return [e, t].forEach((o, r) => {
    let l = r === 1, i = l ? "--mobile-offset" : "--offset", n = l ? em : Qb;
    function c(d) {
      ["top", "right", "bottom", "left"].forEach((y) => {
        a[`${i}-${y}`] = typeof d == "number" ? `${d}px` : d;
      });
    }
    typeof o == "number" || typeof o == "string" ? c(o) : typeof o == "object" ? ["top", "right", "bottom", "left"].forEach((d) => {
      o[d] === void 0 ? a[`${i}-${d}`] = n : a[`${i}-${d}`] = typeof o[d] == "number" ? `${o[d]}px` : o[d];
    }) : c(n);
  }), a;
}
us(function(e, t) {
  let { invert: a, position: o = "bottom-right", hotkey: r = ["altKey", "KeyT"], expand: l, closeButton: i, className: n, offset: c, mobileOffset: d, theme: y = "light", richColors: u, duration: h, style: p, visibleToasts: g = Kb, toastOptions: m, dir: f = Nc(), gap: v = am, loadingIcon: k, icons: w, containerAriaLabel: S = "Notifications", pauseWhenPageIsHidden: T } = e, [C, A] = W.useState([]), M = W.useMemo(() => Array.from(new Set([o].concat(C.filter((V) => V.position).map((V) => V.position)))), [C, o]), [E, F] = W.useState([]), [I, P] = W.useState(!1), [O, z] = W.useState(!1), [U, Y] = W.useState(y !== "system" ? y : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), _ = W.useRef(null), H = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), N = W.useRef(null), D = W.useRef(!1), $ = W.useCallback((V) => {
    A((X) => {
      var oe;
      return (oe = X.find((pe) => pe.id === V.id)) != null && oe.delete || rt.dismiss(V.id), X.filter(({ id: pe }) => pe !== V.id);
    });
  }, []);
  return W.useEffect(() => rt.subscribe((V) => {
    if (V.dismiss) {
      A((X) => X.map((oe) => oe.id === V.id ? { ...oe, delete: !0 } : oe));
      return;
    }
    setTimeout(() => {
      Fb.flushSync(() => {
        A((X) => {
          let oe = X.findIndex((pe) => pe.id === V.id);
          return oe !== -1 ? [...X.slice(0, oe), { ...X[oe], ...V }, ...X.slice(oe + 1)] : [V, ...X];
        });
      });
    });
  }), []), W.useEffect(() => {
    if (y !== "system") {
      Y(y);
      return;
    }
    if (y === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? Y("dark") : Y("light")), typeof window > "u") return;
    let V = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      V.addEventListener("change", ({ matches: X }) => {
        Y(X ? "dark" : "light");
      });
    } catch {
      V.addListener(({ matches: oe }) => {
        try {
          Y(oe ? "dark" : "light");
        } catch (pe) {
          console.error(pe);
        }
      });
    }
  }, [y]), W.useEffect(() => {
    C.length <= 1 && P(!1);
  }, [C]), W.useEffect(() => {
    let V = (X) => {
      var oe, pe;
      r.every((Se) => X[Se] || X.code === Se) && (P(!0), (oe = _.current) == null || oe.focus()), X.code === "Escape" && (document.activeElement === _.current || (pe = _.current) != null && pe.contains(document.activeElement)) && P(!1);
    };
    return document.addEventListener("keydown", V), () => document.removeEventListener("keydown", V);
  }, [r]), W.useEffect(() => {
    if (_.current) return () => {
      N.current && (N.current.focus({ preventScroll: !0 }), N.current = null, D.current = !1);
    };
  }, [_.current]), W.createElement("section", { ref: t, "aria-label": `${S} ${H}`, tabIndex: -1, "aria-live": "polite", "aria-relevant": "additions text", "aria-atomic": "false", suppressHydrationWarning: !0 }, M.map((V, X) => {
    var oe;
    let [pe, Se] = V.split("-");
    return C.length ? W.createElement("ol", { key: V, dir: f === "auto" ? Nc() : f, tabIndex: -1, ref: _, className: n, "data-sonner-toaster": !0, "data-theme": U, "data-y-position": pe, "data-lifted": I && C.length > 1 && !l, "data-x-position": Se, style: { "--front-toast-height": `${((oe = E[0]) == null ? void 0 : oe.height) || 0}px`, "--width": `${tm}px`, "--gap": `${v}px`, ...p, ...nm(c, d) }, onBlur: (ae) => {
      D.current && !ae.currentTarget.contains(ae.relatedTarget) && (D.current = !1, N.current && (N.current.focus({ preventScroll: !0 }), N.current = null));
    }, onFocus: (ae) => {
      ae.target instanceof HTMLElement && ae.target.dataset.dismissible === "false" || D.current || (D.current = !0, N.current = ae.relatedTarget);
    }, onMouseEnter: () => P(!0), onMouseMove: () => P(!0), onMouseLeave: () => {
      O || P(!1);
    }, onDragEnd: () => P(!1), onPointerDown: (ae) => {
      ae.target instanceof HTMLElement && ae.target.dataset.dismissible === "false" || z(!0);
    }, onPointerUp: () => z(!1) }, C.filter((ae) => !ae.position && X === 0 || ae.position === V).map((ae, q) => {
      var re, Z;
      return W.createElement(im, { key: ae.id, icons: w, index: q, toast: ae, defaultRichColors: u, duration: (re = m == null ? void 0 : m.duration) != null ? re : h, className: m == null ? void 0 : m.className, descriptionClassName: m == null ? void 0 : m.descriptionClassName, invert: a, visibleToasts: g, closeButton: (Z = m == null ? void 0 : m.closeButton) != null ? Z : i, interacting: O, position: V, style: m == null ? void 0 : m.style, unstyled: m == null ? void 0 : m.unstyled, classNames: m == null ? void 0 : m.classNames, cancelButtonStyle: m == null ? void 0 : m.cancelButtonStyle, actionButtonStyle: m == null ? void 0 : m.actionButtonStyle, removeToast: $, toasts: C.filter((ie) => ie.position == ae.position), heights: E.filter((ie) => ie.position == ae.position), setHeights: F, expandByDefault: l, gap: v, loadingIcon: k, expanded: I, pauseWhenPageIsHidden: T, swipeDirections: e.swipeDirections });
    })) : null;
  }));
});
const sm = (e, t) => t.some((a) => e === a || e.startsWith(`${a}.`)), Ec = (e, t) => {
  if (!e) return e;
  const a = (t.hide ?? []).filter((n) => !n.includes("[].")), o = (t.hide ?? []).filter((n) => n.includes("[].")).map((n) => n.split("[].")), r = (n) => {
    const c = o.filter(([d]) => d === n.key).map(([, d]) => d);
    return c.length ? {
      ...n,
      ...n.itemSchema ? { itemSchema: n.itemSchema.filter((d) => !c.includes(d.key)) } : {},
      ...n.fields ? { fields: n.fields.filter((d) => !c.includes(d.key)) } : {}
    } : n;
  }, l = e.filter((n) => !sm(n.key, a)).map(r), i = new Set(l.map((n) => n.key));
  return l.map((n) => {
    var y;
    const c = (y = t.labels) == null ? void 0 : y[n.key], d = n.dependency && !i.has(n.dependency.field) ? void 0 : n.dependency;
    return { ...n, ...c ?? {}, dependency: d };
  });
}, uo = (e, t) => {
  if (!t) return e;
  const a = e.variants.filter((r) => !t.keep || t.keep.includes(r.id)), o = [...a, ...(t.add ?? []).filter((r) => !a.some((l) => l.id === r.id))].map((r) => {
    var l;
    return { ...r, label: ((l = t.variantLabels) == null ? void 0 : l[r.id]) ?? r.label, fields: Ec(r.fields, t) };
  });
  return { ...e, variants: o, commonFields: Ec(e.commonFields, t) ?? [] };
}, ht = (e, t) => {
  var a, o;
  return {
    ...e,
    componentSchemas: Object.fromEntries(Object.entries(e.componentSchemas).map(([r, l]) => [r, uo(l, t[r])])),
    ...e.headerSchema ? { headerSchema: uo(e.headerSchema, t.header) } : {},
    ...e.footerSchema ? { footerSchema: uo(e.footerSchema, t.footer) } : {},
    ...e.floatingButtonsSchema ? { floatingButtonsSchema: uo(e.floatingButtonsSchema, t["floating-buttons"]) } : {},
    ...e.mobileNavSchema ? { mobileNavSchema: uo(e.mobileNavSchema, t["mobile-bottom-nav"]) } : {},
    ...e.buttonsSchema ? { buttonsSchema: uo(e.buttonsSchema, t.buttons) } : {},
    hiddenSettings: { design: ((a = t.design) == null ? void 0 : a.hide) ?? [], storeInfo: ((o = t["store-info"]) == null ? void 0 : o.hide) ?? [] }
  };
}, cm = {
  account: { hide: ["signinRedirectPath"] },
  "announcement-bar": { hide: ["bgColor", "textColor"] },
  cart: { hide: ["loadingText", "taxLabel", "secureCheckoutText"] },
  category: { hide: ["productCardVariant", "initialPriceRange", "showBreadcrumb"] },
  checkout: { hide: ["loadingText", "shippingCalculatingText", "securePaymentText"] },
  cta: { hide: ["bgColor"] },
  "featured-category": { hide: ["productCardVariant", "noSelectionText", "noProductsText"] },
  features: { hide: ["bgStyle"] },
  "flash-sale": { hide: ["bgColor", "products"] },
  "new-arrivals": { hide: ["products"] },
  "order-success": { hide: ["loadingText"] },
  "product-detail": { hide: ["loadingText", "notFoundCode", "notFoundText"], keep: ["v1", "v2", "v3", "v6"], variantLabels: { v1: "Standard", v2: "Sale countdown band", v3: "Large photo swatches", v6: "Video under the photo" } },
  "shop-grid": { hide: ["productCardVariant", "initialPriceRange", "sortOldestLabel", "sortNameDescLabel"] },
  "similar-products": { hide: ["productCardVariant"] },
  blog: { keep: ["v1", "v2"] },
  coupon: { hide: ["coupons[].bgColor"] },
  header: { hide: ["topbar[].phone", "topbar[].email", "topbar[].showSocials", "topbar[].socialLinks"] },
  footer: { hide: ["paymentMethods[].icon"] },
  // Theme tab: button settings no part of this theme reads (colours drive every primary button via the CTA).
  buttons: { hide: ["appearance.buttons.primary[].radius", "appearance.buttons.primary[].height", "appearance.buttons.primary[].paddingX", "appearance.buttons.primary[].label", "appearance.buttons.outline[].radius", "appearance.buttons.outline[].height", "appearance.buttons.outline[].paddingX", "appearance.buttons.outline[].label", "appearance.buttons.outline[].hoverBg"] },
  // Corner roundness: this theme's corners are fixed by its design (no --radius-base / --radius-card).
  design: { hide: ["radius"] },
  // Delivery time is shown on product cards only by Prottoho.
  "store-info": { hide: ["deliveryEta"] }
}, dm = {
  type: "account",
  label: "Account Section",
  description: "User dashboard with orders, addresses, and profile settings.",
  supportedPages: ["account"],
  variants: [
    { id: "v1", label: "V1 (Sidebar + Content)" },
    { id: "v2", label: "Order History" },
    { id: "v3", label: "Address Book" }
  ],
  commonFields: [
    { key: "tabOverviewLabel", label: "Overview Tab Label", type: "string", default: "Overview" },
    { key: "tabOrdersLabel", label: "Orders Tab Label", type: "string", default: "Orders" },
    { key: "tabAddressesLabel", label: "Addresses Tab Label", type: "string", default: "Addresses" },
    { key: "tabDetailsLabel", label: "Profile Tab Label", type: "string", default: "Profile" },
    { key: "signOutLabel", label: "Sign Out Label", type: "string", default: "Sign Out" },
    { key: "signinRedirectPath", label: "Sign In Redirect Path", type: "string", default: "/signin" }
  ]
}, Hi = {
  type: "signin",
  label: "Signin Section",
  description: "Login form with phone/OTP flow and two-column layout.",
  supportedPages: ["signin"],
  variants: [{ id: "v1", label: "V1 (Two Column)" }],
  commonFields: [
    { key: "redirectUrl", label: "Redirect After Login", type: "string", default: "/account" }
  ]
}, Ui = {
  type: "signup",
  label: "Signup Section",
  description: "Registration form with phone/OTP flow and two-column layout.",
  supportedPages: ["signup"],
  variants: [{ id: "v2", label: "V2 (Two Column)" }],
  commonFields: [
    { key: "redirectUrl", label: "Redirect After Signup", type: "string", default: "/account" }
  ]
}, Eo = [
  "home",
  "shop",
  "product",
  "category",
  "categories",
  "cart",
  "checkout",
  "contact",
  "signin",
  "signup",
  "account",
  "wishlist",
  "track-order",
  "order-success",
  "privacy-policy",
  "terms-of-service",
  "shipping-policy",
  "return-policy",
  "order-detail"
], bl = [
  { key: "id", label: "ID", type: "string" },
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link", type: "string" }
], pm = [
  { key: "id", label: "ID", type: "string" },
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link URL", type: "string" },
  {
    key: "type",
    label: "Type",
    type: "select",
    options: [
      { label: "Standard Link", value: "link" },
      { label: "Dropdown", value: "dropdown" },
      { label: "Mega Menu", value: "mega-menu" }
    ]
  },
  {
    key: "children",
    label: "Dropdown Items",
    type: "array",
    itemSchema: bl,
    dependency: { field: "type", value: "dropdown" }
  },
  {
    key: "columns",
    label: "Mega Menu Columns",
    type: "array",
    itemSchema: [
      { key: "title", label: "Column Title", type: "string" },
      { key: "items", label: "Links", type: "array", itemSchema: bl }
    ],
    dependency: { field: "type", value: "mega-menu" }
  },
  {
    key: "featuredImage",
    label: "Featured Image",
    type: "object",
    fields: [
      { key: "src", label: "Image", type: "image" },
      { key: "title", label: "Title", type: "string" },
      { key: "href", label: "Link", type: "string" }
    ],
    dependency: { field: "type", value: "mega-menu" }
  }
], Wr = [
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "text" },
  { key: "image", label: "Background Image", type: "image" },
  { key: "ctaText", label: "Button Text", type: "string" },
  { key: "ctaLink", label: "Button Link", type: "string" },
  { key: "badge", label: "Badge Text", type: "string" }
], Ne = [
  {
    key: "styles.paddingTop",
    label: "Padding Top",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.paddingBottom",
    label: "Padding Bottom",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.background",
    label: "Background",
    type: "select",
    options: [
      { label: "None (theme default)", value: "default" },
      { label: "Light grey", value: "muted" },
      { label: "Brand tint", value: "primary" }
    ],
    default: "default"
  }
], um = [
  {
    key: "icon",
    label: "Icon (truck | shield | lock)",
    type: "string"
  },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" }
], ym = [
  { key: "image", label: "Background Image", type: "image" },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" },
  { key: "ctaText", label: "Button Text", type: "string" },
  { key: "ctaLink", label: "Button Link", type: "string" }
], Oa = {
  type: "banner",
  label: "Banner Section",
  description: "Promo feature strip or side-by-side image banners.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Feature Strip (Free Shipping, etc.)",
      fields: [
        { key: "columns", label: "Feature Columns", type: "array", itemSchema: um }
      ]
    },
    {
      id: "v2",
      label: "V2 — Two Promo Image Banners",
      fields: [
        { key: "banners", label: "Promo Banners (max 2)", type: "array", itemSchema: ym }
      ]
    }
  ],
  commonFields: [...Ne]
}, hm = {
  type: "cart",
  label: "Cart Section",
  description: "The shopping cart page section.",
  supportedPages: ["cart"],
  variants: [{ id: "v1", label: "V1 (Apparels)" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Shopping Cart" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading cart items..." },
    { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty State Message", type: "string", default: "Browse our products and add items to your cart." },
    { key: "continueShoppingText", label: "Continue Shopping Button Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingLabel", label: "Shipping Label", type: "string", default: "Shipping" },
    { key: "shippingCalculatedText", label: "Shipping Calculated Text", type: "string", default: "Calculated at checkout" },
    { key: "taxLabel", label: "Tax Label", type: "string", default: "Tax" },
    { key: "totalLabel", label: "Total Label", type: "string", default: "Total" },
    { key: "checkoutButtonText", label: "Checkout Button Text", type: "string", default: "Proceed to Checkout" },
    { key: "checkoutLink", label: "Checkout Link", type: "string", default: "/checkout" },
    { key: "secureCheckoutText", label: "Secure Checkout Label", type: "string", default: "SSL Secure Checkout" }
  ]
}, bm = {
  type: "categories",
  label: "Categories Grid",
  description: "A grid of all category cards with image and product count.",
  supportedPages: ["home", "categories", "shop"],
  variants: [{ id: "v1", label: "V1 (Image Grid)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    {
      key: "columns",
      label: "Columns",
      type: "select",
      options: [
        { label: "2 Columns", value: 2 },
        { label: "3 Columns", value: 3 },
        { label: "4 Columns", value: 4 }
      ],
      default: 4
    },
    { key: "emptyText", label: "Empty Text", type: "string", default: "No categories found." },
    ...Ne
  ]
}, mm = {
  type: "category",
  label: "Category Listing",
  description: "Single category page: breadcrumb, header, product grid with filters.",
  supportedPages: ["category", "shop"],
  variants: [{ id: "v1", label: "V1 (Sidebar + Grid)" }],
  commonFields: [
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "initialPriceRange.min", label: "Price Range Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Price Range Max", type: "number", default: 5e4 },
    { key: "showBreadcrumb", label: "Show Breadcrumb", type: "boolean", default: !0 },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...Ne
  ]
}, gm = {
  type: "checkout",
  label: "Checkout Section",
  description: "The order checkout page section.",
  supportedPages: ["checkout"],
  variants: [{ id: "v1", label: "V1 (Apparels)" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Checkout" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Preparing checkout..." },
    { key: "emptyTitle", label: "Empty Cart Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty Cart Message", type: "string", default: "Checkout is only available for shopping carts with items." },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingChargeLabel", label: "Shipping Charge Label", type: "string", default: "Shipping Charge" },
    { key: "shippingCalculatingText", label: "Shipping Calculating Text", type: "string", default: "Calculating..." },
    { key: "totalLabel", label: "Total Amount Label", type: "string", default: "Total Amount" },
    { key: "placeOrderText", label: "Place Order Button Text", type: "string", default: "Place Order" },
    { key: "placingOrderText", label: "Placing Order Loading Text", type: "string", default: "Placing Order..." },
    { key: "securePaymentText", label: "Secure Payment Label", type: "string", default: "SSL Secure Payment" }
  ]
}, fm = {
  type: "contact",
  label: "Contact Section",
  description: "Two-column contact page with form and info panel.",
  supportedPages: ["contact"],
  variants: [{ id: "v1", label: "V1 (Split Layout)" }],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    { key: "email", label: "Email Address", type: "string" },
    { key: "phone", label: "Phone Number", type: "string" },
    { key: "address", label: "Physical Address", type: "text" }
  ]
}, vm = {
  type: "content",
  label: "Content / Policy Section",
  description: "Generic rich-text section for policies and descriptions.",
  supportedPages: ["privacy-policy", "terms-of-service", "shipping-policy", "return-policy"],
  variants: [
    { id: "v1", label: "V1 (Clean Layout)" },
    { id: "v2", label: "V2 (With Table of Contents)" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "content", label: "HTML Content", type: "rich-text" }
  ]
}, km = {
  type: "featured-category",
  label: "Featured Category",
  description: "Display products from a specific category on the home page.",
  supportedPages: ["home", "product", "cart"],
  variants: [{ id: "v1", label: "V1 (Product Grid)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    { key: "categoryId", label: "Select Category", type: "category-select" },
    { key: "rows", label: "Number of Rows", type: "number", default: 1 },
    { key: "viewAllText", label: "View All Button Text", type: "string", default: "View All" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "noSelectionText", label: "No Category Selected Text", type: "string", default: "Please select a category in the editor settings." },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    ...Ne
  ]
}, wm = {
  type: "floating-buttons",
  label: "Floating Buttons",
  description: "Global floating buttons for quick actions (Call, WhatsApp, Messenger).",
  supportedPages: [...Eo],
  variants: [{ id: "v1", label: "Default" }],
  commonFields: [
    { key: "active", label: "Enable Floating Buttons", type: "boolean", default: !0 },
    { key: "phone", label: "Phone Number", type: "string", placeholder: "+8801..." },
    { key: "whatsapp", label: "WhatsApp Number", type: "string", placeholder: "+8801..." },
    { key: "messenger", label: "Messenger ID/Link", type: "string", placeholder: "m.me/..." },
    { key: "callUsTitle", label: "Call Button Tooltip", type: "string", default: "Call Us" },
    { key: "whatsappTitle", label: "WhatsApp Button Tooltip", type: "string", default: "WhatsApp" },
    { key: "messengerTitle", label: "Messenger Button Tooltip", type: "string", default: "Messenger" }
  ]
}, Sm = {
  type: "footer",
  label: "Footer",
  description: "Site-wide footer with links, newsletter, and contact info.",
  supportedPages: [...Eo],
  variants: [
    { id: "v1", label: "Dark (Default)" },
    { id: "v2", label: "Light" }
  ],
  commonFields: [
    { key: "logo", label: "Footer Logo", type: "image" },
    { key: "title", label: "Brand Name", type: "string", default: "Urban Drip" },
    {
      key: "description",
      label: "Brand Description",
      type: "text",
      default: "Your destination for premium fashion and lifestyle products. Curated styles for the modern wardrobe."
    },
    {
      key: "columns",
      label: "Link Columns",
      type: "array",
      itemSchema: [
        { key: "title", label: "Column Title", type: "string" },
        { key: "links", label: "Links", type: "array", itemSchema: bl }
      ]
    },
    {
      key: "socialLinks",
      label: "Social Links",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Facebook", value: "facebook" },
            { label: "Instagram", value: "instagram" },
            { label: "Twitter", value: "twitter" },
            { label: "YouTube", value: "youtube" },
            { label: "LinkedIn", value: "linkedin" }
          ]
        },
        { key: "href", label: "Link", type: "string" }
      ]
    },
    { key: "contactAddress", label: "Address", type: "string" },
    { key: "contactPhone", label: "Phone", type: "string" },
    { key: "contactEmail", label: "Email", type: "string" },
    { key: "copyright", label: "Copyright Text", type: "string", default: "© 2025 Urban Drip. All rights reserved." },
    {
      key: "paymentMethods",
      label: "Payment Methods",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Visa", value: "visa" },
            { label: "Mastercard", value: "mastercard" },
            { label: "Amex", value: "amex" },
            { label: "Stripe", value: "stripe" },
            { label: "PayPal", value: "paypal" },
            { label: "bKash", value: "bkash" },
            { label: "Nagad", value: "nagad" },
            { label: "Rocket", value: "rocket" }
          ]
        },
        { key: "icon", label: "Icon URL (optional)", type: "string" }
      ]
    }
  ]
}, Gi = {
  type: "header",
  label: "Header",
  description: "Site-wide header with navigation, search, and cart.",
  supportedPages: [...Eo],
  variants: [
    { id: "v1", label: "Fashion (Default)" },
    { id: "v2", label: "Electronics" },
    { id: "v3", label: "Beauty / Minimal" },
    { id: "v4", label: "Jewelry / Elegant" }
  ],
  commonFields: [
    { key: "logo.alt", label: "Logo Alt Text", type: "string" },
    { key: "logo.src", label: "Logo Image", type: "image" },
    { key: "sticky", label: "Sticky Header", type: "boolean", default: !0 },
    {
      key: "topbar",
      label: "Top Bar",
      type: "object",
      fields: [
        { key: "active", label: "Enable Top Bar", type: "boolean", default: !0 },
        {
          key: "variant",
          label: "Variant",
          type: "select",
          options: [
            { label: "V1 (Centered Promo)", value: "v1" },
            { label: "V2 (Contact & Socials)", value: "v2" }
          ],
          default: "v1"
        },
        { key: "text", label: "Announcement Text", type: "string" },
        { key: "phone", label: "Phone Number", type: "string" },
        { key: "email", label: "Email Address", type: "string" },
        { key: "showSocials", label: "Show Social Icons", type: "boolean", default: !0 },
        {
          key: "socialLinks",
          label: "Social Links",
          type: "array",
          itemSchema: [
            { key: "platform", label: "Platform", type: "string" },
            { key: "href", label: "Link", type: "string" },
            { key: "icon", label: "Icon Name", type: "string" }
          ]
        },
        { key: "links", label: "Top Bar Links", type: "array", itemSchema: bl }
      ]
    },
    {
      key: "actions",
      label: "Actions",
      type: "object",
      fields: [
        { key: "showSearch", label: "Show Search", type: "boolean", default: !0 },
        { key: "showCart", label: "Show Cart", type: "boolean", default: !0 },
        { key: "showAccount", label: "Show Account", type: "boolean", default: !0 },
        { key: "showWishlist", label: "Show Wishlist", type: "boolean", default: !0 },
        {
          key: "cartAction",
          label: "Cart Action",
          type: "select",
          options: [
            { label: "Slide-out Sidebar", value: "sidebar" },
            { label: "Go to Page", value: "page" }
          ],
          default: "sidebar"
        }
      ]
    },
    {
      key: "searchConfig",
      label: "Search Settings",
      type: "object",
      fields: [
        { key: "showPrice", label: "Show Price in Suggestions", type: "boolean", default: !0 },
        { key: "showCategory", label: "Show Category in Suggestions", type: "boolean", default: !0 },
        { key: "showImage", label: "Show Image in Suggestions", type: "boolean", default: !0 },
        { key: "maxResults", label: "Max Suggestions", type: "number", default: 6 }
      ]
    },
    { key: "menu", label: "Main Menu", type: "array", itemSchema: pm }
  ]
}, xm = {
  type: "hero",
  label: "Hero Section",
  description: "The main attention-grabbing section at the top of the page.",
  supportedPages: ["home", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Fashion Full-Height Slider",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: Wr },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    },
    {
      id: "v2",
      label: "V2 — Electronics Two-Column Slider",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: Wr },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    },
    {
      id: "v3",
      label: "V3 — Beauty Gradient Hero",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: Wr }
      ]
    },
    {
      id: "v4",
      label: "V4 — Jewelry Dark Elegant Hero",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: Wr }
      ]
    }
  ],
  commonFields: [...Ne]
}, Tm = {
  type: "order-success",
  label: "Order Success Section",
  description: "The order confirmation page section.",
  supportedPages: ["order-success"],
  variants: [{ id: "v1", label: "V1 (Apparels)" }],
  commonFields: [
    { key: "title", label: "Success Title", type: "string", default: "Order Confirmed" },
    { key: "message", label: "Success Message", type: "text", default: "Your order has been placed successfully. We have sent a confirmation email with your order details." },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading order details..." },
    { key: "errorTitle", label: "Error Title", type: "string", default: "Order Not Found" },
    { key: "errorMessage", label: "Error Message", type: "string", default: "We could not find the order you are looking for." },
    { key: "viewOrderText", label: "View Order Button Text", type: "string", default: "View Order Status" },
    { key: "viewOrderLink", label: "View Order Link", type: "string", default: "/account/orders" },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" }
  ]
}, Yi = {
  type: "product-detail",
  label: "Product Detail",
  description: "The main product information page section.",
  supportedPages: ["product"],
  variants: [
    { id: "v1", label: "V1 (Standard)" },
    { id: "v2", label: "V2 (With Countdown Timer)" },
    { id: "v3", label: "V3 (With Color/Size Swatches)" },
    { id: "v4", label: "Countdown Sale" },
    { id: "v5", label: "Swatches" },
    { id: "v6", label: "Video Gallery" }
  ],
  commonFields: [
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading..." },
    { key: "notFoundCode", label: "Not Found Code", type: "string", default: "404" },
    { key: "notFoundText", label: "Not Found Text", type: "string", default: "Product Not Found" },
    { key: "quantityLabel", label: "Quantity Label", type: "string", default: "Quantity" },
    { key: "addToCartText", label: "Add to Cart Button Text", type: "string", default: "Add to Cart" },
    { key: "orderNowText", label: "Order Now Button Text", type: "string", default: "Buy Now" },
    { key: "productDescTitle", label: "Product Description Accordion Title", type: "string", default: "Product Description" },
    { key: "returnPolicyTitle", label: "Return Policy Accordion Title", type: "string", default: "Return Policy" },
    { key: "countdownLabel", label: "Countdown Label (V2 only)", type: "string", default: "Offer ends in:" },
    { key: "saleEndDate", label: "Sale End Date", type: "string", placeholder: "2025-12-31T23:59:59" },
    { key: "videoUrl", label: "Product Video URL", type: "string", placeholder: "https://..." },
    ...Ne
  ]
}, Cm = {
  type: "mobileBottomNav",
  label: "Mobile Navigation",
  description: "Bottom navigation bar for mobile devices.",
  supportedPages: [...Eo],
  variants: [{ id: "v1", label: "V1 (Default)" }],
  commonFields: [
    { key: "active", label: "Show Bottom Nav", type: "boolean" },
    {
      key: "items",
      label: "Nav Items",
      type: "array",
      itemSchema: [
        { key: "label", label: "Label", type: "string" },
        {
          key: "icon",
          label: "Icon Type",
          type: "select",
          options: [
            { label: "Home", value: "home" },
            { label: "Shop (Bag)", value: "shop" },
            { label: "Search", value: "search" },
            { label: "Cart", value: "cart" },
            { label: "User / Account", value: "account" },
            { label: "Heart / Wishlist", value: "heart" },
            { label: "Menu / Hamburger", value: "menu" },
            { label: "Plus / Create", value: "plus" }
          ]
        },
        {
          key: "actionType",
          label: "Action Type",
          type: "select",
          options: [
            { label: "Link (Direct URL)", value: "link" },
            { label: "Open Search Drawer", value: "search" },
            { label: "Open Categories Sidebar", value: "categories" }
          ]
        },
        { key: "href", label: "Target URL", type: "string" },
        { key: "isPrimary", label: "Highlight as Primary (Middle)", type: "boolean" }
      ]
    }
  ]
}, Pm = {
  type: "similar-products",
  label: "Similar Products",
  description: "A row of related products shown on the product page.",
  supportedPages: ["product"],
  variants: [{ id: "v1", label: "V1 (Grid Row)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Similar Products" },
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    ...Ne
  ]
}, Am = {
  type: "shop-grid",
  label: "Shop Grid",
  description: "The main product list with sidebar filters.",
  supportedPages: ["shop", "category", "cart", "checkout", "categories"],
  variants: [
    { id: "v1", label: "V1 (Left Sidebar + Grid)" },
    { id: "v2", label: "V2 (Full-width Grid, Slide-in Filters)" }
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "initialPriceRange.min", label: "Initial Price Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Initial Price Max", type: "number", default: 5e4 },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "allCategoriesLabel", label: "All Categories Label", type: "string", default: "All" },
    { key: "filtersButtonLabel", label: "Filters Button Label", type: "string", default: "Filters" },
    { key: "showingLabel", label: "Showing Label (prefix)", type: "string", default: "Showing" },
    { key: "productsSuffix", label: "Products Count Suffix", type: "string", default: "Products" },
    { key: "sortNewestLabel", label: "Sort: Newest Label", type: "string", default: "Sort: Newest" },
    { key: "sortOldestLabel", label: "Sort: Oldest Label", type: "string", default: "Sort: Oldest" },
    { key: "sortPriceAscLabel", label: "Sort: Price Low-High Label", type: "string", default: "Price: Low to High" },
    { key: "sortPriceDescLabel", label: "Sort: Price High-Low Label", type: "string", default: "Price: High to Low" },
    { key: "sortNameAscLabel", label: "Sort: Name A-Z Label", type: "string", default: "Name: A-Z" },
    { key: "sortNameDescLabel", label: "Sort: Name Z-A Label", type: "string", default: "Name: Z-A" },
    { key: "activeFiltersLabel", label: "Active Filters Label", type: "string", default: "Active Filters:" },
    { key: "clearAllLabel", label: "Clear All Label", type: "string", default: "Clear All" },
    { key: "noProductsTitle", label: "No Products Title", type: "string", default: "No Products Found" },
    { key: "noProductsMessage", label: "No Products Message", type: "string", default: "We couldn't find any products matching your current filters." },
    { key: "backToAllText", label: "Back to All Products Text", type: "string", default: "Back to All Products" },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "currentSearchLabel", label: "Current Search Label", type: "string", default: "Current Search" },
    { key: "clearSearchLabel", label: "Clear Search Label", type: "string", default: "Clear" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...Ne
  ]
}, Lm = {
  type: "wishlist",
  label: "Wishlist Section",
  description: "Displays saved/wishlisted products in a grid layout.",
  supportedPages: ["wishlist"],
  variants: [
    {
      id: "v1",
      label: "V1 (Grid)",
      fields: [
        { key: "title", label: "Page Title", type: "string", default: "My Wishlist" },
        { key: "subtitle", label: "Eyebrow Text", type: "string", default: "Saved items" },
        { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Nothing saved yet" },
        { key: "emptyText", label: "Empty State Description", type: "string", default: "Start exploring and save the items you love." },
        { key: "continueShoppingText", label: "CTA Text", type: "string", default: "Start Shopping" },
        { key: "continueShoppingLink", label: "CTA Link", type: "string", default: "/shop" }
      ]
    }
  ],
  commonFields: []
}, Mm = [
  { key: "text", label: "Message Text", type: "string" },
  { key: "code", label: "Coupon Code (optional)", type: "string" }
], Nm = {
  type: "announcement-bar",
  label: "Announcement Bar",
  description: "Full-width scrolling ticker bar for promotions and announcements.",
  supportedPages: [
    "home",
    "shop",
    "product",
    "category",
    "categories",
    "cart",
    "checkout",
    "contact",
    "wishlist"
  ],
  variants: [
    {
      id: "v1",
      label: "V1 — Scrolling Marquee",
      fields: [
        { key: "items", label: "Announcement Items", type: "array", itemSchema: Mm },
        { key: "bgColor", label: "Background Color", type: "string", default: "#0989FF" },
        { key: "textColor", label: "Text Color", type: "string", default: "#ffffff" }
      ]
    }
  ],
  commonFields: [...Ne]
}, Em = [
  { key: "id", label: "Product ID", type: "string" },
  { key: "name", label: "Product Name", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "originalPrice", label: "Original Price", type: "number" },
  { key: "salePrice", label: "Sale Price", type: "number" },
  { key: "discount", label: "Discount %", type: "number" }
], Dm = {
  type: "flash-sale",
  label: "Flash Sale",
  description: "Countdown timer with a horizontal product row for time-limited offers.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "V1 — Countdown + Product Row",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Flash Sale" },
        { key: "endDate", label: "Sale End Date (ISO)", type: "string", placeholder: "2025-12-31T23:59:59" },
        { key: "bgColor", label: "Header Background Color", type: "color", default: "#1a1a2e" },
        { key: "products", label: "Products", type: "array", itemSchema: Em }
      ]
    }
  ],
  commonFields: [...Ne]
}, Fm = [
  { key: "id", label: "Product ID", type: "string" },
  { key: "name", label: "Product Name", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "price", label: "Price", type: "number" },
  { key: "originalPrice", label: "Original Price", type: "number" },
  { key: "badge", label: "Badge Text", type: "string" }
], Im = {
  type: "new-arrivals",
  label: "New Arrivals",
  description: "Horizontal carousel showcasing the latest product arrivals.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "V1 — Embla Carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Fresh styles just landed" },
        { key: "products", label: "Products", type: "array", itemSchema: Fm },
        { key: "slidesPerView", label: "Slides Per View", type: "number", default: 4 }
      ]
    }
  ],
  commonFields: [...Ne]
}, Om = {
  type: "offer-banner",
  label: "Offer Banner",
  description: "Full-width promotional banner with background image and text overlay.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "V1 — Full-Width Promo Banner",
      fields: [
        { key: "image", label: "Background Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "Special Offer" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Get up to 50% off on selected items" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        { key: "overlayOpacity", label: "Overlay Opacity (0–100)", type: "number", default: 50 }
      ]
    }
  ],
  commonFields: [...Ne]
}, Xi = {
  type: "lookbook-banner",
  label: "Lookbook Banner",
  description: "Editorial banner — split image/text (V1) or full-width overlay (V2).",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "V1 — Editorial Split (Image + Text)",
      fields: [
        { key: "image", label: "Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The New Collection" },
        { key: "subtitle", label: "Subtitle", type: "text" },
        { key: "ctaText", label: "Button Text", type: "string", default: "View Lookbook" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        {
          key: "imagePosition",
          label: "Image Position",
          type: "select",
          options: [
            { label: "Left", value: "left" },
            { label: "Right", value: "right" }
          ],
          default: "left"
        }
      ]
    },
    {
      id: "v2",
      label: "V2 — Full-Width Collection Banner",
      fields: [
        { key: "image", label: "Background Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The Collection" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Discover the new season" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        { key: "overlayOpacity", label: "Overlay Opacity (0–100)", type: "number", default: 40 }
      ]
    }
  ],
  commonFields: [...Ne]
}, $r = [
  { key: "image", label: "Image", type: "image" },
  { key: "link", label: "Link URL", type: "string" }
], Rm = {
  type: "instagram-feed",
  label: "Instagram Feed",
  description: "Display a grid of Instagram photos with hover effects.",
  supportedPages: [...Eo],
  variants: [
    {
      id: "v1",
      label: "V1 — 5-Column Photo Grid",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle (e.g. @urbandrip)", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: $r }
      ]
    },
    {
      id: "v2",
      label: "V2 — 6-Column with Handle Overlay",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: $r }
      ]
    },
    {
      id: "v3",
      label: "V3 — 4-Column Large Tiles",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: $r }
      ]
    },
    {
      id: "v4",
      label: "V4 — Masonry Style with Header",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: $r }
      ]
    }
  ],
  commonFields: [...Ne]
}, Dc = [
  { key: "title", label: "Title", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "excerpt", label: "Excerpt", type: "text" },
  { key: "slug", label: "Slug", type: "string" },
  { key: "date", label: "Date", type: "string" },
  { key: "category", label: "Category", type: "string" }
], Bm = {
  type: "blog",
  label: "Blog Posts",
  description: "Display a grid or list of blog post cards.",
  supportedPages: [...Eo],
  variants: [
    {
      id: "v1",
      label: "V1 — 3-Column Card Grid (Fashion Style)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: Dc },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: !0 }
      ]
    },
    {
      id: "v2",
      label: "V2 — List Style (Electronics Style)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: Dc },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: !0 }
      ]
    },
    {
      id: "v3",
      label: "Article Detail",
      fields: []
    }
  ],
  commonFields: [
    { key: "source", label: "Posts to show", type: "select", options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." },
    ...Ne
  ]
}, hi = [
  {
    key: "icon",
    label: "Icon",
    type: "select",
    options: [
      { label: "Shipping Truck", value: "shipping" },
      { label: "Return Arrow", value: "refund" },
      { label: "Support Headset", value: "support" },
      { label: "Security Lock", value: "secure" },
      { label: "Gift Box", value: "gift" }
    ],
    default: "shipping"
  },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" }
], zm = {
  type: "features",
  label: "Features Strip",
  description: "Trust-building feature strip showing shipping, returns, support, and security highlights.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Compact Horizontal Strip",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: hi },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (Light Gray)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" }
          ],
          default: "default"
        }
      ]
    },
    {
      id: "v2",
      label: "V2 — Spaced Cards",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: hi },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (White)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" }
          ],
          default: "default"
        }
      ]
    },
    {
      id: "v3",
      label: "V3 — Jewelry Minimal Centered",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: hi }
      ]
    }
  ],
  commonFields: [...Ne]
}, Fc = [
  { key: "avatar", label: "Avatar Image", type: "image" },
  { key: "name", label: "Name", type: "string" },
  { key: "designation", label: "Designation", type: "string" },
  { key: "review", label: "Review Text", type: "text" },
  { key: "rating", label: "Rating (1–5)", type: "number", default: 5 }
], Vm = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer reviews and social proof section.",
  supportedPages: ["home", "shop"],
  variants: [
    {
      id: "v1",
      label: "V1 — Centered Slider",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "What Our Customers Say" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: Fc }
      ]
    },
    {
      id: "v2",
      label: "V2 — Card Grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Customer Reviews" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: Fc }
      ]
    }
  ],
  commonFields: [...Ne]
}, Wm = {
  type: "cta",
  label: "Call to Action",
  description: "Email subscribe section with a heading, subtitle, and inline form.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Dark Subscribe Banner",
      fields: [
        { key: "title", label: "Heading", type: "string", default: "Subscribe to Our Newsletter" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Get exclusive deals and new arrivals straight to your inbox." },
        { key: "placeholder", label: "Input Placeholder", type: "string", default: "Enter your email address" },
        { key: "buttonText", label: "Button Text", type: "string", default: "Subscribe" },
        { key: "bgColor", label: "Background Color", type: "color" }
      ]
    }
  ],
  commonFields: [...Ne]
}, $m = [
  { key: "logo", label: "Logo Image", type: "image" },
  { key: "name", label: "Brand Name", type: "string" },
  { key: "link", label: "Brand URL", type: "string" }
], _m = {
  type: "brands",
  label: "Brand Logos",
  description: "Display partner or brand logos in a grid or auto-scrolling ticker.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Logo Grid / Ticker",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        {
          key: "layout",
          label: "Layout",
          type: "select",
          options: [
            { label: "Grid", value: "grid" },
            { label: "Auto-scroll Ticker", value: "ticker" }
          ],
          default: "grid"
        },
        { key: "items", label: "Brand Items", type: "array", itemSchema: $m }
      ]
    }
  ],
  commonFields: [...Ne]
}, Hm = [
  { key: "label", label: "Tab Label", type: "string" }
], Um = {
  type: "product-slider",
  label: "Product Slider",
  description: "A horizontal scrolling product carousel with optional tabs.",
  supportedPages: ["home", "category", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Tabbed Fashion Carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Featured Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "All Product Shop" },
        { key: "tabs", label: "Tabs", type: "array", itemSchema: Hm }
      ]
    },
    {
      id: "v2",
      label: "V2 — Simple Jewelry Carousel (3-4 cols)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Exquisite Collection" }
      ]
    },
    {
      id: "v3",
      label: "V3 — Beauty Product Carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Skincare & Beauty" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Glow Up Collection" }
      ]
    }
  ],
  commonFields: [...Ne]
}, Gm = {
  type: "product-grid",
  label: "Product Grid",
  description: "A product grid section with multiple layout variants.",
  supportedPages: ["home", "category", "categories", "shop"],
  variants: [
    {
      id: "v1",
      label: "V1 — 4-Col Standard Grid (Fashion)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "All Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Customer Favorite Style" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v2",
      label: "V2 — Featured + List Aside (Week's Featured)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Week's Featured" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Top Picks" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v3",
      label: "V3 — Electronics List View + Sidebar",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Trending Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Electronics" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v4",
      label: "V4 — Gadget Showcase (1 Large + Smaller Cards)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Top Gadgets" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "New Arrivals" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v5",
      label: "V5 — Beauty 4-Col Image-Focused",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Beauty Essentials" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Trending Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v6",
      label: "V6 — Trending List + Special Offer with Countdown",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "This Week's Picks" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Hot Right Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" },
        { key: "offerEndsAt", label: "Offer End Date (ISO string)", type: "string" }
      ]
    }
  ],
  commonFields: [...Ne]
}, Ym = {
  type: "compare",
  label: "Product Comparison",
  description: "A lookbook line sheet comparing up to 4 pieces side by side: 3:4 photo, brand and name, sale price with % off (cheapest marked), colour swatches, size chips, fit, fabric and other attributes, category and brand, a show-differences-only switch, Add to bag and remove.",
  supportedPages: ["compare"],
  variants: [
    {
      id: "v1",
      label: "Table"
    }
  ],
  commonFields: [...Ne]
}, Xm = {
  type: "coupon",
  label: "Coupons",
  description: "A grid of coupon cards with discount code, title, description, expiry date, and a copy-to-clipboard button.",
  supportedPages: ["coupon"],
  variants: [
    {
      id: "v1",
      label: "Card Grid"
    }
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Available Coupons" },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Coupon Code", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Description", type: "text" },
        { key: "expiryDate", label: "Expiry Date", type: "string" },
        { key: "discount", label: "Discount (e.g. 20% or Free Shipping)", type: "string" },
        { key: "bgColor", label: "Badge Background Color", type: "color" }
      ]
    },
    ...Ne
  ]
}, jm = {
  type: "recent-products",
  label: "Recently Viewed Products",
  description: "A horizontal slider of products the visitor has recently viewed (stored in localStorage — no API call).",
  supportedPages: ["home", "shop", "product", "category", "cart"],
  variants: [{ id: "v1", label: "V1 (Horizontal Slider)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Recently Viewed" }
  ]
}, qm = {
  key: "messages",
  label: "Marquee messages",
  type: "array",
  help: "Scroll across the top in a loop. Without messages the announcement text is used.",
  itemSchema: [
    { key: "text", label: "Text", type: "localized-string" },
    { key: "link", label: "Link", type: "string" }
  ]
}, Zm = { key: "badge", label: "Badge", type: "string", placeholder: "New", help: "Small label next to the item." }, Jm = { key: "searchPlaceholder", label: "Search label", type: "string", placeholder: "Search" }, Km = (e) => [
  ...e.map((t) => t.key === "type" && t.options && !t.options.some((a) => a.value === "categories") ? { ...t, options: [...t.options, { label: "Shop panel (store categories)", value: "categories" }] } : t),
  Zm
], Qm = {
  ...Gi,
  commonFields: Gi.commonFields.flatMap((e) => e.key === "topbar" && e.fields ? [{ ...e, fields: [...e.fields, qm] }] : e.key === "menu" && e.itemSchema ? [{ ...e, itemSchema: Km(e.itemSchema) }] : e.key === "actions" ? [e, Jm] : [e])
}, Ra = ["home", "shop", "category", "categories", "product", "cart", "blog"], eg = ["truck", "cash", "phone", "shield", "star", "heart", "package", "check", "store", "map-pin", "mail", "sparkle", "clock", "bag", "user", "search", "refresh", "lock", "tag"].map((e) => ({ label: e.replace("-", " "), value: e })), Ba = (e = {}) => [
  { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: e.eyebrow ?? "", help: "Small line above the title." },
  { key: "title", label: "Title", type: "localized-string", default: e.title ?? "" },
  { key: "subtitle", label: "Subtitle", type: "localized-text", default: e.subtitle ?? "" }
], Fp = [
  { key: "icon", label: "Icon", type: "icon", default: "check", options: eg },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "body", label: "Text", type: "localized-text" }
], tg = {
  type: "banner-carousel",
  label: "Banner carousel",
  description: "Picture slides (their text is part of the image) crossfading in a square frame, with counter, arrows and pause.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [{ id: "v1", label: "Crossfading slides" }],
  commonFields: [
    { key: "title", label: "Name for screen readers", type: "string", default: "Offers" },
    {
      key: "slides",
      label: "Slides",
      type: "array",
      itemSchema: [
        { key: "image", label: "Picture", type: "image", required: !0, help: "Square, about 1200 × 1200 px." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional." },
        { key: "alt", label: "Picture description", type: "string", help: "What the banner says, for screen readers." },
        { key: "link", label: "Link", type: "string", placeholder: "/shop" }
      ],
      default: []
    },
    { key: "autoplay", label: "Play automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 5, dependency: { field: "autoplay", value: !0 } }
  ]
}, ag = {
  type: "category-bento",
  label: "Category mosaic",
  description: "Photo tiles linking to categories: the tiles you list, else the store’s categories.",
  supportedPages: Ra,
  variants: [
    { id: "v1", label: "V1 — Row of photo tiles" },
    { id: "v2", label: "V2 — Lookbook mosaic (first tile large)" }
  ],
  commonFields: [
    ...Ba({ eyebrow: "Browse", title: "Shop by category" }),
    {
      key: "tiles",
      label: "Tiles",
      type: "array",
      help: "Empty = the store’s categories.",
      itemSchema: [
        { key: "categoryId", label: "Category", type: "category-select", help: "Sets the link, name and picture unless filled below." },
        { key: "title", label: "Name", type: "localized-string" },
        { key: "tagline", label: "Tagline (mosaic)", type: "localized-string" },
        { key: "image", label: "Picture", type: "image" },
        { key: "link", label: "Link", type: "string", placeholder: "/category/…" }
      ],
      default: []
    },
    { key: "limit", label: "Categories shown (automatic tiles)", type: "number", default: 8 }
  ]
}, og = {
  type: "combo-spotlight",
  label: "Product spotlight",
  description: "One product or bundle as an editorial spread: large photo, price, saving and Add to bag.",
  supportedPages: Ra,
  variants: [{ id: "v1", label: "Editorial spread" }],
  commonFields: [
    ...Ba({ eyebrow: "The drop", title: "Fit of the week" }),
    { key: "productId", label: "Product", type: "product-select", help: "Hidden until a product is picked." },
    { key: "description", label: "Text", type: "localized-text", default: "" },
    { key: "mrpLabel", label: "Regular price label", type: "localized-string", default: "Regular price" },
    { key: "savingLabel", label: "Saving label", type: "localized-string", default: "You save" },
    { key: "detailsLabel", label: "Details link text", type: "localized-string", default: "View details" }
  ]
}, rg = {
  type: "corporate-band",
  label: "Bulk order band",
  description: "An ink band with a short pitch and one button, e.g. for team, event or wholesale orders.",
  supportedPages: Ra,
  variants: [{ id: "v1", label: "Ink band" }],
  commonFields: [
    ...Ba({ eyebrow: "For crews", title: "Bulk and team orders" }).filter((e) => e.key !== "subtitle"),
    { key: "text", label: "Text", type: "localized-text", default: "Kitting out a team, a crew or an event? Get volume pricing and custom prints." },
    { key: "cta.label", label: "Button text", type: "localized-string", default: "Contact us" },
    { key: "cta.url", label: "Button link", type: "string", default: "/contact" }
  ]
}, lg = {
  type: "product-rail",
  label: "Product rail",
  description: "Product cards from new arrivals, deals, a category or your own pick, as a grid or a swipe row.",
  supportedPages: Ra,
  variants: [{ id: "v1", label: "Product cards" }],
  commonFields: [
    ...Ba({ eyebrow: "Just dropped", title: "New arrivals" }),
    { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 8 } },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [
        { label: "Grid (four up)", value: "grid" },
        { label: "Swipe row", value: "rail" }
      ],
      default: "grid"
    },
    { key: "showViewAll", label: "Show “View all”", type: "boolean", default: !0 },
    { key: "viewAllLabel", label: "“View all” text", type: "string", default: "View all", dependency: { field: "showViewAll", value: !0 } }
  ]
}, ig = {
  type: "promises",
  label: "Promises strip",
  description: "Two to four store promises in a hairline-ruled row: icon, title and a short line.",
  supportedPages: Ra,
  variants: [{ id: "v1", label: "Ruled row" }],
  commonFields: [
    ...Ba(),
    {
      key: "items",
      label: "Promises",
      type: "array",
      itemSchema: Fp,
      default: [
        { icon: "truck", title: "Fast delivery", body: "Quick delivery across the city." },
        { icon: "cash", title: "Pay on delivery", body: "Pay in cash when your order arrives." },
        { icon: "refresh", title: "Easy returns", body: "Wrong size? Swap it within 7 days." },
        { icon: "phone", title: "Here to help", body: "Call or message us any day." }
      ]
    }
  ]
}, ng = {
  type: "reviews",
  label: "Customer reviews",
  description: "A swipe row of quote cards: rating, title, quote, name and the product. Store reviews replace these once available.",
  supportedPages: Ra,
  variants: [{ id: "v1", label: "Quote cards" }],
  commonFields: [
    ...Ba({ eyebrow: "Reviews", title: "What the crew says" }),
    {
      key: "items",
      label: "Reviews",
      type: "array",
      help: "Real reviews from your customers, with their permission.",
      itemSchema: [
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "body", label: "Review", type: "localized-text" },
        { key: "name", label: "Customer name", type: "string" },
        { key: "productId", label: "Product", type: "product-select" }
      ],
      default: []
    },
    { key: "limit", label: "Most reviews shown", type: "number", default: 6 },
    { key: "minRating", label: "Lowest rating shown (store reviews)", type: "number", default: 4 }
  ]
}, sg = {
  type: "story",
  label: "Story band",
  description: "A 4:5 photo beside the heading and two to four numbered points, with an optional button.",
  supportedPages: Ra,
  variants: [{ id: "v1", label: "Photo and numbered points" }],
  commonFields: [
    ...Ba({ eyebrow: "Our story", title: "Made for the street" }),
    { key: "image", label: "Picture", type: "image", help: "Portrait, 4:5." },
    {
      key: "points",
      label: "Points",
      type: "array",
      itemSchema: Fp,
      default: [
        { icon: "sparkle", title: "Small drops", body: "Limited runs, so your fit stays yours." },
        { icon: "shield", title: "Heavy fabrics", body: "Cut from cotton that holds its shape." },
        { icon: "truck", title: "Fast shipping", body: "Packed the same day, at your door soon after." }
      ]
    },
    { key: "ctaLabel", label: "Button text", type: "localized-string", default: "" },
    { key: "ctaLink", label: "Button link", type: "string", default: "" }
  ]
}, cg = {
  key: "gallery",
  label: "Mosaic pictures",
  type: "array",
  help: "Up to two (split) or three (full width) extra pictures shown as a mosaic with the main picture.",
  itemSchema: [
    { key: "image", label: "Picture", type: "image" },
    { key: "alt", label: "Description (alt text)", type: "string" },
    { key: "link", label: "Link", type: "string" }
  ]
}, dg = {
  ...Xi,
  variants: Xi.variants.map((e) => ({ ...e, fields: [...e.fields ?? [], cg] }))
}, pg = {
  ...Yi,
  commonFields: [
    ...Yi.commonFields,
    { key: "sizeGuideTitle", label: "Size guide link and title", type: "string", default: "Size guide" },
    { key: "sizeGuide", label: "Size guide", type: "rich-text", help: "Measurements table or fit notes, opened from a link beside the size selector. Hidden while empty." },
    { key: "completeTheLookTitle", label: '"Complete the look" title', type: "string", default: "Complete the look", help: "Other products from the same category, shown under the product." },
    { key: "showDeliveryAreas", label: "Show delivery areas and charges", type: "boolean", default: !0 }
  ]
}, ug = {
  ...Hi,
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Sign in" },
    { key: "intro", label: "Intro text", type: "text", default: "Sign in or create an account with your mobile number." },
    ...Hi.commonFields
  ]
}, yg = {
  ...Ui,
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Create account" },
    { key: "intro", label: "Intro text", type: "text", default: "Create your account with your mobile number." },
    ...Ui.commonFields
  ]
}, Ic = {
  componentSchemas: {
    "banner-carousel": tg,
    "category-bento": ag,
    "combo-spotlight": og,
    "corporate-band": rg,
    "product-rail": lg,
    promises: ig,
    reviews: ng,
    story: sg,
    "lookbook-banner": dg,
    "product-detail": pg,
    signin: ug,
    signup: yg
  },
  chrome: {
    headerSchema: Qm
  }
}, Oc = {
  componentSchemas: {
    account: dm,
    signin: Hi,
    signup: Ui,
    banner: Oa,
    cart: hm,
    categories: bm,
    category: mm,
    checkout: gm,
    contact: fm,
    content: vm,
    "featured-category": km,
    hero: xm,
    "order-success": Tm,
    "product-detail": Yi,
    "similar-products": Pm,
    "shop-grid": Am,
    wishlist: Lm,
    "announcement-bar": Nm,
    "flash-sale": Dm,
    "new-arrivals": Im,
    "offer-banner": Om,
    "lookbook-banner": Xi,
    "instagram-feed": Rm,
    blog: Bm,
    features: zm,
    testimonials: Vm,
    cta: Wm,
    brands: _m,
    "product-slider": Um,
    "product-grid": Gm,
    compare: Ym,
    coupon: Xm,
    "recent-products": jm
  },
  headerSchema: Gi,
  footerSchema: Sm,
  floatingButtonsSchema: wm,
  mobileNavSchema: Cm
}, hg = ht({
  ...Oc,
  componentSchemas: { ...Oc.componentSchemas, ...Ic.componentSchemas },
  ...Ic.chrome
}, cm), bg = {
  account: { hide: ["signinRedirectPath"] },
  "announcement-bar": { hide: ["bgColor", "textColor"] },
  cart: { hide: ["loadingText", "taxLabel", "secureCheckoutText"] },
  category: { hide: ["productCardVariant", "initialPriceRange", "showBreadcrumb"] },
  checkout: { hide: ["loadingText", "shippingCalculatingText", "securePaymentText"] },
  cta: { hide: ["bgColor"] },
  "featured-category": { hide: ["productCardVariant", "noSelectionText", "noProductsText"] },
  features: { hide: ["bgStyle"] },
  "flash-sale": { hide: ["bgColor", "products"] },
  "new-arrivals": { hide: ["products"] },
  "order-success": { hide: ["loadingText"] },
  "product-detail": { hide: ["loadingText", "notFoundCode", "notFoundText"], keep: ["v1", "v2", "v3"], variantLabels: { v1: "Standard (video in the gallery when set)", v2: "Sale countdown band", v3: "Large photo swatches" } },
  "shop-grid": { hide: ["productCardVariant", "initialPriceRange", "sortOldestLabel", "sortNameDescLabel"], keep: ["v1"], variantLabels: { v1: "Boutique: centred, filters in a drawer" } },
  "similar-products": { hide: ["productCardVariant"] },
  blog: { keep: ["v1", "v2"] },
  coupon: { hide: ["coupons[].bgColor"] },
  header: { hide: ["topbar[].phone", "topbar[].email", "topbar[].showSocials", "topbar[].socialLinks"] },
  footer: { hide: ["paymentMethods[].icon"] },
  // Theme tab: button settings no part of this theme reads (colours drive every primary button via the CTA).
  buttons: { hide: ["appearance.buttons.primary[].radius", "appearance.buttons.primary[].height", "appearance.buttons.primary[].paddingX", "appearance.buttons.primary[].label", "appearance.buttons.outline[].radius", "appearance.buttons.outline[].height", "appearance.buttons.outline[].paddingX", "appearance.buttons.outline[].label", "appearance.buttons.outline[].hoverBg"] },
  // Delivery time is shown on product cards only by Prottoho.
  "store-info": { hide: ["deliveryEta"] }
}, mg = {
  type: "account",
  label: "Account Section",
  description: "User dashboard with orders, addresses, and profile settings.",
  supportedPages: ["account"],
  variants: [
    { id: "v1", label: "V1 (Sidebar + Content)" },
    { id: "v2", label: "Order History" },
    { id: "v3", label: "Address Book" }
  ],
  commonFields: [
    { key: "tabOverviewLabel", label: "Overview Tab Label", type: "string", default: "Overview" },
    { key: "tabOrdersLabel", label: "Orders Tab Label", type: "string", default: "Orders" },
    { key: "tabAddressesLabel", label: "Addresses Tab Label", type: "string", default: "Addresses" },
    { key: "tabDetailsLabel", label: "Profile Tab Label", type: "string", default: "Profile" },
    { key: "signOutLabel", label: "Sign Out Label", type: "string", default: "Sign Out" },
    { key: "signinRedirectPath", label: "Sign In Redirect Path", type: "string", default: "/signin" }
  ]
}, ji = {
  type: "signin",
  label: "Signin Section",
  description: "Login form with phone/OTP flow and two-column layout.",
  supportedPages: ["signin"],
  variants: [{ id: "v1", label: "V1 (Two Column)" }],
  commonFields: [
    { key: "redirectUrl", label: "Redirect After Login", type: "string", default: "/account" }
  ]
}, qi = {
  type: "signup",
  label: "Signup Section",
  description: "Registration form with phone/OTP flow and two-column layout.",
  supportedPages: ["signup"],
  variants: [{ id: "v2", label: "V2 (Two Column)" }],
  commonFields: [
    { key: "redirectUrl", label: "Redirect After Signup", type: "string", default: "/account" }
  ]
}, Do = [
  "home",
  "shop",
  "product",
  "category",
  "categories",
  "cart",
  "checkout",
  "contact",
  "signin",
  "signup",
  "account",
  "wishlist",
  "track-order",
  "order-success",
  "privacy-policy",
  "terms-of-service",
  "shipping-policy",
  "return-policy",
  "order-detail"
], ml = [
  { key: "id", label: "ID", type: "string" },
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link", type: "string" }
], gg = [
  { key: "id", label: "ID", type: "string" },
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link URL", type: "string" },
  {
    key: "type",
    label: "Type",
    type: "select",
    options: [
      { label: "Standard Link", value: "link" },
      { label: "Dropdown", value: "dropdown" },
      { label: "Mega Menu", value: "mega-menu" }
    ]
  },
  {
    key: "children",
    label: "Dropdown Items",
    type: "array",
    itemSchema: ml,
    dependency: { field: "type", value: "dropdown" }
  },
  {
    key: "columns",
    label: "Mega Menu Columns",
    type: "array",
    itemSchema: [
      { key: "title", label: "Column Title", type: "string" },
      { key: "items", label: "Links", type: "array", itemSchema: ml }
    ],
    dependency: { field: "type", value: "mega-menu" }
  },
  {
    key: "featuredImage",
    label: "Featured Image",
    type: "object",
    fields: [
      { key: "src", label: "Image", type: "image" },
      { key: "title", label: "Title", type: "string" },
      { key: "href", label: "Link", type: "string" }
    ],
    dependency: { field: "type", value: "mega-menu" }
  }
], _r = [
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "text" },
  { key: "image", label: "Background Image", type: "image" },
  { key: "ctaText", label: "Button Text", type: "string" },
  { key: "ctaLink", label: "Button Link", type: "string" },
  { key: "badge", label: "Badge Text", type: "string" }
], Ee = [
  {
    key: "styles.paddingTop",
    label: "Padding Top",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.paddingBottom",
    label: "Padding Bottom",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.background",
    label: "Background",
    type: "select",
    options: [
      { label: "None (theme default)", value: "default" },
      { label: "Light grey", value: "muted" },
      { label: "Brand tint", value: "primary" }
    ],
    default: "default"
  }
], fg = [
  {
    key: "icon",
    label: "Icon (truck | shield | lock)",
    type: "string"
  },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" }
], vg = [
  { key: "image", label: "Background Image", type: "image" },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" },
  { key: "ctaText", label: "Button Text", type: "string" },
  { key: "ctaLink", label: "Button Link", type: "string" }
], kg = {
  type: "banner",
  label: "Banner Section",
  description: "Promo feature strip or side-by-side image banners.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Feature Strip (Free Shipping, etc.)",
      fields: [
        { key: "columns", label: "Feature Columns", type: "array", itemSchema: fg }
      ]
    },
    {
      id: "v2",
      label: "V2 — Two Promo Image Banners",
      fields: [
        { key: "banners", label: "Promo Banners (max 2)", type: "array", itemSchema: vg }
      ]
    }
  ],
  commonFields: [...Ee]
}, wg = {
  type: "cart",
  label: "Cart Section",
  description: "The shopping cart page section.",
  supportedPages: ["cart"],
  variants: [{ id: "v1", label: "V1" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Shopping Cart" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading cart items..." },
    { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty State Message", type: "string", default: "Browse our products and add items to your cart." },
    { key: "continueShoppingText", label: "Continue Shopping Button Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingLabel", label: "Shipping Label", type: "string", default: "Shipping" },
    { key: "shippingCalculatedText", label: "Shipping Calculated Text", type: "string", default: "Calculated at checkout" },
    { key: "taxLabel", label: "Tax Label", type: "string", default: "Tax" },
    { key: "totalLabel", label: "Total Label", type: "string", default: "Total" },
    { key: "checkoutButtonText", label: "Checkout Button Text", type: "string", default: "Proceed to Checkout" },
    { key: "checkoutLink", label: "Checkout Link", type: "string", default: "/checkout" },
    { key: "secureCheckoutText", label: "Secure Checkout Label", type: "string", default: "SSL Secure Checkout" }
  ]
}, Sg = {
  type: "categories",
  label: "Shop by occasion",
  description: "Occasion rail of arched category tiles (a grid on the categories page).",
  supportedPages: ["home", "categories", "shop"],
  variants: [{ id: "v1", label: "V1 (Image Grid)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    {
      key: "columns",
      label: "Columns",
      type: "select",
      options: [
        { label: "2 Columns", value: 2 },
        { label: "3 Columns", value: 3 },
        { label: "4 Columns", value: 4 }
      ],
      default: 4
    },
    { key: "emptyText", label: "Empty Text", type: "string", default: "No categories found." },
    ...Ee
  ]
}, xg = {
  type: "category",
  label: "Category Listing",
  description: "Single category page: breadcrumb, header, product grid with filters.",
  supportedPages: ["category", "shop"],
  variants: [{ id: "v1", label: "V1 (Sidebar + Grid)" }],
  commonFields: [
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "initialPriceRange.min", label: "Price Range Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Price Range Max", type: "number", default: 5e4 },
    { key: "showBreadcrumb", label: "Show Breadcrumb", type: "boolean", default: !0 },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...Ee
  ]
}, Tg = {
  type: "checkout",
  label: "Checkout Section",
  description: "The order checkout page section.",
  supportedPages: ["checkout"],
  variants: [{ id: "v1", label: "V1" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Checkout" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Preparing checkout..." },
    { key: "emptyTitle", label: "Empty Cart Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty Cart Message", type: "string", default: "Checkout is only available for shopping carts with items." },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingChargeLabel", label: "Shipping Charge Label", type: "string", default: "Shipping Charge" },
    { key: "shippingCalculatingText", label: "Shipping Calculating Text", type: "string", default: "Calculating..." },
    { key: "totalLabel", label: "Total Amount Label", type: "string", default: "Total Amount" },
    { key: "placeOrderText", label: "Place Order Button Text", type: "string", default: "Place Order" },
    { key: "placingOrderText", label: "Placing Order Loading Text", type: "string", default: "Placing Order..." },
    { key: "securePaymentText", label: "Secure Payment Label", type: "string", default: "SSL Secure Payment" }
  ]
}, Cg = {
  type: "contact",
  label: "Contact Section",
  description: "Two-column contact page with form and info panel.",
  supportedPages: ["contact"],
  variants: [{ id: "v1", label: "V1 (Split Layout)" }],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    { key: "email", label: "Email Address", type: "string" },
    { key: "phone", label: "Phone Number", type: "string" },
    { key: "address", label: "Physical Address", type: "text" }
  ]
}, Pg = {
  type: "content",
  label: "Content / Policy Section",
  description: "Generic rich-text section for policies and descriptions.",
  supportedPages: ["privacy-policy", "terms-of-service", "shipping-policy", "return-policy"],
  variants: [
    { id: "v1", label: "V1 (Clean Layout)" },
    { id: "v2", label: "V2 (With Table of Contents)" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "content", label: "HTML Content", type: "rich-text" }
  ]
}, Ag = {
  type: "featured-category",
  label: "Featured Category",
  description: "Display products from a specific category on the home page.",
  supportedPages: ["home", "product", "cart"],
  variants: [{ id: "v1", label: "V1 (Product Grid)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    { key: "categoryId", label: "Select Category", type: "category-select" },
    { key: "rows", label: "Number of Rows", type: "number", default: 1 },
    { key: "viewAllText", label: "View All Button Text", type: "string", default: "View All" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "noSelectionText", label: "No Category Selected Text", type: "string", default: "Please select a category in the editor settings." },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    ...Ee
  ]
}, Lg = {
  type: "floating-buttons",
  label: "Floating Buttons",
  description: "Global floating buttons for quick actions (Call, WhatsApp, Messenger).",
  supportedPages: [...Do],
  variants: [{ id: "v1", label: "Default" }],
  commonFields: [
    { key: "active", label: "Enable Floating Buttons", type: "boolean", default: !0 },
    { key: "phone", label: "Phone Number", type: "string", placeholder: "+8801..." },
    { key: "whatsapp", label: "WhatsApp Number", type: "string", placeholder: "+8801..." },
    { key: "messenger", label: "Messenger ID/Link", type: "string", placeholder: "m.me/..." },
    { key: "callUsTitle", label: "Call Button Tooltip", type: "string", default: "Call Us" },
    { key: "whatsappTitle", label: "WhatsApp Button Tooltip", type: "string", default: "WhatsApp" },
    { key: "messengerTitle", label: "Messenger Button Tooltip", type: "string", default: "Messenger" }
  ]
}, Mg = {
  type: "footer",
  label: "Footer",
  description: "Site-wide footer with links, newsletter, and contact info.",
  supportedPages: [...Do],
  variants: [
    { id: "v1", label: "Dark (Default)" },
    { id: "v2", label: "Light" }
  ],
  commonFields: [
    { key: "logo", label: "Footer Logo", type: "image" },
    { key: "title", label: "Brand Name", type: "string", default: "Nakshi" },
    {
      key: "description",
      label: "Brand Description",
      type: "text",
      default: "Jamdani, muslin and katan sarees, panjabi and three-piece, woven and stitched by Bangladeshi artisans."
    },
    {
      key: "columns",
      label: "Link Columns",
      type: "array",
      itemSchema: [
        { key: "title", label: "Column Title", type: "string" },
        { key: "links", label: "Links", type: "array", itemSchema: ml }
      ]
    },
    {
      key: "socialLinks",
      label: "Social Links",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Facebook", value: "facebook" },
            { label: "Instagram", value: "instagram" },
            { label: "Twitter", value: "twitter" },
            { label: "YouTube", value: "youtube" },
            { label: "LinkedIn", value: "linkedin" }
          ]
        },
        { key: "href", label: "Link", type: "string" }
      ]
    },
    { key: "contactAddress", label: "Address", type: "string" },
    { key: "contactPhone", label: "Phone", type: "string" },
    { key: "contactEmail", label: "Email", type: "string" },
    { key: "copyright", label: "Copyright Text", type: "string", default: "© 2025 Nakshi. All rights reserved." },
    {
      key: "paymentMethods",
      label: "Payment Methods",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Visa", value: "visa" },
            { label: "Mastercard", value: "mastercard" },
            { label: "Amex", value: "amex" },
            { label: "Stripe", value: "stripe" },
            { label: "PayPal", value: "paypal" },
            { label: "bKash", value: "bkash" },
            { label: "Nagad", value: "nagad" },
            { label: "Rocket", value: "rocket" }
          ]
        },
        { key: "icon", label: "Icon URL (optional)", type: "string" }
      ]
    }
  ]
}, Zi = {
  type: "header",
  label: "Header",
  description: "Site-wide header with navigation, search, and cart.",
  supportedPages: [...Do],
  variants: [
    { id: "v1", label: "Default" },
    { id: "v2", label: "Electronics" },
    { id: "v3", label: "Beauty / Minimal" },
    { id: "v4", label: "Jewelry / Elegant" }
  ],
  commonFields: [
    { key: "logo.alt", label: "Logo Alt Text", type: "string" },
    { key: "logo.src", label: "Logo Image", type: "image" },
    { key: "sticky", label: "Sticky Header", type: "boolean", default: !0 },
    {
      key: "topbar",
      label: "Top Bar",
      type: "object",
      fields: [
        { key: "active", label: "Enable Top Bar", type: "boolean", default: !0 },
        {
          key: "variant",
          label: "Variant",
          type: "select",
          options: [
            { label: "V1 (Centered Promo)", value: "v1" },
            { label: "V2 (Contact & Socials)", value: "v2" }
          ],
          default: "v1"
        },
        { key: "text", label: "Announcement Text", type: "string" },
        { key: "phone", label: "Phone Number", type: "string" },
        { key: "email", label: "Email Address", type: "string" },
        { key: "showSocials", label: "Show Social Icons", type: "boolean", default: !0 },
        {
          key: "socialLinks",
          label: "Social Links",
          type: "array",
          itemSchema: [
            { key: "platform", label: "Platform", type: "string" },
            { key: "href", label: "Link", type: "string" },
            { key: "icon", label: "Icon Name", type: "string" }
          ]
        },
        { key: "links", label: "Top Bar Links", type: "array", itemSchema: ml }
      ]
    },
    {
      key: "actions",
      label: "Actions",
      type: "object",
      fields: [
        { key: "showSearch", label: "Show Search", type: "boolean", default: !0 },
        { key: "showCart", label: "Show Cart", type: "boolean", default: !0 },
        { key: "showAccount", label: "Show Account", type: "boolean", default: !0 },
        { key: "showWishlist", label: "Show Wishlist", type: "boolean", default: !0 },
        {
          key: "cartAction",
          label: "Cart Action",
          type: "select",
          options: [
            { label: "Slide-out Sidebar", value: "sidebar" },
            { label: "Go to Page", value: "page" }
          ],
          default: "sidebar"
        }
      ]
    },
    {
      key: "searchConfig",
      label: "Search Settings",
      type: "object",
      fields: [
        { key: "showPrice", label: "Show Price in Suggestions", type: "boolean", default: !0 },
        { key: "showCategory", label: "Show Category in Suggestions", type: "boolean", default: !0 },
        { key: "showImage", label: "Show Image in Suggestions", type: "boolean", default: !0 },
        { key: "maxResults", label: "Max Suggestions", type: "number", default: 6 }
      ]
    },
    { key: "menu", label: "Main Menu", type: "array", itemSchema: gg }
  ]
}, Ng = {
  type: "hero",
  label: "Hero Section",
  description: "The main attention-grabbing section at the top of the page.",
  supportedPages: ["home", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Arched triptych",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: _r },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    },
    {
      id: "v2",
      label: "V2 — Centred arch",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: _r },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    },
    {
      id: "v3",
      label: "V3 — Stitched frame",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: _r }
      ]
    },
    {
      id: "v4",
      label: "V4 — Raat (dark stitched frame)",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: _r }
      ]
    }
  ],
  commonFields: [...Ee]
}, Eg = {
  type: "order-success",
  label: "Order Success Section",
  description: "The order confirmation page section.",
  supportedPages: ["order-success"],
  variants: [{ id: "v1", label: "V1" }],
  commonFields: [
    { key: "title", label: "Success Title", type: "string", default: "Order Confirmed" },
    { key: "message", label: "Success Message", type: "text", default: "Your order has been placed successfully. We have sent a confirmation email with your order details." },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading order details..." },
    { key: "errorTitle", label: "Error Title", type: "string", default: "Order Not Found" },
    { key: "errorMessage", label: "Error Message", type: "string", default: "We could not find the order you are looking for." },
    { key: "viewOrderText", label: "View Order Button Text", type: "string", default: "View Order Status" },
    { key: "viewOrderLink", label: "View Order Link", type: "string", default: "/account/orders" },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" }
  ]
}, Ji = {
  type: "product-detail",
  label: "Product Detail",
  description: "The main product information page section.",
  supportedPages: ["product"],
  variants: [
    { id: "v1", label: "V1 (Standard)" },
    { id: "v2", label: "V2 (With Countdown Timer)" },
    { id: "v3", label: "V3 (With Color/Size Swatches)" },
    { id: "v4", label: "Countdown Sale" },
    { id: "v5", label: "Swatches" },
    { id: "v6", label: "Video Gallery" }
  ],
  commonFields: [
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading..." },
    { key: "notFoundCode", label: "Not Found Code", type: "string", default: "404" },
    { key: "notFoundText", label: "Not Found Text", type: "string", default: "Product Not Found" },
    { key: "quantityLabel", label: "Quantity Label", type: "string", default: "Quantity" },
    { key: "addToCartText", label: "Add to Cart Button Text", type: "string", default: "Add to Cart" },
    { key: "orderNowText", label: "Order Now Button Text", type: "string", default: "Buy Now" },
    { key: "productDescTitle", label: "Product Description Accordion Title", type: "string", default: "Product Description" },
    { key: "returnPolicyTitle", label: "Return Policy Accordion Title", type: "string", default: "Return Policy" },
    { key: "countdownLabel", label: "Countdown Label (V2 only)", type: "string", default: "Offer ends in:" },
    { key: "saleEndDate", label: "Sale End Date", type: "string", placeholder: "2025-12-31T23:59:59" },
    { key: "videoUrl", label: "Product Video URL", type: "string", placeholder: "https://..." },
    ...Ee
  ]
}, Dg = {
  type: "mobileBottomNav",
  label: "Mobile Navigation",
  description: "Bottom navigation bar for mobile devices.",
  supportedPages: [...Do],
  variants: [{ id: "v1", label: "V1 (Default)" }],
  commonFields: [
    { key: "active", label: "Show Bottom Nav", type: "boolean" },
    {
      key: "items",
      label: "Nav Items",
      type: "array",
      itemSchema: [
        { key: "label", label: "Label", type: "string" },
        {
          key: "icon",
          label: "Icon Type",
          type: "select",
          options: [
            { label: "Home", value: "home" },
            { label: "Shop (Bag)", value: "shop" },
            { label: "Search", value: "search" },
            { label: "Cart", value: "cart" },
            { label: "User / Account", value: "account" },
            { label: "Heart / Wishlist", value: "heart" },
            { label: "Menu / Hamburger", value: "menu" },
            { label: "Plus / Create", value: "plus" }
          ]
        },
        {
          key: "actionType",
          label: "Action Type",
          type: "select",
          options: [
            { label: "Link (Direct URL)", value: "link" },
            { label: "Open Search Drawer", value: "search" },
            { label: "Open Categories Sidebar", value: "categories" }
          ]
        },
        { key: "href", label: "Target URL", type: "string" },
        { key: "isPrimary", label: "Highlight as Primary (Middle)", type: "boolean" }
      ]
    }
  ]
}, Fg = {
  type: "similar-products",
  label: "Similar Products",
  description: "A row of related products shown on the product page.",
  supportedPages: ["product"],
  variants: [{ id: "v1", label: "V1 (Grid Row)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Similar Products" },
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    ...Ee
  ]
}, Ig = {
  type: "shop-grid",
  label: "Shop Grid",
  description: "Centred boutique listing: occasion pills, a centred toolbar and filters in a slide-in drawer.",
  supportedPages: ["shop", "category", "cart", "checkout", "categories"],
  variants: [
    { id: "v1", label: "V1 (Boutique: centred, filters in a drawer)" },
    { id: "v2", label: "V2 (Same boutique layout)" }
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "initialPriceRange.min", label: "Initial Price Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Initial Price Max", type: "number", default: 5e4 },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "allCategoriesLabel", label: "All Categories Label", type: "string", default: "All" },
    { key: "filtersButtonLabel", label: "Filters Button Label", type: "string", default: "Filters" },
    { key: "showingLabel", label: "Showing Label (prefix)", type: "string", default: "Showing" },
    { key: "productsSuffix", label: "Products Count Suffix", type: "string", default: "Products" },
    { key: "sortNewestLabel", label: "Sort: Newest Label", type: "string", default: "Sort: Newest" },
    { key: "sortOldestLabel", label: "Sort: Oldest Label", type: "string", default: "Sort: Oldest" },
    { key: "sortPriceAscLabel", label: "Sort: Price Low-High Label", type: "string", default: "Price: Low to High" },
    { key: "sortPriceDescLabel", label: "Sort: Price High-Low Label", type: "string", default: "Price: High to Low" },
    { key: "sortNameAscLabel", label: "Sort: Name A-Z Label", type: "string", default: "Name: A-Z" },
    { key: "sortNameDescLabel", label: "Sort: Name Z-A Label", type: "string", default: "Name: Z-A" },
    { key: "activeFiltersLabel", label: "Active Filters Label", type: "string", default: "Active Filters:" },
    { key: "clearAllLabel", label: "Clear All Label", type: "string", default: "Clear All" },
    { key: "noProductsTitle", label: "No Products Title", type: "string", default: "No Products Found" },
    { key: "noProductsMessage", label: "No Products Message", type: "string", default: "We couldn't find any products matching your current filters." },
    { key: "backToAllText", label: "Back to All Products Text", type: "string", default: "Back to All Products" },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "currentSearchLabel", label: "Current Search Label", type: "string", default: "Current Search" },
    { key: "clearSearchLabel", label: "Clear Search Label", type: "string", default: "Clear" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...Ee
  ]
}, Og = {
  type: "wishlist",
  label: "Wishlist Section",
  description: "Displays saved/wishlisted products in a grid layout.",
  supportedPages: ["wishlist"],
  variants: [
    {
      id: "v1",
      label: "V1 (Grid)",
      fields: [
        { key: "title", label: "Page Title", type: "string", default: "My Wishlist" },
        { key: "subtitle", label: "Eyebrow Text", type: "string", default: "Saved items" },
        { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Nothing saved yet" },
        { key: "emptyText", label: "Empty State Description", type: "string", default: "Start exploring and save the items you love." },
        { key: "continueShoppingText", label: "CTA Text", type: "string", default: "Start Shopping" },
        { key: "continueShoppingLink", label: "CTA Link", type: "string", default: "/shop" }
      ]
    }
  ],
  commonFields: []
}, Rg = [
  { key: "text", label: "Message Text", type: "string" },
  { key: "code", label: "Coupon Code (optional)", type: "string" }
], Bg = {
  type: "announcement-bar",
  label: "Announcement Bar",
  description: "A still, centred ribbon for promotions and announcements.",
  supportedPages: [
    "home",
    "shop",
    "product",
    "category",
    "categories",
    "cart",
    "checkout",
    "contact",
    "wishlist"
  ],
  variants: [
    {
      id: "v1",
      label: "V1 — Centred ribbon",
      fields: [
        { key: "items", label: "Announcement Items", type: "array", itemSchema: Rg },
        { key: "bgColor", label: "Background Color", type: "string", default: "#0989FF" },
        { key: "textColor", label: "Text Color", type: "string", default: "#ffffff" }
      ]
    }
  ],
  commonFields: [...Ee]
}, zg = [
  { key: "id", label: "Product ID", type: "string" },
  { key: "name", label: "Product Name", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "originalPrice", label: "Original Price", type: "number" },
  { key: "salePrice", label: "Sale Price", type: "number" },
  { key: "discount", label: "Discount %", type: "number" }
], Vg = {
  type: "flash-sale",
  label: "Flash Sale",
  description: "Festival countdown band with the most discounted products underneath.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "V1 — Festival countdown",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Flash Sale" },
        { key: "endDate", label: "Sale End Date (ISO)", type: "string", placeholder: "2025-12-31T23:59:59" },
        { key: "bgColor", label: "Header Background Color", type: "color", default: "#1a1a2e" },
        { key: "products", label: "Products", type: "array", itemSchema: zg }
      ]
    }
  ],
  commonFields: [...Ee]
}, Wg = [
  { key: "id", label: "Product ID", type: "string" },
  { key: "name", label: "Product Name", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "price", label: "Price", type: "number" },
  { key: "originalPrice", label: "Original Price", type: "number" },
  { key: "badge", label: "Badge Text", type: "string" }
], $g = {
  type: "new-arrivals",
  label: "New Arrivals",
  description: "Horizontal carousel showcasing the latest product arrivals.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "V1 — Embla Carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Fresh styles just landed" },
        { key: "products", label: "Products", type: "array", itemSchema: Wg },
        { key: "slidesPerView", label: "Slides Per View", type: "number", default: 4 }
      ]
    }
  ],
  commonFields: [...Ee]
}, _g = {
  type: "offer-banner",
  label: "Offer Banner",
  description: "Full-width promotional banner with background image and text overlay.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "V1 — Full-Width Promo Banner",
      fields: [
        { key: "image", label: "Background Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "Special Offer" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Get up to 50% off on selected items" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        { key: "overlayOpacity", label: "Overlay Opacity (0–100)", type: "number", default: 50 }
      ]
    }
  ],
  commonFields: [...Ee]
}, Ki = {
  type: "lookbook-banner",
  label: "Lookbook Banner",
  description: "Lookbook — centred arches (V1) or full-width overlay (V2).",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "V1 — Centred arches",
      fields: [
        { key: "image", label: "Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The New Collection" },
        { key: "subtitle", label: "Subtitle", type: "text" },
        { key: "ctaText", label: "Button Text", type: "string", default: "View Lookbook" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v2",
      label: "V2 — Full-Width Collection Banner",
      fields: [
        { key: "image", label: "Background Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The Collection" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Discover the new season" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        { key: "overlayOpacity", label: "Overlay Opacity (0–100)", type: "number", default: 40 }
      ]
    }
  ],
  commonFields: [...Ee]
}, Hr = [
  { key: "image", label: "Image", type: "image" },
  { key: "link", label: "Link URL", type: "string" }
], Hg = {
  type: "instagram-feed",
  label: "Instagram Feed",
  description: "Display a grid of Instagram photos with hover effects.",
  supportedPages: [...Do],
  variants: [
    {
      id: "v1",
      label: "V1 — 5-Column Photo Grid",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle (e.g. @nakshi)", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Hr }
      ]
    },
    {
      id: "v2",
      label: "V2 — 6-Column with Handle Overlay",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Hr }
      ]
    },
    {
      id: "v3",
      label: "V3 — 4-Column Large Tiles",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Hr }
      ]
    },
    {
      id: "v4",
      label: "V4 — Masonry Style with Header",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Hr }
      ]
    }
  ],
  commonFields: [...Ee]
}, Rc = [
  { key: "title", label: "Title", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "excerpt", label: "Excerpt", type: "text" },
  { key: "slug", label: "Slug", type: "string" },
  { key: "date", label: "Date", type: "string" },
  { key: "category", label: "Category", type: "string" }
], Ug = {
  type: "blog",
  label: "Blog Posts",
  description: "Display a grid or list of blog post cards.",
  supportedPages: [...Do],
  variants: [
    {
      id: "v1",
      label: "V1 — 3-column card grid",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: Rc },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: !0 }
      ]
    },
    {
      id: "v2",
      label: "V2 — List Style (Electronics Style)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: Rc },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: !0 }
      ]
    },
    {
      id: "v3",
      label: "Article Detail",
      fields: []
    }
  ],
  commonFields: [
    { key: "source", label: "Posts to show", type: "select", options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." },
    ...Ee
  ]
}, bi = [
  {
    key: "icon",
    label: "Icon",
    type: "select",
    options: [
      { label: "Shipping Truck", value: "shipping" },
      { label: "Return Arrow", value: "refund" },
      { label: "Support Headset", value: "support" },
      { label: "Security Lock", value: "secure" },
      { label: "Gift Box", value: "gift" }
    ],
    default: "shipping"
  },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" }
], Gg = {
  type: "features",
  label: "Features Strip",
  description: "Trust-building feature strip showing shipping, returns, support, and security highlights.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Compact Horizontal Strip",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: bi },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (Light Gray)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" }
          ],
          default: "default"
        }
      ]
    },
    {
      id: "v2",
      label: "V2 — Spaced Cards",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: bi },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (White)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" }
          ],
          default: "default"
        }
      ]
    },
    {
      id: "v3",
      label: "V3 — Jewelry Minimal Centered",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: bi }
      ]
    }
  ],
  commonFields: [...Ee]
}, Bc = [
  { key: "avatar", label: "Avatar Image", type: "image" },
  { key: "name", label: "Name", type: "string" },
  { key: "designation", label: "Designation", type: "string" },
  { key: "review", label: "Review Text", type: "text" },
  { key: "rating", label: "Rating (1–5)", type: "number", default: 5 }
], Yg = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer reviews and social proof section.",
  supportedPages: ["home", "shop"],
  variants: [
    {
      id: "v1",
      label: "V1 — Centered Slider",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "What Our Customers Say" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: Bc }
      ]
    },
    {
      id: "v2",
      label: "V2 — Card Grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Customer Reviews" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: Bc }
      ]
    }
  ],
  commonFields: [...Ee]
}, Xg = {
  type: "cta",
  label: "Call to Action",
  description: "Email subscribe section with a heading, subtitle, and inline form.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Dark Subscribe Banner",
      fields: [
        { key: "title", label: "Heading", type: "string", default: "Subscribe to Our Newsletter" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Get exclusive deals and new arrivals straight to your inbox." },
        { key: "placeholder", label: "Input Placeholder", type: "string", default: "Enter your email address" },
        { key: "buttonText", label: "Button Text", type: "string", default: "Subscribe" },
        { key: "bgColor", label: "Background Color", type: "color" }
      ]
    }
  ],
  commonFields: [...Ee]
}, jg = [
  { key: "logo", label: "Logo Image", type: "image" },
  { key: "name", label: "Brand Name", type: "string" },
  { key: "link", label: "Brand URL", type: "string" }
], qg = {
  type: "brands",
  label: "Brand Logos",
  description: "Display partner or brand logos in a grid or auto-scrolling ticker.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Logo Grid / Ticker",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        {
          key: "layout",
          label: "Layout",
          type: "select",
          options: [
            { label: "Grid", value: "grid" },
            { label: "Auto-scroll Ticker", value: "ticker" }
          ],
          default: "grid"
        },
        { key: "items", label: "Brand Items", type: "array", itemSchema: jg }
      ]
    }
  ],
  commonFields: [...Ee]
}, Zg = [
  { key: "label", label: "Tab Label", type: "string" }
], Jg = {
  type: "product-slider",
  label: "Product Slider",
  description: "A horizontal scrolling product carousel with optional tabs.",
  supportedPages: ["home", "category", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Tabbed carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Featured Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "All Product Shop" },
        { key: "tabs", label: "Tabs", type: "array", itemSchema: Zg }
      ]
    },
    {
      id: "v2",
      label: "V2 — Simple Jewelry Carousel (3-4 cols)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Exquisite Collection" }
      ]
    },
    {
      id: "v3",
      label: "V3 — Beauty Product Carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Skincare & Beauty" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Glow Up Collection" }
      ]
    }
  ],
  commonFields: [...Ee]
}, Kg = {
  type: "product-grid",
  label: "Product Grid",
  description: "A product grid section with multiple layout variants.",
  supportedPages: ["home", "category", "categories", "shop"],
  variants: [
    {
      id: "v1",
      label: "V1 — 4-column grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "All Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Customer Favorite Style" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v2",
      label: "V2 — Featured + List Aside (Week's Featured)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Week's Featured" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Top Picks" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v3",
      label: "V3 — Electronics List View + Sidebar",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Trending Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Electronics" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v4",
      label: "V4 — Gadget Showcase (1 Large + Smaller Cards)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Top Gadgets" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "New Arrivals" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v5",
      label: "V5 — Beauty 4-Col Image-Focused",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Beauty Essentials" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Trending Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v6",
      label: "V6 — Trending List + Special Offer with Countdown",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "This Week's Picks" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Hot Right Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" },
        { key: "offerEndsAt", label: "Offer End Date (ISO string)", type: "string" }
      ]
    }
  ],
  commonFields: [...Ee]
}, Qg = {
  type: "compare",
  label: "Product Comparison",
  description: 'Up to 4 pieces side by side under arched portrait photos: price with the saving and the best price marked, fabric, colour swatches, size, work and other attributes, category and brand, with "Show differences only", add to bag, remove, and "Ask on WhatsApp" when the store has a WhatsApp number.',
  supportedPages: ["compare"],
  variants: [
    {
      id: "v1",
      label: "Table"
    }
  ],
  commonFields: [...Ee]
}, ef = {
  type: "coupon",
  label: "Coupons",
  description: "A grid of coupon cards with discount code, title, description, expiry date, and a copy-to-clipboard button.",
  supportedPages: ["coupon"],
  variants: [
    {
      id: "v1",
      label: "Card Grid"
    }
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Available Coupons" },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Coupon Code", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Description", type: "text" },
        { key: "expiryDate", label: "Expiry Date", type: "string" },
        { key: "discount", label: "Discount (e.g. 20% or Free Shipping)", type: "string" },
        { key: "bgColor", label: "Badge Background Color", type: "color" }
      ]
    },
    ...Ee
  ]
}, tf = {
  type: "recent-products",
  label: "Recently Viewed Products",
  description: "A horizontal slider of products the visitor has recently viewed (stored in localStorage — no API call).",
  supportedPages: ["home", "shop", "product", "category", "cart"],
  variants: [{ id: "v1", label: "V1 (Horizontal Slider)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Recently Viewed" }
  ]
}, af = {
  key: "messages",
  label: "Announcement messages",
  type: "array",
  help: "Shown still and centred above the logo, separated by ✿. Without messages the announcement text is used.",
  itemSchema: [
    { key: "text", label: "Text", type: "localized-string" },
    { key: "link", label: "Link", type: "string" }
  ]
}, of = { key: "badge", label: "Badge", type: "string", placeholder: "New", help: "Small label next to the item." }, rf = { key: "searchPlaceholder", label: "Search label", type: "string", placeholder: "Search" }, lf = (e) => [
  ...e.map((t) => t.key === "type" && t.options && !t.options.some((a) => a.value === "categories") ? { ...t, options: [...t.options, { label: "Shop panel (store categories)", value: "categories" }] } : t),
  of
], nf = {
  ...Zi,
  variants: [
    { id: "v1", label: "Boutique (centred logo, stitched menu band)" },
    { id: "v2", label: "Boutique" },
    { id: "v3", label: "Boutique" },
    { id: "v4", label: "Compact boutique (band hides on scroll)" }
  ],
  commonFields: Zi.commonFields.flatMap((e) => e.key === "topbar" && e.fields ? [{ ...e, fields: [...e.fields, af] }] : e.key === "menu" && e.itemSchema ? [{ ...e, itemSchema: lf(e.itemSchema) }] : e.key === "actions" ? [e, rf] : [e])
}, za = ["home", "shop", "category", "categories", "product", "cart", "blog"], sf = ["truck", "cash", "phone", "shield", "star", "heart", "package", "check", "store", "map-pin", "mail", "sparkle", "clock", "bag", "user", "search", "refresh", "lock", "tag"].map((e) => ({ label: e.replace("-", " "), value: e })), Va = (e = {}) => [
  { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: e.eyebrow ?? "", help: "Small line above the title." },
  { key: "title", label: "Title", type: "localized-string", default: e.title ?? "" },
  { key: "subtitle", label: "Subtitle", type: "localized-text", default: e.subtitle ?? "" }
], Ip = [
  { key: "icon", label: "Icon", type: "icon", default: "check", options: sf },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "body", label: "Text", type: "localized-text" }
], cf = {
  type: "banner-carousel",
  label: "Banner carousel",
  description: "Picture slides (their text is part of the image) crossfading in a square frame, with counter, arrows and pause.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [{ id: "v1", label: "Crossfading slides" }],
  commonFields: [
    { key: "title", label: "Name for screen readers", type: "string", default: "Offers" },
    {
      key: "slides",
      label: "Slides",
      type: "array",
      itemSchema: [
        { key: "image", label: "Picture", type: "image", required: !0, help: "Square, about 1200 × 1200 px." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional." },
        { key: "alt", label: "Picture description", type: "string", help: "What the banner says, for screen readers." },
        { key: "link", label: "Link", type: "string", placeholder: "/shop" }
      ],
      default: []
    },
    { key: "autoplay", label: "Play automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 5, dependency: { field: "autoplay", value: !0 } }
  ]
}, df = {
  type: "category-bento",
  label: "Category mosaic",
  description: "Photo tiles linking to categories: the tiles you list, else the store’s categories.",
  supportedPages: za,
  variants: [
    { id: "v1", label: "V1 — Row of photo tiles" },
    { id: "v2", label: "V2 — Lookbook mosaic (first tile large)" }
  ],
  commonFields: [
    ...Va({ eyebrow: "Browse", title: "Shop by category" }),
    {
      key: "tiles",
      label: "Tiles",
      type: "array",
      help: "Empty = the store’s categories.",
      itemSchema: [
        { key: "categoryId", label: "Category", type: "category-select", help: "Sets the link, name and picture unless filled below." },
        { key: "title", label: "Name", type: "localized-string" },
        { key: "tagline", label: "Tagline (mosaic)", type: "localized-string" },
        { key: "image", label: "Picture", type: "image" },
        { key: "link", label: "Link", type: "string", placeholder: "/category/…" }
      ],
      default: []
    },
    { key: "limit", label: "Categories shown (automatic tiles)", type: "number", default: 8 }
  ]
}, pf = {
  type: "combo-spotlight",
  label: "Product spotlight",
  description: "One product or bundle as an editorial spread: large photo, price, saving and Add to bag.",
  supportedPages: za,
  variants: [{ id: "v1", label: "Editorial spread" }],
  commonFields: [
    ...Va({ eyebrow: "Festive pick", title: "Saree of the week" }),
    { key: "productId", label: "Product", type: "product-select", help: "Hidden until a product is picked." },
    { key: "description", label: "Text", type: "localized-text", default: "" },
    { key: "mrpLabel", label: "Regular price label", type: "localized-string", default: "Regular price" },
    { key: "savingLabel", label: "Saving label", type: "localized-string", default: "You save" },
    { key: "detailsLabel", label: "Details link text", type: "localized-string", default: "View details" }
  ]
}, uf = {
  type: "corporate-band",
  label: "Bulk order band",
  description: "An ink band with a short pitch and one button, e.g. for team, event or wholesale orders.",
  supportedPages: za,
  variants: [{ id: "v1", label: "Ink band" }],
  commonFields: [
    ...Va({ eyebrow: "For weddings", title: "Family and wedding orders" }).filter((e) => e.key !== "subtitle"),
    { key: "text", label: "Text", type: "localized-text", default: "Dressing the whole family for a wedding or Eid? Get matching sets and family pricing." },
    { key: "cta.label", label: "Button text", type: "localized-string", default: "Contact us" },
    { key: "cta.url", label: "Button link", type: "string", default: "/contact" }
  ]
}, yf = {
  type: "product-rail",
  label: "Product rail",
  description: "Product cards from new arrivals, deals, a category or your own pick, as a grid or a swipe row.",
  supportedPages: za,
  variants: [{ id: "v1", label: "Product cards" }],
  commonFields: [
    ...Va({ eyebrow: "Fresh from the loom", title: "New arrivals" }),
    { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 8 } },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [
        { label: "Grid (four up)", value: "grid" },
        { label: "Swipe row", value: "rail" }
      ],
      default: "grid"
    },
    { key: "showViewAll", label: "Show “View all”", type: "boolean", default: !0 },
    { key: "viewAllLabel", label: "“View all” text", type: "string", default: "View all", dependency: { field: "showViewAll", value: !0 } }
  ]
}, hf = {
  type: "promises",
  label: "Promises strip",
  description: "Two to four store promises in a hairline-ruled row: icon, title and a short line.",
  supportedPages: za,
  variants: [{ id: "v1", label: "Ruled row" }],
  commonFields: [
    ...Va(),
    {
      key: "items",
      label: "Promises",
      type: "array",
      itemSchema: Ip,
      default: [
        { icon: "truck", title: "Fast delivery", body: "Quick delivery across the city." },
        { icon: "cash", title: "Pay on delivery", body: "Pay in cash when your order arrives." },
        { icon: "refresh", title: "Easy returns", body: "Wrong size? Swap it within 7 days." },
        { icon: "phone", title: "Here to help", body: "Call or message us any day." }
      ]
    }
  ]
}, bf = {
  type: "reviews",
  label: "Customer reviews",
  description: "A swipe row of quote cards: rating, title, quote, name and the product. Store reviews replace these once available.",
  supportedPages: za,
  variants: [{ id: "v1", label: "Quote cards" }],
  commonFields: [
    ...Va({ eyebrow: "Reviews", title: "What our customers say" }),
    {
      key: "items",
      label: "Reviews",
      type: "array",
      help: "Real reviews from your customers, with their permission.",
      itemSchema: [
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "body", label: "Review", type: "localized-text" },
        { key: "name", label: "Customer name", type: "string" },
        { key: "productId", label: "Product", type: "product-select" }
      ],
      default: []
    },
    { key: "limit", label: "Most reviews shown", type: "number", default: 6 },
    { key: "minRating", label: "Lowest rating shown (store reviews)", type: "number", default: 4 }
  ]
}, mf = [
  ...Ip,
  { key: "image", label: "Swatch picture (fabric story)", type: "image", help: "Close-up of the weave, portrait. Without one a woven pattern is drawn." },
  { key: "link", label: "Link (fabric story)", type: "string", placeholder: "/shop?search=jamdani" }
], gf = {
  type: "story",
  label: "Story band",
  description: "A 4:5 photo beside the heading and two to four numbered points, with an optional button.",
  supportedPages: za,
  variants: [{ id: "v1", label: "Photo and numbered points" }, { id: "v2", label: "Fabric story (arched swatches)" }],
  commonFields: [
    ...Va({ eyebrow: "Our story", title: "Woven by hand, worn with pride" }),
    { key: "image", label: "Picture", type: "image", help: "Portrait, 4:5." },
    {
      key: "points",
      label: "Points",
      type: "array",
      itemSchema: mf,
      default: [
        { icon: "sparkle", title: "Artisan made", body: "Every piece comes from weavers in Narayanganj, Tangail and Rajshahi." },
        { icon: "shield", title: "Pure fabrics", body: "Real jamdani, muslin, katan and soft cotton, checked before it ships." },
        { icon: "truck", title: "Fast shipping", body: "Packed the same day, at your door soon after." }
      ]
    },
    { key: "ctaLabel", label: "Button text", type: "localized-string", default: "" },
    { key: "ctaLink", label: "Button link", type: "string", default: "" }
  ]
}, ff = {
  key: "gallery",
  label: "Mosaic pictures",
  type: "array",
  help: "Up to two (split) or three (full width) extra pictures shown as a mosaic with the main picture.",
  itemSchema: [
    { key: "image", label: "Picture", type: "image" },
    { key: "alt", label: "Description (alt text)", type: "string" },
    { key: "link", label: "Link", type: "string" }
  ]
}, vf = {
  ...Ki,
  variants: Ki.variants.map((e) => ({ ...e, fields: [...e.fields ?? [], ff] }))
}, kf = {
  ...Ji,
  commonFields: [
    ...Ji.commonFields,
    { key: "sizeGuideTitle", label: "Size guide link and title", type: "string", default: "Size guide" },
    { key: "sizeGuide", label: "Size guide", type: "rich-text", help: "Measurements table or fit notes, opened from a link beside the size selector. Hidden while empty." },
    { key: "completeTheLookTitle", label: '"Complete the look" title', type: "string", default: "Complete the look", help: "Other products from the same category, shown under the product." },
    { key: "showFabric", label: "Show fabric chip", type: "boolean", default: !0, help: "From the product Fabric attribute (Jamdani, Muslin, Katan, Cotton…)." },
    { key: "sareeDetails", label: "Saree details", type: "rich-text", default: "<p>Length 5.5 m with a 0.8 m unstitched blouse piece.</p>", help: "Shown under the description. Hidden while empty." },
    { key: "careNotes", label: "Care notes", type: "rich-text", default: "<p>Dry clean only. Store folded in muslin cloth, away from damp.</p>" },
    { key: "whatsappOrderLabel", label: "WhatsApp order button", type: "localized-string", default: "Order on WhatsApp", help: "Uses the store WhatsApp number. Hidden when none is set." },
    { key: "showDeliveryAreas", label: "Show delivery areas and charges", type: "boolean", default: !0 }
  ]
}, wf = {
  ...ji,
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Sign in" },
    { key: "intro", label: "Intro text", type: "text", default: "Sign in or create an account with your mobile number." },
    ...ji.commonFields
  ]
}, Sf = {
  ...qi,
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Create account" },
    { key: "intro", label: "Intro text", type: "text", default: "Create your account with your mobile number." },
    ...qi.commonFields
  ]
}, zc = {
  componentSchemas: {
    "banner-carousel": cf,
    "category-bento": df,
    "combo-spotlight": pf,
    "corporate-band": uf,
    "product-rail": yf,
    promises: hf,
    reviews: bf,
    story: gf,
    "lookbook-banner": vf,
    "product-detail": kf,
    signin: wf,
    signup: Sf
  },
  chrome: {
    headerSchema: nf
  }
}, Vc = {
  componentSchemas: {
    account: mg,
    signin: ji,
    signup: qi,
    banner: kg,
    cart: wg,
    categories: Sg,
    category: xg,
    checkout: Tg,
    contact: Cg,
    content: Pg,
    "featured-category": Ag,
    hero: Ng,
    "order-success": Eg,
    "product-detail": Ji,
    "similar-products": Fg,
    "shop-grid": Ig,
    wishlist: Og,
    "announcement-bar": Bg,
    "flash-sale": Vg,
    "new-arrivals": $g,
    "offer-banner": _g,
    "lookbook-banner": Ki,
    "instagram-feed": Hg,
    blog: Ug,
    features: Gg,
    testimonials: Yg,
    cta: Xg,
    brands: qg,
    "product-slider": Jg,
    "product-grid": Kg,
    compare: Qg,
    coupon: ef,
    "recent-products": tf
  },
  headerSchema: Zi,
  footerSchema: Mg,
  floatingButtonsSchema: Lg,
  mobileNavSchema: Dg
}, xf = ht({
  ...Vc,
  componentSchemas: { ...Vc.componentSchemas, ...zc.componentSchemas },
  ...zc.chrome
}, bg), Tf = {
  account: { hide: ["signinRedirectPath"] },
  "announcement-bar": { hide: ["bgColor", "textColor"] },
  cart: { hide: ["loadingText", "taxLabel", "secureCheckoutText"] },
  category: { hide: ["productCardVariant", "initialPriceRange", "showBreadcrumb"] },
  checkout: { hide: ["loadingText", "shippingCalculatingText", "securePaymentText"] },
  cta: { hide: ["bgColor"] },
  "featured-category": { hide: ["productCardVariant", "noSelectionText", "noProductsText"] },
  features: { hide: ["bgStyle"] },
  "flash-sale": { hide: ["bgColor", "products"] },
  "new-arrivals": { hide: ["products"] },
  "order-success": { hide: ["loadingText"] },
  "product-detail": { hide: ["loadingText", "notFoundCode", "notFoundText"], keep: ["v1", "v2", "v3", "v6"], variantLabels: { v1: "Standard", v2: "Sale countdown band", v3: "Large photo swatches", v6: "Video under the photo" } },
  "shop-grid": { hide: ["productCardVariant", "initialPriceRange", "sortOldestLabel", "sortNameDescLabel"] },
  "similar-products": { hide: ["productCardVariant"] },
  blog: { keep: ["v1", "v2"] },
  coupon: { hide: ["coupons[].bgColor"] },
  header: { hide: ["topbar[].phone", "topbar[].email", "topbar[].showSocials", "topbar[].socialLinks"], keep: ["v1", "v2"], variantLabels: { v1: "One row", v2: "Menu on a second row" } },
  footer: { hide: ["paymentMethods[].icon"], variantLabels: { v1: "Three columns", v2: "Compact" } },
  // Theme tab: button settings no part of this theme reads (colours drive every primary button via the CTA).
  buttons: { hide: ["appearance.buttons.primary[].radius", "appearance.buttons.primary[].height", "appearance.buttons.primary[].paddingX", "appearance.buttons.primary[].label", "appearance.buttons.outline[].radius", "appearance.buttons.outline[].height", "appearance.buttons.outline[].paddingX", "appearance.buttons.outline[].label", "appearance.buttons.outline[].hoverBg"] },
  // Delivery time is shown on product cards only by Prottoho.
  "store-info": { hide: ["deliveryEta"] }
}, Cf = {
  type: "account",
  label: "Account Section",
  description: "User dashboard with orders, addresses, and profile settings.",
  supportedPages: ["account"],
  variants: [
    { id: "v1", label: "V1 (Sidebar + Content)" },
    { id: "v2", label: "Order History" },
    { id: "v3", label: "Address Book" }
  ],
  commonFields: [
    { key: "tabOverviewLabel", label: "Overview Tab Label", type: "string", default: "Overview" },
    { key: "tabOrdersLabel", label: "Orders Tab Label", type: "string", default: "Orders" },
    { key: "tabAddressesLabel", label: "Addresses Tab Label", type: "string", default: "Addresses" },
    { key: "tabDetailsLabel", label: "Profile Tab Label", type: "string", default: "Profile" },
    { key: "signOutLabel", label: "Sign Out Label", type: "string", default: "Sign Out" },
    { key: "signinRedirectPath", label: "Sign In Redirect Path", type: "string", default: "/signin" }
  ]
}, Qi = {
  type: "signin",
  label: "Signin Section",
  description: "Login form with phone/OTP flow and two-column layout.",
  supportedPages: ["signin"],
  variants: [{ id: "v1", label: "V1 (Two Column)" }],
  commonFields: [
    { key: "redirectUrl", label: "Redirect After Login", type: "string", default: "/account" }
  ]
}, en = {
  type: "signup",
  label: "Signup Section",
  description: "Registration form with phone/OTP flow and two-column layout.",
  supportedPages: ["signup"],
  variants: [{ id: "v2", label: "V2 (Two Column)" }],
  commonFields: [
    { key: "redirectUrl", label: "Redirect After Signup", type: "string", default: "/account" }
  ]
}, Fo = [
  "home",
  "shop",
  "product",
  "category",
  "categories",
  "cart",
  "checkout",
  "contact",
  "signin",
  "signup",
  "account",
  "wishlist",
  "track-order",
  "order-success",
  "privacy-policy",
  "terms-of-service",
  "shipping-policy",
  "return-policy",
  "order-detail"
], gl = [
  { key: "id", label: "ID", type: "string" },
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link", type: "string" }
], Pf = [
  { key: "id", label: "ID", type: "string" },
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link URL", type: "string" },
  {
    key: "type",
    label: "Type",
    type: "select",
    options: [
      { label: "Standard Link", value: "link" },
      { label: "Dropdown", value: "dropdown" },
      { label: "Mega Menu", value: "mega-menu" }
    ]
  },
  {
    key: "children",
    label: "Dropdown Items",
    type: "array",
    itemSchema: gl,
    dependency: { field: "type", value: "dropdown" }
  },
  {
    key: "columns",
    label: "Mega Menu Columns",
    type: "array",
    itemSchema: [
      { key: "title", label: "Column Title", type: "string" },
      { key: "items", label: "Links", type: "array", itemSchema: gl }
    ],
    dependency: { field: "type", value: "mega-menu" }
  },
  {
    key: "featuredImage",
    label: "Featured Image",
    type: "object",
    fields: [
      { key: "src", label: "Image", type: "image" },
      { key: "title", label: "Title", type: "string" },
      { key: "href", label: "Link", type: "string" }
    ],
    dependency: { field: "type", value: "mega-menu" }
  }
], Ur = [
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "text" },
  { key: "image", label: "Background Image", type: "image" },
  { key: "ctaText", label: "Button Text", type: "string" },
  { key: "ctaLink", label: "Button Link", type: "string" },
  { key: "badge", label: "Badge Text", type: "string" }
], De = [
  {
    key: "styles.paddingTop",
    label: "Padding Top",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.paddingBottom",
    label: "Padding Bottom",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.background",
    label: "Background",
    type: "select",
    options: [
      { label: "None (theme default)", value: "default" },
      { label: "Light grey", value: "muted" },
      { label: "Brand tint", value: "primary" }
    ],
    default: "default"
  }
], Af = [
  {
    key: "icon",
    label: "Icon (truck | shield | lock)",
    type: "string"
  },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" }
], Lf = [
  { key: "image", label: "Picture", type: "image", help: "Wide, about 1200 × 525 px; may carry its own artwork." },
  { key: "title", label: "Caption title (optional)", type: "string" },
  { key: "subtitle", label: "Caption line (optional)", type: "string" },
  { key: "ctaText", label: "Link text (optional)", type: "string" },
  { key: "ctaLink", label: "Link", type: "string" }
], Mf = {
  type: "banner",
  label: "Banner Section",
  description: "Promo feature strip or side-by-side image banners.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "Selling points strip",
      fields: [
        { key: "columns", label: "Feature Columns", type: "array", itemSchema: Af }
      ]
    },
    {
      id: "v2",
      label: "Two picture banners",
      fields: [
        { key: "banners", label: "Promo Banners (max 2)", type: "array", itemSchema: Lf }
      ]
    }
  ],
  commonFields: [...De]
}, Nf = {
  type: "cart",
  label: "Cart Section",
  description: "The shopping cart page section.",
  supportedPages: ["cart"],
  variants: [{ id: "v1", label: "V1 (Apparels)" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Shopping Cart" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading cart items..." },
    { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty State Message", type: "string", default: "Browse our products and add items to your cart." },
    { key: "continueShoppingText", label: "Continue Shopping Button Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingLabel", label: "Shipping Label", type: "string", default: "Shipping" },
    { key: "shippingCalculatedText", label: "Shipping Calculated Text", type: "string", default: "Calculated at checkout" },
    { key: "taxLabel", label: "Tax Label", type: "string", default: "Tax" },
    { key: "totalLabel", label: "Total Label", type: "string", default: "Total" },
    { key: "checkoutButtonText", label: "Checkout Button Text", type: "string", default: "Proceed to Checkout" },
    { key: "checkoutLink", label: "Checkout Link", type: "string", default: "/checkout" },
    { key: "secureCheckoutText", label: "Secure Checkout Label", type: "string", default: "SSL Secure Checkout" }
  ]
}, Ef = {
  type: "categories",
  label: "Categories",
  description: "Category photo tiles, or a slim shortcut strip of top categories with a promo line.",
  supportedPages: ["home", "categories", "shop"],
  variants: [
    {
      id: "v1",
      label: "Photo tiles",
      fields: [
        { key: "subtitle", label: "Subtitle", type: "string" },
        {
          key: "columns",
          label: "Columns",
          type: "select",
          options: [
            { label: "2 Columns", value: 2 },
            { label: "3 Columns", value: 3 },
            { label: "4 Columns", value: 4 },
            { label: "5 Columns", value: 5 },
            { label: "6 Columns", value: 6 }
          ],
          default: 4
        },
        { key: "emptyText", label: "Empty Text", type: "string", default: "No categories found." }
      ]
    },
    {
      id: "v2",
      label: "Shortcut strip",
      fields: [
        { key: "limit", label: "Categories shown", type: "number", default: 3, help: "Your first top-level categories." },
        { key: "promoText", label: "Promo line", type: "string", default: "Cash on delivery all over the country" },
        { key: "promoLink", label: "Promo link", type: "string", placeholder: "/shop" }
      ]
    }
  ],
  commonFields: [
    { key: "title", label: "Title (strip: the label on the left)", type: "string" },
    ...De
  ]
}, Df = {
  type: "category",
  label: "Category Listing",
  description: "Single category page: breadcrumb, header, product grid with filters.",
  supportedPages: ["category", "shop"],
  variants: [{ id: "v1", label: "V1 (Sidebar + Grid)" }],
  commonFields: [
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "initialPriceRange.min", label: "Price Range Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Price Range Max", type: "number", default: 5e4 },
    { key: "showBreadcrumb", label: "Show Breadcrumb", type: "boolean", default: !0 },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...De
  ]
}, Ff = {
  type: "checkout",
  label: "Checkout Section",
  description: "The order checkout page section.",
  supportedPages: ["checkout"],
  variants: [{ id: "v1", label: "V1 (Apparels)" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Checkout" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Preparing checkout..." },
    { key: "emptyTitle", label: "Empty Cart Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty Cart Message", type: "string", default: "Checkout is only available for shopping carts with items." },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingChargeLabel", label: "Shipping Charge Label", type: "string", default: "Shipping Charge" },
    { key: "shippingCalculatingText", label: "Shipping Calculating Text", type: "string", default: "Calculating..." },
    { key: "totalLabel", label: "Total Amount Label", type: "string", default: "Total Amount" },
    { key: "placeOrderText", label: "Place Order Button Text", type: "string", default: "Place Order" },
    { key: "placingOrderText", label: "Placing Order Loading Text", type: "string", default: "Placing Order..." },
    { key: "securePaymentText", label: "Secure Payment Label", type: "string", default: "SSL Secure Payment" }
  ]
}, If = {
  type: "contact",
  label: "Contact Section",
  description: "Two-column contact page with form and info panel.",
  supportedPages: ["contact"],
  variants: [{ id: "v1", label: "V1 (Split Layout)" }],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    { key: "email", label: "Email Address", type: "string" },
    { key: "phone", label: "Phone Number", type: "string" },
    { key: "address", label: "Physical Address", type: "text" }
  ]
}, Of = {
  type: "content",
  label: "Content / Policy Section",
  description: "Generic rich-text section for policies and descriptions.",
  supportedPages: ["privacy-policy", "terms-of-service", "shipping-policy", "return-policy"],
  variants: [
    { id: "v1", label: "V1 (Clean Layout)" },
    { id: "v2", label: "V2 (With Table of Contents)" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "content", label: "HTML Content", type: "rich-text" }
  ]
}, Rf = {
  type: "featured-category",
  label: "Featured Category",
  description: "A collection block: one tall captioned tile for a category beside a grid of its products and a View more tile.",
  supportedPages: ["home", "product", "cart"],
  variants: [
    { id: "v1", label: "Big tile left" },
    { id: "v2", label: "Big tile right" }
  ],
  commonFields: [
    { key: "categoryId", label: "Select Category", type: "category-select" },
    { key: "title", label: "Tile caption", type: "string", help: "Empty = the category name. With no category picked, the category with this exact name is shown." },
    { key: "subtitle", label: "Line above the caption", type: "string" },
    { key: "image", label: "Tile picture", type: "image", help: "Portrait. Empty = the category picture." },
    { key: "rows", label: "Rows of products (four each)", type: "number", default: 2 },
    { key: "viewAllText", label: "Last tile text", type: "string", default: "View more" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "noSelectionText", label: "No Category Selected Text", type: "string", default: "Please select a category in the editor settings." },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    ...De
  ]
}, Bf = {
  type: "floating-buttons",
  label: "Floating Buttons",
  description: "Global floating buttons for quick actions (Call, WhatsApp, Messenger).",
  supportedPages: [...Fo],
  variants: [{ id: "v1", label: "Default" }],
  commonFields: [
    { key: "active", label: "Enable Floating Buttons", type: "boolean", default: !0 },
    { key: "phone", label: "Phone Number", type: "string", placeholder: "+8801..." },
    { key: "whatsapp", label: "WhatsApp Number", type: "string", placeholder: "+8801..." },
    { key: "messenger", label: "Messenger ID/Link", type: "string", placeholder: "m.me/..." },
    { key: "callUsTitle", label: "Call Button Tooltip", type: "string", default: "Call Us" },
    { key: "whatsappTitle", label: "WhatsApp Button Tooltip", type: "string", default: "WhatsApp" },
    { key: "messengerTitle", label: "Messenger Button Tooltip", type: "string", default: "Messenger" }
  ]
}, zf = {
  type: "footer",
  label: "Footer",
  description: "Site-wide footer with links, newsletter, and contact info.",
  supportedPages: [...Fo],
  variants: [
    { id: "v1", label: "Dark (Default)" },
    { id: "v2", label: "Light" }
  ],
  commonFields: [
    { key: "logo", label: "Footer Logo", type: "image" },
    { key: "title", label: "Brand Name", type: "string", default: "Tanabana" },
    {
      key: "description",
      label: "Brand Description",
      type: "text",
      default: "Your destination for premium fashion and lifestyle products. Curated styles for the modern wardrobe."
    },
    {
      key: "columns",
      label: "Link Columns",
      type: "array",
      itemSchema: [
        { key: "title", label: "Column Title", type: "string" },
        { key: "links", label: "Links", type: "array", itemSchema: gl }
      ]
    },
    {
      key: "socialLinks",
      label: "Social Links",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Facebook", value: "facebook" },
            { label: "Instagram", value: "instagram" },
            { label: "Twitter", value: "twitter" },
            { label: "YouTube", value: "youtube" },
            { label: "LinkedIn", value: "linkedin" }
          ]
        },
        { key: "href", label: "Link", type: "string" }
      ]
    },
    { key: "contactAddress", label: "Address", type: "string" },
    { key: "contactPhone", label: "Phone", type: "string" },
    { key: "contactEmail", label: "Email", type: "string" },
    {
      key: "newsletterAction",
      label: "Newsletter form URL",
      type: "string",
      placeholder: "https://…",
      help: "Where the email sign-up is sent (your mailing-list provider's form). The sign-up only shows when this is set."
    },
    {
      key: "note",
      label: "Bottom bar message",
      type: "string",
      placeholder: "Packed with care and delivered to your door.",
      help: "One line above the copyright."
    },
    { key: "copyright", label: "Copyright Text", type: "string", default: "© 2025 Tanabana. All rights reserved." },
    {
      key: "paymentMethods",
      label: "Payment Methods",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Visa", value: "visa" },
            { label: "Mastercard", value: "mastercard" },
            { label: "Amex", value: "amex" },
            { label: "Stripe", value: "stripe" },
            { label: "PayPal", value: "paypal" },
            { label: "bKash", value: "bkash" },
            { label: "Nagad", value: "nagad" },
            { label: "Rocket", value: "rocket" }
          ]
        },
        { key: "icon", label: "Icon URL (optional)", type: "string" }
      ]
    }
  ]
}, tn = {
  type: "header",
  label: "Header",
  description: "Site-wide header with navigation, search, and cart.",
  supportedPages: [...Fo],
  variants: [
    { id: "v1", label: "Fashion (Default)" },
    { id: "v2", label: "Electronics" },
    { id: "v3", label: "Beauty / Minimal" },
    { id: "v4", label: "Jewelry / Elegant" }
  ],
  commonFields: [
    { key: "logo.alt", label: "Logo Alt Text", type: "string" },
    { key: "logo.src", label: "Logo Image", type: "image" },
    { key: "sticky", label: "Sticky Header", type: "boolean", default: !0 },
    {
      key: "topbar",
      label: "Top Bar",
      type: "object",
      fields: [
        { key: "active", label: "Enable Top Bar", type: "boolean", default: !0 },
        {
          key: "variant",
          label: "Variant",
          type: "select",
          options: [
            { label: "V1 (Centered Promo)", value: "v1" },
            { label: "V2 (Contact & Socials)", value: "v2" }
          ],
          default: "v1"
        },
        { key: "text", label: "Announcement Text", type: "string" },
        { key: "phone", label: "Phone Number", type: "string" },
        { key: "email", label: "Email Address", type: "string" },
        { key: "showSocials", label: "Show Social Icons", type: "boolean", default: !0 },
        {
          key: "socialLinks",
          label: "Social Links",
          type: "array",
          itemSchema: [
            { key: "platform", label: "Platform", type: "string" },
            { key: "href", label: "Link", type: "string" },
            { key: "icon", label: "Icon Name", type: "string" }
          ]
        },
        { key: "links", label: "Top Bar Links", type: "array", itemSchema: gl }
      ]
    },
    {
      key: "actions",
      label: "Actions",
      type: "object",
      fields: [
        { key: "showSearch", label: "Show Search", type: "boolean", default: !0 },
        { key: "showCart", label: "Show Cart", type: "boolean", default: !0 },
        { key: "showAccount", label: "Show Account", type: "boolean", default: !0 },
        { key: "showWishlist", label: "Show Wishlist", type: "boolean", default: !0 },
        {
          key: "cartAction",
          label: "Cart Action",
          type: "select",
          options: [
            { label: "Slide-out Sidebar", value: "sidebar" },
            { label: "Go to Page", value: "page" }
          ],
          default: "sidebar"
        }
      ]
    },
    {
      key: "searchConfig",
      label: "Search Settings",
      type: "object",
      fields: [
        { key: "showPrice", label: "Show Price in Suggestions", type: "boolean", default: !0 },
        { key: "showCategory", label: "Show Category in Suggestions", type: "boolean", default: !0 },
        { key: "showImage", label: "Show Image in Suggestions", type: "boolean", default: !0 },
        { key: "maxResults", label: "Max Suggestions", type: "number", default: 6 }
      ]
    },
    { key: "menu", label: "Main Menu", type: "array", itemSchema: Pf }
  ]
}, Vf = {
  type: "hero",
  label: "Hero Section",
  description: "The main attention-grabbing section at the top of the page.",
  supportedPages: ["home", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Fashion Full-Height Slider",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: Ur },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    },
    {
      id: "v2",
      label: "V2 — Electronics Two-Column Slider",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: Ur },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    },
    {
      id: "v3",
      label: "V3 — Beauty Gradient Hero",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: Ur }
      ]
    },
    {
      id: "v4",
      label: "V4 — Jewelry Dark Elegant Hero",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: Ur }
      ]
    }
  ],
  commonFields: [...De]
}, Wf = {
  type: "order-success",
  label: "Order Success Section",
  description: "The order confirmation page section.",
  supportedPages: ["order-success"],
  variants: [{ id: "v1", label: "V1 (Apparels)" }],
  commonFields: [
    { key: "title", label: "Success Title", type: "string", default: "Order Confirmed" },
    { key: "message", label: "Success Message", type: "text", default: "Your order has been placed successfully. We have sent a confirmation email with your order details." },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading order details..." },
    { key: "errorTitle", label: "Error Title", type: "string", default: "Order Not Found" },
    { key: "errorMessage", label: "Error Message", type: "string", default: "We could not find the order you are looking for." },
    { key: "viewOrderText", label: "View Order Button Text", type: "string", default: "View Order Status" },
    { key: "viewOrderLink", label: "View Order Link", type: "string", default: "/account/orders" },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" }
  ]
}, an = {
  type: "product-detail",
  label: "Product Detail",
  description: "The main product information page section.",
  supportedPages: ["product"],
  variants: [
    { id: "v1", label: "V1 (Standard)" },
    { id: "v2", label: "V2 (With Countdown Timer)" },
    { id: "v3", label: "V3 (With Color/Size Swatches)" },
    { id: "v4", label: "Countdown Sale" },
    { id: "v5", label: "Swatches" },
    { id: "v6", label: "Video Gallery" }
  ],
  commonFields: [
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading..." },
    { key: "notFoundCode", label: "Not Found Code", type: "string", default: "404" },
    { key: "notFoundText", label: "Not Found Text", type: "string", default: "Product Not Found" },
    { key: "quantityLabel", label: "Quantity Label", type: "string", default: "Quantity" },
    { key: "addToCartText", label: "Add to Cart Button Text", type: "string", default: "Add to Cart" },
    { key: "orderNowText", label: "Order Now Button Text", type: "string", default: "Buy Now" },
    { key: "productDescTitle", label: "Product Description Accordion Title", type: "string", default: "Product Description" },
    { key: "returnPolicyTitle", label: "Return Policy Accordion Title", type: "string", default: "Return Policy" },
    { key: "countdownLabel", label: "Countdown Label (V2 only)", type: "string", default: "Offer ends in:" },
    { key: "saleEndDate", label: "Sale End Date", type: "string", placeholder: "2025-12-31T23:59:59" },
    { key: "videoUrl", label: "Product Video URL", type: "string", placeholder: "https://..." },
    ...De
  ]
}, $f = {
  type: "mobileBottomNav",
  label: "Mobile Navigation",
  description: "Bottom navigation bar for mobile devices.",
  supportedPages: [...Fo],
  variants: [{ id: "v1", label: "V1 (Default)" }],
  commonFields: [
    { key: "active", label: "Show Bottom Nav", type: "boolean" },
    {
      key: "items",
      label: "Nav Items",
      type: "array",
      itemSchema: [
        { key: "label", label: "Label", type: "string" },
        {
          key: "icon",
          label: "Icon Type",
          type: "select",
          options: [
            { label: "Home", value: "home" },
            { label: "Shop (Bag)", value: "shop" },
            { label: "Search", value: "search" },
            { label: "Cart", value: "cart" },
            { label: "User / Account", value: "account" },
            { label: "Heart / Wishlist", value: "heart" },
            { label: "Chat (WhatsApp)", value: "chat" },
            { label: "Menu / Hamburger", value: "menu" },
            { label: "Plus / Create", value: "plus" }
          ]
        },
        {
          key: "actionType",
          label: "Action Type",
          type: "select",
          options: [
            { label: "Link (Direct URL)", value: "link" },
            { label: "Open Search Drawer", value: "search" },
            { label: "Open Categories Sidebar", value: "categories" }
          ]
        },
        { key: "href", label: "Target URL", type: "string" },
        { key: "isPrimary", label: "Highlight as Primary (Middle)", type: "boolean" }
      ]
    }
  ]
}, _f = {
  type: "similar-products",
  label: "Similar Products",
  description: "A row of related products shown on the product page.",
  supportedPages: ["product"],
  variants: [{ id: "v1", label: "V1 (Grid Row)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Similar Products" },
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    ...De
  ]
}, Hf = {
  type: "shop-grid",
  label: "Shop Grid",
  description: "The main product list with sidebar filters.",
  supportedPages: ["shop", "category", "cart", "checkout", "categories"],
  variants: [
    { id: "v1", label: "V1 (Left Sidebar + Grid)" },
    { id: "v2", label: "V2 (Full-width Grid, Slide-in Filters)" }
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "initialPriceRange.min", label: "Initial Price Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Initial Price Max", type: "number", default: 5e4 },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "allCategoriesLabel", label: "All Categories Label", type: "string", default: "All" },
    { key: "filtersButtonLabel", label: "Filters Button Label", type: "string", default: "Filters" },
    { key: "showingLabel", label: "Showing Label (prefix)", type: "string", default: "Showing" },
    { key: "productsSuffix", label: "Products Count Suffix", type: "string", default: "Products" },
    { key: "sortNewestLabel", label: "Sort: Newest Label", type: "string", default: "Sort: Newest" },
    { key: "sortOldestLabel", label: "Sort: Oldest Label", type: "string", default: "Sort: Oldest" },
    { key: "sortPriceAscLabel", label: "Sort: Price Low-High Label", type: "string", default: "Price: Low to High" },
    { key: "sortPriceDescLabel", label: "Sort: Price High-Low Label", type: "string", default: "Price: High to Low" },
    { key: "sortNameAscLabel", label: "Sort: Name A-Z Label", type: "string", default: "Name: A-Z" },
    { key: "sortNameDescLabel", label: "Sort: Name Z-A Label", type: "string", default: "Name: Z-A" },
    { key: "activeFiltersLabel", label: "Active Filters Label", type: "string", default: "Active Filters:" },
    { key: "clearAllLabel", label: "Clear All Label", type: "string", default: "Clear All" },
    { key: "noProductsTitle", label: "No Products Title", type: "string", default: "No Products Found" },
    { key: "noProductsMessage", label: "No Products Message", type: "string", default: "We couldn't find any products matching your current filters." },
    { key: "backToAllText", label: "Back to All Products Text", type: "string", default: "Back to All Products" },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "currentSearchLabel", label: "Current Search Label", type: "string", default: "Current Search" },
    { key: "clearSearchLabel", label: "Clear Search Label", type: "string", default: "Clear" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...De
  ]
}, Uf = {
  type: "wishlist",
  label: "Wishlist Section",
  description: "Displays saved/wishlisted products in a grid layout.",
  supportedPages: ["wishlist"],
  variants: [
    {
      id: "v1",
      label: "V1 (Grid)",
      fields: [
        { key: "title", label: "Page Title", type: "string", default: "My Wishlist" },
        { key: "subtitle", label: "Eyebrow Text", type: "string", default: "Saved items" },
        { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Nothing saved yet" },
        { key: "emptyText", label: "Empty State Description", type: "string", default: "Start exploring and save the items you love." },
        { key: "continueShoppingText", label: "CTA Text", type: "string", default: "Start Shopping" },
        { key: "continueShoppingLink", label: "CTA Link", type: "string", default: "/shop" }
      ]
    }
  ],
  commonFields: []
}, Gf = [
  { key: "lead", label: "Lead word (optional)", type: "string", placeholder: "Free delivery" },
  { key: "text", label: "Message Text", type: "string" },
  { key: "code", label: "Coupon Code (optional)", type: "string" },
  { key: "linkLabel", label: "Link text", type: "string", placeholder: "Click here" },
  { key: "link", label: "Link (optional)", type: "string", placeholder: "/shop" }
], Yf = {
  type: "announcement-bar",
  label: "Announcement Bar",
  description: "Info bar inside the page: a bold lead word, one line and a link (several messages take turns).",
  supportedPages: [
    "home",
    "shop",
    "product",
    "category",
    "categories",
    "cart",
    "checkout",
    "contact",
    "wishlist"
  ],
  variants: [
    {
      id: "v1",
      label: "Info bar",
      fields: [
        { key: "items", label: "Announcement Items", type: "array", itemSchema: Gf },
        { key: "bgColor", label: "Background Color", type: "string", default: "#0989FF" },
        { key: "textColor", label: "Text Color", type: "string", default: "#ffffff" }
      ]
    }
  ],
  commonFields: [...De]
}, Xf = [
  { key: "id", label: "Product ID", type: "string" },
  { key: "name", label: "Product Name", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "originalPrice", label: "Original Price", type: "number" },
  { key: "salePrice", label: "Sale Price", type: "number" },
  { key: "discount", label: "Discount %", type: "number" }
], jf = {
  type: "flash-sale",
  label: "Flash Sale",
  description: "Countdown timer with a horizontal product row for time-limited offers.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "V1 — Countdown + Product Row",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Flash Sale" },
        { key: "endDate", label: "Sale End Date (ISO)", type: "string", placeholder: "2025-12-31T23:59:59" },
        { key: "bgColor", label: "Header Background Color", type: "color", default: "#1a1a2e" },
        { key: "products", label: "Products", type: "array", itemSchema: Xf }
      ]
    }
  ],
  commonFields: [...De]
}, qf = [
  { key: "id", label: "Product ID", type: "string" },
  { key: "name", label: "Product Name", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "price", label: "Price", type: "number" },
  { key: "originalPrice", label: "Original Price", type: "number" },
  { key: "badge", label: "Badge Text", type: "string" }
], Zf = {
  type: "new-arrivals",
  label: "New Arrivals",
  description: "A grid of the newest products: square photos, six across, with name and price.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "Photo grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Fresh styles just landed" },
        { key: "products", label: "Products", type: "array", itemSchema: qf },
        { key: "limit", label: "Products shown", type: "number", default: 12, help: "Six fill one row on desktop." },
        { key: "showDetails", label: "Show name and price", type: "boolean", default: !0 }
      ]
    }
  ],
  commonFields: [...De]
}, Jf = {
  type: "offer-banner",
  label: "Offer Banner",
  description: "A mint banner with a headline, a line and a button, and an optional picture on the right.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "Mint banner",
      fields: [
        { key: "image", label: "Picture (optional)", type: "image" },
        { key: "title", label: "Title", type: "string", default: "Special Offer" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Get up to 50% off on selected items" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" }
      ]
    }
  ],
  commonFields: [...De]
}, on = {
  type: "lookbook-banner",
  label: "Lookbook Banner",
  description: "Editorial banner — split image/text (V1) or full-width overlay (V2).",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "V1 — Editorial Split (Image + Text)",
      fields: [
        { key: "image", label: "Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The New Collection" },
        { key: "subtitle", label: "Subtitle", type: "text" },
        { key: "ctaText", label: "Button Text", type: "string", default: "View Lookbook" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        {
          key: "imagePosition",
          label: "Image Position",
          type: "select",
          options: [
            { label: "Left", value: "left" },
            { label: "Right", value: "right" }
          ],
          default: "left"
        }
      ]
    },
    {
      id: "v2",
      label: "V2 — Full-Width Collection Banner",
      fields: [
        { key: "image", label: "Background Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The Collection" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Discover the new season" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        { key: "overlayOpacity", label: "Overlay Opacity (0–100)", type: "number", default: 40 }
      ]
    }
  ],
  commonFields: [...De]
}, Gr = [
  { key: "image", label: "Image", type: "image" },
  { key: "link", label: "Link URL", type: "string" }
], Kf = {
  type: "instagram-feed",
  label: "Instagram Feed",
  description: "Display a grid of Instagram photos with hover effects.",
  supportedPages: [...Fo],
  variants: [
    {
      id: "v1",
      label: "V1 — 5-Column Photo Grid",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle (e.g. @yourstore)", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Gr }
      ]
    },
    {
      id: "v2",
      label: "V2 — 6-Column with Handle Overlay",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Gr }
      ]
    },
    {
      id: "v3",
      label: "V3 — 4-Column Large Tiles",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Gr }
      ]
    },
    {
      id: "v4",
      label: "V4 — Masonry Style with Header",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Gr }
      ]
    }
  ],
  commonFields: [...De]
}, Wc = [
  { key: "title", label: "Title", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "excerpt", label: "Excerpt", type: "text" },
  { key: "slug", label: "Slug", type: "string" },
  { key: "date", label: "Date", type: "string" },
  { key: "category", label: "Category", type: "string" }
], Qf = {
  type: "blog",
  label: "Blog Posts",
  description: "Display a grid or list of blog post cards.",
  supportedPages: [...Fo],
  variants: [
    {
      id: "v1",
      label: "V1 — 3-Column Card Grid (Fashion Style)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: Wc },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: !0 }
      ]
    },
    {
      id: "v2",
      label: "V2 — List Style (Electronics Style)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: Wc },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: !0 }
      ]
    },
    {
      id: "v3",
      label: "Article Detail",
      fields: []
    }
  ],
  commonFields: [
    { key: "source", label: "Posts to show", type: "select", options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." },
    ...De
  ]
}, mi = [
  {
    key: "icon",
    label: "Icon",
    type: "select",
    options: [
      { label: "Shipping Truck", value: "shipping" },
      { label: "Return Arrow", value: "refund" },
      { label: "Support Headset", value: "support" },
      { label: "Security Lock", value: "secure" },
      { label: "Gift Box", value: "gift" }
    ],
    default: "shipping"
  },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" }
], ev = {
  type: "features",
  label: "Features Strip",
  description: "Trust-building feature strip showing shipping, returns, support, and security highlights.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Compact Horizontal Strip",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: mi },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (Light Gray)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" }
          ],
          default: "default"
        }
      ]
    },
    {
      id: "v2",
      label: "V2 — Spaced Cards",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: mi },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (White)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" }
          ],
          default: "default"
        }
      ]
    },
    {
      id: "v3",
      label: "V3 — Jewelry Minimal Centered",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: mi }
      ]
    }
  ],
  commonFields: [...De]
}, $c = [
  { key: "avatar", label: "Avatar Image", type: "image" },
  { key: "name", label: "Name", type: "string" },
  { key: "designation", label: "Designation", type: "string" },
  { key: "review", label: "Review Text", type: "text" },
  { key: "rating", label: "Rating (1–5)", type: "number", default: 5 }
], tv = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer reviews and social proof section.",
  supportedPages: ["home", "shop"],
  variants: [
    {
      id: "v1",
      label: "V1 — Centered Slider",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "What Our Customers Say" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: $c }
      ]
    },
    {
      id: "v2",
      label: "V2 — Card Grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Customer Reviews" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: $c }
      ]
    }
  ],
  commonFields: [...De]
}, av = {
  type: "cta",
  label: "Call to Action",
  description: "A full-width picture banner with a link, and optional text on a mint band.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "Picture banner",
      fields: [
        { key: "image", label: "Picture", type: "image", help: "Wide, about 1240 × 200 px; may carry its own artwork." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional, about 780 × 340 px." },
        { key: "link", label: "Link", type: "string", default: "/contact" },
        { key: "title", label: "Heading (optional)", type: "string", default: "Become a reseller" },
        { key: "subtitle", label: "Line (optional)", type: "string", default: "Sell our clothes and earn on every order." },
        { key: "buttonText", label: "Button text (optional)", type: "string", default: "Join now" }
      ]
    }
  ],
  commonFields: [...De]
}, ov = [
  { key: "logo", label: "Logo Image", type: "image" },
  { key: "name", label: "Brand Name", type: "string" },
  { key: "link", label: "Brand URL", type: "string" }
], rv = {
  type: "brands",
  label: "Brand Logos",
  description: "An intro line, then partner or brand logos in a carousel with arrows or an auto-scrolling strip.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "Logos",
      fields: [
        { key: "title", label: "Intro line", type: "string" },
        { key: "subtitle", label: "Paragraph", type: "string" },
        {
          key: "layout",
          label: "Layout",
          type: "select",
          options: [
            { label: "Carousel with arrows", value: "grid" },
            { label: "Auto-scroll Ticker", value: "ticker" }
          ],
          default: "grid"
        },
        { key: "items", label: "Brand Items", type: "array", itemSchema: ov }
      ]
    }
  ],
  commonFields: [...De]
}, lv = [
  { key: "label", label: "Tab Label", type: "string" }
], iv = {
  type: "product-slider",
  label: "Product Slider",
  description: "A horizontal scrolling product carousel with optional tabs.",
  supportedPages: ["home", "category", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Tabbed Fashion Carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Featured Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "All Product Shop" },
        { key: "tabs", label: "Tabs", type: "array", itemSchema: lv }
      ]
    },
    {
      id: "v2",
      label: "V2 — Simple Jewelry Carousel (3-4 cols)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Exquisite Collection" }
      ]
    },
    {
      id: "v3",
      label: "V3 — Beauty Product Carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Skincare & Beauty" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Glow Up Collection" }
      ]
    }
  ],
  commonFields: [...De]
}, nv = {
  type: "product-grid",
  label: "Product Grid",
  description: "A product grid section with multiple layout variants.",
  supportedPages: ["home", "category", "categories", "shop"],
  variants: [
    {
      id: "v1",
      label: "V1 — 4-Col Standard Grid (Fashion)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "All Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Customer Favorite Style" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v2",
      label: "V2 — Featured + List Aside (Week's Featured)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Week's Featured" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Top Picks" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v3",
      label: "V3 — Electronics List View + Sidebar",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Trending Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Electronics" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v4",
      label: "V4 — Gadget Showcase (1 Large + Smaller Cards)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Top Gadgets" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "New Arrivals" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v5",
      label: "V5 — Beauty 4-Col Image-Focused",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Beauty Essentials" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Trending Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v6",
      label: "V6 — Trending List + Special Offer with Countdown",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "This Week's Picks" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Hot Right Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" },
        { key: "offerEndsAt", label: "Offer End Date (ISO string)", type: "string" }
      ]
    }
  ],
  commonFields: [...De]
}, sv = {
  type: "compare",
  label: "Product Comparison",
  description: "A lookbook line sheet comparing up to 4 pieces side by side: 3:4 photo, brand and name, sale price with % off (cheapest marked), colour swatches, size chips, fit, fabric and other attributes, category and brand, a show-differences-only switch, Add to bag and remove.",
  supportedPages: ["compare"],
  variants: [
    {
      id: "v1",
      label: "Table"
    }
  ],
  commonFields: [...De]
}, cv = {
  type: "coupon",
  label: "Coupons",
  description: "A grid of coupon cards with discount code, title, description, expiry date, and a copy-to-clipboard button.",
  supportedPages: ["coupon"],
  variants: [
    {
      id: "v1",
      label: "Card Grid"
    }
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Available Coupons" },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Coupon Code", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Description", type: "text" },
        { key: "expiryDate", label: "Expiry Date", type: "string" },
        { key: "discount", label: "Discount (e.g. 20% or Free Shipping)", type: "string" },
        { key: "bgColor", label: "Badge Background Color", type: "color" }
      ]
    },
    ...De
  ]
}, dv = {
  type: "recent-products",
  label: "Recently Viewed Products",
  description: "A horizontal slider of products the visitor has recently viewed (stored in localStorage — no API call).",
  supportedPages: ["home", "shop", "product", "category", "cart"],
  variants: [{ id: "v1", label: "V1 (Horizontal Slider)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Recently Viewed" }
  ]
}, pv = {
  key: "messages",
  label: "Marquee messages",
  type: "array",
  help: "Scroll across the top in a loop. Without messages the announcement text is used.",
  itemSchema: [
    { key: "text", label: "Text", type: "localized-string" },
    { key: "link", label: "Link", type: "string" }
  ]
}, uv = { key: "badge", label: "Badge", type: "string", placeholder: "New", help: "Small label next to the item." }, yv = { key: "searchPlaceholder", label: "Search label", type: "string", placeholder: "Search" }, hv = (e) => [
  ...e.map((t) => t.key === "type" && t.options && !t.options.some((a) => a.value === "categories") ? { ...t, options: [...t.options, { label: "Shop panel (store categories)", value: "categories" }] } : t),
  uv
], bv = {
  ...tn,
  commonFields: tn.commonFields.flatMap((e) => e.key === "topbar" && e.fields ? [{ ...e, fields: [...e.fields, pv] }] : e.key === "menu" && e.itemSchema ? [{ ...e, itemSchema: hv(e.itemSchema) }] : e.key === "actions" ? [e, yv] : [e])
}, Wa = ["home", "shop", "category", "categories", "product", "cart", "blog"], mv = ["truck", "cash", "phone", "shield", "star", "heart", "package", "check", "store", "map-pin", "mail", "sparkle", "clock", "bag", "user", "search", "refresh", "lock", "tag"].map((e) => ({ label: e.replace("-", " "), value: e })), $a = (e = {}) => [
  { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: e.eyebrow ?? "", help: "Small line above the title." },
  { key: "title", label: "Title", type: "localized-string", default: e.title ?? "" },
  { key: "subtitle", label: "Subtitle", type: "localized-text", default: e.subtitle ?? "" }
], Op = [
  { key: "icon", label: "Icon", type: "icon", default: "check", options: mv },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "body", label: "Text", type: "localized-text" }
], gv = {
  type: "banner-carousel",
  label: "Banner carousel",
  description: "Full-width photo slides with an optional short title, line and up to two buttons over the photo; counter, arrows and pause.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [{ id: "v1", label: "Full-width photo slides" }],
  commonFields: [
    { key: "title", label: "Name for screen readers", type: "string", default: "Offers" },
    {
      key: "slides",
      label: "Slides",
      type: "array",
      itemSchema: [
        { key: "image", label: "Picture", type: "image", required: !0, help: "Wide, about 1920 × 550 px." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional, about 780 × 600 px." },
        { key: "alt", label: "Picture description", type: "string", help: "What the picture shows, for screen readers." },
        { key: "title", label: "Title over the photo", type: "string", help: "Optional, a few words." },
        { key: "subtitle", label: "Line under the title", type: "string" },
        { key: "ctaText", label: "Button text", type: "string" },
        { key: "ctaLink", label: "Button link", type: "string", placeholder: "/shop" },
        { key: "cta2Text", label: "Second button text", type: "string" },
        { key: "cta2Link", label: "Second button link", type: "string", placeholder: "/categories" },
        { key: "link", label: "Link of the whole slide", type: "string", placeholder: "/shop", help: "Used when the slide has no button." }
      ],
      default: []
    },
    { key: "autoplay", label: "Play automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 5, dependency: { field: "autoplay", value: !0 } }
  ]
}, fv = {
  type: "category-bento",
  label: "Category mosaic",
  description: "Tall photo tiles linking to categories, the name over the foot of each: the tiles you list, else the store’s categories.",
  supportedPages: Wa,
  variants: [
    { id: "v1", label: "Three-column photo tiles" },
    { id: "v2", label: "Mosaic (first tile large)" }
  ],
  commonFields: [
    ...$a(),
    {
      key: "tiles",
      label: "Tiles",
      type: "array",
      help: "Empty = the store’s categories.",
      itemSchema: [
        { key: "categoryId", label: "Category", type: "category-select", help: "Sets the link, name and picture unless filled below." },
        { key: "title", label: "Name", type: "localized-string" },
        { key: "tagline", label: "Tagline (mosaic)", type: "localized-string" },
        { key: "image", label: "Picture", type: "image" },
        { key: "link", label: "Link", type: "string", placeholder: "/category/…" }
      ],
      default: []
    },
    { key: "limit", label: "Categories shown (automatic tiles)", type: "number", default: 6 }
  ]
}, vv = {
  type: "combo-spotlight",
  label: "Product spotlight",
  description: "One product or bundle on a card: large photo, price, saving and Add to bag.",
  supportedPages: Wa,
  variants: [{ id: "v1", label: "Photo and details card" }],
  commonFields: [
    ...$a({ eyebrow: "Combo deal", title: "Pick of the week" }),
    { key: "productId", label: "Product", type: "product-select", help: "Hidden until a product is picked." },
    { key: "description", label: "Text", type: "localized-text", default: "" },
    { key: "mrpLabel", label: "Regular price label", type: "localized-string", default: "Regular price" },
    { key: "savingLabel", label: "Saving label", type: "localized-string", default: "You save" },
    { key: "detailsLabel", label: "Details link text", type: "localized-string", default: "View details" }
  ]
}, kv = {
  type: "corporate-band",
  label: "Bulk order band",
  description: "A grey box with a linked title, a short pitch and a few product pictures, e.g. for bulk, team or wholesale orders.",
  supportedPages: Wa,
  variants: [{ id: "v1", label: "Grey box with pictures" }],
  commonFields: [
    ...$a({ title: "Bulk order / wholesale" }).filter((e) => e.key !== "subtitle"),
    { key: "text", label: "Text", type: "localized-text", default: "Plain or printed T-shirts and polos for your team, school or event, at wholesale prices and with no minimum order." },
    { key: "cta.url", label: "Title link", type: "string", default: "/contact" },
    {
      key: "images",
      label: "Pictures",
      type: "array",
      help: "Up to six, square.",
      itemSchema: [
        { key: "image", label: "Picture", type: "image" },
        { key: "alt", label: "Picture description", type: "string" }
      ],
      default: []
    }
  ]
}, wv = {
  type: "product-rail",
  label: "Product rail",
  description: "Product cards from new arrivals, deals, a category or your own pick, as a grid or a swipe row.",
  supportedPages: Wa,
  variants: [{ id: "v1", label: "Product cards" }],
  commonFields: [
    ...$a({ eyebrow: "Just dropped", title: "New arrivals" }),
    { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 8 } },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [
        { label: "Grid (four up)", value: "grid" },
        { label: "Swipe row", value: "rail" }
      ],
      default: "grid"
    },
    { key: "showViewAll", label: "Show “View all”", type: "boolean", default: !0 },
    { key: "viewAllLabel", label: "“View all” text", type: "string", default: "View all", dependency: { field: "showViewAll", value: !0 } }
  ]
}, Sv = {
  type: "promises",
  label: "Promises strip",
  description: "Two to four store promises on a grey band: icon, title and a short line.",
  supportedPages: Wa,
  variants: [{ id: "v1", label: "Grey band" }],
  commonFields: [
    ...$a(),
    {
      key: "items",
      label: "Promises",
      type: "array",
      itemSchema: Op,
      default: [
        { icon: "truck", title: "Fast delivery", body: "Quick delivery across the city." },
        { icon: "cash", title: "Pay on delivery", body: "Pay in cash when your order arrives." },
        { icon: "refresh", title: "Easy returns", body: "Wrong size? Swap it within 7 days." },
        { icon: "phone", title: "Here to help", body: "Call or message us any day." }
      ]
    }
  ]
}, xv = {
  type: "reviews",
  label: "Customer reviews",
  description: "A swipe row of quote cards: rating, title, quote, name and the product. Store reviews replace these once available.",
  supportedPages: Wa,
  variants: [{ id: "v1", label: "Quote cards" }],
  commonFields: [
    ...$a({ title: "What our customers say" }),
    {
      key: "items",
      label: "Reviews",
      type: "array",
      help: "Real reviews from your customers, with their permission.",
      itemSchema: [
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "body", label: "Review", type: "localized-text" },
        { key: "name", label: "Customer name", type: "string" },
        { key: "productId", label: "Product", type: "product-select" }
      ],
      default: []
    },
    { key: "limit", label: "Most reviews shown", type: "number", default: 6 },
    { key: "minRating", label: "Lowest rating shown (store reviews)", type: "number", default: 4 }
  ]
}, Tv = {
  type: "story",
  label: "Story band",
  description: "A text column (linked title, bold line, paragraph, short points) beside a photo.",
  supportedPages: Wa,
  variants: [{ id: "v1", label: "Text beside a photo" }],
  commonFields: [
    ...$a({ title: "Our story", subtitle: "Comfortable clothes you can wear every day." }).map((e) => e.key === "subtitle" ? { ...e, label: "Bold line" } : e),
    { key: "text", label: "Paragraph", type: "localized-text", default: "We choose soft, breathable fabrics, check every stitch and size, and price fairly, so your everyday clothes look good and last." },
    { key: "image", label: "Picture", type: "image", help: "Landscape, about 16:10." },
    {
      key: "points",
      label: "Points",
      type: "array",
      itemSchema: Op,
      help: "Optional, up to four.",
      default: []
    },
    { key: "ctaLink", label: "Title link", type: "string", default: "/about", help: "The title links here; the link text below uses it too." },
    { key: "ctaLabel", label: "Link text (under the paragraph)", type: "localized-string", default: "" }
  ]
}, Cv = {
  key: "gallery",
  label: "Mosaic pictures",
  type: "array",
  help: "Up to two (split) or three (full width) extra pictures shown as a mosaic with the main picture.",
  itemSchema: [
    { key: "image", label: "Picture", type: "image" },
    { key: "alt", label: "Description (alt text)", type: "string" },
    { key: "link", label: "Link", type: "string" }
  ]
}, Pv = {
  ...on,
  variants: on.variants.map((e) => ({ ...e, fields: [...e.fields ?? [], Cv] }))
}, Av = {
  ...an,
  commonFields: [
    ...an.commonFields,
    { key: "sizeGuideTitle", label: "Size chart title and link", type: "string", default: "Size chart" },
    { key: "sizeGuide", label: "Size guide", type: "rich-text", help: "Measurements table or fit notes, shown in the product card (a link beside the sizes jumps to it). Two tables, inches then centimetres, get Inch / CM tabs. Hidden while empty." },
    { key: "completeTheLookTitle", label: '"Complete the look" title', type: "string", default: "Complete the look", help: "Up to three other products from the same category, shown under the photos with an Add to cart button." },
    { key: "showDeliveryAreas", label: "Show delivery areas and charges", type: "boolean", default: !0 }
  ]
}, Lv = {
  ...Qi,
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Sign in" },
    { key: "intro", label: "Intro text", type: "text", default: "Sign in or create an account with your mobile number." },
    ...Qi.commonFields
  ]
}, Mv = {
  ...en,
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Create account" },
    { key: "intro", label: "Intro text", type: "text", default: "Create your account with your mobile number." },
    ...en.commonFields
  ]
}, _c = {
  componentSchemas: {
    "banner-carousel": gv,
    "category-bento": fv,
    "combo-spotlight": vv,
    "corporate-band": kv,
    "product-rail": wv,
    promises: Sv,
    reviews: xv,
    story: Tv,
    "lookbook-banner": Pv,
    "product-detail": Av,
    signin: Lv,
    signup: Mv
  },
  chrome: {
    headerSchema: bv
  }
}, Hc = {
  componentSchemas: {
    account: Cf,
    signin: Qi,
    signup: en,
    banner: Mf,
    cart: Nf,
    categories: Ef,
    category: Df,
    checkout: Ff,
    contact: If,
    content: Of,
    "featured-category": Rf,
    hero: Vf,
    "order-success": Wf,
    "product-detail": an,
    "similar-products": _f,
    "shop-grid": Hf,
    wishlist: Uf,
    "announcement-bar": Yf,
    "flash-sale": jf,
    "new-arrivals": Zf,
    "offer-banner": Jf,
    "lookbook-banner": on,
    "instagram-feed": Kf,
    blog: Qf,
    features: ev,
    testimonials: tv,
    cta: av,
    brands: rv,
    "product-slider": iv,
    "product-grid": nv,
    compare: sv,
    coupon: cv,
    "recent-products": dv
  },
  headerSchema: tn,
  footerSchema: zf,
  floatingButtonsSchema: Bf,
  mobileNavSchema: $f
}, Nv = ht({
  ...Hc,
  componentSchemas: { ...Hc.componentSchemas, ..._c.componentSchemas },
  ..._c.chrome
}, Tf), Ev = {
  account: { hide: ["signinRedirectPath"] },
  "announcement-bar": { hide: ["bgColor", "textColor"] },
  cart: { hide: ["loadingText", "taxLabel", "secureCheckoutText"] },
  category: { hide: ["productCardVariant", "initialPriceRange", "showBreadcrumb"] },
  checkout: { hide: ["loadingText", "shippingCalculatingText", "securePaymentText"] },
  cta: { hide: ["bgColor"] },
  "featured-category": { hide: ["productCardVariant", "noSelectionText", "noProductsText"] },
  features: { hide: ["bgStyle"] },
  hero: { variantLabels: { v1: "Full-bleed photo", v2: "Split", v3: "Poster", v4: "Charcoal" } },
  "flash-sale": { hide: ["bgColor", "products"] },
  "new-arrivals": { hide: ["products"] },
  "order-success": { hide: ["loadingText"] },
  "product-detail": { hide: ["loadingText", "notFoundCode", "notFoundText"], keep: ["v1", "v2", "v3", "v6"], variantLabels: { v1: "Standard", v2: "Sale countdown band", v3: "Large photo swatches", v6: "Video under the photo" } },
  "shop-grid": { hide: ["productCardVariant", "initialPriceRange", "sortOldestLabel", "sortNameDescLabel"] },
  "similar-products": { hide: ["productCardVariant"] },
  blog: { keep: ["v1", "v2"] },
  coupon: { hide: ["coupons[].bgColor"] },
  header: { hide: ["topbar[].phone", "topbar[].email", "topbar[].showSocials", "topbar[].socialLinks"], keep: ["v1", "v2"], variantLabels: { v1: "One row", v2: "Menu on a second row" } },
  footer: { hide: ["paymentMethods[].icon"], variantLabels: { v1: "Product lists", v2: "Compact" } },
  // Theme tab: button settings no part of this theme reads (colours drive every primary button via the CTA).
  buttons: { hide: ["appearance.buttons.primary[].radius", "appearance.buttons.primary[].height", "appearance.buttons.primary[].paddingX", "appearance.buttons.primary[].label", "appearance.buttons.outline[].radius", "appearance.buttons.outline[].height", "appearance.buttons.outline[].paddingX", "appearance.buttons.outline[].label", "appearance.buttons.outline[].hoverBg"] },
  // Delivery time is shown on product cards only by Prottoho.
  "store-info": { hide: ["deliveryEta"] }
}, Dv = {
  type: "account",
  label: "Account Section",
  description: "User dashboard with orders, addresses, and profile settings.",
  supportedPages: ["account"],
  variants: [
    { id: "v1", label: "V1 (Sidebar + Content)" },
    { id: "v2", label: "Order History" },
    { id: "v3", label: "Address Book" }
  ],
  commonFields: [
    { key: "tabOverviewLabel", label: "Overview Tab Label", type: "string", default: "Overview" },
    { key: "tabOrdersLabel", label: "Orders Tab Label", type: "string", default: "Orders" },
    { key: "tabAddressesLabel", label: "Addresses Tab Label", type: "string", default: "Addresses" },
    { key: "tabDetailsLabel", label: "Profile Tab Label", type: "string", default: "Profile" },
    { key: "signOutLabel", label: "Sign Out Label", type: "string", default: "Sign Out" },
    { key: "signinRedirectPath", label: "Sign In Redirect Path", type: "string", default: "/signin" }
  ]
}, rn = {
  type: "signin",
  label: "Signin Section",
  description: "Login form with phone/OTP flow and two-column layout.",
  supportedPages: ["signin"],
  variants: [{ id: "v1", label: "V1 (Two Column)" }],
  commonFields: [
    { key: "redirectUrl", label: "Redirect After Login", type: "string", default: "/account" }
  ]
}, ln = {
  type: "signup",
  label: "Signup Section",
  description: "Registration form with phone/OTP flow and two-column layout.",
  supportedPages: ["signup"],
  variants: [{ id: "v2", label: "V2 (Two Column)" }],
  commonFields: [
    { key: "redirectUrl", label: "Redirect After Signup", type: "string", default: "/account" }
  ]
}, Io = [
  "home",
  "shop",
  "product",
  "category",
  "categories",
  "cart",
  "checkout",
  "contact",
  "signin",
  "signup",
  "account",
  "wishlist",
  "track-order",
  "order-success",
  "privacy-policy",
  "terms-of-service",
  "shipping-policy",
  "return-policy",
  "order-detail"
], fl = [
  { key: "id", label: "ID", type: "string" },
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link", type: "string" }
], Fv = [
  { key: "id", label: "ID", type: "string" },
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link URL", type: "string" },
  {
    key: "type",
    label: "Type",
    type: "select",
    options: [
      { label: "Standard Link", value: "link" },
      { label: "Dropdown", value: "dropdown" },
      { label: "Mega Menu", value: "mega-menu" }
    ]
  },
  {
    key: "children",
    label: "Dropdown Items",
    type: "array",
    itemSchema: fl,
    dependency: { field: "type", value: "dropdown" }
  },
  {
    key: "columns",
    label: "Mega Menu Columns",
    type: "array",
    itemSchema: [
      { key: "title", label: "Column Title", type: "string" },
      { key: "items", label: "Links", type: "array", itemSchema: fl }
    ],
    dependency: { field: "type", value: "mega-menu" }
  },
  {
    key: "featuredImage",
    label: "Featured Image",
    type: "object",
    fields: [
      { key: "src", label: "Image", type: "image" },
      { key: "title", label: "Title", type: "string" },
      { key: "href", label: "Link", type: "string" }
    ],
    dependency: { field: "type", value: "mega-menu" }
  }
], Yr = [
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "text" },
  { key: "image", label: "Background Image", type: "image" },
  { key: "ctaText", label: "Button Text", type: "string" },
  { key: "ctaLink", label: "Button Link", type: "string" },
  { key: "badge", label: "Badge Text", type: "string" }
], Fe = [
  {
    key: "styles.paddingTop",
    label: "Padding Top",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.paddingBottom",
    label: "Padding Bottom",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.background",
    label: "Background",
    type: "select",
    options: [
      { label: "None (theme default)", value: "default" },
      { label: "Light grey", value: "muted" },
      { label: "Brand tint", value: "primary" }
    ],
    default: "default"
  }
], Iv = [
  {
    key: "icon",
    label: "Icon (truck | shield | lock)",
    type: "string"
  },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" }
], Ov = [
  { key: "image", label: "Picture", type: "image", help: "Wide, about 1200 × 525 px; may carry its own artwork." },
  { key: "title", label: "Caption title (optional)", type: "string" },
  { key: "subtitle", label: "Caption line (optional)", type: "string" },
  { key: "ctaText", label: "Link text (optional)", type: "string" },
  { key: "ctaLink", label: "Link", type: "string" }
], Rv = [
  { key: "image", label: "Picture", type: "image", help: "Square, about 800 × 800 px; may carry its own artwork." },
  { key: "alt", label: "Picture description", type: "string", help: "What the picture shows, for screen readers." },
  { key: "title", label: "Title over the picture (optional)", type: "string" },
  { key: "ctaLink", label: "Link", type: "string", placeholder: "/shop" }
], Bv = {
  type: "banner",
  label: "Banner Section",
  description: "Promo feature strip, side-by-side image banners or a row of square picture tiles.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "Selling points strip",
      fields: [
        { key: "columns", label: "Feature Columns", type: "array", itemSchema: Iv }
      ]
    },
    {
      id: "v2",
      label: "Two picture banners",
      fields: [
        { key: "banners", label: "Promo Banners (max 2)", type: "array", itemSchema: Ov }
      ]
    },
    {
      id: "v3",
      label: "Square picture tiles",
      fields: [
        { key: "title", label: "Section title", type: "string" },
        { key: "banners", label: "Picture tiles (up to 4)", type: "array", itemSchema: Rv }
      ]
    }
  ],
  commonFields: [...Fe]
}, zv = {
  type: "cart",
  label: "Cart Section",
  description: "The shopping cart page section.",
  supportedPages: ["cart"],
  variants: [{ id: "v1", label: "V1 (Apparels)" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Shopping Cart" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading cart items..." },
    { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty State Message", type: "string", default: "Browse our products and add items to your cart." },
    { key: "continueShoppingText", label: "Continue Shopping Button Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingLabel", label: "Shipping Label", type: "string", default: "Shipping" },
    { key: "shippingCalculatedText", label: "Shipping Calculated Text", type: "string", default: "Calculated at checkout" },
    { key: "taxLabel", label: "Tax Label", type: "string", default: "Tax" },
    { key: "totalLabel", label: "Total Label", type: "string", default: "Total" },
    { key: "checkoutButtonText", label: "Checkout Button Text", type: "string", default: "Proceed to Checkout" },
    { key: "checkoutLink", label: "Checkout Link", type: "string", default: "/checkout" },
    { key: "secureCheckoutText", label: "Secure Checkout Label", type: "string", default: "SSL Secure Checkout" }
  ]
}, Vv = {
  type: "categories",
  label: "Categories",
  description: "Category photo tiles, or a slim shortcut strip of top categories with a promo line.",
  supportedPages: ["home", "categories", "shop"],
  variants: [
    {
      id: "v1",
      label: "Photo tiles",
      fields: [
        { key: "subtitle", label: "Subtitle", type: "string" },
        {
          key: "columns",
          label: "Columns",
          type: "select",
          options: [
            { label: "2 Columns", value: 2 },
            { label: "3 Columns", value: 3 },
            { label: "4 Columns", value: 4 },
            { label: "5 Columns", value: 5 },
            { label: "6 Columns", value: 6 }
          ],
          default: 4
        },
        { key: "emptyText", label: "Empty Text", type: "string", default: "No categories found." }
      ]
    },
    {
      id: "v2",
      label: "Shortcut strip",
      fields: [
        { key: "limit", label: "Categories shown", type: "number", default: 3, help: "Your first top-level categories." },
        { key: "promoText", label: "Promo line", type: "string", default: "Cash on delivery all over the country" },
        { key: "promoLink", label: "Promo link", type: "string", placeholder: "/shop" }
      ]
    }
  ],
  commonFields: [
    { key: "title", label: "Title (strip: the label on the left)", type: "string" },
    ...Fe
  ]
}, Wv = {
  type: "category",
  label: "Category Listing",
  description: "Single category page: breadcrumb, header, product grid with filters.",
  supportedPages: ["category", "shop"],
  variants: [{ id: "v1", label: "V1 (Sidebar + Grid)" }],
  commonFields: [
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "initialPriceRange.min", label: "Price Range Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Price Range Max", type: "number", default: 5e4 },
    { key: "showBreadcrumb", label: "Show Breadcrumb", type: "boolean", default: !0 },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...Fe
  ]
}, $v = {
  type: "checkout",
  label: "Checkout Section",
  description: "The order checkout page section.",
  supportedPages: ["checkout"],
  variants: [{ id: "v1", label: "V1 (Apparels)" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Checkout" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Preparing checkout..." },
    { key: "emptyTitle", label: "Empty Cart Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty Cart Message", type: "string", default: "Checkout is only available for shopping carts with items." },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingChargeLabel", label: "Shipping Charge Label", type: "string", default: "Shipping Charge" },
    { key: "shippingCalculatingText", label: "Shipping Calculating Text", type: "string", default: "Calculating..." },
    { key: "totalLabel", label: "Total Amount Label", type: "string", default: "Total Amount" },
    { key: "placeOrderText", label: "Place Order Button Text", type: "string", default: "Place Order" },
    { key: "placingOrderText", label: "Placing Order Loading Text", type: "string", default: "Placing Order..." },
    { key: "securePaymentText", label: "Secure Payment Label", type: "string", default: "SSL Secure Payment" }
  ]
}, _v = ["phone", "whatsapp", "messenger", "mail", "map-pin", "store", "clock"].map((e) => ({ label: e.replace("-", " "), value: e })), Hv = {
  type: "contact",
  label: "Contact Section",
  description: "Contact page: channel cells, a location band with the address and a map, and a message form.",
  supportedPages: ["contact"],
  variants: [{ id: "v1", label: "Channels, location and form" }],
  commonFields: [
    { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "Pick a way in" },
    { key: "title", label: "Title", type: "string", default: "Get in" },
    { key: "highlight", label: "Highlighted words", type: "localized-string", default: "touch.", help: "Shown in amber on their own line under the title." },
    { key: "description", label: "Description", type: "text", default: "For the quickest help, keep your order number or phone number to hand when you get in touch." },
    {
      key: "channels",
      label: "Channels",
      type: "array",
      help: "Leave empty to show your Store info phone, WhatsApp, email and address. A channel without a link goes to the phone, WhatsApp, email or location by its icon.",
      itemSchema: [
        { key: "icon", label: "Icon", type: "select", options: _v, default: "phone" },
        { key: "label", label: "Small label", type: "localized-string", placeholder: "Call" },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "text", label: "Line", type: "localized-text" },
        { key: "linkText", label: "Link text", type: "localized-string", help: "Empty: the phone number, email or a default text." },
        { key: "link", label: "Link", type: "string", placeholder: "https://m.me/yourpage" }
      ],
      default: [
        { icon: "phone", label: "Call", title: "Call us", text: "Orders, sizes and delivery questions." },
        { icon: "whatsapp", label: "WhatsApp", title: "WhatsApp", text: "Send a quick message to the team.", linkText: "Chat on WhatsApp" },
        { icon: "mail", label: "Email", title: "Email us", text: "Bulk orders, partnerships and anything else." },
        { icon: "map-pin", label: "Visit", title: "Visit us", text: "Try the fits in person at our store.", linkText: "View location" }
      ]
    },
    { key: "email", label: "Email Address", type: "string" },
    { key: "phone", label: "Phone Number", type: "string" },
    { key: "address", label: "Physical Address", type: "text", help: "Empty: the addresses from Store info." },
    { key: "mapEyebrow", label: "Location eyebrow", type: "localized-string", default: "Visit the store" },
    { key: "mapTitle", label: "Location headline", type: "localized-string", default: "Come see us at" },
    { key: "mapOutline", label: "Location outlined words", type: "localized-string", default: "the neighbourhood.", help: "Drawn as outlines on their own line." },
    { key: "mapText", label: "Location line", type: "localized-text", default: "Drop by to try the fits, pick up an order or swap a size. Calling before you come helps." },
    { key: "mapImage", label: "Map picture", type: "image", help: "Optional: a picture of your map, about 4:3. Without one the address is shown in the frame." },
    { key: "mapLink", label: "Map link", type: "string", placeholder: "https://maps.app.goo.gl/…", help: "Empty: a map search for the first address." },
    { key: "mapLinkText", label: "Map link text", type: "localized-string", default: "Open in maps" },
    { key: "formEyebrow", label: "Form eyebrow", type: "localized-string", default: "Send a message" },
    { key: "formTitle", label: "Form headline", type: "localized-string", default: "Tell us what" },
    { key: "formHighlight", label: "Form highlighted words", type: "localized-string", default: "you need." },
    { key: "formText", label: "Form line", type: "localized-text", default: "Leave your name, a way to reach you and your message, and we will get back to you soon." }
  ]
}, Uv = {
  type: "content",
  label: "Content / Policy Section",
  description: "Policies and other text pages, or a questions-and-answers block with a heading beside an accordion.",
  supportedPages: ["privacy-policy", "terms-of-service", "shipping-policy", "return-policy", "about", "contact"],
  variants: [
    { id: "v1", label: "V1 (Clean Layout)" },
    { id: "v2", label: "V2 (With Table of Contents)" },
    {
      id: "v3",
      label: "Questions (heading beside an accordion)",
      fields: [
        { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "Good to know" },
        { key: "highlight", label: "Highlighted words", type: "localized-string", default: "answered.", help: "Shown in amber on their own line under the title." },
        { key: "subtitle", label: "Line under the heading", type: "localized-text", default: "The questions we hear most often, answered by the team." },
        { key: "helpText", label: "Help button text", type: "localized-string", default: "Need help?" },
        { key: "helpLink", label: "Help button link", type: "string", default: "/contact" },
        {
          key: "faqs",
          label: "Questions and answers",
          type: "array",
          help: "Shown as an accordion (also published as FAQ structured data).",
          itemSchema: [
            { key: "question", label: "Question", type: "string" },
            { key: "answer", label: "Answer", type: "text" }
          ],
          default: [
            { question: "How do I place an order?", answer: "Pick a size, add the piece to your cart and check out. You can also call or message us and we will place it for you." },
            { question: "Which payment methods can I use?", answer: "Cash on delivery, cards and mobile banking." },
            { question: "How long does delivery take?", answer: "Usually one to two days inside the city and three to five days elsewhere." },
            { question: "Can I swap a size?", answer: "Yes, within 7 days, as long as the piece is unworn with its tags on." }
          ]
        }
      ]
    }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "content", label: "HTML Content", type: "rich-text" }
  ]
}, Gv = {
  type: "featured-category",
  label: "Featured Category",
  description: "A collection block: one tall captioned tile for a category beside a grid of its products and a View more tile.",
  supportedPages: ["home", "product", "cart"],
  variants: [
    { id: "v1", label: "Big tile left" },
    { id: "v2", label: "Big tile right" }
  ],
  commonFields: [
    { key: "categoryId", label: "Select Category", type: "category-select" },
    { key: "title", label: "Tile caption", type: "string", help: "Empty = the category name. With no category picked, the category with this exact name is shown." },
    { key: "subtitle", label: "Line above the caption", type: "string" },
    { key: "image", label: "Tile picture", type: "image", help: "Portrait. Empty = the category picture." },
    { key: "rows", label: "Rows of products (four each)", type: "number", default: 2 },
    { key: "viewAllText", label: "Last tile text", type: "string", default: "View more" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "noSelectionText", label: "No Category Selected Text", type: "string", default: "Please select a category in the editor settings." },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    ...Fe
  ]
}, Yv = {
  type: "floating-buttons",
  label: "Floating Buttons",
  description: "Global floating buttons for quick actions (Call, WhatsApp, Messenger).",
  supportedPages: [...Io],
  variants: [{ id: "v1", label: "Default" }],
  commonFields: [
    { key: "active", label: "Enable Floating Buttons", type: "boolean", default: !0 },
    { key: "phone", label: "Phone Number", type: "string", placeholder: "+8801..." },
    { key: "whatsapp", label: "WhatsApp Number", type: "string", placeholder: "+8801..." },
    { key: "messenger", label: "Messenger ID/Link", type: "string", placeholder: "m.me/..." },
    { key: "callUsTitle", label: "Call Button Tooltip", type: "string", default: "Call Us" },
    { key: "whatsappTitle", label: "WhatsApp Button Tooltip", type: "string", default: "WhatsApp" },
    { key: "messengerTitle", label: "Messenger Button Tooltip", type: "string", default: "Messenger" }
  ]
}, Xv = {
  type: "footer",
  label: "Footer",
  description: "Site-wide footer: product lists, newsletter and social links, a row of links, payment badges and the copyright.",
  supportedPages: [...Io],
  variants: [
    {
      id: "v1",
      label: "Product lists",
      fields: [
        {
          key: "productLists",
          label: "Product lists",
          type: "array",
          help: "Up to three short lists of products across the top of the footer, five each.",
          itemSchema: [
            { key: "title", label: "Heading", type: "string" },
            { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 5 } }
          ],
          default: [
            { title: "New in", source: { source: "new", limit: 5 } },
            { title: "Top rated", source: { source: "top_rated", limit: 5 } },
            { title: "On sale", source: { source: "on_sale", limit: 5 } }
          ]
        }
      ]
    },
    { id: "v2", label: "Compact" }
  ],
  commonFields: [
    { key: "logo", label: "Footer Logo", type: "image" },
    { key: "title", label: "Brand Name", type: "string", default: "Mohalla" },
    {
      key: "description",
      label: "Brand Description",
      type: "text",
      default: "Your destination for premium fashion and lifestyle products. Curated styles for the modern wardrobe."
    },
    {
      key: "columns",
      label: "Link Columns",
      type: "array",
      itemSchema: [
        { key: "title", label: "Column Title", type: "string" },
        { key: "links", label: "Links", type: "array", itemSchema: fl }
      ]
    },
    {
      key: "socialLinks",
      label: "Social Links",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Facebook", value: "facebook" },
            { label: "Instagram", value: "instagram" },
            { label: "Twitter", value: "twitter" },
            { label: "YouTube", value: "youtube" },
            { label: "LinkedIn", value: "linkedin" }
          ]
        },
        { key: "href", label: "Link", type: "string" }
      ]
    },
    { key: "contactAddress", label: "Address", type: "string" },
    { key: "contactPhone", label: "Phone", type: "string" },
    { key: "contactEmail", label: "Email", type: "string" },
    {
      key: "newsletterAction",
      label: "Newsletter form URL",
      type: "string",
      placeholder: "https://…",
      help: "Where the email sign-up is sent (your mailing-list provider's form). The sign-up only shows when this is set."
    },
    {
      key: "note",
      label: "Bottom bar message",
      type: "string",
      placeholder: "Packed with care and delivered to your door.",
      help: "One line above the copyright."
    },
    { key: "copyright", label: "Copyright Text", type: "string", default: "© 2025 Mohalla. All rights reserved." },
    {
      key: "paymentMethods",
      label: "Payment Methods",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Visa", value: "visa" },
            { label: "Mastercard", value: "mastercard" },
            { label: "Amex", value: "amex" },
            { label: "Stripe", value: "stripe" },
            { label: "PayPal", value: "paypal" },
            { label: "bKash", value: "bkash" },
            { label: "Nagad", value: "nagad" },
            { label: "Rocket", value: "rocket" }
          ]
        },
        { key: "icon", label: "Icon URL (optional)", type: "string" }
      ]
    }
  ]
}, nn = {
  type: "header",
  label: "Header",
  description: "Site-wide header with navigation, search, and cart.",
  supportedPages: [...Io],
  variants: [
    { id: "v1", label: "Fashion (Default)" },
    { id: "v2", label: "Electronics" },
    { id: "v3", label: "Beauty / Minimal" },
    { id: "v4", label: "Jewelry / Elegant" }
  ],
  commonFields: [
    { key: "logo.alt", label: "Logo Alt Text", type: "string" },
    { key: "logo.src", label: "Logo Image", type: "image" },
    { key: "sticky", label: "Sticky Header", type: "boolean", default: !0 },
    {
      key: "topbar",
      label: "Top Bar",
      type: "object",
      fields: [
        { key: "active", label: "Enable Top Bar", type: "boolean", default: !0 },
        {
          key: "variant",
          label: "Variant",
          type: "select",
          options: [
            { label: "V1 (Centered Promo)", value: "v1" },
            { label: "V2 (Contact & Socials)", value: "v2" }
          ],
          default: "v1"
        },
        { key: "text", label: "Announcement Text", type: "string" },
        { key: "phone", label: "Phone Number", type: "string" },
        { key: "email", label: "Email Address", type: "string" },
        { key: "showSocials", label: "Show Social Icons", type: "boolean", default: !0 },
        {
          key: "socialLinks",
          label: "Social Links",
          type: "array",
          itemSchema: [
            { key: "platform", label: "Platform", type: "string" },
            { key: "href", label: "Link", type: "string" },
            { key: "icon", label: "Icon Name", type: "string" }
          ]
        },
        { key: "links", label: "Top Bar Links", type: "array", help: "The first two show on the right of the top bar.", itemSchema: fl }
      ]
    },
    {
      key: "actions",
      label: "Actions",
      type: "object",
      fields: [
        { key: "showSearch", label: "Show Search", type: "boolean", default: !0 },
        { key: "showCart", label: "Show Cart", type: "boolean", default: !0 },
        { key: "showAccount", label: "Show Account", type: "boolean", default: !0 },
        { key: "showWishlist", label: "Show Wishlist", type: "boolean", default: !0 },
        {
          key: "cartAction",
          label: "Cart Action",
          type: "select",
          options: [
            { label: "Slide-out Sidebar", value: "sidebar" },
            { label: "Go to Page", value: "page" }
          ],
          default: "sidebar"
        }
      ]
    },
    {
      key: "searchConfig",
      label: "Search Settings",
      type: "object",
      fields: [
        { key: "showPrice", label: "Show Price in Suggestions", type: "boolean", default: !0 },
        { key: "showCategory", label: "Show Category in Suggestions", type: "boolean", default: !0 },
        { key: "showImage", label: "Show Image in Suggestions", type: "boolean", default: !0 },
        { key: "maxResults", label: "Max Suggestions", type: "number", default: 6 }
      ]
    },
    { key: "menu", label: "Main Menu", type: "array", itemSchema: Fv }
  ]
}, jv = {
  type: "hero",
  label: "Hero Section",
  description: "The main attention-grabbing section at the top of the page.",
  supportedPages: ["home", "categories", "about", "contact"],
  variants: [
    {
      id: "v1",
      label: "V1 — Fashion Full-Height Slider",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: Yr },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    },
    {
      id: "v2",
      label: "V2 — Electronics Two-Column Slider",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: Yr },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    },
    {
      id: "v3",
      label: "V3 — Beauty Gradient Hero",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: Yr }
      ]
    },
    {
      id: "v4",
      label: "V4 — Jewelry Dark Elegant Hero",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: Yr }
      ]
    },
    {
      id: "v5",
      label: "Display (black band, headline and card)",
      fields: [
        { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "Streetwear from the neighbourhood", help: "Small line with a rule, above the headline." },
        { key: "headline", label: "Headline", type: "localized-string", default: "Drawn local." },
        { key: "highlight", label: "Highlighted words", type: "localized-string", default: "Worn loud.", help: "Shown in turmeric on their own line under the headline." },
        { key: "text", label: "Paragraph", type: "localized-text", default: "Heavy cotton, loose cuts and prints drawn in our own studio, for days spent out on the street." },
        { key: "ctaText", label: "Button text", type: "localized-string", default: "Our story" },
        { key: "ctaLink", label: "Button link", type: "string", default: "/about" },
        { key: "linkText", label: "Second link text", type: "localized-string", default: "Shop the drop" },
        { key: "linkHref", label: "Second link", type: "string", default: "/shop" },
        { key: "cardWord", label: "Card word", type: "localized-string", default: "Local", help: "A short word in big letters on the dark card." },
        { key: "cardText", label: "Card line", type: "localized-text", default: "Cut, sewn and printed close to home, in small runs." },
        { key: "cardLabel", label: "Card corner label (left)", type: "localized-string", default: "Dhaka" },
        { key: "cardLabelEnd", label: "Card corner label (right)", type: "localized-string", default: "Since 2024" }
      ]
    }
  ],
  commonFields: [...Fe]
}, qv = {
  type: "order-success",
  label: "Order Success Section",
  description: "The order confirmation page section.",
  supportedPages: ["order-success"],
  variants: [{ id: "v1", label: "V1 (Apparels)" }],
  commonFields: [
    { key: "title", label: "Success Title", type: "string", default: "Order Confirmed" },
    { key: "message", label: "Success Message", type: "text", default: "Your order has been placed successfully. We have sent a confirmation email with your order details." },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading order details..." },
    { key: "errorTitle", label: "Error Title", type: "string", default: "Order Not Found" },
    { key: "errorMessage", label: "Error Message", type: "string", default: "We could not find the order you are looking for." },
    { key: "viewOrderText", label: "View Order Button Text", type: "string", default: "View Order Status" },
    { key: "viewOrderLink", label: "View Order Link", type: "string", default: "/account/orders" },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" }
  ]
}, sn = {
  type: "product-detail",
  label: "Product Detail",
  description: "The main product information page section.",
  supportedPages: ["product"],
  variants: [
    { id: "v1", label: "V1 (Standard)" },
    { id: "v2", label: "V2 (With Countdown Timer)" },
    { id: "v3", label: "V3 (With Color/Size Swatches)" },
    { id: "v4", label: "Countdown Sale" },
    { id: "v5", label: "Swatches" },
    { id: "v6", label: "Video Gallery" }
  ],
  commonFields: [
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading..." },
    { key: "notFoundCode", label: "Not Found Code", type: "string", default: "404" },
    { key: "notFoundText", label: "Not Found Text", type: "string", default: "Product Not Found" },
    { key: "quantityLabel", label: "Quantity Label", type: "string", default: "Quantity" },
    { key: "addToCartText", label: "Add to Cart Button Text", type: "string", default: "Add to Cart" },
    { key: "orderNowText", label: "Order Now Button Text", type: "string", default: "Buy Now" },
    { key: "productDescTitle", label: "Product Description Accordion Title", type: "string", default: "Product Description" },
    { key: "returnPolicyTitle", label: "Return Policy Accordion Title", type: "string", default: "Return Policy" },
    { key: "countdownLabel", label: "Countdown Label (V2 only)", type: "string", default: "Offer ends in:" },
    { key: "saleEndDate", label: "Sale End Date", type: "string", placeholder: "2025-12-31T23:59:59" },
    { key: "videoUrl", label: "Product Video URL", type: "string", placeholder: "https://..." },
    ...Fe
  ]
}, Zv = {
  type: "mobileBottomNav",
  label: "Mobile Navigation",
  description: "Bottom navigation bar for mobile devices.",
  supportedPages: [...Io],
  variants: [{ id: "v1", label: "V1 (Default)" }],
  commonFields: [
    { key: "active", label: "Show Bottom Nav", type: "boolean" },
    {
      key: "items",
      label: "Nav Items",
      type: "array",
      itemSchema: [
        { key: "label", label: "Label", type: "string" },
        {
          key: "icon",
          label: "Icon Type",
          type: "select",
          options: [
            { label: "Home", value: "home" },
            { label: "Shop (Bag)", value: "shop" },
            { label: "Search", value: "search" },
            { label: "Cart", value: "cart" },
            { label: "User / Account", value: "account" },
            { label: "Heart / Wishlist", value: "heart" },
            { label: "Chat (WhatsApp)", value: "chat" },
            { label: "Menu / Hamburger", value: "menu" },
            { label: "Plus / Create", value: "plus" }
          ]
        },
        {
          key: "actionType",
          label: "Action Type",
          type: "select",
          options: [
            { label: "Link (Direct URL)", value: "link" },
            { label: "Open Search Drawer", value: "search" },
            { label: "Open Categories Sidebar", value: "categories" }
          ]
        },
        { key: "href", label: "Target URL", type: "string" },
        { key: "isPrimary", label: "Highlight as Primary (Middle)", type: "boolean" }
      ]
    }
  ]
}, Jv = {
  type: "similar-products",
  label: "Similar Products",
  description: "A row of related products shown on the product page.",
  supportedPages: ["product"],
  variants: [{ id: "v1", label: "V1 (Grid Row)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Similar Products" },
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    ...Fe
  ]
}, Kv = {
  type: "shop-grid",
  label: "Shop Grid",
  description: "The main product list with sidebar filters.",
  supportedPages: ["shop", "category", "cart", "checkout", "categories"],
  variants: [
    { id: "v1", label: "V1 (Left Sidebar + Grid)" },
    { id: "v2", label: "V2 (Full-width Grid, Slide-in Filters)" }
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "initialPriceRange.min", label: "Initial Price Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Initial Price Max", type: "number", default: 5e4 },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "allCategoriesLabel", label: "All Categories Label", type: "string", default: "All" },
    { key: "filtersButtonLabel", label: "Filters Button Label", type: "string", default: "Filters" },
    { key: "showingLabel", label: "Showing Label (prefix)", type: "string", default: "Showing" },
    { key: "productsSuffix", label: "Products Count Suffix", type: "string", default: "Products" },
    { key: "sortNewestLabel", label: "Sort: Newest Label", type: "string", default: "Sort: Newest" },
    { key: "sortOldestLabel", label: "Sort: Oldest Label", type: "string", default: "Sort: Oldest" },
    { key: "sortPriceAscLabel", label: "Sort: Price Low-High Label", type: "string", default: "Price: Low to High" },
    { key: "sortPriceDescLabel", label: "Sort: Price High-Low Label", type: "string", default: "Price: High to Low" },
    { key: "sortNameAscLabel", label: "Sort: Name A-Z Label", type: "string", default: "Name: A-Z" },
    { key: "sortNameDescLabel", label: "Sort: Name Z-A Label", type: "string", default: "Name: Z-A" },
    { key: "activeFiltersLabel", label: "Active Filters Label", type: "string", default: "Active Filters:" },
    { key: "clearAllLabel", label: "Clear All Label", type: "string", default: "Clear All" },
    { key: "noProductsTitle", label: "No Products Title", type: "string", default: "No Products Found" },
    { key: "noProductsMessage", label: "No Products Message", type: "string", default: "We couldn't find any products matching your current filters." },
    { key: "backToAllText", label: "Back to All Products Text", type: "string", default: "Back to All Products" },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "currentSearchLabel", label: "Current Search Label", type: "string", default: "Current Search" },
    { key: "clearSearchLabel", label: "Clear Search Label", type: "string", default: "Clear" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...Fe
  ]
}, Qv = {
  type: "wishlist",
  label: "Wishlist Section",
  description: "Displays saved/wishlisted products in a grid layout.",
  supportedPages: ["wishlist"],
  variants: [
    {
      id: "v1",
      label: "V1 (Grid)",
      fields: [
        { key: "title", label: "Page Title", type: "string", default: "My Wishlist" },
        { key: "subtitle", label: "Eyebrow Text", type: "string", default: "Saved items" },
        { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Nothing saved yet" },
        { key: "emptyText", label: "Empty State Description", type: "string", default: "Start exploring and save the items you love." },
        { key: "continueShoppingText", label: "CTA Text", type: "string", default: "Start Shopping" },
        { key: "continueShoppingLink", label: "CTA Link", type: "string", default: "/shop" }
      ]
    }
  ],
  commonFields: []
}, ek = [
  { key: "lead", label: "Lead word (optional)", type: "string", placeholder: "Free delivery" },
  { key: "text", label: "Message Text", type: "string" },
  { key: "code", label: "Coupon Code (optional)", type: "string" },
  { key: "linkLabel", label: "Link text", type: "string", placeholder: "Click here" },
  { key: "link", label: "Link (optional)", type: "string", placeholder: "/shop" }
], tk = {
  type: "announcement-bar",
  label: "Announcement Bar",
  description: "A black bar with a bold lead phrase, one line and links, or a turmeric band of words scrolling past.",
  supportedPages: [
    "home",
    "shop",
    "product",
    "category",
    "categories",
    "cart",
    "checkout",
    "contact",
    "wishlist"
  ],
  variants: [
    {
      id: "v1",
      label: "Black bar",
      fields: [
        { key: "items", label: "Announcement Items", type: "array", itemSchema: ek },
        { key: "bgColor", label: "Background Color", type: "string", default: "#0989FF" },
        { key: "textColor", label: "Text Color", type: "string", default: "#ffffff" }
      ]
    },
    {
      id: "v2",
      label: "Scrolling band",
      fields: [
        {
          key: "items",
          label: "Words",
          type: "array",
          help: "Short words or phrases that scroll across a turmeric band, a star between each.",
          itemSchema: [{ key: "text", label: "Word or phrase", type: "string" }]
        }
      ]
    }
  ],
  commonFields: [...Fe]
}, ak = [
  { key: "id", label: "Product ID", type: "string" },
  { key: "name", label: "Product Name", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "originalPrice", label: "Original Price", type: "number" },
  { key: "salePrice", label: "Sale Price", type: "number" },
  { key: "discount", label: "Discount %", type: "number" }
], ok = {
  type: "flash-sale",
  label: "Flash Sale",
  description: "Countdown timer with a horizontal product row for time-limited offers.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "V1 — Countdown + Product Row",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Flash Sale" },
        { key: "endDate", label: "Sale End Date (ISO)", type: "string", placeholder: "2025-12-31T23:59:59" },
        { key: "bgColor", label: "Header Background Color", type: "color", default: "#1a1a2e" },
        { key: "products", label: "Products", type: "array", itemSchema: ak }
      ]
    }
  ],
  commonFields: [...Fe]
}, rk = [
  { key: "id", label: "Product ID", type: "string" },
  { key: "name", label: "Product Name", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "price", label: "Price", type: "number" },
  { key: "originalPrice", label: "Original Price", type: "number" },
  { key: "badge", label: "Badge Text", type: "string" }
], lk = {
  type: "new-arrivals",
  label: "New Arrivals",
  description: "A grid of the newest products: square photos, six across, with name and price.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "Photo grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Fresh styles just landed" },
        { key: "products", label: "Products", type: "array", itemSchema: rk },
        { key: "limit", label: "Products shown", type: "number", default: 12, help: "Six fill one row on desktop." },
        { key: "showDetails", label: "Show name and price", type: "boolean", default: !0 }
      ]
    }
  ],
  commonFields: [...Fe]
}, ik = {
  type: "offer-banner",
  label: "Offer Banner",
  description: "A mint banner with a headline, a line and a button, and an optional picture on the right.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "Mint banner",
      fields: [
        { key: "image", label: "Picture (optional)", type: "image" },
        { key: "title", label: "Title", type: "string", default: "Special Offer" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Get up to 50% off on selected items" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" }
      ]
    }
  ],
  commonFields: [...Fe]
}, cn = {
  type: "lookbook-banner",
  label: "Lookbook Banner",
  description: "Editorial banner — split image/text (V1) or full-width overlay (V2).",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "Photo beside text",
      fields: [
        { key: "image", label: "Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The New Collection" },
        { key: "subtitle", label: "Subtitle", type: "text" },
        { key: "ctaText", label: "Button Text", type: "string", default: "View Lookbook" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        {
          key: "imagePosition",
          label: "Image Position",
          type: "select",
          options: [
            { label: "Left", value: "left" },
            { label: "Right", value: "right" }
          ],
          default: "left"
        }
      ]
    },
    {
      id: "v2",
      label: "Full-width photo banner",
      fields: [
        { key: "image", label: "Background Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The Collection" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Discover the new season" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        { key: "overlayOpacity", label: "Overlay Opacity (0–100)", type: "number", default: 40 }
      ]
    }
  ],
  commonFields: [...Fe]
}, Xr = [
  { key: "image", label: "Image", type: "image" },
  { key: "link", label: "Link URL", type: "string" }
], nk = [
  { key: "image", label: "Poster", type: "image", help: "Tall, about 800 × 1000 px (4:5)." },
  { key: "caption", label: "Caption (optional)", type: "string", help: "Shown under the poster; also describes it for screen readers." },
  { key: "link", label: "Link", type: "string", placeholder: "/shop" }
], sk = {
  type: "instagram-feed",
  label: "Instagram Feed",
  description: "Display a grid of Instagram photos with hover effects, or a carousel of portrait posters.",
  supportedPages: [...Io],
  variants: [
    {
      id: "v1",
      label: "Photo strip",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle (e.g. @yourstore)", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Xr }
      ]
    },
    {
      id: "v2",
      label: "Photo strip, handle on hover",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Xr }
      ]
    },
    {
      id: "v3",
      label: "Four large tiles",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Xr }
      ]
    },
    {
      id: "v4",
      label: "Mosaic",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Xr }
      ]
    },
    {
      id: "v5",
      label: "Poster carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Highlights" },
        { key: "handle", label: "Small line above the title (optional)", type: "string" },
        { key: "items", label: "Posters", type: "array", itemSchema: nk }
      ]
    }
  ],
  commonFields: [...Fe]
}, Uc = [
  { key: "title", label: "Title", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "excerpt", label: "Excerpt", type: "text" },
  { key: "slug", label: "Slug", type: "string" },
  { key: "date", label: "Date", type: "string" },
  { key: "category", label: "Category", type: "string" }
], ck = {
  type: "blog",
  label: "Blog Posts",
  description: "Display a grid or list of blog post cards.",
  supportedPages: [...Io],
  variants: [
    {
      id: "v1",
      label: "V1 — 3-Column Card Grid (Fashion Style)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: Uc },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: !0 }
      ]
    },
    {
      id: "v2",
      label: "V2 — List Style (Electronics Style)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: Uc },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: !0 }
      ]
    },
    {
      id: "v3",
      label: "Article Detail",
      fields: []
    }
  ],
  commonFields: [
    { key: "source", label: "Posts to show", type: "select", options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." },
    ...Fe
  ]
}, gi = [
  {
    key: "icon",
    label: "Icon",
    type: "select",
    options: [
      { label: "Shipping Truck", value: "shipping" },
      { label: "Return Arrow", value: "refund" },
      { label: "Support Headset", value: "support" },
      { label: "Security Lock", value: "secure" },
      { label: "Gift Box", value: "gift" }
    ],
    default: "shipping"
  },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" }
], dk = [
  { key: "title", label: "Value", type: "localized-string", help: "A number or a short word, e.g. 2024." },
  { key: "subtitle", label: "Caption", type: "localized-string" }
], pk = [
  {
    key: "icon",
    label: "Icon",
    type: "select",
    options: ["sparkle", "star", "heart", "check", "shield", "truck", "package", "store", "map-pin", "tag", "user", "clock"].map((e) => ({ label: e.replace("-", " "), value: e })),
    default: "sparkle"
  },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "subtitle", label: "Line", type: "localized-text" }
], uk = {
  type: "features",
  label: "Features Strip",
  description: "Trust-building feature strip showing shipping, returns, support, and security highlights.",
  supportedPages: ["home", "shop", "categories", "about", "contact"],
  variants: [
    {
      id: "v1",
      label: "V1 — Compact Horizontal Strip",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: gi },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (Light Gray)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" }
          ],
          default: "default"
        }
      ]
    },
    {
      id: "v2",
      label: "V2 — Spaced Cards",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: gi },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (White)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" }
          ],
          default: "default"
        }
      ]
    },
    {
      id: "v3",
      label: "V3 — Jewelry Minimal Centered",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: gi }
      ]
    },
    {
      id: "v4",
      label: "Stat row",
      fields: [
        {
          key: "items",
          label: "Figures",
          type: "array",
          itemSchema: dk,
          default: [
            { title: "2024", subtitle: "The first drop" },
            { title: "Dhaka", subtitle: "Where we cut and print" },
            { title: "40+", subtitle: "Prints in the archive" },
            { title: "7 days", subtitle: "To swap a size" }
          ]
        }
      ]
    },
    {
      id: "v5",
      label: "Numbered cells on a black band",
      fields: [
        { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "Why people pick us" },
        { key: "title", label: "Heading", type: "localized-string", default: "Made with" },
        { key: "highlight", label: "Highlighted words", type: "localized-string", default: "something to say.", help: "Shown in turmeric on their own line under the heading." },
        { key: "text", label: "Line beside the heading", type: "localized-text", default: "Every piece starts with the street it is worn on: what people wear, how they move and what they want to say." },
        {
          key: "items",
          label: "Cells",
          type: "array",
          itemSchema: pk,
          default: [
            { icon: "sparkle", title: "Local roots", subtitle: "Drawn and printed by people from the neighbourhood." },
            { icon: "star", title: "Bold prints", subtitle: "Graphics with something to say, in small runs." },
            { icon: "shield", title: "Built to last", subtitle: "Heavy cotton and double stitching that keep their shape." },
            { icon: "heart", title: "Fair prices", subtitle: "Streetwear you can wear every day, not once a year." }
          ]
        }
      ]
    }
  ],
  commonFields: [...Fe]
}, Gc = [
  { key: "avatar", label: "Avatar Image", type: "image" },
  { key: "name", label: "Name", type: "string" },
  { key: "designation", label: "Designation", type: "string" },
  { key: "review", label: "Review Text", type: "text" },
  { key: "rating", label: "Rating (1–5)", type: "number", default: 5 }
], yk = [
  { key: "avatar", label: "Portrait photo", type: "image", help: "Tall, about 800 × 1000 px (4:5)." },
  { key: "name", label: "Name", type: "string" },
  { key: "designation", label: "Role", type: "string", help: "Shown after the name, e.g. “Musician”." }
], hk = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer reviews and social proof section.",
  supportedPages: ["home", "shop"],
  variants: [
    {
      id: "v1",
      label: "Quote slider",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "What Our Customers Say" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: Gc }
      ]
    },
    {
      id: "v2",
      label: "Quote cards",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Customer Reviews" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: Gc }
      ]
    },
    {
      id: "v3",
      label: "Portrait carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Worn on our streets" },
        { key: "intro", label: "Intro line", type: "text", help: "Put *stars* around words to show them bold." },
        { key: "items", label: "People", type: "array", itemSchema: yk }
      ]
    }
  ],
  commonFields: [...Fe]
}, bk = {
  type: "cta",
  label: "Call to Action",
  description: "A full-width picture banner with a link, or a turmeric band with a headline and a quote card.",
  supportedPages: ["home", "shop", "categories", "about", "contact"],
  variants: [
    {
      id: "v1",
      label: "Picture banner",
      fields: [
        { key: "image", label: "Picture", type: "image", help: "Wide, about 1240 × 200 px; may carry its own artwork." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional, about 780 × 340 px." },
        { key: "link", label: "Link", type: "string", default: "/contact" },
        { key: "title", label: "Heading (optional)", type: "string", default: "Become a reseller" },
        { key: "subtitle", label: "Line (optional)", type: "string", default: "Sell our clothes and earn on every order." },
        { key: "buttonText", label: "Button text (optional)", type: "string", default: "Join now" }
      ]
    },
    {
      id: "v2",
      label: "Quote band",
      fields: [
        { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "What comes next" },
        { key: "title", label: "Headline", type: "string", default: "From our street" },
        { key: "outline", label: "Outlined words", type: "localized-string", default: "to yours.", help: "Drawn as outlines on their own line under the headline." },
        { key: "subtitle", label: "Paragraph", type: "text", default: "We want to keep making clothes that feel like the neighbourhood: loud, local and made to be lived in, for more streets in more cities." },
        { key: "quote", label: "Quote", type: "localized-string", default: "Wear it loud." },
        { key: "quoteText", label: "Line under the quote", type: "localized-text", default: "More than a slogan: the reason every print says something." }
      ]
    }
  ],
  commonFields: [...Fe]
}, mk = [
  { key: "logo", label: "Logo Image", type: "image" },
  { key: "name", label: "Brand Name", type: "string" },
  { key: "link", label: "Brand URL", type: "string" }
], gk = {
  type: "brands",
  label: "Brand Logos",
  description: "An intro line, then partner or brand logos in a carousel with arrows or an auto-scrolling strip.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "Logos",
      fields: [
        { key: "title", label: "Intro line", type: "string" },
        { key: "subtitle", label: "Paragraph", type: "string" },
        {
          key: "layout",
          label: "Layout",
          type: "select",
          options: [
            { label: "Carousel with arrows", value: "grid" },
            { label: "Auto-scroll Ticker", value: "ticker" }
          ],
          default: "grid"
        },
        { key: "items", label: "Brand Items", type: "array", itemSchema: mk }
      ]
    }
  ],
  commonFields: [...Fe]
}, fk = [
  { key: "label", label: "Tab Label", type: "string" },
  { key: "categoryId", label: "Category", type: "category-select", help: "Empty = the newest products." }
], vk = {
  type: "product-slider",
  label: "Product Slider",
  description: "A horizontal scrolling product carousel with optional tabs.",
  supportedPages: ["home", "category", "categories"],
  variants: [
    {
      id: "v1",
      label: "Tabbed product grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Featured Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "All Product Shop" },
        { key: "tabs", label: "Tabs", type: "array", itemSchema: fk },
        { key: "viewAllLabel", label: "“Explore more” button text", type: "string", default: "Explore more", help: "Links to the open tab’s category, else to the newest products." }
      ]
    },
    {
      id: "v2",
      label: "Swipe row, three across",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Exquisite Collection" }
      ]
    },
    {
      id: "v3",
      label: "Swipe row, four across",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Skincare & Beauty" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Glow Up Collection" }
      ]
    }
  ],
  commonFields: [...Fe]
}, kk = {
  type: "product-grid",
  label: "Product Grid",
  description: "A product grid section with multiple layout variants.",
  supportedPages: ["home", "category", "categories", "shop"],
  variants: [
    {
      id: "v1",
      label: "V1 — 4-Col Standard Grid (Fashion)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "All Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Customer Favorite Style" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v2",
      label: "V2 — Featured + List Aside (Week's Featured)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Week's Featured" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Top Picks" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v3",
      label: "V3 — Electronics List View + Sidebar",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Trending Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Electronics" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v4",
      label: "V4 — Gadget Showcase (1 Large + Smaller Cards)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Top Gadgets" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "New Arrivals" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v5",
      label: "V5 — Beauty 4-Col Image-Focused",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Beauty Essentials" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Trending Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v6",
      label: "V6 — Trending List + Special Offer with Countdown",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "This Week's Picks" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Hot Right Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" },
        { key: "offerEndsAt", label: "Offer End Date (ISO string)", type: "string" }
      ]
    }
  ],
  commonFields: [...Fe]
}, wk = {
  type: "compare",
  label: "Product Comparison",
  description: "A lookbook line sheet comparing up to 4 pieces side by side: 3:4 photo, brand and name, sale price with % off (cheapest marked), colour swatches, size chips, fit, fabric and other attributes, category and brand, a show-differences-only switch, Add to bag and remove.",
  supportedPages: ["compare"],
  variants: [
    {
      id: "v1",
      label: "Table"
    }
  ],
  commonFields: [...Fe]
}, Sk = {
  type: "coupon",
  label: "Coupons",
  description: "A grid of coupon cards with discount code, title, description, expiry date, and a copy-to-clipboard button.",
  supportedPages: ["coupon"],
  variants: [
    {
      id: "v1",
      label: "Card Grid"
    }
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Available Coupons" },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Coupon Code", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Description", type: "text" },
        { key: "expiryDate", label: "Expiry Date", type: "string" },
        { key: "discount", label: "Discount (e.g. 20% or Free Shipping)", type: "string" },
        { key: "bgColor", label: "Badge Background Color", type: "color" }
      ]
    },
    ...Fe
  ]
}, xk = {
  type: "recent-products",
  label: "Recently Viewed Products",
  description: "A horizontal slider of products the visitor has recently viewed (stored in localStorage — no API call).",
  supportedPages: ["home", "shop", "product", "category", "cart"],
  variants: [{ id: "v1", label: "V1 (Horizontal Slider)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Recently Viewed" }
  ]
}, Tk = {
  key: "messages",
  label: "Top bar messages",
  type: "array",
  help: "Shown on the left of the black top bar (phones show the first). Put *stars* around a phrase to make it bold. Without messages the announcement text is used.",
  itemSchema: [
    { key: "text", label: "Text", type: "localized-string" },
    { key: "link", label: "Link", type: "string" }
  ]
}, Ck = { key: "badge", label: "Badge", type: "string", placeholder: "New", help: "Small label next to the item." }, Pk = { key: "searchPlaceholder", label: "Search label", type: "string", placeholder: "Search" }, Ak = (e) => [
  ...e.map((t) => t.key === "type" && t.options && !t.options.some((a) => a.value === "categories") ? { ...t, options: [...t.options, { label: "Shop panel (store categories)", value: "categories" }] } : t),
  Ck
], Lk = {
  ...nn,
  commonFields: nn.commonFields.flatMap((e) => e.key === "topbar" && e.fields ? [{ ...e, fields: [...e.fields, Tk] }] : e.key === "menu" && e.itemSchema ? [{ ...e, itemSchema: Ak(e.itemSchema) }] : e.key === "actions" ? [e, Pk] : [e])
}, _a = ["home", "shop", "category", "categories", "product", "cart", "blog"], Mk = ["truck", "cash", "phone", "shield", "star", "heart", "package", "check", "store", "map-pin", "mail", "sparkle", "clock", "bag", "user", "search", "refresh", "lock", "tag"].map((e) => ({ label: e.replace("-", " "), value: e })), Ha = (e = {}) => [
  { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: e.eyebrow ?? "", help: "Small line above the title." },
  { key: "title", label: "Title", type: "localized-string", default: e.title ?? "" },
  { key: "subtitle", label: "Subtitle", type: "localized-text", default: e.subtitle ?? "" }
], dn = [
  { key: "icon", label: "Icon", type: "icon", default: "check", options: Mk },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "body", label: "Text", type: "localized-text" }
], Yc = [
  { key: "alt", label: "Picture description", type: "string", help: "What the picture shows, for screen readers." },
  { key: "title", label: "Title over the photo", type: "string", help: "Optional, a few words." },
  { key: "subtitle", label: "Line under the title", type: "string" },
  { key: "ctaText", label: "Button text", type: "string" },
  { key: "ctaLink", label: "Button link", type: "string", placeholder: "/shop" }
], Nk = {
  type: "banner-carousel",
  label: "Banner carousel",
  description: "Photo slides with an optional short title, line and button over the photo: full-width slides, or a row of tall posters.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [
    {
      id: "v1",
      label: "Full-width photo slides",
      fields: [
        {
          key: "slides",
          label: "Slides",
          type: "array",
          itemSchema: [
            { key: "image", label: "Picture", type: "image", required: !0, help: "Wide, about 1920 × 550 px." },
            { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional, about 780 × 600 px." },
            ...Yc,
            { key: "cta2Text", label: "Second button text", type: "string" },
            { key: "cta2Link", label: "Second button link", type: "string", placeholder: "/categories" },
            { key: "link", label: "Link of the whole slide", type: "string", placeholder: "/shop", help: "Used when the slide has no button." }
          ],
          default: []
        }
      ]
    },
    {
      id: "v2",
      label: "Poster row",
      fields: [
        {
          key: "slides",
          label: "Posters",
          type: "array",
          help: "Three show side by side on a computer, one on a phone; the next one peeks in.",
          itemSchema: [
            { key: "image", label: "Picture", type: "image", required: !0, help: "Tall, about 960 × 1200 px (4:5)." },
            ...Yc,
            { key: "link", label: "Link of the whole poster", type: "string", placeholder: "/shop", help: "Used when the poster has no button." }
          ],
          default: []
        }
      ]
    }
  ],
  commonFields: [
    { key: "title", label: "Name for screen readers", type: "string", default: "Offers" },
    { key: "autoplay", label: "Play automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 5, dependency: { field: "autoplay", value: !0 } }
  ]
}, Ek = {
  type: "category-bento",
  label: "Category mosaic",
  description: "Portrait photo tiles linking to categories, the name on a small label at the foot of each: the tiles you list, else the store’s categories.",
  supportedPages: _a,
  variants: [
    { id: "v1", label: "Portrait tiles with a label" },
    { id: "v2", label: "Mosaic (first tile large)" }
  ],
  commonFields: [
    ...Ha(),
    {
      key: "tiles",
      label: "Tiles",
      type: "array",
      help: "Empty = the store’s categories.",
      itemSchema: [
        { key: "categoryId", label: "Category", type: "category-select", help: "Sets the link, name and picture unless filled below." },
        { key: "title", label: "Name", type: "localized-string" },
        { key: "tagline", label: "Tagline (mosaic)", type: "localized-string" },
        { key: "image", label: "Picture", type: "image" },
        { key: "link", label: "Link", type: "string", placeholder: "/category/…" }
      ],
      default: []
    },
    { key: "limit", label: "Categories shown (automatic tiles)", type: "number", default: 12 }
  ]
}, Dk = {
  type: "combo-spotlight",
  label: "Product spotlight",
  description: "One product or bundle on a card: large photo, price, saving and Add to bag.",
  supportedPages: _a,
  variants: [{ id: "v1", label: "Photo and details card" }],
  commonFields: [
    ...Ha({ eyebrow: "Combo deal", title: "Pick of the week" }),
    { key: "productId", label: "Product", type: "product-select", help: "Hidden until a product is picked." },
    { key: "description", label: "Text", type: "localized-text", default: "" },
    { key: "mrpLabel", label: "Regular price label", type: "localized-string", default: "Regular price" },
    { key: "savingLabel", label: "Saving label", type: "localized-string", default: "You save" },
    { key: "detailsLabel", label: "Details link text", type: "localized-string", default: "View details" }
  ]
}, Fk = {
  type: "corporate-band",
  label: "Bulk order band",
  description: "A warm box with a linked title, a short pitch and a few product pictures, e.g. for bulk, team or wholesale orders.",
  supportedPages: _a,
  variants: [{ id: "v1", label: "Box with pictures" }],
  commonFields: [
    ...Ha({ title: "Bulk order / wholesale" }).filter((e) => e.key !== "subtitle"),
    { key: "text", label: "Text", type: "localized-text", default: "Plain or printed T-shirts and polos for your team, school or event, at wholesale prices and with no minimum order." },
    { key: "cta.url", label: "Title link", type: "string", default: "/contact" },
    {
      key: "images",
      label: "Pictures",
      type: "array",
      help: "Up to six, square.",
      itemSchema: [
        { key: "image", label: "Picture", type: "image" },
        { key: "alt", label: "Picture description", type: "string" }
      ],
      default: []
    }
  ]
}, Ik = {
  type: "product-rail",
  label: "Product rail",
  description: "Product cards from new arrivals, deals, a category or your own pick, as a grid or a swipe row.",
  supportedPages: _a,
  variants: [{ id: "v1", label: "Product cards" }],
  commonFields: [
    ...Ha({ eyebrow: "Just dropped", title: "New arrivals" }),
    { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 8 } },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [
        { label: "Grid (four up)", value: "grid" },
        { label: "Swipe row", value: "rail" }
      ],
      default: "grid"
    },
    { key: "showViewAll", label: "Show “View all”", type: "boolean", default: !0 },
    { key: "viewAllLabel", label: "“View all” text", type: "string", default: "View all", dependency: { field: "showViewAll", value: !0 } }
  ]
}, Ok = {
  type: "promises",
  label: "Promises strip",
  description: "Store promises: a grey band of icon, title and line, or a numbered checklist on a black band.",
  supportedPages: [..._a, "about", "contact"],
  variants: [
    {
      id: "v1",
      label: "Grey band",
      fields: [
        {
          key: "items",
          label: "Promises",
          type: "array",
          itemSchema: dn,
          default: [
            { icon: "truck", title: "Fast delivery", body: "Quick delivery across the city." },
            { icon: "cash", title: "Pay on delivery", body: "Pay in cash when your order arrives." },
            { icon: "refresh", title: "Easy returns", body: "Wrong size? Swap it within 7 days." },
            { icon: "phone", title: "Here to help", body: "Call or message us any day." }
          ]
        }
      ]
    },
    {
      id: "v2",
      label: "Checklist on a black band",
      fields: [
        { key: "highlight", label: "Highlighted words", type: "localized-string", default: "anything you need.", help: "Shown in turmeric on their own line under the title." },
        {
          key: "items",
          label: "Checklist",
          type: "array",
          itemSchema: dn.filter((e) => e.key !== "icon"),
          default: [
            { title: "Order status and tracking" },
            { title: "Size, fit and product advice" },
            { title: "Delivery, swaps and payments" },
            { title: "Bulk, team and custom orders" }
          ]
        }
      ]
    }
  ],
  commonFields: [...Ha()]
}, Rk = {
  type: "reviews",
  label: "Customer reviews",
  description: "A swipe row of quote cards: rating, title, quote, name and the product. Store reviews replace these once available.",
  supportedPages: _a,
  variants: [{ id: "v1", label: "Quote cards" }],
  commonFields: [
    ...Ha({ title: "What our customers say" }),
    {
      key: "items",
      label: "Reviews",
      type: "array",
      help: "Real reviews from your customers, with their permission.",
      itemSchema: [
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "body", label: "Review", type: "localized-text" },
        { key: "name", label: "Customer name", type: "string" },
        { key: "productId", label: "Product", type: "product-select" }
      ],
      default: []
    },
    { key: "limit", label: "Most reviews shown", type: "number", default: 6 },
    { key: "minRating", label: "Lowest rating shown (store reviews)", type: "number", default: 4 }
  ]
}, Bk = {
  type: "story",
  label: "Story band",
  description: "An off-white split: eyebrow and a huge headline with a highlighted last line (and an optional photo) beside a bold line, the paragraph and a numbered list.",
  supportedPages: [..._a, "about", "contact"],
  variants: [{ id: "v1", label: "Headline beside a numbered list" }],
  commonFields: [
    ...Ha({ title: "Our story", subtitle: "Comfortable clothes you can wear every day." }).map((e) => e.key === "subtitle" ? { ...e, label: "Bold line" } : e),
    { key: "highlight", label: "Highlighted words", type: "localized-string", default: "to your street.", help: "Shown in amber on their own line under the title." },
    { key: "text", label: "Paragraph", type: "localized-text", default: "We choose soft, breathable fabrics, check every stitch and size, and price fairly, so your everyday clothes look good and last." },
    { key: "image", label: "Picture", type: "image", help: "Optional, under the headline; landscape 4:3." },
    {
      key: "points",
      label: "Points",
      type: "array",
      itemSchema: dn.filter((e) => e.key !== "icon"),
      help: "Shown as a numbered list (01, 02…).",
      default: []
    },
    { key: "ctaLink", label: "Link", type: "string", default: "/about", help: "The link under the list goes here." },
    { key: "ctaLabel", label: "Link text", type: "localized-string", default: "" }
  ]
}, zk = {
  key: "gallery",
  label: "Mosaic pictures",
  type: "array",
  help: "Up to two (split) or three (full width) extra pictures shown as a mosaic with the main picture.",
  itemSchema: [
    { key: "image", label: "Picture", type: "image" },
    { key: "alt", label: "Description (alt text)", type: "string" },
    { key: "link", label: "Link", type: "string" }
  ]
}, Vk = {
  ...cn,
  variants: cn.variants.map((e) => ({ ...e, fields: [...e.fields ?? [], zk] }))
}, Wk = [
  { label: "Shield", value: "shield" },
  { label: "Exchange arrows", value: "refresh" },
  { label: "Lock", value: "lock" },
  { label: "Delivery truck", value: "truck" },
  { label: "Cash", value: "cash" },
  { label: "Parcel", value: "package" },
  { label: "Star", value: "star" },
  { label: "Tick", value: "check" }
], $k = {
  ...sn,
  commonFields: [
    ...sn.commonFields,
    { key: "sizeGuideTitle", label: "Size chart title and link", type: "string", default: "Size chart" },
    { key: "sizeGuide", label: "Size guide", type: "rich-text", help: 'Measurements table or fit notes, opened from the "Size chart" link beside the sizes. Two tables, inches then centimetres, get Inch / CM tabs. Hidden while empty.' },
    { key: "completeTheLookTitle", label: '"Suggested picks" title', type: "string", default: "Suggested picks", help: "Up to five other products from the same category, shown as compact rows beside the photos (under them on phones)." },
    { key: "additionalInfoTitle", label: '"Additional information" tab title', type: "string", default: "Additional information", help: "The product's options (sizes, colours…), the delivery and returns policy and the delivery areas." },
    { key: "showDeliveryAreas", label: "Show delivery areas and charges", type: "boolean", default: !0 },
    {
      key: "deliveryPoints",
      label: "Delivery lines",
      type: "array",
      help: "Short lines with a green dot under the buttons.",
      itemSchema: [{ key: "text", label: "Line", type: "string" }],
      default: [
        { text: "Delivery all over Bangladesh" },
        { text: "Cash on delivery available" },
        { text: "Check the parcel before you pay" }
      ]
    },
    {
      key: "trustCards",
      label: "Trust cards",
      type: "array",
      help: "Up to three small cards under the delivery lines.",
      itemSchema: [
        { key: "icon", label: "Icon", type: "select", options: Wk, default: "shield" },
        { key: "title", label: "Title", type: "string" },
        { key: "text", label: "Line", type: "string" }
      ],
      default: [
        { icon: "shield", title: "Quality checked", text: "Every piece checked before it ships" },
        { icon: "refresh", title: "Easy exchange", text: "Wrong size? Swap it within 7 days" },
        { icon: "lock", title: "Safe payment", text: "Pay on delivery or online" }
      ]
    }
  ]
}, _k = {
  ...rn,
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Sign in" },
    { key: "intro", label: "Intro text", type: "text", default: "Sign in or create an account with your mobile number." },
    ...rn.commonFields
  ]
}, Hk = {
  ...ln,
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Create account" },
    { key: "intro", label: "Intro text", type: "text", default: "Create your account with your mobile number." },
    ...ln.commonFields
  ]
}, Xc = {
  componentSchemas: {
    "banner-carousel": Nk,
    "category-bento": Ek,
    "combo-spotlight": Dk,
    "corporate-band": Fk,
    "product-rail": Ik,
    promises: Ok,
    reviews: Rk,
    story: Bk,
    "lookbook-banner": Vk,
    "product-detail": $k,
    signin: _k,
    signup: Hk
  },
  chrome: {
    headerSchema: Lk
  }
}, jc = {
  componentSchemas: {
    account: Dv,
    signin: rn,
    signup: ln,
    banner: Bv,
    cart: zv,
    categories: Vv,
    category: Wv,
    checkout: $v,
    contact: Hv,
    content: Uv,
    "featured-category": Gv,
    hero: jv,
    "order-success": qv,
    "product-detail": sn,
    "similar-products": Jv,
    "shop-grid": Kv,
    wishlist: Qv,
    "announcement-bar": tk,
    "flash-sale": ok,
    "new-arrivals": lk,
    "offer-banner": ik,
    "lookbook-banner": cn,
    "instagram-feed": sk,
    blog: ck,
    features: uk,
    testimonials: hk,
    cta: bk,
    brands: gk,
    "product-slider": vk,
    "product-grid": kk,
    compare: wk,
    coupon: Sk,
    "recent-products": xk
  },
  headerSchema: nn,
  footerSchema: Xv,
  floatingButtonsSchema: Yv,
  mobileNavSchema: Zv
}, Uk = ht({
  ...jc,
  componentSchemas: { ...jc.componentSchemas, ...Xc.componentSchemas },
  ...Xc.chrome
}, Ev), Gk = {
  account: { hide: ["signinRedirectPath"] },
  "announcement-bar": { hide: ["bgColor", "textColor"] },
  cart: { hide: ["loadingText", "taxLabel", "secureCheckoutText"] },
  category: { hide: ["productCardVariant", "initialPriceRange", "showBreadcrumb"] },
  checkout: { hide: ["loadingText", "shippingCalculatingText", "securePaymentText"] },
  cta: { hide: ["bgColor"] },
  "featured-category": { hide: ["productCardVariant", "noSelectionText", "noProductsText"] },
  features: { hide: ["bgStyle"] },
  hero: { variantLabels: { v1: "Full-bleed photo", v2: "Split", v3: "Poster", v4: "Charcoal" } },
  "flash-sale": { hide: ["bgColor", "products"] },
  "new-arrivals": { hide: ["products"] },
  "order-success": { hide: ["loadingText"] },
  "product-detail": { hide: ["loadingText", "notFoundCode", "notFoundText"], keep: ["v1", "v2", "v3", "v6"], variantLabels: { v1: "Standard", v2: "Sale countdown band", v3: "Large photo swatches", v6: "Video under the photo" } },
  "shop-grid": { hide: ["productCardVariant", "initialPriceRange", "sortOldestLabel", "sortNameDescLabel"] },
  "similar-products": { hide: ["productCardVariant"] },
  blog: { keep: ["v1", "v2"] },
  "banner-carousel": { variantLabels: { v1: "Full-bleed slides", v2: "Poster row" } },
  banner: { variantLabels: { v1: "Selling points strip", v2: "Wide", v3: "Square picture tiles" } },
  "product-slider": { variantLabels: { v1: "Tabbed grid", v2: "Carousel, three across", v3: "Carousel" } },
  "product-grid": { variantLabels: { v1: "Tabbed grid", v2: "Featured + grid", v3: "Numbered list", v4: "One large + four", v5: "Three across", v6: "Numbered list + offer" } },
  categories: { variantLabels: { v1: "Square carousel", v2: "Shortcut strip" } },
  "category-bento": { variantLabels: { v1: "3 + 2 tiles", v2: "Mosaic (first tile large)" } },
  "offer-banner": { variantLabels: { v1: "Strip" } },
  coupon: { hide: ["coupons[].bgColor"] },
  header: { hide: ["topbar[].phone", "topbar[].email", "topbar[].showSocials", "topbar[].socialLinks"], keep: ["v1", "v2"], variantLabels: { v1: "Search row and category bar", v2: "One row" } },
  footer: { hide: ["paymentMethods[].icon"], variantLabels: { v1: "Product lists", v2: "Compact" } },
  // Theme tab: button settings no part of this theme reads (colours and corner radius drive every button).
  buttons: { hide: ["appearance.buttons.primary[].height", "appearance.buttons.primary[].paddingX", "appearance.buttons.primary[].label", "appearance.buttons.outline[].height", "appearance.buttons.outline[].paddingX", "appearance.buttons.outline[].label", "appearance.buttons.outline[].hoverBg"] },
  // Delivery time is shown on product cards only by Prottoho.
  "store-info": { hide: ["deliveryEta"] }
}, Yk = {
  type: "account",
  label: "Account Section",
  description: "User dashboard with orders, addresses, and profile settings.",
  supportedPages: ["account"],
  variants: [
    { id: "v1", label: "V1 (Sidebar + Content)" },
    { id: "v2", label: "Order History" },
    { id: "v3", label: "Address Book" }
  ],
  commonFields: [
    { key: "tabOverviewLabel", label: "Overview Tab Label", type: "string", default: "Overview" },
    { key: "tabOrdersLabel", label: "Orders Tab Label", type: "string", default: "Orders" },
    { key: "tabAddressesLabel", label: "Addresses Tab Label", type: "string", default: "Addresses" },
    { key: "tabDetailsLabel", label: "Profile Tab Label", type: "string", default: "Profile" },
    { key: "signOutLabel", label: "Sign Out Label", type: "string", default: "Sign Out" },
    { key: "signinRedirectPath", label: "Sign In Redirect Path", type: "string", default: "/signin" }
  ]
}, pn = {
  type: "signin",
  label: "Signin Section",
  description: "Login form with phone/OTP flow and two-column layout.",
  supportedPages: ["signin"],
  variants: [{ id: "v1", label: "V1 (Two Column)" }],
  commonFields: [
    { key: "redirectUrl", label: "Redirect After Login", type: "string", default: "/account" }
  ]
}, un = {
  type: "signup",
  label: "Signup Section",
  description: "Registration form with phone/OTP flow and two-column layout.",
  supportedPages: ["signup"],
  variants: [{ id: "v2", label: "V2 (Two Column)" }],
  commonFields: [
    { key: "redirectUrl", label: "Redirect After Signup", type: "string", default: "/account" }
  ]
}, Oo = [
  "home",
  "shop",
  "product",
  "category",
  "categories",
  "cart",
  "checkout",
  "contact",
  "signin",
  "signup",
  "account",
  "wishlist",
  "track-order",
  "order-success",
  "privacy-policy",
  "terms-of-service",
  "shipping-policy",
  "return-policy",
  "order-detail"
], vl = [
  { key: "id", label: "ID", type: "string" },
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link", type: "string" }
], Xk = [
  { key: "id", label: "ID", type: "string" },
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link URL", type: "string" },
  {
    key: "type",
    label: "Type",
    type: "select",
    options: [
      { label: "Standard Link", value: "link" },
      { label: "Dropdown", value: "dropdown" },
      { label: "Mega Menu", value: "mega-menu" }
    ]
  },
  {
    key: "children",
    label: "Dropdown Items",
    type: "array",
    itemSchema: vl,
    dependency: { field: "type", value: "dropdown" }
  },
  {
    key: "columns",
    label: "Mega Menu Columns",
    type: "array",
    itemSchema: [
      { key: "title", label: "Column Title", type: "string" },
      { key: "items", label: "Links", type: "array", itemSchema: vl }
    ],
    dependency: { field: "type", value: "mega-menu" }
  },
  {
    key: "featuredImage",
    label: "Featured Image",
    type: "object",
    fields: [
      { key: "src", label: "Image", type: "image" },
      { key: "title", label: "Title", type: "string" },
      { key: "href", label: "Link", type: "string" }
    ],
    dependency: { field: "type", value: "mega-menu" }
  }
], jr = [
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "text" },
  { key: "image", label: "Background Image", type: "image" },
  { key: "ctaText", label: "Button Text", type: "string" },
  { key: "ctaLink", label: "Button Link", type: "string" },
  { key: "badge", label: "Badge Text", type: "string" }
], Ie = [
  {
    key: "styles.paddingTop",
    label: "Padding Top",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.paddingBottom",
    label: "Padding Bottom",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.background",
    label: "Background",
    type: "select",
    options: [
      { label: "None (theme default)", value: "default" },
      { label: "Light grey", value: "muted" },
      { label: "Brand tint", value: "primary" }
    ],
    default: "default"
  }
], jk = [
  {
    key: "icon",
    label: "Icon (truck | shield | lock)",
    type: "string"
  },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" }
], qk = [
  { key: "image", label: "Picture", type: "image", help: "Wide, about 1240 × 310 px (two side by side: 2:1); may carry its own artwork." },
  { key: "title", label: "Caption title (optional)", type: "string" },
  { key: "subtitle", label: "Caption line (optional)", type: "string" },
  { key: "ctaText", label: "Link text (optional)", type: "string" },
  { key: "ctaLink", label: "Link", type: "string" }
], Zk = [
  { key: "image", label: "Picture", type: "image", help: "Square, about 800 × 800 px; may carry its own artwork." },
  { key: "alt", label: "Picture description", type: "string", help: "What the picture shows, for screen readers." },
  { key: "title", label: "Title over the picture (optional)", type: "string" },
  { key: "ctaLink", label: "Link", type: "string", placeholder: "/shop" }
], Jk = {
  type: "banner",
  label: "Banner Section",
  description: "Promo feature strip, side-by-side image banners or a row of square picture tiles.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "Selling points strip",
      fields: [
        { key: "columns", label: "Feature Columns", type: "array", itemSchema: jk }
      ]
    },
    {
      id: "v2",
      label: "Two picture banners",
      fields: [
        { key: "banners", label: "Promo Banners (max 2)", type: "array", itemSchema: qk }
      ]
    },
    {
      id: "v3",
      label: "Square picture tiles",
      fields: [
        { key: "title", label: "Section title", type: "string" },
        { key: "banners", label: "Picture tiles (up to 4)", type: "array", itemSchema: Zk }
      ]
    }
  ],
  commonFields: [...Ie]
}, Kk = {
  type: "cart",
  label: "Cart Section",
  description: "The shopping cart page section.",
  supportedPages: ["cart"],
  variants: [{ id: "v1", label: "V1 (Apparels)" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Shopping Cart" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading cart items..." },
    { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty State Message", type: "string", default: "Browse our products and add items to your cart." },
    { key: "continueShoppingText", label: "Continue Shopping Button Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingLabel", label: "Shipping Label", type: "string", default: "Shipping" },
    { key: "shippingCalculatedText", label: "Shipping Calculated Text", type: "string", default: "Calculated at checkout" },
    { key: "taxLabel", label: "Tax Label", type: "string", default: "Tax" },
    { key: "totalLabel", label: "Total Label", type: "string", default: "Total" },
    { key: "checkoutButtonText", label: "Checkout Button Text", type: "string", default: "Proceed to Checkout" },
    { key: "checkoutLink", label: "Checkout Link", type: "string", default: "/checkout" },
    { key: "secureCheckoutText", label: "Secure Checkout Label", type: "string", default: "SSL Secure Checkout" }
  ]
}, Qk = {
  type: "categories",
  label: "Categories",
  description: "Category photo tiles, or a slim shortcut strip of top categories with a promo line.",
  supportedPages: ["home", "categories", "shop"],
  variants: [
    {
      id: "v1",
      label: "Photo tiles",
      fields: [
        { key: "subtitle", label: "Subtitle", type: "string" },
        {
          key: "columns",
          label: "Columns",
          type: "select",
          options: [
            { label: "2 Columns", value: 2 },
            { label: "3 Columns", value: 3 },
            { label: "4 Columns", value: 4 },
            { label: "5 Columns", value: 5 },
            { label: "6 Columns", value: 6 }
          ],
          default: 4
        },
        { key: "emptyText", label: "Empty Text", type: "string", default: "No categories found." }
      ]
    },
    {
      id: "v2",
      label: "Shortcut strip",
      fields: [
        { key: "limit", label: "Categories shown", type: "number", default: 3, help: "Your first top-level categories." },
        { key: "promoText", label: "Promo line", type: "string", default: "Cash on delivery all over the country" },
        { key: "promoLink", label: "Promo link", type: "string", placeholder: "/shop" }
      ]
    }
  ],
  commonFields: [
    { key: "title", label: "Title (strip: the label on the left)", type: "string" },
    ...Ie
  ]
}, ew = {
  type: "category",
  label: "Category Listing",
  description: "Single category page: breadcrumb, header, product grid with filters.",
  supportedPages: ["category", "shop"],
  variants: [{ id: "v1", label: "V1 (Sidebar + Grid)" }],
  commonFields: [
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "initialPriceRange.min", label: "Price Range Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Price Range Max", type: "number", default: 5e4 },
    { key: "showBreadcrumb", label: "Show Breadcrumb", type: "boolean", default: !0 },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...Ie
  ]
}, tw = {
  type: "checkout",
  label: "Checkout Section",
  description: "The order checkout page section.",
  supportedPages: ["checkout"],
  variants: [{ id: "v1", label: "V1 (Apparels)" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Checkout" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Preparing checkout..." },
    { key: "emptyTitle", label: "Empty Cart Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty Cart Message", type: "string", default: "Checkout is only available for shopping carts with items." },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingChargeLabel", label: "Shipping Charge Label", type: "string", default: "Shipping Charge" },
    { key: "shippingCalculatingText", label: "Shipping Calculating Text", type: "string", default: "Calculating..." },
    { key: "totalLabel", label: "Total Amount Label", type: "string", default: "Total Amount" },
    { key: "placeOrderText", label: "Place Order Button Text", type: "string", default: "Place Order" },
    { key: "placingOrderText", label: "Placing Order Loading Text", type: "string", default: "Placing Order..." },
    { key: "securePaymentText", label: "Secure Payment Label", type: "string", default: "SSL Secure Payment" }
  ]
}, aw = ["phone", "whatsapp", "messenger", "mail", "map-pin", "store", "clock"].map((e) => ({ label: e.replace("-", " "), value: e })), ow = {
  type: "contact",
  label: "Contact Section",
  description: "Contact page: channel cells, a location band with the address and a map, and a message form.",
  supportedPages: ["contact"],
  variants: [{ id: "v1", label: "Channels, location and form" }],
  commonFields: [
    { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "Pick a way in" },
    { key: "title", label: "Title", type: "string", default: "Get in" },
    { key: "highlight", label: "Highlighted words", type: "localized-string", default: "touch.", help: "Shown on the accent fill on their own line under the title." },
    { key: "description", label: "Description", type: "text", default: "For the quickest help, keep your order number or phone number to hand when you get in touch." },
    {
      key: "channels",
      label: "Channels",
      type: "array",
      help: "Leave empty to show your Store info phone, WhatsApp, email and address. A channel without a link goes to the phone, WhatsApp, email or location by its icon.",
      itemSchema: [
        { key: "icon", label: "Icon", type: "select", options: aw, default: "phone" },
        { key: "label", label: "Small label", type: "localized-string", placeholder: "Call" },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "text", label: "Line", type: "localized-text" },
        { key: "linkText", label: "Link text", type: "localized-string", help: "Empty: the phone number, email or a default text." },
        { key: "link", label: "Link", type: "string", placeholder: "https://m.me/yourpage" }
      ],
      default: [
        { icon: "phone", label: "Call", title: "Call us", text: "Orders, sizes and delivery questions." },
        { icon: "whatsapp", label: "WhatsApp", title: "WhatsApp", text: "Send a quick message to the team.", linkText: "Chat on WhatsApp" },
        { icon: "mail", label: "Email", title: "Email us", text: "Bulk orders, partnerships and anything else." },
        { icon: "map-pin", label: "Visit", title: "Visit us", text: "Try the fits in person at our store.", linkText: "View location" }
      ]
    },
    { key: "email", label: "Email Address", type: "string" },
    { key: "phone", label: "Phone Number", type: "string" },
    { key: "address", label: "Physical Address", type: "text", help: "Empty: the addresses from Store info." },
    { key: "mapEyebrow", label: "Location eyebrow", type: "localized-string", default: "Visit the store" },
    { key: "mapTitle", label: "Location headline", type: "localized-string", default: "Come see us at" },
    { key: "mapOutline", label: "Location second line", type: "localized-string", default: "our store.", help: "Shown in muted text on its own line." },
    { key: "mapText", label: "Location line", type: "localized-text", default: "Drop by to try the fits, pick up an order or swap a size. Calling before you come helps." },
    { key: "mapImage", label: "Map picture", type: "image", help: "Optional: a picture of your map, about 4:3. Without one the address is shown in the frame." },
    { key: "mapLink", label: "Map link", type: "string", placeholder: "https://maps.app.goo.gl/…", help: "Empty: a map search for the first address." },
    { key: "mapLinkText", label: "Map link text", type: "localized-string", default: "Open in maps" },
    { key: "formEyebrow", label: "Form eyebrow", type: "localized-string", default: "Send a message" },
    { key: "formTitle", label: "Form headline", type: "localized-string", default: "Tell us what" },
    { key: "formHighlight", label: "Form highlighted words", type: "localized-string", default: "you need." },
    { key: "formText", label: "Form line", type: "localized-text", default: "Leave your name, a way to reach you and your message, and we will get back to you soon." }
  ]
}, rw = {
  type: "content",
  label: "Content / Policy Section",
  description: "Policies and other text pages, or a questions-and-answers block with a heading beside an accordion.",
  supportedPages: ["privacy-policy", "terms-of-service", "shipping-policy", "return-policy", "about", "contact"],
  variants: [
    { id: "v1", label: "V1 (Clean Layout)" },
    { id: "v2", label: "V2 (With Table of Contents)" },
    {
      id: "v3",
      label: "Questions (heading beside an accordion)",
      fields: [
        { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "Good to know" },
        { key: "highlight", label: "Highlighted words", type: "localized-string", default: "answered.", help: "Shown on the accent fill on their own line under the title." },
        { key: "subtitle", label: "Line under the heading", type: "localized-text", default: "The questions we hear most often, answered by the team." },
        { key: "helpText", label: "Help button text", type: "localized-string", default: "Need help?" },
        { key: "helpLink", label: "Help button link", type: "string", default: "/contact" },
        {
          key: "faqs",
          label: "Questions and answers",
          type: "array",
          help: "Shown as an accordion (also published as FAQ structured data).",
          itemSchema: [
            { key: "question", label: "Question", type: "string" },
            { key: "answer", label: "Answer", type: "text" }
          ],
          default: [
            { question: "How do I place an order?", answer: "Pick a size, add the piece to your cart and check out. You can also call or message us and we will place it for you." },
            { question: "Which payment methods can I use?", answer: "Cash on delivery, cards and mobile banking." },
            { question: "How long does delivery take?", answer: "Usually one to two days inside the city and three to five days elsewhere." },
            { question: "Can I swap a size?", answer: "Yes, within 7 days, as long as the piece is unworn with its tags on." }
          ]
        }
      ]
    }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "content", label: "HTML Content", type: "rich-text" }
  ]
}, lw = {
  type: "featured-category",
  label: "Featured Category",
  description: "A collection block: one tall captioned tile for a category beside a grid of its products and a View more tile.",
  supportedPages: ["home", "product", "cart"],
  variants: [
    { id: "v1", label: "Big tile left" },
    { id: "v2", label: "Big tile right" }
  ],
  commonFields: [
    { key: "categoryId", label: "Select Category", type: "category-select" },
    { key: "title", label: "Tile caption", type: "string", help: "Empty = the category name. With no category picked, the category with this exact name is shown." },
    { key: "subtitle", label: "Line above the caption", type: "string" },
    { key: "image", label: "Tile picture", type: "image", help: "Portrait. Empty = the category picture." },
    { key: "rows", label: "Rows of products (four each)", type: "number", default: 2 },
    { key: "viewAllText", label: "Last tile text", type: "string", default: "View more" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "noSelectionText", label: "No Category Selected Text", type: "string", default: "Please select a category in the editor settings." },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    ...Ie
  ]
}, iw = {
  type: "floating-buttons",
  label: "Floating Buttons",
  description: "Global floating buttons for quick actions (Call, WhatsApp, Messenger).",
  supportedPages: [...Oo],
  variants: [{ id: "v1", label: "Default" }],
  commonFields: [
    { key: "active", label: "Enable Floating Buttons", type: "boolean", default: !0 },
    { key: "phone", label: "Phone Number", type: "string", placeholder: "+8801..." },
    { key: "whatsapp", label: "WhatsApp Number", type: "string", placeholder: "+8801..." },
    { key: "messenger", label: "Messenger ID/Link", type: "string", placeholder: "m.me/..." },
    { key: "callUsTitle", label: "Call Button Tooltip", type: "string", default: "Call Us" },
    { key: "whatsappTitle", label: "WhatsApp Button Tooltip", type: "string", default: "WhatsApp" },
    { key: "messengerTitle", label: "Messenger Button Tooltip", type: "string", default: "Messenger" }
  ]
}, nw = {
  type: "footer",
  label: "Footer",
  description: "Site-wide footer: product lists, newsletter and social links, a row of links, payment badges and the copyright.",
  supportedPages: [...Oo],
  variants: [
    {
      id: "v1",
      label: "Product lists",
      fields: [
        {
          key: "productLists",
          label: "Product lists",
          type: "array",
          help: "Up to three short lists of products across the top of the footer, five each.",
          itemSchema: [
            { key: "title", label: "Heading", type: "string" },
            { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 5 } }
          ],
          default: [
            { title: "New in", source: { source: "new", limit: 5 } },
            { title: "Top rated", source: { source: "top_rated", limit: 5 } },
            { title: "On sale", source: { source: "on_sale", limit: 5 } }
          ]
        }
      ]
    },
    { id: "v2", label: "Compact" }
  ],
  commonFields: [
    { key: "logo", label: "Footer Logo", type: "image" },
    { key: "title", label: "Brand Name", type: "string", default: "Juta" },
    {
      key: "description",
      label: "Brand Description",
      type: "text",
      default: "Your destination for premium fashion and lifestyle products. Curated styles for the modern wardrobe."
    },
    {
      key: "columns",
      label: "Link Columns",
      type: "array",
      itemSchema: [
        { key: "title", label: "Column Title", type: "string" },
        { key: "links", label: "Links", type: "array", itemSchema: vl }
      ]
    },
    {
      key: "socialLinks",
      label: "Social Links",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Facebook", value: "facebook" },
            { label: "Instagram", value: "instagram" },
            { label: "Twitter", value: "twitter" },
            { label: "YouTube", value: "youtube" },
            { label: "LinkedIn", value: "linkedin" }
          ]
        },
        { key: "href", label: "Link", type: "string" }
      ]
    },
    { key: "contactAddress", label: "Address", type: "string" },
    { key: "contactPhone", label: "Phone", type: "string" },
    { key: "contactEmail", label: "Email", type: "string" },
    {
      key: "newsletterAction",
      label: "Newsletter form URL",
      type: "string",
      placeholder: "https://…",
      help: "Where the email sign-up is sent (your mailing-list provider's form). The sign-up only shows when this is set."
    },
    {
      key: "note",
      label: "Bottom bar message",
      type: "string",
      placeholder: "Packed with care and delivered to your door.",
      help: "One line above the copyright."
    },
    { key: "copyright", label: "Copyright Text", type: "string", default: "© 2025 Juta. All rights reserved." },
    {
      key: "paymentMethods",
      label: "Payment Methods",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Visa", value: "visa" },
            { label: "Mastercard", value: "mastercard" },
            { label: "Amex", value: "amex" },
            { label: "Stripe", value: "stripe" },
            { label: "PayPal", value: "paypal" },
            { label: "bKash", value: "bkash" },
            { label: "Nagad", value: "nagad" },
            { label: "Rocket", value: "rocket" }
          ]
        },
        { key: "icon", label: "Icon URL (optional)", type: "string" }
      ]
    }
  ]
}, yn = {
  type: "header",
  label: "Header",
  description: "Site-wide header with navigation, search, and cart.",
  supportedPages: [...Oo],
  variants: [
    { id: "v1", label: "Fashion (Default)" },
    { id: "v2", label: "Electronics" },
    { id: "v3", label: "Beauty / Minimal" },
    { id: "v4", label: "Jewelry / Elegant" }
  ],
  commonFields: [
    { key: "logo.alt", label: "Logo Alt Text", type: "string" },
    { key: "logo.src", label: "Logo Image", type: "image" },
    { key: "sticky", label: "Sticky Header", type: "boolean", default: !0 },
    {
      key: "topbar",
      label: "Top Bar",
      type: "object",
      fields: [
        { key: "active", label: "Enable Top Bar", type: "boolean", default: !0 },
        {
          key: "variant",
          label: "Variant",
          type: "select",
          options: [
            { label: "V1 (Centered Promo)", value: "v1" },
            { label: "V2 (Contact & Socials)", value: "v2" }
          ],
          default: "v1"
        },
        { key: "text", label: "Announcement Text", type: "string" },
        { key: "phone", label: "Phone Number", type: "string" },
        { key: "email", label: "Email Address", type: "string" },
        { key: "showSocials", label: "Show Social Icons", type: "boolean", default: !0 },
        {
          key: "socialLinks",
          label: "Social Links",
          type: "array",
          itemSchema: [
            { key: "platform", label: "Platform", type: "string" },
            { key: "href", label: "Link", type: "string" },
            { key: "icon", label: "Icon Name", type: "string" }
          ]
        },
        { key: "links", label: "Top Bar Links", type: "array", help: "The first two show on the right of the top bar.", itemSchema: vl }
      ]
    },
    {
      key: "actions",
      label: "Actions",
      type: "object",
      fields: [
        { key: "showSearch", label: "Show Search", type: "boolean", default: !0 },
        { key: "showCart", label: "Show Cart", type: "boolean", default: !0 },
        { key: "showAccount", label: "Show Account", type: "boolean", default: !0 },
        { key: "showWishlist", label: "Show Wishlist", type: "boolean", default: !0 },
        {
          key: "cartAction",
          label: "Cart Action",
          type: "select",
          options: [
            { label: "Slide-out Sidebar", value: "sidebar" },
            { label: "Go to Page", value: "page" }
          ],
          default: "sidebar"
        }
      ]
    },
    {
      key: "searchConfig",
      label: "Search Settings",
      type: "object",
      fields: [
        { key: "showPrice", label: "Show Price in Suggestions", type: "boolean", default: !0 },
        { key: "showCategory", label: "Show Category in Suggestions", type: "boolean", default: !0 },
        { key: "showImage", label: "Show Image in Suggestions", type: "boolean", default: !0 },
        { key: "maxResults", label: "Max Suggestions", type: "number", default: 6 }
      ]
    },
    { key: "menu", label: "Main Menu", type: "array", itemSchema: Xk }
  ]
}, sw = {
  type: "hero",
  label: "Hero Section",
  description: "The main attention-grabbing section at the top of the page.",
  supportedPages: ["home", "categories", "about", "contact"],
  variants: [
    {
      id: "v1",
      label: "V1 — Fashion Full-Height Slider",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: jr },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    },
    {
      id: "v2",
      label: "V2 — Electronics Two-Column Slider",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: jr },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    },
    {
      id: "v3",
      label: "V3 — Beauty Gradient Hero",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: jr }
      ]
    },
    {
      id: "v4",
      label: "V4 — Jewelry Dark Elegant Hero",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: jr }
      ]
    },
    {
      id: "v5",
      label: "Display (black band, headline and card)",
      fields: [
        { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "Shoes for every day", help: "Small line with a rule, above the headline." },
        { key: "headline", label: "Headline", type: "localized-string", default: "Built to walk." },
        { key: "highlight", label: "Highlighted words", type: "localized-string", default: "Made to be worn.", help: "Shown in the accent colour on their own line under the headline." },
        { key: "text", label: "Paragraph", type: "localized-text", default: "Sneakers, runners and everyday shoes in EU sizes, picked and checked by people who wear them." },
        { key: "ctaText", label: "Button text", type: "localized-string", default: "Our story" },
        { key: "ctaLink", label: "Button link", type: "string", default: "/about" },
        { key: "linkText", label: "Second link text", type: "localized-string", default: "Shop the drop" },
        { key: "linkHref", label: "Second link", type: "string", default: "/shop" },
        { key: "cardWord", label: "Card word", type: "localized-string", default: "Local", help: "A short word in big letters on the dark card." },
        { key: "cardText", label: "Card line", type: "localized-text", default: "Cut, sewn and printed close to home, in small runs." },
        { key: "cardLabel", label: "Card corner label (left)", type: "localized-string", default: "Dhaka" },
        { key: "cardLabelEnd", label: "Card corner label (right)", type: "localized-string", default: "Since 2024" }
      ]
    }
  ],
  commonFields: [...Ie]
}, cw = {
  type: "order-success",
  label: "Order Success Section",
  description: "The order confirmation page section.",
  supportedPages: ["order-success"],
  variants: [{ id: "v1", label: "V1 (Apparels)" }],
  commonFields: [
    { key: "title", label: "Success Title", type: "string", default: "Order Confirmed" },
    { key: "message", label: "Success Message", type: "text", default: "Your order has been placed successfully. We have sent a confirmation email with your order details." },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading order details..." },
    { key: "errorTitle", label: "Error Title", type: "string", default: "Order Not Found" },
    { key: "errorMessage", label: "Error Message", type: "string", default: "We could not find the order you are looking for." },
    { key: "viewOrderText", label: "View Order Button Text", type: "string", default: "View Order Status" },
    { key: "viewOrderLink", label: "View Order Link", type: "string", default: "/account/orders" },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" }
  ]
}, hn = {
  type: "product-detail",
  label: "Product Detail",
  description: "The main product information page section.",
  supportedPages: ["product"],
  variants: [
    { id: "v1", label: "V1 (Standard)" },
    { id: "v2", label: "V2 (With Countdown Timer)" },
    { id: "v3", label: "V3 (With Color/Size Swatches)" },
    { id: "v4", label: "Countdown Sale" },
    { id: "v5", label: "Swatches" },
    { id: "v6", label: "Video Gallery" }
  ],
  commonFields: [
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading..." },
    { key: "notFoundCode", label: "Not Found Code", type: "string", default: "404" },
    { key: "notFoundText", label: "Not Found Text", type: "string", default: "Product Not Found" },
    { key: "quantityLabel", label: "Quantity Label", type: "string", default: "Quantity" },
    { key: "addToCartText", label: "Add to Cart Button Text", type: "string", default: "Add to Cart" },
    { key: "orderNowText", label: "Order Now Button Text", type: "string", default: "Buy Now" },
    { key: "productDescTitle", label: "Product Description Accordion Title", type: "string", default: "Product Description" },
    { key: "returnPolicyTitle", label: "Return Policy Accordion Title", type: "string", default: "Return Policy" },
    { key: "countdownLabel", label: "Countdown Label (V2 only)", type: "string", default: "Offer ends in:" },
    { key: "saleEndDate", label: "Sale End Date", type: "string", placeholder: "2025-12-31T23:59:59" },
    { key: "videoUrl", label: "Product Video URL", type: "string", placeholder: "https://..." },
    ...Ie
  ]
}, dw = {
  type: "mobileBottomNav",
  label: "Mobile Navigation",
  description: "Bottom navigation bar for mobile devices.",
  supportedPages: [...Oo],
  variants: [{ id: "v1", label: "V1 (Default)" }],
  commonFields: [
    { key: "active", label: "Show Bottom Nav", type: "boolean" },
    {
      key: "items",
      label: "Nav Items",
      type: "array",
      itemSchema: [
        { key: "label", label: "Label", type: "string" },
        {
          key: "icon",
          label: "Icon Type",
          type: "select",
          options: [
            { label: "Home", value: "home" },
            { label: "Shop (Bag)", value: "shop" },
            { label: "Search", value: "search" },
            { label: "Cart", value: "cart" },
            { label: "User / Account", value: "account" },
            { label: "Heart / Wishlist", value: "heart" },
            { label: "Chat (WhatsApp)", value: "chat" },
            { label: "Menu / Hamburger", value: "menu" },
            { label: "Plus / Create", value: "plus" }
          ]
        },
        {
          key: "actionType",
          label: "Action Type",
          type: "select",
          options: [
            { label: "Link (Direct URL)", value: "link" },
            { label: "Open Search Drawer", value: "search" },
            { label: "Open Categories Sidebar", value: "categories" }
          ]
        },
        { key: "href", label: "Target URL", type: "string" },
        { key: "isPrimary", label: "Highlight as Primary (Middle)", type: "boolean" }
      ]
    }
  ]
}, pw = {
  type: "similar-products",
  label: "Similar Products",
  description: "A row of related products shown on the product page.",
  supportedPages: ["product"],
  variants: [{ id: "v1", label: "V1 (Grid Row)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Similar Products" },
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    ...Ie
  ]
}, uw = {
  type: "shop-grid",
  label: "Shop Grid",
  description: "The main product list with sidebar filters.",
  supportedPages: ["shop", "category", "cart", "checkout", "categories"],
  variants: [
    { id: "v1", label: "V1 (Left Sidebar + Grid)" },
    { id: "v2", label: "V2 (Full-width Grid, Slide-in Filters)" }
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "initialPriceRange.min", label: "Initial Price Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Initial Price Max", type: "number", default: 5e4 },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "allCategoriesLabel", label: "All Categories Label", type: "string", default: "All" },
    { key: "filtersButtonLabel", label: "Filters Button Label", type: "string", default: "Filters" },
    { key: "showingLabel", label: "Showing Label (prefix)", type: "string", default: "Showing" },
    { key: "productsSuffix", label: "Products Count Suffix", type: "string", default: "Products" },
    { key: "sortNewestLabel", label: "Sort: Newest Label", type: "string", default: "Sort: Newest" },
    { key: "sortOldestLabel", label: "Sort: Oldest Label", type: "string", default: "Sort: Oldest" },
    { key: "sortPriceAscLabel", label: "Sort: Price Low-High Label", type: "string", default: "Price: Low to High" },
    { key: "sortPriceDescLabel", label: "Sort: Price High-Low Label", type: "string", default: "Price: High to Low" },
    { key: "sortNameAscLabel", label: "Sort: Name A-Z Label", type: "string", default: "Name: A-Z" },
    { key: "sortNameDescLabel", label: "Sort: Name Z-A Label", type: "string", default: "Name: Z-A" },
    { key: "activeFiltersLabel", label: "Active Filters Label", type: "string", default: "Active Filters:" },
    { key: "clearAllLabel", label: "Clear All Label", type: "string", default: "Clear All" },
    { key: "noProductsTitle", label: "No Products Title", type: "string", default: "No Products Found" },
    { key: "noProductsMessage", label: "No Products Message", type: "string", default: "We couldn't find any products matching your current filters." },
    { key: "backToAllText", label: "Back to All Products Text", type: "string", default: "Back to All Products" },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "currentSearchLabel", label: "Current Search Label", type: "string", default: "Current Search" },
    { key: "clearSearchLabel", label: "Clear Search Label", type: "string", default: "Clear" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...Ie
  ]
}, yw = {
  type: "wishlist",
  label: "Wishlist Section",
  description: "Displays saved/wishlisted products in a grid layout.",
  supportedPages: ["wishlist"],
  variants: [
    {
      id: "v1",
      label: "V1 (Grid)",
      fields: [
        { key: "title", label: "Page Title", type: "string", default: "My Wishlist" },
        { key: "subtitle", label: "Eyebrow Text", type: "string", default: "Saved items" },
        { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Nothing saved yet" },
        { key: "emptyText", label: "Empty State Description", type: "string", default: "Start exploring and save the items you love." },
        { key: "continueShoppingText", label: "CTA Text", type: "string", default: "Start Shopping" },
        { key: "continueShoppingLink", label: "CTA Link", type: "string", default: "/shop" }
      ]
    }
  ],
  commonFields: []
}, hw = [
  { key: "lead", label: "Lead word (optional)", type: "string", placeholder: "Free delivery" },
  { key: "text", label: "Message Text", type: "string" },
  { key: "code", label: "Coupon Code (optional)", type: "string" },
  { key: "linkLabel", label: "Link text", type: "string", placeholder: "Click here" },
  { key: "link", label: "Link (optional)", type: "string", placeholder: "/shop" }
], bw = {
  type: "announcement-bar",
  label: "Announcement Bar",
  description: "A black bar with a bold lead phrase, one line and links, or an accent band of words scrolling past.",
  supportedPages: [
    "home",
    "shop",
    "product",
    "category",
    "categories",
    "cart",
    "checkout",
    "contact",
    "wishlist"
  ],
  variants: [
    {
      id: "v1",
      label: "Black bar",
      fields: [
        { key: "items", label: "Announcement Items", type: "array", itemSchema: hw },
        { key: "bgColor", label: "Background Color", type: "string", default: "#0989FF" },
        { key: "textColor", label: "Text Color", type: "string", default: "#ffffff" }
      ]
    },
    {
      id: "v2",
      label: "Scrolling band",
      fields: [
        {
          key: "items",
          label: "Words",
          type: "array",
          help: "Short words or phrases that scroll across an accent band, a star between each.",
          itemSchema: [{ key: "text", label: "Word or phrase", type: "string" }]
        }
      ]
    }
  ],
  commonFields: [...Ie]
}, mw = [
  { key: "id", label: "Product ID", type: "string" },
  { key: "name", label: "Product Name", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "originalPrice", label: "Original Price", type: "number" },
  { key: "salePrice", label: "Sale Price", type: "number" },
  { key: "discount", label: "Discount %", type: "number" }
], gw = {
  type: "flash-sale",
  label: "Flash Sale",
  description: "Countdown timer with a horizontal product row for time-limited offers.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "V1 — Countdown + Product Row",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Flash Sale" },
        { key: "endDate", label: "Sale End Date (ISO)", type: "string", placeholder: "2025-12-31T23:59:59" },
        { key: "bgColor", label: "Header Background Color", type: "color", default: "#1a1a2e" },
        { key: "products", label: "Products", type: "array", itemSchema: mw }
      ]
    }
  ],
  commonFields: [...Ie]
}, fw = [
  { key: "id", label: "Product ID", type: "string" },
  { key: "name", label: "Product Name", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "price", label: "Price", type: "number" },
  { key: "originalPrice", label: "Original Price", type: "number" },
  { key: "badge", label: "Badge Text", type: "string" }
], vw = {
  type: "new-arrivals",
  label: "New Arrivals",
  description: "A grid of the newest products: square photos, six across, with name and price.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "Photo grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Fresh styles just landed" },
        { key: "products", label: "Products", type: "array", itemSchema: fw },
        { key: "limit", label: "Products shown", type: "number", default: 12, help: "Six fill one row on desktop." },
        { key: "showDetails", label: "Show name and price", type: "boolean", default: !0 }
      ]
    }
  ],
  commonFields: [...Ie]
}, kw = {
  type: "offer-banner",
  label: "Offer Banner",
  description: "A mint banner with a headline, a line and a button, and an optional picture on the right.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "Mint banner",
      fields: [
        { key: "image", label: "Small picture before the text (optional)", type: "image", help: "Payment artwork or a logo, shown at most 32px tall." },
        { key: "title", label: "Title", type: "string", default: "Special Offer" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Get up to 50% off on selected items" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" }
      ]
    }
  ],
  commonFields: [...Ie]
}, bn = {
  type: "lookbook-banner",
  label: "Lookbook Banner",
  description: "Editorial banner — split image/text (V1) or full-width overlay (V2).",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "Photo beside text",
      fields: [
        { key: "image", label: "Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The New Collection" },
        { key: "subtitle", label: "Subtitle", type: "text" },
        { key: "ctaText", label: "Button Text", type: "string", default: "View Lookbook" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        {
          key: "imagePosition",
          label: "Image Position",
          type: "select",
          options: [
            { label: "Left", value: "left" },
            { label: "Right", value: "right" }
          ],
          default: "left"
        }
      ]
    },
    {
      id: "v2",
      label: "Full-width photo banner",
      fields: [
        { key: "image", label: "Background Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The Collection" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Discover the new season" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        { key: "overlayOpacity", label: "Overlay Opacity (0–100)", type: "number", default: 40 }
      ]
    }
  ],
  commonFields: [...Ie]
}, qr = [
  { key: "image", label: "Image", type: "image" },
  { key: "link", label: "Link URL", type: "string" }
], ww = [
  { key: "image", label: "Poster", type: "image", help: "Tall, about 800 × 1000 px (4:5)." },
  { key: "caption", label: "Caption (optional)", type: "string", help: "Shown under the poster; also describes it for screen readers." },
  { key: "link", label: "Link", type: "string", placeholder: "/shop" }
], Sw = {
  type: "instagram-feed",
  label: "Instagram Feed",
  description: "Display a grid of Instagram photos with hover effects, or a carousel of portrait posters.",
  supportedPages: [...Oo],
  variants: [
    {
      id: "v1",
      label: "Photo strip",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle (e.g. @yourstore)", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: qr }
      ]
    },
    {
      id: "v2",
      label: "Photo strip, handle on hover",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: qr }
      ]
    },
    {
      id: "v3",
      label: "Four large tiles",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: qr }
      ]
    },
    {
      id: "v4",
      label: "Mosaic",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: qr }
      ]
    },
    {
      id: "v5",
      label: "Poster carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Highlights" },
        { key: "handle", label: "Small line above the title (optional)", type: "string" },
        { key: "items", label: "Posters", type: "array", itemSchema: ww }
      ]
    }
  ],
  commonFields: [...Ie]
}, qc = [
  { key: "title", label: "Title", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "excerpt", label: "Excerpt", type: "text" },
  { key: "slug", label: "Slug", type: "string" },
  { key: "date", label: "Date", type: "string" },
  { key: "category", label: "Category", type: "string" }
], xw = {
  type: "blog",
  label: "Blog Posts",
  description: "Display a grid or list of blog post cards.",
  supportedPages: [...Oo],
  variants: [
    {
      id: "v1",
      label: "V1 — 3-Column Card Grid (Fashion Style)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: qc },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: !0 }
      ]
    },
    {
      id: "v2",
      label: "V2 — List Style (Electronics Style)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: qc },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: !0 }
      ]
    },
    {
      id: "v3",
      label: "Article Detail",
      fields: []
    }
  ],
  commonFields: [
    { key: "source", label: "Posts to show", type: "select", options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." },
    ...Ie
  ]
}, fi = [
  {
    key: "icon",
    label: "Icon",
    type: "select",
    options: [
      { label: "Shipping Truck", value: "shipping" },
      { label: "Return Arrow", value: "refund" },
      { label: "Support Headset", value: "support" },
      { label: "Security Lock", value: "secure" },
      { label: "Gift Box", value: "gift" }
    ],
    default: "shipping"
  },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" }
], Tw = [
  { key: "title", label: "Value", type: "localized-string", help: "A number or a short word, e.g. 2024." },
  { key: "subtitle", label: "Caption", type: "localized-string" }
], Cw = [
  {
    key: "icon",
    label: "Icon",
    type: "select",
    options: ["sparkle", "star", "heart", "check", "shield", "truck", "package", "store", "map-pin", "tag", "user", "clock"].map((e) => ({ label: e.replace("-", " "), value: e })),
    default: "sparkle"
  },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "subtitle", label: "Line", type: "localized-text" }
], Pw = {
  type: "features",
  label: "Features Strip",
  description: "Trust-building feature strip showing shipping, returns, support, and security highlights.",
  supportedPages: ["home", "shop", "categories", "about", "contact"],
  variants: [
    {
      id: "v1",
      label: "V1 — Compact Horizontal Strip",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: fi },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (Light Gray)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" }
          ],
          default: "default"
        }
      ]
    },
    {
      id: "v2",
      label: "V2 — Spaced Cards",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: fi },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (White)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" }
          ],
          default: "default"
        }
      ]
    },
    {
      id: "v3",
      label: "V3 — Jewelry Minimal Centered",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: fi }
      ]
    },
    {
      id: "v4",
      label: "Stat row",
      fields: [
        {
          key: "items",
          label: "Figures",
          type: "array",
          itemSchema: Tw,
          default: [
            { title: "2024", subtitle: "The first drop" },
            { title: "Dhaka", subtitle: "Where we pack and ship" },
            { title: "40+", subtitle: "Styles in stock" },
            { title: "7 days", subtitle: "To swap a size" }
          ]
        }
      ]
    },
    {
      id: "v5",
      label: "Numbered cells on a black band",
      fields: [
        { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "Why people pick us" },
        { key: "title", label: "Heading", type: "localized-string", default: "Made with" },
        { key: "highlight", label: "Highlighted words", type: "localized-string", default: "fit the first time.", help: "Shown on the accent fill on their own line under the heading." },
        { key: "text", label: "Line beside the heading", type: "localized-text", default: "Every piece starts with the street it is worn on: what people wear, how they move and what they want to say." },
        {
          key: "items",
          label: "Cells",
          type: "array",
          itemSchema: Cw,
          default: [
            { icon: "sparkle", title: "Honest sizing", subtitle: "EU sizes and a fit note on every product." },
            { icon: "star", title: "New every week", subtitle: "Fresh pairs and colourways every Friday." },
            { icon: "shield", title: "Built to last", subtitle: "Heavy cotton and double stitching that keep their shape." },
            { icon: "heart", title: "Fair prices", subtitle: "Good shoes you can wear every day." }
          ]
        }
      ]
    }
  ],
  commonFields: [...Ie]
}, Zc = [
  { key: "avatar", label: "Avatar Image", type: "image" },
  { key: "name", label: "Name", type: "string" },
  { key: "designation", label: "Designation", type: "string" },
  { key: "review", label: "Review Text", type: "text" },
  { key: "rating", label: "Rating (1–5)", type: "number", default: 5 }
], Aw = [
  { key: "avatar", label: "Portrait photo", type: "image", help: "Tall, about 800 × 1000 px (4:5)." },
  { key: "name", label: "Name", type: "string" },
  { key: "designation", label: "Role", type: "string", help: "Shown after the name, e.g. “Musician”." }
], Lw = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer reviews and social proof section.",
  supportedPages: ["home", "shop"],
  variants: [
    {
      id: "v1",
      label: "Quote slider",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "What Our Customers Say" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: Zc }
      ]
    },
    {
      id: "v2",
      label: "Quote cards",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Customer Reviews" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: Zc }
      ]
    },
    {
      id: "v3",
      label: "Portrait carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Worn on our streets" },
        { key: "intro", label: "Intro line", type: "text", help: "Put *stars* around words to show them bold." },
        { key: "items", label: "People", type: "array", itemSchema: Aw }
      ]
    }
  ],
  commonFields: [...Ie]
}, Mw = {
  type: "cta",
  label: "Call to Action",
  description: "A full-width picture banner with a link, or an accent band with a headline and a quote card.",
  supportedPages: ["home", "shop", "categories", "about", "contact"],
  variants: [
    {
      id: "v1",
      label: "Picture banner",
      fields: [
        { key: "image", label: "Picture", type: "image", help: "Wide, about 1240 × 200 px; may carry its own artwork." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional, about 780 × 340 px." },
        { key: "link", label: "Link", type: "string", default: "/contact" },
        { key: "title", label: "Heading (optional)", type: "string", default: "Become a reseller" },
        { key: "subtitle", label: "Line (optional)", type: "string", default: "Sell our shoes and earn on every order." },
        { key: "buttonText", label: "Button text (optional)", type: "string", default: "Join now" }
      ]
    },
    {
      id: "v2",
      label: "Quote band",
      fields: [
        { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "What comes next" },
        { key: "title", label: "Headline", type: "string", default: "From our street" },
        { key: "outline", label: "Second line", type: "localized-string", default: "to yours.", help: "On its own line under the headline, in a lighter weight." },
        { key: "subtitle", label: "Paragraph", type: "text", default: "We want to keep finding shoes that fit well, last long and cost fairly, for more feet in more cities." },
        { key: "quote", label: "Quote", type: "localized-string", default: "Wear it loud." },
        { key: "quoteText", label: "Line under the quote", type: "localized-text", default: "More than a slogan: the reason every pair is checked before it ships." }
      ]
    }
  ],
  commonFields: [...Ie]
}, Nw = [
  { key: "logo", label: "Logo Image", type: "image" },
  { key: "name", label: "Brand Name", type: "string" },
  { key: "link", label: "Brand URL", type: "string" }
], Ew = {
  type: "brands",
  label: "Brand Logos",
  description: "An intro line, then partner or brand logos in a carousel with arrows or an auto-scrolling strip.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "Logos",
      fields: [
        { key: "title", label: "Intro line", type: "string" },
        { key: "subtitle", label: "Paragraph", type: "string" },
        {
          key: "layout",
          label: "Layout",
          type: "select",
          options: [
            { label: "Carousel with arrows", value: "grid" },
            { label: "Auto-scroll Ticker", value: "ticker" }
          ],
          default: "grid"
        },
        { key: "items", label: "Brand Items", type: "array", itemSchema: Nw }
      ]
    }
  ],
  commonFields: [...Ie]
}, Dw = [
  { key: "label", label: "Tab Label", type: "string" },
  { key: "categoryId", label: "Category", type: "category-select", help: "Empty = the newest products." }
], Fw = {
  type: "product-slider",
  label: "Product Slider",
  description: "A horizontal scrolling product carousel with optional tabs.",
  supportedPages: ["home", "category", "categories"],
  variants: [
    {
      id: "v1",
      label: "Tabbed product grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Shop by style" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "" },
        { key: "tabs", label: "Tabs", type: "array", itemSchema: Dw },
        { key: "viewAllLabel", label: "“Explore more” button text", type: "string", default: "Explore more", help: "Links to the open tab’s category, else to the newest products." }
      ]
    },
    {
      id: "v2",
      label: "Swipe row, three across",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New in" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "" },
        { key: "launchAt", label: "Launch date (optional)", type: "string", placeholder: "2026-12-01T10:00", help: 'Shows a "Drops in…" tag in the title row until then, "Out now" for a week after.' }
      ]
    },
    {
      id: "v3",
      label: "Swipe row, four across",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Launches" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "" },
        { key: "launchAt", label: "Launch date (optional)", type: "string", placeholder: "2026-12-01T10:00", help: 'Shows a "Drops in…" tag in the title row until then, "Out now" for a week after.' }
      ]
    }
  ],
  commonFields: [...Ie]
}, Iw = {
  type: "product-grid",
  label: "Product Grid",
  description: "A product grid section with multiple layout variants.",
  supportedPages: ["home", "category", "categories", "shop"],
  variants: [
    {
      id: "v1",
      label: "V1 — 4-Col Standard Grid (Fashion)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "All Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Customer Favorite Style" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v2",
      label: "V2 — Featured + List Aside (Week's Featured)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Week's Featured" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Top Picks" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v3",
      label: "V3 — Electronics List View + Sidebar",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Trending Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Electronics" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v4",
      label: "V4 — Gadget Showcase (1 Large + Smaller Cards)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Top Gadgets" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "New Arrivals" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v5",
      label: "V5 — Beauty 4-Col Image-Focused",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Beauty Essentials" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Trending Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v6",
      label: "V6 — Trending List + Special Offer with Countdown",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "This Week's Picks" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Hot Right Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" },
        { key: "offerEndsAt", label: "Offer End Date (ISO string)", type: "string" }
      ]
    }
  ],
  commonFields: [...Ie]
}, Ow = {
  type: "compare",
  label: "Product Comparison",
  description: "A lookbook line sheet comparing up to 4 pieces side by side: 3:4 photo, brand and name, sale price with % off (cheapest marked), colour swatches, size chips, fit, fabric and other attributes, category and brand, a show-differences-only switch, Add to bag and remove.",
  supportedPages: ["compare"],
  variants: [
    {
      id: "v1",
      label: "Table"
    }
  ],
  commonFields: [...Ie]
}, Rw = {
  type: "coupon",
  label: "Coupons",
  description: "A grid of coupon cards with discount code, title, description, expiry date, and a copy-to-clipboard button.",
  supportedPages: ["coupon"],
  variants: [
    {
      id: "v1",
      label: "Card Grid"
    }
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Available Coupons" },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Coupon Code", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Description", type: "text" },
        { key: "expiryDate", label: "Expiry Date", type: "string" },
        { key: "discount", label: "Discount (e.g. 20% or Free Shipping)", type: "string" },
        { key: "bgColor", label: "Badge Background Color", type: "color" }
      ]
    },
    ...Ie
  ]
}, Bw = {
  type: "recent-products",
  label: "Recently Viewed Products",
  description: "A horizontal slider of products the visitor has recently viewed (stored in localStorage — no API call).",
  supportedPages: ["home", "shop", "product", "category", "cart"],
  variants: [{ id: "v1", label: "V1 (Horizontal Slider)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Recently Viewed" }
  ]
}, zw = {
  key: "messages",
  label: "Top bar messages",
  type: "array",
  help: "Shown on the left of the black top bar (phones show the first). Put *stars* around a phrase to make it bold. Without messages the announcement text is used.",
  itemSchema: [
    { key: "text", label: "Text", type: "localized-string" },
    { key: "link", label: "Link", type: "string" }
  ]
}, Vw = { key: "badge", label: "Badge", type: "string", placeholder: "New", help: "Small label next to the item." }, Ww = { key: "searchPlaceholder", label: "Search label", type: "string", placeholder: "Search" }, $w = (e) => [
  ...e.map((t) => t.key === "type" && t.options && !t.options.some((a) => a.value === "categories") ? { ...t, options: [...t.options, { label: "Shop panel (store categories)", value: "categories" }] } : t),
  Vw
], _w = {
  ...yn,
  commonFields: yn.commonFields.flatMap((e) => e.key === "topbar" && e.fields ? [{ ...e, fields: [...e.fields, zw] }] : e.key === "menu" && e.itemSchema ? [{ ...e, itemSchema: $w(e.itemSchema) }] : e.key === "actions" ? [e, Ww] : [e])
}, Ua = ["home", "shop", "category", "categories", "product", "cart", "blog"], Hw = ["truck", "cash", "phone", "shield", "star", "heart", "package", "check", "store", "map-pin", "mail", "sparkle", "clock", "bag", "user", "search", "refresh", "lock", "tag"].map((e) => ({ label: e.replace("-", " "), value: e })), Ga = (e = {}) => [
  { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: e.eyebrow ?? "", help: "Small line above the title." },
  { key: "title", label: "Title", type: "localized-string", default: e.title ?? "" },
  { key: "subtitle", label: "Subtitle", type: "localized-text", default: e.subtitle ?? "" }
], mn = [
  { key: "icon", label: "Icon", type: "icon", default: "check", options: Hw },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "body", label: "Text", type: "localized-text" }
], Jc = [
  { key: "alt", label: "Picture description", type: "string", help: "What the picture shows, for screen readers." },
  { key: "eyebrow", label: "Small line above the title", type: "string", help: 'Optional, e.g. "New in".' },
  { key: "title", label: "Title over the photo", type: "string", help: "Optional, a few words." },
  { key: "subtitle", label: "Line under the title", type: "string" },
  { key: "ctaText", label: "Button text", type: "string" },
  { key: "ctaLink", label: "Button link", type: "string", placeholder: "/shop" }
], Uw = {
  type: "banner-carousel",
  label: "Banner carousel",
  description: "Photo slides with an optional short title, line and button over the photo: full-width slides, or a row of tall posters.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [
    {
      id: "v1",
      label: "Full-width photo slides",
      fields: [
        {
          key: "slides",
          label: "Slides",
          type: "array",
          itemSchema: [
            { key: "image", label: "Picture", type: "image", required: !0, help: "Wide, about 1920 × 550 px." },
            { key: "mobileImage", label: "Phone picture", type: "image", help: "Portrait, about 780 × 880 px." },
            ...Jc,
            { key: "cta2Text", label: "Second button text", type: "string" },
            { key: "cta2Link", label: "Second button link", type: "string", placeholder: "/categories" },
            { key: "link", label: "Link of the whole slide", type: "string", placeholder: "/shop", help: "Used when the slide has no button." }
          ],
          default: []
        }
      ]
    },
    {
      id: "v2",
      label: "Poster row",
      fields: [
        {
          key: "slides",
          label: "Posters",
          type: "array",
          help: "Three show side by side on a computer, one on a phone; the next one peeks in.",
          itemSchema: [
            { key: "image", label: "Picture", type: "image", required: !0, help: "Tall, about 960 × 1200 px (4:5)." },
            ...Jc,
            { key: "link", label: "Link of the whole poster", type: "string", placeholder: "/shop", help: "Used when the poster has no button." }
          ],
          default: []
        }
      ]
    }
  ],
  commonFields: [
    { key: "title", label: "Name for screen readers", type: "string", default: "Offers" },
    { key: "autoplay", label: "Play automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 5, dependency: { field: "autoplay", value: !0 } }
  ]
}, Gw = {
  type: "category-bento",
  label: "Category mosaic",
  description: "Portrait photo tiles linking to categories, the name on a small label at the foot of each: the tiles you list, else the store’s categories.",
  supportedPages: Ua,
  variants: [
    { id: "v1", label: "Portrait tiles with a label" },
    { id: "v2", label: "Mosaic (first tile large)" }
  ],
  commonFields: [
    ...Ga(),
    {
      key: "tiles",
      label: "Tiles",
      type: "array",
      help: "Empty = the store’s categories.",
      itemSchema: [
        { key: "categoryId", label: "Category", type: "category-select", help: "Sets the link, name and picture unless filled below." },
        { key: "title", label: "Name", type: "localized-string" },
        { key: "tagline", label: "Tagline", type: "localized-string" },
        { key: "image", label: "Picture", type: "image" },
        { key: "link", label: "Link", type: "string", placeholder: "/category/…" }
      ],
      default: []
    },
    { key: "limit", label: "Categories shown (automatic tiles)", type: "number", default: 12 }
  ]
}, Yw = {
  type: "combo-spotlight",
  label: "Product spotlight",
  description: "One product or bundle on a card: large photo, price, saving and Add to bag.",
  supportedPages: Ua,
  variants: [{ id: "v1", label: "Photo and details card" }],
  commonFields: [
    ...Ga({ eyebrow: "Combo deal", title: "Pick of the week" }),
    { key: "productId", label: "Product", type: "product-select", help: "Hidden until a product is picked." },
    { key: "description", label: "Text", type: "localized-text", default: "" },
    { key: "mrpLabel", label: "Regular price label", type: "localized-string", default: "Regular price" },
    { key: "savingLabel", label: "Saving label", type: "localized-string", default: "You save" },
    { key: "detailsLabel", label: "Details link text", type: "localized-string", default: "View details" }
  ]
}, Xw = {
  type: "corporate-band",
  label: "Bulk order band",
  description: "A warm box with a linked title, a short pitch and a few product pictures, e.g. for bulk, team or wholesale orders.",
  supportedPages: Ua,
  variants: [{ id: "v1", label: "Box with pictures" }],
  commonFields: [
    ...Ga({ title: "Bulk order / wholesale" }).filter((e) => e.key !== "subtitle"),
    { key: "text", label: "Text", type: "localized-text", default: "School shoes, team sneakers and staff footwear in every EU size, at wholesale prices and with no minimum order." },
    { key: "cta.url", label: "Title link", type: "string", default: "/contact" },
    {
      key: "images",
      label: "Pictures",
      type: "array",
      help: "Up to six, square.",
      itemSchema: [
        { key: "image", label: "Picture", type: "image" },
        { key: "alt", label: "Picture description", type: "string" }
      ],
      default: []
    }
  ]
}, jw = {
  type: "product-rail",
  label: "Product rail",
  description: "Product cards from new arrivals, deals, a category or your own pick, as a grid or a swipe row.",
  supportedPages: Ua,
  variants: [{ id: "v1", label: "Product cards" }],
  commonFields: [
    ...Ga({ eyebrow: "Just dropped", title: "New arrivals" }),
    { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 8 } },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [
        { label: "Grid (four up)", value: "grid" },
        { label: "Swipe row", value: "rail" }
      ],
      default: "grid"
    },
    { key: "showViewAll", label: "Show “View all”", type: "boolean", default: !0 },
    { key: "viewAllLabel", label: "“View all” text", type: "string", default: "View all", dependency: { field: "showViewAll", value: !0 } }
  ]
}, qw = {
  type: "promises",
  label: "Promises strip",
  description: "Store promises: a grey band of icon, title and line, or a numbered checklist on a black band.",
  supportedPages: [...Ua, "about", "contact"],
  variants: [
    {
      id: "v1",
      label: "Grey band",
      fields: [
        {
          key: "items",
          label: "Promises",
          type: "array",
          itemSchema: mn,
          default: [
            { icon: "truck", title: "Fast delivery", body: "Quick delivery across the city." },
            { icon: "cash", title: "Pay on delivery", body: "Pay in cash when your order arrives." },
            { icon: "refresh", title: "Easy returns", body: "Wrong size? Swap it within 7 days." },
            { icon: "phone", title: "Here to help", body: "Call or message us any day." }
          ]
        }
      ]
    },
    {
      id: "v2",
      label: "Checklist on a black band",
      fields: [
        { key: "highlight", label: "Highlighted words", type: "localized-string", default: "anything you need.", help: "Shown on the accent fill on their own line under the title." },
        {
          key: "items",
          label: "Checklist",
          type: "array",
          itemSchema: mn.filter((e) => e.key !== "icon"),
          default: [
            { title: "Order status and tracking" },
            { title: "Size, fit and product advice" },
            { title: "Delivery, swaps and payments" },
            { title: "Bulk, team and custom orders" }
          ]
        }
      ]
    }
  ],
  commonFields: [...Ga()]
}, Zw = {
  type: "reviews",
  label: "Customer reviews",
  description: "A swipe row of quote cards: rating, title, quote, name and the product. Store reviews replace these once available.",
  supportedPages: Ua,
  variants: [{ id: "v1", label: "Quote cards" }],
  commonFields: [
    ...Ga({ title: "What our customers say" }),
    {
      key: "items",
      label: "Reviews",
      type: "array",
      help: "Real reviews from your customers, with their permission.",
      itemSchema: [
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "body", label: "Review", type: "localized-text" },
        { key: "name", label: "Customer name", type: "string" },
        { key: "productId", label: "Product", type: "product-select" }
      ],
      default: []
    },
    { key: "limit", label: "Most reviews shown", type: "number", default: 6 },
    { key: "minRating", label: "Lowest rating shown (store reviews)", type: "number", default: 4 }
  ]
}, Jw = {
  type: "story",
  label: "Story band",
  description: "An off-white split: eyebrow and a huge headline with a highlighted last line (and an optional photo) beside a bold line, the paragraph and a numbered list.",
  supportedPages: [...Ua, "about", "contact"],
  variants: [{ id: "v1", label: "Headline beside a numbered list" }],
  commonFields: [
    ...Ga({ title: "Our story", subtitle: "Comfortable shoes you can wear every day." }).map((e) => e.key === "subtitle" ? { ...e, label: "Bold line" } : e),
    { key: "highlight", label: "Highlighted words", type: "localized-string", default: "to your street.", help: "Shown on the accent fill on their own line under the title." },
    { key: "text", label: "Paragraph", type: "localized-text", default: "We choose comfortable, hard-wearing pairs, check every size and stitch, and price fairly, so your everyday shoes fit well and last." },
    { key: "image", label: "Picture", type: "image", help: "Optional, under the headline; landscape 4:3." },
    {
      key: "points",
      label: "Points",
      type: "array",
      itemSchema: mn.filter((e) => e.key !== "icon"),
      help: "Shown as a numbered list (01, 02…).",
      default: []
    },
    { key: "ctaLink", label: "Link", type: "string", default: "/about", help: "The link under the list goes here." },
    { key: "ctaLabel", label: "Link text", type: "localized-string", default: "" }
  ]
}, Kw = {
  key: "gallery",
  label: "Mosaic pictures",
  type: "array",
  help: "Up to two (split) or three (full width) extra pictures shown as a mosaic with the main picture.",
  itemSchema: [
    { key: "image", label: "Picture", type: "image" },
    { key: "alt", label: "Description (alt text)", type: "string" },
    { key: "link", label: "Link", type: "string" }
  ]
}, Qw = {
  ...bn,
  variants: bn.variants.map((e) => ({ ...e, fields: [...e.fields ?? [], Kw] }))
}, eS = [
  { label: "Shield", value: "shield" },
  { label: "Exchange arrows", value: "refresh" },
  { label: "Lock", value: "lock" },
  { label: "Delivery truck", value: "truck" },
  { label: "Cash", value: "cash" },
  { label: "Parcel", value: "package" },
  { label: "Star", value: "star" },
  { label: "Tick", value: "check" }
], tS = {
  ...hn,
  commonFields: [
    ...hn.commonFields,
    { key: "sizeGuideTitle", label: "Size guide link", type: "string", default: "Size guide", help: "Link above the size buttons; opens the size chart inside the page." },
    { key: "sizeGuide", label: "Size guide", type: "rich-text", help: "Tables and fit notes shown inline under the sizes; while empty the theme's EU / UK / US / cm chart shows." },
    { key: "completeTheLookTitle", label: '"You may also like" title', type: "string", default: "You may also like", help: "Rail of up to 8 same-category products under the page." },
    { key: "additionalInfoTitle", label: '"Specifications" title', type: "string", default: "Specifications", help: "Accordion with the options and the variation summary." },
    { key: "showDeliveryAreas", label: "Show delivery areas and charges", type: "boolean", default: !0 },
    {
      key: "deliveryPoints",
      label: "Delivery lines",
      type: "array",
      help: "Lines in the delivery box (truck icon).",
      itemSchema: [{ key: "text", label: "Line", type: "string" }],
      default: [
        { text: "Delivery all over Bangladesh" },
        { text: "Cash on delivery available" },
        { text: "Check the parcel before you pay" }
      ]
    },
    {
      key: "trustCards",
      label: "Trust cards",
      type: "array",
      help: "Up to three items in the green strip under the buttons.",
      itemSchema: [
        { key: "icon", label: "Icon", type: "select", options: eS, default: "shield" },
        { key: "title", label: "Title", type: "string" },
        { key: "text", label: "Line", type: "string" }
      ],
      default: [
        { icon: "shield", title: "Checked pair by pair", text: "Every pair inspected before it ships" },
        { icon: "refresh", title: "Easy size swap", text: "Wrong size? Swap it within 7 days" },
        { icon: "lock", title: "Safe payment", text: "Pay on delivery or online" }
      ]
    }
  ]
}, aS = {
  ...pn,
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Sign in" },
    { key: "intro", label: "Intro text", type: "text", default: "Sign in or create an account with your mobile number." },
    ...pn.commonFields
  ]
}, oS = {
  ...un,
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Create account" },
    { key: "intro", label: "Intro text", type: "text", default: "Create your account with your mobile number." },
    ...un.commonFields
  ]
}, Kc = {
  componentSchemas: {
    "banner-carousel": Uw,
    "category-bento": Gw,
    "combo-spotlight": Yw,
    "corporate-band": Xw,
    "product-rail": jw,
    promises: qw,
    reviews: Zw,
    story: Jw,
    "lookbook-banner": Qw,
    "product-detail": tS,
    signin: aS,
    signup: oS
  },
  chrome: {
    headerSchema: _w
  }
}, Qc = {
  componentSchemas: {
    account: Yk,
    signin: pn,
    signup: un,
    banner: Jk,
    cart: Kk,
    categories: Qk,
    category: ew,
    checkout: tw,
    contact: ow,
    content: rw,
    "featured-category": lw,
    hero: sw,
    "order-success": cw,
    "product-detail": hn,
    "similar-products": pw,
    "shop-grid": uw,
    wishlist: yw,
    "announcement-bar": bw,
    "flash-sale": gw,
    "new-arrivals": vw,
    "offer-banner": kw,
    "lookbook-banner": bn,
    "instagram-feed": Sw,
    blog: xw,
    features: Pw,
    testimonials: Lw,
    cta: Mw,
    brands: Ew,
    "product-slider": Fw,
    "product-grid": Iw,
    compare: Ow,
    coupon: Rw,
    "recent-products": Bw
  },
  headerSchema: yn,
  footerSchema: nw,
  floatingButtonsSchema: iw,
  mobileNavSchema: dw
}, rS = ht({
  ...Qc,
  componentSchemas: { ...Qc.componentSchemas, ...Kc.componentSchemas },
  ...Kc.chrome
}, Gk), lS = {
  banner: { hide: ["title", "description", "ctaText", "ctaLink", "backgroundImage"], keep: [], add: Oa.variants, variantLabels: { v1: "Selling points (icon, title, line)", v2: "Two picture banners" } },
  category: { hide: ["cardVariant", "autoplay", "autoplayDelay"] },
  "featured-category": { hide: ["productCardVariant", "noSelectionText", "noProductsText", "buttons.orderNow"] },
  "floating-buttons": { hide: ["phone", "messenger", "callUsTitle", "whatsappTitle", "messengerTitle"] },
  footer: { hide: ["logo", "contactAddress"] },
  "product-detail": { hide: ["loadingText", "notFoundCode", "notFoundText"] },
  "recent-products": { hide: ["productCardVariant", "buttons"] },
  "shop-grid": { hide: ["sidebarVariant", "productCardVariant", "paginationVariant", "initialPriceRange", "filtersButtonLabel", "showingLabel", "productsSuffix", "sortNewestLabel", "sortOldestLabel", "sortPriceAscLabel", "sortPriceDescLabel", "sortNameAscLabel", "sortNameDescLabel", "activeFiltersLabel", "backToAllText", "filterDrawerTitle", "currentSearchLabel", "clearSearchLabel", "applyFiltersLabel", "buttons.orderNow"] },
  "similar-products": { hide: ["productCardVariant", "buttons.orderNow"] },
  features: { add: [{ id: "v2", label: "Large tiles" }, { id: "v3", label: "Icons on one band" }], variantLabels: { v1: "Tiles" } },
  "mobile-bottom-nav": { hide: ["items[].isPrimary"] },
  // Theme tab: button settings no part of this theme reads (colours drive every primary button via the CTA).
  buttons: { hide: ["appearance.buttons.primary[].radius", "appearance.buttons.primary[].height", "appearance.buttons.primary[].paddingX", "appearance.buttons.primary[].label", "appearance.buttons.outline[].radius", "appearance.buttons.outline[].height", "appearance.buttons.outline[].paddingX", "appearance.buttons.outline[].label"] },
  // Corner roundness: this theme's corners are fixed by its design (no --radius-base / --radius-card).
  design: { hide: ["radius"] },
  // Delivery time is shown on product cards only by Prottoho.
  "store-info": { hide: ["deliveryEta"] }
}, iS = {
  account: { hide: ["signinRedirectPath"], add: [{ id: "v2", label: "Side navigation" }], variantLabels: { v1: "Tabs" } },
  cart: { hide: ["taxLabel", "buttons"] },
  category: { hide: ["cardVariant", "autoplay", "autoplayDelay"] },
  checkout: { hide: ["buttons"] },
  "featured-category": { hide: ["noSelectionText", "noProductsText", "buttons.orderNow"] },
  "product-detail": { hide: ["loadingText", "notFoundCode", "notFoundText"], add: [{ id: "v2", label: "Gallery above the details" }], variantLabels: { v1: "Gallery beside the details" } },
  "shop-grid": { hide: ["sidebarVariant", "paginationVariant", "initialPriceRange", "sortOldestLabel", "sortNameDescLabel"], add: [{ id: "v2", label: "Full width, filters in a drawer" }], variantLabels: { v1: "Filter sidebar" } },
  blog: { keep: ["v1", "v2"] },
  "product-grid": { keep: ["v1", "v2", "v3", "v4", "v6"] },
  content: { add: [{ id: "v2", label: "Centred text" }], variantLabels: { v1: "Left-aligned text" } },
  features: { add: [{ id: "v2", label: "Cards with glowing icons" }, { id: "v3", label: "Centred icons, no frame" }], variantLabels: { v1: "Glass spec strip" } },
  hero: { add: [{ id: "v1", label: "Full-screen picture, text over it" }, { id: "v2", label: "Text beside a spotlit picture" }, { id: "v3", label: "Glass panel" }], variantLabels: { v4: "Cinema slider with thumbnails" } },
  banner: { add: Oa.variants.filter((e) => e.id === "v2"), variantLabels: { v2: "Two picture banners" } },
  footer: { add: [{ id: "v2", label: "Minimal (links and payments only)" }] },
  "recent-products": { hide: ["buttons.orderNow"] },
  "order-success": { hide: ["buttons.viewOrder[].bg", "buttons.continueShopping[].bg"] },
  "similar-products": { hide: ["buttons.orderNow"] },
  header: { hide: ["topbar[].showSocials", "topbar[].socialLinks"] },
  // Theme tab: button settings no part of this theme reads (colours drive every primary button via the CTA).
  buttons: { hide: ["appearance.buttons.primary[].radius", "appearance.buttons.primary[].height", "appearance.buttons.primary[].paddingX", "appearance.buttons.primary[].label", "appearance.buttons.outline[].radius", "appearance.buttons.outline[].height", "appearance.buttons.outline[].paddingX", "appearance.buttons.outline[].label"] },
  // Delivery time is shown on product cards only by Prottoho.
  "store-info": { hide: ["deliveryEta"] }
}, nS = {
  type: "account",
  label: "Account Section",
  description: "User dashboard with orders, history and settings.",
  supportedPages: ["account"],
  variants: [{ id: "v1", label: "V1 (Tabbed Interface)" }],
  commonFields: [
    { key: "tabOverviewLabel", label: "Overview Tab Label", type: "string", default: "Overview" },
    { key: "tabOrdersLabel", label: "Orders Tab Label", type: "string", default: "Orders" },
    { key: "tabAddressesLabel", label: "Addresses Tab Label", type: "string", default: "Saved Locations" },
    { key: "tabDetailsLabel", label: "Profile Tab Label", type: "string", default: "Profile Info" },
    { key: "signOutLabel", label: "Sign Out Label", type: "string", default: "Sign Out" },
    { key: "signinRedirectPath", label: "Sign In Redirect Path", type: "string", default: "/signin" }
  ]
}, sS = {
  type: "signin",
  label: "Signin Section",
  description: "Login form with phone/OTP.",
  supportedPages: ["signin"],
  variants: [{ id: "v1", label: "V1 (Standard)" }],
  commonFields: [{ key: "redirectUrl", label: "Redirect After Login", type: "string", default: "/account" }]
}, cS = {
  type: "signup",
  label: "Signup Section",
  description: "Registration form with phone/OTP.",
  supportedPages: ["signup"],
  variants: [{ id: "v1", label: "V1 (Standard)" }],
  commonFields: [{ key: "redirectUrl", label: "Redirect After Signup", type: "string", default: "/account" }]
}, gn = {
  type: "banner",
  label: "Banner",
  description: "Promotional strip for sales, announcements, or features.",
  supportedPages: ["home", "shop", "category", "cart", "checkout", "order-success"],
  variants: [{ id: "v1", label: "V1 (Standard)" }],
  commonFields: [
    { key: "title", label: "Banner Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    { key: "ctaText", label: "Button Text", type: "string" },
    { key: "ctaLink", label: "Button Link", type: "string" },
    { key: "backgroundImage", label: "Background Image", type: "image" }
  ]
};
function na(e, t) {
  return [
    {
      key: e,
      label: t,
      type: "object",
      preview: { type: "button", variant: "primary", defaultLabel: t },
      fields: [
        { key: "label", label: "Button Text", type: "string" },
        { key: "bg", label: "Background Color", type: "color" }
      ]
    }
  ];
}
function Ya(e, t) {
  return [
    {
      key: e,
      label: t,
      type: "object",
      preview: { type: "button", variant: "outline", defaultLabel: t },
      fields: [
        { key: "label", label: "Button Text", type: "string" },
        { key: "bg", label: "Background Color", type: "color" }
      ]
    }
  ];
}
const dS = {
  type: "cart",
  label: "Cart Section",
  description: "The shopping cart page section.",
  supportedPages: ["cart"],
  variants: [{ id: "v1", label: "V1 (Neon Cinematic)" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Shopping Cart" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading cart items..." },
    { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty State Message", type: "string", default: "Browse our products and add items to your cart." },
    { key: "continueShoppingText", label: "Continue Shopping Button Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingLabel", label: "Shipping Label", type: "string", default: "Shipping" },
    { key: "shippingCalculatedText", label: "Shipping Calculated Text", type: "string", default: "Calculated at checkout" },
    { key: "taxLabel", label: "Tax Label", type: "string", default: "Tax" },
    { key: "totalLabel", label: "Total Label", type: "string", default: "Total" },
    { key: "checkoutButtonText", label: "Checkout Button Text", type: "string", default: "Proceed to Checkout" },
    { key: "checkoutLink", label: "Checkout Link", type: "string", default: "/checkout" },
    { key: "secureCheckoutText", label: "Secure Checkout Label", type: "string", default: "SSL Secure Checkout" },
    // ─── Buttons ──────────────────────────────────────────────────────
    ...na("buttons.checkout", "Proceed to Checkout Button")
  ]
}, pS = {
  type: "categories",
  label: "Categories Page Section",
  description: "The main grid listing all categories.",
  supportedPages: ["categories"],
  variants: [{ id: "v1", label: "V1 (Exploration Grid)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    {
      key: "columns",
      label: "Grid Columns",
      type: "select",
      options: [
        { label: "2 Columns", value: 2 },
        { label: "3 Columns", value: 3 },
        { label: "4 Columns", value: 4 }
      ],
      default: 4
    },
    { key: "emptyText", label: "Empty State Text", type: "string", default: "No categories found." }
  ]
}, uS = {
  type: "category",
  label: "Category Section",
  description: "Dynamic sections for displaying product categories.",
  supportedPages: ["home", "shop", "cart", "checkout", "order-success", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 (Slider Layout)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "subtitle", label: "Subtitle", type: "string" },
        { key: "autoplay", label: "Enable Autoplay", type: "boolean", default: !1 },
        { key: "autoplayDelay", label: "Autoplay Delay (ms)", type: "number", default: 3e3 }
      ]
    }
  ],
  commonFields: [
    {
      key: "cardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard Card (V1)", value: "v1" }],
      default: "v1"
    }
  ]
}, yS = {
  type: "checkout",
  label: "Checkout Section",
  description: "The order checkout page section.",
  supportedPages: ["checkout"],
  variants: [{ id: "v1", label: "V1 (Multi-column Summary)" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Checkout" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Preparing checkout..." },
    { key: "emptyTitle", label: "Empty Cart Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty Cart Message", type: "string", default: "Checkout is only available for shopping carts with items." },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingChargeLabel", label: "Shipping Charge Label", type: "string", default: "Shipping Charge" },
    { key: "shippingCalculatingText", label: "Shipping Calculating Text", type: "string", default: "Calculating..." },
    { key: "totalLabel", label: "Total Amount Label", type: "string", default: "Total Amount" },
    { key: "placeOrderText", label: "Place Order Button Text", type: "string", default: "Place Order" },
    { key: "placingOrderText", label: "Placing Order Loading Text", type: "string", default: "Placing Order..." },
    { key: "securePaymentText", label: "Secure Payment Label", type: "string", default: "SSL Secure Payment" },
    // ─── Buttons ──────────────────────────────────────────────────────
    ...na("buttons.placeOrder", "Place Order Button")
  ]
}, hS = {
  type: "contact",
  label: "Contact Section",
  description: "Contact information and form.",
  supportedPages: ["contact"],
  variants: [{ id: "v1", label: "V1 (Split Contact Details)" }],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    { key: "email", label: "Email Address", type: "string" },
    { key: "phone", label: "Phone Number", type: "string" },
    { key: "address", label: "Physical Address", type: "text" }
  ]
}, bS = {
  type: "content",
  label: "Content / Policy Section",
  description: "Generic rich-text section for policies and descriptions.",
  supportedPages: ["privacy-policy", "terms-of-service", "shipping-policy", "return-policy"],
  variants: [{ id: "v1", label: "V1 (Readable Layout)" }],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "content", label: "HTML Content", type: "rich-text" }
  ]
}, mS = {
  type: "featured-category",
  label: "Featured Category",
  description: "Display products from a specific category.",
  supportedPages: ["home", "product", "cart"],
  variants: [
    {
      id: "v1",
      label: "V1 (Grid Layout)",
      fields: [
        { key: "title", label: "Title", type: "string" },
        { key: "subtitle", label: "Subtitle", type: "string" },
        { key: "categoryId", label: "Select Category", type: "category-select" },
        { key: "rows", label: "Number of Rows", type: "number", default: 1 },
        { key: "noSelectionText", label: "No Category Selected Text", type: "string", default: "Please select a category in the editor settings." },
        { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
        { key: "viewAllText", label: "View All Button Text", type: "string", default: "View All" }
      ]
    }
  ],
  commonFields: [
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [
        { label: "Bordered (V1)", value: "v1" },
        { label: "Clean (V2)", value: "v2" }
      ],
      default: "v1"
    },
    // ─── Product Card Buttons ─────────────────────────────────────────
    ...na("buttons.orderNow", "Order Now Button"),
    ...Ya("buttons.addToCart", "Add to Cart Button")
  ]
}, gS = {
  type: "features",
  label: "Features / Service Highlights",
  description: "A grid of service highlight cards with icon, title, and subtitle.",
  supportedPages: ["home", "shop", "category"],
  variants: [{ id: "v1", label: "V1 (2×2 Grid)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    {
      key: "items",
      label: "Feature Items",
      type: "array",
      itemSchema: [
        {
          key: "icon",
          label: "Icon",
          type: "select",
          options: [
            { label: "Truck (Delivery)", value: "truck" },
            { label: "Zap (Fast)", value: "zap" },
            { label: "Shield (Secure)", value: "shield" },
            { label: "Headphones (Support)", value: "headphones" },
            { label: "Package (Packaging)", value: "package" },
            { label: "RefreshCw (Returns)", value: "refresh-cw" },
            { label: "Star (Quality)", value: "star" },
            { label: "Award (Certified)", value: "award" }
          ],
          default: "truck"
        },
        { key: "title", label: "Title", type: "string" },
        { key: "subtitle", label: "Subtitle", type: "string" }
      ],
      default: [
        { icon: "truck", title: "হোম ডেলিভারি", subtitle: "সারাদেশে ডেলিভারি" },
        { icon: "zap", title: "ফাস্ট ডেলিভারি", subtitle: "দ্রুত ডেলিভারি সার্ভিস" },
        { icon: "shield", title: "সিকিউর পেমেন্ট", subtitle: "নিরাপদ পেমেন্ট" },
        { icon: "headphones", title: "২৪/৭ সাপোর্ট", subtitle: "যেকোনো সময় সাহায্য" }
      ]
    }
  ]
}, fS = {
  type: "recent-products",
  label: "Recently Viewed Products",
  description: "A horizontal slider of products the visitor has recently viewed (stored in localStorage — no API call).",
  supportedPages: ["home", "shop", "product", "category", "cart"],
  variants: [{ id: "v1", label: "V1 (Horizontal Slider)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Recently Viewed" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [
        { label: "Standard (V1)", value: "v1" },
        { label: "Clean (V2)", value: "v2" }
      ],
      default: "v1"
    },
    ...na("buttons.orderNow", "Order Now Button"),
    ...Ya("buttons.addToCart", "Add to Cart Button")
  ]
}, Rl = [
  "home",
  "shop",
  "product",
  "category",
  "categories",
  "cart",
  "checkout",
  "contact",
  "signin",
  "signup",
  "account",
  "wishlist",
  "track-order",
  "order-success",
  "privacy-policy",
  "terms-of-service",
  "shipping-policy",
  "return-policy",
  "order-detail"
], kl = [
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link", type: "string" }
], Rp = [
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link URL", type: "string" },
  {
    key: "type",
    label: "Type",
    type: "select",
    options: [
      { label: "Standard Link", value: "link" },
      { label: "Dropdown", value: "dropdown" },
      { label: "Mega Menu", value: "mega-menu" }
    ]
  },
  {
    key: "children",
    label: "Dropdown Items",
    type: "array",
    itemSchema: kl,
    dependency: { field: "type", value: "dropdown" }
  },
  {
    key: "columns",
    label: "Mega Menu Columns",
    type: "array",
    itemSchema: [
      { key: "title", label: "Column Title", type: "string" },
      { key: "items", label: "Links", type: "array", itemSchema: kl }
    ],
    dependency: { field: "type", value: "mega-menu" }
  },
  {
    key: "featuredImage",
    label: "Featured Image",
    type: "object",
    fields: [
      { key: "src", label: "Image", type: "image" },
      { key: "title", label: "Title", type: "string" },
      { key: "href", label: "Link", type: "string" }
    ],
    dependency: { field: "type", value: "mega-menu" }
  }
], Bp = [
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "text" },
  { key: "image", label: "Image", type: "image" },
  { key: "ctaText", label: "Button Text", type: "string" },
  { key: "ctaLink", label: "Button Link", type: "string" }
], R = [
  {
    key: "styles.paddingTop",
    label: "Padding Top",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.paddingBottom",
    label: "Padding Bottom",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.background",
    label: "Background",
    type: "select",
    options: [
      { label: "None (theme default)", value: "default" },
      { label: "Light grey", value: "muted" },
      { label: "Brand tint", value: "primary" }
    ],
    default: "default"
  }
], vS = {
  type: "floating-buttons",
  label: "Floating Buttons",
  description: "Global floating buttons for quick actions (Call, WhatsApp, Messenger).",
  supportedPages: [...Rl],
  variants: [{ id: "v1", label: "Default" }],
  commonFields: [
    { key: "active", label: "Enable Floating Buttons", type: "boolean", default: !0 },
    { key: "phone", label: "Phone Number", type: "string", placeholder: "+8801..." },
    { key: "whatsapp", label: "WhatsApp Number", type: "string", placeholder: "+8801..." },
    { key: "messenger", label: "Messenger ID/Link", type: "string", placeholder: "m.me/..." },
    { key: "callUsTitle", label: "Call Button Tooltip", type: "string", default: "Call Us" },
    { key: "whatsappTitle", label: "WhatsApp Button Tooltip", type: "string", default: "WhatsApp" },
    { key: "messengerTitle", label: "Messenger Button Tooltip", type: "string", default: "Messenger" }
  ]
}, Ct = {
  type: "footer",
  label: "Footer Configuration",
  description: "Site footer and utility links.",
  supportedPages: [...Rl],
  variants: [{ id: "v1", label: "V1 (Neon Minimalist)" }],
  commonFields: [
    { key: "title", label: "About Title", type: "string" },
    { key: "logo", label: "Logo", type: "image" },
    { key: "description", label: "About Description", type: "text" },
    { key: "copyright", label: "Copyright Text", type: "string" },
    {
      key: "columns",
      label: "Footer Columns",
      type: "array",
      itemSchema: [
        { key: "title", label: "Column Title", type: "string" },
        { key: "links", label: "Links", type: "array", itemSchema: kl }
      ]
    },
    {
      key: "socialLinks",
      label: "Social Links",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Facebook", value: "facebook" },
            { label: "Instagram", value: "instagram" },
            { label: "Twitter", value: "twitter" },
            { label: "YouTube", value: "youtube" },
            { label: "LinkedIn", value: "linkedin" }
          ]
        },
        { key: "href", label: "Link", type: "string" }
      ]
    },
    { key: "contactAddress", label: "Contact Address", type: "string" },
    { key: "contactPhone", label: "Contact Phone", type: "string" },
    { key: "contactEmail", label: "Contact Email", type: "string" },
    {
      key: "paymentMethods",
      label: "Payment Methods",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "bKash", value: "bkash" },
            { label: "Nagad", value: "nagad" },
            { label: "Rocket", value: "rocket" },
            { label: "Upay", value: "upay" },
            { label: "Visa", value: "visa" },
            { label: "MasterCard", value: "mastercard" },
            { label: "Amex", value: "amex" }
          ]
        },
        { key: "icon", label: "Custom Icon URL", type: "image" }
      ]
    }
  ]
}, fn = {
  type: "header",
  label: "Header Configuration",
  description: "Global site navigation.",
  supportedPages: [...Rl],
  variants: [{ id: "v1", label: "V1" }],
  commonFields: [
    { key: "logo.alt", label: "Logo Alt Text", type: "string" },
    { key: "logo.src", label: "Logo Image", type: "image" },
    { key: "sticky", label: "Sticky Header", type: "boolean" },
    {
      key: "topbar",
      label: "Top Bar",
      type: "object",
      fields: [
        { key: "active", label: "Enable Top Bar", type: "boolean" },
        {
          key: "variant",
          label: "Variant",
          type: "select",
          options: [
            { label: "V1 (Centered Promo)", value: "v1" },
            { label: "V2 (Contact & Socials)", value: "v2" }
          ]
        },
        { key: "text", label: "Announcement Text", type: "string" },
        { key: "phone", label: "Phone Number", type: "string" },
        { key: "email", label: "Email Address", type: "string" },
        { key: "showSocials", label: "Show Social Icons", type: "boolean" },
        {
          key: "socialLinks",
          label: "Social Links",
          type: "array",
          itemSchema: [
            { key: "platform", label: "Platform", type: "string" },
            { key: "href", label: "Link", type: "string" },
            { key: "icon", label: "Icon Name", type: "string" }
          ]
        },
        { key: "links", label: "Top Bar Links", type: "array", itemSchema: kl }
      ]
    },
    {
      key: "actions",
      label: "Actions",
      type: "object",
      fields: [
        { key: "showSearch", label: "Show Search", type: "boolean" },
        { key: "showCart", label: "Show Cart", type: "boolean" },
        { key: "showAccount", label: "Show Account", type: "boolean" },
        {
          key: "cartAction",
          label: "Cart Action",
          type: "select",
          options: [
            { label: "Slide-out Sidebar", value: "sidebar" },
            { label: "Go to Page", value: "page" }
          ],
          default: "sidebar"
        }
      ]
    },
    {
      key: "searchConfig",
      label: "Search Settings",
      type: "object",
      fields: [
        { key: "showPrice", label: "Show Price in Suggestions", type: "boolean", default: !0 },
        { key: "showCategory", label: "Show Category in Suggestions", type: "boolean", default: !0 },
        { key: "showImage", label: "Show Image in Suggestions", type: "boolean", default: !0 },
        { key: "maxResults", label: "Max Suggestions", type: "number", default: 6 }
      ]
    },
    { key: "menu", label: "Main Menu", type: "array", itemSchema: Rp }
  ]
}, vn = {
  type: "hero",
  label: "Hero Section",
  description: "The main attention-grabbing section at the top of the page.",
  supportedPages: ["home", "cart", "checkout", "order-success", "categories"],
  variants: [
    {
      id: "v4",
      label: "V4 (Premium Full Width Slider)",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: Bp },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    }
  ],
  commonFields: [
    // ─── CTA Button ───────────────────────────────────────────────────
    ...na("buttons.cta", "CTA Button")
  ]
}, kS = {
  type: "order-success",
  label: "Order Success Section",
  description: "The order confirmation page section.",
  supportedPages: ["order-success"],
  variants: [{ id: "v1", label: "V1 (Detailed Receipt)" }],
  commonFields: [
    { key: "title", label: "Success Title", type: "string", default: "Order Confirmed" },
    { key: "message", label: "Success Message", type: "text", default: "Your order has been placed successfully. We have sent a confirmation email with your order details." },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading order details..." },
    { key: "errorTitle", label: "Error Title", type: "string", default: "Order Not Found" },
    { key: "errorMessage", label: "Error Message", type: "string", default: "We could not find the order you are looking for." },
    { key: "viewOrderText", label: "View Order Button Text", type: "string", default: "View Order Status" },
    { key: "viewOrderLink", label: "View Order Link", type: "string", default: "/account/orders" },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    // ─── Buttons ──────────────────────────────────────────────────────
    ...na("buttons.viewOrder", "View Order Button"),
    ...Ya("buttons.continueShopping", "Continue Shopping Button")
  ]
}, Pt = {
  type: "product-detail",
  label: "Product Detail",
  description: "The main product information page section.",
  supportedPages: ["product"],
  variants: [{ id: "v1", label: "V1 (Classic Info Grid)" }],
  commonFields: [
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading Data..." },
    { key: "notFoundCode", label: "Not Found Code", type: "string", default: "404" },
    { key: "notFoundText", label: "Not Found Text", type: "string", default: "Product Not Found" },
    { key: "quantityLabel", label: "Quantity Label", type: "string", default: "Quantity" },
    { key: "productDescTitle", label: "Product Description Accordion Title", type: "string", default: "Product Description" },
    { key: "returnPolicyTitle", label: "Return Policy Accordion Title", type: "string", default: "Return Policy" },
    // ─── Buttons ──────────────────────────────────────────────────────
    ...na("buttons.addToCart", "Add to Cart Button"),
    ...Ya("buttons.orderNow", "Order Now Button")
  ]
}, wS = {
  type: "mobileBottomNav",
  label: "Mobile Navigation",
  description: "Bottom navigation bar for mobile devices.",
  supportedPages: [...Rl],
  variants: [{ id: "v1", label: "V1 (Default)" }],
  commonFields: [
    { key: "active", label: "Show Bottom Nav", type: "boolean" },
    {
      key: "items",
      label: "Nav Items",
      type: "array",
      itemSchema: [
        { key: "label", label: "Label", type: "string" },
        {
          key: "icon",
          label: "Icon Type",
          type: "select",
          options: [
            { label: "Home", value: "home" },
            { label: "Shop (Bag)", value: "shop" },
            { label: "Search", value: "search" },
            { label: "Cart", value: "cart" },
            { label: "User / Account", value: "account" },
            { label: "Heart / Wishlist", value: "heart" },
            { label: "Menu / Hamburger", value: "menu" },
            { label: "Plus / Create", value: "plus" },
            { label: "Categories (Grid)", value: "categories" }
          ]
        },
        {
          key: "actionType",
          label: "Action Type",
          type: "select",
          options: [
            { label: "Link (Direct URL)", value: "link" },
            { label: "Open Search Drawer", value: "search" },
            { label: "Open Categories Sidebar", value: "categories" }
          ]
        },
        { key: "href", label: "Target URL", type: "string" },
        { key: "isPrimary", label: "Highlight as Primary (Middle)", type: "boolean" }
      ]
    }
  ]
}, SS = {
  type: "similar-products",
  label: "Similar Products",
  description: "A section that displays products similar to a given product.",
  supportedPages: ["shop", "product"],
  variants: [
    {
      id: "v1",
      label: "Default (Grid)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Similar Products" },
        { key: "limit", label: "Limit", type: "number", default: 4 }
      ]
    }
  ],
  commonFields: [
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [
        { label: "Standard (V1)", value: "v1" },
        { label: "Clean (V2)", value: "v2" }
      ],
      default: "v1"
    },
    // ─── Product Card Buttons ─────────────────────────────────────────
    ...na("buttons.orderNow", "Order Now Button"),
    ...Ya("buttons.addToCart", "Add to Cart Button")
  ]
}, At = {
  type: "shop-grid",
  label: "Shop Grid",
  description: "The main product list with sidebar filters.",
  supportedPages: ["shop", "category", "cart", "checkout", "categories"],
  variants: [{ id: "v1", label: "V1 (Classic Sticky Sidebar)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    {
      key: "sidebarVariant",
      label: "Sidebar Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [
        { label: "Standard (V1)", value: "v1" },
        { label: "Clean (V2)", value: "v2" }
      ],
      default: "v1"
    },
    {
      key: "paginationVariant",
      label: "Pagination Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "initialPriceRange.min", label: "Initial Price Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Initial Price Max", type: "number", default: 5e4 },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "allCategoriesLabel", label: "All Categories Label", type: "string", default: "All" },
    { key: "filtersButtonLabel", label: "Filters Button Label", type: "string", default: "Filters" },
    { key: "showingLabel", label: "Showing Label (prefix)", type: "string", default: "Showing" },
    { key: "productsSuffix", label: "Products Count Suffix", type: "string", default: "Products" },
    { key: "sortNewestLabel", label: "Sort: Newest Label", type: "string", default: "Sort: Newest" },
    { key: "sortOldestLabel", label: "Sort: Oldest Label", type: "string", default: "Sort: Oldest" },
    { key: "sortPriceAscLabel", label: "Sort: Price Low-High Label", type: "string", default: "Price: Low to High" },
    { key: "sortPriceDescLabel", label: "Sort: Price High-Low Label", type: "string", default: "Price: High to Low" },
    { key: "sortNameAscLabel", label: "Sort: Name A-Z Label", type: "string", default: "Name: A-Z" },
    { key: "sortNameDescLabel", label: "Sort: Name Z-A Label", type: "string", default: "Name: Z-A" },
    { key: "activeFiltersLabel", label: "Active Filters Label", type: "string", default: "Active Filters:" },
    { key: "clearAllLabel", label: "Clear All Label", type: "string", default: "Clear All" },
    { key: "noProductsTitle", label: "No Products Title", type: "string", default: "No Products Found" },
    { key: "noProductsMessage", label: "No Products Message", type: "string", default: "We couldn't find any products matching your current filters. Try adjusting them." },
    { key: "backToAllText", label: "Back to All Products Text", type: "string", default: "Back to All Products" },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "currentSearchLabel", label: "Current Search Label", type: "string", default: "Current Search" },
    { key: "clearSearchLabel", label: "Clear Search Label", type: "string", default: "Clear" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    // ─── Product Card Buttons ─────────────────────────────────────────
    ...na("buttons.orderNow", "Order Now Button"),
    ...Ya("buttons.addToCart", "Add to Cart Button")
  ]
}, ed = [
  { label: "None", value: "0px" },
  { label: "Small", value: "4px" },
  { label: "Medium", value: "8px" },
  { label: "Large", value: "12px" },
  { label: "XL", value: "16px" },
  { label: "Pill", value: "9999px" }
], td = [
  { label: "XS — 32px", value: "32px" },
  { label: "SM — 36px", value: "36px" },
  { label: "MD — 40px", value: "40px" },
  { label: "Default — 44px", value: "44px" },
  { label: "LG — 48px", value: "48px" },
  { label: "XL — 56px", value: "56px" }
], ad = [
  { label: "XS — 8px", value: "8px" },
  { label: "SM — 12px", value: "12px" },
  { label: "MD — 16px", value: "16px" },
  { label: "Default — 20px", value: "20px" },
  { label: "LG — 24px", value: "24px" },
  { label: "XL — 32px", value: "32px" },
  { label: "XXL — 40px", value: "40px" }
], xS = {
  type: "buttons",
  label: "Buttons",
  description: "Global button styles applied across the entire theme. Per-section buttons can override the label and background.",
  supportedPages: [],
  variants: [{ id: "v1", label: "Default" }],
  commonFields: [
    {
      key: "appearance.buttons.primary",
      label: "Primary Button",
      type: "object",
      preview: { type: "button", variant: "primary", defaultLabel: "Order Now" },
      fields: [
        { key: "bg", label: "Background Color", type: "color" },
        { key: "hoverBg", label: "Hover Background", type: "color" },
        { key: "text", label: "Text Color", type: "color" },
        { key: "radius", label: "Border Radius", type: "select", options: ed, default: "12px" },
        { key: "height", label: "Height", type: "select", options: td, default: "44px" },
        { key: "paddingX", label: "Horizontal Padding", type: "select", options: ad, default: "20px" },
        { key: "label", label: "Default Text", type: "string", placeholder: "অর্ডার করুন" }
      ]
    },
    {
      key: "appearance.buttons.outline",
      label: "Outline Button",
      type: "object",
      preview: { type: "button", variant: "outline", defaultLabel: "Add to Cart" },
      fields: [
        { key: "borderColor", label: "Border Color", type: "color" },
        { key: "hoverBg", label: "Hover Background", type: "color" },
        { key: "text", label: "Text / Icon Color", type: "color" },
        { key: "radius", label: "Border Radius", type: "select", options: ed, default: "12px" },
        { key: "height", label: "Height", type: "select", options: td, default: "44px" },
        { key: "paddingX", label: "Horizontal Padding", type: "select", options: ad, default: "20px" },
        { key: "label", label: "Default Text", type: "string", placeholder: "Add to Cart" }
      ]
    }
  ]
}, TS = {
  ...gn,
  variants: [...gn.variants, { id: "v3", label: "V3 (Compact strip)" }]
}, CS = [
  ...Rp.map((e) => e.key === "type" ? { ...e, options: [...e.options ?? [], { label: "Shop panel (category tiles)", value: "categories" }] } : e),
  { key: "badge", label: "Badge", type: "string", placeholder: "New", help: "Small label next to the item." }
], PS = [
  {
    key: "messages",
    label: "Ticker messages",
    type: "array",
    help: "Run across the top bar; the single announcement text is used when this is empty.",
    itemSchema: [
      { key: "text", label: "Text", type: "localized-string" },
      { key: "link", label: "Link", type: "string" }
    ]
  },
  { key: "dismissible", label: "Shoppers can close it", type: "boolean", default: !1 }
], AS = {
  ...fn,
  commonFields: [
    ...(fn.commonFields ?? []).map((e) => e.key === "topbar" ? { ...e, fields: [...e.fields ?? [], ...PS] } : e.key === "menu" ? { ...e, itemSchema: CS } : e),
    { key: "searchPlaceholder", label: "Search placeholder", type: "string", placeholder: "Search products…" }
  ]
}, LS = [
  ...Bp,
  { key: "badge", label: "Badge", type: "string", placeholder: "New", help: "Small label above the title." },
  { key: "glow", label: "Spotlight colour", type: "color", help: "The light behind this slide; empty uses the theme colours in turn." }
], MS = {
  ...vn,
  variants: (vn.variants ?? []).map((e) => ({
    ...e,
    fields: (e.fields ?? []).map((t) => t.key === "slides" ? { ...t, itemSchema: LS } : t)
  }))
}, zp = ["home", "shop", "category", "categories"], Vp = (e) => Ya(`buttons.${e}`, "Add to Cart Button"), NS = {
  type: "announcement-bar",
  label: "Announcement Ticker",
  description: "A ticker of short messages; a coupon code shows as an amber chip after its message.",
  supportedPages: ["home", "shop", "product", "category", "categories", "cart", "checkout", "contact", "wishlist"],
  variants: [{
    id: "v1",
    label: "Ticker",
    fields: [{
      key: "items",
      label: "Messages",
      type: "array",
      itemSchema: [
        { key: "text", label: "Message", type: "string" },
        { key: "code", label: "Coupon code (optional)", type: "string" }
      ]
    }]
  }],
  commonFields: []
}, ES = {
  type: "flash-sale",
  label: "Flash Sale Ticker",
  description: "A ticker strip with a departure-board countdown over a rail of the most discounted products. Hidden after it ends.",
  supportedPages: ["home"],
  variants: [{
    id: "v1",
    label: "Countdown ticker",
    fields: [
      { key: "title", label: "Title", type: "string", default: "Flash sale" },
      { key: "endDate", label: "Ends at (ISO date)", type: "string", placeholder: "2026-12-31T23:59:59" }
    ]
  }],
  commonFields: []
}, vi = [
  { key: "title", label: "Title", type: "string", default: "Featured products" },
  { key: "subtitle", label: "Eyebrow", type: "string" }
], DS = {
  type: "product-slider",
  label: "Product Slider",
  description: "A rail of product cards, optionally with category tabs.",
  supportedPages: zp,
  variants: [
    {
      id: "v1",
      label: "V1 — Category tabs",
      fields: [
        ...vi,
        {
          key: "tabs",
          label: "Tabs",
          type: "array",
          itemSchema: [
            { key: "label", label: "Tab label", type: "string" },
            { key: "categoryId", label: "Category", type: "category-select" }
          ]
        }
      ]
    },
    { id: "v2", label: "V2 — Single rail, centred heading", fields: vi },
    { id: "v3", label: "V3 — Single rail", fields: vi }
  ],
  commonFields: Vp("addToCart")
}, yo = [
  { key: "title", label: "Title", type: "string", default: "All products" },
  { key: "subtitle", label: "Eyebrow", type: "string" },
  { key: "viewAllLink", label: "View all link", type: "string", default: "/shop" }
], FS = {
  type: "product-grid",
  label: "Product Grid",
  description: "Product cards as a grid, a spotlight (one large product beside smaller ones) or spec rows.",
  supportedPages: zp,
  variants: [
    { id: "v1", label: "V1 — Grid", fields: yo },
    { id: "v2", label: "V2 — Spotlight, 3 columns", fields: yo },
    { id: "v3", label: "V3 — Spec rows", fields: yo },
    { id: "v4", label: "V4 — Spotlight, 2 columns", fields: yo },
    { id: "v5", label: "V5 — Grid", fields: yo },
    {
      id: "v6",
      label: "V6 — Spec rows with special offer",
      fields: [...yo, { key: "offerEndsAt", label: "Offer ends at (ISO date)", type: "string" }]
    }
  ],
  commonFields: [
    { key: "categoryId", label: "Category (optional)", type: "category-select" },
    {
      key: "orderBy",
      label: "Order",
      type: "select",
      options: [
        { label: "Newest", value: "newest_first" },
        { label: "Biggest discount", value: "discount_desc" },
        { label: "Price: low to high", value: "price_asc" },
        { label: "Price: high to low", value: "price_desc" },
        { label: "Name: A–Z", value: "name_asc" }
      ],
      default: "newest_first"
    },
    { key: "limit", label: "Products", type: "number", default: 8 },
    ...Vp("addToCart")
  ]
}, od = [
  { key: "image", label: "Image", type: "image" },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "text" },
  { key: "ctaText", label: "Button text", type: "string", default: "Shop now" },
  { key: "ctaLink", label: "Button link", type: "string", default: "/shop" }
], IS = {
  type: "lookbook-banner",
  label: "Lookbook Banner",
  description: 'A glass panel with a lit picture beside the text (V1), or the letterboxed "cinema" band (V2).',
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "V1 — Lit frame and text",
      fields: [
        ...od,
        {
          key: "imagePosition",
          label: "Picture side",
          type: "select",
          options: [{ label: "Left", value: "left" }, { label: "Right", value: "right" }],
          default: "left"
        }
      ]
    },
    {
      id: "v2",
      label: "V2 — Cinema band",
      fields: [...od, { key: "overlayOpacity", label: "Dark wash (40–100)", type: "number", default: 55 }]
    }
  ],
  commonFields: []
}, OS = [
  { key: "avatar", label: "Photo", type: "image" },
  { key: "name", label: "Name", type: "string" },
  { key: "designation", label: "Detail (city, product…)", type: "string" },
  { key: "review", label: "Review", type: "text" },
  { key: "rating", label: "Rating (1–5)", type: "number", default: 5 }
], rd = [
  { key: "title", label: "Title", type: "string", default: "What customers say" },
  { key: "items", label: "Reviews", type: "array", itemSchema: OS }
], RS = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer quotes: one at a time in the spotlight (V1) or a grid of glass cards (V2).",
  supportedPages: ["home", "shop"],
  variants: [
    { id: "v1", label: "V1 — Spotlight quote", fields: rd },
    { id: "v2", label: "V2 — Card grid", fields: rd }
  ],
  commonFields: []
}, BS = {
  type: "brands",
  label: "Brands",
  description: "Brand logos on glass tiles or a slow ticker; empty uses the store's brands.",
  supportedPages: ["home", "shop", "categories"],
  variants: [{
    id: "v1",
    label: "Logos",
    fields: [
      { key: "title", label: "Title", type: "string" },
      {
        key: "layout",
        label: "Layout",
        type: "select",
        options: [{ label: "Grid", value: "grid" }, { label: "Ticker", value: "ticker" }],
        default: "grid"
      },
      {
        key: "items",
        label: "Brands",
        type: "array",
        itemSchema: [
          { key: "logo", label: "Logo", type: "image" },
          { key: "name", label: "Name", type: "string" },
          { key: "link", label: "Link", type: "string" }
        ]
      }
    ]
  }],
  commonFields: []
}, zS = [
  { key: "title", label: "Title", type: "string" },
  { key: "image", label: "Cover", type: "image" },
  { key: "excerpt", label: "Excerpt", type: "text" },
  { key: "slug", label: "Slug", type: "string" },
  { key: "date", label: "Date", type: "string" },
  { key: "category", label: "Topic", type: "string" }
], VS = { key: "source", label: "Posts to show", type: "select", options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." }, ki = [
  { key: "title", label: "Title", type: "string", default: "From the blog" },
  { key: "posts", label: "Posts", type: "array", itemSchema: zS },
  { key: "viewAllLink", label: "View all link", type: "string", default: "/blog" },
  { key: "showViewAll", label: 'Show "View all"', type: "boolean", default: !0 }
], WS = {
  type: "blog",
  label: "Blog",
  description: "Post cards (V1, V3) or compact rows (V2); on /blog/<slug> the matching post as an article.",
  supportedPages: ["home", "blog", "shop"],
  variants: [
    { id: "v1", label: "V1 — Cards", fields: ki },
    { id: "v2", label: "V2 — Rows", fields: ki },
    { id: "v3", label: "V3 — Cards", fields: ki }
  ],
  commonFields: [VS]
}, $S = {
  type: "cta",
  label: "Newsletter",
  description: "A glass band with the title and an email field; the form shows only with an external form URL.",
  supportedPages: ["home", "shop", "categories"],
  variants: [{
    id: "v1",
    label: "Newsletter band",
    fields: [
      { key: "title", label: "Title", type: "string", default: "Get first light on new drops" },
      { key: "subtitle", label: "Subtitle", type: "string" },
      { key: "placeholder", label: "Email placeholder", type: "string", default: "Your email address" },
      { key: "buttonText", label: "Button text", type: "string", default: "Subscribe" },
      { key: "formAction", label: "Form URL", type: "string", help: "An external newsletter form; without it the band shows no form." }
    ]
  }],
  commonFields: []
}, _S = {
  type: "wishlist",
  label: "Wishlist",
  description: "The products this shopper saved.",
  supportedPages: ["wishlist"],
  variants: [{ id: "v1", label: "Saved products" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Wishlist" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    { key: "emptyTitle", label: "Empty title", type: "string" },
    { key: "emptyText", label: "Empty message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" }
  ]
}, HS = {
  type: "compare",
  label: "Compare",
  description: "Up to four products side by side with a spec table built from their attributes.",
  supportedPages: ["compare"],
  variants: [{ id: "v1", label: "Spec table" }],
  commonFields: [{ key: "title", label: "Title", type: "string", default: "Compare" }]
}, US = {
  type: "coupon",
  label: "Coupons",
  description: "Coupon codes on ticket stubs with copy-to-clipboard.",
  supportedPages: ["coupon"],
  variants: [{ id: "v1", label: "Ticket stubs" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Coupons" },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Code", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Description", type: "string" },
        { key: "discount", label: "Discount label", type: "string", placeholder: "10% off" },
        { key: "expiryDate", label: "Expires (ISO date)", type: "string" }
      ]
    }
  ]
}, Xa = ["home", "shop", "category", "categories", "product", "cart", "blog"], GS = ["truck", "cash", "phone", "shield", "star", "heart", "package", "check", "home", "map-pin", "mail", "bolt", "spark", "clock", "bag", "gift", "headset", "refresh", "bulb", "plug"].map((e) => ({ label: e.replace("-", " "), value: e })), Ro = (e = {}) => [
  { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: e.eyebrow ?? "" },
  { key: "title", label: "Title", type: "localized-string", default: e.title ?? "" },
  { key: "subtitle", label: "Subtitle", type: "localized-text", default: e.subtitle ?? "" }
], Wp = [
  { key: "icon", label: "Icon", type: "icon", default: "shield", options: GS },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "body", label: "Text", type: "localized-text" }
], YS = {
  type: "banner-carousel",
  label: "Banner Carousel",
  description: "Picture slides (their text is part of the image) crossfading in a framed screen, with a progress-bar pager.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [{
    id: "v1",
    label: "Framed screen",
    fields: [
      { key: "title", label: "Name for screen readers", type: "string", default: "Offers" },
      {
        key: "slides",
        label: "Slides",
        type: "array",
        itemSchema: [
          { key: "image", label: "Picture", type: "image", required: !0 },
          { key: "mobileImage", label: "Phone picture (optional)", type: "image" },
          { key: "alt", label: "Picture description", type: "string" },
          { key: "link", label: "Link", type: "string", placeholder: "/shop" }
        ]
      },
      { key: "autoplay", label: "Play automatically", type: "boolean", default: !0 },
      { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 5, dependency: { field: "autoplay", value: !0 } }
    ]
  }],
  commonFields: []
}, ld = [
  ...Ro({ eyebrow: "Browse", title: "Shop by category" }),
  {
    key: "tiles",
    label: "Tiles",
    type: "array",
    help: "Empty = the store's categories.",
    itemSchema: [
      { key: "categoryId", label: "Category", type: "category-select", help: "Sets the link, name and picture unless filled below." },
      { key: "title", label: "Name", type: "localized-string" },
      { key: "tagline", label: "Tagline", type: "localized-string" },
      { key: "image", label: "Picture", type: "image" },
      { key: "link", label: "Link", type: "string", placeholder: "/category/…" }
    ]
  },
  { key: "limit", label: "Categories shown (automatic tiles)", type: "number", default: 8 }
], XS = {
  type: "category-bento",
  label: "Category Tiles",
  description: "Glowing round tiles (V1) or dark bento cards with the picture in a cyan glow (V2).",
  supportedPages: Xa,
  variants: [
    { id: "v1", label: "V1 — Round tiles", fields: ld },
    { id: "v2", label: "V2 — Bento cards", fields: ld }
  ],
  commonFields: []
}, jS = {
  type: "combo-spotlight",
  label: "Product Spotlight",
  description: "One product or bundle on a dark stage under a cone of light, with its saving. Hidden until a product is picked.",
  supportedPages: Xa,
  variants: [{
    id: "v1",
    label: "Spotlight stage",
    fields: [
      ...Ro({ eyebrow: "Bundle & save", title: "Bundle of the week" }),
      { key: "productId", label: "Product", type: "product-select" },
      { key: "description", label: "Text", type: "localized-text", default: "" },
      { key: "mrpLabel", label: "Regular price label", type: "localized-string", default: "Regular price" },
      { key: "savingLabel", label: "Saving label", type: "localized-string", default: "You save" },
      { key: "detailsLabel", label: "Details button text", type: "localized-string", default: "View details" }
    ]
  }],
  commonFields: []
}, qS = {
  type: "corporate-band",
  label: "Bulk Order Band",
  description: "A dark panel edged by an amber-to-cyan line: eyebrow, title and text beside one button.",
  supportedPages: Xa,
  variants: [{
    id: "v1",
    label: "Text and button",
    fields: [
      { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "For businesses" },
      { key: "title", label: "Title", type: "localized-string", default: "Bulk and project orders" },
      { key: "text", label: "Text", type: "localized-text", default: "Lighting an office, a venue or a new build? Get volume pricing and scheduled delivery." },
      { key: "cta.label", label: "Button text", type: "localized-string", default: "Contact us" },
      { key: "cta.url", label: "Button link", type: "string", default: "/contact" }
    ]
  }],
  commonFields: []
}, Zr = [
  { key: "title", label: "Title", type: "string" },
  { key: "handle", label: "Handle (e.g. @neoncinema)", type: "string" },
  {
    key: "items",
    label: "Photos",
    type: "array",
    itemSchema: [
      { key: "image", label: "Photo", type: "image" },
      { key: "link", label: "Link", type: "string" }
    ]
  }
], ZS = {
  type: "instagram-feed",
  label: "Social Feed",
  description: "Photo tiles that glow on hover, the handle as the eyebrow.",
  supportedPages: ["home", "shop"],
  variants: [
    { id: "v1", label: "V1 — 5 columns", fields: Zr },
    { id: "v2", label: "V2 — 6 columns, handle on hover", fields: Zr },
    { id: "v3", label: "V3 — 4 large tiles", fields: Zr },
    { id: "v4", label: "V4 — Masonry", fields: Zr }
  ],
  commonFields: []
}, JS = {
  type: "new-arrivals",
  label: "New Arrivals",
  description: 'A rail of the newest products with "Shop all".',
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [{
    id: "v1",
    label: "Newest rail",
    fields: [
      { key: "title", label: "Title", type: "string", default: "New arrivals" },
      { key: "subtitle", label: "Eyebrow", type: "string" }
    ]
  }],
  commonFields: []
}, KS = {
  type: "offer-banner",
  label: "Offer Banner",
  description: "A picture panel under a dark wash with an amber light leak, a large title and one button.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [{
    id: "v1",
    label: "Picture panel",
    fields: [
      { key: "image", label: "Image", type: "image" },
      { key: "title", label: "Title", type: "string", default: "Special offer" },
      { key: "subtitle", label: "Subtitle", type: "string" },
      { key: "ctaText", label: "Button text", type: "string", default: "Shop now" },
      { key: "ctaLink", label: "Button link", type: "string", default: "/shop", help: "The button shows only with a link." },
      { key: "overlayOpacity", label: "Dark wash (40–90)", type: "number", default: 55 }
    ]
  }],
  commonFields: []
}, QS = {
  type: "product-rail",
  label: "Product Rail",
  description: "Product cards from new arrivals, deals, a category or your own pick, as a grid or a rail. Hidden when empty.",
  supportedPages: Xa,
  variants: [{
    id: "v1",
    label: "Product cards",
    fields: [
      ...Ro({ eyebrow: "Just in", title: "New arrivals" }),
      { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 8 } },
      {
        key: "layout",
        label: "Layout",
        type: "select",
        options: [{ label: "Grid", value: "grid" }, { label: "Rail", value: "rail" }],
        default: "grid"
      },
      { key: "showViewAll", label: 'Show "View all"', type: "boolean", default: !0 },
      { key: "viewAllLabel", label: '"View all" text', type: "string", default: "View all", dependency: { field: "showViewAll", value: !0 } }
    ]
  }],
  commonFields: []
}, ex = {
  type: "promises",
  label: "Promises Strip",
  description: "Two to four glass tiles in one strip, each with a glowing icon, title and line.",
  supportedPages: Xa,
  variants: [{
    id: "v1",
    label: "Glass strip",
    fields: [
      ...Ro(),
      {
        key: "items",
        label: "Promises",
        type: "array",
        itemSchema: Wp,
        default: [
          { icon: "truck", title: "Fast delivery", body: "Quick delivery across the city." },
          { icon: "cash", title: "Pay on delivery", body: "Pay in cash when your order arrives." },
          { icon: "refresh", title: "Easy returns", body: "Not right? We will make it right." },
          { icon: "headset", title: "Here to help", body: "Call or message us any day." }
        ]
      }
    ]
  }],
  commonFields: []
}, tx = {
  type: "reviews",
  label: "Customer Reviews",
  description: "A rail of glass review cards. The store's featured reviews when available, else the ones entered here; hidden when there are none.",
  supportedPages: Xa,
  variants: [{
    id: "v1",
    label: "Review cards",
    fields: [
      ...Ro({ eyebrow: "Reviews", title: "What customers say" }),
      {
        key: "items",
        label: "Reviews",
        type: "array",
        itemSchema: [
          { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
          { key: "title", label: "Title", type: "localized-string" },
          { key: "body", label: "Review", type: "localized-text" },
          { key: "name", label: "Customer name", type: "string" },
          { key: "productId", label: "Product", type: "product-select" }
        ]
      },
      { key: "limit", label: "Most reviews shown", type: "number", default: 6 },
      { key: "minRating", label: "Lowest rating shown (store reviews)", type: "number", default: 4 }
    ]
  }],
  commonFields: []
}, ax = {
  type: "story",
  label: "Story Band",
  description: "A picture in an amber spotlight beside two to four points on a luminous rail, with an optional button.",
  supportedPages: Xa,
  variants: [{
    id: "v1",
    label: "Spotlight and points",
    fields: [
      ...Ro({ eyebrow: "Our promise", title: "Why shop with us" }),
      { key: "image", label: "Picture", type: "image" },
      { key: "points", label: "Points", type: "array", itemSchema: Wp },
      { key: "ctaLabel", label: "Button text", type: "localized-string", default: "" },
      { key: "ctaLink", label: "Button link", type: "string", default: "" }
    ]
  }],
  commonFields: []
}, id = {
  componentSchemas: {
    hero: MS,
    banner: TS,
    "announcement-bar": NS,
    "flash-sale": ES,
    "product-slider": DS,
    "product-grid": FS,
    "lookbook-banner": IS,
    testimonials: RS,
    brands: BS,
    blog: WS,
    cta: $S,
    wishlist: _S,
    compare: HS,
    coupon: US,
    "banner-carousel": YS,
    "category-bento": XS,
    "combo-spotlight": jS,
    "corporate-band": qS,
    "instagram-feed": ZS,
    "new-arrivals": JS,
    "offer-banner": KS,
    "product-rail": QS,
    promises: ex,
    reviews: tx,
    story: ax
  },
  chrome: { headerSchema: AS }
}, yt = {
  componentSchemas: {
    account: nS,
    signin: sS,
    signup: cS,
    banner: gn,
    cart: dS,
    categories: pS,
    category: uS,
    checkout: yS,
    contact: hS,
    content: bS,
    "featured-category": mS,
    features: gS,
    "recent-products": fS,
    hero: vn,
    "order-success": kS,
    "product-detail": Pt,
    "similar-products": SS,
    "shop-grid": At
  },
  headerSchema: fn,
  footerSchema: Ct,
  floatingButtonsSchema: vS,
  mobileNavSchema: wS,
  buttonsSchema: xS
}, ox = ht({
  ...yt,
  componentSchemas: { ...yt.componentSchemas, ...id.componentSchemas },
  ...id.chrome
}, iS), rx = {
  type: "compare",
  label: "Compare",
  description: "Up to four saved products side by side with pack size, price per unit and the best value marked, or an empty state.",
  supportedPages: ["compare"],
  variants: [{ id: "v1", label: "Side by side" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Compare products" },
    { key: "emptyTitle", label: "Empty title", type: "string" },
    { key: "emptyText", label: "Empty message", type: "string" }
  ]
}, lx = {
  ...Pt,
  commonFields: [
    ...Pt.commonFields,
    { key: "howToOrderTitle", label: '"How to order" tab title', type: "string", default: "How to order" },
    { key: "howToOrder", label: "How to order", type: "localized-text", help: "Steps shown in their own tab; the tab is hidden while this is empty." },
    { key: "showDeliveryAreas", label: "Show delivery areas and charges", type: "boolean", default: !0 }
  ]
}, ix = {
  ...At,
  commonFields: [
    ...At.commonFields,
    { key: "pageSizes", label: "Extra page sizes", type: "string", placeholder: "24, 48", help: 'Offered next to "Products per page"; leave empty for one size.' }
  ]
}, nx = {
  type: "wishlist",
  label: "Wishlist",
  description: "The products a shopper saved, or an empty state with a link back to the shop.",
  supportedPages: ["wishlist"],
  variants: [{ id: "v1", label: "Saved products" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Wishlist" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    { key: "emptyTitle", label: "Empty title", type: "string", default: "Your wishlist is empty" },
    { key: "emptyText", label: "Empty message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" }
  ]
}, sx = {
  "shop-grid": ix,
  "product-detail": lx,
  wishlist: nx,
  compare: rx
}, cx = ["facebook", "instagram", "youtube", "tiktok", "linkedin", "x"].map((e) => ({ label: e === "x" ? "X" : e[0].toUpperCase() + e.slice(1), value: e })), dx = {
  ...Ct,
  label: "Footer",
  description: "Brand column, link columns, contact (from Store info) and payment badges.",
  variants: [{ id: "v1", label: "Tint" }],
  commonFields: Ct.commonFields.filter((e) => e.key !== "title").map((e) => {
    var t;
    return e.key !== "socialLinks" ? e : { ...e, itemSchema: (t = e.itemSchema) == null ? void 0 : t.map((a) => a.key === "platform" ? { ...a, options: cx } : a) };
  })
}, px = [
  "home",
  "shop",
  "product",
  "category",
  "categories",
  "search",
  "cart",
  "checkout",
  "contact",
  "signin",
  "signup",
  "account",
  "wishlist",
  "track-order",
  "order-success",
  "order-detail",
  "blog",
  "privacy-policy",
  "terms-of-service",
  "shipping-policy",
  "return-policy"
], ux = [
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link URL", type: "string" },
  {
    key: "type",
    label: "Type",
    type: "select",
    options: [
      { label: "Link", value: "link" },
      { label: "Shop panel (category cards)", value: "categories" }
    ],
    default: "link"
  },
  { key: "badge", label: "Badge", type: "string", placeholder: "New", help: "Small label next to the item." }
], yx = {
  type: "header",
  label: "Header",
  description: "Announcement bar, logo, search, shopper icons and the main menu.",
  supportedPages: [...px],
  variants: [{ id: "v1", label: "Two-tier" }],
  commonFields: [
    { key: "logo.src", label: "Logo", type: "image" },
    { key: "logo.alt", label: "Logo alt text", type: "string" },
    {
      key: "topbar",
      label: "Announcement bar",
      type: "object",
      fields: [
        { key: "active", label: "Show announcement bar", type: "boolean", default: !0 },
        {
          key: "messages",
          label: "Messages",
          type: "array",
          help: "More than one message rotates every few seconds.",
          itemSchema: [
            { key: "text", label: "Text", type: "localized-string" },
            { key: "link", label: "Link", type: "string" }
          ]
        },
        { key: "dismissible", label: "Shoppers can close it", type: "boolean", default: !1 }
      ]
    },
    { key: "searchPlaceholder", label: "Search placeholder", type: "string", placeholder: "Search products…" },
    {
      key: "actions",
      label: "Icons",
      type: "object",
      fields: [
        { key: "showSearch", label: "Search", type: "boolean", default: !0 },
        { key: "showAccount", label: "Account", type: "boolean", default: !0 },
        { key: "showWishlist", label: "Wishlist", type: "boolean", default: !0 },
        { key: "showCart", label: "Cart", type: "boolean", default: !0 },
        {
          key: "cartAction",
          label: "Cart opens",
          type: "select",
          options: [
            { label: "Cart drawer", value: "sidebar" },
            { label: "Cart page", value: "page" }
          ],
          default: "sidebar"
        }
      ]
    },
    { key: "menu", label: "Main menu", type: "array", itemSchema: ux }
  ]
}, hx = {
  type: "announcement-bar",
  label: "Announcement bar",
  description: "A slim rotating bar of short messages, with an optional coupon code after each.",
  supportedPages: ["home", "shop", "product", "category", "categories", "cart", "checkout", "contact", "wishlist"],
  variants: [{ id: "v1", label: "Rotating bar" }],
  commonFields: [{
    key: "items",
    label: "Messages",
    type: "array",
    itemSchema: [
      { key: "text", label: "Message", type: "string" },
      { key: "code", label: "Coupon code (optional)", type: "string" }
    ],
    default: [{ text: "Free delivery on orders over 1000" }]
  }]
}, $p = ["truck", "cash", "phone", "shield", "star", "heart", "package", "check", "store", "map-pin", "mail", "leaf", "sparkle", "clock"].map((e) => ({ label: e.replace("-", " "), value: e })), ja = (e = {}) => [
  { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: e.eyebrow ?? "", help: "Small line above the title." },
  { key: "title", label: "Title", type: "localized-string", default: e.title ?? "" },
  { key: "subtitle", label: "Subtitle", type: "localized-text", default: e.subtitle ?? "" }
], _p = [
  { key: "icon", label: "Icon", type: "icon", default: "shield", options: $p },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "body", label: "Text", type: "localized-text" }
], Mt = ["home", "shop", "category", "categories", "product", "cart", "blog"], bx = [
  { key: "title", label: "Title", type: "string" },
  { key: "image", label: "Cover (16:9)", type: "image" },
  { key: "excerpt", label: "Excerpt", type: "text" },
  { key: "slug", label: "Slug", type: "string", help: "Opens the post at /blog/<slug>." },
  { key: "date", label: "Date", type: "string", placeholder: "12 Sep 2026" },
  { key: "category", label: "Topic", type: "string" }
], nd = [
  { key: "title", label: "Title", type: "string", default: "From the blog" },
  { key: "posts", label: "Posts", type: "array", itemSchema: bx },
  { key: "viewAllLink", label: "View all link", type: "string", default: "/blog" },
  { key: "showViewAll", label: 'Show "View all"', type: "boolean", default: !0 }
], mx = {
  type: "blog",
  label: "Blog",
  description: "Posts entered here, as cards with cover, topic, excerpt and date, or as a compact list.",
  supportedPages: Mt,
  variants: [
    { id: "v1", label: "Cards", fields: nd },
    { id: "v2", label: "Compact list", fields: nd }
  ],
  commonFields: [
    { key: "source", label: "Posts to show", type: "select", options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." },
    ...R
  ]
}, gx = {
  type: "brands",
  label: "Brands",
  description: "Brand logos as a grid of tiles or a scrolling ticker; leave empty to show the store's brands.",
  supportedPages: ["home", "shop", "categories"],
  variants: [{ id: "v1", label: "Logos" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Brands we carry" },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [{ label: "Grid", value: "grid" }, { label: "Ticker", value: "ticker" }],
      default: "grid"
    },
    {
      key: "items",
      label: "Brands",
      type: "array",
      itemSchema: [
        { key: "logo", label: "Logo", type: "image" },
        { key: "name", label: "Name", type: "string" },
        { key: "link", label: "Link", type: "string" }
      ]
    },
    ...R
  ]
}, fx = {
  type: "cta",
  label: "Newsletter",
  description: "A tint card with a title and text beside an email form.",
  supportedPages: Mt,
  variants: [{ id: "v1", label: "Newsletter band" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Subscribe to our newsletter" },
    { key: "subtitle", label: "Text", type: "string" },
    { key: "placeholder", label: "Email placeholder", type: "string", default: "Email address" },
    { key: "buttonText", label: "Button text", type: "string", default: "Subscribe" },
    { key: "formAction", label: "Form URL", type: "string", help: "An external newsletter form; without it the band shows no form." },
    ...R
  ]
}, vx = {
  type: "flash-sale",
  label: "Flash sale",
  description: "A countdown to the end date over a row of the most discounted products. Hidden after it ends.",
  supportedPages: ["home"],
  variants: [{ id: "v1", label: "Countdown row" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Flash sale" },
    { key: "endDate", label: "Ends at (ISO date)", type: "string", placeholder: "2026-12-31T23:59:59" },
    ...R
  ]
}, kx = {
  type: "instagram-feed",
  label: "Social feed",
  description: "Photo tiles from your social account, each linking to its post.",
  supportedPages: Mt,
  variants: [
    { id: "v1", label: "Grid, 5 columns" },
    { id: "v2", label: "Grid, 6 columns" },
    { id: "v3", label: "Grid, 4 columns" },
    { id: "v4", label: "Masonry, 4 columns" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Follow us" },
    { key: "handle", label: "Handle", type: "string", placeholder: "@yourstore" },
    {
      key: "items",
      label: "Photos",
      type: "array",
      itemSchema: [
        { key: "image", label: "Photo", type: "image" },
        { key: "link", label: "Post link", type: "string" }
      ]
    },
    ...R
  ]
}, sd = [
  { key: "image", label: "Picture", type: "image" },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Text", type: "text" },
  { key: "ctaText", label: "Button text", type: "string" },
  { key: "ctaLink", label: "Button link", type: "string", default: "/shop" }
], wx = {
  type: "lookbook-banner",
  label: "Editorial banner",
  description: "A picture with a title, text and one button.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "Picture beside text",
      fields: [
        ...sd,
        {
          key: "imagePosition",
          label: "Picture side",
          type: "select",
          options: [{ label: "Left", value: "left" }, { label: "Right", value: "right" }],
          default: "left"
        }
      ]
    },
    {
      id: "v2",
      label: "Text over picture",
      fields: [...sd, { key: "overlayOpacity", label: "Dark wash (30–90)", type: "number", default: 40 }]
    }
  ],
  commonFields: [...R]
}, Hp = [{
  key: "buttons.addToCart",
  label: "Add to cart button",
  type: "object",
  preview: { type: "button", variant: "primary", defaultLabel: "Add to cart" },
  fields: [
    { key: "label", label: "Button text", type: "string" },
    { key: "bg", label: "Background colour", type: "color" },
    { key: "text", label: "Text colour", type: "color" }
  ]
}], ys = (e) => [
  { key: "title", label: "Title", type: "string", default: e },
  { key: "subtitle", label: "Subtitle", type: "string" }
], hs = ["home", "shop", "category", "categories"], Sx = {
  type: "new-arrivals",
  label: "New arrivals",
  description: "A swipe row of the newest products.",
  supportedPages: hs,
  variants: [{ id: "v1", label: "Product row" }],
  commonFields: [...ys("New arrivals"), ...R]
}, xx = {
  type: "offer-banner",
  label: "Offer banner",
  description: "A picture panel with a title, text and one button.",
  supportedPages: ["home", "shop", "category"],
  variants: [{ id: "v1", label: "Picture panel" }],
  commonFields: [
    { key: "image", label: "Picture", type: "image" },
    { key: "title", label: "Title", type: "string", default: "Special offer" },
    { key: "subtitle", label: "Text", type: "text" },
    { key: "ctaText", label: "Button text", type: "string", default: "Shop now" },
    { key: "ctaLink", label: "Button link", type: "string", default: "/shop" },
    { key: "overlayOpacity", label: "Dark wash (30–90)", type: "number", default: 50 },
    ...R
  ]
}, Jo = [...ys("All products"), { key: "viewAllLink", label: "View all link", type: "string", default: "/shop" }], Tx = {
  type: "product-grid",
  label: "Product grid",
  description: "Products as a card grid, a lead product beside smaller ones, or compact rows.",
  supportedPages: hs,
  variants: [
    { id: "v1", label: "Card grid", fields: Jo },
    { id: "v2", label: "Lead card and 6", fields: Jo },
    { id: "v3", label: "Compact rows", fields: Jo },
    { id: "v4", label: "Lead card and 4", fields: Jo },
    {
      id: "v6",
      label: "Compact rows with special offer",
      fields: [...Jo, { key: "offerEndsAt", label: "Offer ends at (ISO date)", type: "string" }]
    }
  ],
  commonFields: [
    { key: "categoryId", label: "Category (optional)", type: "category-select" },
    {
      key: "orderBy",
      label: "Order",
      type: "select",
      options: [
        { label: "Newest", value: "newest_first" },
        { label: "Biggest discount", value: "discount_desc" },
        { label: "Price: low to high", value: "price_asc" },
        { label: "Price: high to low", value: "price_desc" },
        { label: "Name: A–Z", value: "name_asc" }
      ],
      default: "newest_first"
    },
    { key: "limit", label: "Products", type: "number", default: 8 },
    ...Hp,
    ...R
  ]
}, Cx = {
  type: "product-slider",
  label: "Product slider",
  description: "A swipe row of product cards, optionally with category tabs.",
  supportedPages: hs,
  variants: [
    {
      id: "v1",
      label: "Category tabs",
      fields: [{
        key: "tabs",
        label: "Tabs",
        type: "array",
        itemSchema: [
          { key: "label", label: "Tab label", type: "string" },
          { key: "categoryId", label: "Category", type: "category-select" }
        ]
      }]
    },
    { id: "v2", label: "Single row" }
  ],
  commonFields: [...ys("Featured products"), ...Hp, ...R]
}, Px = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer quotes as review cards with rating, photo, name and role.",
  supportedPages: Mt,
  variants: [
    { id: "v1", label: "Review cards" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "What customers say" },
    {
      key: "items",
      label: "Reviews",
      type: "array",
      itemSchema: [
        { key: "avatar", label: "Photo", type: "image" },
        { key: "name", label: "Name", type: "string" },
        { key: "designation", label: "Role or city", type: "string" },
        { key: "review", label: "Review", type: "text" },
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 }
      ]
    },
    ...R
  ]
}, Ax = {
  type: "banner-carousel",
  label: "Banner carousel",
  description: "Full-width picture slides (offers, campaigns) with arrows, dots and autoplay.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [{ id: "v1", label: "Picture slides" }],
  commonFields: [
    { key: "title", label: "Name for screen readers", type: "string", default: "Offers" },
    {
      key: "slides",
      label: "Slides",
      type: "array",
      itemSchema: [
        { key: "image", label: "Picture", type: "image", required: !0, help: "About 1240 × 360 px." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional, about 780 × 400 px." },
        { key: "alt", label: "Picture description", type: "string", help: "What the banner says, for screen readers." },
        { key: "link", label: "Link", type: "string", placeholder: "/shop" }
      ],
      default: []
    },
    { key: "autoplay", label: "Play automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 5, dependency: { field: "autoplay", value: !0 } },
    ...R
  ]
}, Lx = {
  type: "category-bento",
  label: "Category tiles",
  description: "Round photo tiles or tint cards linking to categories.",
  supportedPages: Mt,
  variants: [
    { id: "v1", label: "Round tiles" },
    { id: "v2", label: "Bento cards" }
  ],
  commonFields: [
    ...ja({ eyebrow: "Browse", title: "Shop by category" }),
    {
      key: "tiles",
      label: "Tiles",
      type: "array",
      help: "Empty = the store’s categories.",
      itemSchema: [
        { key: "categoryId", label: "Category", type: "category-select", help: "Sets the link, name and picture unless filled below." },
        { key: "title", label: "Name", type: "localized-string" },
        { key: "tagline", label: "Tagline", type: "localized-string" },
        { key: "image", label: "Picture", type: "image" },
        { key: "link", label: "Link", type: "string", placeholder: "/category/…" }
      ],
      default: []
    },
    { key: "limit", label: "Categories shown (automatic tiles)", type: "number", default: 8 },
    ...R
  ]
}, Mx = {
  type: "combo-spotlight",
  label: "Product spotlight",
  description: "One product or bundle on a large dark card with its price, saving and Add to cart.",
  supportedPages: Mt,
  variants: [{ id: "v1", label: "Dark card" }],
  commonFields: [
    ...ja({ eyebrow: "Bundle & save", title: "Value pack of the week" }),
    { key: "productId", label: "Product", type: "product-select", help: "Hidden until a product is picked." },
    { key: "description", label: "Text", type: "localized-text", default: "" },
    { key: "mrpLabel", label: "Regular price label", type: "localized-string", default: "Regular price" },
    { key: "savingLabel", label: "Saving label", type: "localized-string", default: "You save" },
    { key: "detailsLabel", label: "Details button text", type: "localized-string", default: "View details" },
    ...R
  ]
}, Nx = {
  type: "corporate-band",
  label: "Bulk order band",
  description: "Text and one button, e.g. for corporate, event or wholesale orders.",
  supportedPages: Mt,
  variants: [{ id: "v1", label: "Text and button" }],
  commonFields: [
    ...ja({ eyebrow: "For businesses", title: "Bulk and corporate orders" }).filter((e) => e.key !== "subtitle"),
    { key: "text", label: "Text", type: "localized-text", default: "Ordering for an office, an event or gifts? Get volume pricing and scheduled delivery." },
    { key: "cta.label", label: "Button text", type: "localized-string", default: "Contact us" },
    { key: "cta.url", label: "Button link", type: "string", default: "/contact" },
    ...R
  ]
}, Ex = {
  type: "hero",
  label: "Hero",
  description: "Headline panel with buttons, trust chips and product cards; extra slides rotate after it.",
  supportedPages: ["home", "shop", "category", "categories", "cart", "checkout", "order-success"],
  variants: [{ id: "v1", label: "Split panel with product cards" }],
  commonFields: [
    { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "Fresh every day" },
    { key: "headline", label: "Headline", type: "localized-string", default: "Everyday essentials, delivered to your door" },
    { key: "subtext", label: "Text", type: "localized-text", default: "Hand-picked products at fair prices. Order in minutes and pay when it arrives." },
    { key: "image", label: "Picture", type: "image", help: "Shown beside the text on large screens. Empty = the first product card’s photo." },
    { key: "imageAlt", label: "Picture description", type: "string", help: "For screen readers. Leave empty if the picture is decorative." },
    { key: "primaryCta.label", label: "Main button text", type: "localized-string", default: "Shop now" },
    { key: "primaryCta.url", label: "Main button link", type: "string", default: "/shop" },
    { key: "secondaryCta.label", label: "Second button text", type: "localized-string", default: "Today’s deals" },
    { key: "secondaryCta.url", label: "Second button link", type: "string", default: "/shop?order_by=discount_desc" },
    { key: "showTrustChips", label: "Show trust chips", type: "boolean", default: !0 },
    {
      key: "trustChips",
      label: "Trust chips",
      type: "array",
      dependency: { field: "showTrustChips", value: !0 },
      itemSchema: [
        { key: "icon", label: "Icon", type: "icon", default: "truck", options: $p },
        { key: "text", label: "Text", type: "localized-string" }
      ],
      default: [
        { icon: "shipping", text: "Fast delivery" },
        { icon: "secure", text: "Cash on delivery" },
        { icon: "refund", text: "Easy returns" }
      ]
    },
    { key: "showCards", label: "Show product cards", type: "boolean", default: !0 },
    {
      key: "cards",
      label: "Product cards",
      type: "array",
      help: "Up to two. Empty = the two biggest current deals.",
      dependency: { field: "showCards", value: !0 },
      itemSchema: [
        { key: "productId", label: "Product", type: "product-select" },
        { key: "label", label: "Label", type: "localized-string", placeholder: "Bestseller" }
      ],
      default: []
    },
    {
      key: "slides",
      label: "More slides",
      type: "array",
      help: "Shown after the headline slide. Pick a product, or write your own text and add a picture.",
      itemSchema: [
        { key: "productId", label: "Product", type: "product-select" },
        { key: "badge", label: "Badge", type: "localized-string", placeholder: "New" },
        { key: "title", label: "Headline", type: "localized-string", help: "Empty = the product name." },
        { key: "subtitle", label: "Text", type: "localized-text" },
        { key: "image", label: "Picture", type: "image", help: "Empty = the product photo." },
        { key: "ctaText", label: "Button text", type: "localized-string", placeholder: "View product" },
        { key: "ctaLink", label: "Button link", type: "string", help: "Empty = the product page." }
      ],
      default: []
    },
    { key: "autoplay", label: "Play slides automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 6, dependency: { field: "autoplay", value: !0 } },
    ...R
  ]
}, Dx = {
  type: "product-rail",
  label: "Product rail",
  description: "A grid or swipe row of product cards from new arrivals, deals, a category or your own pick.",
  supportedPages: Mt,
  variants: [{ id: "v1", label: "Product cards" }],
  commonFields: [
    ...ja({ eyebrow: "Just in", title: "New arrivals", subtitle: "The latest additions to the store." }),
    { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 8 } },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [
        { label: "Grid (2 columns on phones, 4 on desktop)", value: "grid" },
        { label: "Swipe row", value: "rail" }
      ],
      default: "grid"
    },
    { key: "showViewAll", label: "Show “View all”", type: "boolean", default: !0 },
    { key: "viewAllLabel", label: "“View all” text", type: "string", default: "View all", dependency: { field: "showViewAll", value: !0 } },
    ...R
  ]
}, Fx = {
  type: "promises",
  label: "Promises strip",
  description: "Short store promises (delivery, payment, returns, support) with icons.",
  supportedPages: Mt,
  variants: [{ id: "v1", label: "Tint tiles" }],
  commonFields: [
    ...ja(),
    {
      key: "items",
      label: "Promises",
      type: "array",
      itemSchema: _p,
      default: [
        { icon: "shipping", title: "Fast delivery", body: "Quick delivery across the city." },
        { icon: "secure", title: "Pay on delivery", body: "Pay in cash when your order arrives." },
        { icon: "refund", title: "Easy returns", body: "Not right? We will make it right." },
        { icon: "support", title: "Here to help", body: "Call or message us any day." }
      ]
    },
    ...R
  ]
}, Ix = {
  type: "reviews",
  label: "Customer reviews",
  description: "A swipe row of review cards: rating, quote, name and the product.",
  supportedPages: Mt,
  variants: [{ id: "v1", label: "Review cards" }],
  commonFields: [
    ...ja({ eyebrow: "Reviews", title: "What customers say" }),
    {
      key: "items",
      label: "Reviews",
      type: "array",
      help: "Real reviews from your customers, with their permission.",
      itemSchema: [
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "body", label: "Review", type: "localized-text" },
        { key: "name", label: "Customer name", type: "string" },
        { key: "productId", label: "Product", type: "product-select" }
      ],
      default: []
    },
    { key: "limit", label: "Most reviews shown", type: "number", default: 6 },
    { key: "minRating", label: "Lowest rating shown (store reviews)", type: "number", default: 4 },
    ...R
  ]
}, Ox = {
  type: "story",
  label: "Story band",
  description: "Why shop with you: a picture beside short benefit points.",
  supportedPages: Mt,
  variants: [{ id: "v1", label: "Picture and points" }],
  commonFields: [
    ...ja({ eyebrow: "Our promise", title: "Why shop with us", subtitle: "Good products, honest prices and service you can count on." }),
    { key: "image", label: "Picture", type: "image" },
    {
      key: "points",
      label: "Points",
      type: "array",
      itemSchema: _p,
      default: [
        { icon: "secure", title: "Quality checked", body: "Every product is checked before it leaves our store." },
        { icon: "shipping", title: "Delivered fresh", body: "Packed with care and delivered quickly to your door." },
        { icon: "support", title: "Real support", body: "Questions about an order? Call or message us any day." }
      ]
    },
    { key: "ctaLabel", label: "Button text", type: "localized-string", default: "" },
    { key: "ctaLink", label: "Button link", type: "string", default: "" },
    ...R
  ]
}, Rx = {
  hero: Ex,
  "banner-carousel": Ax,
  "category-bento": Lx,
  "product-rail": Dx,
  story: Ox,
  "combo-spotlight": Mx,
  reviews: Ix,
  promises: Fx,
  "corporate-band": Nx,
  "announcement-bar": hx,
  blog: mx,
  brands: gx,
  cta: fx,
  "flash-sale": vx,
  "instagram-feed": kx,
  "lookbook-banner": wx,
  "new-arrivals": Sx,
  "offer-banner": xx,
  "product-grid": Tx,
  "product-slider": Cx,
  testimonials: Px
}, Bx = {
  type: "account",
  label: "Account",
  description: "Signed-in shopper area: overview, orders, profile and saved addresses.",
  supportedPages: ["account", "orders", "profile", "addresses"],
  variants: [{ id: "v1", label: "Side navigation" }],
  commonFields: [
    { key: "title", label: "Overview title", type: "string", default: "My account" },
    { key: "tabOverviewLabel", label: "Overview label", type: "string", default: "Overview" },
    { key: "tabOrdersLabel", label: "Orders label", type: "string", default: "Orders" },
    { key: "tabDetailsLabel", label: "Profile label", type: "string", default: "Profile" },
    { key: "tabAddressesLabel", label: "Addresses label", type: "string", default: "Addresses" },
    { key: "signOutLabel", label: "Sign out label", type: "string", default: "Sign out" }
  ]
}, zx = {
  type: "cart",
  label: "Cart",
  description: "Cart lines with quantity steppers, delivery area choice, free-delivery progress and checkout.",
  supportedPages: ["cart"],
  variants: [{ id: "v1", label: "Lines + totals box" }],
  commonFields: [
    { key: "pageTitle", label: "Page title (for screen readers)", type: "string", default: "Shopping cart" },
    { key: "emptyTitle", label: "Empty cart title", type: "string", default: "Your cart is currently empty." },
    { key: "emptyMessage", label: "Empty cart message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Totals title", type: "string", default: "Cart totals" },
    { key: "subtotalLabel", label: "Subtotal label", type: "string", default: "Subtotal" },
    { key: "shippingLabel", label: "Delivery label", type: "string", default: "Delivery" },
    { key: "shippingCalculatedText", label: "Text when delivery areas are unavailable", type: "string", default: "Delivery charge is added at checkout." },
    { key: "totalLabel", label: "Total label", type: "string", default: "Total" },
    { key: "checkoutButtonText", label: "Checkout button text", type: "string", default: "Proceed to checkout" },
    { key: "checkoutLink", label: "Checkout link", type: "string", default: "/checkout" }
  ]
}, Vx = {
  type: "checkout",
  label: "Checkout",
  description: "Billing details, delivery area, payment and order summary with a place-order button.",
  supportedPages: ["checkout"],
  variants: [{ id: "v1", label: "Two columns" }],
  commonFields: [
    { key: "pageTitle", label: "Billing title", type: "string", default: "Billing details" },
    { key: "emptyTitle", label: "Empty cart title", type: "string", default: "Your cart is empty." },
    { key: "emptyMessage", label: "Empty cart message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Return to shop" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order summary title", type: "string", default: "Your order" },
    { key: "subtotalLabel", label: "Subtotal label", type: "string", default: "Subtotal" },
    { key: "deliveryLabel", label: "Delivery label", type: "string", default: "Delivery" },
    { key: "totalLabel", label: "Total label", type: "string", default: "Total" },
    { key: "codLabel", label: "Cash on delivery label", type: "string", default: "Cash on delivery" },
    { key: "codDescription", label: "How to pay (cash on delivery)", type: "localized-text", default: "Pay with cash when your order arrives." },
    { key: "privacyNote", label: "Privacy note", type: "localized-text", help: "Shown above the place-order button. Leave empty for the default note linking to the privacy policy." },
    { key: "placeOrderText", label: "Place order button text", type: "string", default: "Place order" },
    { key: "placingOrderText", label: "Placing order text", type: "string", default: "Placing order…" }
  ]
}, Wx = {
  type: "contact",
  label: "Contact",
  description: "Phone, WhatsApp, email and address cards. Empty fields use Store info.",
  supportedPages: ["contact"],
  variants: [{ id: "v1", label: "Contact cards" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Contact us" },
    { key: "description", label: "Intro text", type: "localized-text", default: "Questions about an order or a product? We are happy to help." },
    { key: "phone", label: "Phone (empty: Store info hotline)", type: "string" },
    { key: "email", label: "Email (empty: Store info email)", type: "string" },
    { key: "address", label: "Address (empty: Store info addresses)", type: "text" },
    { key: "hoursText", label: "Opening hours", type: "localized-text" }
  ]
}, $x = {
  type: "content",
  label: "Content page",
  description: "Policies, about, FAQ and other text pages, with an optional question-and-answer list.",
  supportedPages: ["privacy-policy", "terms-of-service", "shipping-policy", "return-policy", "track-order"],
  variants: [{ id: "v1", label: "Readable column" }],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "subtitle", label: "Subtitle", type: "localized-text" },
    { key: "content", label: "Text", type: "rich-text" },
    {
      key: "faqs",
      label: "Questions and answers",
      type: "array",
      help: "Shown as an accordion under the text (also published as FAQ structured data).",
      itemSchema: [
        { key: "question", label: "Question", type: "string" },
        { key: "answer", label: "Answer", type: "text" }
      ]
    },
    { key: "updatedText", label: "Last updated note", type: "string", placeholder: "Last updated 1 January 2026" }
  ]
}, _x = {
  type: "coupon",
  label: "Coupons",
  description: "Coupon codes with discount, title, description, expiry and a copy button.",
  supportedPages: ["coupon"],
  variants: [{ id: "v1", label: "Code cards" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Coupons" },
    { key: "subtitle", label: "Subtitle", type: "localized-text", default: "Use these codes when you order." },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Code", type: "string" },
        { key: "discount", label: "Discount (e.g. 10% off)", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Conditions", type: "text" },
        { key: "expiryDate", label: "Valid until", type: "string" }
      ]
    },
    { key: "emptyText", label: "Text when there are no coupons", type: "string", default: "No coupons right now. Check back soon." }
  ]
}, Hx = {
  type: "order-success",
  label: "Order complete",
  description: "Thank-you message with the order number, date, total, payment and order details.",
  supportedPages: ["order-success"],
  variants: [{ id: "v1", label: "Thank-you card" }],
  commonFields: [
    { key: "title", label: "Thank-you title", type: "localized-string", default: "Thank you. Your order has been received." },
    { key: "message", label: "Thank-you message", type: "localized-text", default: "We will call you to confirm your order before delivery." },
    { key: "errorTitle", label: "Title when the order cannot be loaded", type: "string", default: "Your order was placed." },
    { key: "errorMessage", label: "Message when the order cannot be loaded", type: "string", default: "We could not load the order details on this device, but your order was received." },
    { key: "viewOrderText", label: "View order button text (signed-in shoppers)", type: "string", default: "View order" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" }
  ]
}, Ux = {
  type: "signin",
  label: "Sign in",
  description: "Phone number and one-time code card; new shoppers add their name.",
  supportedPages: ["signin", "forgot-password", "reset-password"],
  variants: [{ id: "v1", label: "Card" }],
  commonFields: [
    { key: "title", label: "Title", type: "localized-string", default: "Sign in" },
    { key: "intro", label: "Intro text", type: "localized-text", default: "Use your mobile number. We send you a code by SMS — no password needed." },
    { key: "redirectUrl", label: "Go to after signing in", type: "string", default: "/account" }
  ]
}, Gx = {
  type: "signup",
  label: "Sign up",
  description: "Phone number and one-time code card; new shoppers add their name.",
  supportedPages: ["signup"],
  variants: [{ id: "v1", label: "Card" }],
  commonFields: [
    { key: "title", label: "Title", type: "localized-string", default: "Create your account" },
    { key: "intro", label: "Intro text", type: "localized-text", default: "Use your mobile number. We send you a code by SMS — no password needed." },
    { key: "redirectUrl", label: "Go to after signing in", type: "string", default: "/account" }
  ]
}, Yx = {
  cart: zx,
  checkout: Vx,
  "order-success": Hx,
  coupon: _x,
  account: Bx,
  signin: Ux,
  signup: Gx,
  contact: Wx,
  content: $x
}, Xx = ht({
  ...yt,
  componentSchemas: {
    ...yt.componentSchemas,
    ...Rx,
    ...sx,
    ...Yx
  },
  headerSchema: yx,
  footerSchema: dx
}, lS), jx = {
  banner: { hide: ["title", "description", "ctaText", "ctaLink", "backgroundImage"], keep: [], add: Oa.variants, variantLabels: { v1: "Selling points (icon, title, line)", v2: "Two picture banners" } },
  category: { hide: ["cardVariant", "autoplay", "autoplayDelay"] },
  "featured-category": { hide: ["productCardVariant", "noSelectionText", "noProductsText", "buttons.orderNow"] },
  "floating-buttons": { hide: ["phone", "messenger", "callUsTitle", "whatsappTitle", "messengerTitle"] },
  footer: { hide: ["logo", "contactAddress"] },
  hero: { hide: ["showTrustChips", "trustChips", "showCards", "cards"], labels: { eyebrow: { label: "Yellow label above the headline" }, headline: { label: "Headline (first slide)", help: "Upper-case title of the first slide. More slides follow it." }, subtext: { label: "Text under the headline" }, image: { label: "Picture on the right of the first slide", help: "Desktop only. Empty = the first deal’s photo." }, slides: { label: "More slides", help: "Shown after the first slide. A slide with a picture and no product fills the banner with that picture." } } },
  "offer-banner": { hide: ["overlayOpacity"] },
  "product-detail": { hide: ["loadingText", "notFoundCode", "notFoundText"] },
  "recent-products": { hide: ["productCardVariant", "buttons"] },
  "shop-grid": { hide: ["sidebarVariant", "productCardVariant", "paginationVariant", "initialPriceRange", "filtersButtonLabel", "showingLabel", "productsSuffix", "sortNewestLabel", "sortOldestLabel", "sortPriceAscLabel", "sortPriceDescLabel", "sortNameAscLabel", "sortNameDescLabel", "activeFiltersLabel", "backToAllText", "filterDrawerTitle", "currentSearchLabel", "clearSearchLabel", "applyFiltersLabel", "buttons.orderNow"] },
  "similar-products": { hide: ["productCardVariant", "buttons.orderNow"] },
  features: { add: [{ id: "v2", label: "Large tiles" }, { id: "v3", label: "Icons on one band" }], variantLabels: { v1: "Tiles" } },
  "mobile-bottom-nav": { hide: ["items[].isPrimary"] },
  // Theme tab: button settings no part of this theme reads (colours drive every primary button via the CTA).
  buttons: { hide: ["appearance.buttons.primary[].radius", "appearance.buttons.primary[].height", "appearance.buttons.primary[].paddingX", "appearance.buttons.primary[].label", "appearance.buttons.outline[].radius", "appearance.buttons.outline[].height", "appearance.buttons.outline[].paddingX", "appearance.buttons.outline[].label"] }
}, qx = {
  type: "compare",
  label: "Compare",
  description: "Up to four saved products side by side with the price per kg, litre or piece, the cheapest flagged, or an empty state.",
  supportedPages: ["compare"],
  variants: [{ id: "v1", label: "Side by side" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Compare products" },
    { key: "emptyTitle", label: "Empty title", type: "string" },
    { key: "emptyText", label: "Empty message", type: "string" }
  ]
}, Zx = {
  ...Pt,
  commonFields: [
    ...Pt.commonFields,
    { key: "howToOrderTitle", label: '"How to order" tab title', type: "string", default: "How to order" },
    { key: "howToOrder", label: "How to order", type: "localized-text", help: "Steps shown in their own tab; the tab is hidden while this is empty." },
    { key: "showDeliveryAreas", label: "Show delivery areas and charges", type: "boolean", default: !0 }
  ]
}, Jx = {
  ...At,
  commonFields: [
    ...At.commonFields,
    { key: "pageSizes", label: "Extra page sizes", type: "string", placeholder: "24, 48", help: 'Offered next to "Products per page"; leave empty for one size.' }
  ]
}, Kx = {
  type: "wishlist",
  label: "Wishlist",
  description: "The products a shopper saved, or an empty state with a link back to the shop.",
  supportedPages: ["wishlist"],
  variants: [{ id: "v1", label: "Saved products" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Wishlist" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    { key: "emptyTitle", label: "Empty title", type: "string", default: "Your wishlist is empty" },
    { key: "emptyText", label: "Empty message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" }
  ]
}, Qx = {
  "shop-grid": Jx,
  "product-detail": Zx,
  wishlist: Kx,
  compare: qx
}, eT = ["facebook", "instagram", "youtube", "tiktok", "linkedin", "x"].map((e) => ({ label: e === "x" ? "X" : e[0].toUpperCase() + e.slice(1), value: e })), tT = {
  ...Ct,
  label: "Footer",
  description: "Brand column, link columns, contact (from Store info) and payment badges.",
  variants: [{ id: "v1", label: "Tint" }],
  commonFields: Ct.commonFields.filter((e) => e.key !== "title").map((e) => {
    var t;
    return e.key !== "socialLinks" ? e : { ...e, itemSchema: (t = e.itemSchema) == null ? void 0 : t.map((a) => a.key === "platform" ? { ...a, options: eT } : a) };
  })
}, aT = [
  "home",
  "shop",
  "product",
  "category",
  "categories",
  "search",
  "cart",
  "checkout",
  "contact",
  "signin",
  "signup",
  "account",
  "wishlist",
  "track-order",
  "order-success",
  "order-detail",
  "blog",
  "privacy-policy",
  "terms-of-service",
  "shipping-policy",
  "return-policy"
], oT = [
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link URL", type: "string" },
  {
    key: "type",
    label: "Type",
    type: "select",
    options: [
      { label: "Link", value: "link" },
      { label: "Shop panel (category cards)", value: "categories" }
    ],
    default: "link"
  },
  { key: "badge", label: "Badge", type: "string", placeholder: "New", help: "Small label next to the item." }
], rT = {
  type: "header",
  label: "Header",
  description: "Announcement bar, logo, search, shopper icons and the main menu.",
  supportedPages: [...aT],
  variants: [{ id: "v1", label: "Two-tier" }],
  commonFields: [
    { key: "logo.src", label: "Logo", type: "image" },
    { key: "logo.alt", label: "Logo alt text", type: "string" },
    {
      key: "topbar",
      label: "Announcement bar",
      type: "object",
      fields: [
        { key: "active", label: "Show announcement bar", type: "boolean", default: !0 },
        {
          key: "messages",
          label: "Messages",
          type: "array",
          help: "More than one message rotates every few seconds.",
          itemSchema: [
            { key: "text", label: "Text", type: "localized-string" },
            { key: "link", label: "Link", type: "string" }
          ]
        },
        { key: "dismissible", label: "Shoppers can close it", type: "boolean", default: !1 }
      ]
    },
    { key: "searchPlaceholder", label: "Search placeholder", type: "string", placeholder: "Search products…" },
    {
      key: "actions",
      label: "Icons",
      type: "object",
      fields: [
        { key: "showSearch", label: "Search", type: "boolean", default: !0 },
        { key: "showAccount", label: "Account", type: "boolean", default: !0 },
        { key: "showWishlist", label: "Wishlist", type: "boolean", default: !0 },
        { key: "showCart", label: "Cart", type: "boolean", default: !0 },
        {
          key: "cartAction",
          label: "Cart opens",
          type: "select",
          options: [
            { label: "Cart drawer", value: "sidebar" },
            { label: "Cart page", value: "page" }
          ],
          default: "sidebar"
        }
      ]
    },
    { key: "menu", label: "Main menu", type: "array", itemSchema: oT }
  ]
}, lT = {
  type: "announcement-bar",
  label: "Announcement bar",
  description: "A slim rotating bar of short messages, with an optional coupon code after each.",
  supportedPages: ["home", "shop", "product", "category", "categories", "cart", "checkout", "contact", "wishlist"],
  variants: [{ id: "v1", label: "Rotating bar" }],
  commonFields: [{
    key: "items",
    label: "Messages",
    type: "array",
    itemSchema: [
      { key: "text", label: "Message", type: "string" },
      { key: "code", label: "Coupon code (optional)", type: "string" }
    ],
    default: [{ text: "Free delivery on orders over 1000" }]
  }]
}, Up = ["truck", "cash", "phone", "shield", "star", "heart", "package", "check", "store", "map-pin", "mail", "leaf", "sparkle", "clock"].map((e) => ({ label: e.replace("-", " "), value: e })), qa = (e = {}) => [
  { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: e.eyebrow ?? "", help: "Small line above the title." },
  { key: "title", label: "Title", type: "localized-string", default: e.title ?? "" },
  { key: "subtitle", label: "Subtitle", type: "localized-text", default: e.subtitle ?? "" }
], Gp = [
  { key: "icon", label: "Icon", type: "icon", default: "shield", options: Up },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "body", label: "Text", type: "localized-text" }
], Nt = ["home", "shop", "category", "categories", "product", "cart", "blog"], iT = [
  { key: "title", label: "Title", type: "string" },
  { key: "image", label: "Cover (16:9)", type: "image" },
  { key: "excerpt", label: "Excerpt", type: "text" },
  { key: "slug", label: "Slug", type: "string", help: "Opens the post at /blog/<slug>." },
  { key: "date", label: "Date", type: "string", placeholder: "12 Sep 2026" },
  { key: "category", label: "Topic", type: "string" }
], cd = [
  { key: "title", label: "Title", type: "string", default: "From the blog" },
  { key: "posts", label: "Posts", type: "array", itemSchema: iT },
  { key: "viewAllLink", label: "View all link", type: "string", default: "/blog" },
  { key: "showViewAll", label: 'Show "View all"', type: "boolean", default: !0 }
], nT = {
  type: "blog",
  label: "Blog",
  description: "Posts entered here, as cards with cover, topic, excerpt and date, or as a compact list.",
  supportedPages: Nt,
  variants: [
    { id: "v1", label: "Cards", fields: cd },
    { id: "v2", label: "Compact list", fields: cd }
  ],
  commonFields: [
    { key: "source", label: "Posts to show", type: "select", options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." },
    ...R
  ]
}, sT = {
  type: "brands",
  label: "Brands",
  description: "Brand logos as a grid of tiles or a scrolling ticker; leave empty to show the store's brands.",
  supportedPages: ["home", "shop", "categories"],
  variants: [{ id: "v1", label: "Logos" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Brands we carry" },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [{ label: "Grid", value: "grid" }, { label: "Ticker", value: "ticker" }],
      default: "grid"
    },
    {
      key: "items",
      label: "Brands",
      type: "array",
      itemSchema: [
        { key: "logo", label: "Logo", type: "image" },
        { key: "name", label: "Name", type: "string" },
        { key: "link", label: "Link", type: "string" }
      ]
    },
    ...R
  ]
}, cT = {
  type: "cta",
  label: "Newsletter",
  description: "A tint card with a title and text beside an email form.",
  supportedPages: Nt,
  variants: [{ id: "v1", label: "Newsletter band" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Subscribe to our newsletter" },
    { key: "subtitle", label: "Text", type: "string" },
    { key: "placeholder", label: "Email placeholder", type: "string", default: "Email address" },
    { key: "buttonText", label: "Button text", type: "string", default: "Subscribe" },
    { key: "formAction", label: "Form URL", type: "string", help: "An external newsletter form; without it the band shows no form." },
    ...R
  ]
}, dT = {
  type: "flash-sale",
  label: "Flash sale",
  description: "A grey band with countdown boxes, category chips and the most discounted products, and an optional side banner. Hidden after it ends.",
  supportedPages: ["home"],
  variants: [{ id: "v1", label: "Countdown row" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Flash sale" },
    { key: "endDate", label: "Ends at (ISO date)", type: "string", placeholder: "2026-12-31T23:59:59", help: "Leave empty to hide the countdown." },
    { key: "sideImage", label: "Side banner picture", type: "image", help: "Tall picture beside the deals (desktop). Optional." },
    { key: "sideLink", label: "Side banner link", type: "string", placeholder: "/shop" },
    ...R
  ]
}, pT = {
  type: "instagram-feed",
  label: "Social feed",
  description: "Photo tiles from your social account, each linking to its post.",
  supportedPages: Nt,
  variants: [
    { id: "v1", label: "Grid, 5 columns" },
    { id: "v2", label: "Grid, 6 columns" },
    { id: "v3", label: "Grid, 4 columns" },
    { id: "v4", label: "Masonry, 4 columns" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Follow us" },
    { key: "handle", label: "Handle", type: "string", placeholder: "@yourstore" },
    {
      key: "items",
      label: "Photos",
      type: "array",
      itemSchema: [
        { key: "image", label: "Photo", type: "image" },
        { key: "link", label: "Post link", type: "string" }
      ]
    },
    ...R
  ]
}, dd = [
  { key: "image", label: "Picture", type: "image" },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Text", type: "text" },
  { key: "ctaText", label: "Button text", type: "string" },
  { key: "ctaLink", label: "Button link", type: "string", default: "/shop" }
], uT = {
  type: "lookbook-banner",
  label: "Editorial banner",
  description: "A picture with a title, text and one button.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "Picture beside text",
      fields: [
        ...dd,
        {
          key: "imagePosition",
          label: "Picture side",
          type: "select",
          options: [{ label: "Left", value: "left" }, { label: "Right", value: "right" }],
          default: "left"
        }
      ]
    },
    {
      id: "v2",
      label: "Text over picture",
      fields: [...dd, { key: "overlayOpacity", label: "Dark wash (30–90)", type: "number", default: 40 }]
    }
  ],
  commonFields: [...R]
}, Yp = [{
  key: "buttons.addToCart",
  label: "Add to cart button",
  type: "object",
  preview: { type: "button", variant: "primary", defaultLabel: "Add to cart" },
  fields: [
    { key: "label", label: "Button text", type: "string" },
    { key: "bg", label: "Background colour", type: "color" },
    { key: "text", label: "Text colour", type: "color" }
  ]
}], bs = (e) => [
  { key: "title", label: "Title", type: "string", default: e },
  { key: "subtitle", label: "Subtitle", type: "string" }
], ms = ["home", "shop", "category", "categories"], yT = {
  type: "new-arrivals",
  label: "New arrivals",
  description: "A swipe row of the newest products.",
  supportedPages: ms,
  variants: [{ id: "v1", label: "Product row" }],
  commonFields: [...bs("New arrivals"), ...R]
}, hT = {
  type: "offer-banner",
  label: "Offer banner",
  description: "A picture panel with a title, text and one button.",
  supportedPages: ["home", "shop", "category"],
  variants: [{ id: "v1", label: "Picture panel" }],
  commonFields: [
    { key: "image", label: "Picture", type: "image" },
    { key: "title", label: "Title", type: "string", default: "Special offer" },
    { key: "subtitle", label: "Text", type: "text" },
    { key: "ctaText", label: "Button text", type: "string", default: "Shop now" },
    { key: "ctaLink", label: "Button link", type: "string", default: "/shop" },
    { key: "overlayOpacity", label: "Dark wash (30–90)", type: "number", default: 50 },
    ...R
  ]
}, Ko = [...bs("All products"), { key: "viewAllLink", label: "View all link", type: "string", default: "/shop" }], bT = {
  type: "product-grid",
  label: "Product grid",
  description: "Products as a card grid, a lead product beside smaller ones, or compact rows.",
  supportedPages: ms,
  variants: [
    { id: "v1", label: "Card grid", fields: Ko },
    { id: "v2", label: "Lead card and 6", fields: Ko },
    { id: "v3", label: "Compact rows", fields: Ko },
    { id: "v4", label: "Lead card and 4", fields: Ko },
    {
      id: "v6",
      label: "Compact rows with special offer",
      fields: [...Ko, { key: "offerEndsAt", label: "Offer ends at (ISO date)", type: "string" }]
    }
  ],
  commonFields: [
    { key: "categoryId", label: "Category (optional)", type: "category-select" },
    {
      key: "orderBy",
      label: "Order",
      type: "select",
      options: [
        { label: "Newest", value: "newest_first" },
        { label: "Biggest discount", value: "discount_desc" },
        { label: "Price: low to high", value: "price_asc" },
        { label: "Price: high to low", value: "price_desc" },
        { label: "Name: A–Z", value: "name_asc" }
      ],
      default: "newest_first"
    },
    { key: "limit", label: "Products", type: "number", default: 8 },
    ...Yp,
    ...R
  ]
}, mT = {
  type: "product-slider",
  label: "Product slider",
  description: "A swipe row of product cards, optionally with category tabs.",
  supportedPages: ms,
  variants: [
    {
      id: "v1",
      label: "Category tabs",
      fields: [{
        key: "tabs",
        label: "Tabs",
        type: "array",
        itemSchema: [
          { key: "label", label: "Tab label", type: "string" },
          { key: "categoryId", label: "Category", type: "category-select" }
        ]
      }]
    },
    { id: "v2", label: "Single row" }
  ],
  commonFields: [...bs("Featured products"), ...Yp, ...R]
}, gT = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer quotes as review cards with rating, photo, name and role.",
  supportedPages: Nt,
  variants: [
    { id: "v1", label: "Review cards" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "What customers say" },
    {
      key: "items",
      label: "Reviews",
      type: "array",
      itemSchema: [
        { key: "avatar", label: "Photo", type: "image" },
        { key: "name", label: "Name", type: "string" },
        { key: "designation", label: "Role or city", type: "string" },
        { key: "review", label: "Review", type: "text" },
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 }
      ]
    },
    ...R
  ]
}, fT = {
  type: "banner-carousel",
  label: "Banner carousel",
  description: "Full-width picture slides (offers, campaigns) with arrows, dots and autoplay.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [{ id: "v1", label: "Picture slides" }],
  commonFields: [
    { key: "title", label: "Name for screen readers", type: "string", default: "Offers" },
    {
      key: "slides",
      label: "Slides",
      type: "array",
      itemSchema: [
        { key: "image", label: "Picture", type: "image", required: !0, help: "About 1240 × 360 px." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional, about 780 × 400 px." },
        { key: "alt", label: "Picture description", type: "string", help: "What the banner says, for screen readers." },
        { key: "link", label: "Link", type: "string", placeholder: "/shop" }
      ],
      default: []
    },
    { key: "autoplay", label: "Play automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 5, dependency: { field: "autoplay", value: !0 } },
    ...R
  ]
}, vT = {
  type: "category-bento",
  label: "Category tiles",
  description: "Round photo tiles or tint cards linking to categories.",
  supportedPages: Nt,
  variants: [
    { id: "v1", label: "Round tiles" },
    { id: "v2", label: "Bento cards" }
  ],
  commonFields: [
    ...qa({ eyebrow: "Browse", title: "Shop by category" }),
    {
      key: "tiles",
      label: "Tiles",
      type: "array",
      help: "Empty = the store’s categories.",
      itemSchema: [
        { key: "categoryId", label: "Category", type: "category-select", help: "Sets the link, name and picture unless filled below." },
        { key: "title", label: "Name", type: "localized-string" },
        { key: "tagline", label: "Tagline", type: "localized-string" },
        { key: "image", label: "Picture", type: "image" },
        { key: "link", label: "Link", type: "string", placeholder: "/category/…" }
      ],
      default: []
    },
    { key: "limit", label: "Categories shown (automatic tiles)", type: "number", default: 8 },
    ...R
  ]
}, kT = {
  type: "combo-spotlight",
  label: "Product spotlight",
  description: "One product or bundle on a large dark card with its price, saving and Add to cart.",
  supportedPages: Nt,
  variants: [{ id: "v1", label: "Dark card" }],
  commonFields: [
    ...qa({ eyebrow: "Bundle & save", title: "Value pack of the week" }),
    { key: "productId", label: "Product", type: "product-select", help: "Hidden until a product is picked." },
    { key: "description", label: "Text", type: "localized-text", default: "" },
    { key: "mrpLabel", label: "Regular price label", type: "localized-string", default: "Regular price" },
    { key: "savingLabel", label: "Saving label", type: "localized-string", default: "You save" },
    { key: "detailsLabel", label: "Details button text", type: "localized-string", default: "View details" },
    ...R
  ]
}, wT = {
  type: "corporate-band",
  label: "Bulk order band",
  description: "Text and one button, e.g. for corporate, event or wholesale orders.",
  supportedPages: Nt,
  variants: [{ id: "v1", label: "Text and button" }],
  commonFields: [
    ...qa({ eyebrow: "For businesses", title: "Bulk and corporate orders" }).filter((e) => e.key !== "subtitle"),
    { key: "text", label: "Text", type: "localized-text", default: "Ordering for an office, an event or gifts? Get volume pricing and scheduled delivery." },
    { key: "cta.label", label: "Button text", type: "localized-string", default: "Contact us" },
    { key: "cta.url", label: "Button link", type: "string", default: "/contact" },
    ...R
  ]
}, ST = {
  type: "hero",
  label: "Hero",
  description: "Headline panel with buttons, trust chips and product cards; extra slides rotate after it.",
  supportedPages: ["home", "shop", "category", "categories", "cart", "checkout", "order-success"],
  variants: [{ id: "v1", label: "Banner beside the category list" }],
  commonFields: [
    { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "Fresh every day" },
    { key: "headline", label: "Headline", type: "localized-string", default: "Everyday essentials, delivered to your door" },
    { key: "subtext", label: "Text", type: "localized-text", default: "Hand-picked products at fair prices. Order in minutes and pay when it arrives." },
    { key: "image", label: "Picture", type: "image", help: "Shown beside the text on large screens. Empty = the first product card’s photo." },
    { key: "imageAlt", label: "Picture description", type: "string", help: "For screen readers. Leave empty if the picture is decorative." },
    { key: "primaryCta.label", label: "Main button text", type: "localized-string", default: "Shop now" },
    { key: "primaryCta.url", label: "Main button link", type: "string", default: "/shop" },
    { key: "secondaryCta.label", label: "Second button text", type: "localized-string", default: "Today’s deals" },
    { key: "secondaryCta.url", label: "Second button link", type: "string", default: "/shop?order_by=discount_desc" },
    { key: "showTrustChips", label: "Show trust chips", type: "boolean", default: !0 },
    {
      key: "trustChips",
      label: "Trust chips",
      type: "array",
      dependency: { field: "showTrustChips", value: !0 },
      itemSchema: [
        { key: "icon", label: "Icon", type: "icon", default: "truck", options: Up },
        { key: "text", label: "Text", type: "localized-string" }
      ],
      default: [
        { icon: "shipping", text: "Fast delivery" },
        { icon: "secure", text: "Cash on delivery" },
        { icon: "refund", text: "Easy returns" }
      ]
    },
    { key: "showCards", label: "Show product cards", type: "boolean", default: !0 },
    {
      key: "cards",
      label: "Product cards",
      type: "array",
      help: "Up to two. Empty = the two biggest current deals.",
      dependency: { field: "showCards", value: !0 },
      itemSchema: [
        { key: "productId", label: "Product", type: "product-select" },
        { key: "label", label: "Label", type: "localized-string", placeholder: "Bestseller" }
      ],
      default: []
    },
    {
      key: "slides",
      label: "More slides",
      type: "array",
      help: "Shown after the headline slide. Pick a product, or write your own text and add a picture.",
      itemSchema: [
        { key: "productId", label: "Product", type: "product-select" },
        { key: "badge", label: "Badge (product slides)", type: "localized-string", placeholder: "New" },
        { key: "title", label: "Headline", type: "localized-string", help: "Shown on product slides (empty = the product name). On a picture slide it is only read by screen readers." },
        { key: "subtitle", label: "Text (product slides)", type: "localized-text" },
        { key: "image", label: "Banner picture", type: "image", help: "Without a product, the picture fills the banner on its own (put your text in the picture). With a product, empty = the product photo." },
        { key: "ctaText", label: "Button text (product slides)", type: "localized-string", placeholder: "View product" },
        { key: "ctaLink", label: "Link", type: "string", help: "Where the button (product slide) or the whole banner (picture slide) goes. Empty = the product page." }
      ],
      default: []
    },
    { key: "autoplay", label: "Play slides automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 6, help: "0 or empty = 6 seconds.", dependency: { field: "autoplay", value: !0 } },
    ...R
  ]
}, xT = {
  type: "product-rail",
  label: "Product rail",
  description: "A grid or swipe row of product cards from new arrivals, deals, a category or your own pick.",
  supportedPages: Nt,
  variants: [{ id: "v1", label: "Product cards" }],
  commonFields: [
    ...qa({ eyebrow: "Just in", title: "New arrivals", subtitle: "The latest additions to the store." }),
    { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 8 } },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [
        { label: "Grid (2 columns on phones, 4 on desktop)", value: "grid" },
        { label: "Swipe row", value: "rail" }
      ],
      default: "grid"
    },
    { key: "showViewAll", label: "Show “View all”", type: "boolean", default: !0 },
    { key: "viewAllLabel", label: "“View all” text", type: "string", default: "View all", dependency: { field: "showViewAll", value: !0 } },
    ...R
  ]
}, TT = {
  type: "promises",
  label: "Promises strip",
  description: "Short store promises (delivery, payment, returns, support) with icons.",
  supportedPages: Nt,
  variants: [{ id: "v1", label: "Tint tiles" }],
  commonFields: [
    ...qa(),
    {
      key: "items",
      label: "Promises",
      type: "array",
      itemSchema: Gp,
      default: [
        { icon: "shipping", title: "Fast delivery", body: "Quick delivery across the city." },
        { icon: "secure", title: "Pay on delivery", body: "Pay in cash when your order arrives." },
        { icon: "refund", title: "Easy returns", body: "Not right? We will make it right." },
        { icon: "support", title: "Here to help", body: "Call or message us any day." }
      ]
    },
    ...R
  ]
}, CT = {
  type: "reviews",
  label: "Customer reviews",
  description: "A swipe row of review cards: rating, quote, name and the product.",
  supportedPages: Nt,
  variants: [{ id: "v1", label: "Review cards" }],
  commonFields: [
    ...qa({ eyebrow: "Reviews", title: "What customers say" }),
    {
      key: "items",
      label: "Reviews",
      type: "array",
      help: "Real reviews from your customers, with their permission.",
      itemSchema: [
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "body", label: "Review", type: "localized-text" },
        { key: "name", label: "Customer name", type: "string" },
        { key: "productId", label: "Product", type: "product-select" }
      ],
      default: []
    },
    { key: "limit", label: "Most reviews shown", type: "number", default: 6 },
    { key: "minRating", label: "Lowest rating shown (store reviews)", type: "number", default: 4 },
    ...R
  ]
}, PT = {
  type: "story",
  label: "Story band",
  description: "Why shop with you: a picture beside short benefit points.",
  supportedPages: Nt,
  variants: [{ id: "v1", label: "Picture and points" }],
  commonFields: [
    ...qa({ eyebrow: "Our promise", title: "Why shop with us", subtitle: "Good products, honest prices and service you can count on." }),
    { key: "image", label: "Picture", type: "image" },
    {
      key: "points",
      label: "Points",
      type: "array",
      itemSchema: Gp,
      default: [
        { icon: "secure", title: "Quality checked", body: "Every product is checked before it leaves our store." },
        { icon: "shipping", title: "Delivered fresh", body: "Packed with care and delivered quickly to your door." },
        { icon: "support", title: "Real support", body: "Questions about an order? Call or message us any day." }
      ]
    },
    { key: "ctaLabel", label: "Button text", type: "localized-string", default: "" },
    { key: "ctaLink", label: "Button link", type: "string", default: "" },
    ...R
  ]
}, AT = {
  hero: ST,
  "banner-carousel": fT,
  "category-bento": vT,
  "product-rail": xT,
  story: PT,
  "combo-spotlight": kT,
  reviews: CT,
  promises: TT,
  "corporate-band": wT,
  "announcement-bar": lT,
  blog: nT,
  brands: sT,
  cta: cT,
  "flash-sale": dT,
  "instagram-feed": pT,
  "lookbook-banner": uT,
  "new-arrivals": yT,
  "offer-banner": hT,
  "product-grid": bT,
  "product-slider": mT,
  testimonials: gT
}, LT = {
  type: "account",
  label: "Account",
  description: "Signed-in shopper area: overview, orders, profile and saved addresses.",
  supportedPages: ["account", "orders", "profile", "addresses"],
  variants: [{ id: "v1", label: "Side navigation" }],
  commonFields: [
    { key: "title", label: "Overview title", type: "string", default: "My account" },
    { key: "tabOverviewLabel", label: "Overview label", type: "string", default: "Overview" },
    { key: "tabOrdersLabel", label: "Orders label", type: "string", default: "Orders" },
    { key: "tabDetailsLabel", label: "Profile label", type: "string", default: "Profile" },
    { key: "tabAddressesLabel", label: "Addresses label", type: "string", default: "Addresses" },
    { key: "signOutLabel", label: "Sign out label", type: "string", default: "Sign out" }
  ]
}, MT = {
  type: "cart",
  label: "Cart",
  description: "Cart lines with quantity steppers, delivery area choice, free-delivery progress and checkout.",
  supportedPages: ["cart"],
  variants: [{ id: "v1", label: "Lines + totals box" }],
  commonFields: [
    { key: "pageTitle", label: "Page title (for screen readers)", type: "string", default: "Shopping cart" },
    { key: "emptyTitle", label: "Empty cart title", type: "string", default: "Your cart is currently empty." },
    { key: "emptyMessage", label: "Empty cart message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Totals title", type: "string", default: "Cart totals" },
    { key: "subtotalLabel", label: "Subtotal label", type: "string", default: "Subtotal" },
    { key: "shippingLabel", label: "Delivery label", type: "string", default: "Delivery" },
    { key: "shippingCalculatedText", label: "Text when delivery areas are unavailable", type: "string", default: "Delivery charge is added at checkout." },
    { key: "totalLabel", label: "Total label", type: "string", default: "Total" },
    { key: "checkoutButtonText", label: "Checkout button text", type: "string", default: "Proceed to checkout" },
    { key: "checkoutLink", label: "Checkout link", type: "string", default: "/checkout" }
  ]
}, NT = {
  type: "checkout",
  label: "Checkout",
  description: "Billing details, delivery area, payment and order summary with a place-order button.",
  supportedPages: ["checkout"],
  variants: [{ id: "v1", label: "Two columns" }],
  commonFields: [
    { key: "pageTitle", label: "Billing title", type: "string", default: "Billing details" },
    { key: "emptyTitle", label: "Empty cart title", type: "string", default: "Your cart is empty." },
    { key: "emptyMessage", label: "Empty cart message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Return to shop" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order summary title", type: "string", default: "Your order" },
    { key: "subtotalLabel", label: "Subtotal label", type: "string", default: "Subtotal" },
    { key: "deliveryLabel", label: "Delivery label", type: "string", default: "Delivery" },
    { key: "totalLabel", label: "Total label", type: "string", default: "Total" },
    { key: "codLabel", label: "Cash on delivery label", type: "string", default: "Cash on delivery" },
    { key: "codDescription", label: "How to pay (cash on delivery)", type: "localized-text", default: "Pay with cash when your order arrives." },
    { key: "privacyNote", label: "Privacy note", type: "localized-text", help: "Shown above the place-order button. Leave empty for the default note linking to the privacy policy." },
    { key: "placeOrderText", label: "Place order button text", type: "string", default: "Place order" },
    { key: "placingOrderText", label: "Placing order text", type: "string", default: "Placing order…" }
  ]
}, ET = {
  type: "contact",
  label: "Contact",
  description: "Phone, WhatsApp, email and address cards. Empty fields use Store info.",
  supportedPages: ["contact"],
  variants: [{ id: "v1", label: "Contact cards" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Contact us" },
    { key: "description", label: "Intro text", type: "localized-text", default: "Questions about an order or a product? We are happy to help." },
    { key: "phone", label: "Phone (empty: Store info hotline)", type: "string" },
    { key: "email", label: "Email (empty: Store info email)", type: "string" },
    { key: "address", label: "Address (empty: Store info addresses)", type: "text" },
    { key: "hoursText", label: "Opening hours", type: "localized-text" }
  ]
}, DT = {
  type: "content",
  label: "Content page",
  description: "Policies, about, FAQ and other text pages, with an optional question-and-answer list.",
  supportedPages: ["privacy-policy", "terms-of-service", "shipping-policy", "return-policy", "track-order"],
  variants: [{ id: "v1", label: "Readable column" }],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "subtitle", label: "Subtitle", type: "localized-text" },
    { key: "content", label: "Text", type: "rich-text" },
    {
      key: "faqs",
      label: "Questions and answers",
      type: "array",
      help: "Shown as an accordion under the text (also published as FAQ structured data).",
      itemSchema: [
        { key: "question", label: "Question", type: "string" },
        { key: "answer", label: "Answer", type: "text" }
      ]
    },
    { key: "updatedText", label: "Last updated note", type: "string", placeholder: "Last updated 1 January 2026" }
  ]
}, FT = {
  type: "coupon",
  label: "Coupons",
  description: "Coupon codes with discount, title, description, expiry and a copy button.",
  supportedPages: ["coupon"],
  variants: [{ id: "v1", label: "Code cards" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Coupons" },
    { key: "subtitle", label: "Subtitle", type: "localized-text", default: "Use these codes when you order." },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Code", type: "string" },
        { key: "discount", label: "Discount (e.g. 10% off)", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Conditions", type: "text" },
        { key: "expiryDate", label: "Valid until", type: "string" }
      ]
    },
    { key: "emptyText", label: "Text when there are no coupons", type: "string", default: "No coupons right now. Check back soon." }
  ]
}, IT = {
  type: "order-success",
  label: "Order complete",
  description: "Thank-you message with the order number, date, total, payment and order details.",
  supportedPages: ["order-success"],
  variants: [{ id: "v1", label: "Thank-you card" }],
  commonFields: [
    { key: "title", label: "Thank-you title", type: "localized-string", default: "Thank you. Your order has been received." },
    { key: "message", label: "Thank-you message", type: "localized-text", default: "We will call you to confirm your order before delivery." },
    { key: "errorTitle", label: "Title when the order cannot be loaded", type: "string", default: "Your order was placed." },
    { key: "errorMessage", label: "Message when the order cannot be loaded", type: "string", default: "We could not load the order details on this device, but your order was received." },
    { key: "viewOrderText", label: "View order button text (signed-in shoppers)", type: "string", default: "View order" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" }
  ]
}, OT = {
  type: "signin",
  label: "Sign in",
  description: "Phone number and one-time code card; new shoppers add their name.",
  supportedPages: ["signin", "forgot-password", "reset-password"],
  variants: [{ id: "v1", label: "Card" }],
  commonFields: [
    { key: "title", label: "Title", type: "localized-string", default: "Sign in" },
    { key: "intro", label: "Intro text", type: "localized-text", default: "Use your mobile number. We send you a code by SMS — no password needed." },
    { key: "redirectUrl", label: "Go to after signing in", type: "string", default: "/account" }
  ]
}, RT = {
  type: "signup",
  label: "Sign up",
  description: "Phone number and one-time code card; new shoppers add their name.",
  supportedPages: ["signup"],
  variants: [{ id: "v1", label: "Card" }],
  commonFields: [
    { key: "title", label: "Title", type: "localized-string", default: "Create your account" },
    { key: "intro", label: "Intro text", type: "localized-text", default: "Use your mobile number. We send you a code by SMS — no password needed." },
    { key: "redirectUrl", label: "Go to after signing in", type: "string", default: "/account" }
  ]
}, BT = {
  cart: MT,
  checkout: NT,
  "order-success": IT,
  coupon: FT,
  account: LT,
  signin: OT,
  signup: RT,
  contact: ET,
  content: DT
}, zT = ht({
  ...yt,
  componentSchemas: {
    ...yt.componentSchemas,
    ...AT,
    ...Qx,
    ...BT
  },
  headerSchema: rT,
  footerSchema: tT
}, jx), VT = {
  banner: { hide: ["title", "description", "ctaText", "ctaLink", "backgroundImage"], keep: [], add: Oa.variants, variantLabels: { v1: "Selling points (icon, title, line)", v2: "Two picture banners" } },
  category: { hide: ["cardVariant", "autoplay", "autoplayDelay"] },
  "featured-category": { hide: ["productCardVariant", "noSelectionText", "noProductsText", "buttons.orderNow"] },
  "floating-buttons": { hide: ["phone", "messenger", "callUsTitle", "whatsappTitle", "messengerTitle"] },
  footer: { hide: ["logo", "contactAddress"] },
  "product-detail": { hide: ["loadingText", "notFoundCode", "notFoundText"] },
  "recent-products": { hide: ["productCardVariant", "buttons"] },
  "shop-grid": { hide: ["sidebarVariant", "productCardVariant", "paginationVariant", "initialPriceRange", "filtersButtonLabel", "showingLabel", "productsSuffix", "sortNewestLabel", "sortOldestLabel", "sortPriceAscLabel", "sortPriceDescLabel", "sortNameAscLabel", "sortNameDescLabel", "activeFiltersLabel", "backToAllText", "filterDrawerTitle", "currentSearchLabel", "clearSearchLabel", "applyFiltersLabel", "buttons.orderNow"] },
  "similar-products": { hide: ["productCardVariant", "buttons.orderNow"] },
  features: { add: [{ id: "v2", label: "Large tiles" }, { id: "v3", label: "Icons on one band" }], variantLabels: { v1: "Tiles" } },
  hero: { hide: ["showTrustChips", "trustChips", "showCards", "cards"], labels: { eyebrow: { label: "Pill label above the title" }, headline: { label: "Title (first slide)", help: "The last word (two when the title has four or more) shows in amber." }, subtext: { label: "Text under the title" }, image: { label: "Picture on the amber circle", help: "Right side on desktop. Empty = the first deal’s cover." } } },
  header: { hide: ["topbar[].dismissible", "menu[].type"] },
  "mobile-bottom-nav": { hide: ["items[].isPrimary"] },
  // Theme tab: button settings no part of this theme reads (colours drive every primary button via the CTA).
  buttons: { hide: ["appearance.buttons.primary[].radius", "appearance.buttons.primary[].height", "appearance.buttons.primary[].paddingX", "appearance.buttons.primary[].label", "appearance.buttons.outline[].radius", "appearance.buttons.outline[].height", "appearance.buttons.outline[].paddingX", "appearance.buttons.outline[].label"] },
  // Delivery time is shown on product cards only by Prottoho.
  "store-info": { hide: ["deliveryEta"] }
}, WT = {
  type: "compare",
  label: "Compare",
  description: "Up to four saved books side by side (covers, price, writer, format, publisher, book details), or an empty state.",
  supportedPages: ["compare"],
  variants: [{ id: "v1", label: "Side by side" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Compare products" },
    { key: "emptyTitle", label: "Empty title", type: "string" },
    { key: "emptyText", label: "Empty message", type: "string" }
  ]
}, $T = {
  ...Pt,
  commonFields: [
    ...Pt.commonFields,
    { key: "howToOrderTitle", label: '"How to order" tab title', type: "string", default: "How to order" },
    { key: "howToOrder", label: "How to order", type: "localized-text", help: "Steps shown in their own tab; the tab is hidden while this is empty." },
    { key: "showDeliveryAreas", label: "Show delivery areas and charges", type: "boolean", default: !0 }
  ]
}, _T = {
  ...At,
  commonFields: [
    ...At.commonFields,
    { key: "pageSizes", label: "Extra page sizes", type: "string", placeholder: "24, 48", help: 'Offered next to "Products per page"; leave empty for one size.' }
  ]
}, HT = {
  type: "wishlist",
  label: "Wishlist",
  description: "The products a shopper saved, or an empty state with a link back to the shop.",
  supportedPages: ["wishlist"],
  variants: [{ id: "v1", label: "Saved products" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Wishlist" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    { key: "emptyTitle", label: "Empty title", type: "string", default: "Your wishlist is empty" },
    { key: "emptyText", label: "Empty message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" }
  ]
}, UT = {
  "shop-grid": _T,
  "product-detail": $T,
  wishlist: HT,
  compare: WT
}, GT = ["facebook", "instagram", "youtube", "tiktok", "linkedin", "x"].map((e) => ({ label: e === "x" ? "X" : e[0].toUpperCase() + e.slice(1), value: e })), YT = {
  ...Ct,
  label: "Footer",
  description: "Brand column, link columns, contact (from Store info) and payment badges.",
  variants: [{ id: "v1", label: "Tint" }],
  commonFields: Ct.commonFields.filter((e) => e.key !== "title").map((e) => {
    var t;
    return e.key !== "socialLinks" ? e : { ...e, itemSchema: (t = e.itemSchema) == null ? void 0 : t.map((a) => a.key === "platform" ? { ...a, options: GT } : a) };
  })
}, XT = [
  "home",
  "shop",
  "product",
  "category",
  "categories",
  "search",
  "cart",
  "checkout",
  "contact",
  "signin",
  "signup",
  "account",
  "wishlist",
  "track-order",
  "order-success",
  "order-detail",
  "blog",
  "privacy-policy",
  "terms-of-service",
  "shipping-policy",
  "return-policy"
], jT = [
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link URL", type: "string" },
  {
    key: "type",
    label: "Type",
    type: "select",
    options: [
      { label: "Link", value: "link" },
      { label: "Shop panel (category cards)", value: "categories" }
    ],
    default: "link"
  },
  { key: "badge", label: "Badge", type: "string", placeholder: "New", help: "Small label next to the item." }
], qT = {
  type: "header",
  label: "Header",
  description: "Announcement bar, logo, search, shopper icons and the main menu.",
  supportedPages: [...XT],
  variants: [{ id: "v1", label: "Two-tier" }],
  commonFields: [
    { key: "logo.src", label: "Logo", type: "image" },
    { key: "logo.alt", label: "Logo alt text", type: "string" },
    {
      key: "topbar",
      label: "Announcement bar",
      type: "object",
      fields: [
        { key: "active", label: "Show announcement bar", type: "boolean", default: !0 },
        {
          key: "messages",
          label: "Messages",
          type: "array",
          help: "More than one message rotates every few seconds.",
          itemSchema: [
            { key: "text", label: "Text", type: "localized-string" },
            { key: "link", label: "Link", type: "string" }
          ]
        },
        { key: "dismissible", label: "Shoppers can close it", type: "boolean", default: !1 }
      ]
    },
    { key: "searchPlaceholder", label: "Search placeholder", type: "string", placeholder: "Search products…" },
    {
      key: "actions",
      label: "Icons",
      type: "object",
      fields: [
        { key: "showSearch", label: "Search", type: "boolean", default: !0 },
        { key: "showAccount", label: "Account", type: "boolean", default: !0 },
        { key: "showWishlist", label: "Wishlist", type: "boolean", default: !0 },
        { key: "showCart", label: "Cart", type: "boolean", default: !0 },
        {
          key: "cartAction",
          label: "Cart opens",
          type: "select",
          options: [
            { label: "Cart drawer", value: "sidebar" },
            { label: "Cart page", value: "page" }
          ],
          default: "sidebar"
        }
      ]
    },
    { key: "menu", label: "Main menu", type: "array", itemSchema: jT }
  ]
}, ZT = {
  type: "announcement-bar",
  label: "Announcement bar",
  description: "A slim rotating bar of short messages, with an optional coupon code after each.",
  supportedPages: ["home", "shop", "product", "category", "categories", "cart", "checkout", "contact", "wishlist"],
  variants: [{ id: "v1", label: "Rotating bar" }],
  commonFields: [{
    key: "items",
    label: "Messages",
    type: "array",
    itemSchema: [
      { key: "text", label: "Message", type: "string" },
      { key: "code", label: "Coupon code (optional)", type: "string" }
    ],
    default: [{ text: "Free delivery on orders over 1000" }]
  }]
}, Xp = ["truck", "cash", "phone", "shield", "star", "heart", "package", "check", "store", "map-pin", "mail", "leaf", "sparkle", "clock"].map((e) => ({ label: e.replace("-", " "), value: e })), Za = (e = {}) => [
  { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: e.eyebrow ?? "", help: "Small line above the title." },
  { key: "title", label: "Title", type: "localized-string", default: e.title ?? "" },
  { key: "subtitle", label: "Subtitle", type: "localized-text", default: e.subtitle ?? "" }
], jp = [
  { key: "icon", label: "Icon", type: "icon", default: "shield", options: Xp },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "body", label: "Text", type: "localized-text" }
], Et = ["home", "shop", "category", "categories", "product", "cart", "blog"], JT = [
  { key: "title", label: "Title", type: "string" },
  { key: "image", label: "Cover (16:9)", type: "image" },
  { key: "excerpt", label: "Excerpt", type: "text" },
  { key: "slug", label: "Slug", type: "string", help: "Opens the post at /blog/<slug>." },
  { key: "date", label: "Date", type: "string", placeholder: "12 Sep 2026" },
  { key: "category", label: "Topic", type: "string" }
], pd = [
  { key: "title", label: "Title", type: "string", default: "From the blog" },
  { key: "posts", label: "Posts", type: "array", itemSchema: JT },
  { key: "viewAllLink", label: "View all link", type: "string", default: "/blog" },
  { key: "showViewAll", label: 'Show "View all"', type: "boolean", default: !0 }
], KT = {
  type: "blog",
  label: "Blog",
  description: "Posts entered here, as cards with cover, topic, excerpt and date, or as a compact list.",
  supportedPages: Et,
  variants: [
    { id: "v1", label: "Cards", fields: pd },
    { id: "v2", label: "Compact list", fields: pd }
  ],
  commonFields: [
    { key: "source", label: "Posts to show", type: "select", options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." },
    ...R
  ]
}, QT = {
  type: "brands",
  label: "Brands",
  description: "Brand logos as a grid of tiles or a scrolling ticker; leave empty to show the store's brands.",
  supportedPages: ["home", "shop", "categories"],
  variants: [{ id: "v1", label: "Logos" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Brands we carry" },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [{ label: "Grid", value: "grid" }, { label: "Ticker", value: "ticker" }],
      default: "grid"
    },
    {
      key: "items",
      label: "Brands",
      type: "array",
      itemSchema: [
        { key: "logo", label: "Logo", type: "image" },
        { key: "name", label: "Name", type: "string" },
        { key: "link", label: "Link", type: "string" }
      ]
    },
    ...R
  ]
}, e1 = {
  type: "cta",
  label: "Newsletter",
  description: "A tint card with a title and text beside an email form.",
  supportedPages: Et,
  variants: [{ id: "v1", label: "Newsletter band" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Subscribe to our newsletter" },
    { key: "subtitle", label: "Text", type: "string" },
    { key: "placeholder", label: "Email placeholder", type: "string", default: "Email address" },
    { key: "buttonText", label: "Button text", type: "string", default: "Subscribe" },
    { key: "formAction", label: "Form URL", type: "string", help: "An external newsletter form; without it the band shows no form." },
    ...R
  ]
}, t1 = {
  type: "flash-sale",
  label: "Flash sale",
  description: "A countdown to the end date over a row of the most discounted products. Hidden after it ends.",
  supportedPages: ["home"],
  variants: [{ id: "v1", label: "Countdown row" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Flash sale" },
    { key: "endDate", label: "Ends at (ISO date)", type: "string", placeholder: "2026-12-31T23:59:59" },
    ...R
  ]
}, a1 = {
  type: "instagram-feed",
  label: "Social feed",
  description: "Photo tiles from your social account, each linking to its post.",
  supportedPages: Et,
  variants: [
    { id: "v1", label: "Grid, 5 columns" },
    { id: "v2", label: "Grid, 6 columns" },
    { id: "v3", label: "Grid, 4 columns" },
    { id: "v4", label: "Masonry, 4 columns" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Follow us" },
    { key: "handle", label: "Handle", type: "string", placeholder: "@yourstore" },
    {
      key: "items",
      label: "Photos",
      type: "array",
      itemSchema: [
        { key: "image", label: "Photo", type: "image" },
        { key: "link", label: "Post link", type: "string" }
      ]
    },
    ...R
  ]
}, ud = [
  { key: "image", label: "Picture", type: "image" },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Text", type: "text" },
  { key: "ctaText", label: "Button text", type: "string" },
  { key: "ctaLink", label: "Button link", type: "string", default: "/shop" }
], o1 = {
  type: "lookbook-banner",
  label: "Editorial banner",
  description: "A picture with a title, text and one button.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "Picture beside text",
      fields: [
        ...ud,
        {
          key: "imagePosition",
          label: "Picture side",
          type: "select",
          options: [{ label: "Left", value: "left" }, { label: "Right", value: "right" }],
          default: "left"
        }
      ]
    },
    {
      id: "v2",
      label: "Text over picture",
      fields: [...ud, { key: "overlayOpacity", label: "Dark wash (30–90)", type: "number", default: 40 }]
    }
  ],
  commonFields: [...R]
}, qp = [{
  key: "buttons.addToCart",
  label: "Add to cart button",
  type: "object",
  preview: { type: "button", variant: "primary", defaultLabel: "Add to cart" },
  fields: [
    { key: "label", label: "Button text", type: "string" },
    { key: "bg", label: "Background colour", type: "color" },
    { key: "text", label: "Text colour", type: "color" }
  ]
}], gs = (e) => [
  { key: "title", label: "Title", type: "string", default: e },
  { key: "subtitle", label: "Subtitle", type: "string" }
], fs = ["home", "shop", "category", "categories"], r1 = {
  type: "new-arrivals",
  label: "New arrivals",
  description: "A swipe row of the newest products.",
  supportedPages: fs,
  variants: [{ id: "v1", label: "Product row" }],
  commonFields: [...gs("New arrivals"), ...R]
}, l1 = {
  type: "offer-banner",
  label: "Offer banner",
  description: "A picture panel with a title, text and one button.",
  supportedPages: ["home", "shop", "category"],
  variants: [{ id: "v1", label: "Picture panel" }],
  commonFields: [
    { key: "image", label: "Picture", type: "image" },
    { key: "title", label: "Title", type: "string", default: "Special offer" },
    { key: "subtitle", label: "Text", type: "text" },
    { key: "ctaText", label: "Button text", type: "string", default: "Shop now" },
    { key: "ctaLink", label: "Button link", type: "string", default: "/shop" },
    { key: "overlayOpacity", label: "Dark wash (30–90)", type: "number", default: 50 },
    ...R
  ]
}, Qo = [...gs("All products"), { key: "viewAllLink", label: "View all link", type: "string", default: "/shop" }], i1 = {
  type: "product-grid",
  label: "Product grid",
  description: "Products as a card grid, a lead product beside smaller ones, or compact rows.",
  supportedPages: fs,
  variants: [
    { id: "v1", label: "Card grid", fields: Qo },
    { id: "v2", label: "Lead card and 6", fields: Qo },
    { id: "v3", label: "Compact rows", fields: Qo },
    { id: "v4", label: "Lead card and 4", fields: Qo },
    {
      id: "v6",
      label: "Compact rows with special offer",
      fields: [...Qo, { key: "offerEndsAt", label: "Offer ends at (ISO date)", type: "string" }]
    }
  ],
  commonFields: [
    { key: "categoryId", label: "Category (optional)", type: "category-select" },
    {
      key: "orderBy",
      label: "Order",
      type: "select",
      options: [
        { label: "Newest", value: "newest_first" },
        { label: "Biggest discount", value: "discount_desc" },
        { label: "Price: low to high", value: "price_asc" },
        { label: "Price: high to low", value: "price_desc" },
        { label: "Name: A–Z", value: "name_asc" }
      ],
      default: "newest_first"
    },
    { key: "limit", label: "Products", type: "number", default: 8 },
    ...qp,
    ...R
  ]
}, n1 = {
  type: "product-slider",
  label: "Product slider",
  description: "A swipe row of product cards, optionally with category tabs.",
  supportedPages: fs,
  variants: [
    {
      id: "v1",
      label: "Category tabs",
      fields: [{
        key: "tabs",
        label: "Tabs",
        type: "array",
        itemSchema: [
          { key: "label", label: "Tab label", type: "string" },
          { key: "categoryId", label: "Category", type: "category-select" }
        ]
      }]
    },
    { id: "v2", label: "Single row" }
  ],
  commonFields: [...gs("Featured products"), ...qp, ...R]
}, s1 = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer quotes as review cards with rating, photo, name and role.",
  supportedPages: Et,
  variants: [
    { id: "v1", label: "Review cards" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "What customers say" },
    {
      key: "items",
      label: "Reviews",
      type: "array",
      itemSchema: [
        { key: "avatar", label: "Photo", type: "image" },
        { key: "name", label: "Name", type: "string" },
        { key: "designation", label: "Role or city", type: "string" },
        { key: "review", label: "Review", type: "text" },
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 }
      ]
    },
    ...R
  ]
}, c1 = {
  type: "banner-carousel",
  label: "Banner carousel",
  description: "Full-width picture slides (offers, campaigns) with arrows, dots and autoplay.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [{ id: "v1", label: "Picture slides" }],
  commonFields: [
    { key: "title", label: "Name for screen readers", type: "string", default: "Offers" },
    {
      key: "slides",
      label: "Slides",
      type: "array",
      itemSchema: [
        { key: "image", label: "Picture", type: "image", required: !0, help: "About 1240 × 360 px." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional, about 780 × 400 px." },
        { key: "alt", label: "Picture description", type: "string", help: "What the banner says, for screen readers." },
        { key: "link", label: "Link", type: "string", placeholder: "/shop" }
      ],
      default: []
    },
    { key: "autoplay", label: "Play automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 5, dependency: { field: "autoplay", value: !0 } },
    ...R
  ]
}, d1 = {
  type: "category-bento",
  label: "Category tiles",
  description: "Category panels (each with four sub-categories) or wide tiles with the product count.",
  supportedPages: Et,
  variants: [
    { id: "v1", label: "Category panels" },
    { id: "v2", label: "Category tiles" }
  ],
  commonFields: [
    ...Za({ eyebrow: "Browse", title: "Shop by category" }),
    {
      key: "tiles",
      label: "Tiles",
      type: "array",
      help: "Empty = the store’s categories.",
      itemSchema: [
        { key: "categoryId", label: "Category", type: "category-select", help: "Sets the link, name and picture unless filled below." },
        { key: "title", label: "Name", type: "localized-string" },
        { key: "tagline", label: "Tagline", type: "localized-string" },
        { key: "image", label: "Picture", type: "image" },
        { key: "link", label: "Link", type: "string", placeholder: "/category/…" }
      ],
      default: []
    },
    { key: "limit", label: "Categories shown (automatic tiles)", type: "number", default: 8 },
    ...R
  ]
}, p1 = {
  type: "combo-spotlight",
  label: "Product spotlight",
  description: "One product or bundle on a large dark card with its price, saving and Add to cart.",
  supportedPages: Et,
  variants: [{ id: "v1", label: "Dark card" }],
  commonFields: [
    ...Za({ eyebrow: "Bundle & save", title: "Value pack of the week" }),
    { key: "productId", label: "Product", type: "product-select", help: "Hidden until a product is picked." },
    { key: "description", label: "Text", type: "localized-text", default: "" },
    { key: "mrpLabel", label: "Regular price label", type: "localized-string", default: "Regular price" },
    { key: "savingLabel", label: "Saving label", type: "localized-string", default: "You save" },
    { key: "detailsLabel", label: "Details button text", type: "localized-string", default: "View details" },
    ...R
  ]
}, u1 = {
  type: "corporate-band",
  label: "Bulk order band",
  description: "Text and one button, e.g. for corporate, event or wholesale orders.",
  supportedPages: Et,
  variants: [{ id: "v1", label: "Text and button" }],
  commonFields: [
    ...Za({ eyebrow: "For businesses", title: "Bulk and corporate orders" }).filter((e) => e.key !== "subtitle"),
    { key: "text", label: "Text", type: "localized-text", default: "Ordering for an office, an event or gifts? Get volume pricing and scheduled delivery." },
    { key: "cta.label", label: "Button text", type: "localized-string", default: "Contact us" },
    { key: "cta.url", label: "Button link", type: "string", default: "/contact" },
    ...R
  ]
}, y1 = {
  type: "hero",
  label: "Hero",
  description: "Headline panel with buttons, trust chips and product cards; extra slides rotate after it.",
  supportedPages: ["home", "shop", "category", "categories", "cart", "checkout", "order-success"],
  variants: [{ id: "v1", label: "Dark band with a picture on an amber circle" }],
  commonFields: [
    { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "Fresh every day" },
    { key: "headline", label: "Headline", type: "localized-string", default: "Everyday essentials, delivered to your door" },
    { key: "subtext", label: "Text", type: "localized-text", default: "Hand-picked products at fair prices. Order in minutes and pay when it arrives." },
    { key: "image", label: "Picture", type: "image", help: "Shown beside the text on large screens. Empty = the first product card’s photo." },
    { key: "imageAlt", label: "Picture description", type: "string", help: "For screen readers. Leave empty if the picture is decorative." },
    { key: "primaryCta.label", label: "Main button text", type: "localized-string", default: "Shop now" },
    { key: "primaryCta.url", label: "Main button link", type: "string", default: "/shop" },
    { key: "secondaryCta.label", label: "Second button text", type: "localized-string", default: "Today’s deals" },
    { key: "secondaryCta.url", label: "Second button link", type: "string", default: "/shop?order_by=discount_desc" },
    { key: "showTrustChips", label: "Show trust chips", type: "boolean", default: !0 },
    {
      key: "trustChips",
      label: "Trust chips",
      type: "array",
      dependency: { field: "showTrustChips", value: !0 },
      itemSchema: [
        { key: "icon", label: "Icon", type: "icon", default: "truck", options: Xp },
        { key: "text", label: "Text", type: "localized-string" }
      ],
      default: [
        { icon: "shipping", text: "Fast delivery" },
        { icon: "secure", text: "Cash on delivery" },
        { icon: "refund", text: "Easy returns" }
      ]
    },
    { key: "showCards", label: "Show product cards", type: "boolean", default: !0 },
    {
      key: "cards",
      label: "Product cards",
      type: "array",
      help: "Up to two. Empty = the two biggest current deals.",
      dependency: { field: "showCards", value: !0 },
      itemSchema: [
        { key: "productId", label: "Product", type: "product-select" },
        { key: "label", label: "Label", type: "localized-string", placeholder: "Bestseller" }
      ],
      default: []
    },
    {
      key: "slides",
      label: "More slides",
      type: "array",
      help: "Shown after the headline slide. Pick a product, or write your own text and add a picture.",
      itemSchema: [
        { key: "productId", label: "Product", type: "product-select" },
        { key: "badge", label: "Badge", type: "localized-string", placeholder: "New" },
        { key: "title", label: "Headline", type: "localized-string", help: "Empty = the product name." },
        { key: "subtitle", label: "Text", type: "localized-text" },
        { key: "image", label: "Picture", type: "image", help: "Empty = the product photo." },
        { key: "ctaText", label: "Button text", type: "localized-string", placeholder: "View product" },
        { key: "ctaLink", label: "Button link", type: "string", help: "Empty = the product page." }
      ],
      default: []
    },
    { key: "autoplay", label: "Play slides automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 6, help: "0 or empty = 6 seconds.", dependency: { field: "autoplay", value: !0 } },
    ...R
  ]
}, h1 = {
  type: "product-rail",
  label: "Product rail",
  description: "A grid or swipe row of product cards from new arrivals, deals, a category or your own pick.",
  supportedPages: Et,
  variants: [{ id: "v1", label: "Product cards" }],
  commonFields: [
    ...Za({ eyebrow: "Just in", title: "New arrivals", subtitle: "The latest additions to the store." }),
    { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 8 } },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [
        { label: "Grid (2 columns on phones, 4 on desktop)", value: "grid" },
        { label: "Swipe row", value: "rail" }
      ],
      default: "grid"
    },
    { key: "showViewAll", label: "Show “View all”", type: "boolean", default: !0 },
    { key: "viewAllLabel", label: "“View all” text", type: "string", default: "View all", dependency: { field: "showViewAll", value: !0 } },
    ...R
  ]
}, b1 = {
  type: "promises",
  label: "Promises strip",
  description: "Short store promises (delivery, payment, returns, support) with icons.",
  supportedPages: Et,
  variants: [{ id: "v1", label: "Tint tiles" }],
  commonFields: [
    ...Za(),
    {
      key: "items",
      label: "Promises",
      type: "array",
      itemSchema: jp,
      default: [
        { icon: "shipping", title: "Fast delivery", body: "Quick delivery across the city." },
        { icon: "secure", title: "Pay on delivery", body: "Pay in cash when your order arrives." },
        { icon: "refund", title: "Easy returns", body: "Not right? We will make it right." },
        { icon: "support", title: "Here to help", body: "Call or message us any day." }
      ]
    },
    ...R
  ]
}, m1 = {
  type: "reviews",
  label: "Customer reviews",
  description: "A swipe row of review cards: rating, quote, name and the product.",
  supportedPages: Et,
  variants: [{ id: "v1", label: "Review cards" }],
  commonFields: [
    ...Za({ eyebrow: "Reviews", title: "What customers say" }),
    {
      key: "items",
      label: "Reviews",
      type: "array",
      help: "Real reviews from your customers, with their permission.",
      itemSchema: [
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "body", label: "Review", type: "localized-text" },
        { key: "name", label: "Customer name", type: "string" },
        { key: "productId", label: "Product", type: "product-select" }
      ],
      default: []
    },
    { key: "limit", label: "Most reviews shown", type: "number", default: 6 },
    { key: "minRating", label: "Lowest rating shown (store reviews)", type: "number", default: 4 },
    ...R
  ]
}, g1 = {
  type: "story",
  label: "Story band",
  description: "Why shop with you: a picture beside short benefit points.",
  supportedPages: Et,
  variants: [{ id: "v1", label: "Picture and points" }],
  commonFields: [
    ...Za({ eyebrow: "Our promise", title: "Why shop with us", subtitle: "Good products, honest prices and service you can count on." }),
    { key: "image", label: "Picture", type: "image" },
    {
      key: "points",
      label: "Points",
      type: "array",
      itemSchema: jp,
      default: [
        { icon: "secure", title: "Quality checked", body: "Every product is checked before it leaves our store." },
        { icon: "shipping", title: "Delivered fresh", body: "Packed with care and delivered quickly to your door." },
        { icon: "support", title: "Real support", body: "Questions about an order? Call or message us any day." }
      ]
    },
    { key: "ctaLabel", label: "Button text", type: "localized-string", default: "" },
    { key: "ctaLink", label: "Button link", type: "string", default: "" },
    ...R
  ]
}, f1 = {
  hero: y1,
  "banner-carousel": c1,
  "category-bento": d1,
  "product-rail": h1,
  story: g1,
  "combo-spotlight": p1,
  reviews: m1,
  promises: b1,
  "corporate-band": u1,
  "announcement-bar": ZT,
  blog: KT,
  brands: QT,
  cta: e1,
  "flash-sale": t1,
  "instagram-feed": a1,
  "lookbook-banner": o1,
  "new-arrivals": r1,
  "offer-banner": l1,
  "product-grid": i1,
  "product-slider": n1,
  testimonials: s1
}, v1 = {
  type: "account",
  label: "Account",
  description: "Signed-in shopper area: overview, orders, profile and saved addresses.",
  supportedPages: ["account", "orders", "profile", "addresses"],
  variants: [{ id: "v1", label: "Side navigation" }],
  commonFields: [
    { key: "title", label: "Overview title", type: "string", default: "My account" },
    { key: "tabOverviewLabel", label: "Overview label", type: "string", default: "Overview" },
    { key: "tabOrdersLabel", label: "Orders label", type: "string", default: "Orders" },
    { key: "tabDetailsLabel", label: "Profile label", type: "string", default: "Profile" },
    { key: "tabAddressesLabel", label: "Addresses label", type: "string", default: "Addresses" },
    { key: "signOutLabel", label: "Sign out label", type: "string", default: "Sign out" }
  ]
}, k1 = {
  type: "cart",
  label: "Cart",
  description: "Cart lines with quantity steppers, delivery area choice, free-delivery progress and checkout.",
  supportedPages: ["cart"],
  variants: [{ id: "v1", label: "Lines + totals box" }],
  commonFields: [
    { key: "pageTitle", label: "Page title (for screen readers)", type: "string", default: "Shopping cart" },
    { key: "emptyTitle", label: "Empty cart title", type: "string", default: "Your cart is currently empty." },
    { key: "emptyMessage", label: "Empty cart message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Totals title", type: "string", default: "Cart totals" },
    { key: "subtotalLabel", label: "Subtotal label", type: "string", default: "Subtotal" },
    { key: "shippingLabel", label: "Delivery label", type: "string", default: "Delivery" },
    { key: "shippingCalculatedText", label: "Text when delivery areas are unavailable", type: "string", default: "Delivery charge is added at checkout." },
    { key: "totalLabel", label: "Total label", type: "string", default: "Total" },
    { key: "checkoutButtonText", label: "Checkout button text", type: "string", default: "Proceed to checkout" },
    { key: "checkoutLink", label: "Checkout link", type: "string", default: "/checkout" }
  ]
}, w1 = {
  type: "checkout",
  label: "Checkout",
  description: "Billing details, delivery area, payment and order summary with a place-order button.",
  supportedPages: ["checkout"],
  variants: [{ id: "v1", label: "Two columns" }],
  commonFields: [
    { key: "pageTitle", label: "Billing title", type: "string", default: "Billing details" },
    { key: "emptyTitle", label: "Empty cart title", type: "string", default: "Your cart is empty." },
    { key: "emptyMessage", label: "Empty cart message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Return to shop" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order summary title", type: "string", default: "Your order" },
    { key: "subtotalLabel", label: "Subtotal label", type: "string", default: "Subtotal" },
    { key: "deliveryLabel", label: "Delivery label", type: "string", default: "Delivery" },
    { key: "totalLabel", label: "Total label", type: "string", default: "Total" },
    { key: "codLabel", label: "Cash on delivery label", type: "string", default: "Cash on delivery" },
    { key: "codDescription", label: "How to pay (cash on delivery)", type: "localized-text", default: "Pay with cash when your order arrives." },
    { key: "privacyNote", label: "Privacy note", type: "localized-text", help: "Shown above the place-order button. Leave empty for the default note linking to the privacy policy." },
    { key: "placeOrderText", label: "Place order button text", type: "string", default: "Place order" },
    { key: "placingOrderText", label: "Placing order text", type: "string", default: "Placing order…" }
  ]
}, S1 = {
  type: "contact",
  label: "Contact",
  description: "Phone, WhatsApp, email and address cards. Empty fields use Store info.",
  supportedPages: ["contact"],
  variants: [{ id: "v1", label: "Contact cards" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Contact us" },
    { key: "description", label: "Intro text", type: "localized-text", default: "Questions about an order or a product? We are happy to help." },
    { key: "phone", label: "Phone (empty: Store info hotline)", type: "string" },
    { key: "email", label: "Email (empty: Store info email)", type: "string" },
    { key: "address", label: "Address (empty: Store info addresses)", type: "text" },
    { key: "hoursText", label: "Opening hours", type: "localized-text" }
  ]
}, x1 = {
  type: "content",
  label: "Content page",
  description: "Policies, about, FAQ and other text pages, with an optional question-and-answer list.",
  supportedPages: ["privacy-policy", "terms-of-service", "shipping-policy", "return-policy", "track-order"],
  variants: [{ id: "v1", label: "Readable column" }],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "subtitle", label: "Subtitle", type: "localized-text" },
    { key: "content", label: "Text", type: "rich-text" },
    {
      key: "faqs",
      label: "Questions and answers",
      type: "array",
      help: "Shown as an accordion under the text (also published as FAQ structured data).",
      itemSchema: [
        { key: "question", label: "Question", type: "string" },
        { key: "answer", label: "Answer", type: "text" }
      ]
    },
    { key: "updatedText", label: "Last updated note", type: "string", placeholder: "Last updated 1 January 2026" }
  ]
}, T1 = {
  type: "coupon",
  label: "Coupons",
  description: "Coupon codes with discount, title, description, expiry and a copy button.",
  supportedPages: ["coupon"],
  variants: [{ id: "v1", label: "Code cards" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Coupons" },
    { key: "subtitle", label: "Subtitle", type: "localized-text", default: "Use these codes when you order." },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Code", type: "string" },
        { key: "discount", label: "Discount (e.g. 10% off)", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Conditions", type: "text" },
        { key: "expiryDate", label: "Valid until", type: "string" }
      ]
    },
    { key: "emptyText", label: "Text when there are no coupons", type: "string", default: "No coupons right now. Check back soon." }
  ]
}, C1 = {
  type: "order-success",
  label: "Order complete",
  description: "Thank-you message with the order number, date, total, payment and order details.",
  supportedPages: ["order-success"],
  variants: [{ id: "v1", label: "Thank-you card" }],
  commonFields: [
    { key: "title", label: "Thank-you title", type: "localized-string", default: "Thank you. Your order has been received." },
    { key: "message", label: "Thank-you message", type: "localized-text", default: "We will call you to confirm your order before delivery." },
    { key: "errorTitle", label: "Title when the order cannot be loaded", type: "string", default: "Your order was placed." },
    { key: "errorMessage", label: "Message when the order cannot be loaded", type: "string", default: "We could not load the order details on this device, but your order was received." },
    { key: "viewOrderText", label: "View order button text (signed-in shoppers)", type: "string", default: "View order" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" }
  ]
}, P1 = {
  type: "signin",
  label: "Sign in",
  description: "Phone number and one-time code card; new shoppers add their name.",
  supportedPages: ["signin", "forgot-password", "reset-password"],
  variants: [{ id: "v1", label: "Card" }],
  commonFields: [
    { key: "title", label: "Title", type: "localized-string", default: "Sign in" },
    { key: "intro", label: "Intro text", type: "localized-text", default: "Use your mobile number. We send you a code by SMS — no password needed." },
    { key: "redirectUrl", label: "Go to after signing in", type: "string", default: "/account" }
  ]
}, A1 = {
  type: "signup",
  label: "Sign up",
  description: "Phone number and one-time code card; new shoppers add their name.",
  supportedPages: ["signup"],
  variants: [{ id: "v1", label: "Card" }],
  commonFields: [
    { key: "title", label: "Title", type: "localized-string", default: "Create your account" },
    { key: "intro", label: "Intro text", type: "localized-text", default: "Use your mobile number. We send you a code by SMS — no password needed." },
    { key: "redirectUrl", label: "Go to after signing in", type: "string", default: "/account" }
  ]
}, L1 = {
  cart: k1,
  checkout: w1,
  "order-success": C1,
  coupon: T1,
  account: v1,
  signin: P1,
  signup: A1,
  contact: S1,
  content: x1
}, M1 = ht({
  ...yt,
  componentSchemas: {
    ...yt.componentSchemas,
    ...f1,
    ...UT,
    ...L1
  },
  headerSchema: qT,
  footerSchema: YT
}, VT), N1 = {
  banner: { hide: ["title", "description", "ctaText", "ctaLink", "backgroundImage"], keep: [], add: Oa.variants, variantLabels: { v1: "Selling points (icon, title, line)", v2: "Two picture banners" } },
  category: { hide: ["cardVariant", "autoplay", "autoplayDelay"] },
  "featured-category": { hide: ["productCardVariant", "noSelectionText", "noProductsText", "buttons.orderNow"] },
  "floating-buttons": {
    hide: ["messenger", "messengerTitle"],
    labels: { callUsTitle: { label: "Call button text", help: "The green pill; it opens the hotline and WhatsApp." }, whatsappTitle: { label: "WhatsApp button text" } }
  },
  footer: { hide: ["logo"], labels: { contactAddress: { label: "Shop address", help: "Empty = the first address in Store info." } } },
  "product-detail": { hide: ["loadingText", "notFoundCode", "notFoundText"] },
  "recent-products": { hide: ["productCardVariant", "buttons"] },
  "shop-grid": { hide: ["sidebarVariant", "productCardVariant", "paginationVariant", "initialPriceRange", "filtersButtonLabel", "showingLabel", "productsSuffix", "sortNewestLabel", "sortOldestLabel", "sortPriceAscLabel", "sortPriceDescLabel", "sortNameAscLabel", "sortNameDescLabel", "activeFiltersLabel", "backToAllText", "filterDrawerTitle", "currentSearchLabel", "clearSearchLabel", "applyFiltersLabel", "buttons.orderNow"] },
  "similar-products": { hide: ["productCardVariant", "buttons.orderNow"] },
  features: { add: [{ id: "v2", label: "Large tiles" }, { id: "v3", label: "Icons on one band" }], variantLabels: { v1: "Tiles" } },
  hero: { labels: { eyebrow: { label: "Label on the first slide" }, headline: { label: "Title (first slide)" }, subtext: { label: "Text (first slide)" }, image: { label: "Picture (first slide)", help: "Right side of the slide. Empty = the biggest current deal’s photo." } } },
  header: { hide: ["topbar[].dismissible"] },
  "mobile-bottom-nav": { hide: ["items[].isPrimary"] },
  // Theme tab: button settings no part of this theme reads (colours drive every primary button via the CTA).
  buttons: { hide: ["appearance.buttons.primary[].radius", "appearance.buttons.primary[].height", "appearance.buttons.primary[].paddingX", "appearance.buttons.primary[].label", "appearance.buttons.outline[].radius", "appearance.buttons.outline[].height", "appearance.buttons.outline[].paddingX", "appearance.buttons.outline[].label"] },
  // Delivery time is shown on product cards only by Prottoho.
  "store-info": { hide: ["deliveryEta"] }
}, E1 = {
  type: "compare",
  label: "Compare",
  description: "Up to four saved products side by side (photo, price, brand, warranty, specifications), or an empty state.",
  supportedPages: ["compare"],
  variants: [{ id: "v1", label: "Side by side" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Compare products" },
    { key: "emptyTitle", label: "Empty title", type: "string" },
    { key: "emptyText", label: "Empty message", type: "string" }
  ]
}, D1 = {
  ...Pt,
  commonFields: [
    ...Pt.commonFields,
    { key: "howToOrderTitle", label: '"How to order" tab title', type: "string", default: "How to order" },
    { key: "howToOrder", label: "How to order", type: "localized-text", help: "Steps shown in their own tab; the tab is hidden while this is empty." },
    { key: "showDeliveryAreas", label: "Show delivery areas and charges", type: "boolean", default: !0 }
  ]
}, F1 = {
  ...At,
  commonFields: [
    ...At.commonFields,
    { key: "pageSizes", label: "Extra page sizes", type: "string", placeholder: "24, 48", help: 'Offered next to "Products per page"; leave empty for one size.' }
  ]
}, I1 = {
  type: "wishlist",
  label: "Wishlist",
  description: "The products a shopper saved, or an empty state with a link back to the shop.",
  supportedPages: ["wishlist"],
  variants: [{ id: "v1", label: "Saved products" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Wishlist" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    { key: "emptyTitle", label: "Empty title", type: "string", default: "Your wishlist is empty" },
    { key: "emptyText", label: "Empty message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" }
  ]
}, O1 = {
  "shop-grid": F1,
  "product-detail": D1,
  wishlist: I1,
  compare: E1
}, R1 = ["facebook", "instagram", "youtube", "tiktok", "linkedin", "x"].map((e) => ({ label: e === "x" ? "X" : e[0].toUpperCase() + e.slice(1), value: e })), B1 = [
  { key: "newsletterTitle", label: "Newsletter title", type: "localized-string", default: "Sign up to our newsletter" },
  { key: "newsletterText", label: "Newsletter offer line", type: "localized-string", default: "…and get offers before anyone else" },
  {
    key: "newsletterAction",
    label: "Sign-up form link",
    type: "string",
    placeholder: "https://…",
    help: 'The email field posts to this form (e.g. your mailing-list sign-up form). Empty = a "Get offers on WhatsApp" button.'
  }
], z1 = {
  ...Ct,
  label: "Footer",
  description: "Newsletter band, brand column with hotline and shop address, link columns and payment badges.",
  variants: [{ id: "v1", label: "Light grey with a blue newsletter band" }],
  commonFields: [
    ...B1,
    ...Ct.commonFields.filter((e) => e.key !== "title").map((e) => {
      var t;
      return e.key !== "socialLinks" ? e : { ...e, itemSchema: (t = e.itemSchema) == null ? void 0 : t.map((a) => a.key === "platform" ? { ...a, options: R1 } : a) };
    })
  ]
}, V1 = [
  "home",
  "shop",
  "product",
  "category",
  "categories",
  "search",
  "cart",
  "checkout",
  "contact",
  "signin",
  "signup",
  "account",
  "wishlist",
  "track-order",
  "order-success",
  "order-detail",
  "blog",
  "privacy-policy",
  "terms-of-service",
  "shipping-policy",
  "return-policy"
], W1 = [
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link URL", type: "string" },
  {
    key: "type",
    label: "Type",
    type: "select",
    options: [
      { label: "Link", value: "link" },
      { label: "Shop panel (category cards)", value: "categories" }
    ],
    default: "link"
  },
  { key: "badge", label: "Badge", type: "string", placeholder: "New", help: "Small label next to the item." }
], $1 = {
  type: "header",
  label: "Header",
  description: "Announcement bar, logo, search, shopper icons and the main menu.",
  supportedPages: [...V1],
  variants: [{ id: "v1", label: "Two-tier" }],
  commonFields: [
    { key: "logo.src", label: "Logo", type: "image" },
    { key: "logo.alt", label: "Logo alt text", type: "string" },
    {
      key: "topbar",
      label: "Announcement bar",
      type: "object",
      fields: [
        { key: "active", label: "Show announcement bar", type: "boolean", default: !0 },
        {
          key: "messages",
          label: "Messages",
          type: "array",
          help: "More than one message rotates every few seconds.",
          itemSchema: [
            { key: "text", label: "Text", type: "localized-string" },
            { key: "link", label: "Link", type: "string" }
          ]
        },
        { key: "dismissible", label: "Shoppers can close it", type: "boolean", default: !1 }
      ]
    },
    { key: "searchPlaceholder", label: "Search placeholder", type: "string", placeholder: "Search products…" },
    {
      key: "actions",
      label: "Icons",
      type: "object",
      fields: [
        { key: "showSearch", label: "Search", type: "boolean", default: !0 },
        { key: "showAccount", label: "Account", type: "boolean", default: !0 },
        { key: "showWishlist", label: "Wishlist", type: "boolean", default: !0 },
        { key: "showCart", label: "Cart", type: "boolean", default: !0 },
        {
          key: "cartAction",
          label: "Cart opens",
          type: "select",
          options: [
            { label: "Cart drawer", value: "sidebar" },
            { label: "Cart page", value: "page" }
          ],
          default: "sidebar"
        }
      ]
    },
    { key: "menu", label: "Main menu", type: "array", itemSchema: W1 }
  ]
}, _1 = {
  type: "announcement-bar",
  label: "Announcement bar",
  description: "A slim rotating bar of short messages, with an optional coupon code after each.",
  supportedPages: ["home", "shop", "product", "category", "categories", "cart", "checkout", "contact", "wishlist"],
  variants: [{ id: "v1", label: "Rotating bar" }],
  commonFields: [{
    key: "items",
    label: "Messages",
    type: "array",
    itemSchema: [
      { key: "text", label: "Message", type: "string" },
      { key: "code", label: "Coupon code (optional)", type: "string" }
    ],
    default: [{ text: "Free delivery on orders over 1000" }]
  }]
}, Zp = ["truck", "cash", "phone", "shield", "star", "heart", "package", "check", "store", "map-pin", "mail", "leaf", "sparkle", "clock", "headset", "zap", "award", "refresh"].map((e) => ({ label: e.replace("-", " "), value: e })), Ja = (e = {}) => [
  { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: e.eyebrow ?? "", help: "Small line above the title." },
  { key: "title", label: "Title", type: "localized-string", default: e.title ?? "" },
  { key: "subtitle", label: "Subtitle", type: "localized-text", default: e.subtitle ?? "" }
], Jp = [
  { key: "icon", label: "Icon", type: "icon", default: "shield", options: Zp },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "body", label: "Text", type: "localized-text" }
], Dt = ["home", "shop", "category", "categories", "product", "cart", "blog"], H1 = [
  { key: "title", label: "Title", type: "string" },
  { key: "image", label: "Cover (16:9)", type: "image" },
  { key: "excerpt", label: "Excerpt", type: "text" },
  { key: "slug", label: "Slug", type: "string", help: "Opens the post at /blog/<slug>." },
  { key: "date", label: "Date", type: "string", placeholder: "12 Sep 2026" },
  { key: "category", label: "Topic", type: "string" }
], yd = [
  { key: "title", label: "Title", type: "string", default: "From the blog" },
  { key: "posts", label: "Posts", type: "array", itemSchema: H1 },
  { key: "viewAllLink", label: "View all link", type: "string", default: "/blog" },
  { key: "showViewAll", label: 'Show "View all"', type: "boolean", default: !0 }
], U1 = {
  type: "blog",
  label: "Blog",
  description: "Posts entered here, as cards with cover, topic, excerpt and date, or as a compact list.",
  supportedPages: Dt,
  variants: [
    { id: "v1", label: "Cards", fields: yd },
    { id: "v2", label: "Compact list", fields: yd }
  ],
  commonFields: [
    { key: "source", label: "Posts to show", type: "select", options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." },
    ...R
  ]
}, G1 = {
  type: "brands",
  label: "Brands",
  description: "Brand logos as a grid of tiles or a scrolling ticker; leave empty to show the store's brands.",
  supportedPages: ["home", "shop", "categories"],
  variants: [{ id: "v1", label: "Logos" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Brands we carry" },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [{ label: "Grid", value: "grid" }, { label: "Ticker", value: "ticker" }],
      default: "grid"
    },
    {
      key: "items",
      label: "Brands",
      type: "array",
      itemSchema: [
        { key: "logo", label: "Logo", type: "image" },
        { key: "name", label: "Name", type: "string" },
        { key: "link", label: "Link", type: "string" }
      ]
    },
    ...R
  ]
}, Y1 = {
  type: "cta",
  label: "Newsletter",
  description: "A tint card with a title and text beside an email form.",
  supportedPages: Dt,
  variants: [{ id: "v1", label: "Newsletter band" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Subscribe to our newsletter" },
    { key: "subtitle", label: "Text", type: "string" },
    { key: "placeholder", label: "Email placeholder", type: "string", default: "Email address" },
    { key: "buttonText", label: "Button text", type: "string", default: "Subscribe" },
    { key: "formAction", label: "Form URL", type: "string", help: "An external newsletter form; without it the band shows no form." },
    ...R
  ]
}, X1 = {
  type: "flash-sale",
  label: "Flash sale",
  description: "A countdown to the end date over a row of the most discounted products. Hidden after it ends.",
  supportedPages: ["home"],
  variants: [{ id: "v1", label: "Countdown row" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Flash sale" },
    { key: "endDate", label: "Ends at (ISO date)", type: "string", placeholder: "2026-12-31T23:59:59" },
    ...R
  ]
}, j1 = {
  type: "instagram-feed",
  label: "Social feed",
  description: "Photo tiles from your social account, each linking to its post.",
  supportedPages: Dt,
  variants: [
    { id: "v1", label: "Grid, 5 columns" },
    { id: "v2", label: "Grid, 6 columns" },
    { id: "v3", label: "Grid, 4 columns" },
    { id: "v4", label: "Masonry, 4 columns" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Follow us" },
    { key: "handle", label: "Handle", type: "string", placeholder: "@yourstore" },
    {
      key: "items",
      label: "Photos",
      type: "array",
      itemSchema: [
        { key: "image", label: "Photo", type: "image" },
        { key: "link", label: "Post link", type: "string" }
      ]
    },
    ...R
  ]
}, hd = [
  { key: "image", label: "Picture", type: "image" },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Text", type: "text" },
  { key: "ctaText", label: "Button text", type: "string" },
  { key: "ctaLink", label: "Button link", type: "string", default: "/shop" }
], q1 = {
  type: "lookbook-banner",
  label: "Editorial banner",
  description: "A picture with a title, text and one button.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "Picture beside text",
      fields: [
        ...hd,
        {
          key: "imagePosition",
          label: "Picture side",
          type: "select",
          options: [{ label: "Left", value: "left" }, { label: "Right", value: "right" }],
          default: "left"
        }
      ]
    },
    {
      id: "v2",
      label: "Text over picture",
      fields: [...hd, { key: "overlayOpacity", label: "Dark wash (30–90)", type: "number", default: 40 }]
    }
  ],
  commonFields: [...R]
}, Kp = [{
  key: "buttons.addToCart",
  label: "Add to cart button",
  type: "object",
  preview: { type: "button", variant: "primary", defaultLabel: "Add to cart" },
  fields: [
    { key: "label", label: "Button text", type: "string" },
    { key: "bg", label: "Background colour", type: "color" },
    { key: "text", label: "Text colour", type: "color" }
  ]
}], vs = (e) => [
  { key: "title", label: "Title", type: "string", default: e },
  { key: "subtitle", label: "Subtitle", type: "string" }
], ks = ["home", "shop", "category", "categories"], Z1 = {
  type: "new-arrivals",
  label: "New arrivals",
  description: "A swipe row of the newest products.",
  supportedPages: ks,
  variants: [{ id: "v1", label: "Product row" }],
  commonFields: [...vs("New arrivals"), ...R]
}, J1 = {
  type: "offer-banner",
  label: "Offer banner",
  description: "A picture panel with a title, text and one button.",
  supportedPages: ["home", "shop", "category"],
  variants: [{ id: "v1", label: "Picture panel" }],
  commonFields: [
    { key: "image", label: "Picture", type: "image" },
    { key: "title", label: "Title", type: "string", default: "Special offer" },
    { key: "subtitle", label: "Text", type: "text" },
    { key: "ctaText", label: "Button text", type: "string", default: "Shop now" },
    { key: "ctaLink", label: "Button link", type: "string", default: "/shop" },
    { key: "overlayOpacity", label: "Dark wash (30–90)", type: "number", default: 50 },
    ...R
  ]
}, er = [...vs("All products"), { key: "viewAllLink", label: "View all link", type: "string", default: "/shop" }], K1 = {
  type: "product-grid",
  label: "Product grid",
  description: "Products as a card grid, a lead product beside smaller ones, or compact rows.",
  supportedPages: ks,
  variants: [
    { id: "v1", label: "Card grid", fields: er },
    { id: "v2", label: "Lead card and 6", fields: er },
    { id: "v3", label: "Compact rows", fields: er },
    { id: "v4", label: "Lead card and 4", fields: er },
    {
      id: "v6",
      label: "Compact rows with special offer",
      fields: [...er, { key: "offerEndsAt", label: "Offer ends at (ISO date)", type: "string" }]
    }
  ],
  commonFields: [
    { key: "categoryId", label: "Category (optional)", type: "category-select" },
    {
      key: "orderBy",
      label: "Order",
      type: "select",
      options: [
        { label: "Newest", value: "newest_first" },
        { label: "Biggest discount", value: "discount_desc" },
        { label: "Price: low to high", value: "price_asc" },
        { label: "Price: high to low", value: "price_desc" },
        { label: "Name: A–Z", value: "name_asc" }
      ],
      default: "newest_first"
    },
    { key: "limit", label: "Products", type: "number", default: 8 },
    ...Kp,
    ...R
  ]
}, Q1 = {
  type: "product-slider",
  label: "Product slider",
  description: "A swipe row of product cards, optionally with category tabs.",
  supportedPages: ks,
  variants: [
    {
      id: "v1",
      label: "Category tabs",
      fields: [{
        key: "tabs",
        label: "Tabs",
        type: "array",
        itemSchema: [
          { key: "label", label: "Tab label", type: "string" },
          { key: "categoryId", label: "Category", type: "category-select" }
        ]
      }]
    },
    { id: "v2", label: "Single row" }
  ],
  commonFields: [...vs("Featured products"), ...Kp, ...R]
}, e0 = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer quotes as review cards with rating, photo, name and role.",
  supportedPages: Dt,
  variants: [
    { id: "v1", label: "Review cards" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "What customers say" },
    {
      key: "items",
      label: "Reviews",
      type: "array",
      itemSchema: [
        { key: "avatar", label: "Photo", type: "image" },
        { key: "name", label: "Name", type: "string" },
        { key: "designation", label: "Role or city", type: "string" },
        { key: "review", label: "Review", type: "text" },
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 }
      ]
    },
    ...R
  ]
}, t0 = {
  type: "banner-carousel",
  label: "Banner carousel",
  description: "Full-width picture slides (offers, campaigns) with arrows, dots and autoplay.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [{ id: "v1", label: "Picture slides" }],
  commonFields: [
    { key: "title", label: "Name for screen readers", type: "string", default: "Offers" },
    {
      key: "slides",
      label: "Slides",
      type: "array",
      itemSchema: [
        { key: "image", label: "Picture", type: "image", required: !0, help: "About 1240 × 360 px." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional, about 780 × 400 px." },
        { key: "alt", label: "Picture description", type: "string", help: "What the banner says, for screen readers." },
        { key: "link", label: "Link", type: "string", placeholder: "/shop" }
      ],
      default: []
    },
    { key: "autoplay", label: "Play automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 5, dependency: { field: "autoplay", value: !0 } },
    ...R
  ]
}, a0 = {
  type: "category-bento",
  label: "Category tiles",
  description: "Category tiles with the product shot beside the name (2 / 4 per row), or picture tiles (3 / 6 per row).",
  supportedPages: Dt,
  variants: [
    { id: "v1", label: "Picture beside the name (2 / 4 per row)" },
    { id: "v2", label: "Picture above the name (3 / 6 per row)" }
  ],
  commonFields: [
    ...Ja({ title: "" }),
    {
      key: "tiles",
      label: "Tiles",
      type: "array",
      help: "Empty = the store’s categories. Leave the title empty for a grid without a heading.",
      itemSchema: [
        { key: "categoryId", label: "Category", type: "category-select", help: "Sets the link, name and picture unless filled below." },
        { key: "title", label: "Name", type: "localized-string" },
        { key: "tagline", label: "Tagline", type: "localized-string", help: "Shown when the category has no product count." },
        { key: "image", label: "Picture", type: "image" },
        { key: "link", label: "Link", type: "string", placeholder: "/category/…" }
      ],
      default: []
    },
    { key: "limit", label: "Categories shown (automatic tiles)", type: "number", default: 24 },
    ...R
  ]
}, o0 = {
  type: "combo-spotlight",
  label: "Product spotlight",
  description: "One product or bundle on a large dark card with its price, saving and Add to cart.",
  supportedPages: Dt,
  variants: [{ id: "v1", label: "Dark card" }],
  commonFields: [
    ...Ja({ eyebrow: "Bundle & save", title: "Value pack of the week" }),
    { key: "productId", label: "Product", type: "product-select", help: "Hidden until a product is picked." },
    { key: "description", label: "Text", type: "localized-text", default: "" },
    { key: "mrpLabel", label: "Regular price label", type: "localized-string", default: "Regular price" },
    { key: "savingLabel", label: "Saving label", type: "localized-string", default: "You save" },
    { key: "detailsLabel", label: "Details button text", type: "localized-string", default: "View details" },
    ...R
  ]
}, r0 = {
  type: "corporate-band",
  label: "Bulk order band",
  description: "Text and one button, e.g. for corporate, event or wholesale orders.",
  supportedPages: Dt,
  variants: [{ id: "v1", label: "Text and button" }],
  commonFields: [
    ...Ja({ eyebrow: "For businesses", title: "Bulk and corporate orders" }).filter((e) => e.key !== "subtitle"),
    { key: "text", label: "Text", type: "localized-text", default: "Ordering for an office, an event or gifts? Get volume pricing and scheduled delivery." },
    { key: "cta.label", label: "Button text", type: "localized-string", default: "Contact us" },
    { key: "cta.url", label: "Button link", type: "string", default: "/contact" },
    ...R
  ]
}, l0 = {
  type: "hero",
  label: "Hero",
  description: "Slider with side banners and a trust strip (delivery, warranty, cash on delivery, hotline).",
  supportedPages: ["home", "shop", "category", "categories", "cart", "checkout", "order-success"],
  variants: [{ id: "v1", label: "Slider with two side banners" }],
  commonFields: [
    { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "New this week" },
    { key: "headline", label: "Headline", type: "localized-string", default: "Big-screen cinema at home" },
    { key: "subtext", label: "Text", type: "localized-text", default: "Projectors, TV boxes and sound for every room, with official warranty and cash on delivery." },
    { key: "image", label: "Picture", type: "image", help: "Shown beside the text on large screens. Empty = the first product card’s photo." },
    { key: "imageAlt", label: "Picture description", type: "string", help: "For screen readers. Leave empty if the picture is decorative." },
    { key: "primaryCta.label", label: "Main button text", type: "localized-string", default: "Shop now" },
    { key: "primaryCta.url", label: "Main button link", type: "string", default: "/shop" },
    { key: "secondaryCta.label", label: "Second button text", type: "localized-string", default: "Today’s offers" },
    { key: "secondaryCta.url", label: "Second button link", type: "string", default: "/shop?order_by=discount_desc" },
    { key: "showTrustChips", label: "Show the trust strip", type: "boolean", default: !0 },
    {
      key: "trustChips",
      label: "Trust strip",
      help: "Up to four.",
      type: "array",
      dependency: { field: "showTrustChips", value: !0 },
      itemSchema: [
        { key: "icon", label: "Icon", type: "icon", default: "truck", options: Zp },
        { key: "text", label: "Text", type: "localized-string" }
      ],
      default: [
        { icon: "truck", text: "Delivery all over Bangladesh" },
        { icon: "shield", text: "Official warranty" },
        { icon: "cash", text: "Cash on delivery" },
        { icon: "headset", text: "Hotline support" }
      ]
    },
    { key: "showCards", label: "Show the side banners", type: "boolean", default: !0 },
    {
      key: "cards",
      label: "Side banners",
      type: "array",
      help: "Up to two, beside the slider on desktop. Empty = the two biggest current deals.",
      dependency: { field: "showCards", value: !0 },
      itemSchema: [
        { key: "productId", label: "Product", type: "product-select" },
        { key: "label", label: "Label", type: "localized-string", placeholder: "Hot deal" }
      ],
      default: []
    },
    {
      key: "slides",
      label: "More slides",
      type: "array",
      help: "Shown after the headline slide. Pick a product, or write your own text and add a picture.",
      itemSchema: [
        { key: "productId", label: "Product", type: "product-select" },
        { key: "badge", label: "Badge", type: "localized-string", placeholder: "New" },
        { key: "title", label: "Headline", type: "localized-string", help: "Empty = the product name." },
        { key: "subtitle", label: "Text", type: "localized-text" },
        { key: "image", label: "Picture", type: "image", help: "Empty = the product photo." },
        { key: "ctaText", label: "Button text", type: "localized-string", placeholder: "View product" },
        { key: "ctaLink", label: "Button link", type: "string", help: "Empty = the product page." }
      ],
      default: []
    },
    { key: "autoplay", label: "Play slides automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 6, help: "0 or empty = 6 seconds.", dependency: { field: "autoplay", value: !0 } },
    ...R
  ]
}, i0 = {
  type: "product-rail",
  label: "Product rail",
  description: "A grid or swipe row of product cards from new arrivals, deals, a category or your own pick.",
  supportedPages: Dt,
  variants: [{ id: "v1", label: "Product cards" }],
  commonFields: [
    ...Ja({ eyebrow: "Just in", title: "New arrivals", subtitle: "The latest additions to the store." }),
    { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 8 } },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [
        { label: "Grid (2 columns on phones, 4 on desktop)", value: "grid" },
        { label: "Swipe row", value: "rail" }
      ],
      default: "grid"
    },
    { key: "showViewAll", label: "Show “View all”", type: "boolean", default: !0 },
    { key: "viewAllLabel", label: "“View all” text", type: "string", default: "View all", dependency: { field: "showViewAll", value: !0 } },
    ...R
  ]
}, n0 = {
  type: "promises",
  label: "Promises strip",
  description: "Short store promises (delivery, payment, returns, support) with icons.",
  supportedPages: Dt,
  variants: [{ id: "v1", label: "Tint tiles" }],
  commonFields: [
    ...Ja(),
    {
      key: "items",
      label: "Promises",
      type: "array",
      itemSchema: Jp,
      default: [
        { icon: "shipping", title: "Fast delivery", body: "Quick delivery across the city." },
        { icon: "secure", title: "Pay on delivery", body: "Pay in cash when your order arrives." },
        { icon: "refund", title: "Easy returns", body: "Not right? We will make it right." },
        { icon: "support", title: "Here to help", body: "Call or message us any day." }
      ]
    },
    ...R
  ]
}, s0 = {
  type: "reviews",
  label: "Customer reviews",
  description: "A swipe row of review cards: rating, quote, name and the product.",
  supportedPages: Dt,
  variants: [{ id: "v1", label: "Review cards" }],
  commonFields: [
    ...Ja({ eyebrow: "Reviews", title: "What customers say" }),
    {
      key: "items",
      label: "Reviews",
      type: "array",
      help: "Real reviews from your customers, with their permission.",
      itemSchema: [
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "body", label: "Review", type: "localized-text" },
        { key: "name", label: "Customer name", type: "string" },
        { key: "productId", label: "Product", type: "product-select" }
      ],
      default: []
    },
    { key: "limit", label: "Most reviews shown", type: "number", default: 6 },
    { key: "minRating", label: "Lowest rating shown (store reviews)", type: "number", default: 4 },
    ...R
  ]
}, c0 = {
  type: "story",
  label: "Story band",
  description: "Why shop with you: a picture beside short benefit points.",
  supportedPages: Dt,
  variants: [{ id: "v1", label: "Picture and points" }],
  commonFields: [
    ...Ja({ eyebrow: "Our promise", title: "Why shop with us", subtitle: "Good products, honest prices and service you can count on." }),
    { key: "image", label: "Picture", type: "image" },
    {
      key: "points",
      label: "Points",
      type: "array",
      itemSchema: Jp,
      default: [
        { icon: "secure", title: "Quality checked", body: "Every product is checked before it leaves our store." },
        { icon: "shipping", title: "Delivered fresh", body: "Packed with care and delivered quickly to your door." },
        { icon: "support", title: "Real support", body: "Questions about an order? Call or message us any day." }
      ]
    },
    { key: "ctaLabel", label: "Button text", type: "localized-string", default: "" },
    { key: "ctaLink", label: "Button link", type: "string", default: "" },
    ...R
  ]
}, d0 = {
  hero: l0,
  "banner-carousel": t0,
  "category-bento": a0,
  "product-rail": i0,
  story: c0,
  "combo-spotlight": o0,
  reviews: s0,
  promises: n0,
  "corporate-band": r0,
  "announcement-bar": _1,
  blog: U1,
  brands: G1,
  cta: Y1,
  "flash-sale": X1,
  "instagram-feed": j1,
  "lookbook-banner": q1,
  "new-arrivals": Z1,
  "offer-banner": J1,
  "product-grid": K1,
  "product-slider": Q1,
  testimonials: e0
}, p0 = {
  type: "account",
  label: "Account",
  description: "Signed-in shopper area: overview, orders, profile and saved addresses.",
  supportedPages: ["account", "orders", "profile", "addresses"],
  variants: [{ id: "v1", label: "Side navigation" }],
  commonFields: [
    { key: "title", label: "Overview title", type: "string", default: "My account" },
    { key: "tabOverviewLabel", label: "Overview label", type: "string", default: "Overview" },
    { key: "tabOrdersLabel", label: "Orders label", type: "string", default: "Orders" },
    { key: "tabDetailsLabel", label: "Profile label", type: "string", default: "Profile" },
    { key: "tabAddressesLabel", label: "Addresses label", type: "string", default: "Addresses" },
    { key: "signOutLabel", label: "Sign out label", type: "string", default: "Sign out" }
  ]
}, u0 = {
  type: "cart",
  label: "Cart",
  description: "Cart lines with quantity steppers, delivery area choice, free-delivery progress and checkout.",
  supportedPages: ["cart"],
  variants: [{ id: "v1", label: "Lines + totals box" }],
  commonFields: [
    { key: "pageTitle", label: "Page title (for screen readers)", type: "string", default: "Shopping cart" },
    { key: "emptyTitle", label: "Empty cart title", type: "string", default: "Your cart is currently empty." },
    { key: "emptyMessage", label: "Empty cart message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Totals title", type: "string", default: "Cart totals" },
    { key: "subtotalLabel", label: "Subtotal label", type: "string", default: "Subtotal" },
    { key: "shippingLabel", label: "Delivery label", type: "string", default: "Delivery" },
    { key: "shippingCalculatedText", label: "Text when delivery areas are unavailable", type: "string", default: "Delivery charge is added at checkout." },
    { key: "totalLabel", label: "Total label", type: "string", default: "Total" },
    { key: "checkoutButtonText", label: "Checkout button text", type: "string", default: "Proceed to checkout" },
    { key: "checkoutLink", label: "Checkout link", type: "string", default: "/checkout" }
  ]
}, y0 = {
  type: "checkout",
  label: "Checkout",
  description: "Billing details, delivery area, payment and order summary with a place-order button.",
  supportedPages: ["checkout"],
  variants: [{ id: "v1", label: "Two columns" }],
  commonFields: [
    { key: "pageTitle", label: "Billing title", type: "string", default: "Billing details" },
    { key: "emptyTitle", label: "Empty cart title", type: "string", default: "Your cart is empty." },
    { key: "emptyMessage", label: "Empty cart message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Return to shop" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order summary title", type: "string", default: "Your order" },
    { key: "subtotalLabel", label: "Subtotal label", type: "string", default: "Subtotal" },
    { key: "deliveryLabel", label: "Delivery label", type: "string", default: "Delivery" },
    { key: "totalLabel", label: "Total label", type: "string", default: "Total" },
    { key: "codLabel", label: "Cash on delivery label", type: "string", default: "Cash on delivery" },
    { key: "codDescription", label: "How to pay (cash on delivery)", type: "localized-text", default: "Pay with cash when your order arrives." },
    { key: "privacyNote", label: "Privacy note", type: "localized-text", help: "Shown above the place-order button. Leave empty for the default note linking to the privacy policy." },
    { key: "placeOrderText", label: "Place order button text", type: "string", default: "Place order" },
    { key: "placingOrderText", label: "Placing order text", type: "string", default: "Placing order…" }
  ]
}, h0 = {
  type: "contact",
  label: "Contact",
  description: "Phone, WhatsApp, email and address cards. Empty fields use Store info.",
  supportedPages: ["contact"],
  variants: [{ id: "v1", label: "Contact cards" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Contact us" },
    { key: "description", label: "Intro text", type: "localized-text", default: "Questions about an order or a product? We are happy to help." },
    { key: "phone", label: "Phone (empty: Store info hotline)", type: "string" },
    { key: "email", label: "Email (empty: Store info email)", type: "string" },
    { key: "address", label: "Address (empty: Store info addresses)", type: "text" },
    { key: "hoursText", label: "Opening hours", type: "localized-text" }
  ]
}, b0 = {
  type: "content",
  label: "Text / FAQ",
  description: "Policies and other text pages, the home page’s “Read more” article, or questions as cards and an accordion.",
  supportedPages: ["home", "shop", "category", "contact", "privacy-policy", "terms-of-service", "shipping-policy", "return-policy", "track-order"],
  variants: [
    { id: "v1", label: "Text page (readable column)" },
    { id: "v2", label: "Article with “Read more”" },
    { id: "v3", label: "FAQ (two-column cards, then an accordion)" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "subtitle", label: "Subtitle / intro", type: "localized-text", help: "In the article layout this is the part shown before “Read more”." },
    { key: "content", label: "Text", type: "rich-text" },
    {
      key: "faqs",
      label: "Questions and answers",
      type: "array",
      help: "Shown as an accordion under the text (also published as FAQ structured data).",
      itemSchema: [
        { key: "question", label: "Question", type: "string" },
        { key: "answer", label: "Answer", type: "text" }
      ]
    },
    { key: "updatedText", label: "Last updated note", type: "string", placeholder: "Last updated 1 January 2026" }
  ]
}, m0 = {
  type: "coupon",
  label: "Coupons",
  description: "Coupon codes with discount, title, description, expiry and a copy button.",
  supportedPages: ["coupon"],
  variants: [{ id: "v1", label: "Code cards" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Coupons" },
    { key: "subtitle", label: "Subtitle", type: "localized-text", default: "Use these codes when you order." },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Code", type: "string" },
        { key: "discount", label: "Discount (e.g. 10% off)", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Conditions", type: "text" },
        { key: "expiryDate", label: "Valid until", type: "string" }
      ]
    },
    { key: "emptyText", label: "Text when there are no coupons", type: "string", default: "No coupons right now. Check back soon." }
  ]
}, g0 = {
  type: "order-success",
  label: "Order complete",
  description: "Thank-you message with the order number, date, total, payment and order details.",
  supportedPages: ["order-success"],
  variants: [{ id: "v1", label: "Thank-you card" }],
  commonFields: [
    { key: "title", label: "Thank-you title", type: "localized-string", default: "Thank you. Your order has been received." },
    { key: "message", label: "Thank-you message", type: "localized-text", default: "We will call you to confirm your order before delivery." },
    { key: "errorTitle", label: "Title when the order cannot be loaded", type: "string", default: "Your order was placed." },
    { key: "errorMessage", label: "Message when the order cannot be loaded", type: "string", default: "We could not load the order details on this device, but your order was received." },
    { key: "viewOrderText", label: "View order button text (signed-in shoppers)", type: "string", default: "View order" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" }
  ]
}, f0 = {
  type: "signin",
  label: "Sign in",
  description: "Phone number and one-time code card; new shoppers add their name.",
  supportedPages: ["signin", "forgot-password", "reset-password"],
  variants: [{ id: "v1", label: "Card" }],
  commonFields: [
    { key: "title", label: "Title", type: "localized-string", default: "Sign in" },
    { key: "intro", label: "Intro text", type: "localized-text", default: "Use your mobile number. We send you a code by SMS — no password needed." },
    { key: "redirectUrl", label: "Go to after signing in", type: "string", default: "/account" }
  ]
}, v0 = {
  type: "signup",
  label: "Sign up",
  description: "Phone number and one-time code card; new shoppers add their name.",
  supportedPages: ["signup"],
  variants: [{ id: "v1", label: "Card" }],
  commonFields: [
    { key: "title", label: "Title", type: "localized-string", default: "Create your account" },
    { key: "intro", label: "Intro text", type: "localized-text", default: "Use your mobile number. We send you a code by SMS — no password needed." },
    { key: "redirectUrl", label: "Go to after signing in", type: "string", default: "/account" }
  ]
}, k0 = {
  cart: u0,
  checkout: y0,
  "order-success": g0,
  coupon: m0,
  account: p0,
  signin: f0,
  signup: v0,
  contact: h0,
  content: b0
}, w0 = ht({
  ...yt,
  componentSchemas: {
    ...yt.componentSchemas,
    ...d0,
    ...O1,
    ...k0
  },
  headerSchema: $1,
  footerSchema: z1
}, N1), S0 = {
  banner: { hide: ["title", "description", "ctaText", "ctaLink", "backgroundImage"], keep: [], add: Oa.variants, variantLabels: { v1: "Selling points (icon, title, line)", v2: "Two picture banners" } },
  category: { hide: ["cardVariant", "autoplay", "autoplayDelay"] },
  "featured-category": { hide: ["productCardVariant", "noSelectionText", "noProductsText", "buttons.orderNow"] },
  "floating-buttons": {
    hide: ["messenger", "messengerTitle"],
    labels: { callUsTitle: { label: "Call button label", help: "Shown beside the round call button on hover; the button calls the hotline." }, whatsappTitle: { label: "WhatsApp button text" } }
  },
  footer: { hide: ["logo"], labels: { contactAddress: { label: "Shop address", help: "Empty = the first address in Store info." } } },
  "product-detail": { hide: ["loadingText", "notFoundCode", "notFoundText"] },
  "recent-products": { hide: ["productCardVariant", "buttons"] },
  "shop-grid": { hide: ["sidebarVariant", "productCardVariant", "paginationVariant", "initialPriceRange", "filtersButtonLabel", "showingLabel", "productsSuffix", "sortNewestLabel", "sortOldestLabel", "sortPriceAscLabel", "sortPriceDescLabel", "sortNameAscLabel", "sortNameDescLabel", "activeFiltersLabel", "backToAllText", "filterDrawerTitle", "currentSearchLabel", "clearSearchLabel", "applyFiltersLabel", "buttons.orderNow"] },
  "similar-products": { hide: ["productCardVariant", "buttons.orderNow"] },
  features: { add: [{ id: "v2", label: "Large tiles" }, { id: "v3", label: "Icons on one band" }], variantLabels: { v1: "Tiles" } },
  hero: { labels: { eyebrow: { label: "Label on the first slide" }, headline: { label: "Title (first slide)" }, subtext: { label: "Text (first slide)" }, image: { label: "Picture (first slide)", help: "Right side of the slide. Empty = the biggest current deal’s photo." } } },
  "mobile-bottom-nav": { hide: ["items[].isPrimary"] },
  // Theme tab: button settings no part of this theme reads (colours drive every primary button via the CTA).
  buttons: { hide: ["appearance.buttons.primary[].radius", "appearance.buttons.primary[].height", "appearance.buttons.primary[].paddingX", "appearance.buttons.primary[].label", "appearance.buttons.outline[].radius", "appearance.buttons.outline[].height", "appearance.buttons.outline[].paddingX", "appearance.buttons.outline[].label"] },
  // Delivery time is shown on product cards only by Prottoho.
  "store-info": { hide: ["deliveryEta"] }
}, x0 = {
  type: "compare",
  label: "Compare",
  description: "Up to four saved products side by side (photo, price, brand, warranty, specifications), or an empty state.",
  supportedPages: ["compare"],
  variants: [{ id: "v1", label: "Side by side" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Compare products" },
    { key: "emptyTitle", label: "Empty title", type: "string" },
    { key: "emptyText", label: "Empty message", type: "string" }
  ]
}, T0 = {
  ...Pt,
  commonFields: [
    ...Pt.commonFields,
    { key: "howToOrderTitle", label: '"How to order" tab title', type: "string", default: "How to order" },
    { key: "howToOrder", label: "How to order", type: "localized-text", help: "Steps shown in their own tab; the tab is hidden while this is empty." },
    { key: "showDeliveryAreas", label: "Show delivery areas and charges", type: "boolean", default: !0 },
    { key: "showRelated", label: "Show related products", type: "boolean", default: !0, help: "A column left of the product on computers, under the tabs on phones." },
    { key: "relatedTitle", label: "Related products title", type: "string", default: "Related products", dependency: { field: "showRelated", value: !0 } },
    {
      key: "specGroups",
      label: "Spec groups",
      type: "array",
      help: "Your own headings for the specification table. Empty = Processor, Memory, Storage, Graphics, Display, Connectivity, Physical, Power, Warranty; anything unmatched goes under General.",
      itemSchema: [
        { key: "title", label: "Heading", type: "string", placeholder: "Processor" },
        { key: "attributes", label: "Attribute names", type: "string", placeholder: "Processor, Cores, Threads", help: "Comma-separated, as they are named in your attributes." }
      ]
    }
  ]
}, C0 = {
  ...At,
  commonFields: [
    ...At.commonFields,
    { key: "pageSizes", label: "Extra page sizes", type: "string", placeholder: "24, 48", help: 'Offered next to "Products per page"; leave empty for one size.' }
  ]
}, P0 = {
  type: "wishlist",
  label: "Wishlist",
  description: "The products a shopper saved, or an empty state with a link back to the shop.",
  supportedPages: ["wishlist"],
  variants: [{ id: "v1", label: "Saved products" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Wishlist" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    { key: "emptyTitle", label: "Empty title", type: "string", default: "Your wishlist is empty" },
    { key: "emptyText", label: "Empty message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" }
  ]
}, A0 = {
  "shop-grid": C0,
  "product-detail": T0,
  wishlist: P0,
  compare: x0
}, L0 = ["facebook", "instagram", "youtube", "tiktok", "linkedin", "x"].map((e) => ({ label: e === "x" ? "X" : e[0].toUpperCase() + e.slice(1), value: e })), M0 = [
  { key: "locationUrl", label: '"Our location" link', type: "string", placeholder: "https://maps.google.com/…", help: "Empty = a map search for the shop address." },
  { key: "complaintUrl", label: '"Complaint box" link', type: "string", placeholder: "/contact", help: "Empty = no Complaint box button." },
  { key: "badgesTitle", label: "Logo column title", type: "string", default: "Affiliation" },
  {
    key: "badges",
    label: "Affiliation and partner logos",
    type: "array",
    help: "Shown on white tiles in the last column; the first logo is wide.",
    itemSchema: [
      { key: "image", label: "Logo", type: "image" },
      { key: "alt", label: "Name", type: "string" },
      { key: "href", label: "Link", type: "string" }
    ]
  }
], N0 = {
  ...Ct,
  label: "Footer",
  description: "Graphite footer: contact column, link columns, affiliation logos and a payment strip.",
  variants: [{ id: "v1", label: "Graphite, four columns" }],
  commonFields: [
    ...Ct.commonFields.filter((e) => e.key !== "title").map((e) => {
      var t;
      return e.key !== "socialLinks" ? e : { ...e, itemSchema: (t = e.itemSchema) == null ? void 0 : t.map((a) => a.key === "platform" ? { ...a, options: L0 } : a) };
    }),
    ...M0
  ]
}, E0 = [
  "home",
  "shop",
  "product",
  "category",
  "categories",
  "search",
  "cart",
  "checkout",
  "contact",
  "signin",
  "signup",
  "account",
  "wishlist",
  "track-order",
  "order-success",
  "order-detail",
  "blog",
  "privacy-policy",
  "terms-of-service",
  "shipping-policy",
  "return-policy",
  "offers",
  "tools",
  "pc-builder"
], D0 = [
  { label: "Tag (offers)", value: "tag" },
  { label: "Wrench (tools)", value: "wrench" },
  { label: "Monitor (PC builder)", value: "monitor" },
  { label: "Chip", value: "cpu" },
  { label: "Lightning", value: "zap" },
  { label: "Truck", value: "truck" },
  { label: "Headset", value: "headset" },
  { label: "Grid", value: "grid" }
], F0 = [
  { key: "label", label: "Label", type: "string" },
  { key: "url", label: "Link URL", type: "string", placeholder: "/offers" },
  { key: "icon", label: "Icon", type: "select", options: D0, default: "tag" }
], I0 = {
  type: "header",
  label: "Header",
  description: "Logo, search, quick-link buttons, shopper icons and the category bar.",
  supportedPages: [...E0],
  variants: [{ id: "v1", label: "Graphite bar with a category bar" }],
  commonFields: [
    { key: "logo.src", label: "Logo", type: "image", help: "Shown on a white tile on the dark bar." },
    { key: "logo.alt", label: "Logo alt text", type: "string" },
    { key: "searchPlaceholder", label: "Search placeholder", type: "string", placeholder: "Search laptops, parts, brands or models…" },
    {
      key: "quickLinks",
      label: "Quick-link buttons",
      type: "array",
      help: "The outlined buttons beside the search (up to three). Empty = Offers, Tools and PC Builder.",
      itemSchema: F0
    },
    {
      key: "actions",
      label: "Icons",
      type: "object",
      fields: [
        { key: "showSearch", label: "Search", type: "boolean", default: !0 },
        { key: "showCompare", label: "Compare", type: "boolean", default: !0 },
        { key: "showWishlist", label: "Wishlist", type: "boolean", default: !0 },
        { key: "showCart", label: "Cart", type: "boolean", default: !0 },
        { key: "showAccount", label: "Login / account", type: "boolean", default: !0 },
        {
          key: "cartAction",
          label: "Cart opens",
          type: "select",
          options: [
            { label: "Cart drawer", value: "sidebar" },
            { label: "Cart page", value: "page" }
          ],
          default: "sidebar"
        }
      ]
    }
  ]
}, O0 = {
  type: "announcement-bar",
  label: "Announcement bar",
  description: "A slim rotating bar of short messages, with an optional coupon code after each.",
  supportedPages: ["home", "shop", "product", "category", "categories", "cart", "checkout", "contact", "wishlist"],
  variants: [{ id: "v1", label: "Rotating bar" }],
  commonFields: [{
    key: "items",
    label: "Messages",
    type: "array",
    itemSchema: [
      { key: "text", label: "Message", type: "string" },
      { key: "code", label: "Coupon code (optional)", type: "string" }
    ],
    default: [{ text: "Free delivery on orders over 1000" }]
  }]
}, Qp = ["truck", "cash", "phone", "shield", "star", "heart", "package", "check", "store", "map-pin", "mail", "leaf", "sparkle", "clock", "headset", "zap", "award", "refresh"].map((e) => ({ label: e.replace("-", " "), value: e })), Ka = (e = {}) => [
  { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: e.eyebrow ?? "", help: "Small line above the title." },
  { key: "title", label: "Title", type: "localized-string", default: e.title ?? "" },
  { key: "subtitle", label: "Subtitle", type: "localized-text", default: e.subtitle ?? "" }
], eu = [
  { key: "icon", label: "Icon", type: "icon", default: "shield", options: Qp },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "body", label: "Text", type: "localized-text" }
], Ft = ["home", "shop", "category", "categories", "product", "cart", "blog"], R0 = [
  { key: "title", label: "Title", type: "string" },
  { key: "image", label: "Cover (16:9)", type: "image" },
  { key: "excerpt", label: "Excerpt", type: "text" },
  { key: "slug", label: "Slug", type: "string", help: "Opens the post at /blog/<slug>." },
  { key: "date", label: "Date", type: "string", placeholder: "12 Sep 2026" },
  { key: "category", label: "Topic", type: "string" }
], bd = [
  { key: "title", label: "Title", type: "string", default: "From the blog" },
  { key: "posts", label: "Posts", type: "array", itemSchema: R0 },
  { key: "viewAllLink", label: "View all link", type: "string", default: "/blog" },
  { key: "showViewAll", label: 'Show "View all"', type: "boolean", default: !0 }
], B0 = {
  type: "blog",
  label: "Blog",
  description: "Posts entered here, as cards with cover, topic, excerpt and date, or as a compact list.",
  supportedPages: Ft,
  variants: [
    { id: "v1", label: "Cards", fields: bd },
    { id: "v2", label: "Compact list", fields: bd }
  ],
  commonFields: [
    { key: "source", label: "Posts to show", type: "select", options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." },
    ...R
  ]
}, z0 = {
  type: "brands",
  label: "Brands",
  description: "Brand logos as a grid of tiles or a scrolling ticker; leave empty to show the store's brands.",
  supportedPages: ["home", "shop", "categories"],
  variants: [{ id: "v1", label: "Logos" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Brands we carry" },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [{ label: "Grid", value: "grid" }, { label: "Ticker", value: "ticker" }],
      default: "grid"
    },
    {
      key: "items",
      label: "Brands",
      type: "array",
      itemSchema: [
        { key: "logo", label: "Logo", type: "image" },
        { key: "name", label: "Name", type: "string" },
        { key: "link", label: "Link", type: "string" }
      ]
    },
    ...R
  ]
}, V0 = {
  type: "cta",
  label: "Newsletter",
  description: "A tint card with a title and text beside an email form.",
  supportedPages: Ft,
  variants: [{ id: "v1", label: "Newsletter band" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Subscribe to our newsletter" },
    { key: "subtitle", label: "Text", type: "string" },
    { key: "placeholder", label: "Email placeholder", type: "string", default: "Email address" },
    { key: "buttonText", label: "Button text", type: "string", default: "Subscribe" },
    { key: "formAction", label: "Form URL", type: "string", help: "An external newsletter form; without it the band shows no form." },
    ...R
  ]
}, W0 = {
  type: "flash-sale",
  label: "Flash sale",
  description: "A countdown to the end date over a row of the most discounted products. Hidden after it ends.",
  supportedPages: ["home"],
  variants: [{ id: "v1", label: "Countdown row" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Flash sale" },
    { key: "endDate", label: "Ends at (ISO date)", type: "string", placeholder: "2026-12-31T23:59:59" },
    ...R
  ]
}, $0 = {
  type: "instagram-feed",
  label: "Social feed",
  description: "Photo tiles from your social account, each linking to its post.",
  supportedPages: Ft,
  variants: [
    { id: "v1", label: "Grid, 5 columns" },
    { id: "v2", label: "Grid, 6 columns" },
    { id: "v3", label: "Grid, 4 columns" },
    { id: "v4", label: "Masonry, 4 columns" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Follow us" },
    { key: "handle", label: "Handle", type: "string", placeholder: "@yourstore" },
    {
      key: "items",
      label: "Photos",
      type: "array",
      itemSchema: [
        { key: "image", label: "Photo", type: "image" },
        { key: "link", label: "Post link", type: "string" }
      ]
    },
    ...R
  ]
}, md = [
  { key: "image", label: "Picture", type: "image" },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Text", type: "text" },
  { key: "ctaText", label: "Button text", type: "string" },
  { key: "ctaLink", label: "Button link", type: "string", default: "/shop" }
], _0 = {
  type: "lookbook-banner",
  label: "Editorial banner",
  description: "A picture with a title, text and one button.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "Picture beside text",
      fields: [
        ...md,
        {
          key: "imagePosition",
          label: "Picture side",
          type: "select",
          options: [{ label: "Left", value: "left" }, { label: "Right", value: "right" }],
          default: "left"
        }
      ]
    },
    {
      id: "v2",
      label: "Text over picture",
      fields: [...md, { key: "overlayOpacity", label: "Dark wash (30–90)", type: "number", default: 40 }]
    }
  ],
  commonFields: [...R]
}, tu = [{
  key: "buttons.addToCart",
  label: "Add to cart button",
  type: "object",
  preview: { type: "button", variant: "primary", defaultLabel: "Add to cart" },
  fields: [
    { key: "label", label: "Button text", type: "string" },
    { key: "bg", label: "Background colour", type: "color" },
    { key: "text", label: "Text colour", type: "color" }
  ]
}], ws = (e) => [
  { key: "title", label: "Title", type: "string", default: e },
  { key: "subtitle", label: "Subtitle", type: "string" }
], Ss = ["home", "shop", "category", "categories"], H0 = {
  type: "new-arrivals",
  label: "New arrivals",
  description: "A swipe row of the newest products.",
  supportedPages: Ss,
  variants: [{ id: "v1", label: "Product row" }],
  commonFields: [...ws("New arrivals"), ...R]
}, U0 = {
  type: "offer-banner",
  label: "Offer banner",
  description: "A picture panel with a title, text and one button.",
  supportedPages: ["home", "shop", "category"],
  variants: [{ id: "v1", label: "Picture panel" }],
  commonFields: [
    { key: "image", label: "Picture", type: "image" },
    { key: "title", label: "Title", type: "string", default: "Special offer" },
    { key: "subtitle", label: "Text", type: "text" },
    { key: "ctaText", label: "Button text", type: "string", default: "Shop now" },
    { key: "ctaLink", label: "Button link", type: "string", default: "/shop" },
    { key: "overlayOpacity", label: "Dark wash (30–90)", type: "number", default: 50 },
    ...R
  ]
}, tr = [...ws("All products"), { key: "viewAllLink", label: "View all link", type: "string", default: "/shop" }], G0 = {
  type: "product-grid",
  label: "Product grid",
  description: "Products as a card grid, a lead product beside smaller ones, or compact rows.",
  supportedPages: Ss,
  variants: [
    { id: "v1", label: "Card grid", fields: tr },
    { id: "v2", label: "Lead card and 6", fields: tr },
    { id: "v3", label: "Compact rows", fields: tr },
    { id: "v4", label: "Lead card and 4", fields: tr },
    {
      id: "v6",
      label: "Compact rows with special offer",
      fields: [...tr, { key: "offerEndsAt", label: "Offer ends at (ISO date)", type: "string" }]
    }
  ],
  commonFields: [
    { key: "categoryId", label: "Category (optional)", type: "category-select" },
    {
      key: "orderBy",
      label: "Order",
      type: "select",
      options: [
        { label: "Newest", value: "newest_first" },
        { label: "Biggest discount", value: "discount_desc" },
        { label: "Price: low to high", value: "price_asc" },
        { label: "Price: high to low", value: "price_desc" },
        { label: "Name: A–Z", value: "name_asc" }
      ],
      default: "newest_first"
    },
    { key: "limit", label: "Products", type: "number", default: 8 },
    ...tu,
    ...R
  ]
}, Y0 = {
  type: "product-slider",
  label: "Product slider",
  description: "A swipe row of product cards, optionally with category tabs.",
  supportedPages: Ss,
  variants: [
    {
      id: "v1",
      label: "Category tabs",
      fields: [{
        key: "tabs",
        label: "Tabs",
        type: "array",
        itemSchema: [
          { key: "label", label: "Tab label", type: "string" },
          { key: "categoryId", label: "Category", type: "category-select" }
        ]
      }]
    },
    { id: "v2", label: "Single row" }
  ],
  commonFields: [...ws("Featured products"), ...tu, ...R]
}, X0 = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer quotes as review cards with rating, photo, name and role.",
  supportedPages: Ft,
  variants: [
    { id: "v1", label: "Review cards" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "What customers say" },
    {
      key: "items",
      label: "Reviews",
      type: "array",
      itemSchema: [
        { key: "avatar", label: "Photo", type: "image" },
        { key: "name", label: "Name", type: "string" },
        { key: "designation", label: "Role or city", type: "string" },
        { key: "review", label: "Review", type: "text" },
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 }
      ]
    },
    ...R
  ]
}, j0 = {
  type: "banner-carousel",
  label: "Banner carousel",
  description: "Picture slides (offers, campaigns) with arrows, dots and autoplay, full width or with two picture banners beside them.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [
    { id: "v1", label: "Picture slides" },
    {
      id: "v2",
      label: "Slides with two side banners",
      fields: [
        {
          key: "sideBanners",
          label: "Side banners",
          type: "array",
          help: "Two pictures stacked beside the slides (under them on phones); more are not shown.",
          itemSchema: [
            { key: "image", label: "Picture", type: "image", required: !0, help: "About 520 × 230 px." },
            { key: "alt", label: "Picture description", type: "string", help: "What the banner says, for screen readers." },
            { key: "link", label: "Link", type: "string", placeholder: "/shop" }
          ],
          default: []
        }
      ]
    }
  ],
  commonFields: [
    { key: "title", label: "Name for screen readers", type: "string", default: "Offers" },
    {
      key: "slides",
      label: "Slides",
      type: "array",
      itemSchema: [
        { key: "image", label: "Picture", type: "image", required: !0, help: "About 1240 × 360 px (about 880 × 460 px with side banners)." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional, about 780 × 400 px." },
        { key: "alt", label: "Picture description", type: "string", help: "What the banner says, for screen readers." },
        { key: "link", label: "Link", type: "string", placeholder: "/shop" }
      ],
      default: []
    },
    { key: "autoplay", label: "Play automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 5, dependency: { field: "autoplay", value: !0 } },
    ...R
  ]
}, q0 = [
  ["laptop", "Laptop"],
  ["pc-case", "Desktop PC"],
  ["monitor", "Monitor"],
  ["cpu", "Processor"],
  ["circuit-board", "Motherboard"],
  ["memory-stick", "RAM"],
  ["hard-drive", "Storage"],
  ["gpu", "Graphics card"],
  ["fan", "Cooling"],
  ["router", "Router"],
  ["wifi", "Wi-Fi"],
  ["server", "Server"],
  ["printer", "Printer"],
  ["keyboard", "Keyboard"],
  ["mouse", "Mouse"],
  ["headphones", "Headphones"],
  ["speaker", "Speaker"],
  ["gamepad", "Gaming"],
  ["camera", "Camera"],
  ["webcam", "Webcam / CCTV"],
  ["tv", "TV"],
  ["smartphone", "Phone"],
  ["tablet", "Tablet"],
  ["watch", "Smart watch"],
  ["battery-charging", "UPS / power"],
  ["plug", "Cables & adapters"],
  ["disc", "Software"],
  ["package", "Other"]
].map(([e, t]) => ({ value: e, label: t })), Z0 = {
  type: "category-bento",
  label: "Category tiles",
  description: "Category tiles with the product shot beside the name (2 / 4 per row), picture tiles (3 / 6 per row) or icon tiles (4 / 8 per row).",
  supportedPages: Ft,
  variants: [
    { id: "v1", label: "Picture beside the name (2 / 4 per row)" },
    { id: "v2", label: "Picture above the name (3 / 6 per row)" },
    { id: "v3", label: "Icon tiles (4 / 8 per row)" }
  ],
  commonFields: [
    ...Ka({ title: "Shop by category", subtitle: "Parts, devices and accessories, sorted for you." }),
    {
      key: "tiles",
      label: "Tiles",
      type: "array",
      help: "Empty = the store’s categories. Leave the title empty for a grid without a heading.",
      itemSchema: [
        { key: "categoryId", label: "Category", type: "category-select", help: "Sets the link, name and picture unless filled below." },
        { key: "title", label: "Name", type: "localized-string" },
        { key: "tagline", label: "Tagline", type: "localized-string", help: "Shown when the category has no product count." },
        { key: "icon", label: "Icon", type: "icon", options: q0, help: "Shown when the tile has no picture of its own. Empty = guessed from the name." },
        { key: "image", label: "Picture", type: "image", help: "Replaces the icon." },
        { key: "link", label: "Link", type: "string", placeholder: "/category/…" }
      ],
      default: []
    },
    { key: "limit", label: "Categories shown (automatic tiles)", type: "number", default: 24 },
    ...R
  ]
}, J0 = {
  type: "combo-spotlight",
  label: "Product spotlight",
  description: "One product or bundle on a large dark card with its price, saving and Add to cart.",
  supportedPages: Ft,
  variants: [{ id: "v1", label: "Dark card" }],
  commonFields: [
    ...Ka({ eyebrow: "Bundle & save", title: "Value pack of the week" }),
    { key: "productId", label: "Product", type: "product-select", help: "Hidden until a product is picked." },
    { key: "description", label: "Text", type: "localized-text", default: "" },
    { key: "mrpLabel", label: "Regular price label", type: "localized-string", default: "Regular price" },
    { key: "savingLabel", label: "Saving label", type: "localized-string", default: "You save" },
    { key: "detailsLabel", label: "Details button text", type: "localized-string", default: "View details" },
    ...R
  ]
}, K0 = {
  type: "corporate-band",
  label: "Bulk order band",
  description: "Text and one button, e.g. for corporate, event or wholesale orders.",
  supportedPages: Ft,
  variants: [{ id: "v1", label: "Text and button" }],
  commonFields: [
    ...Ka({ eyebrow: "For businesses", title: "Bulk and corporate orders" }).filter((e) => e.key !== "subtitle"),
    { key: "text", label: "Text", type: "localized-text", default: "Ordering for an office, an event or gifts? Get volume pricing and scheduled delivery." },
    { key: "cta.label", label: "Button text", type: "localized-string", default: "Contact us" },
    { key: "cta.url", label: "Button link", type: "string", default: "/contact" },
    ...R
  ]
}, Q0 = {
  type: "hero",
  label: "Hero",
  description: "Slider with side banners and a trust strip (delivery, warranty, cash on delivery, hotline).",
  supportedPages: ["home", "shop", "category", "categories", "cart", "checkout", "order-success"],
  variants: [{ id: "v1", label: "Slider with two side banners" }],
  commonFields: [
    { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "New this week" },
    { key: "headline", label: "Headline", type: "localized-string", default: "Big-screen cinema at home" },
    { key: "subtext", label: "Text", type: "localized-text", default: "Projectors, TV boxes and sound for every room, with official warranty and cash on delivery." },
    { key: "image", label: "Picture", type: "image", help: "Shown beside the text on large screens. Empty = the first product card’s photo." },
    { key: "imageAlt", label: "Picture description", type: "string", help: "For screen readers. Leave empty if the picture is decorative." },
    { key: "primaryCta.label", label: "Main button text", type: "localized-string", default: "Shop now" },
    { key: "primaryCta.url", label: "Main button link", type: "string", default: "/shop" },
    { key: "secondaryCta.label", label: "Second button text", type: "localized-string", default: "Today’s offers" },
    { key: "secondaryCta.url", label: "Second button link", type: "string", default: "/shop?order_by=discount_desc" },
    { key: "showTrustChips", label: "Show the trust strip", type: "boolean", default: !0 },
    {
      key: "trustChips",
      label: "Trust strip",
      help: "Up to four.",
      type: "array",
      dependency: { field: "showTrustChips", value: !0 },
      itemSchema: [
        { key: "icon", label: "Icon", type: "icon", default: "truck", options: Qp },
        { key: "text", label: "Text", type: "localized-string" }
      ],
      default: [
        { icon: "truck", text: "Delivery all over Bangladesh" },
        { icon: "shield", text: "Official warranty" },
        { icon: "cash", text: "Cash on delivery" },
        { icon: "headset", text: "Hotline support" }
      ]
    },
    { key: "showCards", label: "Show the side banners", type: "boolean", default: !0 },
    {
      key: "cards",
      label: "Side banners",
      type: "array",
      help: "Up to two, beside the slider on desktop. Empty = the two biggest current deals.",
      dependency: { field: "showCards", value: !0 },
      itemSchema: [
        { key: "productId", label: "Product", type: "product-select" },
        { key: "label", label: "Label", type: "localized-string", placeholder: "Hot deal" }
      ],
      default: []
    },
    {
      key: "slides",
      label: "More slides",
      type: "array",
      help: "Shown after the headline slide. Pick a product, or write your own text and add a picture.",
      itemSchema: [
        { key: "productId", label: "Product", type: "product-select" },
        { key: "badge", label: "Badge", type: "localized-string", placeholder: "New" },
        { key: "title", label: "Headline", type: "localized-string", help: "Empty = the product name." },
        { key: "subtitle", label: "Text", type: "localized-text" },
        { key: "image", label: "Picture", type: "image", help: "Empty = the product photo." },
        { key: "ctaText", label: "Button text", type: "localized-string", placeholder: "View product" },
        { key: "ctaLink", label: "Button link", type: "string", help: "Empty = the product page." }
      ],
      default: []
    },
    { key: "autoplay", label: "Play slides automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 6, help: "0 or empty = 6 seconds.", dependency: { field: "autoplay", value: !0 } },
    ...R
  ]
}, eC = {
  type: "product-rail",
  label: "Product rail",
  description: "A swipe row (with arrows) or grid of product cards from new arrivals, deals, a category or your own pick.",
  supportedPages: Ft,
  variants: [{ id: "v1", label: "Product cards" }],
  commonFields: [
    ...Ka({ eyebrow: "Just in", title: "New arrivals", subtitle: "The latest additions to the store." }),
    { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 8 } },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [
        { label: "Swipe row with arrows", value: "rail" },
        { label: "Grid (2 columns on phones, 5 on desktop)", value: "grid" }
      ],
      default: "rail"
    },
    { key: "showViewAll", label: "Show “View all”", type: "boolean", default: !0 },
    { key: "viewAllLabel", label: "“View all” text", type: "string", default: "View all", dependency: { field: "showViewAll", value: !0 } },
    ...R
  ]
}, tC = {
  type: "promises",
  label: "Promises strip",
  description: "Short store promises (delivery, payment, returns, support) with icons.",
  supportedPages: Ft,
  variants: [{ id: "v1", label: "Tint tiles" }],
  commonFields: [
    ...Ka(),
    {
      key: "items",
      label: "Promises",
      type: "array",
      itemSchema: eu,
      default: [
        { icon: "shipping", title: "Fast delivery", body: "Quick delivery across the city." },
        { icon: "secure", title: "Pay on delivery", body: "Pay in cash when your order arrives." },
        { icon: "refund", title: "Easy returns", body: "Not right? We will make it right." },
        { icon: "support", title: "Here to help", body: "Call or message us any day." }
      ]
    },
    ...R
  ]
}, aC = {
  type: "reviews",
  label: "Customer reviews",
  description: "A swipe row of review cards: rating, quote, name and the product.",
  supportedPages: Ft,
  variants: [{ id: "v1", label: "Review cards" }],
  commonFields: [
    ...Ka({ eyebrow: "Reviews", title: "What customers say" }),
    {
      key: "items",
      label: "Reviews",
      type: "array",
      help: "Real reviews from your customers, with their permission.",
      itemSchema: [
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "body", label: "Review", type: "localized-text" },
        { key: "name", label: "Customer name", type: "string" },
        { key: "productId", label: "Product", type: "product-select" }
      ],
      default: []
    },
    { key: "limit", label: "Most reviews shown", type: "number", default: 6 },
    { key: "minRating", label: "Lowest rating shown (store reviews)", type: "number", default: 4 },
    ...R
  ]
}, oC = {
  type: "story",
  label: "Story band",
  description: "Why shop with you: a picture beside short benefit points.",
  supportedPages: Ft,
  variants: [{ id: "v1", label: "Picture and points" }],
  commonFields: [
    ...Ka({ eyebrow: "Our promise", title: "Why shop with us", subtitle: "Good products, honest prices and service you can count on." }),
    { key: "image", label: "Picture", type: "image" },
    {
      key: "points",
      label: "Points",
      type: "array",
      itemSchema: eu,
      default: [
        { icon: "secure", title: "Quality checked", body: "Every product is checked before it leaves our store." },
        { icon: "shipping", title: "Delivered fresh", body: "Packed with care and delivered quickly to your door." },
        { icon: "support", title: "Real support", body: "Questions about an order? Call or message us any day." }
      ]
    },
    { key: "ctaLabel", label: "Button text", type: "localized-string", default: "" },
    { key: "ctaLink", label: "Button link", type: "string", default: "" },
    ...R
  ]
}, rC = {
  hero: Q0,
  "banner-carousel": j0,
  "category-bento": Z0,
  "product-rail": eC,
  story: oC,
  "combo-spotlight": J0,
  reviews: aC,
  promises: tC,
  "corporate-band": K0,
  "announcement-bar": O0,
  blog: B0,
  brands: z0,
  cta: V0,
  "flash-sale": W0,
  "instagram-feed": $0,
  "lookbook-banner": _0,
  "new-arrivals": H0,
  "offer-banner": U0,
  "product-grid": G0,
  "product-slider": Y0,
  testimonials: X0
}, lC = {
  type: "account",
  label: "Account",
  description: "Signed-in shopper area: overview, orders, profile and saved addresses.",
  supportedPages: ["account", "orders", "profile", "addresses"],
  variants: [{ id: "v1", label: "Side navigation" }],
  commonFields: [
    { key: "title", label: "Overview title", type: "string", default: "My account" },
    { key: "tabOverviewLabel", label: "Overview label", type: "string", default: "Overview" },
    { key: "tabOrdersLabel", label: "Orders label", type: "string", default: "Orders" },
    { key: "tabDetailsLabel", label: "Profile label", type: "string", default: "Profile" },
    { key: "tabAddressesLabel", label: "Addresses label", type: "string", default: "Addresses" },
    { key: "signOutLabel", label: "Sign out label", type: "string", default: "Sign out" }
  ]
}, iC = {
  type: "cart",
  label: "Cart",
  description: "Cart lines with quantity steppers, delivery area choice, free-delivery progress and checkout.",
  supportedPages: ["cart"],
  variants: [{ id: "v1", label: "Lines + totals box" }],
  commonFields: [
    { key: "pageTitle", label: "Page title (for screen readers)", type: "string", default: "Shopping cart" },
    { key: "emptyTitle", label: "Empty cart title", type: "string", default: "Your cart is currently empty." },
    { key: "emptyMessage", label: "Empty cart message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Totals title", type: "string", default: "Cart totals" },
    { key: "subtotalLabel", label: "Subtotal label", type: "string", default: "Subtotal" },
    { key: "shippingLabel", label: "Delivery label", type: "string", default: "Delivery" },
    { key: "shippingCalculatedText", label: "Text when delivery areas are unavailable", type: "string", default: "Delivery charge is added at checkout." },
    { key: "totalLabel", label: "Total label", type: "string", default: "Total" },
    { key: "checkoutButtonText", label: "Checkout button text", type: "string", default: "Proceed to checkout" },
    { key: "checkoutLink", label: "Checkout link", type: "string", default: "/checkout" }
  ]
}, nC = {
  type: "checkout",
  label: "Checkout",
  description: "Billing details, delivery area, payment and order summary with a place-order button.",
  supportedPages: ["checkout"],
  variants: [{ id: "v1", label: "Two columns" }],
  commonFields: [
    { key: "pageTitle", label: "Billing title", type: "string", default: "Billing details" },
    { key: "emptyTitle", label: "Empty cart title", type: "string", default: "Your cart is empty." },
    { key: "emptyMessage", label: "Empty cart message", type: "string" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Return to shop" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order summary title", type: "string", default: "Your order" },
    { key: "subtotalLabel", label: "Subtotal label", type: "string", default: "Subtotal" },
    { key: "deliveryLabel", label: "Delivery label", type: "string", default: "Delivery" },
    { key: "totalLabel", label: "Total label", type: "string", default: "Total" },
    { key: "codLabel", label: "Cash on delivery label", type: "string", default: "Cash on delivery" },
    { key: "codDescription", label: "How to pay (cash on delivery)", type: "localized-text", default: "Pay with cash when your order arrives." },
    { key: "privacyNote", label: "Privacy note", type: "localized-text", help: "Shown above the place-order button. Leave empty for the default note linking to the privacy policy." },
    { key: "placeOrderText", label: "Place order button text", type: "string", default: "Place order" },
    { key: "placingOrderText", label: "Placing order text", type: "string", default: "Placing order…" }
  ]
}, sC = {
  type: "contact",
  label: "Contact",
  description: "Phone, WhatsApp, email and address cards. Empty fields use Store info.",
  supportedPages: ["contact"],
  variants: [{ id: "v1", label: "Contact cards" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Contact us" },
    { key: "description", label: "Intro text", type: "localized-text", default: "Questions about an order or a product? We are happy to help." },
    { key: "phone", label: "Phone (empty: Store info hotline)", type: "string" },
    { key: "email", label: "Email (empty: Store info email)", type: "string" },
    { key: "address", label: "Address (empty: Store info addresses)", type: "text" },
    { key: "hoursText", label: "Opening hours", type: "localized-text" }
  ]
}, cC = {
  type: "content",
  label: "Text / FAQ",
  description: "Policies and other text pages, the home page’s “Read more” article, or questions as cards and an accordion.",
  supportedPages: ["home", "shop", "category", "contact", "privacy-policy", "terms-of-service", "shipping-policy", "return-policy", "track-order"],
  variants: [
    { id: "v1", label: "Text page (readable column)" },
    { id: "v2", label: "Article with “Read more”" },
    { id: "v3", label: "FAQ (two-column cards, then an accordion)" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "subtitle", label: "Subtitle / intro", type: "localized-text", help: "In the article layout this is the part shown before “Read more”." },
    { key: "content", label: "Text", type: "rich-text" },
    {
      key: "faqs",
      label: "Questions and answers",
      type: "array",
      help: "Shown as an accordion under the text (also published as FAQ structured data).",
      itemSchema: [
        { key: "question", label: "Question", type: "string" },
        { key: "answer", label: "Answer", type: "text" }
      ]
    },
    { key: "updatedText", label: "Last updated note", type: "string", placeholder: "Last updated 1 January 2026" }
  ]
}, dC = {
  type: "coupon",
  label: "Coupons",
  description: "Coupon codes with discount, title, description, expiry and a copy button.",
  supportedPages: ["coupon"],
  variants: [{ id: "v1", label: "Code cards" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Coupons" },
    { key: "subtitle", label: "Subtitle", type: "localized-text", default: "Use these codes when you order." },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Code", type: "string" },
        { key: "discount", label: "Discount (e.g. 10% off)", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Conditions", type: "text" },
        { key: "expiryDate", label: "Valid until", type: "string" }
      ]
    },
    { key: "emptyText", label: "Text when there are no coupons", type: "string", default: "No coupons right now. Check back soon." }
  ]
}, pC = {
  type: "order-success",
  label: "Order complete",
  description: "Thank-you message with the order number, date, total, payment and order details.",
  supportedPages: ["order-success"],
  variants: [{ id: "v1", label: "Thank-you card" }],
  commonFields: [
    { key: "title", label: "Thank-you title", type: "localized-string", default: "Thank you. Your order has been received." },
    { key: "message", label: "Thank-you message", type: "localized-text", default: "We will call you to confirm your order before delivery." },
    { key: "errorTitle", label: "Title when the order cannot be loaded", type: "string", default: "Your order was placed." },
    { key: "errorMessage", label: "Message when the order cannot be loaded", type: "string", default: "We could not load the order details on this device, but your order was received." },
    { key: "viewOrderText", label: "View order button text (signed-in shoppers)", type: "string", default: "View order" },
    { key: "continueShoppingText", label: "Continue shopping text", type: "string", default: "Continue shopping" },
    { key: "continueShoppingLink", label: "Continue shopping link", type: "string", default: "/shop" }
  ]
}, uC = {
  type: "signin",
  label: "Sign in",
  description: "Phone number and one-time code card; new shoppers add their name.",
  supportedPages: ["signin", "forgot-password", "reset-password"],
  variants: [{ id: "v1", label: "Card" }],
  commonFields: [
    { key: "title", label: "Title", type: "localized-string", default: "Sign in" },
    { key: "intro", label: "Intro text", type: "localized-text", default: "Use your mobile number. We send you a code by SMS — no password needed." },
    { key: "redirectUrl", label: "Go to after signing in", type: "string", default: "/account" }
  ]
}, yC = {
  type: "signup",
  label: "Sign up",
  description: "Phone number and one-time code card; new shoppers add their name.",
  supportedPages: ["signup"],
  variants: [{ id: "v1", label: "Card" }],
  commonFields: [
    { key: "title", label: "Title", type: "localized-string", default: "Create your account" },
    { key: "intro", label: "Intro text", type: "localized-text", default: "Use your mobile number. We send you a code by SMS — no password needed." },
    { key: "redirectUrl", label: "Go to after signing in", type: "string", default: "/account" }
  ]
}, hC = {
  cart: iC,
  checkout: nC,
  "order-success": pC,
  coupon: dC,
  account: lC,
  signin: uC,
  signup: yC,
  contact: sC,
  content: cC
}, bC = ht({
  ...yt,
  componentSchemas: {
    ...yt.componentSchemas,
    ...rC,
    ...A0,
    ...hC
  },
  headerSchema: I0,
  footerSchema: N0
}, S0), mC = {
  account: { hide: ["signinRedirectPath"] },
  "announcement-bar": { hide: ["bgColor", "textColor"] },
  cart: { hide: ["loadingText", "taxLabel", "secureCheckoutText"] },
  category: { hide: ["productCardVariant", "initialPriceRange", "showBreadcrumb"] },
  checkout: { hide: ["loadingText", "shippingCalculatingText", "securePaymentText"] },
  cta: { hide: ["bgColor"] },
  "featured-category": { hide: ["productCardVariant", "noSelectionText", "noProductsText"] },
  features: { hide: ["bgStyle"] },
  "flash-sale": { hide: ["bgColor", "products"] },
  "new-arrivals": { hide: ["products"] },
  "order-success": { hide: ["loadingText"] },
  "product-detail": { hide: ["loadingText", "notFoundCode", "notFoundText"], keep: ["v1", "v2", "v3", "v6"], variantLabels: { v1: "Standard", v2: "Sale countdown band", v3: "Large photo swatches", v6: "Video under the photo" } },
  "shop-grid": { hide: ["productCardVariant", "initialPriceRange", "sortOldestLabel", "sortNameDescLabel"], keep: ["v1"], variantLabels: { v1: "Showroom: room tiles and filter bar" } },
  "similar-products": { hide: ["productCardVariant"] },
  blog: { keep: ["v1", "v2"] },
  coupon: { hide: ["coupons[].bgColor"] },
  header: { hide: ["topbar[].phone", "topbar[].email", "topbar[].showSocials", "topbar[].socialLinks"] },
  footer: { hide: ["paymentMethods[].icon"] },
  // Theme tab: button settings no part of this theme reads (colours drive every primary button via the CTA).
  buttons: { hide: ["appearance.buttons.primary[].radius", "appearance.buttons.primary[].height", "appearance.buttons.primary[].paddingX", "appearance.buttons.primary[].label", "appearance.buttons.outline[].radius", "appearance.buttons.outline[].height", "appearance.buttons.outline[].paddingX", "appearance.buttons.outline[].label", "appearance.buttons.outline[].hoverBg"] },
  // Delivery time is shown on product cards only by Prottoho.
  "store-info": { hide: ["deliveryEta"] }
}, gC = {
  type: "account",
  label: "Account Section",
  description: "User dashboard with orders, addresses, and profile settings.",
  supportedPages: ["account"],
  variants: [
    { id: "v1", label: "V1 (Sidebar + Content)" },
    { id: "v2", label: "Order History" },
    { id: "v3", label: "Address Book" }
  ],
  commonFields: [
    { key: "tabOverviewLabel", label: "Overview Tab Label", type: "string", default: "Overview" },
    { key: "tabOrdersLabel", label: "Orders Tab Label", type: "string", default: "Orders" },
    { key: "tabAddressesLabel", label: "Addresses Tab Label", type: "string", default: "Addresses" },
    { key: "tabDetailsLabel", label: "Profile Tab Label", type: "string", default: "Profile" },
    { key: "signOutLabel", label: "Sign Out Label", type: "string", default: "Sign Out" },
    { key: "signinRedirectPath", label: "Sign In Redirect Path", type: "string", default: "/signin" }
  ]
}, kn = {
  type: "signin",
  label: "Signin Section",
  description: "Login form with phone/OTP flow and two-column layout.",
  supportedPages: ["signin"],
  variants: [{ id: "v1", label: "V1 (Two Column)" }],
  commonFields: [
    { key: "redirectUrl", label: "Redirect After Login", type: "string", default: "/account" }
  ]
}, wn = {
  type: "signup",
  label: "Signup Section",
  description: "Registration form with phone/OTP flow and two-column layout.",
  supportedPages: ["signup"],
  variants: [{ id: "v2", label: "V2 (Two Column)" }],
  commonFields: [
    { key: "redirectUrl", label: "Redirect After Signup", type: "string", default: "/account" }
  ]
}, Bo = [
  "home",
  "shop",
  "product",
  "category",
  "categories",
  "cart",
  "checkout",
  "contact",
  "signin",
  "signup",
  "account",
  "wishlist",
  "track-order",
  "order-success",
  "privacy-policy",
  "terms-of-service",
  "shipping-policy",
  "return-policy",
  "order-detail"
], wl = [
  { key: "id", label: "ID", type: "string" },
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link", type: "string" }
], fC = [
  { key: "id", label: "ID", type: "string" },
  { key: "label", label: "Label", type: "string" },
  { key: "href", label: "Link URL", type: "string" },
  {
    key: "type",
    label: "Type",
    type: "select",
    options: [
      { label: "Standard Link", value: "link" },
      { label: "Dropdown", value: "dropdown" },
      { label: "Mega Menu", value: "mega-menu" }
    ]
  },
  {
    key: "children",
    label: "Dropdown Items",
    type: "array",
    itemSchema: wl,
    dependency: { field: "type", value: "dropdown" }
  },
  {
    key: "columns",
    label: "Mega Menu Columns",
    type: "array",
    itemSchema: [
      { key: "title", label: "Column Title", type: "string" },
      { key: "items", label: "Links", type: "array", itemSchema: wl }
    ],
    dependency: { field: "type", value: "mega-menu" }
  },
  {
    key: "featuredImage",
    label: "Featured Image",
    type: "object",
    fields: [
      { key: "src", label: "Image", type: "image" },
      { key: "title", label: "Title", type: "string" },
      { key: "href", label: "Link", type: "string" }
    ],
    dependency: { field: "type", value: "mega-menu" }
  }
], Sn = [
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "text" },
  { key: "image", label: "Background Image", type: "image" },
  { key: "ctaText", label: "Button Text", type: "string" },
  { key: "ctaLink", label: "Button Link", type: "string" },
  { key: "badge", label: "Badge Text", type: "string" }
], Oe = [
  {
    key: "styles.paddingTop",
    label: "Padding Top",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.paddingBottom",
    label: "Padding Bottom",
    type: "select",
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "sm" },
      { label: "Medium", value: "md" },
      { label: "Large", value: "lg" },
      { label: "Extra Large", value: "xl" }
    ],
    default: "md"
  },
  {
    key: "styles.background",
    label: "Background",
    type: "select",
    options: [
      { label: "None (theme default)", value: "default" },
      { label: "Light grey", value: "muted" },
      { label: "Brand tint", value: "primary" }
    ],
    default: "default"
  }
], vC = [
  {
    key: "icon",
    label: "Icon (truck | shield | lock)",
    type: "string"
  },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" }
], kC = [
  { key: "image", label: "Background Image", type: "image" },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" },
  { key: "ctaText", label: "Button Text", type: "string" },
  { key: "ctaLink", label: "Button Link", type: "string" }
], wC = {
  type: "banner",
  label: "Banner Section",
  description: "Promo feature strip or side-by-side image banners.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Feature Strip (Free Shipping, etc.)",
      fields: [
        { key: "columns", label: "Feature Columns", type: "array", itemSchema: vC }
      ]
    },
    {
      id: "v2",
      label: "V2 — Two Promo Image Banners",
      fields: [
        { key: "banners", label: "Promo Banners (max 2)", type: "array", itemSchema: kC }
      ]
    }
  ],
  commonFields: [...Oe]
}, SC = {
  type: "cart",
  label: "Cart Section",
  description: "The shopping cart page section.",
  supportedPages: ["cart"],
  variants: [{ id: "v1", label: "V1" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Shopping Cart" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading cart items..." },
    { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty State Message", type: "string", default: "Browse our products and add items to your cart." },
    { key: "continueShoppingText", label: "Continue Shopping Button Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingLabel", label: "Shipping Label", type: "string", default: "Shipping" },
    { key: "shippingCalculatedText", label: "Shipping Calculated Text", type: "string", default: "Calculated at checkout" },
    { key: "taxLabel", label: "Tax Label", type: "string", default: "Tax" },
    { key: "totalLabel", label: "Total Label", type: "string", default: "Total" },
    { key: "checkoutButtonText", label: "Checkout Button Text", type: "string", default: "Proceed to Checkout" },
    { key: "checkoutLink", label: "Checkout Link", type: "string", default: "/checkout" },
    { key: "secureCheckoutText", label: "Secure Checkout Label", type: "string", default: "SSL Secure Checkout" }
  ]
}, xC = {
  type: "categories",
  label: "Shop by room",
  description: "Shop-by-room bento of large category tiles (a grid on the categories page).",
  supportedPages: ["home", "categories", "shop"],
  variants: [{ id: "v1", label: "V1 (Image Grid)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    {
      key: "columns",
      label: "Columns",
      type: "select",
      options: [
        { label: "2 Columns", value: 2 },
        { label: "3 Columns", value: 3 },
        { label: "4 Columns", value: 4 }
      ],
      default: 4
    },
    { key: "emptyText", label: "Empty Text", type: "string", default: "No categories found." },
    ...Oe
  ]
}, TC = {
  type: "category",
  label: "Category Listing",
  description: "Single category page: breadcrumb, header, product grid with filters.",
  supportedPages: ["category", "shop"],
  variants: [{ id: "v1", label: "V1 (Sidebar + Grid)" }],
  commonFields: [
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "initialPriceRange.min", label: "Price Range Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Price Range Max", type: "number", default: 5e4 },
    { key: "showBreadcrumb", label: "Show Breadcrumb", type: "boolean", default: !0 },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...Oe
  ]
}, CC = {
  type: "checkout",
  label: "Checkout Section",
  description: "The order checkout page section.",
  supportedPages: ["checkout"],
  variants: [{ id: "v1", label: "V1" }],
  commonFields: [
    { key: "pageTitle", label: "Page Title", type: "string", default: "Checkout" },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Preparing checkout..." },
    { key: "emptyTitle", label: "Empty Cart Title", type: "string", default: "Your cart is empty" },
    { key: "emptyMessage", label: "Empty Cart Message", type: "string", default: "Checkout is only available for shopping carts with items." },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" },
    { key: "summaryTitle", label: "Order Summary Title", type: "string", default: "Order Summary" },
    { key: "subtotalLabel", label: "Subtotal Label", type: "string", default: "Subtotal" },
    { key: "shippingChargeLabel", label: "Shipping Charge Label", type: "string", default: "Shipping Charge" },
    { key: "shippingCalculatingText", label: "Shipping Calculating Text", type: "string", default: "Calculating..." },
    { key: "totalLabel", label: "Total Amount Label", type: "string", default: "Total Amount" },
    { key: "placeOrderText", label: "Place Order Button Text", type: "string", default: "Place Order" },
    { key: "placingOrderText", label: "Placing Order Loading Text", type: "string", default: "Placing Order..." },
    { key: "securePaymentText", label: "Secure Payment Label", type: "string", default: "SSL Secure Payment" }
  ]
}, PC = {
  type: "contact",
  label: "Contact Section",
  description: "Two-column contact page with form and info panel.",
  supportedPages: ["contact"],
  variants: [{ id: "v1", label: "V1 (Split Layout)" }],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    { key: "email", label: "Email Address", type: "string" },
    { key: "phone", label: "Phone Number", type: "string" },
    { key: "address", label: "Physical Address", type: "text" }
  ]
}, AC = {
  type: "content",
  label: "Content / Policy Section",
  description: "Generic rich-text section for policies and descriptions.",
  supportedPages: ["privacy-policy", "terms-of-service", "shipping-policy", "return-policy"],
  variants: [
    { id: "v1", label: "V1 (Clean Layout)" },
    { id: "v2", label: "V2 (With Table of Contents)" }
  ],
  commonFields: [
    { key: "title", label: "Title", type: "string" },
    { key: "content", label: "HTML Content", type: "rich-text" }
  ]
}, LC = {
  type: "featured-category",
  label: "Featured Category",
  description: "Display products from a specific category on the home page.",
  supportedPages: ["home", "product", "cart"],
  variants: [{ id: "v1", label: "V1 (Product Grid)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "subtitle", label: "Subtitle", type: "string" },
    { key: "categoryId", label: "Select Category", type: "category-select" },
    { key: "rows", label: "Number of Rows", type: "number", default: 1 },
    { key: "viewAllText", label: "View All Button Text", type: "string", default: "View All" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "noSelectionText", label: "No Category Selected Text", type: "string", default: "Please select a category in the editor settings." },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    ...Oe
  ]
}, MC = {
  type: "floating-buttons",
  label: "Floating Buttons",
  description: "Global floating buttons for quick actions (Call, WhatsApp, Messenger).",
  supportedPages: [...Bo],
  variants: [{ id: "v1", label: "Default" }],
  commonFields: [
    { key: "active", label: "Enable Floating Buttons", type: "boolean", default: !0 },
    { key: "phone", label: "Phone Number", type: "string", placeholder: "+8801..." },
    { key: "whatsapp", label: "WhatsApp Number", type: "string", placeholder: "+8801..." },
    { key: "messenger", label: "Messenger ID/Link", type: "string", placeholder: "m.me/..." },
    { key: "callUsTitle", label: "Call Button Tooltip", type: "string", default: "Call Us" },
    { key: "whatsappTitle", label: "WhatsApp Button Tooltip", type: "string", default: "WhatsApp" },
    { key: "messengerTitle", label: "Messenger Button Tooltip", type: "string", default: "Messenger" }
  ]
}, NC = {
  type: "footer",
  label: "Footer",
  description: "Site-wide footer with links, newsletter, and contact info.",
  supportedPages: [...Bo],
  variants: [
    { id: "v1", label: "Dark (Default)" },
    { id: "v2", label: "Light" }
  ],
  commonFields: [
    { key: "logo", label: "Footer Logo", type: "image" },
    { key: "title", label: "Brand Name", type: "string", default: "Shegun" },
    {
      key: "description",
      label: "Brand Description",
      type: "text",
      default: "Solid wood furniture for Bangladeshi homes: segun, mehogoni and gamari, made to last and delivered to your door."
    },
    {
      key: "columns",
      label: "Link Columns",
      type: "array",
      itemSchema: [
        { key: "title", label: "Column Title", type: "string" },
        { key: "links", label: "Links", type: "array", itemSchema: wl }
      ]
    },
    {
      key: "socialLinks",
      label: "Social Links",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Facebook", value: "facebook" },
            { label: "Instagram", value: "instagram" },
            { label: "Twitter", value: "twitter" },
            { label: "YouTube", value: "youtube" },
            { label: "LinkedIn", value: "linkedin" }
          ]
        },
        { key: "href", label: "Link", type: "string" }
      ]
    },
    { key: "contactAddress", label: "Address", type: "string" },
    { key: "contactPhone", label: "Phone", type: "string" },
    { key: "contactEmail", label: "Email", type: "string" },
    { key: "copyright", label: "Copyright Text", type: "string", default: "© 2025 Shegun. All rights reserved." },
    {
      key: "paymentMethods",
      label: "Payment Methods",
      type: "array",
      itemSchema: [
        {
          key: "platform",
          label: "Platform",
          type: "select",
          options: [
            { label: "Visa", value: "visa" },
            { label: "Mastercard", value: "mastercard" },
            { label: "Amex", value: "amex" },
            { label: "Stripe", value: "stripe" },
            { label: "PayPal", value: "paypal" },
            { label: "bKash", value: "bkash" },
            { label: "Nagad", value: "nagad" },
            { label: "Rocket", value: "rocket" }
          ]
        },
        { key: "icon", label: "Icon URL (optional)", type: "string" }
      ]
    }
  ]
}, xn = {
  type: "header",
  label: "Header",
  description: "Site-wide header with navigation, search, and cart.",
  supportedPages: [...Bo],
  variants: [
    { id: "v1", label: "Default" },
    { id: "v2", label: "Electronics" },
    { id: "v3", label: "Beauty / Minimal" },
    { id: "v4", label: "Jewelry / Elegant" }
  ],
  commonFields: [
    { key: "logo.alt", label: "Logo Alt Text", type: "string" },
    { key: "logo.src", label: "Logo Image", type: "image" },
    { key: "sticky", label: "Sticky Header", type: "boolean", default: !0 },
    {
      key: "topbar",
      label: "Top Bar",
      type: "object",
      fields: [
        { key: "active", label: "Enable Top Bar", type: "boolean", default: !0 },
        {
          key: "variant",
          label: "Variant",
          type: "select",
          options: [
            { label: "V1 (Centered Promo)", value: "v1" },
            { label: "V2 (Contact & Socials)", value: "v2" }
          ],
          default: "v1"
        },
        { key: "text", label: "Announcement Text", type: "string" },
        { key: "phone", label: "Phone Number", type: "string" },
        { key: "email", label: "Email Address", type: "string" },
        { key: "showSocials", label: "Show Social Icons", type: "boolean", default: !0 },
        {
          key: "socialLinks",
          label: "Social Links",
          type: "array",
          itemSchema: [
            { key: "platform", label: "Platform", type: "string" },
            { key: "href", label: "Link", type: "string" },
            { key: "icon", label: "Icon Name", type: "string" }
          ]
        },
        { key: "links", label: "Top Bar Links", type: "array", itemSchema: wl }
      ]
    },
    {
      key: "actions",
      label: "Actions",
      type: "object",
      fields: [
        { key: "showSearch", label: "Show Search", type: "boolean", default: !0 },
        { key: "showCart", label: "Show Cart", type: "boolean", default: !0 },
        { key: "showAccount", label: "Show Account", type: "boolean", default: !0 },
        { key: "showWishlist", label: "Show Wishlist", type: "boolean", default: !0 },
        {
          key: "cartAction",
          label: "Cart Action",
          type: "select",
          options: [
            { label: "Slide-out Sidebar", value: "sidebar" },
            { label: "Go to Page", value: "page" }
          ],
          default: "sidebar"
        }
      ]
    },
    {
      key: "searchConfig",
      label: "Search Settings",
      type: "object",
      fields: [
        { key: "showPrice", label: "Show Price in Suggestions", type: "boolean", default: !0 },
        { key: "showCategory", label: "Show Category in Suggestions", type: "boolean", default: !0 },
        { key: "showImage", label: "Show Image in Suggestions", type: "boolean", default: !0 },
        { key: "maxResults", label: "Max Suggestions", type: "number", default: 6 }
      ]
    },
    { key: "menu", label: "Main Menu", type: "array", itemSchema: fC }
  ]
}, gd = [
  ...Sn,
  { key: "room", label: "Room tab label", type: "string", help: "e.g. Bedroom. Falls back to the slide title." },
  { key: "productId", label: "Product in this room", type: "product-select", help: "Shown as a card on the photo. Hidden until a product is picked." }
], EC = {
  type: "hero",
  label: "Hero Section",
  description: "The main attention-grabbing section at the top of the page.",
  supportedPages: ["home", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Room scene",
      fields: [
        { key: "slides", label: "Slides (one per room)", type: "array", itemSchema: gd },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    },
    {
      id: "v2",
      label: "V2 — Split with badge panel",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: Sn },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: !0 },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5e3 }
      ]
    },
    {
      id: "v3",
      label: "V3 — Collage",
      fields: [
        { key: "slides", label: "Slides (the next two fill the side tiles)", type: "array", itemSchema: Sn }
      ]
    },
    {
      id: "v4",
      label: "V4 — Shondhya (dark room scene)",
      fields: [
        { key: "slides", label: "Slides (one per room)", type: "array", itemSchema: gd }
      ]
    }
  ],
  commonFields: [...Oe]
}, DC = {
  type: "order-success",
  label: "Order Success Section",
  description: "The order confirmation page section.",
  supportedPages: ["order-success"],
  variants: [{ id: "v1", label: "V1" }],
  commonFields: [
    { key: "title", label: "Success Title", type: "string", default: "Order Confirmed" },
    { key: "message", label: "Success Message", type: "text", default: "Your order has been placed successfully. We have sent a confirmation email with your order details." },
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading order details..." },
    { key: "errorTitle", label: "Error Title", type: "string", default: "Order Not Found" },
    { key: "errorMessage", label: "Error Message", type: "string", default: "We could not find the order you are looking for." },
    { key: "viewOrderText", label: "View Order Button Text", type: "string", default: "View Order Status" },
    { key: "viewOrderLink", label: "View Order Link", type: "string", default: "/account/orders" },
    { key: "continueShoppingText", label: "Continue Shopping Text", type: "string", default: "Continue Shopping" },
    { key: "continueShoppingLink", label: "Continue Shopping Link", type: "string", default: "/shop" }
  ]
}, Tn = {
  type: "product-detail",
  label: "Product Detail",
  description: "The main product information page section.",
  supportedPages: ["product"],
  variants: [
    { id: "v1", label: "V1 (Standard)" },
    { id: "v2", label: "V2 (With Countdown Timer)" },
    { id: "v3", label: "V3 (With Color/Size Swatches)" },
    { id: "v4", label: "Countdown Sale" },
    { id: "v5", label: "Swatches" },
    { id: "v6", label: "Video Gallery" }
  ],
  commonFields: [
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading..." },
    { key: "notFoundCode", label: "Not Found Code", type: "string", default: "404" },
    { key: "notFoundText", label: "Not Found Text", type: "string", default: "Product Not Found" },
    { key: "quantityLabel", label: "Quantity Label", type: "string", default: "Quantity" },
    { key: "addToCartText", label: "Add to Cart Button Text", type: "string", default: "Add to Cart" },
    { key: "orderNowText", label: "Order Now Button Text", type: "string", default: "Buy Now" },
    { key: "productDescTitle", label: "Product Description Accordion Title", type: "string", default: "Product Description" },
    { key: "returnPolicyTitle", label: "Return Policy Accordion Title", type: "string", default: "Return Policy" },
    { key: "countdownLabel", label: "Countdown Label (V2 only)", type: "string", default: "Offer ends in:" },
    { key: "saleEndDate", label: "Sale End Date", type: "string", placeholder: "2025-12-31T23:59:59" },
    { key: "videoUrl", label: "Product Video URL", type: "string", placeholder: "https://..." },
    ...Oe
  ]
}, FC = {
  type: "mobileBottomNav",
  label: "Mobile Navigation",
  description: "Bottom navigation bar for mobile devices.",
  supportedPages: [...Bo],
  variants: [{ id: "v1", label: "V1 (Default)" }],
  commonFields: [
    { key: "active", label: "Show Bottom Nav", type: "boolean" },
    {
      key: "items",
      label: "Nav Items",
      type: "array",
      itemSchema: [
        { key: "label", label: "Label", type: "string" },
        {
          key: "icon",
          label: "Icon Type",
          type: "select",
          options: [
            { label: "Home", value: "home" },
            { label: "Shop (Cart)", value: "shop" },
            { label: "Search", value: "search" },
            { label: "Cart", value: "cart" },
            { label: "User / Account", value: "account" },
            { label: "Heart / Wishlist", value: "heart" },
            { label: "Menu / Hamburger", value: "menu" },
            { label: "Plus / Create", value: "plus" }
          ]
        },
        {
          key: "actionType",
          label: "Action Type",
          type: "select",
          options: [
            { label: "Link (Direct URL)", value: "link" },
            { label: "Open Search Drawer", value: "search" },
            { label: "Open Categories Sidebar", value: "categories" }
          ]
        },
        { key: "href", label: "Target URL", type: "string" },
        { key: "isPrimary", label: "Highlight as Primary (Middle)", type: "boolean" }
      ]
    }
  ]
}, IC = {
  type: "similar-products",
  label: "Similar Products",
  description: "A row of related products shown on the product page.",
  supportedPages: ["product"],
  variants: [{ id: "v1", label: "V1 (Grid Row)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Similar Products" },
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    ...Oe
  ]
}, OC = {
  type: "shop-grid",
  label: "Shop Grid",
  description: "Showroom listing: room tiles, a filter bar with quick sort chips and a three-up grid.",
  supportedPages: ["shop", "category", "cart", "checkout", "categories"],
  variants: [
    { id: "v1", label: "V1 (Showroom: room tiles and filter bar)" },
    { id: "v2", label: "V2 (Same showroom layout)" }
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string" },
    { key: "description", label: "Description", type: "text" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1"
    },
    { key: "initialPriceRange.min", label: "Initial Price Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Initial Price Max", type: "number", default: 5e4 },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "allCategoriesLabel", label: "All Categories Label", type: "string", default: "All" },
    { key: "filtersButtonLabel", label: "Filters Button Label", type: "string", default: "Filters" },
    { key: "showingLabel", label: "Showing Label (prefix)", type: "string", default: "Showing" },
    { key: "productsSuffix", label: "Products Count Suffix", type: "string", default: "Products" },
    { key: "sortNewestLabel", label: "Sort: Newest Label", type: "string", default: "Sort: Newest" },
    { key: "sortOldestLabel", label: "Sort: Oldest Label", type: "string", default: "Sort: Oldest" },
    { key: "sortPriceAscLabel", label: "Sort: Price Low-High Label", type: "string", default: "Price: Low to High" },
    { key: "sortPriceDescLabel", label: "Sort: Price High-Low Label", type: "string", default: "Price: High to Low" },
    { key: "sortNameAscLabel", label: "Sort: Name A-Z Label", type: "string", default: "Name: A-Z" },
    { key: "sortNameDescLabel", label: "Sort: Name Z-A Label", type: "string", default: "Name: Z-A" },
    { key: "activeFiltersLabel", label: "Active Filters Label", type: "string", default: "Active Filters:" },
    { key: "clearAllLabel", label: "Clear All Label", type: "string", default: "Clear All" },
    { key: "noProductsTitle", label: "No Products Title", type: "string", default: "No Products Found" },
    { key: "noProductsMessage", label: "No Products Message", type: "string", default: "We couldn't find any products matching your current filters." },
    { key: "backToAllText", label: "Back to All Products Text", type: "string", default: "Back to All Products" },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "currentSearchLabel", label: "Current Search Label", type: "string", default: "Current Search" },
    { key: "clearSearchLabel", label: "Clear Search Label", type: "string", default: "Clear" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...Oe
  ]
}, RC = {
  type: "wishlist",
  label: "Wishlist Section",
  description: "Displays saved/wishlisted products in a grid layout.",
  supportedPages: ["wishlist"],
  variants: [
    {
      id: "v1",
      label: "V1 (Grid)",
      fields: [
        { key: "title", label: "Page Title", type: "string", default: "My Wishlist" },
        { key: "subtitle", label: "Eyebrow Text", type: "string", default: "Saved items" },
        { key: "emptyTitle", label: "Empty State Title", type: "string", default: "Nothing saved yet" },
        { key: "emptyText", label: "Empty State Description", type: "string", default: "Start exploring and save the items you love." },
        { key: "continueShoppingText", label: "CTA Text", type: "string", default: "Start Shopping" },
        { key: "continueShoppingLink", label: "CTA Link", type: "string", default: "/shop" }
      ]
    }
  ],
  commonFields: []
}, BC = [
  { key: "text", label: "Message Text", type: "string" },
  { key: "code", label: "Coupon Code (optional)", type: "string" }
], zC = {
  type: "announcement-bar",
  label: "Announcement Bar",
  description: "A still showroom line: each message after a check mark, spread across the page.",
  supportedPages: [
    "home",
    "shop",
    "product",
    "category",
    "categories",
    "cart",
    "checkout",
    "contact",
    "wishlist"
  ],
  variants: [
    {
      id: "v1",
      label: "V1 — Showroom line",
      fields: [
        { key: "items", label: "Announcement Items", type: "array", itemSchema: BC },
        { key: "bgColor", label: "Background Color", type: "string", default: "#0989FF" },
        { key: "textColor", label: "Text Color", type: "string", default: "#ffffff" }
      ]
    }
  ],
  commonFields: [...Oe]
}, VC = [
  { key: "id", label: "Product ID", type: "string" },
  { key: "name", label: "Product Name", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "originalPrice", label: "Original Price", type: "number" },
  { key: "salePrice", label: "Sale Price", type: "number" },
  { key: "discount", label: "Discount %", type: "number" }
], WC = {
  type: "flash-sale",
  label: "Flash Sale",
  description: "Sale panel with a countdown beside the three most discounted products.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "V1 — Split sale panel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Flash Sale" },
        { key: "endDate", label: "Sale End Date (ISO)", type: "string", placeholder: "2025-12-31T23:59:59" },
        { key: "bgColor", label: "Header Background Color", type: "color", default: "#1a1a2e" },
        { key: "products", label: "Products", type: "array", itemSchema: VC }
      ]
    }
  ],
  commonFields: [...Oe]
}, $C = [
  { key: "id", label: "Product ID", type: "string" },
  { key: "name", label: "Product Name", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "price", label: "Price", type: "number" },
  { key: "originalPrice", label: "Original Price", type: "number" },
  { key: "badge", label: "Badge Text", type: "string" }
], _C = {
  type: "new-arrivals",
  label: "New Arrivals",
  description: "Horizontal carousel showcasing the latest product arrivals.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "V1 — Embla Carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Fresh styles just landed" },
        { key: "products", label: "Products", type: "array", itemSchema: $C },
        { key: "slidesPerView", label: "Slides Per View", type: "number", default: 4 }
      ]
    }
  ],
  commonFields: [...Oe]
}, HC = {
  type: "offer-banner",
  label: "Offer Banner",
  description: "Full-width promotional banner with background image and text overlay.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "V1 — Full-Width Promo Banner",
      fields: [
        { key: "image", label: "Background Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "Special Offer" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Get up to 50% off on selected items" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        { key: "overlayOpacity", label: "Overlay Opacity (0–100)", type: "number", default: 50 }
      ]
    }
  ],
  commonFields: [...Oe]
}, Cn = {
  type: "lookbook-banner",
  label: "Lookbook Banner",
  description: "Lookbook — room scene with a shop-the-look card (V1) or full-width overlay (V2).",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "V1 — Room scene",
      fields: [
        { key: "image", label: "Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The New Collection" },
        { key: "subtitle", label: "Subtitle", type: "text" },
        { key: "ctaText", label: "Button Text", type: "string", default: "View Lookbook" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        {
          key: "imagePosition",
          label: "Photo subject side",
          help: "The shop-the-look card sits on the other side.",
          type: "select",
          options: [
            { label: "Left", value: "left" },
            { label: "Right", value: "right" }
          ],
          default: "left"
        }
      ]
    },
    {
      id: "v2",
      label: "V2 — Full-Width Collection Banner",
      fields: [
        { key: "image", label: "Background Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The Collection" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Discover the new season" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        { key: "overlayOpacity", label: "Overlay Opacity (0–100)", type: "number", default: 40 }
      ]
    }
  ],
  commonFields: [...Oe]
}, Jr = [
  { key: "image", label: "Image", type: "image" },
  { key: "link", label: "Link URL", type: "string" }
], UC = {
  type: "instagram-feed",
  label: "Instagram Feed",
  description: "Display a grid of Instagram photos with hover effects.",
  supportedPages: [...Bo],
  variants: [
    {
      id: "v1",
      label: "V1 — 5-Column Photo Grid",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle (e.g. @shegun)", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Jr }
      ]
    },
    {
      id: "v2",
      label: "V2 — 6-Column with Handle Overlay",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Jr }
      ]
    },
    {
      id: "v3",
      label: "V3 — 4-Column Large Tiles",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Jr }
      ]
    },
    {
      id: "v4",
      label: "V4 — Masonry Style with Header",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: Jr }
      ]
    }
  ],
  commonFields: [...Oe]
}, fd = [
  { key: "title", label: "Title", type: "string" },
  { key: "image", label: "Image", type: "image" },
  { key: "excerpt", label: "Excerpt", type: "text" },
  { key: "slug", label: "Slug", type: "string" },
  { key: "date", label: "Date", type: "string" },
  { key: "category", label: "Category", type: "string" }
], GC = {
  type: "blog",
  label: "Blog Posts",
  description: "Display a grid or list of blog post cards.",
  supportedPages: [...Bo],
  variants: [
    {
      id: "v1",
      label: "V1 — 3-column card grid",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: fd },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: !0 }
      ]
    },
    {
      id: "v2",
      label: "V2 — List Style (Electronics Style)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: fd },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: !0 }
      ]
    },
    {
      id: "v3",
      label: "Article Detail",
      fields: []
    }
  ],
  commonFields: [
    { key: "source", label: "Posts to show", type: "select", options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." },
    ...Oe
  ]
}, wi = [
  {
    key: "icon",
    label: "Icon",
    type: "select",
    options: [
      { label: "Shipping Truck", value: "shipping" },
      { label: "Return Arrow", value: "refund" },
      { label: "Support Headset", value: "support" },
      { label: "Security Lock", value: "secure" },
      { label: "Gift Box", value: "gift" }
    ],
    default: "shipping"
  },
  { key: "title", label: "Title", type: "string" },
  { key: "subtitle", label: "Subtitle", type: "string" }
], YC = {
  type: "features",
  label: "Features Strip",
  description: "Trust-building feature strip showing shipping, returns, support, and security highlights.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Compact Horizontal Strip",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: wi },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (Light Gray)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" }
          ],
          default: "default"
        }
      ]
    },
    {
      id: "v2",
      label: "V2 — Spaced Cards",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: wi },
        {
          key: "bgStyle",
          label: "Background Style",
          type: "select",
          options: [
            { label: "Default (White)", value: "default" },
            { label: "Bordered", value: "bordered" },
            { label: "Transparent", value: "transparent" }
          ],
          default: "default"
        }
      ]
    },
    {
      id: "v3",
      label: "V3 — Jewelry Minimal Centered",
      fields: [
        { key: "items", label: "Feature Items", type: "array", itemSchema: wi }
      ]
    }
  ],
  commonFields: [...Oe]
}, vd = [
  { key: "avatar", label: "Avatar Image", type: "image" },
  { key: "name", label: "Name", type: "string" },
  { key: "designation", label: "Designation", type: "string" },
  { key: "review", label: "Review Text", type: "text" },
  { key: "rating", label: "Rating (1–5)", type: "number", default: 5 }
], XC = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer reviews and social proof section.",
  supportedPages: ["home", "shop"],
  variants: [
    {
      id: "v1",
      label: "V1 — Centered Slider",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "What Our Customers Say" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: vd }
      ]
    },
    {
      id: "v2",
      label: "V2 — Card Grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Customer Reviews" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: vd }
      ]
    }
  ],
  commonFields: [...Oe]
}, jC = {
  type: "cta",
  label: "Call to Action",
  description: "Rounded sage newsletter panel: headline and line beside an email field.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Newsletter panel",
      fields: [
        { key: "title", label: "Heading", type: "string", default: "Subscribe to Our Newsletter" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Get exclusive deals and new arrivals straight to your inbox." },
        { key: "placeholder", label: "Input Placeholder", type: "string", default: "Enter your email address" },
        { key: "buttonText", label: "Button Text", type: "string", default: "Subscribe" },
        { key: "bgColor", label: "Background Color", type: "color" }
      ]
    }
  ],
  commonFields: [...Oe]
}, qC = [
  { key: "logo", label: "Logo Image", type: "image" },
  { key: "name", label: "Brand Name", type: "string" },
  { key: "link", label: "Brand URL", type: "string" }
], ZC = {
  type: "brands",
  label: "Brand Logos",
  description: "Display partner or brand logos in a grid or auto-scrolling ticker.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Logo Grid / Ticker",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        {
          key: "layout",
          label: "Layout",
          type: "select",
          options: [
            { label: "Grid", value: "grid" },
            { label: "Auto-scroll Ticker", value: "ticker" }
          ],
          default: "grid"
        },
        { key: "items", label: "Brand Items", type: "array", itemSchema: qC }
      ]
    }
  ],
  commonFields: [...Oe]
}, JC = [
  { key: "label", label: "Tab Label", type: "string" }
], KC = {
  type: "product-slider",
  label: "Product Slider",
  description: "A horizontal scrolling product carousel with optional tabs.",
  supportedPages: ["home", "category", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Tabbed carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Featured Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "All Product Shop" },
        { key: "tabs", label: "Tabs", type: "array", itemSchema: JC }
      ]
    },
    {
      id: "v2",
      label: "V2 — Simple Jewelry Carousel (3-4 cols)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Exquisite Collection" }
      ]
    },
    {
      id: "v3",
      label: "V3 — Beauty Product Carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Skincare & Beauty" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Glow Up Collection" }
      ]
    }
  ],
  commonFields: [...Oe]
}, QC = {
  type: "product-grid",
  label: "Product Grid",
  description: "A product grid section with multiple layout variants.",
  supportedPages: ["home", "category", "categories", "shop"],
  variants: [
    {
      id: "v1",
      label: "V1 — 4-column grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "All Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Customer Favorite Style" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v2",
      label: "V2 — Featured + List Aside (Week's Featured)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Week's Featured" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Top Picks" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v3",
      label: "V3 — Electronics List View + Sidebar",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Trending Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Electronics" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v4",
      label: "V4 — Gadget Showcase (1 Large + Smaller Cards)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Top Gadgets" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "New Arrivals" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v5",
      label: "V5 — Beauty 4-Col Image-Focused",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Beauty Essentials" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Trending Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" }
      ]
    },
    {
      id: "v6",
      label: "V6 — Trending List + Special Offer with Countdown",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "This Week's Picks" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Hot Right Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" },
        { key: "offerEndsAt", label: "Offer End Date (ISO string)", type: "string" }
      ]
    }
  ],
  commonFields: [...Oe]
}, eP = {
  type: "compare",
  label: "Product Comparison",
  description: "Up to 4 pieces side by side: room photo, name, category and brand, price with the saving and lowest price, EMI per month, W × D × H drawn to one scale, wood, finish, warranty and every other attribute, with a show-differences-only switch, add to cart and remove.",
  supportedPages: ["compare"],
  variants: [
    {
      id: "v1",
      label: "Table"
    }
  ],
  commonFields: [...Oe]
}, tP = {
  type: "coupon",
  label: "Coupons",
  description: "A grid of coupon cards with discount code, title, description, expiry date, and a copy-to-clipboard button.",
  supportedPages: ["coupon"],
  variants: [
    {
      id: "v1",
      label: "Card Grid"
    }
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Available Coupons" },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Coupon Code", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Description", type: "text" },
        { key: "expiryDate", label: "Expiry Date", type: "string" },
        { key: "discount", label: "Discount (e.g. 20% or Free Shipping)", type: "string" },
        { key: "bgColor", label: "Badge Background Color", type: "color" }
      ]
    },
    ...Oe
  ]
}, aP = {
  type: "recent-products",
  label: "Recently Viewed Products",
  description: "A horizontal slider of products the visitor has recently viewed (stored in localStorage — no API call).",
  supportedPages: ["home", "shop", "product", "category", "cart"],
  variants: [{ id: "v1", label: "V1 (Horizontal Slider)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Recently Viewed" }
  ]
}, oP = {
  key: "messages",
  label: "Marquee messages",
  type: "array",
  help: "Scroll across the top in a loop. Without messages the announcement text is used.",
  itemSchema: [
    { key: "text", label: "Text", type: "localized-string" },
    { key: "link", label: "Link", type: "string" }
  ]
}, rP = { key: "badge", label: "Badge", type: "string", placeholder: "New", help: "Small label next to the item." }, lP = { key: "searchPlaceholder", label: "Search label", type: "string", placeholder: "Search" }, iP = (e) => [
  ...e.map((t) => t.key === "type" && t.options && !t.options.some((a) => a.value === "categories") ? { ...t, options: [...t.options, { label: "Shop panel (store categories)", value: "categories" }] } : t),
  rP
], nP = {
  ...xn,
  variants: [
    { id: "v1", label: "Showroom (utility bar, menu centred, search field)" },
    { id: "v2", label: "Showroom" },
    { id: "v3", label: "Showroom" },
    { id: "v4", label: "Compact showroom (shorter bar)" }
  ],
  commonFields: xn.commonFields.flatMap((e) => e.key === "topbar" && e.fields ? [{ ...e, fields: [...e.fields, oP] }] : e.key === "menu" && e.itemSchema ? [{ ...e, itemSchema: iP(e.itemSchema) }] : e.key === "actions" ? [e, lP] : [e])
}, Qa = ["home", "shop", "category", "categories", "product", "cart", "blog"], sP = ["truck", "cash", "phone", "shield", "star", "heart", "package", "check", "store", "map-pin", "mail", "sparkle", "clock", "bag", "user", "search", "refresh", "lock", "tag"].map((e) => ({ label: e.replace("-", " "), value: e })), eo = (e = {}) => [
  { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: e.eyebrow ?? "", help: "Small line above the title." },
  { key: "title", label: "Title", type: "localized-string", default: e.title ?? "" },
  { key: "subtitle", label: "Subtitle", type: "localized-text", default: e.subtitle ?? "" }
], au = [
  { key: "icon", label: "Icon", type: "icon", default: "check", options: sP },
  { key: "title", label: "Title", type: "localized-string" },
  { key: "body", label: "Text", type: "localized-text" }
], cP = {
  type: "banner-carousel",
  label: "Banner carousel",
  description: "Picture slides (their text is part of the image) crossfading in a square frame, with counter, arrows and pause.",
  supportedPages: ["home", "shop", "category", "categories"],
  variants: [{ id: "v1", label: "Crossfading slides" }],
  commonFields: [
    { key: "title", label: "Name for screen readers", type: "string", default: "Offers" },
    {
      key: "slides",
      label: "Slides",
      type: "array",
      itemSchema: [
        { key: "image", label: "Picture", type: "image", required: !0, help: "Square, about 1200 × 1200 px." },
        { key: "mobileImage", label: "Phone picture", type: "image", help: "Optional." },
        { key: "alt", label: "Picture description", type: "string", help: "What the banner says, for screen readers." },
        { key: "link", label: "Link", type: "string", placeholder: "/shop" }
      ],
      default: []
    },
    { key: "autoplay", label: "Play automatically", type: "boolean", default: !0 },
    { key: "autoplaySeconds", label: "Seconds per slide", type: "number", default: 5, dependency: { field: "autoplay", value: !0 } }
  ]
}, dP = {
  type: "category-bento",
  label: "Category mosaic",
  description: "Photo tiles linking to categories: the tiles you list, else the store’s categories.",
  supportedPages: Qa,
  variants: [
    { id: "v1", label: "V1 — Row of photo tiles" },
    { id: "v2", label: "V2 — Lookbook mosaic (first tile large)" }
  ],
  commonFields: [
    ...eo({ eyebrow: "Browse", title: "Shop by room" }),
    {
      key: "tiles",
      label: "Tiles",
      type: "array",
      help: "Empty = the store’s categories.",
      itemSchema: [
        { key: "categoryId", label: "Category", type: "category-select", help: "Sets the link, name and picture unless filled below." },
        { key: "title", label: "Name", type: "localized-string" },
        { key: "tagline", label: "Tagline (mosaic)", type: "localized-string" },
        { key: "image", label: "Picture", type: "image" },
        { key: "link", label: "Link", type: "string", placeholder: "/category/…" }
      ],
      default: []
    },
    { key: "limit", label: "Categories shown (automatic tiles)", type: "number", default: 8 }
  ]
}, pP = {
  type: "combo-spotlight",
  label: "Product spotlight",
  description: "One product or bundle as an editorial spread: large photo, price, saving and Add to cart.",
  supportedPages: Qa,
  variants: [{ id: "v1", label: "Editorial spread" }],
  commonFields: [
    ...eo({ eyebrow: "Showroom pick", title: "Piece of the week" }),
    { key: "productId", label: "Product", type: "product-select", help: "Hidden until a product is picked." },
    { key: "description", label: "Text", type: "localized-text", default: "" },
    { key: "mrpLabel", label: "Regular price label", type: "localized-string", default: "Regular price" },
    { key: "savingLabel", label: "Saving label", type: "localized-string", default: "You save" },
    { key: "detailsLabel", label: "Details link text", type: "localized-string", default: "View details" }
  ]
}, uP = {
  type: "corporate-band",
  label: "Bulk order band",
  description: "An ink band with a short pitch and one button, e.g. for team, event or wholesale orders.",
  supportedPages: Qa,
  variants: [{ id: "v1", label: "Ink band" }],
  commonFields: [
    ...eo({ eyebrow: "For offices", title: "Office and project orders" }).filter((e) => e.key !== "subtitle"),
    { key: "text", label: "Text", type: "localized-text", default: "Furnishing an office, a hotel or a new flat? Get project pricing and custom sizes." },
    { key: "cta.label", label: "Button text", type: "localized-string", default: "Contact us" },
    { key: "cta.url", label: "Button link", type: "string", default: "/contact" }
  ]
}, yP = {
  type: "product-rail",
  label: "Product rail",
  description: "Product cards from new arrivals, deals, a category or your own pick, as a grid or a swipe row.",
  supportedPages: Qa,
  variants: [{ id: "v1", label: "Product cards" }],
  commonFields: [
    ...eo({ eyebrow: "From the workshop", title: "New arrivals" }),
    { key: "source", label: "Products", type: "product-source", default: { source: "new", limit: 8 } },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [
        { label: "Grid (four up)", value: "grid" },
        { label: "Swipe row", value: "rail" }
      ],
      default: "grid"
    },
    { key: "showViewAll", label: "Show “View all”", type: "boolean", default: !0 },
    { key: "viewAllLabel", label: "“View all” text", type: "string", default: "View all", dependency: { field: "showViewAll", value: !0 } }
  ]
}, hP = {
  type: "promises",
  label: "Promises strip",
  description: "Two to four store promises in a hairline-ruled row: icon, title and a short line.",
  supportedPages: Qa,
  variants: [{ id: "v1", label: "Ruled row" }],
  commonFields: [
    ...eo(),
    {
      key: "items",
      label: "Promises",
      type: "array",
      itemSchema: au,
      default: [
        { icon: "truck", title: "Fast delivery", body: "Quick delivery across the city." },
        { icon: "cash", title: "Pay on delivery", body: "Pay in cash when your order arrives." },
        { icon: "refresh", title: "Easy returns", body: "Wrong size? Swap it within 7 days." },
        { icon: "phone", title: "Here to help", body: "Call or message us any day." }
      ]
    }
  ]
}, bP = {
  type: "reviews",
  label: "Customer reviews",
  description: "A swipe row of quote cards: rating, title, quote, name and the product. Store reviews replace these once available.",
  supportedPages: Qa,
  variants: [{ id: "v1", label: "Quote cards" }],
  commonFields: [
    ...eo({ eyebrow: "Reviews", title: "What our customers say" }),
    {
      key: "items",
      label: "Reviews",
      type: "array",
      help: "Real reviews from your customers, with their permission.",
      itemSchema: [
        { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
        { key: "title", label: "Title", type: "localized-string" },
        { key: "body", label: "Review", type: "localized-text" },
        { key: "name", label: "Customer name", type: "string" },
        { key: "productId", label: "Product", type: "product-select" }
      ],
      default: []
    },
    { key: "limit", label: "Most reviews shown", type: "number", default: 6 },
    { key: "minRating", label: "Lowest rating shown (store reviews)", type: "number", default: 4 }
  ]
}, mP = [
  ...au,
  { key: "swatch", label: "Wood colour (materials)", type: "color", help: "Shown as a swatch on the comparison card." },
  { key: "note", label: "Facts line (materials)", type: "localized-string", placeholder: "Hardness: very high · Price: ৳৳৳", help: "Separate facts with ·" },
  { key: "link", label: "Link (materials)", type: "string", placeholder: "/shop?search=segun" }
], gP = {
  type: "story",
  label: "Story band",
  description: "A 4:5 photo beside the heading and two to four numbered points, with an optional button.",
  supportedPages: Qa,
  variants: [{ id: "v1", label: "Photo and numbered points" }, { id: "v2", label: "Materials comparison" }],
  commonFields: [
    ...eo({ eyebrow: "Our story", title: "Made from wood that lasts generations" }),
    { key: "image", label: "Picture", type: "image", help: "Portrait, 4:5." },
    {
      key: "points",
      label: "Points",
      type: "array",
      itemSchema: mP,
      default: [
        { icon: "sparkle", title: "Seasoned hardwood", body: "Kiln-dried segun and mehogoni that does not warp in the monsoon." },
        { icon: "shield", title: "Five-year warranty", body: "Joints and frames covered, with free service visits in Dhaka." },
        { icon: "truck", title: "Delivered and assembled", body: "Our own team carries it in and sets it up." }
      ]
    },
    { key: "ctaLabel", label: "Button text", type: "localized-string", default: "" },
    { key: "ctaLink", label: "Button link", type: "string", default: "" }
  ]
}, fP = {
  key: "gallery",
  label: "Mosaic pictures",
  type: "array",
  help: "Up to two (split) or three (full width) extra pictures shown as a mosaic with the main picture.",
  itemSchema: [
    { key: "image", label: "Picture", type: "image" },
    { key: "alt", label: "Description (alt text)", type: "string" },
    { key: "link", label: "Link", type: "string" }
  ]
}, vP = {
  ...Cn,
  variants: Cn.variants.map((e) => ({ ...e, fields: [...e.fields ?? [], fP] }))
}, kP = {
  ...Tn,
  commonFields: [
    ...Tn.commonFields,
    { key: "dimensionsTitle", label: "Dimensions title", type: "localized-string", default: "Dimensions & materials", help: "Width, depth, height, wood, finish and warranty from the product attributes. Hidden when none are set." },
    { key: "warranty", label: "Default warranty", type: "localized-string", default: "5 years on frame and joints", help: "Used when the product has no Warranty attribute." },
    { key: "emiMinPrice", label: "Show EMI hint from (৳)", type: "number", default: 1e4, help: 'Products at or above this price show "EMI from ৳x/month". 0 hides it.' },
    { key: "emiMonths", label: "EMI months", type: "number", default: 12 },
    { key: "assemblyNote", label: "Delivery and assembly note", type: "rich-text", default: "<p>Delivered by our own team and assembled at your home. Inside Dhaka in 3–5 days, outside Dhaka in 5–10 days.</p>" },
    { key: "quoteLabel", label: "Custom order button", type: "localized-string", default: "Customize / request a quote", help: "Opens WhatsApp with the product name. Hidden when the store has no WhatsApp number." },
    { key: "completeTheLookTitle", label: '"Complete the room" title', type: "string", default: "Complete the room", help: "Other products from the same category, shown under the product." },
    { key: "showDeliveryAreas", label: "Show delivery areas and charges", type: "boolean", default: !0 }
  ]
}, wP = {
  ...kn,
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Sign in" },
    { key: "intro", label: "Intro text", type: "text", default: "Sign in or create an account with your mobile number." },
    ...kn.commonFields
  ]
}, SP = {
  ...wn,
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Create account" },
    { key: "intro", label: "Intro text", type: "text", default: "Create your account with your mobile number." },
    ...wn.commonFields
  ]
}, kd = {
  componentSchemas: {
    "banner-carousel": cP,
    "category-bento": dP,
    "combo-spotlight": pP,
    "corporate-band": uP,
    "product-rail": yP,
    promises: hP,
    reviews: bP,
    story: gP,
    "lookbook-banner": vP,
    "product-detail": kP,
    signin: wP,
    signup: SP
  },
  chrome: {
    headerSchema: nP
  }
}, wd = {
  componentSchemas: {
    account: gC,
    signin: kn,
    signup: wn,
    banner: wC,
    cart: SC,
    categories: xC,
    category: TC,
    checkout: CC,
    contact: PC,
    content: AC,
    "featured-category": LC,
    hero: EC,
    "order-success": DC,
    "product-detail": Tn,
    "similar-products": IC,
    "shop-grid": OC,
    wishlist: RC,
    "announcement-bar": zC,
    "flash-sale": WC,
    "new-arrivals": _C,
    "offer-banner": HC,
    "lookbook-banner": Cn,
    "instagram-feed": UC,
    blog: GC,
    features: YC,
    testimonials: XC,
    cta: jC,
    brands: ZC,
    "product-slider": KC,
    "product-grid": QC,
    compare: eP,
    coupon: tP,
    "recent-products": aP
  },
  headerSchema: xn,
  footerSchema: NC,
  floatingButtonsSchema: MC,
  mobileNavSchema: FC
}, xP = ht({
  ...wd,
  componentSchemas: { ...wd.componentSchemas, ...kd.componentSchemas },
  ...kd.chrome
}, mC), TP = {
  type: "emi-calculator",
  label: "EMI calculator",
  description: "Shoppers enter an amount and see the monthly instalment of each EMI plan you offer.",
  supportedPages: ["tools"],
  variants: [{ id: "v1", label: "Plan table" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "EMI calculator" },
    { key: "intro", label: "Intro", type: "text", default: "Pay in easy monthly instalments with your credit card." },
    { key: "defaultAmount", label: "Starting amount", type: "number", default: 5e4, help: "A link with ?amount= (from a product page) fills its own amount." },
    {
      key: "plans",
      label: "Plans",
      type: "array",
      itemSchema: [
        { key: "months", label: "Months", type: "number", default: 6 },
        { key: "annualRate", label: "Interest a year (%)", type: "number", default: 0 },
        { key: "feePercent", label: "Processing fee (%)", type: "number", default: 0 }
      ],
      default: [
        { months: 3, annualRate: 0, feePercent: 3 },
        { months: 6, annualRate: 0, feePercent: 4.5 },
        { months: 9, annualRate: 0, feePercent: 6.5 },
        { months: 12, annualRate: 0, feePercent: 8.5 },
        { months: 18, annualRate: 0, feePercent: 11.5 },
        { months: 24, annualRate: 0, feePercent: 14.5 }
      ]
    },
    { key: "banks", label: "Partner banks", type: "array", itemSchema: [{ key: "name", label: "Bank", type: "string" }], default: [] },
    { key: "note", label: "Note", type: "text", default: "EMI is available on credit cards of partner banks. The bank may charge its own fees." },
    ...R
  ]
}, CP = {
  type: "offers-list",
  label: "Offers list",
  description: "Every running campaign as a card with its dates and days left, plus the discounted products.",
  supportedPages: ["offers", "home"],
  variants: [{ id: "v1", label: "Offer cards" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Offers" },
    { key: "subtitle", label: "Subtitle", type: "text", default: "Every deal running in the store right now." },
    { key: "showCampaigns", label: "Show campaigns", type: "boolean", default: !0 },
    { key: "emptyText", label: "Text when no campaign is running", type: "string", default: "No offers are running right now. Check back soon." },
    { key: "showProducts", label: "Show discounted products", type: "boolean", default: !0 },
    { key: "productsTitle", label: "Products title", type: "string", default: "Discounted products", dependency: { field: "showProducts", value: !0 } },
    { key: "productsLimit", label: "Number of products", type: "number", default: 12, dependency: { field: "showProducts", value: !0 } },
    ...R
  ]
}, Sd = [
  { label: "Processor", value: "cpu" },
  { label: "Motherboard", value: "motherboard" },
  { label: "Memory (RAM)", value: "ram" },
  { label: "Storage", value: "storage" },
  { label: "Graphics card", value: "gpu" },
  { label: "Power supply", value: "psu" },
  { label: "Casing", value: "case" },
  { label: "CPU cooler", value: "cooler" },
  { label: "Monitor", value: "monitor" }
], PP = {
  type: "pc-builder",
  label: "PC Builder",
  description: "Shoppers pick a part for each slot, see whether the parts fit together, then add the whole build to the cart.",
  supportedPages: ["pc-builder"],
  variants: [{ id: "v1", label: "Part list" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "PC Builder" },
    { key: "subtitle", label: "Subtitle", type: "text", default: "Pick your parts. We check that they fit together." },
    {
      key: "slots",
      label: "Parts",
      type: "array",
      help: "Empty category = the category whose name matches the part (Processor, Motherboard…).",
      itemSchema: [
        { key: "slot", label: "Part", type: "select", options: Sd, default: "cpu" },
        { key: "label", label: "Name", type: "string" },
        { key: "categoryId", label: "Category", type: "category-select" },
        { key: "required", label: "Required", type: "boolean", default: !1 }
      ],
      default: Sd.map((e) => ({ slot: e.value, label: e.label, categoryId: "", required: ["cpu", "motherboard", "ram", "storage", "psu", "case"].includes(e.value) }))
    },
    { key: "headroomPercent", label: "Power supply spare capacity (%)", type: "number", default: 30 },
    { key: "showOnlyCompatible", label: "Hide parts that do not fit", type: "boolean", default: !1 },
    {
      key: "labels",
      label: "Texts",
      type: "object",
      fields: [
        { key: "addAllLabel", label: "Add all button", type: "string", default: "Add all to cart" },
        { key: "totalLabel", label: "Total", type: "string", default: "Total" },
        { key: "printLabel", label: "Print button", type: "string", default: "Print" },
        { key: "shareLabel", label: "Share button", type: "string", default: "Share" },
        { key: "incompatibleLabel", label: "Not compatible", type: "string", default: "Not compatible" },
        { key: "emptySlotLabel", label: "Empty part", type: "string", default: "Not selected" }
      ]
    },
    ...R
  ]
}, AP = {
  type: "power-calculator",
  label: "Power supply calculator",
  description: "Shoppers pick a processor and graphics card and see the power supply their PC needs.",
  supportedPages: ["tools"],
  variants: [{ id: "v1", label: "Calculator" }],
  commonFields: [
    { key: "title", label: "Title", type: "string", default: "Power supply calculator" },
    { key: "intro", label: "Intro", type: "text", default: "Pick your processor and graphics card to find the power supply you need." },
    {
      key: "presets",
      label: "Quick picks",
      type: "array",
      itemSchema: [
        { key: "label", label: "Name", type: "string" },
        { key: "kind", label: "Part", type: "select", options: [{ label: "Processor", value: "cpu" }, { label: "Graphics card", value: "gpu" }], default: "cpu" },
        { key: "watts", label: "Wattage (W)", type: "number", default: 65 }
      ],
      default: [
        { label: "Entry processor (65 W)", kind: "cpu", watts: 65 },
        { label: "Mid-range processor (105 W)", kind: "cpu", watts: 105 },
        { label: "High-end processor (170 W)", kind: "cpu", watts: 170 },
        { label: "Entry graphics (115 W)", kind: "gpu", watts: 115 },
        { label: "Mid-range graphics (220 W)", kind: "gpu", watts: 220 },
        { label: "High-end graphics (350 W)", kind: "gpu", watts: 350 }
      ]
    },
    { key: "headroomPercent", label: "Spare capacity (%)", type: "number", default: 30, help: "Added on top of the estimated draw." },
    ...R
  ]
}, LP = {
  "offers-list": CP,
  "emi-calculator": TP,
  "power-calculator": AP,
  "pc-builder": PP
}, ct = (e) => ({
  ...e,
  componentSchemas: { ...e.componentSchemas, ...LP }
}), xs = {
  "essentials-1": ct(Xx),
  "essentials-2": ct(zT),
  "books-1": ct(M1),
  "gadgets-1": ct(w0),
  "computers-1": ct(bC),
  "apparels-2": ct(hg),
  "lightings-1": ct(ox),
  "apparels-3": ct(xf),
  "apparels-4": ct(Nv),
  "apparels-5": ct(Uk),
  "footwear-1": ct(rS),
  "furniture-1": ct(xP)
}, xd = {
  "order-detail": "the order page is the fixed route /account/orders/[id]"
}, MP = (e) => [
  ...Object.values(e.componentSchemas),
  e.headerSchema,
  e.footerSchema,
  e.floatingButtonsSchema,
  e.mobileNavSchema
], NP = (e = xs) => {
  const t = /* @__PURE__ */ new Map();
  for (const a of Object.values(e)) {
    for (const [o, r] of Object.entries(a.componentSchemas)) {
      const l = t.get(o) ?? /* @__PURE__ */ new Set();
      r.variants.forEach((i) => l.add(i.id)), t.set(o, l);
    }
    for (const o of MP(a)) {
      const r = t.get(o.type) ?? /* @__PURE__ */ new Set();
      o.variants.forEach((l) => r.add(l.id)), t.set(o.type, r);
    }
  }
  return t;
}, ho = (e) => typeof e == "object" && e !== null && !Array.isArray(e), EP = (e, t = xs) => {
  const a = NP(t), o = { checked: 0, sections: 0, issues: [], typeUsage: {} };
  for (const { label: r, settings: l } of e) {
    o.checked += 1;
    const i = (h, p, g) => o.issues.push({ label: r, kind: h, where: p, detail: g });
    if (!ho(l) || !ho(l.config)) {
      i("malformed", "$", "expected an object with a `config` object");
      continue;
    }
    const n = l.config.themeId, c = typeof n == "string" ? t[n] : void 0;
    c || i("unknown-theme", "config.themeId", String(n));
    const d = new Set(c ? Object.keys(c.componentSchemas) : []), y = (h, p, g) => {
      if (typeof h.type != "string") {
        i("malformed", p, "section has no string `type`");
        return;
      }
      o.sections += 1, o.typeUsage[h.type] = (o.typeUsage[h.type] ?? 0) + 1;
      const m = a.get(h.type);
      if (!m && xd[h.type]) {
        i("retired-type", p, `${h.type}: ${xd[h.type]}`);
        return;
      }
      if (!m) {
        i("unknown-type", p, h.type);
        return;
      }
      c && !g && !d.has(h.type) && i("type-not-in-theme", p, `${h.type} (theme ${String(n)})`), h.variant !== void 0 && !m.has(String(h.variant)) && i("unknown-variant", p, `${h.type}:${String(h.variant)}`);
    };
    for (const h of ["header", "footer"]) {
      const p = l.config[h];
      ho(p) && y({ type: h, variant: p.variant }, `config.${h}`, !0);
    }
    const u = l.pages;
    if (u !== void 0) {
      if (!ho(u)) {
        i("malformed", "pages", "expected an object keyed by page");
        continue;
      }
      for (const [h, p] of Object.entries(u)) {
        if (!ho(p) || !Array.isArray(p.sections)) {
          i("malformed", `pages.${h}`, "expected `sections` array");
          continue;
        }
        p.sections.forEach((g, m) => {
          const f = `pages.${h}.sections[${m}]`;
          ho(g) ? y(g, f, !1) : i("malformed", f, "section is not an object");
        });
      }
    }
  }
  return o;
};
function DP(e, t) {
  const a = {};
  for (const o of e.commonFields)
    o.default !== void 0 && (a[o.key] = o.default);
  if (t) {
    const o = e.variants.find((r) => r.id === t);
    if (o != null && o.fields)
      for (const r of o.fields)
        r.default !== void 0 && (a[r.key] = r.default);
  }
  return a;
}
const Pn = xs, FP = new Set(Object.keys(Pn)), ou = (e, t = "theme") => {
  const a = Pn[e ?? ""];
  if (!a) return {};
  if (t === "theme") return a;
  const o = {};
  for (const r of Object.values(Pn)) Object.assign(o, r.componentSchemas);
  return { ...a, componentSchemas: { ...o, ...a.componentSchemas } };
}, Td = [
  { id: "hero", label: "Hero & banners", types: ["hero", "banner-carousel", "banner", "announcement-bar", "offer-banner", "lookbook-banner", "cta", "corporate-band"] },
  { id: "products", label: "Products", types: ["product-rail", "combo-spotlight", "product-grid", "product-slider", "new-arrivals", "flash-sale", "featured-category", "recent-products", "similar-products", "category-bento", "categories", "category", "shop-grid"] },
  { id: "trust", label: "Trust & social", types: ["promises", "features", "reviews", "testimonials", "brands", "instagram-feed"] },
  { id: "content", label: "Content", types: ["story", "content", "blog", "coupon", "contact"] },
  { id: "page", label: "Store pages", types: ["product-detail", "cart", "checkout", "order-success", "account", "signin", "signup", "wishlist", "compare"] },
  { id: "tools", label: "Tools", types: ["offers-list", "emi-calculator", "power-calculator", "pc-builder"] }
], IP = 2e3, Cd = (e) => ({ past: [], present: e, future: [] }), OP = (e, t, a, o = Date.now()) => t === e.present ? e : a && e.group === a && e.at !== void 0 && o - e.at < IP ? { past: e.past, present: t, future: [], group: a, at: o } : { past: [...e.past, e.present].slice(-200), present: t, future: [], group: a, at: o }, RP = (e) => e.past.length ? { past: e.past.slice(0, -1), present: e.past[e.past.length - 1], future: [e.present, ...e.future] } : e, BP = (e) => e.future.length ? { past: [...e.past, e.present], present: e.future[0], future: e.future.slice(1) } : e, ea = (e, t) => {
  var a, o;
  return ((o = (a = e.pages) == null ? void 0 : a[t]) == null ? void 0 : o.sections) ?? [];
}, to = (e, t, a) => {
  var o;
  return {
    ...e,
    pages: { ...e.pages ?? {}, [t]: { ...((o = e.pages) == null ? void 0 : o[t]) ?? {}, sections: a.map((r, l) => ({ ...r, order: l * 10 })) } }
  };
};
let zP = 0;
const Ts = (e) => `${e}-${Date.now().toString(36)}-${(zP++).toString(36)}`, ru = (e, t, a, o) => {
  const r = [...ea(e, t)], l = Ts(a.type);
  return r.splice(o ?? r.length, 0, { ...a, id: l, order: 0 }), { settings: to(e, t, r), id: l };
}, VP = (e, t, a) => {
  const o = [...ea(e, t)], r = o.findIndex((i) => i.id === a);
  if (r === -1) return { settings: e, id: null };
  const l = Ts(o[r].type);
  return o.splice(r + 1, 0, { ...structuredClone(o[r]), id: l }), { settings: to(e, t, o), id: l };
}, WP = (e, t, a, o) => {
  const r = [...ea(e, t)], l = r.findIndex((n) => n.id === a), i = l + o;
  return l === -1 || i < 0 || i >= r.length ? e : ([r[l], r[i]] = [r[i], r[l]], to(e, t, r));
}, lu = (e, t, a) => to(e, t, a), $P = (e, t, a) => to(e, t, ea(e, t).filter((o) => o.id !== a)), cl = (e, t, a, o) => to(e, t, ea(e, t).map((r) => r.id === a ? o(r) : r)), iu = (e, t, a) => to(e, t, a.map((o) => ({ ...structuredClone(o), id: Ts(o.type), order: 0 }))), _P = (e, t, { fill: a = {}, themeLook: o } = {}) => {
  const r = { ...e.config ?? {}, themeId: t };
  if (o) {
    const i = r.appearance ?? {}, n = r.tokens ?? {}, c = n.typography ?? {};
    r.appearance = { ...i, colorMode: o.mode, customColors: !1 }, r.tokens = { ...n, typography: { ...c, heading: "inherit", body: "inherit" } };
  }
  const l = { ...e, config: r };
  return Object.entries(a).reduce((i, [n, c]) => ea(i, n).length ? i : iu(i, n, c), l);
}, HP = (e, t, a) => {
  const o = Object.keys(e.pages ?? {}).map((l) => {
    const i = ea(e, l), n = [...new Set(i.map((c) => c.type).filter((c) => !t.has(c)))];
    return { page: l, sections: i.length, own: i.filter((c) => t.has(c.type)).length, shared: n };
  }).filter((l) => l.sections > 0), r = Object.fromEntries(Object.entries(a).filter(([l, i]) => i.length && !ea(e, l).length));
  return { pages: o, fill: r };
}, UP = (e, t) => {
  const a = e.config ?? {}, o = a.appearance ?? {}, r = a.tokens ?? {};
  return {
    ...e,
    config: {
      ...a,
      appearance: { ...o, colorMode: t.mode, customColors: !!t.colors },
      tokens: t.colors ? { ...r, colors: { ...r.colors ?? {}, ...t.colors } } : r
    }
  };
}, bo = (e) => {
  const t = JSON.stringify(e ?? null);
  let a = 5381;
  for (let o = 0; o < t.length; o++) a = (a << 5) + a + t.charCodeAt(o) | 0;
  return `${t.length}:${(a >>> 0).toString(36)}`;
}, nu = (e, t, a) => {
  const [o, ...r] = t.split("."), l = Array.isArray(e) ? [...e] : { ...e }, i = e == null ? void 0 : e[o], n = r.length ? nu(i && typeof i == "object" ? i : /^\d+$/.test(r[0]) ? [] : {}, r.join("."), a) : a;
  return l[o] = n, l;
}, GP = (e, t, a) => {
  let o = e, r = 0;
  for (const l of t) {
    const i = ea(o, l.page);
    if (l.op === "add_section") {
      if (!l.section_type) continue;
      const c = l.variant ?? "v1";
      o = ru(o, l.page, { type: l.section_type, variant: c, props: a(l.section_type, c), styles: {}, isActive: !0 }, l.position).settings, r += 1;
      continue;
    }
    const n = i.find((c) => c.id === l.section_id);
    if (n) {
      if (l.op === "set_field" && l.field && l.value !== void 0)
        o = cl(o, l.page, n.id, (c) => ({ ...c, props: nu(c.props ?? {}, l.field, l.value) }));
      else if (l.op === "toggle_section")
        o = cl(o, l.page, n.id, (c) => ({ ...c, isActive: l.visible ?? !c.isActive }));
      else if (l.op === "set_variant" && l.variant)
        o = cl(o, l.page, n.id, (c) => ({ ...c, variant: l.variant }));
      else if (l.op === "move_section" && l.position !== void 0) {
        const c = [...i].sort((d, y) => d.order - y.order).filter((d) => d.id !== n.id);
        c.splice(Math.min(l.position, c.length), 0, n), o = lu(o, l.page, c);
      } else
        continue;
      r += 1;
    }
  }
  return { settings: o, applied: r, skipped: t.length - r };
}, An = (e) => e == null || e === "" || Array.isArray(e) && e.length === 0, YP = (e, t) => {
  const a = [];
  for (const o of e) {
    const r = t[o.key];
    if (o.type === "image" && o.required && An(r) && a.push(o.label), o.type === "array" && Array.isArray(r) && o.itemSchema) {
      const l = o.itemSchema.filter((i) => i.type === "image" && i.required);
      r.forEach((i, n) => {
        for (const c of l) An(i == null ? void 0 : i[c.key]) && a.push(`${o.label} ${n + 1}: ${c.label}`);
      });
    }
  }
  return a;
}, XP = (e, t) => {
  const a = [];
  for (const [o, r] of Object.entries(e.pages ?? {})) {
    const l = (r == null ? void 0 : r.sections) ?? [], i = /* @__PURE__ */ new Set();
    for (const n of l) {
      i.has(n.id) && a.push({ level: "error", page: o, sectionId: n.id, message: `Two sections share the id "${n.id}"` }), i.add(n.id);
      const c = t[n.type];
      if (!c) {
        a.push({ level: "warning", page: o, sectionId: n.id, message: `"${n.type}" is not a section this theme can show; it is hidden on the store. Remove it.` });
        continue;
      }
      if (n.isActive === !1) continue;
      const d = c.variants.find((h) => h.id === n.variant), y = [...c.commonFields, ...(d == null ? void 0 : d.fields) ?? []], u = n.props ?? {};
      for (const h of YP(y, u))
        a.push({ level: "warning", page: o, sectionId: n.id, message: `${c.label}: no image for ${h}` });
      y.some((h) => h.type === "category-select") && An(u.categoryId) && a.push({ level: "warning", page: o, sectionId: n.id, message: `${c.label}: choose a category, or it will not show` });
      for (const h of y.filter((p) => p.type === "array"))
        Array.isArray(u[h.key]) && u[h.key].length === 0 && a.push({ level: "warning", page: o, sectionId: n.id, message: `${c.label}: "${h.label}" is empty` });
    }
    (r == null ? void 0 : r.isActive) !== !1 && l.length === 0 && o === "home" && a.push({ level: "warning", page: o, message: "The home page has no sections" });
  }
  return a;
}, jP = 20, Si = (e) => {
  try {
    const t = localStorage.getItem(e);
    return t ? JSON.parse(t) : null;
  } catch {
    return null;
  }
}, Pd = (e, t) => {
  try {
    return localStorage.setItem(e, JSON.stringify(t)), !0;
  } catch {
    return !1;
  }
}, qP = (e) => {
  const t = `iws-theme-draft:${e}`, a = `iws-theme-versions:${e}`;
  return {
    loadDraft: () => Si(t),
    saveDraft: (o) => Pd(t, o),
    clearDraft: () => {
      try {
        localStorage.removeItem(t);
      } catch {
      }
    },
    listVersions: () => Si(a) ?? [],
    addVersion: (o, r) => {
      const l = [{ id: `${Date.now()}`, settings: o, publishedAt: Date.now(), label: r }, ...Si(a) ?? []];
      for (let i = Math.min(l.length, jP); i > 0; i--) if (Pd(a, l.slice(0, i))) return;
    }
  };
}, ZP = 1500, JP = () => {
  var Pe;
  const e = ia(), t = e.sectionLibrary ?? "theme", a = fe(() => qP(e.storeKey ?? window.location.host), [e.storeKey]), [o, r] = j(Cd(null)), [l, i] = j(null), [n, c] = j(!0), [d, y] = j(!1), [u, h] = j("clean"), [p, g] = j(null), [m, f] = j(null), [v, k] = j([]), w = ve(!1), S = o.present, T = fe(() => bo(l), [l]), C = fe(() => S !== null && bo(S) !== T, [S, T]);
  ne(() => {
    e.fetchSettings().then((G) => {
      var Q;
      const L = G ?? {};
      i(L), r(Cd(structuredClone(L)));
      const B = a.loadDraft();
      B && bo(B.settings) !== bo(L) && g({ ...B, stale: B.base !== bo(L) }), (Q = e.track) == null || Q.call(e, "theme_editor_opened");
    }).catch(() => Me.error("Could not load the theme settings")).finally(() => c(!1));
  }, []), ne(() => {
    if (!S || !C) {
      h("clean");
      return;
    }
    h("unsaved");
    const G = setTimeout(() => {
      const L = a.saveDraft({ settings: S, base: T, savedAt: Date.now() });
      h(L ? "saved" : "unavailable");
    }, ZP);
    return () => clearTimeout(G);
  }, [S, C, T, a]);
  const A = be((G, L) => {
    var B;
    r((Q) => Q.present ? OP(Q, G(Q.present), L) : Q), w.current || (w.current = !0, (B = e.track) == null || B.call(e, "theme_editor_first_edit"));
  }, [e]), M = fe(
    () => {
      var G;
      return ou((G = S == null ? void 0 : S.config) == null ? void 0 : G.themeId, t);
    },
    [(Pe = S == null ? void 0 : S.config) == null ? void 0 : Pe.themeId, t]
  ), E = (G, L) => {
    var Q;
    const B = (Q = M.componentSchemas) == null ? void 0 : Q[G];
    return B ? DP(B, L) : {};
  }, F = (G) => A((L) => ({ ...L, config: { ...L.config ?? {}, ...G } })), I = (G) => A((L) => ({ ...L, seo: { ...L.seo ?? {}, ...G } })), P = (G, L) => A((B) => {
    var Q;
    return { ...B, pages: { ...B.pages ?? {}, [G]: { ...((Q = B.pages) == null ? void 0 : Q[G]) ?? {}, ...L } } };
  }), O = (G, L, B, Q) => A((xe) => cl(xe, G, L, (ue) => B(ue)), Q), z = (G, L, B, Q) => {
    if (!S) return null;
    const { settings: xe, id: ue } = ru(S, G, { type: L, variant: B, props: E(L, B), styles: {}, isActive: !0 }, Q);
    return A(() => xe), ue;
  }, U = (G, L, B) => {
    z(G, L, B);
  }, Y = (G, L) => {
    if (!S) return null;
    const { settings: B, id: Q } = VP(S, G, L);
    return A(() => B), Q;
  }, _ = (G, L, B) => A((Q) => WP(Q, G, L, B)), H = (G, L) => A((B) => $P(B, G, L)), N = (G, L) => A((B) => lu(B, G, L)), D = (G) => {
    var L;
    A((B) => iu(B, G.page, G.sections)), (L = e.track) == null || L.call(e, "theme_editor_template_applied", { page: G.page, template: G.id });
  }, $ = (G, L) => {
    var B;
    A((Q) => _P(Q, G, L)), (B = e.track) == null || B.call(e, "theme_editor_theme_switched", { theme: G, filled_pages: Object.keys((L == null ? void 0 : L.fill) ?? {}).length, theme_look: !!(L != null && L.themeLook) });
  }, V = (G) => {
    var L;
    A((B) => UP(B, G)), (L = e.track) == null || L.call(e, "theme_editor_preset_applied", { preset: G.id });
  }, X = (G) => {
    if (!S) return 0;
    const L = GP(S, G, E);
    return L.applied && A(() => L.settings), L.applied;
  }, oe = () => r(RP), pe = () => r(BP), Se = () => {
    p && A(() => structuredClone(p.settings)), g(null);
  }, ae = () => {
    a.clearDraft(), g(null);
  }, q = async (G = {}) => {
    var B, Q, xe, ue;
    if (!S) return "failed";
    const L = XP(S, M.componentSchemas ?? {});
    if (k(L), L.some((Re) => Re.level === "error"))
      return Me.error("Fix the problems marked in red before publishing"), "blocked";
    y(!0);
    try {
      if (!G.force) {
        const Je = await e.fetchSettings() ?? {};
        if (bo(Je) !== T)
          return f(Je), "conflict";
      }
      await e.saveSettings(S), !e.versions && a.listVersions().length === 0 && l && a.addVersion(l, "Before your first publish"), e.versions || a.addVersion(S, "Published"), i(S), f(null), a.clearDraft();
      const Re = L.filter((Je) => Je.level === "warning").length;
      return Me.success(Re ? `Published, with ${Re} thing${Re === 1 ? "" : "s"} to check` : "Published"), (B = e.onSaved) == null || B.call(e), (Q = e.track) == null || Q.call(e, "theme_editor_published", { warnings: Re }), (ue = (xe = e.preview) == null ? void 0 : xe.revalidate) == null || ue.call(xe).catch(() => {
        Me.info("Published. The live store may take up to a minute to update.");
      }), "published";
    } catch {
      return Me.error("Publishing failed. Your changes are still here; try again."), "failed";
    } finally {
      y(!1);
    }
  }, re = (G) => {
    m && (G === "reload" ? (i(m), A(() => structuredClone(m)), f(null), Me.info("Loaded the latest published version. Undo brings back your edits.")) : (i(m), f(null), q({ force: !0 })));
  }, Z = () => {
    l && (A(() => structuredClone(l)), a.clearDraft(), Me.info("Changes discarded. Undo brings them back."));
  }, ie = (G) => {
    A(() => structuredClone(G)), Me.info("Version restored as a draft. Publish to make it live.");
  }, K = () => JSON.stringify(S ?? {}, null, 2), se = (G) => {
    let L;
    try {
      L = JSON.parse(G);
    } catch {
      return ["This file is not valid JSON"];
    }
    const B = (L == null ? void 0 : L.theme_settings) ?? L, xe = EP([{ label: "import", settings: B }]).issues.filter((ue) => ue.kind === "malformed" || ue.kind === "unknown-type" || ue.kind === "unknown-theme");
    return xe.length ? xe.map((ue) => `${ue.where}: ${ue.detail}`) : (A(() => B), Me.success("Imported as a draft. Publish to make it live."), []);
  };
  return {
    themeSettings: l,
    localSettings: S,
    schemas: M,
    library: t,
    isLoading: n,
    isSaving: d,
    hasChanges: C,
    draftState: u,
    pendingDraft: p,
    conflict: m,
    issues: v,
    canUndo: o.past.length > 0,
    canRedo: o.future.length > 0,
    undo: oe,
    redo: pe,
    updateThemeConfig: F,
    updateGlobalSEO: I,
    updatePageSettings: P,
    updateSection: O,
    addSection: U,
    insertSection: z,
    duplicateSection: Y,
    moveSection: _,
    removeSection: H,
    reorderSections: N,
    applyTemplate: D,
    switchTheme: $,
    applyPreset: V,
    applyEdits: X,
    restoreDraft: Se,
    dismissDraft: ae,
    publish: q,
    saveChanges: async () => {
      await q();
    },
    resolveConflict: re,
    discardChanges: Z,
    restoreVersion: ie,
    listLocalVersions: a.listVersions,
    exportSettings: K,
    importSettings: se
  };
}, su = xa(null), KP = ({ children: e }) => {
  const t = JP();
  return /* @__PURE__ */ s(su.Provider, { value: t, children: e });
}, at = () => $t(su);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QP = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), cu = (...e) => e.filter((t, a, o) => !!t && t.trim() !== "" && o.indexOf(t) === a).join(" ").trim();
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var eA = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tA = us(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: a = 2,
    absoluteStrokeWidth: o,
    className: r = "",
    children: l,
    iconNode: i,
    ...n
  }, c) => $i(
    "svg",
    {
      ref: c,
      ...eA,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: o ? Number(a) * 24 / Number(t) : a,
      className: cu("lucide", r),
      ...n
    },
    [
      ...i.map(([d, y]) => $i(d, y)),
      ...Array.isArray(l) ? l : [l]
    ]
  )
);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const te = (e, t) => {
  const a = us(
    ({ className: o, ...r }, l) => $i(tA, {
      ref: l,
      iconNode: t,
      className: cu(`lucide-${QP(e)}`, o),
      ...r
    })
  );
  return a.displayName = `${e}`, a;
};
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const du = te("ArrowDown", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pu = te("ArrowUp", [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aA = te("Box", [
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cr = te("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bl = te("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uu = te("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cs = te("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oA = te("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rA = te("CircleCheck", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yu = te("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ln = te("CloudUpload", [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m8 17 4-4 4 4", key: "1quai1" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lA = te("Code", [
  ["polyline", { points: "16 18 22 12 16 6", key: "z7tu5w" }],
  ["polyline", { points: "8 6 2 12 8 18", key: "1eg1df" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iA = te("Copy", [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nA = te("Download", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mn = te("EllipsisVertical", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sA = te("Ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cA = te("EyeOff", [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dA = te("Eye", [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hu = te("FileText", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pA = te("Film", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uA = te("Folder", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bu = te("GripVertical", [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yA = te("HardDrive", [
  ["line", { x1: "22", x2: "2", y1: "12", y2: "12", key: "1y58io" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ],
  ["line", { x1: "6", x2: "6.01", y1: "16", y2: "16", key: "sgf278" }],
  ["line", { x1: "10", x2: "10.01", y1: "16", y2: "16", key: "1l4acy" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hA = te("History", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ps = te("Image", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bA = te("Inbox", [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mA = te("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gA = te("Layers", [
  [
    "path",
    {
      d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
      key: "8b97xw"
    }
  ],
  ["path", { d: "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65", key: "dd6zsq" }],
  ["path", { d: "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65", key: "ep9fru" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fA = te("LayoutGrid", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vA = te("LayoutList", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["path", { d: "M14 4h7", key: "3xa0d5" }],
  ["path", { d: "M14 9h7", key: "1icrd9" }],
  ["path", { d: "M14 15h7", key: "1mj8o2" }],
  ["path", { d: "M14 20h7", key: "11slyb" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kA = te("ListChecks", [
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "m3 7 2 2 4-4", key: "1obspn" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wA = te("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SA = te("MonitorX", [
  ["path", { d: "m14.5 12.5-5-5", key: "1jahn5" }],
  ["path", { d: "m9.5 12.5 5-5", key: "1k2t7b" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xA = te("Monitor", [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TA = te("MousePointerClick", [
  ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
  ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
  ["path", { d: "m6 12-1.9 2", key: "mnht97" }],
  ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
  [
    "path",
    {
      d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z",
      key: "s0h3yz"
    }
  ]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CA = te("Music", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PA = te("Palette", [
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  [
    "path",
    {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
      key: "12rzf8"
    }
  ]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AA = te("PanelLeftClose", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LA = te("PanelLeftOpen", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sl = te("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MA = te("Redo2", [
  ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
  ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key: "6uklza" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ad = te("RefreshCw", [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NA = te("RotateCcw", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const As = te("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EA = te("Settings2", [
  ["path", { d: "M20 7h-9", key: "3s1dr2" }],
  ["path", { d: "M14 17H5", key: "gfn3mx" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DA = te("Shapes", [
  [
    "path",
    {
      d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
      key: "1bo67w"
    }
  ],
  ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "3.5", key: "w3z12y" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FA = te("Smartphone", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IA = te("Tablet", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["line", { x1: "12", x2: "12.01", y1: "18", y2: "18", key: "1dp563" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Co = te("Trash2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OA = te("Undo2", [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RA = te("Upload", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dr = te("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), Ls = {
  "essentials-1": {
    id: "essentials-1",
    theme_key: "essentials-1",
    name: "Taza Bazar",
    nameBn: "তাজা বাজার",
    category: "Essentials",
    styleClass: "style-fresh-basket",
    thumbnail: "/images/themes/essentials-1.png",
    defaultMode: "light",
    fonts: ["Plus Jakarta Sans", "Hind Siliguri"]
  },
  "lightings-1": {
    id: "lightings-1",
    theme_key: "lightings-1",
    name: "Jhilmil",
    nameBn: "ঝিলমিল",
    category: "Lightings",
    styleClass: "style-neon-cinema",
    thumbnail: "/images/themes/lightings-1.png",
    defaultMode: "dark",
    fonts: ["Space Grotesk", "Inter", "Hind Siliguri"]
  },
  "apparels-2": {
    id: "apparels-2",
    theme_key: "apparels-2",
    name: "Shohure",
    nameBn: "শহুরে",
    category: "Apparels",
    styleClass: "style-urban-drip",
    thumbnail: "/images/themes/apparels-2.png",
    defaultMode: "light",
    fonts: ["Archivo Narrow", "Inter", "Hind Siliguri"]
  },
  "apparels-3": {
    id: "apparels-3",
    theme_key: "apparels-3",
    name: "Nakshi",
    nameBn: "নকশি",
    category: "Apparels",
    styleClass: "style-nakshi",
    thumbnail: "/images/themes/apparels-3.png",
    defaultMode: "light",
    fonts: ["Cormorant Garamond", "Mulish", "Hind Siliguri"]
  },
  "furniture-1": {
    id: "furniture-1",
    theme_key: "furniture-1",
    name: "Shegun",
    nameBn: "সেগুন",
    category: "Furniture",
    styleClass: "style-shegun",
    thumbnail: "/images/themes/furniture-1.png",
    defaultMode: "light",
    fonts: ["Fraunces", "DM Sans", "Hind Siliguri"]
  },
  "essentials-2": {
    id: "essentials-2",
    theme_key: "essentials-2",
    name: "Prottoho",
    nameBn: "প্রত্যহ",
    category: "Essentials",
    styleClass: "style-prottoho",
    thumbnail: "/images/themes/essentials-2.png",
    defaultMode: "light",
    fonts: ["Poppins", "Hind Siliguri"]
  },
  "books-1": {
    id: "books-1",
    theme_key: "books-1",
    name: "Pathok",
    nameBn: "পাঠক",
    category: "Books",
    styleClass: "style-pathok",
    thumbnail: "/images/themes/books-1.png",
    defaultMode: "light",
    fonts: ["Inter", "Hind Siliguri"]
  },
  "apparels-4": {
    id: "apparels-4",
    theme_key: "apparels-4",
    name: "Tanabana",
    nameBn: "টানাবানা",
    category: "Apparels",
    styleClass: "style-tanabana",
    thumbnail: "/images/themes/apparels-4.png",
    defaultMode: "light",
    fonts: ["Oswald", "Nunito Sans", "Hind Siliguri"]
  },
  "apparels-5": {
    id: "apparels-5",
    theme_key: "apparels-5",
    name: "Mohalla",
    nameBn: "মহল্লা",
    category: "Apparels",
    styleClass: "style-mohalla",
    thumbnail: "/images/themes/apparels-5.png",
    defaultMode: "light",
    fonts: ["Bricolage Grotesque", "Manrope", "Hind Siliguri"]
  },
  "footwear-1": {
    id: "footwear-1",
    theme_key: "footwear-1",
    name: "Juta",
    nameBn: "জুতা",
    category: "Footwear",
    styleClass: "style-juta",
    thumbnail: "/images/themes/footwear-1.png",
    defaultMode: "light",
    fonts: ["Archivo", "Inter", "Hind Siliguri"]
  },
  "gadgets-1": {
    id: "gadgets-1",
    theme_key: "gadgets-1",
    name: "Torongo",
    nameBn: "তরঙ্গ",
    category: "Gadgets",
    styleClass: "style-torongo",
    thumbnail: "/images/themes/gadgets-1.png",
    defaultMode: "light",
    fonts: ["Inter", "Hind Siliguri"]
  },
  "computers-1": {
    id: "computers-1",
    theme_key: "computers-1",
    name: "Projukti",
    nameBn: "প্রযুক্তি",
    category: "Computers",
    styleClass: "style-projukti",
    thumbnail: "/images/themes/computers-1.png",
    defaultMode: "light",
    fonts: ["IBM Plex Sans", "Hind Siliguri"]
  }
}, BA = (e) => Ls[e] ?? null, zl = (e) => `${e.name} · ${e.nameBn}`, mu = () => Object.values(Ls).filter((e) => !e.hidden), zA = { title: "Urban Drip — streetwear and accessories", description: "Streetwear basics, new drops every Friday and cash on delivery.", keywords: ["streetwear", "fashion", "apparel", "hoodies", "t-shirts", "accessories"], ogImage: "https://images.unsplash.com/photo-1582225905616-c3adc77ada6b?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8c3RyZWV0d2VhciUyMG1vZGVsJTIwdXJiYW58ZW58MXwxfHx8MTc5MzE2MDA2Mnww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80", index_allow: !0 }, VA = { themeId: "apparels-2", appearance: { colorMode: "light", product_image_aspect_ratio: "aspect-[3/4]" }, header: { variant: "v2", sticky: !0, topbar: { active: !1 }, actions: { showSearch: !0, showCart: !0, showAccount: !0, showWishlist: !0, cartAction: "sidebar" }, searchPlaceholder: "Search tees, hoodies, bags…", searchConfig: { showPrice: !0, showCategory: !0, showImage: !0, maxResults: 6 }, menu: [{ label: "Shop", href: "/shop", type: "categories" }, { label: "New in", href: "/shop?order_by=newest_first", type: "link", badge: "New" }, { label: "Sale", href: "/shop?order_by=discount_desc", type: "link" }, { label: "Journal", href: "/blog", type: "link" }, { label: "Contact", href: "/contact", type: "link" }] }, footer: { variant: "v1", title: "Urban Drip", description: "Streetwear basics and accessories, made to be worn hard. New drops every Friday.", columns: [{ title: "Shop", links: [{ label: "All products", href: "/shop" }, { label: "New in", href: "/shop?order_by=newest_first" }, { label: "Categories", href: "/categories" }, { label: "Offers", href: "/coupon" }] }, { title: "Help", links: [{ label: "Track order", href: "/track-order" }, { label: "Shipping policy", href: "/shipping-policy" }, { label: "Return policy", href: "/return-policy" }, { label: "Contact us", href: "/contact" }] }, { title: "About", links: [{ label: "Journal", href: "/blog" }, { label: "Privacy policy", href: "/privacy-policy" }, { label: "Terms of service", href: "/terms-of-service" }] }], socialLinks: [], copyright: "© Urban Drip. All rights reserved.", paymentMethods: [{ platform: "bkash" }, { platform: "nagad" }] }, floatingButtons: { active: !0, callUsTitle: "Call us", whatsappTitle: "WhatsApp", messengerTitle: "Messenger" }, mobileBottomNav: { active: !0, items: [{ label: "Home", icon: "home", actionType: "link", href: "/", isPrimary: !1 }, { label: "Shop", icon: "shop", actionType: "categories", href: "/shop", isPrimary: !1 }, { label: "Search", icon: "search", actionType: "search", href: "", isPrimary: !1 }, { label: "Wishlist", icon: "heart", actionType: "link", href: "/wishlist", isPrimary: !1 }, { label: "Bag", icon: "cart", actionType: "link", href: "/cart", isPrimary: !1 }] } }, WA = /* @__PURE__ */ JSON.parse('{"home":{"isActive":true,"sections":[{"id":"announcement-bar","type":"announcement-bar","variant":"v1","props":{"items":[{"text":"Free delivery on bigger orders"},{"text":"New drop every Friday"},{"text":"Ten percent off your first order","code":"FIRST10"},{"text":"Cash on delivery everywhere we deliver"}]},"styles":{},"isActive":true,"order":0},{"id":"hero","type":"hero","variant":"v1","props":{"slides":[{"title":"Built for the street","subtitle":"Heavyweight basics, relaxed cuts and details that last. The new season is here.","image":"https://images.unsplash.com/photo-1613539266165-e444d4d3c977?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8c3RyZWV0d2VhciUyMGZhc2hpb24lMjBjaXR5JTIwc3RyZWV0fGVufDF8MHx8fDE3OTMxNjAwNjN8MA&ixlib=rb-4.1.0&w=1600&h=900&fit=crop&crop=entropy&auto=format&q=80","ctaText":"Shop the drop","ctaLink":"/shop?order_by=newest_first","badge":"New season"},{"title":"Off-duty essentials","subtitle":"Pieces that work from Monday to the weekend.","image":"https://images.unsplash.com/photo-1507680434567-5739c80be1ac?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8Y2FzdWFsJTIwbWVuc3dlYXIlMjBvdXRmaXR8ZW58MXwwfHx8MTc5MzE2MDA2NHww&ixlib=rb-4.1.0&w=1600&h=900&fit=crop&crop=entropy&auto=format&q=80","ctaText":"Shop essentials","ctaLink":"/shop","badge":"Core"},{"title":"Finish the look","subtitle":"Bags, watches and the accessories that pull an outfit together.","image":"https://images.unsplash.com/photo-1624447166415-bc59eff7b716?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8ZmFzaGlvbiUyMGFjY2Vzc29yaWVzJTIwYmFnJTIwd2F0Y2glMjBmbGF0bGF5fGVufDF8MHx8fDE3OTMxNjAwNjV8MA&ixlib=rb-4.1.0&w=1600&h=900&fit=crop&crop=entropy&auto=format&q=80","ctaText":"Shop accessories","ctaLink":"/categories","badge":"Accessories"}],"autoplay":true,"autoplayDelay":6000},"styles":{},"isActive":true,"order":10},{"id":"lookbook-city-edit","type":"lookbook-banner","variant":"v1","props":{"image":"https://images.unsplash.com/photo-1653875842174-429c1b467548?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8dXJiYW4lMjBmYXNoaW9uJTIwbG9va2Jvb2slMjBuZXV0cmFsfGVufDF8MXx8fDE3OTMxNjAwNjV8MA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","title":"The city edit","subtitle":"Layered neutrals, utility pockets and clean lines. Our lookbook for the season, shot on the street.","ctaText":"View the lookbook","ctaLink":"/shop","imagePosition":"left","gallery":[{"image":"https://images.unsplash.com/photo-1782110569431-88bfea6738cd?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d3Jpc3QlMjB3YXRjaCUyMGRhcmslMjBzdHJhcHxlbnwxfDF8fHwxNzkzMTYwMDY2fDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A watch with a dark strap","link":"/shop"},{"image":"https://images.unsplash.com/photo-1623664946031-e6aaf0630602?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8aGVhZHBob25lcyUyMHBsYWluJTIwYmFja2dyb3VuZHxlbnwxfDF8fHwxNzkzMTYwMDY2fDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"Headphones on a plain background","link":"/shop"}]},"styles":{},"isActive":true,"order":20},{"id":"categories","type":"categories","variant":"v1","props":{"title":"Shop by category","subtitle":"Find your fit","columns":4},"styles":{},"isActive":true,"order":30},{"id":"new-arrivals","type":"new-arrivals","variant":"v1","props":{"title":"New arrivals","subtitle":"Just landed this week","slidesPerView":4},"styles":{},"isActive":true,"order":40},{"id":"lookbook-monochrome","type":"lookbook-banner","variant":"v2","props":{"image":"https://images.unsplash.com/photo-1495462911434-be47104d70fa?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMGZhc2hpb24lMjBwb3J0cmFpdHxlbnwxfDF8fHwxNzkzMTYwMDY3fDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","title":"Monochrome","subtitle":"Black, white and everything in between","ctaText":"Shop the collection","ctaLink":"/shop","overlayOpacity":45,"gallery":[{"image":"https://images.unsplash.com/photo-1598532163257-ae3c6b2524b6?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8bGVhdGhlciUyMGJhZ3xlbnwxfDF8fHwxNzkzMTYwMDY3fDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A leather bag","link":"/shop"},{"image":"https://images.unsplash.com/photo-1628202926206-c63a34b1618f?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8YmxhY2slMjBoZWFkcGhvbmVzfGVufDF8MXx8fDE3OTMxNjAwNjh8MA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"Headphones","link":"/shop"},{"image":"https://images.unsplash.com/photo-1716399201049-60835e27c843?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d2F0Y2glMjBmYWNlJTIwY2xvc2V1cHxlbnwxfDF8fHwxNzkzMTYwMDY5fDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A watch face","link":"/shop"}]},"styles":{},"isActive":true,"order":50},{"id":"product-grid","type":"product-grid","variant":"v1","props":{"title":"Best sellers","subtitle":"What everyone is wearing","viewAllLink":"/shop"},"styles":{},"isActive":true,"order":60},{"id":"flash-sale","type":"flash-sale","variant":"v1","props":{"title":"Flash sale"},"styles":{},"isActive":true,"order":70},{"id":"brands","type":"brands","variant":"v1","props":{"title":"Brands we carry","layout":"ticker"},"styles":{},"isActive":true,"order":80},{"id":"instagram-feed","type":"instagram-feed","variant":"v1","props":{"title":"Seen on the street","items":[{"image":"https://images.unsplash.com/photo-1624353656309-8be1a6c457be?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8c3RyZWV0JTIwc3R5bGUlMjBvdXRmaXR8ZW58MXwxfHx8MTc5MzE2MDA2OXww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1578102718171-ec1f91680562?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Mnx8c3RyZWV0JTIwc3R5bGUlMjBvdXRmaXR8ZW58MXwxfHx8MTc5MzE2MDA2OXww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1584216338898-f34d78201414?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8M3x8c3RyZWV0JTIwc3R5bGUlMjBvdXRmaXR8ZW58MXwxfHx8MTc5MzE2MDA2OXww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1708242355178-d8c929b01a9d?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8NHx8c3RyZWV0JTIwc3R5bGUlMjBvdXRmaXR8ZW58MXwxfHx8MTc5MzE2MDA2OXww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1529399447871-731cff7f696b?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8NXx8c3RyZWV0JTIwc3R5bGUlMjBvdXRmaXR8ZW58MXwxfHx8MTc5MzE2MDA2OXww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1684283377169-e3dcfec7790c?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Nnx8c3RyZWV0JTIwc3R5bGUlMjBvdXRmaXR8ZW58MXwxfHx8MTc5MzE2MDA2OXww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"}]},"styles":{},"isActive":true,"order":90},{"id":"blog","type":"blog","variant":"v1","props":{"title":"Journal","posts":[],"viewAllLink":"/blog","showViewAll":true},"styles":{},"isActive":true,"order":100},{"id":"testimonials","type":"testimonials","variant":"v1","props":{"title":"Worn and reviewed","items":[{"name":"Nadia R.","designation":"Verified buyer","review":"The hoodie is properly heavy and the fit is exactly as the size guide said. Already ordered a second colour.","rating":5},{"name":"Tanvir H.","designation":"Verified buyer","review":"Fast delivery, paid at the door, and the tee still looks new after a month of washing.","rating":5},{"name":"Sadia K.","designation":"Verified buyer","review":"Clean cuts and good fabric for the price. The cargo trousers are my new favourite.","rating":4}]},"styles":{},"isActive":true,"order":110},{"id":"cta","type":"cta","variant":"v1","props":{"title":"Get the drop first","subtitle":"New arrivals, restocks and members-only offers. No spam, unsubscribe any time.","placeholder":"Your email address","buttonText":"Sign up"},"styles":{},"isActive":true,"order":120}]},"shop":{"isActive":true,"sections":[{"id":"shop-grid","type":"shop-grid","variant":"v1","props":{"title":"Shop all","description":"Tees, hoodies, trousers and accessories. New pieces every Friday.","itemsPerPage":12,"allCategoriesLabel":"All","noProductsTitle":"Nothing here yet","noProductsMessage":"Try changing or clearing the filters."},"styles":{},"isActive":true,"order":0}]},"product":{"isActive":true,"sections":[{"id":"product-detail","type":"product-detail","variant":"v1","props":{"quantityLabel":"Quantity","addToCartText":"Add to bag","orderNowText":"Buy now","productDescTitle":"Description","returnPolicyTitle":"Delivery & returns","sizeGuideTitle":"Size guide","sizeGuide":"<p>Measurements are in inches, taken flat across the garment. Between two sizes? Take the larger one for a relaxed fit.</p><table><thead><tr><th>Size</th><th>Chest</th><th>Length</th><th>Shoulder</th><th>Sleeve</th></tr></thead><tbody><tr><td>S</td><td>38</td><td>27</td><td>17.5</td><td>8</td></tr><tr><td>M</td><td>40</td><td>28</td><td>18</td><td>8.5</td></tr><tr><td>L</td><td>42</td><td>29</td><td>19</td><td>9</td></tr><tr><td>XL</td><td>44</td><td>30</td><td>20</td><td>9.5</td></tr><tr><td>XXL</td><td>46</td><td>31</td><td>21</td><td>10</td></tr></tbody></table><h3>How to measure</h3><ul><li><strong>Chest:</strong> straight across, one inch below the armholes.</li><li><strong>Length:</strong> from the highest point of the shoulder to the hem.</li><li><strong>Shoulder:</strong> from one shoulder seam to the other.</li></ul>","completeTheLookTitle":"Complete the look","showDeliveryAreas":true},"styles":{},"isActive":true,"order":0},{"id":"similar-products","type":"similar-products","variant":"v1","props":{"title":"You may also like"},"styles":{},"isActive":true,"order":10}]},"cart":{"isActive":true,"sections":[{"id":"cart","type":"cart","variant":"v1","props":{"pageTitle":"Bag","emptyTitle":"Your bag is empty","emptyMessage":"Find something you like and add it to your bag.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop","summaryTitle":"Summary","subtotalLabel":"Subtotal","shippingLabel":"Delivery","shippingCalculatedText":"Delivery is calculated at checkout.","totalLabel":"Total","checkoutButtonText":"Checkout","checkoutLink":"/checkout"},"styles":{},"isActive":true,"order":0}]},"checkout":{"isActive":true,"sections":[{"id":"checkout","type":"checkout","variant":"v1","props":{"pageTitle":"Checkout","emptyTitle":"Your bag is empty","emptyMessage":"Add something to your bag before you check out.","continueShoppingText":"Shop now","continueShoppingLink":"/shop","summaryTitle":"Your order","subtotalLabel":"Subtotal","shippingChargeLabel":"Delivery area","totalLabel":"Total","placeOrderText":"Place order","placingOrderText":"Placing order…"},"styles":{},"isActive":true,"order":0}]},"order-success":{"isActive":true,"sections":[{"id":"order-success","type":"order-success","variant":"v1","props":{"title":"Thank you","message":"Your order is in. We will call to confirm it before it ships.","errorTitle":"Your order was placed","errorMessage":"We could not load the order details on this device, but your order was received.","viewOrderText":"View order","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"categories":{"isActive":true,"sections":[{"id":"categories","type":"categories","variant":"v1","props":{"title":"Categories","subtitle":"Everything, sorted","columns":4,"emptyText":"No categories yet."},"styles":{},"isActive":true,"order":0}]},"wishlist":{"isActive":true,"sections":[{"id":"wishlist","type":"wishlist","variant":"v1","props":{"title":"Wishlist","subtitle":"Saved for later","emptyTitle":"Nothing saved yet","emptyText":"Tap the heart on any product to keep it here.","continueShoppingText":"Start shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"compare":{"isActive":true,"sections":[{"id":"compare","type":"compare","variant":"v1","props":{},"styles":{},"isActive":true,"order":0}]},"coupon":{"isActive":true,"sections":[{"id":"coupon","type":"coupon","variant":"v1","props":{"title":"Offers","coupons":[{"code":"FIRST10","title":"Ten percent off","description":"On your first order.","discount":"10% off"},{"code":"FRIDAY","title":"Friday drop","description":"On new arrivals, every Friday.","discount":"15% off"}]},"styles":{},"isActive":true,"order":0}]},"track-order":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Track your order","content":"<p>Enter your order number and phone to see where your order is. Signed in? Your orders are under <a href=\\"/account/orders\\">My orders</a>.</p>"},"styles":{},"isActive":true,"order":0}]},"signin":{"isActive":true,"sections":[{"id":"signin","type":"signin","variant":"v1","props":{"title":"Sign in","intro":"Sign in or create an account with your mobile number.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"signup":{"isActive":true,"sections":[{"id":"signup","type":"signup","variant":"v2","props":{"title":"Create account","intro":"Create your account with your mobile number.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"account":{"isActive":true,"sections":[{"id":"account","type":"account","variant":"v1","props":{"tabOverviewLabel":"Overview","tabOrdersLabel":"Orders","tabAddressesLabel":"Addresses","tabDetailsLabel":"Profile","signOutLabel":"Sign out"},"styles":{},"isActive":true,"order":0}]},"contact":{"isActive":true,"sections":[{"id":"contact","type":"contact","variant":"v1","props":{"title":"Contact","description":"Questions about an order, a size or a return? Message or call us and we will get back to you within a day."},"styles":{},"isActive":true,"order":0}]},"blog":{"isActive":true,"sections":[{"id":"blog","type":"blog","variant":"v1","props":{"title":"Journal","posts":[],"showViewAll":false},"styles":{},"isActive":true,"order":0}]},"privacy-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Privacy policy","content":"<p>This policy explains what we collect when you shop with us and how we use it.</p><h2>What we collect</h2><p>Your name, phone number, delivery address and order history, so we can deliver your orders and help you with them.</p><h2>How we use it</h2><p>To process and deliver orders, to contact you about them and, if you agree, to tell you about new arrivals. We never sell your details.</p><h2>Your choices</h2><p>You can ask us to update or delete your details at any time through the contact page.</p>"},"styles":{},"isActive":true,"order":0}]},"shipping-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Shipping policy","content":"<p>We deliver to every area listed at checkout. The delivery charge for your area is shown before you place the order.</p><h2>Delivery times</h2><p>Orders inside the city usually arrive in 1–2 days and elsewhere in 3–5 days.</p><h2>Payment</h2><p>Pay in cash when your order arrives. Please check the parcel before you pay.</p>"},"styles":{},"isActive":true,"order":0}]},"terms-of-service":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Terms of service","content":"<p>By placing an order you agree to these terms.</p><h2>Orders</h2><p>An order is confirmed once we call or message you to confirm it. We may cancel an order if an item is out of stock.</p><h2>Prices</h2><p>Prices are shown in the store currency and include all taxes. Delivery is charged separately and shown at checkout.</p><h2>Changes</h2><p>We may update these terms. The version on this page applies to new orders.</p>"},"styles":{},"isActive":true,"order":0}]},"return-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Return policy","content":"<p>Wrong size or changed your mind? You can return or exchange unworn items within 7 days of delivery.</p><h2>How to return</h2><p>Contact us with your order number. Items must be unworn, unwashed and have their tags.</p><h2>Refunds</h2><p>Once we receive and check the item, we refund the amount or send the replacement within 5 working days.</p>"},"styles":{},"isActive":true,"order":0}]}}'), $A = {
  seo: zA,
  config: VA,
  pages: WA
}, _A = { title: "Nakshi — sarees, panjabi and festive wear", description: "Handwoven jamdani, muslin and katan sarees, festive panjabi and three-piece sets, with cash on delivery across Bangladesh.", keywords: ["saree", "jamdani", "panjabi", "three-piece", "eid collection", "ethnic wear"], ogImage: "https://images.unsplash.com/photo-1752469126143-9de2078e5281?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8YmFuZ2xhZGVzaGklMjBzYXJlZSUyMGZhc2hpb258ZW58MXwxfHx8MTc5MzE2MDA3MHww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80", index_allow: !0 }, HA = { themeId: "apparels-3", appearance: { colorMode: "light", product_image_aspect_ratio: "aspect-[3/4]" }, header: { variant: "v2", sticky: !0, topbar: { active: !1 }, actions: { showSearch: !0, showCart: !0, showAccount: !0, showWishlist: !0, cartAction: "sidebar" }, searchPlaceholder: "Search sarees, panjabi, three-piece…", searchConfig: { showPrice: !0, showCategory: !0, showImage: !0, maxResults: 6 }, menu: [{ label: "Shop", href: "/shop", type: "categories" }, { label: "New in", href: "/shop?order_by=newest_first", type: "link", badge: "New" }, { label: "Sale", href: "/shop?order_by=discount_desc", type: "link" }, { label: "Journal", href: "/blog", type: "link" }, { label: "Contact", href: "/contact", type: "link" }] }, footer: { variant: "v1", title: "Nakshi", description: "Handwoven jamdani, festive panjabi and three-piece sets, stitched in Bangladesh for every utsob.", columns: [{ title: "Shop", links: [{ label: "All products", href: "/shop" }, { label: "New in", href: "/shop?order_by=newest_first" }, { label: "Categories", href: "/categories" }, { label: "Offers", href: "/coupon" }] }, { title: "Help", links: [{ label: "Track order", href: "/track-order" }, { label: "Shipping policy", href: "/shipping-policy" }, { label: "Return policy", href: "/return-policy" }, { label: "Contact us", href: "/contact" }] }, { title: "About", links: [{ label: "Journal", href: "/blog" }, { label: "Privacy policy", href: "/privacy-policy" }, { label: "Terms of service", href: "/terms-of-service" }] }], socialLinks: [], copyright: "© Nakshi. All rights reserved.", paymentMethods: [{ platform: "bkash" }, { platform: "nagad" }] }, floatingButtons: { active: !0, callUsTitle: "Call us", whatsappTitle: "WhatsApp", messengerTitle: "Messenger" }, mobileBottomNav: { active: !0, items: [{ label: "Home", icon: "home", actionType: "link", href: "/", isPrimary: !1 }, { label: "Shop", icon: "shop", actionType: "categories", href: "/shop", isPrimary: !1 }, { label: "Search", icon: "search", actionType: "search", href: "", isPrimary: !1 }, { label: "Wishlist", icon: "heart", actionType: "link", href: "/wishlist", isPrimary: !1 }, { label: "Bag", icon: "cart", actionType: "link", href: "/cart", isPrimary: !1 }] } }, UA = /* @__PURE__ */ JSON.parse('{"home":{"isActive":true,"sections":[{"id":"announcement-bar","type":"announcement-bar","variant":"v1","props":{"items":[{"text":"Free delivery on bigger orders"},{"text":"New Eid collection is here"},{"text":"Ten percent off your first order","code":"FIRST10"},{"text":"Cash on delivery everywhere we deliver"}]},"styles":{},"isActive":true,"order":0},{"id":"hero","type":"hero","variant":"v1","props":{"slides":[{"title":"Dressed for every utsob","subtitle":"Handwoven jamdani, festive panjabi and three-piece sets for Eid, Boishakh and weddings.","image":"https://images.unsplash.com/photo-1583878448938-0de973eec3b9?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8c291dGglMjBhc2lhbiUyMGZlc3RpdmUlMjBjbG90aGluZ3xlbnwxfDB8fHwxNzkzMTYwMDcwfDA&ixlib=rb-4.1.0&w=1600&h=900&fit=crop&crop=entropy&auto=format&q=80","ctaText":"Shop the Eid edit","ctaLink":"/shop?order_by=newest_first","badge":"Eid collection"},{"title":"Everyday cotton","subtitle":"Soft tant and cotton for office, campus and home.","image":"https://images.unsplash.com/photo-1610189012906-4c0aa9b9781e?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8Y290dG9uJTIwc2FyZWUlMjB3b21hbnxlbnwxfDB8fHwxNzkzMTYwMDcyfDA&ixlib=rb-4.1.0&w=1600&h=900&fit=crop&crop=entropy&auto=format&q=80","ctaText":"Shop essentials","ctaLink":"/shop","badge":"Everyday"},{"title":"Wedding edit","subtitle":"Katan and benarasi sarees, sherwani and the jewellery to match.","image":"https://images.unsplash.com/photo-1610276347459-825713e28145?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8YmVuZ2FsaSUyMHdlZGRpbmclMjBzYXJlZXxlbnwxfDB8fHwxNzkzMTYwMDcyfDA&ixlib=rb-4.1.0&w=1600&h=900&fit=crop&crop=entropy&auto=format&q=80","ctaText":"Shop accessories","ctaLink":"/categories","badge":"Wedding"}],"autoplay":true,"autoplayDelay":6000},"styles":{},"isActive":true,"order":10},{"id":"categories","type":"categories","variant":"v1","props":{"title":"Shop by occasion","subtitle":"Eid, weddings, Boishakh and every day in between","columns":4},"styles":{},"isActive":true,"order":20},{"id":"new-arrivals","type":"new-arrivals","variant":"v1","props":{"title":"New arrivals","subtitle":"Just landed this week","slidesPerView":4},"styles":{},"isActive":true,"order":30},{"id":"lookbook-city-edit","type":"lookbook-banner","variant":"v1","props":{"image":"https://images.unsplash.com/photo-1786300114351-c0c73bb6fe85?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8cmVkJTIwYW5kJTIwd2hpdGUlMjBzYXJlZXxlbnwxfDF8fHwxNzkzMTYwMDczfDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","title":"The Boishakh edit","subtitle":"Red and white, alpona prints and kantha stitch. Our lookbook for Pohela Boishakh.","ctaText":"View the lookbook","ctaLink":"/shop","gallery":[{"image":"https://images.unsplash.com/photo-1773439878577-5969ffc1b198?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8ZW1icm9pZGVyZWQlMjBkdXBhdHRhfGVufDF8MXx8fDE3OTMxNjAwNzN8MA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A kantha-stitched dupatta","link":"/shop"},{"image":"https://images.unsplash.com/photo-1597983073493-88cd35cf93b0?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8cHJpbnRlZCUyMHNhbHdhciUyMGthbWVlenxlbnwxfDF8fHwxNzkzMTYwMDc0fDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A three-piece in alpona print","link":"/shop"}]},"styles":{},"isActive":true,"order":40},{"id":"fabric-story","type":"story","variant":"v2","props":{"eyebrow":"Know your weave","title":"The fabrics behind every utsob","subtitle":"Three weaves from three corners of Bangladesh, each with its own drape and season.","points":[{"icon":"sparkle","title":{"en":"Jamdani","bn":"জামদানি"},"body":"Hand-loomed on the Shitalakshya, with motifs woven in, never printed.","link":"/shop?search=jamdani"},{"icon":"sparkle","title":{"en":"Muslin","bn":"মসলিন"},"body":"Feather-light and breathable, made for long summer celebrations.","link":"/shop?search=muslin"},{"icon":"sparkle","title":{"en":"Katan","bn":"কাতান"},"body":"Rich silk with a heavy fall, the wedding-day classic.","link":"/shop?search=katan"}],"ctaLabel":"","ctaLink":""},"styles":{},"isActive":true,"order":50},{"id":"flash-sale","type":"flash-sale","variant":"v1","props":{"title":"Eid countdown"},"styles":{},"isActive":true,"order":60},{"id":"product-grid","type":"product-grid","variant":"v1","props":{"title":"Best sellers","subtitle":"Loved this season","viewAllLink":"/shop"},"styles":{},"isActive":true,"order":70},{"id":"lookbook-monochrome","type":"lookbook-banner","variant":"v2","props":{"image":"https://images.unsplash.com/photo-1610030469983-98e550d6193c?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8aGFuZHdvdmVuJTIwc2FyZWV8ZW58MXwxfHx8MTc5MzE2MDA3NXww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","title":"Jamdani","subtitle":"Handwoven on the banks of the Shitalakshya","ctaText":"Shop the collection","ctaLink":"/shop","overlayOpacity":45,"gallery":[{"image":"https://images.unsplash.com/photo-1726076574747-c0fb20b3cf37?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d29tYW4lMjByZWQlMjB3aGl0ZSUyMHNhcmVlfGVufDF8MXx8fDE3OTMxNjAwNzV8MA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A woman in a red and white Boishakh saree","link":"/shop"},{"image":"https://images.unsplash.com/photo-1727835523545-70ee992b5763?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8bWFuJTIwZW1icm9pZGVyZWQlMjBrdXJ0YXxlbnwxfDF8fHwxNzkzMTYwMDc2fDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A man in an embroidered cotton panjabi","link":"/shop"},{"image":"https://images.unsplash.com/photo-1710440189404-e95fabead2a3?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8c2lsayUyMHNhcmVlJTIwZmFicmljfGVufDF8MXx8fDE3OTMxNjAwNzZ8MA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A jamdani saree draped over a chair","link":"/shop"}]},"styles":{},"isActive":true,"order":80},{"id":"testimonials","type":"testimonials","variant":"v1","props":{"title":"What our customers say","items":[{"name":"Nadia R.","designation":"Verified buyer","review":"The jamdani is real and the colour is exactly as the photos. My mother wore it on Eid and everyone asked where it came from.","rating":5},{"name":"Tanvir H.","designation":"Verified buyer","review":"Ordered panjabi for my father and brothers, paid cash on delivery and it arrived two days before Eid.","rating":5},{"name":"Sadia K.","designation":"Verified buyer","review":"Soft cotton three-piece, good stitching for the price. The size guide in inches was very helpful.","rating":4}]},"styles":{},"isActive":true,"order":90},{"id":"blog","type":"blog","variant":"v1","props":{"title":"Journal","posts":[],"viewAllLink":"/blog","showViewAll":true},"styles":{},"isActive":true,"order":100},{"id":"instagram-feed","type":"instagram-feed","variant":"v1","props":{"title":"Worn by you","items":[{"image":"https://images.unsplash.com/photo-1756483509254-3cc48a5a15b2?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8aW5kaWFuJTIwZXRobmljJTIwd2VhciUyMGZhc2hpb258ZW58MXwxfHx8MTc5MzE2MDA3N3ww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1668371459824-094a960a227d?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Mnx8aW5kaWFuJTIwZXRobmljJTIwd2VhciUyMGZhc2hpb258ZW58MXwxfHx8MTc5MzE2MDA3N3ww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1713296008556-29c7fae52234?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8M3x8aW5kaWFuJTIwZXRobmljJTIwd2VhciUyMGZhc2hpb258ZW58MXwxfHx8MTc5MzE2MDA3N3ww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1756483488645-5973a1a92e33?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8NHx8aW5kaWFuJTIwZXRobmljJTIwd2VhciUyMGZhc2hpb258ZW58MXwxfHx8MTc5MzE2MDA3N3ww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1610048869310-d889ff25c374?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8NXx8aW5kaWFuJTIwZXRobmljJTIwd2VhciUyMGZhc2hpb258ZW58MXwxfHx8MTc5MzE2MDA3N3ww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1522169092203-1cce6d311a0b?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Nnx8aW5kaWFuJTIwZXRobmljJTIwd2VhciUyMGZhc2hpb258ZW58MXwxfHx8MTc5MzE2MDA3N3ww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"}]},"styles":{},"isActive":true,"order":110},{"id":"brands","type":"brands","variant":"v1","props":{"title":"Brands we carry","layout":"ticker"},"styles":{},"isActive":true,"order":120},{"id":"cta","type":"cta","variant":"v1","props":{"title":"Hear about new collections first","subtitle":"New arrivals, restocks and members-only offers. No spam, unsubscribe any time.","placeholder":"Your email address","buttonText":"Sign up"},"styles":{},"isActive":true,"order":130}]},"shop":{"isActive":true,"sections":[{"id":"shop-grid","type":"shop-grid","variant":"v1","props":{"title":"Shop all","description":"Sarees, panjabi, three-piece and festive sets, woven and stitched in Bangladesh.","itemsPerPage":12,"allCategoriesLabel":"All","noProductsTitle":"Nothing here yet","noProductsMessage":"Try changing or clearing the filters."},"styles":{},"isActive":true,"order":0}]},"product":{"isActive":true,"sections":[{"id":"product-detail","type":"product-detail","variant":"v1","props":{"quantityLabel":"Quantity","addToCartText":"Add to bag","orderNowText":"Buy now","productDescTitle":"Description","returnPolicyTitle":"Delivery & returns","sizeGuideTitle":"Size guide","sizeGuide":"<table><thead><tr><th>Size</th><th>Chest (in)</th><th>Length (in)</th></tr></thead><tbody><tr><td>M</td><td>40</td><td>42</td></tr><tr><td>L</td><td>42</td><td>43</td></tr><tr><td>XL</td><td>44</td><td>44</td></tr><tr><td>XXL</td><td>46</td><td>45</td></tr></tbody></table><p>Panjabi and kameez measurements. Sarees are 5.5 m with a 0.8 m blouse piece.</p>","completeTheLookTitle":"Complete the look","showDeliveryAreas":true,"showFabric":true,"sareeDetails":"<p>Length 5.5 m with a 0.8 m unstitched blouse piece.</p>","careNotes":"<p>Dry clean only. Store folded in muslin cloth, away from damp.</p>","whatsappOrderLabel":"Order on WhatsApp"},"styles":{},"isActive":true,"order":0},{"id":"similar-products","type":"similar-products","variant":"v1","props":{"title":"You may also like"},"styles":{},"isActive":true,"order":10}]},"cart":{"isActive":true,"sections":[{"id":"cart","type":"cart","variant":"v1","props":{"pageTitle":"Bag","emptyTitle":"Your bag is empty","emptyMessage":"Find something you like and add it to your bag.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop","summaryTitle":"Summary","subtotalLabel":"Subtotal","shippingLabel":"Delivery","shippingCalculatedText":"Delivery is calculated at checkout.","totalLabel":"Total","checkoutButtonText":"Checkout","checkoutLink":"/checkout"},"styles":{},"isActive":true,"order":0}]},"checkout":{"isActive":true,"sections":[{"id":"checkout","type":"checkout","variant":"v1","props":{"pageTitle":"Checkout","emptyTitle":"Your bag is empty","emptyMessage":"Add something to your bag before you check out.","continueShoppingText":"Shop now","continueShoppingLink":"/shop","summaryTitle":"Your order","subtotalLabel":"Subtotal","shippingChargeLabel":"Delivery area","totalLabel":"Total","placeOrderText":"Place order","placingOrderText":"Placing order…"},"styles":{},"isActive":true,"order":0}]},"order-success":{"isActive":true,"sections":[{"id":"order-success","type":"order-success","variant":"v1","props":{"title":"Thank you","message":"Your order is in. We will call to confirm it before it ships.","errorTitle":"Your order was placed","errorMessage":"We could not load the order details on this device, but your order was received.","viewOrderText":"View order","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"categories":{"isActive":true,"sections":[{"id":"categories","type":"categories","variant":"v1","props":{"title":"Categories","subtitle":"Everything, sorted","columns":4,"emptyText":"No categories yet."},"styles":{},"isActive":true,"order":0}]},"wishlist":{"isActive":true,"sections":[{"id":"wishlist","type":"wishlist","variant":"v1","props":{"title":"Wishlist","subtitle":"Saved for later","emptyTitle":"Nothing saved yet","emptyText":"Tap the heart on any product to keep it here.","continueShoppingText":"Start shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"compare":{"isActive":true,"sections":[{"id":"compare","type":"compare","variant":"v1","props":{},"styles":{},"isActive":true,"order":0}]},"coupon":{"isActive":true,"sections":[{"id":"coupon","type":"coupon","variant":"v1","props":{"title":"Offers","coupons":[{"code":"FIRST10","title":"Ten percent off","description":"On your first order.","discount":"10% off"},{"code":"FRIDAY","title":"Eid collection","description":"On new arrivals, every Friday.","discount":"15% off"}]},"styles":{},"isActive":true,"order":0}]},"track-order":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Track your order","content":"<p>Enter your order number and phone to see where your order is. Signed in? Your orders are under <a href=\\"/account/orders\\">My orders</a>.</p>"},"styles":{},"isActive":true,"order":0}]},"signin":{"isActive":true,"sections":[{"id":"signin","type":"signin","variant":"v1","props":{"title":"Sign in","intro":"Sign in or create an account with your mobile number.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"signup":{"isActive":true,"sections":[{"id":"signup","type":"signup","variant":"v2","props":{"title":"Create account","intro":"Create your account with your mobile number.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"account":{"isActive":true,"sections":[{"id":"account","type":"account","variant":"v1","props":{"tabOverviewLabel":"Overview","tabOrdersLabel":"Orders","tabAddressesLabel":"Addresses","tabDetailsLabel":"Profile","signOutLabel":"Sign out"},"styles":{},"isActive":true,"order":0}]},"contact":{"isActive":true,"sections":[{"id":"contact","type":"contact","variant":"v1","props":{"title":"Contact","description":"Questions about an order, a size or a return? Message or call us and we will get back to you within a day."},"styles":{},"isActive":true,"order":0}]},"blog":{"isActive":true,"sections":[{"id":"blog","type":"blog","variant":"v1","props":{"title":"Journal","posts":[],"showViewAll":false},"styles":{},"isActive":true,"order":0}]},"privacy-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Privacy policy","content":"<p>This policy explains what we collect when you shop with us and how we use it.</p><h2>What we collect</h2><p>Your name, phone number, delivery address and order history, so we can deliver your orders and help you with them.</p><h2>How we use it</h2><p>To process and deliver orders, to contact you about them and, if you agree, to tell you about new arrivals. We never sell your details.</p><h2>Your choices</h2><p>You can ask us to update or delete your details at any time through the contact page.</p>"},"styles":{},"isActive":true,"order":0}]},"shipping-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Shipping policy","content":"<p>We deliver to every area listed at checkout. The delivery charge for your area is shown before you place the order.</p><h2>Delivery times</h2><p>Orders inside the city usually arrive in 1–2 days and elsewhere in 3–5 days.</p><h2>Payment</h2><p>Pay in cash when your order arrives. Please check the parcel before you pay.</p>"},"styles":{},"isActive":true,"order":0}]},"terms-of-service":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Terms of service","content":"<p>By placing an order you agree to these terms.</p><h2>Orders</h2><p>An order is confirmed once we call or message you to confirm it. We may cancel an order if an item is out of stock.</p><h2>Prices</h2><p>Prices are shown in the store currency and include all taxes. Delivery is charged separately and shown at checkout.</p><h2>Changes</h2><p>We may update these terms. The version on this page applies to new orders.</p>"},"styles":{},"isActive":true,"order":0}]},"return-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Return policy","content":"<p>Wrong size or changed your mind? You can return or exchange unworn items within 7 days of delivery.</p><h2>How to return</h2><p>Contact us with your order number. Items must be unworn, unwashed and have their tags.</p><h2>Refunds</h2><p>Once we receive and check the item, we refund the amount or send the replacement within 5 working days.</p>"},"styles":{},"isActive":true,"order":0}]}}'), GA = {
  seo: _A,
  config: HA,
  pages: UA
}, YA = { title: "Tanabana — everyday clothing for the whole family", description: "Comfortable T-shirts, polos, panjabi and kidswear in every size, with cash on delivery across the country.", keywords: ["clothing", "t-shirts", "polo", "panjabi", "kidswear", "fashion"], ogImage: "https://images.unsplash.com/photo-1582225905616-c3adc77ada6b?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8c3RyZWV0d2VhciUyMG1vZGVsJTIwdXJiYW58ZW58MXwxfHx8MTc5MzE2MDA2Mnww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80", index_allow: !0 }, XA = { themeId: "apparels-4", appearance: { colorMode: "light", product_image_aspect_ratio: "aspect-[3/4]" }, header: { variant: "v1", sticky: !0, topbar: { active: !1 }, actions: { showSearch: !0, showCart: !0, showAccount: !0, showWishlist: !0, cartAction: "sidebar" }, searchPlaceholder: "Search T-shirts, polos, panjabi…", searchConfig: { showPrice: !0, showCategory: !0, showImage: !0, maxResults: 6 }, menu: [{ label: "Shop", href: "/shop", type: "categories" }, { label: "New in", href: "/shop?order_by=newest_first", type: "link", badge: "New" }, { label: "Sale", href: "/shop?order_by=discount_desc", type: "link" }, { label: "Journal", href: "/blog", type: "link" }, { label: "Contact", href: "/contact", type: "link" }] }, footer: { variant: "v1", title: "Tanabana", description: "Comfortable everyday clothes for men, women and kids, made from fabrics we check ourselves.", columns: [{ title: "Shop", links: [{ label: "All products", href: "/shop" }, { label: "New in", href: "/shop?order_by=newest_first" }, { label: "Categories", href: "/categories" }, { label: "Offers", href: "/coupon" }] }, { title: "Help", links: [{ label: "Track order", href: "/track-order" }, { label: "Shipping policy", href: "/shipping-policy" }, { label: "Return policy", href: "/return-policy" }, { label: "Contact us", href: "/contact" }] }, { title: "About", links: [{ label: "Journal", href: "/blog" }, { label: "Privacy policy", href: "/privacy-policy" }, { label: "Terms of service", href: "/terms-of-service" }] }], socialLinks: [], copyright: "© Tanabana. All rights reserved.", paymentMethods: [{ platform: "bkash" }, { platform: "nagad" }], note: "Packed with care and delivered to your door." }, floatingButtons: { active: !0, callUsTitle: "Call us", whatsappTitle: "WhatsApp", messengerTitle: "Messenger" }, mobileBottomNav: { active: !0, items: [{ label: "Home", icon: "home", actionType: "link", href: "/", isPrimary: !1 }, { label: "Category", icon: "shop", actionType: "categories", href: "/shop", isPrimary: !1 }, { label: "Cart", icon: "cart", actionType: "link", href: "/cart", isPrimary: !1 }, { label: "Chat", icon: "chat", actionType: "link", href: "", isPrimary: !1 }, { label: "Account", icon: "account", actionType: "link", href: "/account", isPrimary: !1 }] } }, jA = /* @__PURE__ */ JSON.parse('{"home":{"isActive":true,"sections":[{"id":"banner-carousel","type":"banner-carousel","variant":"v1","props":{"title":"Featured","autoplay":true,"autoplaySeconds":5,"slides":[{"image":"https://images.unsplash.com/photo-1789879316263-097c9af7bfdd?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8NXx8bWVuJTIwY290dG9uJTIwc2hpcnQlMjBvdXRkb29yfGVufDF8MHx8fDE3OTM1MzM4MzN8MA&ixlib=rb-4.1.0&w=1920&h=550&fit=crop&crop=entropy&auto=format&q=80","mobileImage":"https://images.unsplash.com/photo-1789879316263-097c9af7bfdd?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8NXx8bWVuJTIwY290dG9uJTIwc2hpcnQlMjBvdXRkb29yfGVufDF8MHx8fDE3OTM1MzM4MzN8MA&ixlib=rb-4.1.0&w=780&h=600&fit=crop&crop=entropy&auto=format&q=80","alt":"Summer cotton collection","title":"Summer cotton","subtitle":"Soft, breathable everyday wear","ctaText":"Shop now","ctaLink":"/shop"},{"image":"https://images.unsplash.com/photo-1675064370267-9d2159af55d9?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8bWFuJTIwd2VhcmluZyUyMHBhbmphYml8ZW58MXwwfHx8MTc5MzUzMzgzNHww&ixlib=rb-4.1.0&w=1920&h=550&fit=crop&crop=entropy&auto=format&q=80","mobileImage":"https://images.unsplash.com/photo-1675064370267-9d2159af55d9?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8bWFuJTIwd2VhcmluZyUyMHBhbmphYml8ZW58MXwwfHx8MTc5MzUzMzgzNHww&ixlib=rb-4.1.0&w=780&h=600&fit=crop&crop=entropy&auto=format&q=80","alt":"New panjabi collection","title":"Festive panjabi","subtitle":"Fresh cuts for the season","ctaText":"Explore","ctaLink":"/shop?order_by=newest_first"}]},"styles":{},"isActive":true,"order":0},{"id":"categories","type":"categories","variant":"v2","props":{"title":"Shop now","limit":3,"promoText":"Cash on delivery all over the country","promoLink":"/shop"},"styles":{},"isActive":true,"order":1},{"id":"announcement-bar","type":"announcement-bar","variant":"v1","props":{"items":[{"lead":"Team T-shirts","text":"Custom printed T-shirts for your team or event, with no minimum order.","linkLabel":"Ask us","link":"/contact"}]},"styles":{},"isActive":true,"order":2},{"id":"new-arrivals","type":"new-arrivals","variant":"v1","props":{"title":"New arrival","subtitle":"","limit":18,"showDetails":true},"styles":{},"isActive":true,"order":3},{"id":"banner","type":"banner","variant":"v2","props":{"banners":[{"image":"https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8Y2xvdGhpbmclMjBzYWxlJTIwcmFja3xlbnwxfDB8fHwxNzkzNTMzODM1fDA&ixlib=rb-4.1.0&w=1200&h=525&fit=crop&crop=entropy&auto=format&q=80","title":"","ctaLink":"/shop?order_by=discount_desc"},{"image":"https://images.unsplash.com/photo-1629426958003-35a5583b2977?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8Zm9sZGVkJTIwdC1zaGlydHMlMjBjb2xvcmZ1bHxlbnwxfDB8fHwxNzkzNTMzODM2fDA&ixlib=rb-4.1.0&w=1200&h=525&fit=crop&crop=entropy&auto=format&q=80","title":"","ctaLink":"/shop?order_by=newest_first"}]},"styles":{},"isActive":true,"order":4},{"id":"category-bento","type":"category-bento","variant":"v1","props":{"eyebrow":"","title":"","subtitle":"","tiles":[],"limit":6},"styles":{},"isActive":true,"order":5},{"id":"story","type":"story","variant":"v1","props":{"title":"Tanabana","subtitle":"Comfortable clothes you can wear every day.","text":"We choose soft, breathable fabrics, check every stitch and size, and price fairly, so your everyday clothes look good and last.","image":"https://images.unsplash.com/photo-1591195854242-8804547cdcab?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8Y290dG9uJTIwZmFicmljJTIwdGV4dHVyZXxlbnwxfDB8fHwxNzkzNTMzODM2fDA&ixlib=rb-4.1.0&w=800&h=500&fit=crop&crop=entropy&auto=format&q=80","points":[],"ctaLink":"/about","ctaLabel":""},"styles":{},"isActive":true,"order":6},{"id":"featured-category","type":"featured-category","variant":"v1","props":{"title":"Men","subtitle":"","image":"https://images.unsplash.com/photo-1625910513413-c23b8bb81cba?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8bWFuJTIwY2FzdWFsJTIwcG9sbyUyMHNoaXJ0fGVufDF8MXx8fDE3OTM1MzM4Mzd8MA&ixlib=rb-4.1.0&w=600&h=800&fit=crop&crop=entropy&auto=format&q=80","rows":2,"viewAllText":"View more"},"styles":{},"isActive":true,"order":7},{"id":"featured-category-2","type":"featured-category","variant":"v2","props":{"title":"Women","subtitle":"","image":"https://images.unsplash.com/photo-1708534419572-6e6614a53ca1?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d29tYW4lMjBrdXJ0aSUyMGZhc2hpb258ZW58MXwxfHx8MTc5MzUzMzgzN3ww&ixlib=rb-4.1.0&w=600&h=800&fit=crop&crop=entropy&auto=format&q=80","rows":2,"viewAllText":"View more"},"styles":{},"isActive":true,"order":8},{"id":"featured-category-3","type":"featured-category","variant":"v1","props":{"title":"Kids","subtitle":"","image":"https://images.unsplash.com/photo-1607453998825-f3f36da5ab18?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Nnx8a2lkcyUyMGNsb3RoaW5nfGVufDF8MXx8fDE3OTM1MzM4Mzh8MA&ixlib=rb-4.1.0&w=600&h=800&fit=crop&crop=entropy&auto=format&q=80","rows":2,"viewAllText":"View more"},"styles":{},"isActive":true,"order":9},{"id":"offer-banner","type":"offer-banner","variant":"v1","props":{"title":"Everyday cotton, fairly priced","subtitle":"Pure cotton basics in every size, delivered to your door.","ctaText":"Shop basics","ctaLink":"/shop"},"styles":{},"isActive":true,"order":10},{"id":"corporate-band","type":"corporate-band","variant":"v1","props":{"eyebrow":"","title":"Bulk order / wholesale","text":"Plain or printed T-shirts and polos for your team, school or event, at wholesale prices and with no minimum order.","cta":{"url":"/contact"},"images":[{"image":"https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8cGxhaW4lMjB0LXNoaXJ0fGVufDF8Mnx8fDE3OTM1MzM4Mzh8MA&ixlib=rb-4.1.0&w=300&h=300&fit=crop&crop=entropy&auto=format&q=80"},{"image":"https://images.unsplash.com/photo-1631479501467-a46d06c900fc?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8N3x8cGxhaW4lMjB0LXNoaXJ0fGVufDF8Mnx8fDE3OTM1MzM4Mzh8MA&ixlib=rb-4.1.0&w=300&h=300&fit=crop&crop=entropy&auto=format&q=80"},{"image":"https://images.unsplash.com/photo-1623041202328-91f087f1635d?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8OHx8cGxhaW4lMjB0LXNoaXJ0fGVufDF8Mnx8fDE3OTM1MzM4Mzh8MA&ixlib=rb-4.1.0&w=300&h=300&fit=crop&crop=entropy&auto=format&q=80"},{"image":"https://images.unsplash.com/photo-1553754507-b3f37c9f11a6?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8NXx8cGxhaW4lMjB0LXNoaXJ0fGVufDF8Mnx8fDE3OTM1MzM4Mzh8MA&ixlib=rb-4.1.0&w=300&h=300&fit=crop&crop=entropy&auto=format&q=80"},{"image":"https://images.unsplash.com/photo-1669791777784-dddd07abc8a5?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Nnx8cGxhaW4lMjB0LXNoaXJ0fGVufDF8Mnx8fDE3OTM1MzM4Mzh8MA&ixlib=rb-4.1.0&w=300&h=300&fit=crop&crop=entropy&auto=format&q=80"}]},"styles":{},"isActive":true,"order":11},{"id":"brands","type":"brands","variant":"v1","props":{"title":"Trusted by teams, schools and events","subtitle":"We make uniforms and event shirts for organisations across the country.","layout":"grid","items":[]},"styles":{},"isActive":true,"order":12},{"id":"cta","type":"cta","variant":"v1","props":{"image":"https://images.unsplash.com/photo-1584365132623-e273491c69d2?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Nnx8dGVhbSUyMG1hdGNoaW5nJTIwdC1zaGlydHN8ZW58MXwwfHx8MTc5MzUzMzgzOXww&ixlib=rb-4.1.0&w=1240&h=200&fit=crop&crop=entropy&auto=format&q=80","mobileImage":"https://images.unsplash.com/photo-1584365132623-e273491c69d2?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Nnx8dGVhbSUyMG1hdGNoaW5nJTIwdC1zaGlydHN8ZW58MXwwfHx8MTc5MzUzMzgzOXww&ixlib=rb-4.1.0&w=780&h=340&fit=crop&crop=entropy&auto=format&q=80","link":"/contact","title":"Become a reseller","subtitle":"Sell our clothes and earn on every order.","buttonText":"Join now"},"styles":{},"isActive":true,"order":13}]},"shop":{"isActive":true,"sections":[{"id":"shop-grid","type":"shop-grid","variant":"v1","props":{"title":"Shop all","description":"T-shirts, polos, trousers and accessories for every day.","itemsPerPage":12,"allCategoriesLabel":"All","noProductsTitle":"Nothing here yet","noProductsMessage":"Try changing or clearing the filters."},"styles":{},"isActive":true,"order":0}]},"product":{"isActive":true,"sections":[{"id":"product-detail","type":"product-detail","variant":"v1","props":{"quantityLabel":"Quantity","addToCartText":"Add to bag","orderNowText":"Buy now","productDescTitle":"Description","returnPolicyTitle":"Delivery & returns","sizeGuideTitle":"Size guide","sizeGuide":"<p>Measurements are in inches, taken flat across the garment. Between two sizes? Take the larger one for a relaxed fit.</p><table><thead><tr><th>Size</th><th>Chest</th><th>Length</th><th>Shoulder</th><th>Sleeve</th></tr></thead><tbody><tr><td>S</td><td>38</td><td>27</td><td>17.5</td><td>8</td></tr><tr><td>M</td><td>40</td><td>28</td><td>18</td><td>8.5</td></tr><tr><td>L</td><td>42</td><td>29</td><td>19</td><td>9</td></tr><tr><td>XL</td><td>44</td><td>30</td><td>20</td><td>9.5</td></tr><tr><td>XXL</td><td>46</td><td>31</td><td>21</td><td>10</td></tr></tbody></table><h3>How to measure</h3><ul><li><strong>Chest:</strong> straight across, one inch below the armholes.</li><li><strong>Length:</strong> from the highest point of the shoulder to the hem.</li><li><strong>Shoulder:</strong> from one shoulder seam to the other.</li></ul>","completeTheLookTitle":"Complete the look","showDeliveryAreas":true},"styles":{},"isActive":true,"order":0},{"id":"similar-products","type":"similar-products","variant":"v1","props":{"title":"You may also like"},"styles":{},"isActive":true,"order":10}]},"cart":{"isActive":true,"sections":[{"id":"cart","type":"cart","variant":"v1","props":{"pageTitle":"Bag","emptyTitle":"Your bag is empty","emptyMessage":"Find something you like and add it to your bag.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop","summaryTitle":"Summary","subtotalLabel":"Subtotal","shippingLabel":"Delivery","shippingCalculatedText":"Delivery is calculated at checkout.","totalLabel":"Total","checkoutButtonText":"Checkout","checkoutLink":"/checkout"},"styles":{},"isActive":true,"order":0}]},"checkout":{"isActive":true,"sections":[{"id":"checkout","type":"checkout","variant":"v1","props":{"pageTitle":"Checkout","emptyTitle":"Your bag is empty","emptyMessage":"Add something to your bag before you check out.","continueShoppingText":"Shop now","continueShoppingLink":"/shop","summaryTitle":"Your order","subtotalLabel":"Subtotal","shippingChargeLabel":"Delivery area","totalLabel":"Total","placeOrderText":"Place order","placingOrderText":"Placing order…"},"styles":{},"isActive":true,"order":0}]},"order-success":{"isActive":true,"sections":[{"id":"order-success","type":"order-success","variant":"v1","props":{"title":"Thank you","message":"Your order is in. We will call to confirm it before it ships.","errorTitle":"Your order was placed","errorMessage":"We could not load the order details on this device, but your order was received.","viewOrderText":"View order","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"categories":{"isActive":true,"sections":[{"id":"categories","type":"categories","variant":"v1","props":{"title":"Categories","subtitle":"Everything, sorted","columns":4,"emptyText":"No categories yet."},"styles":{},"isActive":true,"order":0}]},"wishlist":{"isActive":true,"sections":[{"id":"wishlist","type":"wishlist","variant":"v1","props":{"title":"Wishlist","subtitle":"Saved for later","emptyTitle":"Nothing saved yet","emptyText":"Tap the heart on any product to keep it here.","continueShoppingText":"Start shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"compare":{"isActive":true,"sections":[{"id":"compare","type":"compare","variant":"v1","props":{},"styles":{},"isActive":true,"order":0}]},"coupon":{"isActive":true,"sections":[{"id":"coupon","type":"coupon","variant":"v1","props":{"title":"Offers","coupons":[{"code":"FIRST10","title":"Ten percent off","description":"On your first order.","discount":"10% off"},{"code":"FRIDAY","title":"Friday drop","description":"On new arrivals, every Friday.","discount":"15% off"}]},"styles":{},"isActive":true,"order":0}]},"track-order":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Track your order","content":"<p>Enter your order number and phone to see where your order is. Signed in? Your orders are under <a href=\\"/account/orders\\">My orders</a>.</p>"},"styles":{},"isActive":true,"order":0}]},"signin":{"isActive":true,"sections":[{"id":"signin","type":"signin","variant":"v1","props":{"title":"Sign in","intro":"Sign in or create an account with your mobile number.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"signup":{"isActive":true,"sections":[{"id":"signup","type":"signup","variant":"v2","props":{"title":"Create account","intro":"Create your account with your mobile number.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"account":{"isActive":true,"sections":[{"id":"account","type":"account","variant":"v1","props":{"tabOverviewLabel":"Overview","tabOrdersLabel":"Orders","tabAddressesLabel":"Addresses","tabDetailsLabel":"Profile","signOutLabel":"Sign out"},"styles":{},"isActive":true,"order":0}]},"contact":{"isActive":true,"sections":[{"id":"contact","type":"contact","variant":"v1","props":{"title":"Contact","description":"Questions about an order, a size or a return? Message or call us and we will get back to you within a day."},"styles":{},"isActive":true,"order":0}]},"blog":{"isActive":true,"sections":[{"id":"blog","type":"blog","variant":"v1","props":{"title":"Journal","posts":[],"showViewAll":false},"styles":{},"isActive":true,"order":0}]},"privacy-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Privacy policy","content":"<p>This policy explains what we collect when you shop with us and how we use it.</p><h2>What we collect</h2><p>Your name, phone number, delivery address and order history, so we can deliver your orders and help you with them.</p><h2>How we use it</h2><p>To process and deliver orders, to contact you about them and, if you agree, to tell you about new arrivals. We never sell your details.</p><h2>Your choices</h2><p>You can ask us to update or delete your details at any time through the contact page.</p>"},"styles":{},"isActive":true,"order":0}]},"shipping-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Shipping policy","content":"<p>We deliver to every area listed at checkout. The delivery charge for your area is shown before you place the order.</p><h2>Delivery times</h2><p>Orders inside the city usually arrive in 1–2 days and elsewhere in 3–5 days.</p><h2>Payment</h2><p>Pay in cash when your order arrives. Please check the parcel before you pay.</p>"},"styles":{},"isActive":true,"order":0}]},"terms-of-service":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Terms of service","content":"<p>By placing an order you agree to these terms.</p><h2>Orders</h2><p>An order is confirmed once we call or message you to confirm it. We may cancel an order if an item is out of stock.</p><h2>Prices</h2><p>Prices are shown in the store currency and include all taxes. Delivery is charged separately and shown at checkout.</p><h2>Changes</h2><p>We may update these terms. The version on this page applies to new orders.</p>"},"styles":{},"isActive":true,"order":0}]},"return-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Return policy","content":"<p>Wrong size or changed your mind? You can return or exchange unworn items within 7 days of delivery.</p><h2>How to return</h2><p>Contact us with your order number. Items must be unworn, unwashed and have their tags.</p><h2>Refunds</h2><p>Once we receive and check the item, we refund the amount or send the replacement within 5 working days.</p>"},"styles":{},"isActive":true,"order":0}]}}'), qA = {
  seo: YA,
  config: XA,
  pages: jA
}, ZA = { title: "Mohalla — streetwear made local", description: "Drop-shoulder tees, hoodies, polos and everyday streetwear, delivered across Bangladesh with cash on delivery.", keywords: ["clothing", "t-shirts", "polo", "panjabi", "kidswear", "fashion"], ogImage: "https://images.unsplash.com/photo-1582225905616-c3adc77ada6b?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8c3RyZWV0d2VhciUyMG1vZGVsJTIwdXJiYW58ZW58MXwxfHx8MTc5MzE2MDA2Mnww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80", index_allow: !0 }, JA = { themeId: "apparels-5", appearance: { colorMode: "light", product_image_aspect_ratio: "aspect-[3/4]" }, header: { variant: "v1", sticky: !0, topbar: { active: !0, messages: [{ text: "Streetwear from *our own mohalla*, delivered across the country." }], links: [{ label: "Track order", href: "/track-order" }, { label: "Stores", href: "/contact" }] }, actions: { showSearch: !0, showCart: !0, showAccount: !0, showWishlist: !0, cartAction: "sidebar" }, searchPlaceholder: "Search T-shirts, polos, panjabi…", searchConfig: { showPrice: !0, showCategory: !0, showImage: !0, maxResults: 6 }, menu: [{ label: "Shop", href: "/shop", type: "categories" }, { label: "New in", href: "/shop?order_by=newest_first", type: "link", badge: "New" }, { label: "Sale", href: "/shop?order_by=discount_desc", type: "link" }, { label: "Journal", href: "/blog", type: "link" }, { label: "Contact", href: "/contact", type: "link" }, { label: "About", href: "/about", type: "link" }] }, footer: { variant: "v1", title: "Mohalla", description: "Streetwear with something to say: our own designs, cut and checked by our team.", columns: [{ title: "Shop", links: [{ label: "All products", href: "/shop" }, { label: "New in", href: "/shop?order_by=newest_first" }, { label: "Categories", href: "/categories" }, { label: "Offers", href: "/coupon" }] }, { title: "Help", links: [{ label: "Track order", href: "/track-order" }, { label: "Shipping policy", href: "/shipping-policy" }, { label: "Return policy", href: "/return-policy" }, { label: "Contact us", href: "/contact" }] }, { title: "About", links: [{ label: "Journal", href: "/blog" }, { label: "Privacy policy", href: "/privacy-policy" }, { label: "Terms of service", href: "/terms-of-service" }] }], socialLinks: [], copyright: "© Mohalla. All rights reserved.", paymentMethods: [{ platform: "bkash" }, { platform: "nagad" }], note: "Packed with care and delivered to your door." }, floatingButtons: { active: !0, callUsTitle: "Call us", whatsappTitle: "WhatsApp", messengerTitle: "Messenger" }, mobileBottomNav: { active: !0, items: [{ label: "Home", icon: "home", actionType: "link", href: "/", isPrimary: !1 }, { label: "Categories", icon: "shop", actionType: "categories", href: "/shop", isPrimary: !1 }, { label: "Cart", icon: "cart", actionType: "link", href: "/cart", isPrimary: !1 }, { label: "Wishlist", icon: "heart", actionType: "link", href: "/wishlist", isPrimary: !1 }, { label: "Account", icon: "account", actionType: "link", href: "/account", isPrimary: !1 }] } }, KA = /* @__PURE__ */ JSON.parse('{"home":{"isActive":true,"sections":[{"id":"home-banner-carousel-0","type":"banner-carousel","variant":"v2","props":{"title":"Offers","autoplay":true,"autoplaySeconds":5,"slides":[{"image":"https://images.unsplash.com/photo-1633292750937-120a94f5c2bb?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8c3RyZWV0d2VhciUyMGhvb2RpZSUyMGZyaWVuZHN8ZW58MXwxfHx8MTc5MzY0MjM0NHww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"Two friends in boxy hoodies on a city street","title":"Boxy hoodies","subtitle":"Heavy cotton, dropped shoulders","ctaText":"Shop hoodies","ctaLink":"/shop"},{"image":"https://images.unsplash.com/photo-1727835523545-70ee992b5763?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8bWFuJTIwbGluZW4lMjBrdXJ0YXxlbnwxfDF8fHwxNzkzNjQyMzQ0fDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A man in a striped cotton katua","title":"Katua season","subtitle":"Soft cotton for long days","ctaText":"Order here","ctaLink":"/shop"},{"image":"https://images.unsplash.com/photo-1652380277664-6ed27b2179ae?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Mnx8ZnJpZW5kcyUyMHBsYWluJTIwcG9sbyUyMG91dGRvb3J8ZW58MXwxfHx8MTc5MzY0MzQ0OHww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A group in pastel polo shirts","title":"Easy in polos","subtitle":"Four colours, one fit","ctaText":"See polos","ctaLink":"/shop"},{"image":"https://images.unsplash.com/photo-1638501478003-4e9761dcfe22?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8N3x8Y2FyZGJvYXJkJTIwYm94JTIwZG9vcnxlbnwxfDF8fHwxNzkzNjQyNDYzfDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A parcel at a doorstep","title":"Free delivery","subtitle":"On orders over ৳1,999","ctaText":"Start shopping","ctaLink":"/shop"}]},"styles":{},"isActive":true,"order":0},{"id":"home-category-bento-1","type":"category-bento","variant":"v1","props":{"eyebrow":"","title":"Featured categories","subtitle":"","tiles":[],"limit":12},"styles":{},"isActive":true,"order":1},{"id":"home-instagram-feed-2","type":"instagram-feed","variant":"v5","props":{"title":"Highlights","items":[{"image":"https://images.unsplash.com/photo-1721637686340-de9f8cebda5a?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8b3ZlcnNpemVkJTIwdHNoaXJ0JTIwc3RyZWV0fGVufDF8MXx8fDE3OTM2NDIzNDZ8MA&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","caption":"Drop shoulder","link":"/shop"},{"image":"https://images.unsplash.com/photo-1762474316414-afbf5c1eff26?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8Z3JhcGhpYyUyMHRlZSUyMHBvcnRyYWl0fGVufDF8MXx8fDE3OTM2NDIzNDZ8MA&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","caption":"Street graphics","link":"/shop"},{"image":"https://images.unsplash.com/photo-1581655353564-df123a1eb820?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8cGxhaW4lMjB0c2hpcnQlMjBtb2RlbHxlbnwxfDF8fHwxNzkzNjQyMzQ3fDA&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","caption":"Solid basics","link":"/shop"},{"image":"https://images.unsplash.com/photo-1608146226687-b39d090a8c20?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8c3RyZWV0d2VhciUyMGNvdXBsZXxlbnwxfDF8fHwxNzkzNjQyMzQ3fDA&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","caption":"Made for you","link":"/shop"},{"image":"https://images.unsplash.com/photo-1761483882843-1ca9b83adf73?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d2ludGVyJTIwaG9vZGllJTIwY2l0eXxlbnwxfDF8fHwxNzkzNjQyMzQ4fDA&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","caption":"Winter layers","link":"/shop"},{"image":"https://images.unsplash.com/photo-1627639679690-db4d401aae84?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8M3x8a2lkcyUyMHRzaGlydHxlbnwxfDF8fHwxNzkzNjQyMzQ4fDA&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","caption":"Kids tees","link":"/shop"},{"image":"https://images.unsplash.com/photo-1625910513413-c23b8bb81cba?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8cG9sbyUyMHNoaXJ0JTIwbWFufGVufDF8MXx8fDE3OTM2NDIzNDl8MA&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","caption":"Polo edit","link":"/shop"},{"image":"https://images.unsplash.com/photo-1607748862156-7c548e7e98f4?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d2Vla2VuZCUyMG91dGZpdCUyMGZyaWVuZHN8ZW58MXwxfHx8MTc5MzY0MjM0OXww&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","caption":"Weekend fits","link":"/shop"}]},"styles":{},"isActive":true,"order":2},{"id":"home-banner-3","type":"banner","variant":"v3","props":{"title":"Wear your mood","banners":[{"image":"https://images.unsplash.com/photo-1716951735063-3d60c2c288e4?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8Zm9sZGVkJTIwdHNoaXJ0cyUyMHN0YWNrfGVufDF8Mnx8fDE3OTM2NDIzNTB8MA&ixlib=rb-4.1.0&w=800&h=800&fit=crop&crop=entropy&auto=format&q=80","alt":"Folded tees with a discount tag","title":"First order 5% off","ctaLink":"/shop"},{"image":"https://images.unsplash.com/photo-1777869356086-b0351f541ae7?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8Y2xvdGhpbmclMjBzdG9yZSUyMGZyb250fGVufDF8Mnx8fDE3OTM2NDIzNTB8MA&ixlib=rb-4.1.0&w=800&h=800&fit=crop&crop=entropy&auto=format&q=80","alt":"A new shop front at night","title":"New store open","ctaLink":"/contact"},{"image":"https://images.unsplash.com/photo-1645328225784-2a7b73847cc5?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8ZGVsaXZlcnklMjBtb3RvcmJpa2V8ZW58MXwyfHx8MTc5MzY0MjM1MXww&ixlib=rb-4.1.0&w=800&h=800&fit=crop&crop=entropy&auto=format&q=80","alt":"Parcels stacked on a delivery bike","title":"Free delivery","ctaLink":"/shop"},{"image":"https://images.unsplash.com/photo-1519568470290-c0c1fbfff16f?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8ZnJpZW5kcyUyMG1hdGNoaW5nJTIwc2hpcnRzfGVufDF8Mnx8fDE3OTM2NDIzNTJ8MA&ixlib=rb-4.1.0&w=800&h=800&fit=crop&crop=entropy&auto=format&q=80","alt":"Two friends in matching polos","title":"Polo edit","ctaLink":"/shop"}]},"styles":{},"isActive":true,"order":3},{"id":"home-lookbook-banner-4","type":"lookbook-banner","variant":"v2","props":{"title":"Wear your district","subtitle":"Graphic tees for every corner of the country","ctaText":"Find yours","ctaLink":"/shop","overlayOpacity":40,"image":"https://images.unsplash.com/photo-1601484437104-66abbd01c7f7?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8bWFuJTIwY2FtZXJhJTIwcml2ZXIlMjBmb3Jlc3R8ZW58MXwwfHx8MTc5MzY0MjM1Mnww&ixlib=rb-4.1.0&w=1920&h=700&fit=crop&crop=entropy&auto=format&q=80"},"styles":{},"isActive":true,"order":4},{"id":"home-product-slider-5","type":"product-slider","variant":"v1","props":{"title":"Pick your fit","subtitle":"","viewAllLabel":"Explore more","tabs":[]},"styles":{},"isActive":true,"order":5},{"id":"home-testimonials-6","type":"testimonials","variant":"v3","props":{"title":"Worn on our streets","intro":"Friends of the brand in their *favourite* pieces.","items":[{"avatar":"https://images.unsplash.com/photo-1750188179642-a60dd3e24369?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8YmFuZCUyMG11c2ljaWFucyUyMHBvcnRyYWl0fGVufDF8MXx8fDE3OTM2NDIzNTN8MA&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","name":"Riverline","designation":"Music band"},{"avatar":"https://images.unsplash.com/photo-1618924250456-0c7d405f2d53?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Mnx8d29tYW4lMjBwb3J0cmFpdCUyMHN0cmVldHdlYXJ8ZW58MXwxfHx8MTc5MzY0MjM1M3ww&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","name":"Tania R.","designation":"Actor"},{"avatar":"https://images.unsplash.com/photo-1724118135600-35009a8d6a89?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8eW91bmclMjBtYW4lMjBwb3J0cmFpdCUyMGNpdHl8ZW58MXwxfHx8MTc5MzY0MjM1NHww&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","name":"Arif H.","designation":"Content creator"},{"avatar":"https://images.unsplash.com/photo-1495745966610-2a67f2297e5e?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8cGhvdG9ncmFwaGVyJTIwcG9ydHJhaXR8ZW58MXwxfHx8MTc5MzY0MjM1NHww&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","name":"Nadia K.","designation":"Photographer"},{"avatar":"https://images.unsplash.com/photo-1516224498413-84ecf3a1e7fd?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8YXRobGV0ZSUyMHBvcnRyYWl0fGVufDF8MXx8fDE3OTM2NDIzNTV8MA&ixlib=rb-4.1.0&w=600&h=750&fit=crop&crop=entropy&auto=format&q=80","name":"Samir D.","designation":"Footballer"}]},"styles":{},"isActive":true,"order":6}]},"shop":{"isActive":true,"sections":[{"id":"shop-grid","type":"shop-grid","variant":"v1","props":{"title":"Shop all","description":"T-shirts, polos, trousers and accessories for every day.","itemsPerPage":12,"allCategoriesLabel":"All","noProductsTitle":"Nothing here yet","noProductsMessage":"Try changing or clearing the filters."},"styles":{},"isActive":true,"order":0}]},"product":{"isActive":true,"sections":[{"id":"product-detail","type":"product-detail","variant":"v1","props":{"quantityLabel":"Quantity","addToCartText":"Add to bag","orderNowText":"Buy now","productDescTitle":"Description","returnPolicyTitle":"Delivery & returns","sizeGuideTitle":"Size chart","sizeGuide":"<p>Measurements are in inches, taken flat across the garment. Between two sizes? Take the larger one for a relaxed fit.</p><table><thead><tr><th>Size</th><th>Chest</th><th>Length</th><th>Shoulder</th><th>Sleeve</th></tr></thead><tbody><tr><td>S</td><td>38</td><td>27</td><td>17.5</td><td>8</td></tr><tr><td>M</td><td>40</td><td>28</td><td>18</td><td>8.5</td></tr><tr><td>L</td><td>42</td><td>29</td><td>19</td><td>9</td></tr><tr><td>XL</td><td>44</td><td>30</td><td>20</td><td>9.5</td></tr><tr><td>XXL</td><td>46</td><td>31</td><td>21</td><td>10</td></tr></tbody></table><h3>How to measure</h3><ul><li><strong>Chest:</strong> straight across, one inch below the armholes.</li><li><strong>Length:</strong> from the highest point of the shoulder to the hem.</li><li><strong>Shoulder:</strong> from one shoulder seam to the other.</li></ul>","completeTheLookTitle":"Suggested picks","showDeliveryAreas":true,"deliveryPoints":[{"text":"Delivery all over Bangladesh"},{"text":"Cash on delivery available"},{"text":"Check the parcel before you pay"}],"trustCards":[{"icon":"shield","title":"Quality checked","text":"Every piece checked before it ships"},{"icon":"refresh","title":"Easy exchange","text":"Wrong size? Swap it within 7 days"},{"icon":"lock","title":"Safe payment","text":"Pay on delivery or online"}]},"styles":{},"isActive":true,"order":0}]},"cart":{"isActive":true,"sections":[{"id":"cart","type":"cart","variant":"v1","props":{"pageTitle":"Bag","emptyTitle":"Your bag is empty","emptyMessage":"Find something you like and add it to your bag.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop","summaryTitle":"Summary","subtotalLabel":"Subtotal","shippingLabel":"Delivery","shippingCalculatedText":"Delivery is calculated at checkout.","totalLabel":"Total","checkoutButtonText":"Checkout","checkoutLink":"/checkout"},"styles":{},"isActive":true,"order":0}]},"checkout":{"isActive":true,"sections":[{"id":"checkout","type":"checkout","variant":"v1","props":{"pageTitle":"Checkout","emptyTitle":"Your bag is empty","emptyMessage":"Add something to your bag before you check out.","continueShoppingText":"Shop now","continueShoppingLink":"/shop","summaryTitle":"Your order","subtotalLabel":"Subtotal","shippingChargeLabel":"Delivery area","totalLabel":"Total","placeOrderText":"Place order","placingOrderText":"Placing order…"},"styles":{},"isActive":true,"order":0}]},"order-success":{"isActive":true,"sections":[{"id":"order-success","type":"order-success","variant":"v1","props":{"title":"Thank you","message":"Your order is in. We will call to confirm it before it ships.","errorTitle":"Your order was placed","errorMessage":"We could not load the order details on this device, but your order was received.","viewOrderText":"View order","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"categories":{"isActive":true,"sections":[{"id":"categories","type":"categories","variant":"v1","props":{"title":"Categories","subtitle":"Everything, sorted","columns":4,"emptyText":"No categories yet."},"styles":{},"isActive":true,"order":0}]},"wishlist":{"isActive":true,"sections":[{"id":"wishlist","type":"wishlist","variant":"v1","props":{"title":"Wishlist","subtitle":"Saved for later","emptyTitle":"Nothing saved yet","emptyText":"Tap the heart on any product to keep it here.","continueShoppingText":"Start shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"compare":{"isActive":true,"sections":[{"id":"compare","type":"compare","variant":"v1","props":{},"styles":{},"isActive":true,"order":0}]},"coupon":{"isActive":true,"sections":[{"id":"coupon","type":"coupon","variant":"v1","props":{"title":"Offers","coupons":[{"code":"FIRST10","title":"Ten percent off","description":"On your first order.","discount":"10% off"},{"code":"FRIDAY","title":"Friday drop","description":"On new arrivals, every Friday.","discount":"15% off"}]},"styles":{},"isActive":true,"order":0}]},"track-order":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Track your order","content":"<p>Enter your order number and phone to see where your order is. Signed in? Your orders are under <a href=\\"/account/orders\\">My orders</a>.</p>"},"styles":{},"isActive":true,"order":0}]},"signin":{"isActive":true,"sections":[{"id":"signin","type":"signin","variant":"v1","props":{"title":"Sign in","intro":"Sign in or create an account with your mobile number.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"signup":{"isActive":true,"sections":[{"id":"signup","type":"signup","variant":"v2","props":{"title":"Create account","intro":"Create your account with your mobile number.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"account":{"isActive":true,"sections":[{"id":"account","type":"account","variant":"v1","props":{"tabOverviewLabel":"Overview","tabOrdersLabel":"Orders","tabAddressesLabel":"Addresses","tabDetailsLabel":"Profile","signOutLabel":"Sign out"},"styles":{},"isActive":true,"order":0}]},"contact":{"isActive":true,"sections":[{"id":"contact-hero-0","type":"hero","variant":"v5","props":{"eyebrow":"Customer care","headline":"Talk to us.","highlight":"Any day, any way.","text":"Questions about an order, a size, a swap or a bulk order? Pick whichever is easiest for you.","ctaText":"Shop now","ctaLink":"/shop","linkText":"Track an order","linkHref":"/track-order","cardWord":"Care","cardText":"Real people, clear answers, every day of the week.","cardLabel":"Dhaka","cardLabelEnd":"Since 2024"},"styles":{},"isActive":true,"order":0},{"id":"contact-contact-1","type":"contact","variant":"v1","props":{"eyebrow":"Pick a way in","title":"Get in","highlight":"touch.","description":"For the quickest help, keep your order number or phone number to hand when you get in touch.","channels":[{"icon":"phone","label":"Call","title":"Call us","text":"Orders, sizes and delivery questions."},{"icon":"whatsapp","label":"WhatsApp","title":"WhatsApp","text":"Send a quick message to the team.","linkText":"Chat on WhatsApp"},{"icon":"mail","label":"Email","title":"Email us","text":"Bulk orders, partnerships and anything else."},{"icon":"map-pin","label":"Visit","title":"Visit us","text":"Try the fits in person at our store.","linkText":"View location"}],"mapEyebrow":"Visit the store","mapTitle":"Come see us at","mapOutline":"the neighbourhood.","mapText":"Drop by to try the fits, pick up an order or swap a size. Calling before you come helps.","mapLinkText":"Open in maps","formEyebrow":"Send a message","formTitle":"Tell us what","formHighlight":"you need.","formText":"Leave your name, a way to reach you and your message, and we will get back to you soon."},"styles":{},"isActive":true,"order":1},{"id":"contact-promises-2","type":"promises","variant":"v2","props":{"eyebrow":"","title":"Help with","subtitle":"","highlight":"anything you need.","items":[{"title":"Order status and tracking"},{"title":"Size, fit and product advice"},{"title":"Delivery, swaps and payments"},{"title":"Bulk, team and custom orders"}]},"styles":{},"isActive":true,"order":2},{"id":"contact-content-3","type":"content","variant":"v3","props":{"eyebrow":"Good to know","highlight":"answered.","subtitle":"The questions we hear most often, answered by the team.","helpText":"Need help?","helpLink":"/contact","faqs":[{"question":"How do I place an order?","answer":"Pick a size, add the piece to your cart and check out. You can also call or message us and we will place it for you."},{"question":"Which payment methods can I use?","answer":"Cash on delivery, cards and mobile banking."},{"question":"How long does delivery take?","answer":"Usually one to two days inside the city and three to five days elsewhere."},{"question":"Can I swap a size?","answer":"Yes, within 7 days, as long as the piece is unworn with its tags on."}],"title":"Questions,"},"styles":{},"isActive":true,"order":3}]},"blog":{"isActive":true,"sections":[{"id":"blog","type":"blog","variant":"v1","props":{"title":"Journal","posts":[],"showViewAll":false},"styles":{},"isActive":true,"order":0}]},"privacy-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Privacy policy","content":"<p>This policy explains what we collect when you shop with us and how we use it.</p><h2>What we collect</h2><p>Your name, phone number, delivery address and order history, so we can deliver your orders and help you with them.</p><h2>How we use it</h2><p>To process and deliver orders, to contact you about them and, if you agree, to tell you about new arrivals. We never sell your details.</p><h2>Your choices</h2><p>You can ask us to update or delete your details at any time through the contact page.</p>"},"styles":{},"isActive":true,"order":0}]},"shipping-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Shipping policy","content":"<p>We deliver to every area listed at checkout. The delivery charge for your area is shown before you place the order.</p><h2>Delivery times</h2><p>Orders inside the city usually arrive in 1–2 days and elsewhere in 3–5 days.</p><h2>Payment</h2><p>Pay in cash when your order arrives. Please check the parcel before you pay.</p>"},"styles":{},"isActive":true,"order":0}]},"terms-of-service":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Terms of service","content":"<p>By placing an order you agree to these terms.</p><h2>Orders</h2><p>An order is confirmed once we call or message you to confirm it. We may cancel an order if an item is out of stock.</p><h2>Prices</h2><p>Prices are shown in the store currency and include all taxes. Delivery is charged separately and shown at checkout.</p><h2>Changes</h2><p>We may update these terms. The version on this page applies to new orders.</p>"},"styles":{},"isActive":true,"order":0}]},"return-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Return policy","content":"<p>Wrong size or changed your mind? You can return or exchange unworn items within 7 days of delivery.</p><h2>How to return</h2><p>Contact us with your order number. Items must be unworn, unwashed and have their tags.</p><h2>Refunds</h2><p>Once we receive and check the item, we refund the amount or send the replacement within 5 working days.</p>"},"styles":{},"isActive":true,"order":0}]},"about":{"isActive":true,"sections":[{"id":"about-hero-0","type":"hero","variant":"v5","props":{"eyebrow":"Streetwear from the neighbourhood","headline":"Drawn local.","highlight":"Worn loud.","text":"Heavy cotton, loose cuts and prints drawn in our own studio, for days spent out on the street.","ctaText":"Our story","ctaLink":"/about","linkText":"Shop the drop","linkHref":"/shop","cardWord":"Local","cardText":"Cut, sewn and printed close to home, in small runs.","cardLabel":"Dhaka","cardLabelEnd":"Since 2024"},"styles":{},"isActive":true,"order":0},{"id":"about-announcement-bar-1","type":"announcement-bar","variant":"v2","props":{"items":[{"text":"Made local"},{"text":"Worn loud"},{"text":"Since day one"},{"text":"Wear your street"}]},"styles":{},"isActive":true,"order":1},{"id":"about-features-2","type":"features","variant":"v4","props":{"items":[{"title":"2024","subtitle":"The first drop"},{"title":"Dhaka","subtitle":"Where we cut and print"},{"title":"40+","subtitle":"Prints in the archive"},{"title":"7 days","subtitle":"To swap a size"}]},"styles":{},"isActive":true,"order":2},{"id":"about-story-3","type":"story","variant":"v1","props":{"eyebrow":"Our story","title":"Started small,","subtitle":"Clothes with something to say, priced for everyday wear.","highlight":"worn everywhere.","text":"We started with a few graphic tees and a simple idea: clothes that feel like where you are from.\\n\\nToday every collection is drawn, cut and checked by our own team, and sold online and in our stores.","points":[{"title":"Our own designs, made for our streets"},{"title":"Quality, comfort and fair prices"},{"title":"Online and in stores across the country"}],"ctaLink":"/shop","ctaLabel":""},"styles":{},"isActive":true,"order":3},{"id":"about-features-4","type":"features","variant":"v5","props":{"eyebrow":"Why people pick us","title":"Made with","highlight":"something to say.","text":"Every piece starts with the street it is worn on: what people wear, how they move and what they want to say.","items":[{"icon":"sparkle","title":"Local roots","subtitle":"Drawn and printed by people from the neighbourhood."},{"icon":"star","title":"Bold prints","subtitle":"Graphics with something to say, in small runs."},{"icon":"shield","title":"Built to last","subtitle":"Heavy cotton and double stitching that keep their shape."},{"icon":"heart","title":"Fair prices","subtitle":"Streetwear you can wear every day, not once a year."}]},"styles":{},"isActive":true,"order":4},{"id":"about-cta-5","type":"cta","variant":"v2","props":{"eyebrow":"What comes next","title":"From our street","outline":"to yours.","subtitle":"We want to keep making clothes that feel like the neighbourhood: loud, local and made to be lived in, for more streets in more cities.","quote":"Wear it loud.","quoteText":"More than a slogan: the reason every print says something."},"styles":{},"isActive":true,"order":5}]}}'), QA = {
  seo: ZA,
  config: JA,
  pages: KA
}, eL = { title: "Juta — sneakers and shoes, delivered", description: "Sneakers, running shoes, sandals, loafers and kids shoes in EU sizes, delivered across Bangladesh with cash on delivery.", keywords: ["sneakers", "shoes", "running shoes", "sandals", "loafers", "kids shoes"], ogImage: "https://images.unsplash.com/photo-1574859154521-4f7aa07d91b9?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8M3x8c25lYWtlcnMlMjBmbGF0JTIwbGF5fGVufDF8MHx8fDE3OTM2OTY1NTN8MA&ixlib=rb-4.1.0&w=1200&h=630&fit=crop&crop=entropy&auto=format&q=80", index_allow: !0 }, tL = { themeId: "footwear-1", appearance: { colorMode: "light", product_image_aspect_ratio: "aspect-[3/4]" }, header: { variant: "v1", sticky: !0, topbar: { active: !0, messages: [{ text: "Free delivery on orders over *৳3,500*" }, { text: "Cash on delivery and bKash accepted" }, { text: "Wrong size? *Swap it within 7 days*" }], links: [{ label: "Track order", href: "/track-order" }, { label: "Size guide", href: "/contact" }] }, actions: { showSearch: !0, showCart: !0, showAccount: !0, showWishlist: !0, cartAction: "sidebar" }, searchPlaceholder: "Search sneakers, sandals and brands…", searchConfig: { showPrice: !0, showCategory: !0, showImage: !0, maxResults: 6 }, menu: [{ label: "New in", href: "/shop?order_by=newest_first", type: "link", badge: "New" }, { label: "Shop", href: "/shop", type: "categories" }, { label: "Sale", href: "/shop?order_by=discount_desc", type: "link" }, { label: "Journal", href: "/blog", type: "link" }, { label: "Contact", href: "/contact", type: "link" }] }, footer: { variant: "v1", title: "Juta", description: "Sneakers, runners and everyday shoes in EU sizes, checked pair by pair before they ship.", columns: [{ title: "Shop", links: [{ label: "All products", href: "/shop" }, { label: "New in", href: "/shop?order_by=newest_first" }, { label: "Categories", href: "/categories" }, { label: "Offers", href: "/coupon" }] }, { title: "Help", links: [{ label: "Track order", href: "/track-order" }, { label: "Shipping policy", href: "/shipping-policy" }, { label: "Return policy", href: "/return-policy" }, { label: "Contact us", href: "/contact" }] }, { title: "About", links: [{ label: "Journal", href: "/blog" }, { label: "Privacy policy", href: "/privacy-policy" }, { label: "Terms of service", href: "/terms-of-service" }] }], socialLinks: [], copyright: "© Juta. All rights reserved.", paymentMethods: [{ platform: "bkash" }, { platform: "nagad" }], note: "Every pair boxed, checked and delivered to your door." }, floatingButtons: { active: !0, callUsTitle: "Call us", whatsappTitle: "WhatsApp", messengerTitle: "Messenger" }, mobileBottomNav: { active: !0, items: [{ label: "Home", icon: "home", actionType: "link", href: "/", isPrimary: !1 }, { label: "Categories", icon: "shop", actionType: "categories", href: "/shop", isPrimary: !1 }, { label: "Wishlist", icon: "heart", actionType: "link", href: "/wishlist", isPrimary: !1 }, { label: "Cart", icon: "cart", actionType: "link", href: "/cart", isPrimary: !1 }, { label: "Account", icon: "account", actionType: "link", href: "/account", isPrimary: !1 }] } }, aL = /* @__PURE__ */ JSON.parse(`{"home":{"isActive":true,"sections":[{"id":"home-banner-carousel-1","type":"banner-carousel","variant":"v1","order":1,"isActive":true,"props":{"title":"Featured","autoplay":true,"autoplaySeconds":6,"slides":[{"image":"https://images.unsplash.com/photo-1499692526241-33b38bd6c2df?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8cnVubmluZyUyMHNob2VzJTIwc3RyZWV0fGVufDF8MHx8fDE3OTM2OTY1NTR8MA&ixlib=rb-4.1.0&w=1920&h=480&fit=crop&crop=entropy&auto=format&q=80","mobileImage":"https://images.unsplash.com/photo-1608819252414-35dcc0f21051?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8NHx8cnVubmVyJTIwdHlpbmclMjBzaG9lc3xlbnwxfDJ8fHwxNzkzNjk2NTU0fDA&ixlib=rb-4.1.0&w=780&h=880&fit=crop&crop=entropy&auto=format&q=80","alt":"A runner lacing up bright running shoes on a city street","eyebrow":"New in","title":"Run the city","subtitle":"Light, cushioned runners for early mornings and long days.","ctaText":"Shop running","ctaLink":"/shop"},{"image":"https://images.unsplash.com/photo-1591300424743-f601d8b0031a?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d2hpdGUlMjBzbmVha2VycyUyMGNvbmNyZXRlfGVufDF8MHx8fDE3OTM2OTY1NTV8MA&ixlib=rb-4.1.0&w=1920&h=480&fit=crop&crop=entropy&auto=format&q=80","mobileImage":"https://images.unsplash.com/photo-1643758344142-7933a8c07796?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Mnx8d2hpdGUlMjBzbmVha2VycyUyMGZlZXR8ZW58MXwyfHx8MTc5MzY5NjU1NXww&ixlib=rb-4.1.0&w=780&h=880&fit=crop&crop=entropy&auto=format&q=80","alt":"White low-top sneakers on a concrete step","eyebrow":"Everyday","title":"Clean whites, every day","subtitle":"Low-tops that go with everything you own.","ctaText":"Shop sneakers","ctaLink":"/shop"}]},"styles":{}},{"id":"home-banner-2","type":"banner","variant":"v2","order":2,"isActive":true,"props":{"banners":[{"image":"https://images.unsplash.com/photo-1638859436319-662beea3bfa8?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8M3x8c2FuZGFscyUyMHJhaW58ZW58MXwwfHx8MTc5MzY5NjU1Nnww&ixlib=rb-4.1.0&w=1240&h=310&fit=crop&crop=entropy&auto=format&q=80","title":"The monsoon edit","subtitle":"Sandals and slides that dry fast and grip wet roads.","ctaText":"Shop sandals","ctaLink":"/shop"}]},"styles":{}},{"id":"home-product-slider-3","type":"product-slider","variant":"v3","order":3,"isActive":true,"props":{"title":"Launches","subtitle":"","launchAt":"2026-12-05T10:00:00+06:00"},"styles":{}},{"id":"home-categories-4","type":"categories","variant":"v1","order":4,"isActive":true,"props":{"title":"Spotlight categories","subtitle":"","columns":4,"emptyText":"No categories yet."},"styles":{}},{"id":"home-category-bento-5","type":"category-bento","variant":"v1","order":5,"isActive":true,"props":{"eyebrow":"","title":"Shop by style","subtitle":"","tiles":[],"limit":5},"styles":{}},{"id":"home-brands-6","type":"brands","variant":"v1","order":6,"isActive":true,"props":{"title":"Our brands","subtitle":"","layout":"grid","items":[]},"styles":{}},{"id":"home-offer-banner-7","type":"offer-banner","variant":"v1","order":7,"isActive":true,"props":{"image":"","title":"Cash on delivery, bKash and Nagad","subtitle":"Try the pair on before you pay. Free delivery over ৳3,500.","ctaText":"How delivery works","ctaLink":"/shipping-policy"},"styles":{}},{"id":"home-product-grid-8","type":"product-grid","variant":"v1","order":8,"isActive":true,"props":{"title":"New in","subtitle":"","viewAllLink":"/shop?order_by=newest_first"},"styles":{}},{"id":"home-banner-carousel-9","type":"banner-carousel","variant":"v1","order":9,"isActive":true,"props":{"title":"Campaign","autoplay":false,"autoplaySeconds":6,"slides":[{"image":"https://images.unsplash.com/photo-1692014957348-a0865eb54792?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8c2Nob29sJTIwc2hvZXN8ZW58MXwwfHx8MTc5MzY5NjU1Nnww&ixlib=rb-4.1.0&w=1920&h=480&fit=crop&crop=entropy&auto=format&q=80","mobileImage":"https://images.unsplash.com/photo-1742392853164-93a8084fa402?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Mnx8a2lkcyUyMHNob2VzfGVufDF8Mnx8fDE3OTM2OTY1NTd8MA&ixlib=rb-4.1.0&w=780&h=880&fit=crop&crop=entropy&auto=format&q=80","alt":"Children's black school shoes lined up on a bench","eyebrow":"Kids","title":"Back to school","subtitle":"Hard-wearing school shoes in EU 28 to 35.","ctaText":"Shop kids","ctaLink":"/shop"}]},"styles":{}}]},"shop":{"isActive":true,"sections":[{"id":"shop-grid","type":"shop-grid","variant":"v1","props":{"title":"Shop all","description":"Sneakers, running shoes, sandals, loafers and kids shoes, in EU sizes.","itemsPerPage":12,"allCategoriesLabel":"All","noProductsTitle":"Nothing here yet","noProductsMessage":"Try changing or clearing the filters."},"styles":{},"isActive":true,"order":0}]},"product":{"isActive":true,"sections":[{"id":"product-detail","type":"product-detail","variant":"v1","props":{"quantityLabel":"Quantity","addToCartText":"Add to cart","orderNowText":"Buy now","productDescTitle":"Description","returnPolicyTitle":"Delivery & returns","sizeGuideTitle":"Size guide","sizeGuide":"<p>Measure your foot from heel to longest toe, standing, in the evening. Pick the size whose length matches; between two sizes, take the larger one.</p><table><thead><tr><th>EU</th><th>UK</th><th>US men</th><th>US women</th><th>Foot (cm)</th></tr></thead><tbody><tr><td>36</td><td>3.5</td><td>4.5</td><td>6</td><td>22.5</td></tr><tr><td>37</td><td>4</td><td>5</td><td>6.5</td><td>23.5</td></tr><tr><td>38</td><td>5</td><td>6</td><td>7.5</td><td>24</td></tr><tr><td>39</td><td>6</td><td>6.5</td><td>8</td><td>24.5</td></tr><tr><td>40</td><td>6.5</td><td>7</td><td>9</td><td>25</td></tr><tr><td>41</td><td>7</td><td>8</td><td>9.5</td><td>26</td></tr><tr><td>42</td><td>8</td><td>8.5</td><td>10.5</td><td>26.5</td></tr><tr><td>43</td><td>9</td><td>9.5</td><td>11</td><td>27.5</td></tr><tr><td>44</td><td>9.5</td><td>10</td><td>12</td><td>28</td></tr><tr><td>45</td><td>10.5</td><td>11</td><td>12.5</td><td>29</td></tr></tbody></table><h3>Fit notes</h3><ul><li><strong>Runners</strong> fit true to size; wide feet may want half a size up.</li><li><strong>Leather loafers</strong> run snug at first and give with wear.</li><li><strong>Kids</strong>: leave a thumb's width at the toe for growing room.</li></ul>","completeTheLookTitle":"You may also like","showDeliveryAreas":true,"deliveryPoints":[{"text":"Delivery all over Bangladesh"},{"text":"Cash on delivery and bKash"},{"text":"Try the pair on before you pay"}],"trustCards":[{"icon":"shield","title":"Checked pair by pair","text":"Every pair inspected before it ships"},{"icon":"refresh","title":"Easy size swap","text":"Wrong size? Swap it within 7 days"},{"icon":"lock","title":"Safe payment","text":"Pay on delivery or online"}]},"styles":{},"isActive":true,"order":0}]},"cart":{"isActive":true,"sections":[{"id":"cart","type":"cart","variant":"v1","props":{"pageTitle":"Cart","emptyTitle":"Your cart is empty","emptyMessage":"Find a pair you like and add it to your cart.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop","summaryTitle":"Summary","subtotalLabel":"Subtotal","shippingLabel":"Delivery","shippingCalculatedText":"Delivery is calculated at checkout.","totalLabel":"Total","checkoutButtonText":"Checkout","checkoutLink":"/checkout"},"styles":{},"isActive":true,"order":0}]},"checkout":{"isActive":true,"sections":[{"id":"checkout","type":"checkout","variant":"v1","props":{"pageTitle":"Checkout","emptyTitle":"Your bag is empty","emptyMessage":"Add something to your bag before you check out.","continueShoppingText":"Shop now","continueShoppingLink":"/shop","summaryTitle":"Your order","subtotalLabel":"Subtotal","shippingChargeLabel":"Delivery area","totalLabel":"Total","placeOrderText":"Place order","placingOrderText":"Placing order…"},"styles":{},"isActive":true,"order":0}]},"order-success":{"isActive":true,"sections":[{"id":"order-success","type":"order-success","variant":"v1","props":{"title":"Thank you","message":"Your order is in. We will call to confirm it before it ships.","errorTitle":"Your order was placed","errorMessage":"We could not load the order details on this device, but your order was received.","viewOrderText":"View order","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"categories":{"isActive":true,"sections":[{"id":"categories","type":"categories","variant":"v1","props":{"title":"Categories","subtitle":"Everything, sorted","columns":4,"emptyText":"No categories yet."},"styles":{},"isActive":true,"order":0}]},"wishlist":{"isActive":true,"sections":[{"id":"wishlist","type":"wishlist","variant":"v1","props":{"title":"Wishlist","subtitle":"Saved for later","emptyTitle":"Nothing saved yet","emptyText":"Tap the heart on any product to keep it here.","continueShoppingText":"Start shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"compare":{"isActive":true,"sections":[{"id":"compare","type":"compare","variant":"v1","props":{},"styles":{},"isActive":true,"order":0}]},"coupon":{"isActive":true,"sections":[{"id":"coupon","type":"coupon","variant":"v1","props":{"title":"Offers","coupons":[{"code":"FIRSTSTEP","title":"Your first pair","description":"On your first order.","discount":"10% off"},{"code":"FREESHIP","title":"Free delivery","description":"On any order, any area.","discount":"Free delivery"}]},"styles":{},"isActive":true,"order":0}]},"track-order":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Track your order","content":"<p>Enter your order number and phone to see where your order is. Signed in? Your orders are under <a href=\\"/account/orders\\">My orders</a>.</p>"},"styles":{},"isActive":true,"order":0}]},"signin":{"isActive":true,"sections":[{"id":"signin","type":"signin","variant":"v1","props":{"title":"Sign in","intro":"Sign in or create an account with your mobile number.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"signup":{"isActive":true,"sections":[{"id":"signup","type":"signup","variant":"v2","props":{"title":"Create account","intro":"Create your account with your mobile number.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"account":{"isActive":true,"sections":[{"id":"account","type":"account","variant":"v1","props":{"tabOverviewLabel":"Overview","tabOrdersLabel":"Orders","tabAddressesLabel":"Addresses","tabDetailsLabel":"Profile","signOutLabel":"Sign out"},"styles":{},"isActive":true,"order":0}]},"contact":{"isActive":true,"sections":[{"id":"contact-hero-0","type":"hero","variant":"v5","props":{"eyebrow":"Customer care","headline":"Talk to us.","highlight":"Sizes, swaps, orders.","text":"Not sure about a size, or want to swap a pair? Pick whichever way is easiest for you.","ctaText":"Shop now","ctaLink":"/shop","linkText":"Track an order","linkHref":"/track-order","cardWord":"Care","cardText":"Real people, clear answers, every day of the week.","cardLabel":"Dhaka","cardLabelEnd":"Since 2024"},"styles":{},"isActive":true,"order":0},{"id":"contact-contact-1","type":"contact","variant":"v1","props":{"eyebrow":"Pick a way in","title":"Get in","highlight":"touch.","description":"Keep your order number or phone number to hand for the quickest help.","channels":[{"icon":"phone","label":"Call","title":"Call us","text":"Orders, sizes and delivery questions."},{"icon":"whatsapp","label":"WhatsApp","title":"WhatsApp","text":"Send a quick message to the team.","linkText":"Chat on WhatsApp"},{"icon":"mail","label":"Email","title":"Email us","text":"Bulk orders, school shoes for teams and anything else."},{"icon":"map-pin","label":"Visit","title":"Visit us","text":"Try sizes in person at our store.","linkText":"View location"}],"mapEyebrow":"Visit the store","mapTitle":"Try a pair at","mapOutline":"our store.","mapText":"Drop by to try sizes, pick up an order or swap a pair. Calling before you come helps.","mapLinkText":"Open in maps","formEyebrow":"Send a message","formTitle":"Tell us what","formHighlight":"you need.","formText":"Leave your name, a way to reach you and your message, and we will get back to you soon."},"styles":{},"isActive":true,"order":1},{"id":"contact-promises-2","type":"promises","variant":"v2","props":{"eyebrow":"","title":"Help with","subtitle":"","highlight":"anything you need.","items":[{"title":"Order status and tracking"},{"title":"Finding your EU size"},{"title":"Delivery, swaps and payments"},{"title":"Bulk and school orders"}]},"styles":{},"isActive":true,"order":2},{"id":"contact-content-3","type":"content","variant":"v3","props":{"eyebrow":"Good to know","highlight":"answered.","subtitle":"The questions we hear most often, answered by the team.","helpText":"Need help?","helpLink":"/contact","faqs":[{"question":"How do I find my size?","answer":"Measure your foot from heel to longest toe and match it to the cm column of the size guide on every product page. Between two sizes, take the larger one."},{"question":"Which payment methods can I use?","answer":"Cash on delivery, bKash, Nagad and cards."},{"question":"How long does delivery take?","answer":"Usually one to two days inside Dhaka and three to five days elsewhere."},{"question":"Can I swap a size?","answer":"Yes, within 7 days, as long as the pair is unworn and in its box."}],"title":"Questions,"},"styles":{},"isActive":true,"order":3}]},"blog":{"isActive":true,"sections":[{"id":"blog","type":"blog","variant":"v1","props":{"title":"Journal","posts":[],"showViewAll":false},"styles":{},"isActive":true,"order":0}]},"privacy-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Privacy policy","content":"<p>This policy explains what we collect when you shop with us and how we use it.</p><h2>What we collect</h2><p>Your name, phone number, delivery address and order history, so we can deliver your orders and help you with them.</p><h2>How we use it</h2><p>To process and deliver orders, to contact you about them and, if you agree, to tell you about new arrivals. We never sell your details.</p><h2>Your choices</h2><p>You can ask us to update or delete your details at any time through the contact page.</p>"},"styles":{},"isActive":true,"order":0}]},"shipping-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Shipping policy","content":"<p>We deliver to every area listed at checkout. The delivery charge for your area is shown before you place the order.</p><h2>Delivery times</h2><p>Orders inside the city usually arrive in 1–2 days and elsewhere in 3–5 days.</p><h2>Payment</h2><p>Pay in cash when your order arrives. Please check the parcel before you pay.</p>"},"styles":{},"isActive":true,"order":0}]},"terms-of-service":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Terms of service","content":"<p>By placing an order you agree to these terms.</p><h2>Orders</h2><p>An order is confirmed once we call or message you to confirm it. We may cancel an order if an item is out of stock.</p><h2>Prices</h2><p>Prices are shown in the store currency and include all taxes. Delivery is charged separately and shown at checkout.</p><h2>Changes</h2><p>We may update these terms. The version on this page applies to new orders.</p>"},"styles":{},"isActive":true,"order":0}]},"return-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Return policy","content":"<p>Wrong size or changed your mind? You can return or exchange unworn items within 7 days of delivery.</p><h2>How to return</h2><p>Contact us with your order number. Items must be unworn, unwashed and have their tags.</p><h2>Refunds</h2><p>Once we receive and check the item, we refund the amount or send the replacement within 5 working days.</p>"},"styles":{},"isActive":true,"order":0}]},"about":{"isActive":true,"sections":[{"id":"about-hero-0","type":"hero","variant":"v5","props":{"eyebrow":"Shoes for every day","headline":"Built to walk.","highlight":"Made to be worn.","text":"Sneakers, runners and everyday shoes in EU sizes, picked and checked by people who wear them.","ctaText":"Our story","ctaLink":"/about","linkText":"Shop new in","linkHref":"/shop","cardWord":"Fit","cardText":"Every pair sized in EU, with a fit note on every page.","cardLabel":"Dhaka","cardLabelEnd":"Since 2024"},"styles":{},"isActive":true,"order":0},{"id":"about-announcement-bar-1","type":"announcement-bar","variant":"v2","props":{"items":[{"text":"EU sizes"},{"text":"Checked pair by pair"},{"text":"Cash on delivery"},{"text":"7-day size swap"}]},"styles":{},"isActive":true,"order":1},{"id":"about-features-2","type":"features","variant":"v4","props":{"items":[{"title":"2024","subtitle":"Our first pairs"},{"title":"Dhaka","subtitle":"Where we pack and ship"},{"title":"40+","subtitle":"Styles in stock"},{"title":"7 days","subtitle":"To swap a size"}]},"styles":{},"isActive":true,"order":2},{"id":"about-story-3","type":"story","variant":"v1","props":{"eyebrow":"Our story","title":"Started small,","subtitle":"Good shoes, honest sizes, fair prices.","highlight":"walking further.","text":"We started with a few pairs of sneakers and a simple idea: shoes that fit the first time.\\n\\nToday every pair is checked, sized and boxed by our own team, and sold online and in our store.","points":[{"title":"Sized in EU, with a fit note on every pair"},{"title":"Comfort, quality and fair prices"},{"title":"Delivered all over Bangladesh"}],"ctaLink":"/shop","ctaLabel":""},"styles":{},"isActive":true,"order":3},{"id":"about-features-4","type":"features","variant":"v5","props":{"eyebrow":"Why people pick us","title":"Shoes that","highlight":"fit the first time.","text":"Every pair starts with how it will be worn: to work, to school, on a run or through the monsoon.","items":[{"icon":"sparkle","title":"Honest sizing","subtitle":"EU sizes and a fit note on every product."},{"icon":"star","title":"New every week","subtitle":"Fresh pairs and colourways every Friday."},{"icon":"shield","title":"Built to last","subtitle":"Stitched uppers and soles that keep their grip."},{"icon":"heart","title":"Fair prices","subtitle":"Good shoes you can wear every day."}]},"styles":{},"isActive":true,"order":4},{"id":"about-cta-5","type":"cta","variant":"v2","props":{"eyebrow":"What comes next","title":"From our shelves","outline":"to your street.","subtitle":"We want to keep finding shoes that fit well, last long and cost fairly, for more feet in more cities.","quote":"Walk your way.","quoteText":"More than a slogan: the reason every pair is checked before it ships."},"styles":{},"isActive":true,"order":5}]}}`), oL = {
  seo: eL,
  config: tL,
  pages: aL
}, rL = { title: "Pathok — Bangla and English books online", description: "Buy Bangla and English books and eBooks online in Bangladesh. Cash on delivery across the country." }, lL = { themeId: "books-1", appearance: { colorMode: "light" }, header: { variant: "v1", topbar: { active: !0, messages: [{ text: "Free delivery on orders over ৳1,199" }, { text: "Cash on delivery across Bangladesh" }, { text: "eBooks (PDF): read on any device" }], dismissible: !0 }, actions: { showSearch: !0, showCart: !0, showAccount: !0, showWishlist: !0, cartAction: "sidebar" }, searchPlaceholder: "Search by book, author or publisher…", menu: [{ label: "Books", href: "/shop", type: "categories" }, { label: "Novels", href: "/shop", type: "link" }, { label: "Academic", href: "/shop", type: "link" }, { label: "eBooks", href: "/shop?search=ebook", type: "link", badge: "New" }, { label: "Offers", href: "/shop?order_by=discount_desc", type: "link" }, { label: "Blog", href: "/blog", type: "link" }] }, footer: { variant: "v1", description: "Bangla and English books, printed and as eBooks (PDF), delivered across Bangladesh.", columns: [{ title: "Shop", links: [{ label: "All products", href: "/shop" }, { label: "Categories", href: "/categories" }, { label: "Track order", href: "/track-order" }] }, { title: "Help", links: [{ label: "Contact us", href: "/contact" }, { label: "Shipping policy", href: "/shipping-policy" }, { label: "Return policy", href: "/return-policy" }] }, { title: "Company", links: [{ label: "Privacy policy", href: "/privacy-policy" }, { label: "Terms of service", href: "/terms-of-service" }] }], socialLinks: [] }, floatingButtons: { active: !0 }, mobileBottomNav: { active: !0, items: [] } }, iL = /* @__PURE__ */ JSON.parse(`{"home":{"seo":{"title":"","description":""},"isActive":true,"sections":[{"id":"hero","type":"hero","variant":"v1","props":{"eyebrow":"Bangladesh's online book shop","headline":"Every book you love, delivered","subtext":"Novels, academic and children's books, printed or as an eBook. Order today, pay on delivery.","primaryCta.label":"Shop books","primaryCta.url":"/shop","secondaryCta.label":"Browse eBooks","secondaryCta.url":"/shop?search=ebook","showTrustChips":false,"trustChips":[{"icon":"shipping","text":"Fast delivery"},{"icon":"secure","text":"Cash on delivery"},{"icon":"refund","text":"Easy returns"}],"showCards":true,"cards":[],"slides":[],"autoplay":true,"autoplaySeconds":6},"styles":{"paddingTop":"none","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":0},{"id":"category-bento","type":"category-bento","variant":"v2","props":{"eyebrow":"Our collection","title":"Shop by category","subtitle":"","tiles":[],"limit":8},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":10},{"id":"popular","type":"product-rail","variant":"v1","props":{"eyebrow":"Top picks","title":"Popular books","subtitle":"","source":{"source":"top_rated","limit":10},"layout":"grid","showViewAll":true,"viewAllLabel":"See all books"},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":20},{"id":"new-arrivals","type":"product-rail","variant":"v1","props":{"eyebrow":"Just arrived","title":"New releases","subtitle":"","source":{"source":"new","limit":12},"layout":"rail","showViewAll":true,"viewAllLabel":"See all"},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":30},{"id":"on-sale","type":"product-rail","variant":"v1","props":{"eyebrow":"Quick deal","title":"Today's book deals","subtitle":"Discounts on bestsellers, while stocks last.","source":{"source":"on_sale","limit":10},"layout":"grid","showViewAll":true,"viewAllLabel":"See all deals"},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":40},{"id":"category-panels","type":"category-bento","variant":"v1","props":{"eyebrow":"Categories","title":"Find books by category","subtitle":"","tiles":[],"limit":4},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":50},{"id":"combo-spotlight","type":"combo-spotlight","variant":"v1","props":{"eyebrow":"Book bundle","title":"Bundle of the week","subtitle":"","description":"","mrpLabel":"Regular price","savingLabel":"You save","detailsLabel":"View details"},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":60},{"id":"reviews","type":"reviews","variant":"v1","props":{"eyebrow":"Readers say","title":"What our readers say","subtitle":"","items":[],"limit":6,"minRating":4},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":70},{"id":"corporate-band","type":"corporate-band","variant":"v1","props":{"eyebrow":"Schools & libraries","title":"Bulk orders for schools, libraries and offices","text":"Buying books for a school, a library or as gifts? Get bulk prices and scheduled delivery.","cta.label":"Contact us","cta.url":"/contact"},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":80}]},"shop":{"seo":{"title":"Shop","description":""},"isActive":true,"sections":[{"id":"shop-grid","type":"shop-grid","variant":"v1","props":{"sidebarVariant":"v1","productCardVariant":"v1","paginationVariant":"v1","initialPriceRange.min":0,"initialPriceRange.max":50000,"itemsPerPage":12,"allCategoriesLabel":"All","filtersButtonLabel":"Filters","showingLabel":"Showing","productsSuffix":"Products","sortNewestLabel":"Sort: Newest","sortOldestLabel":"Sort: Oldest","sortPriceAscLabel":"Price: Low to High","sortPriceDescLabel":"Price: High to Low","sortNameAscLabel":"Name: A-Z","sortNameDescLabel":"Name: Z-A","activeFiltersLabel":"Active Filters:","clearAllLabel":"Clear All","noProductsTitle":"No Products Found","noProductsMessage":"We couldn't find any products matching your current filters. Try adjusting them.","backToAllText":"Back to All Products","filterDrawerTitle":"Filter Products","currentSearchLabel":"Current Search","clearSearchLabel":"Clear","applyFiltersLabel":"Apply Filters"},"styles":{},"isActive":true,"order":0}]},"categories":{"seo":{"title":"Categories","description":""},"isActive":true,"sections":[{"id":"categories","type":"categories","variant":"v1","props":{"columns":4,"emptyText":"No categories found."},"styles":{},"isActive":true,"order":0}]},"product":{"seo":{"title":"","description":""},"isActive":true,"sections":[{"id":"product-detail","type":"product-detail","variant":"v1","props":{"loadingText":"Loading Data...","notFoundCode":"404","notFoundText":"Product Not Found","quantityLabel":"Quantity","productDescTitle":"Product Description","returnPolicyTitle":"Return Policy","howToOrderTitle":"How to order","showDeliveryAreas":true},"styles":{},"isActive":true,"order":0},{"id":"similar-products","type":"similar-products","variant":"v1","props":{"productCardVariant":"v1","title":"Similar Products","limit":4},"styles":{},"isActive":true,"order":10}]},"cart":{"seo":{"title":"Cart","description":""},"isActive":true,"sections":[{"id":"cart","type":"cart","variant":"v1","props":{"pageTitle":"Shopping cart","emptyTitle":"Your cart is currently empty.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop","summaryTitle":"Cart totals","subtotalLabel":"Subtotal","shippingLabel":"Delivery","shippingCalculatedText":"Delivery charge is added at checkout.","totalLabel":"Total","checkoutButtonText":"Proceed to checkout","checkoutLink":"/checkout"},"styles":{},"isActive":true,"order":0}]},"checkout":{"seo":{"title":"Checkout","description":""},"isActive":true,"sections":[{"id":"checkout","type":"checkout","variant":"v1","props":{"pageTitle":"Billing details","emptyTitle":"Your cart is empty.","continueShoppingText":"Return to shop","continueShoppingLink":"/shop","summaryTitle":"Your order","subtotalLabel":"Subtotal","deliveryLabel":"Delivery","totalLabel":"Total","codLabel":"Cash on delivery","codDescription":"Pay with cash when your order arrives.","placeOrderText":"Place order","placingOrderText":"Placing order…"},"styles":{},"isActive":true,"order":0}]},"order-success":{"seo":{"title":"Order placed","description":""},"isActive":true,"sections":[{"id":"order-success","type":"order-success","variant":"v1","props":{"title":"Thank you. Your order has been received.","message":"We will call you to confirm your order before delivery.","errorTitle":"Your order was placed.","errorMessage":"We could not load the order details on this device, but your order was received.","viewOrderText":"View order","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"signin":{"seo":{"title":"Sign in","description":""},"isActive":true,"sections":[{"id":"signin","type":"signin","variant":"v1","props":{"title":"Sign in","intro":"Use your mobile number. We send you a code by SMS — no password needed.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"signup":{"seo":{"title":"Create account","description":""},"isActive":true,"sections":[{"id":"signup","type":"signup","variant":"v1","props":{"title":"Create your account","intro":"Use your mobile number. We send you a code by SMS — no password needed.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"account":{"seo":{"title":"My account","description":""},"isActive":true,"sections":[{"id":"account","type":"account","variant":"v1","props":{"title":"My account","tabOverviewLabel":"Overview","tabOrdersLabel":"Orders","tabDetailsLabel":"Profile","tabAddressesLabel":"Addresses","signOutLabel":"Sign out"},"styles":{},"isActive":true,"order":0}]},"contact":{"seo":{"title":"Contact us","description":""},"isActive":true,"sections":[{"id":"contact","type":"contact","variant":"v1","props":{"title":"Contact us","description":"Questions about an order or a product? We are happy to help."},"styles":{},"isActive":true,"order":0}]},"wishlist":{"seo":{"title":"Wishlist","description":""},"isActive":true,"sections":[{"id":"wishlist","type":"wishlist","variant":"v1","props":{"title":"Wishlist","subtitle":"Products you saved for later.","emptyTitle":"Your wishlist is empty","emptyText":"Tap the heart on any product to save it here.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"compare":{"seo":{"title":"Compare products","description":""},"isActive":true,"sections":[{"id":"compare","type":"compare","variant":"v1","props":{"title":"Compare products","emptyTitle":"Nothing to compare yet","emptyText":"Add up to four products to compare them side by side."},"styles":{},"isActive":true,"order":0}]},"coupon":{"seo":{"title":"Coupons","description":""},"isActive":true,"sections":[{"id":"coupon","type":"coupon","variant":"v1","props":{"title":"Coupons","subtitle":"Use these codes when you order.","coupons":[{"code":"WELCOME10","discount":"10% off","title":"Welcome offer","description":"On your first order.","expiryDate":"31 Dec 2026"},{"code":"FREESHIP","discount":"Free delivery","title":"Free delivery","description":"On orders over 1000.","expiryDate":"31 Dec 2026"}],"emptyText":"No coupons right now. Check back soon."},"styles":{},"isActive":true,"order":0}]},"track-order":{"seo":{"title":"Track your order","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Track your order","content":"<p>Sign in to follow your orders, or enter your order number and phone number below. You can also contact us with your order number.</p>"},"styles":{},"isActive":true,"order":0}]},"blog":{"seo":{"title":"Blog","description":""},"isActive":true,"sections":[{"id":"blog","type":"blog","variant":"v1","props":{"title":"From the blog","viewAllLink":"/blog","showViewAll":false,"posts":[]},"styles":{},"isActive":true,"order":0}]},"privacy-policy":{"seo":{"title":"Privacy policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Privacy Policy ","content":"<p>Welcome to our store (“we”, “our”, “us”). Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our website, mobile app, or services (collectively, the “Platform”).</p><p>By using our Platform, you agree to the collection and use of information in accordance with this policy.</p><h2>1. Information We Collect</h2><h3>a. Personal Information</h3><p>When you use our Platform, we may collect:</p><ul><li>Full name</li><li>Email address</li><li>Phone number</li><li>Shipping and billing address</li><li>Payment details (processed securely by third-party payment providers)</li><li>Account login credentials</li></ul><h3>b. Order &amp; Transaction Information</h3><ul><li>Products purchased</li><li>Order history</li><li>Payment status</li><li>Delivery and return details</li></ul><h3>c. Technical &amp; Usage Data</h3><ul><li>IP address</li><li>Browser type and version</li><li>Device information</li><li>Pages visited and time spent</li><li>Cookies and similar tracking technologies</li></ul><h2>2. How We Use Your Information</h2><p>We use your information to:</p><ul><li>Create and manage your account</li><li>Process orders and payments</li><li>Deliver products and services</li><li>Communicate order updates and support responses</li><li>Improve website performance and user experience</li><li>Send promotional messages (only if you opt in)</li><li>Prevent fraud and ensure platform security</li><li>Comply with legal obligations</li></ul><h2>3. Cookies &amp; Tracking Technologies</h2><p>We use cookies and similar technologies to:</p><ul><li>Remember your preferences</li><li>Keep you logged in</li><li>Analyze traffic and usage patterns</li><li>Improve our services</li></ul><p>You can control cookies through your browser settings. Disabling cookies may affect some features of the Platform.</p><h2>4. Sharing Your Information</h2><p>We <strong>do not sell</strong> your personal data.</p><p>We may share your information with:</p><ul><li>Payment gateways (e.g., Stripe, PayPal)</li><li>Delivery and logistics partners</li><li>Analytics and marketing tools</li><li>IT and hosting service providers</li><li>Legal or regulatory authorities (if required by law)</li></ul><p>All third parties are required to protect your data.</p><h2>5. Data Security</h2><p>We implement appropriate technical and organizational measures to protect your data, including:</p><ul><li>Secure servers</li><li>Encrypted communication (HTTPS/SSL)</li><li>Limited internal access</li></ul><p>However, no method of transmission over the internet is 100% secure.</p><h2>6. Data Retention</h2><p>We retain your personal information only as long as necessary to:</p><ul><li>Fulfill orders and services</li><li>Comply with legal, tax, and accounting requirements</li><li>Resolve disputes</li></ul><h2>7. Your Rights</h2><p>Depending on your location, you may have the right to:</p><ul><li>Access your personal data</li><li>Correct inaccurate information</li><li>Request deletion of your data</li><li>Withdraw consent for marketing communications</li></ul><p>To exercise these rights, contact us at <strong>[support@email.com</strong></p><p><strong>]</strong>.</p><h2>8. Children’s Privacy</h2><p>Our Platform is not intended for users under the age of 13. We do not knowingly collect personal information from children.</p><h2>9. Third-Party Links</h2><p>Our Platform may contain links to third-party websites. We are not responsible for their privacy practices.</p><h2>10. Changes to This Policy</h2><p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated “Last updated” date.</p><h2>11. Contact Us</h2><p>If you have any questions about this Privacy Policy, contact us:</p><p>📧 Email: <strong>[support@email.com]</strong></p><p>🏢 Address: <strong>[Company Address]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"shipping-policy":{"seo":{"title":"Shipping policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Shipping Policy","content":"<p>This Shipping Policy explains how orders are processed and delivered by <strong>[Your Store Name]</strong>.</p><h2>1. Order Processing Time</h2><ul><li>Orders are processed within <strong>[1–3] business days</strong></li><li>Orders placed on weekends or holidays are processed next business day</li></ul><h2>2. Shipping Methods &amp; Delivery Time</h2><p>Estimated delivery times:</p><ul><li><strong>Standard Shipping:</strong> [3–7] business days</li><li><strong>Express Shipping:</strong> [1–3] business days</li></ul><p>Delivery times may vary due to location, weather, or courier delays.</p><h2>3. Shipping Charges</h2><ul><li>Shipping fees are calculated at checkout</li><li>Free shipping may apply for orders above <strong>[amount]</strong></li></ul><h2>4. Delivery Areas</h2><p>We currently ship to:</p><ul><li><strong>[Domestic / International – specify regions]</strong></li></ul><h2>5. Order Tracking</h2><p>Once shipped, you will receive:</p><ul><li>A confirmation message/email</li><li>Tracking details (if available)</li></ul><h2>6. Delayed or Lost Shipments</h2><p>If your order is delayed or lost:</p><ul><li>Contact us at <strong>[support@email.com</strong></li><li><strong>]</strong></li><li>We will coordinate with the courier to resolve the issue</li></ul><h2>7. Incorrect Address</h2><p>Please ensure your shipping address is correct. We are not responsible for orders delivered to incorrect addresses provided by the customer.</p><h2>8. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"return-policy":{"seo":{"title":"Return policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Return & Refund Policy","content":"<p>At <strong>[Your Store Name]</strong>, we want you to be satisfied with your purchase. This Return &amp; Refund Policy explains when and how you can return items bought from our Platform.</p><h2>1. Eligibility for Returns</h2><p>You may request a return if:</p><ul><li>The product is damaged, defective, or incorrect</li><li>The product is unused and in original condition</li><li>The return request is made within <strong>[7/14/30] days</strong> of delivery</li></ul><p>Items must be returned with:</p><ul><li>Original packaging</li><li>Tags, labels, and accessories (if any)</li><li>Proof of purchase</li></ul><h2>2. Non-Returnable Items</h2><p>The following items are <strong>not eligible</strong> for return or refund:</p><ul><li>Perishable goods</li><li>Personal care or hygiene products</li><li>Digital products or downloadable items</li><li>Customized or made-to-order products</li><li>Items marked as “Final Sale”</li></ul><h2>3. Return Process</h2><p>To initiate a return:</p><ol><li>Contact us at <strong>[support@email.com</strong></li><li><strong>]</strong> with your order ID</li><li>Our team will review and approve the request</li><li>Ship the product to the provided return address</li></ol><p>Return shipping costs:</p><ul><li>Covered by us if the item is defective or incorrect</li><li>Covered by the customer for all other reasons</li></ul><h2>4. Refunds</h2><ul><li>Approved refunds will be processed within <strong>[5–10] business days</strong></li><li>Refunds will be issued to the original payment method</li><li>Shipping charges are non-refundable unless the return is due to our error</li></ul><h2>5. Exchanges</h2><p>We replace items only if they are defective, damaged, or incorrect. Exchange requests are subject to product availability.</p><h2>6. Contact</h2><p>For return-related questions:</p><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p><h1>Terms &amp; Conditions (Terms of Service)</h1><p><strong>Last updated:</strong> [Insert Date]</p><p>Welcome to <strong>[Your Store Name]</strong>. By accessing or using our website, mobile app, or services, you agree to these Terms &amp; Conditions.</p><h2>1. Use of the Platform</h2><p>You agree to:</p><ul><li>Provide accurate and current information</li><li>Use the Platform for lawful purposes only</li><li>Not misuse, copy, or exploit our content or services</li></ul><p>We reserve the right to suspend or terminate accounts violating these terms.</p><h2>2. Account Responsibility</h2><p>You are responsible for:</p><ul><li>Maintaining the confidentiality of your account credentials</li><li>All activities that occur under your account</li></ul><h2>3. Product Information &amp; Pricing</h2><ul><li>We strive to display accurate product descriptions and prices</li><li>Errors may occur; we reserve the right to correct them</li><li>Prices and availability are subject to change without notice</li></ul><h2>4. Orders &amp; Payments</h2><ul><li>Orders are confirmed only after successful payment</li><li>We reserve the right to cancel or refuse any order</li><li>Payments are securely processed through third-party providers</li></ul><h2>5. Intellectual Property</h2><p>All content on the Platform (logos, text, images, software) is the property of <strong>[Your Store Name]</strong> and protected by applicable laws.</p><h2>6. Limitation of Liability</h2><p>We are not liable for:</p><ul><li>Indirect or consequential damages</li><li>Delays caused by third-party services</li><li>Losses due to misuse of the Platform</li></ul><h2>7. Termination</h2><p>We may terminate or suspend access to the Platform at any time without notice for violations of these Terms.</p><h2>8. Governing Law</h2><p>These Terms are governed by the laws of <strong>[Country/State]</strong>.</p><h2>9. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"terms-of-service":{"seo":{"title":"Terms of service","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Terms & Conditions (Terms of Service)","content":"<p>Welcome to <strong>[Your Store Name]</strong>. By accessing or using our website, mobile app, or services, you agree to these Terms &amp; Conditions.</p><h2>1. Use of the Platform</h2><p>You agree to:</p><ul><li>Provide accurate and current information</li><li>Use the Platform for lawful purposes only</li><li>Not misuse, copy, or exploit our content or services</li></ul><p>We reserve the right to suspend or terminate accounts violating these terms.</p><h2>2. Account Responsibility</h2><p>You are responsible for:</p><ul><li>Maintaining the confidentiality of your account credentials</li><li>All activities that occur under your account</li></ul><h2>3. Product Information &amp; Pricing</h2><ul><li>We strive to display accurate product descriptions and prices</li><li>Errors may occur; we reserve the right to correct them</li><li>Prices and availability are subject to change without notice</li></ul><h2>4. Orders &amp; Payments</h2><ul><li>Orders are confirmed only after successful payment</li><li>We reserve the right to cancel or refuse any order</li><li>Payments are securely processed through third-party providers</li></ul><h2>5. Intellectual Property</h2><p>All content on the Platform (logos, text, images, software) is the property of <strong>[Your Store Name]</strong> and protected by applicable laws.</p><h2>6. Limitation of Liability</h2><p>We are not liable for:</p><ul><li>Indirect or consequential damages</li><li>Delays caused by third-party services</li><li>Losses due to misuse of the Platform</li></ul><h2>7. Termination</h2><p>We may terminate or suspend access to the Platform at any time without notice for violations of these Terms.</p><h2>8. Governing Law</h2><p>These Terms are governed by the laws of <strong>[Country/State]</strong>.</p><h2>9. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p><h1>Shipping Policy</h1><p><strong>Last updated:</strong> [Insert Date]</p><p>This Shipping Policy explain</p>"},"styles":{},"isActive":true,"order":0}]}}`), nL = {
  seo: rL,
  config: lL,
  pages: iL
}, sL = { title: "Torongo — gadgets, projectors and smart devices online", description: "Projectors, Android TV boxes, security cameras, smart locks, smart watches and audio with official warranty. Cash on delivery all over Bangladesh." }, cL = { themeId: "gadgets-1", appearance: { colorMode: "light" }, header: { variant: "v1", topbar: { active: !0, messages: [{ text: { en: "Welcome to our gadget shop — delivery all over Bangladesh", bn: "সারা বাংলাদেশে ডেলিভারি" } }], dismissible: !1 }, actions: { showSearch: !0, showCart: !0, showAccount: !0, showWishlist: !0, cartAction: "sidebar" }, searchPlaceholder: "Search projectors, TV boxes, smart watches…", menu: [{ label: "Home", href: "/", type: "link" }, { label: "Shop", href: "/shop", type: "link" }, { label: "Product categories", href: "/categories", type: "categories" }, { label: "Offers", href: "/shop?order_by=discount_desc", type: "link", badge: "Hot" }, { label: "Contact us", href: "/contact", type: "link" }] }, footer: { variant: "v1", newsletterTitle: { en: "Sign up to our newsletter", bn: "নিউজলেটারে যুক্ত হোন" }, newsletterText: { en: "…and hear about new arrivals and offers first", bn: "নতুন পণ্য ও অফারের খবর সবার আগে" }, newsletterAction: "", description: "Projectors, TV boxes, smart security and audio with official warranty, delivered all over Bangladesh.", columns: [{ title: "Find it fast", links: [{ label: "Home", href: "/" }, { label: "Contact us", href: "/contact" }, { label: "Track order", href: "/track-order" }, { label: "Terms and conditions", href: "/terms-of-service" }, { label: "Refund and returns", href: "/return-policy" }, { label: "Shipping policy", href: "/shipping-policy" }, { label: "Privacy policy", href: "/privacy-policy" }] }, { title: "Product categories", links: [{ label: "Projectors", href: "/shop?search=projector" }, { label: "Android TV boxes", href: "/shop?search=tv%20box" }, { label: "Security cameras", href: "/shop?search=camera" }, { label: "Smart door locks", href: "/shop?search=lock" }, { label: "Smart watches", href: "/shop?search=watch" }, { label: "All categories", href: "/categories" }] }], socialLinks: [{ platform: "facebook", href: "https://facebook.com/" }, { platform: "youtube", href: "https://youtube.com/" }, { platform: "tiktok", href: "https://tiktok.com/" }], copyright: "" }, floatingButtons: { active: !0, callUsTitle: "Call us", whatsappTitle: "WhatsApp" }, mobileBottomNav: { active: !0, items: [] } }, dL = /* @__PURE__ */ JSON.parse(`{"home":{"seo":{"title":"","description":""},"isActive":true,"sections":[{"id":"hero","type":"hero","variant":"v1","isActive":true,"order":0,"styles":{"paddingTop":"none","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"eyebrow":{"en":"Movie night deal","bn":"মুভি নাইট অফার"},"headline":{"en":"Big-screen cinema at home","bn":"ঘরেই বড় পর্দার সিনেমা"},"subtext":{"en":"Projectors, TV boxes and sound for every room, with official warranty and cash on delivery.","bn":""},"primaryCta.label":"Shop projectors","primaryCta.url":"/shop?search=projector","secondaryCta.label":"Today's offers","secondaryCta.url":"/shop?order_by=discount_desc","showTrustChips":true,"trustChips":[{"icon":"truck","text":{"en":"Delivery all over Bangladesh","bn":"সারা দেশে ডেলিভারি"}},{"icon":"shield","text":{"en":"Official warranty","bn":"অফিসিয়াল ওয়ারেন্টি"}},{"icon":"cash","text":{"en":"Cash on delivery","bn":"ক্যাশ অন ডেলিভারি"}},{"icon":"headset","text":{"en":"Hotline 10am–9pm","bn":"হটলাইন সকাল ১০টা–রাত ৯টা"}}],"showCards":true,"cards":[],"slides":[],"autoplay":true,"autoplaySeconds":6}},{"id":"category-tiles","type":"category-bento","variant":"v1","isActive":true,"order":10,"styles":{"paddingTop":"sm","paddingBottom":"sm","background":"muted","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"eyebrow":"","title":{"en":"Shop by category","bn":"ক্যাটাগরি অনুযায়ী কিনুন"},"subtitle":"","tiles":[],"limit":28}},{"id":"flash-sale","type":"flash-sale","variant":"v1","isActive":true,"order":20,"styles":{"paddingTop":"none","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"title":"Flash sale","endDate":"2027-12-31T18:00:00.000Z"}},{"id":"new-arrivals","type":"product-rail","variant":"v1","isActive":true,"order":30,"styles":{"paddingTop":"none","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"eyebrow":"","title":{"en":"New arrivals","bn":"নতুন এসেছে"},"subtitle":"","source":{"source":"new","limit":10},"layout":"grid","showViewAll":true,"viewAllLabel":"View all"}},{"id":"best-sellers","type":"product-rail","variant":"v1","isActive":true,"order":40,"styles":{"paddingTop":"none","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"eyebrow":"","title":{"en":"Best sellers","bn":"বেস্ট সেলার"},"subtitle":"","source":{"source":"top_rated","limit":10},"layout":"rail","showViewAll":true,"viewAllLabel":"View all"}},{"id":"offer-band","type":"corporate-band","variant":"v1","isActive":true,"order":50,"styles":{"paddingTop":"none","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"eyebrow":"Combo offer","title":{"en":"Projector + screen + mount, one price","bn":"প্রজেক্টর + স্ক্রিন + মাউন্ট কম্বো"},"text":"Build a home cinema in one order: pick a projector, add a screen and a ceiling mount, and save on the bundle. Free fitting inside Dhaka.","cta.label":"See combos","cta.url":"/shop?search=projector"}},{"id":"deals","type":"product-rail","variant":"v1","isActive":true,"order":60,"styles":{"paddingTop":"none","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"eyebrow":"","title":{"en":"Hot deals","bn":"হট ডিল"},"subtitle":"Discounts while stocks last.","source":{"source":"on_sale","limit":10},"layout":"grid","showViewAll":true,"viewAllLabel":"View all"}},{"id":"brands","type":"brands","variant":"v1","isActive":true,"order":70,"styles":{"paddingTop":"none","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"title":"Our brands"}},{"id":"reviews","type":"reviews","variant":"v1","isActive":true,"order":80,"styles":{"paddingTop":"none","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"eyebrow":"","title":{"en":"What our customers say","bn":"গ্রাহকদের কথা"},"subtitle":"","items":[],"limit":6,"minRating":4}},{"id":"seo-text","type":"content","variant":"v2","isActive":true,"order":90,"styles":{"paddingTop":"none","paddingBottom":"sm","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"title":"Gadgets online in Bangladesh, with warranty and cash on delivery","subtitle":{"en":"From home projectors and Android TV boxes to smart locks, security cameras and smart watches, we bring the gadgets people actually use, check every unit before it ships, and deliver all over Bangladesh.","bn":""},"content":"<h2>Why buy gadgets from us</h2><p>Every product carries the warranty shown on its page, and every order is confirmed by phone before it leaves the shop.</p><h2>What we sell</h2><ul><li>Projectors, screens and mounts</li><li>Android TV boxes and wireless display adapters</li><li>Security cameras, smart door locks and digital lockers</li><li>Smart watches, earbuds, speakers and soundbars</li><li>Keyboards, mice and mini PCs</li><li>RC cars, 3D lamps and décor lights</li></ul><h2>Delivery and payment</h2><p>Inside Dhaka in 1–2 days, outside Dhaka in 2–3 days. Pay cash on delivery, or with bKash, Nagad or card.</p>","faqs":[],"updatedText":""}}]},"shop":{"seo":{"title":"Shop","description":""},"isActive":true,"sections":[{"id":"shop-grid","type":"shop-grid","variant":"v1","props":{"sidebarVariant":"v1","productCardVariant":"v1","paginationVariant":"v1","initialPriceRange.min":0,"initialPriceRange.max":50000,"itemsPerPage":24,"allCategoriesLabel":"All","filtersButtonLabel":"Filters","showingLabel":"Showing","productsSuffix":"Products","sortNewestLabel":"Sort: Newest","sortOldestLabel":"Sort: Oldest","sortPriceAscLabel":"Price: Low to High","sortPriceDescLabel":"Price: High to Low","sortNameAscLabel":"Name: A-Z","sortNameDescLabel":"Name: Z-A","activeFiltersLabel":"Active Filters:","clearAllLabel":"Clear All","noProductsTitle":"No Products Found","noProductsMessage":"We couldn't find any products matching your current filters. Try adjusting them.","backToAllText":"Back to All Products","filterDrawerTitle":"Filter Products","currentSearchLabel":"Current Search","clearSearchLabel":"Clear","applyFiltersLabel":"Apply Filters","pageSizes":"48, 96"},"styles":{},"isActive":true,"order":0}]},"categories":{"seo":{"title":"Categories","description":""},"isActive":true,"sections":[{"id":"categories","type":"categories","variant":"v1","props":{"columns":4,"emptyText":"No categories found."},"styles":{},"isActive":true,"order":0}]},"product":{"seo":{"title":"","description":""},"isActive":true,"sections":[{"id":"product-detail","type":"product-detail","variant":"v1","props":{"loadingText":"Loading Data...","notFoundCode":"404","notFoundText":"Product Not Found","quantityLabel":"Quantity","productDescTitle":"Description","returnPolicyTitle":"Delivery & returns","howToOrderTitle":"How to order","showDeliveryAreas":true,"howToOrder":{"en":"Choose a version and the quantity.\\nTap \\"Order now\\" to go straight to checkout, or \\"Add to cart\\" to keep shopping.\\nWrite your name, address, district and phone number.\\nWe call to confirm, then deliver. Pay cash on delivery.","bn":"ভার্সন ও পরিমাণ বেছে নিন।\\n\\"Order now\\" চাপুন।\\nনাম, ঠিকানা, জেলা ও ফোন নম্বর লিখুন।\\nআমরা ফোন করে কনফার্ম করে ডেলিভারি দেব।"}},"styles":{},"isActive":true,"order":0},{"id":"similar-products","type":"similar-products","variant":"v1","props":{"productCardVariant":"v1","title":"Related products","limit":5},"styles":{},"isActive":true,"order":10},{"id":"recent-products","type":"recent-products","variant":"v1","props":{"title":"Recently viewed"},"styles":{},"isActive":true,"order":20}]},"cart":{"seo":{"title":"Cart","description":""},"isActive":true,"sections":[{"id":"cart","type":"cart","variant":"v1","props":{"pageTitle":"Shopping cart","emptyTitle":"Your cart is currently empty.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop","summaryTitle":"Cart totals","subtotalLabel":"Subtotal","shippingLabel":"Delivery","shippingCalculatedText":"Delivery charge is added at checkout.","totalLabel":"Total","checkoutButtonText":"Proceed to checkout","checkoutLink":"/checkout"},"styles":{},"isActive":true,"order":0}]},"checkout":{"seo":{"title":"Checkout","description":""},"isActive":true,"sections":[{"id":"checkout","type":"checkout","variant":"v1","props":{"pageTitle":"Billing details","emptyTitle":"Your cart is empty.","continueShoppingText":"Return to shop","continueShoppingLink":"/shop","summaryTitle":"Your order","subtotalLabel":"Subtotal","deliveryLabel":"Delivery","totalLabel":"Total","codLabel":"Cash on delivery","codDescription":"Pay with cash when your order arrives.","placeOrderText":"Place order","placingOrderText":"Placing order…"},"styles":{},"isActive":true,"order":0}]},"order-success":{"seo":{"title":"Order placed","description":""},"isActive":true,"sections":[{"id":"order-success","type":"order-success","variant":"v1","props":{"title":"Thank you. Your order has been received.","message":"We will call you to confirm your order before delivery.","errorTitle":"Your order was placed.","errorMessage":"We could not load the order details on this device, but your order was received.","viewOrderText":"View order","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"signin":{"seo":{"title":"Sign in","description":""},"isActive":true,"sections":[{"id":"signin","type":"signin","variant":"v1","props":{"title":"Sign in","intro":"Use your mobile number. We send you a code by SMS — no password needed.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"signup":{"seo":{"title":"Create account","description":""},"isActive":true,"sections":[{"id":"signup","type":"signup","variant":"v1","props":{"title":"Create your account","intro":"Use your mobile number. We send you a code by SMS — no password needed.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"account":{"seo":{"title":"My account","description":""},"isActive":true,"sections":[{"id":"account","type":"account","variant":"v1","props":{"title":"My account","tabOverviewLabel":"Overview","tabOrdersLabel":"Orders","tabDetailsLabel":"Profile","tabAddressesLabel":"Addresses","signOutLabel":"Sign out"},"styles":{},"isActive":true,"order":0}]},"contact":{"seo":{"title":"Contact us","description":""},"isActive":true,"sections":[{"id":"contact","type":"contact","variant":"v1","props":{"title":"Contact us","description":"Questions about an order or a product? We are happy to help."},"styles":{},"isActive":true,"order":0},{"id":"faq","type":"content","variant":"v3","isActive":true,"order":10,"styles":{},"props":{"title":"Frequently asked questions","subtitle":{"en":"Shipping, warranty and payment","bn":"ডেলিভারি, ওয়ারেন্টি ও পেমেন্ট"},"content":"","faqs":[{"question":"How long does delivery take?","answer":"Inside Dhaka 1–2 days, outside Dhaka 2–3 days."},{"question":"How do I track my order?","answer":"Use Track order with your order number and phone number, or sign in to see your orders."},{"question":"Do I need an account to order?","answer":"No. You can order as a guest; an account keeps your orders and addresses."},{"question":"Which payment methods can I use?","answer":"Cash on delivery all over Bangladesh, bKash, Nagad and cards."},{"question":"How do I claim warranty?","answer":"Bring or send the product with its invoice and box. We repair or replace it within the warranty period shown on the product page."},{"question":"Can I return a product?","answer":"A faulty or wrong item is replaced within 7 days. Check the product in front of the delivery person."},{"question":"Where is your shop?","answer":"See the shop address in the footer or tap \\"Shop address\\" at the bottom of any page."}],"updatedText":""}}]},"wishlist":{"seo":{"title":"Wishlist","description":""},"isActive":true,"sections":[{"id":"wishlist","type":"wishlist","variant":"v1","props":{"title":"Wishlist","subtitle":"Products you saved for later.","emptyTitle":"Your wishlist is empty","emptyText":"Tap the heart on any product to save it here.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"compare":{"seo":{"title":"Compare products","description":""},"isActive":true,"sections":[{"id":"compare","type":"compare","variant":"v1","props":{"title":"Compare products","emptyTitle":"Nothing to compare yet","emptyText":"Add up to four products to compare them side by side."},"styles":{},"isActive":true,"order":0}]},"coupon":{"seo":{"title":"Coupons","description":""},"isActive":true,"sections":[{"id":"coupon","type":"coupon","variant":"v1","props":{"title":"Coupons","subtitle":"Use these codes when you order.","coupons":[{"code":"WELCOME10","discount":"10% off","title":"Welcome offer","description":"On your first order.","expiryDate":"31 Dec 2026"},{"code":"FREESHIP","discount":"Free delivery","title":"Free delivery","description":"On orders over 1000.","expiryDate":"31 Dec 2026"}],"emptyText":"No coupons right now. Check back soon."},"styles":{},"isActive":true,"order":0}]},"track-order":{"seo":{"title":"Track your order","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Track your order","content":"<p>Sign in to follow your orders, or enter your order number and phone number below. You can also contact us with your order number.</p>"},"styles":{},"isActive":true,"order":0}]},"blog":{"seo":{"title":"Blog","description":""},"isActive":true,"sections":[{"id":"blog","type":"blog","variant":"v1","props":{"title":"From the blog","viewAllLink":"/blog","showViewAll":false,"posts":[]},"styles":{},"isActive":true,"order":0}]},"privacy-policy":{"seo":{"title":"Privacy policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Privacy Policy ","content":"<p>Welcome to our store (“we”, “our”, “us”). Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our website, mobile app, or services (collectively, the “Platform”).</p><p>By using our Platform, you agree to the collection and use of information in accordance with this policy.</p><h2>1. Information We Collect</h2><h3>a. Personal Information</h3><p>When you use our Platform, we may collect:</p><ul><li>Full name</li><li>Email address</li><li>Phone number</li><li>Shipping and billing address</li><li>Payment details (processed securely by third-party payment providers)</li><li>Account login credentials</li></ul><h3>b. Order &amp; Transaction Information</h3><ul><li>Products purchased</li><li>Order history</li><li>Payment status</li><li>Delivery and return details</li></ul><h3>c. Technical &amp; Usage Data</h3><ul><li>IP address</li><li>Browser type and version</li><li>Device information</li><li>Pages visited and time spent</li><li>Cookies and similar tracking technologies</li></ul><h2>2. How We Use Your Information</h2><p>We use your information to:</p><ul><li>Create and manage your account</li><li>Process orders and payments</li><li>Deliver products and services</li><li>Communicate order updates and support responses</li><li>Improve website performance and user experience</li><li>Send promotional messages (only if you opt in)</li><li>Prevent fraud and ensure platform security</li><li>Comply with legal obligations</li></ul><h2>3. Cookies &amp; Tracking Technologies</h2><p>We use cookies and similar technologies to:</p><ul><li>Remember your preferences</li><li>Keep you logged in</li><li>Analyze traffic and usage patterns</li><li>Improve our services</li></ul><p>You can control cookies through your browser settings. Disabling cookies may affect some features of the Platform.</p><h2>4. Sharing Your Information</h2><p>We <strong>do not sell</strong> your personal data.</p><p>We may share your information with:</p><ul><li>Payment gateways (e.g., Stripe, PayPal)</li><li>Delivery and logistics partners</li><li>Analytics and marketing tools</li><li>IT and hosting service providers</li><li>Legal or regulatory authorities (if required by law)</li></ul><p>All third parties are required to protect your data.</p><h2>5. Data Security</h2><p>We implement appropriate technical and organizational measures to protect your data, including:</p><ul><li>Secure servers</li><li>Encrypted communication (HTTPS/SSL)</li><li>Limited internal access</li></ul><p>However, no method of transmission over the internet is 100% secure.</p><h2>6. Data Retention</h2><p>We retain your personal information only as long as necessary to:</p><ul><li>Fulfill orders and services</li><li>Comply with legal, tax, and accounting requirements</li><li>Resolve disputes</li></ul><h2>7. Your Rights</h2><p>Depending on your location, you may have the right to:</p><ul><li>Access your personal data</li><li>Correct inaccurate information</li><li>Request deletion of your data</li><li>Withdraw consent for marketing communications</li></ul><p>To exercise these rights, contact us at <strong>[support@email.com</strong></p><p><strong>]</strong>.</p><h2>8. Children’s Privacy</h2><p>Our Platform is not intended for users under the age of 13. We do not knowingly collect personal information from children.</p><h2>9. Third-Party Links</h2><p>Our Platform may contain links to third-party websites. We are not responsible for their privacy practices.</p><h2>10. Changes to This Policy</h2><p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated “Last updated” date.</p><h2>11. Contact Us</h2><p>If you have any questions about this Privacy Policy, contact us:</p><p>📧 Email: <strong>[support@email.com]</strong></p><p>🏢 Address: <strong>[Company Address]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"shipping-policy":{"seo":{"title":"Shipping policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Shipping Policy","content":"<p>This Shipping Policy explains how orders are processed and delivered by <strong>[Your Store Name]</strong>.</p><h2>1. Order Processing Time</h2><ul><li>Orders are processed within <strong>[1–3] business days</strong></li><li>Orders placed on weekends or holidays are processed next business day</li></ul><h2>2. Shipping Methods &amp; Delivery Time</h2><p>Estimated delivery times:</p><ul><li><strong>Standard Shipping:</strong> [3–7] business days</li><li><strong>Express Shipping:</strong> [1–3] business days</li></ul><p>Delivery times may vary due to location, weather, or courier delays.</p><h2>3. Shipping Charges</h2><ul><li>Shipping fees are calculated at checkout</li><li>Free shipping may apply for orders above <strong>[amount]</strong></li></ul><h2>4. Delivery Areas</h2><p>We currently ship to:</p><ul><li><strong>[Domestic / International – specify regions]</strong></li></ul><h2>5. Order Tracking</h2><p>Once shipped, you will receive:</p><ul><li>A confirmation message/email</li><li>Tracking details (if available)</li></ul><h2>6. Delayed or Lost Shipments</h2><p>If your order is delayed or lost:</p><ul><li>Contact us at <strong>[support@email.com</strong></li><li><strong>]</strong></li><li>We will coordinate with the courier to resolve the issue</li></ul><h2>7. Incorrect Address</h2><p>Please ensure your shipping address is correct. We are not responsible for orders delivered to incorrect addresses provided by the customer.</p><h2>8. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"return-policy":{"seo":{"title":"Return policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Warranty, refund and returns","content":"<h2>1. Our warranty</h2><p>Each product shows its warranty period. <strong>Replacement warranty</strong>: a faulty unit is replaced. <strong>Service warranty</strong>: we repair it free of charge.</p><h2>2. What the warranty does not cover</h2><ul><li>Physical, burn or water damage</li><li>A broken warranty sticker or a unit opened elsewhere</li></ul><h2>3. How to claim</h2><ol><li>Call the hotline with your order number.</li><li>Bring or send the product with its invoice and box.</li><li>We check it and repair or replace it.</li></ol><h2>4. Returns and refunds</h2><p>A faulty or wrong item is replaced within 7 days of delivery. Refunds go back the way you paid within 7 working days.</p>"},"styles":{},"isActive":true,"order":0}]},"terms-of-service":{"seo":{"title":"Terms of service","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Terms & Conditions (Terms of Service)","content":"<p>Welcome to <strong>[Your Store Name]</strong>. By accessing or using our website, mobile app, or services, you agree to these Terms &amp; Conditions.</p><h2>1. Use of the Platform</h2><p>You agree to:</p><ul><li>Provide accurate and current information</li><li>Use the Platform for lawful purposes only</li><li>Not misuse, copy, or exploit our content or services</li></ul><p>We reserve the right to suspend or terminate accounts violating these terms.</p><h2>2. Account Responsibility</h2><p>You are responsible for:</p><ul><li>Maintaining the confidentiality of your account credentials</li><li>All activities that occur under your account</li></ul><h2>3. Product Information &amp; Pricing</h2><ul><li>We strive to display accurate product descriptions and prices</li><li>Errors may occur; we reserve the right to correct them</li><li>Prices and availability are subject to change without notice</li></ul><h2>4. Orders &amp; Payments</h2><ul><li>Orders are confirmed only after successful payment</li><li>We reserve the right to cancel or refuse any order</li><li>Payments are securely processed through third-party providers</li></ul><h2>5. Intellectual Property</h2><p>All content on the Platform (logos, text, images, software) is the property of <strong>[Your Store Name]</strong> and protected by applicable laws.</p><h2>6. Limitation of Liability</h2><p>We are not liable for:</p><ul><li>Indirect or consequential damages</li><li>Delays caused by third-party services</li><li>Losses due to misuse of the Platform</li></ul><h2>7. Termination</h2><p>We may terminate or suspend access to the Platform at any time without notice for violations of these Terms.</p><h2>8. Governing Law</h2><p>These Terms are governed by the laws of <strong>[Country/State]</strong>.</p><h2>9. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p><h1>Shipping Policy</h1><p><strong>Last updated:</strong> [Insert Date]</p><p>This Shipping Policy explain</p>"},"styles":{},"isActive":true,"order":0}]}}`), pL = {
  seo: sL,
  config: cL,
  pages: dL
}, uL = { title: "Projukti — laptops, desktop PCs and computer parts online", description: "Laptops, desktop PCs, processors, graphics cards, monitors and accessories with official warranty. Build your own PC with compatibility checks. Delivery all over Bangladesh." }, yL = { themeId: "computers-1", appearance: { colorMode: "light" }, header: { variant: "v1", actions: { showSearch: !0, showCart: !0, showAccount: !0, showWishlist: !0, cartAction: "sidebar" }, searchPlaceholder: "Search laptops, parts, brands or models…", quickLinks: [] }, footer: { variant: "v1", description: "Laptops, desktop PCs, computer parts and accessories with official warranty, delivered all over Bangladesh.", columns: [{ title: "Information", links: [{ label: "About us", href: "/contact" }, { label: "Offers", href: "/offers" }, { label: "PC Builder", href: "/pc-builder" }, { label: "Tools", href: "/tools" }, { label: "Track order", href: "/track-order" }, { label: "Blog", href: "/blog" }] }, { title: "Policies", links: [{ label: "Terms and conditions", href: "/terms-of-service" }, { label: "Refund and returns", href: "/return-policy" }, { label: "Shipping policy", href: "/shipping-policy" }, { label: "Privacy policy", href: "/privacy-policy" }] }], socialLinks: [{ platform: "facebook", href: "https://facebook.com/" }, { platform: "youtube", href: "https://youtube.com/" }, { platform: "tiktok", href: "https://tiktok.com/" }], copyright: "", badgesTitle: "Affiliation", badges: [], complaintUrl: "/contact" }, floatingButtons: { active: !0, callUsTitle: "Call us", whatsappTitle: "WhatsApp" }, mobileBottomNav: { active: !0, items: [] } }, hL = /* @__PURE__ */ JSON.parse(`{"home":{"seo":{"title":"","description":""},"isActive":true,"sections":[{"id":"hero-banners","type":"banner-carousel","variant":"v2","isActive":true,"order":0,"styles":{"paddingTop":"sm","paddingBottom":"none","background":"muted","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"title":"Offers","autoplay":true,"autoplaySeconds":5,"slides":[{"image":"https://images.unsplash.com/photo-1603481546238-487240415921?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Mnx8Z2FtaW5nJTIwbGFwdG9wJTIwb24lMjBkZXNrfGVufDF8MHx8fDE3OTM1NTM0NzN8MA&ixlib=rb-4.1.0&w=880&h=460&fit=crop&crop=entropy&auto=format&q=80","alt":"Gaming laptops week: up to 10% off","link":"/shop?search=gaming"},{"image":"https://images.unsplash.com/photo-1622013378145-e8d89cfbd990?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8NXx8cGMlMjBidWlsZCUyMGNvbXBvbmVudHN8ZW58MXwwfHx8MTc5MzU1MzQ3NHww&ixlib=rb-4.1.0&w=880&h=460&fit=crop&crop=entropy&auto=format&q=80","alt":"Build your PC with checked parts","link":"/pc-builder"},{"image":"https://images.unsplash.com/photo-1517518295033-d5ab8ca078cc?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8OHx8Y29tcHV0ZXIlMjBtb25pdG9yJTIwZGVza3xlbnwxfDB8fHwxNzkzNTUzNDc0fDA&ixlib=rb-4.1.0&w=880&h=460&fit=crop&crop=entropy&auto=format&q=80","alt":"Fast monitors, 144 Hz and up","link":"/shop?search=monitor"}],"sideBanners":[{"image":"https://images.unsplash.com/photo-1738520420641-0d39da26723c?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8OHx8cG93ZXIlMjBjYWJsZSUyMHBsdWd8ZW58MXwwfHx8MTc5MzU1NDU2NXww&ixlib=rb-4.1.0&w=520&h=230&fit=crop&crop=entropy&auto=format&q=80","alt":"Not sure about your power supply? Use the calculator","link":"/tools"},{"image":"https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8Mnx8c2hvcHBpbmclMjBiYWdzJTIwc2FsZXxlbnwxfDB8fHwxNzkzNTUzNTI4fDA&ixlib=rb-4.1.0&w=520&h=230&fit=crop&crop=entropy&auto=format&q=80","alt":"This month's offers","link":"/offers"}]}},{"id":"category-tiles","type":"category-bento","variant":"v3","isActive":true,"order":10,"styles":{"paddingTop":"sm","paddingBottom":"sm","background":"muted","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"eyebrow":"","title":{"en":"Featured categories","bn":"জনপ্রিয় ক্যাটাগরি"},"subtitle":"Laptops, parts and accessories, sorted for you.","tiles":[],"limit":16}},{"id":"flash-sale","type":"flash-sale","variant":"v1","isActive":true,"order":20,"styles":{"paddingTop":"sm","paddingBottom":"sm","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"title":"Deals of the week","endDate":"2027-12-31T18:00:00.000Z"}},{"id":"featured-products","type":"product-rail","variant":"v1","isActive":true,"order":30,"styles":{"paddingTop":"sm","paddingBottom":"sm","background":"muted","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"eyebrow":"","title":{"en":"Featured products","bn":"বাছাই করা পণ্য"},"subtitle":"","source":{"source":"new","limit":12},"layout":"rail","showViewAll":true}},{"id":"top-rated","type":"product-rail","variant":"v1","isActive":true,"order":40,"styles":{"paddingTop":"sm","paddingBottom":"sm","background":"muted","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"eyebrow":"","title":{"en":"Top rated","bn":"সেরা রেটিং"},"subtitle":"","source":{"source":"top_rated","limit":12},"layout":"rail","showViewAll":true}},{"id":"on-sale","type":"product-rail","variant":"v1","isActive":true,"order":50,"styles":{"paddingTop":"sm","paddingBottom":"sm","background":"muted","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"eyebrow":"","title":{"en":"On sale","bn":"ছাড়ে"},"subtitle":"Discounts while stocks last.","source":{"source":"on_sale","limit":12},"layout":"grid","showViewAll":true}},{"id":"brands","type":"brands","variant":"v1","isActive":true,"order":60,"styles":{"paddingTop":"none","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"title":"Our brands"}},{"id":"reviews","type":"reviews","variant":"v1","isActive":true,"order":70,"styles":{"paddingTop":"none","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"eyebrow":"","title":{"en":"What our customers say","bn":"গ্রাহকদের কথা"},"subtitle":"","items":[],"limit":6,"minRating":4}},{"id":"seo-text","type":"content","variant":"v2","isActive":true,"order":80,"styles":{"paddingTop":"none","paddingBottom":"sm","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{"title":"Computers, laptops and PC parts online in Bangladesh","subtitle":{"en":"Laptops, desktop PCs, processors, graphics cards, monitors and accessories with official warranty and delivery across the country.","bn":"ল্যাপটপ, ডেস্কটপ, প্রসেসর, গ্রাফিক্স কার্ড, মনিটর ও এক্সেসরিজ — অফিসিয়াল ওয়ারেন্টি ও সারা দেশে ডেলিভারি।"},"content":"<h2>Why buy your computer from us</h2><p>Every product carries the brand's warranty, and our team checks that the parts you pick fit together before we ship them. Use the PC Builder to plan a desktop part by part: it warns you when a processor and motherboard use different sockets, when memory does not match the board, or when the power supply is too small.</p><h2>Delivery and payment</h2><p>We deliver across Bangladesh. Pay cash on delivery, by card or by mobile banking; bigger orders can be split into monthly instalments (see the EMI calculator on the Tools page).</p><h2>Need help choosing?</h2><p>Call or message us with what you want to do with the computer, your budget and any parts you already have, and we will suggest a build.</p>","faqs":[],"updatedText":""}}]},"shop":{"seo":{"title":"Shop","description":""},"isActive":true,"sections":[{"id":"shop-grid","type":"shop-grid","variant":"v1","props":{"sidebarVariant":"v1","productCardVariant":"v1","paginationVariant":"v1","initialPriceRange.min":0,"initialPriceRange.max":50000,"itemsPerPage":24,"allCategoriesLabel":"All","filtersButtonLabel":"Filters","showingLabel":"Showing","productsSuffix":"Products","sortNewestLabel":"Sort: Newest","sortOldestLabel":"Sort: Oldest","sortPriceAscLabel":"Price: Low to High","sortPriceDescLabel":"Price: High to Low","sortNameAscLabel":"Name: A-Z","sortNameDescLabel":"Name: Z-A","activeFiltersLabel":"Active Filters:","clearAllLabel":"Clear All","noProductsTitle":"No Products Found","noProductsMessage":"We couldn't find any products matching your current filters. Try adjusting them.","backToAllText":"Back to All Products","filterDrawerTitle":"Filter Products","currentSearchLabel":"Current Search","clearSearchLabel":"Clear","applyFiltersLabel":"Apply Filters","pageSizes":"48, 96"},"styles":{},"isActive":true,"order":0}]},"categories":{"seo":{"title":"Categories","description":""},"isActive":true,"sections":[{"id":"categories","type":"categories","variant":"v1","props":{"columns":4,"emptyText":"No categories found."},"styles":{},"isActive":true,"order":0}]},"product":{"seo":{"title":"","description":""},"isActive":true,"sections":[{"id":"product-detail","type":"product-detail","variant":"v1","props":{"loadingText":"Loading Data...","notFoundCode":"404","notFoundText":"Product Not Found","quantityLabel":"Quantity","productDescTitle":"Description","returnPolicyTitle":"Delivery & returns","howToOrderTitle":"How to order","showDeliveryAreas":true,"howToOrder":{"en":"Choose a version and the quantity.\\nTap \\"Order now\\" to go straight to checkout, or \\"Add to cart\\" to keep shopping.\\nWrite your name, address, district and phone number.\\nWe call to confirm, then deliver. Pay cash on delivery.","bn":"ভার্সন ও পরিমাণ বেছে নিন।\\n\\"Order now\\" চাপুন।\\nনাম, ঠিকানা, জেলা ও ফোন নম্বর লিখুন।\\nআমরা ফোন করে কনফার্ম করে ডেলিভারি দেব।"}},"styles":{},"isActive":true,"order":0},{"id":"similar-products","type":"similar-products","variant":"v1","props":{"productCardVariant":"v1","title":"Related products","limit":5},"styles":{},"isActive":true,"order":10},{"id":"recent-products","type":"recent-products","variant":"v1","props":{"title":"Recently viewed"},"styles":{},"isActive":true,"order":20}]},"cart":{"seo":{"title":"Cart","description":""},"isActive":true,"sections":[{"id":"cart","type":"cart","variant":"v1","props":{"pageTitle":"Shopping cart","emptyTitle":"Your cart is currently empty.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop","summaryTitle":"Cart totals","subtotalLabel":"Subtotal","shippingLabel":"Delivery","shippingCalculatedText":"Delivery charge is added at checkout.","totalLabel":"Total","checkoutButtonText":"Proceed to checkout","checkoutLink":"/checkout"},"styles":{},"isActive":true,"order":0}]},"checkout":{"seo":{"title":"Checkout","description":""},"isActive":true,"sections":[{"id":"checkout","type":"checkout","variant":"v1","props":{"pageTitle":"Billing details","emptyTitle":"Your cart is empty.","continueShoppingText":"Return to shop","continueShoppingLink":"/shop","summaryTitle":"Your order","subtotalLabel":"Subtotal","deliveryLabel":"Delivery","totalLabel":"Total","codLabel":"Cash on delivery","codDescription":"Pay with cash when your order arrives.","placeOrderText":"Place order","placingOrderText":"Placing order…"},"styles":{},"isActive":true,"order":0}]},"order-success":{"seo":{"title":"Order placed","description":""},"isActive":true,"sections":[{"id":"order-success","type":"order-success","variant":"v1","props":{"title":"Thank you. Your order has been received.","message":"We will call you to confirm your order before delivery.","errorTitle":"Your order was placed.","errorMessage":"We could not load the order details on this device, but your order was received.","viewOrderText":"View order","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"signin":{"seo":{"title":"Sign in","description":""},"isActive":true,"sections":[{"id":"signin","type":"signin","variant":"v1","props":{"title":"Sign in","intro":"Use your mobile number. We send you a code by SMS — no password needed.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"signup":{"seo":{"title":"Create account","description":""},"isActive":true,"sections":[{"id":"signup","type":"signup","variant":"v1","props":{"title":"Create your account","intro":"Use your mobile number. We send you a code by SMS — no password needed.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"account":{"seo":{"title":"My account","description":""},"isActive":true,"sections":[{"id":"account","type":"account","variant":"v1","props":{"title":"My account","tabOverviewLabel":"Overview","tabOrdersLabel":"Orders","tabDetailsLabel":"Profile","tabAddressesLabel":"Addresses","signOutLabel":"Sign out"},"styles":{},"isActive":true,"order":0}]},"contact":{"seo":{"title":"Contact us","description":""},"isActive":true,"sections":[{"id":"contact","type":"contact","variant":"v1","props":{"title":"Contact us","description":"Questions about an order or a product? We are happy to help."},"styles":{},"isActive":true,"order":0},{"id":"faq","type":"content","variant":"v3","isActive":true,"order":10,"styles":{},"props":{"title":"Frequently asked questions","subtitle":{"en":"Shipping, warranty and payment","bn":"ডেলিভারি, ওয়ারেন্টি ও পেমেন্ট"},"content":"","faqs":[{"question":"How long does delivery take?","answer":"Inside Dhaka 1–2 days, outside Dhaka 2–3 days."},{"question":"How do I track my order?","answer":"Use Track order with your order number and phone number, or sign in to see your orders."},{"question":"Do I need an account to order?","answer":"No. You can order as a guest; an account keeps your orders and addresses."},{"question":"Which payment methods can I use?","answer":"Cash on delivery all over Bangladesh, bKash, Nagad and cards."},{"question":"How do I claim warranty?","answer":"Bring or send the product with its invoice and box. We repair or replace it within the warranty period shown on the product page."},{"question":"Can I return a product?","answer":"A faulty or wrong item is replaced within 7 days. Check the product in front of the delivery person."},{"question":"Where is your shop?","answer":"See the shop address in the footer or tap \\"Shop address\\" at the bottom of any page."}],"updatedText":""}}]},"wishlist":{"seo":{"title":"Wishlist","description":""},"isActive":true,"sections":[{"id":"wishlist","type":"wishlist","variant":"v1","props":{"title":"Wishlist","subtitle":"Products you saved for later.","emptyTitle":"Your wishlist is empty","emptyText":"Tap the heart on any product to save it here.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"compare":{"seo":{"title":"Compare products","description":""},"isActive":true,"sections":[{"id":"compare","type":"compare","variant":"v1","props":{"title":"Compare products","emptyTitle":"Nothing to compare yet","emptyText":"Add up to four products to compare them side by side."},"styles":{},"isActive":true,"order":0}]},"coupon":{"seo":{"title":"Coupons","description":""},"isActive":true,"sections":[{"id":"coupon","type":"coupon","variant":"v1","props":{"title":"Coupons","subtitle":"Use these codes when you order.","coupons":[{"code":"WELCOME10","discount":"10% off","title":"Welcome offer","description":"On your first order.","expiryDate":"31 Dec 2026"},{"code":"FREESHIP","discount":"Free delivery","title":"Free delivery","description":"On orders over 1000.","expiryDate":"31 Dec 2026"}],"emptyText":"No coupons right now. Check back soon."},"styles":{},"isActive":true,"order":0}]},"track-order":{"seo":{"title":"Track your order","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Track your order","content":"<p>Sign in to follow your orders, or enter your order number and phone number below. You can also contact us with your order number.</p>"},"styles":{},"isActive":true,"order":0}]},"blog":{"seo":{"title":"Blog","description":""},"isActive":true,"sections":[{"id":"blog","type":"blog","variant":"v1","props":{"title":"From the blog","viewAllLink":"/blog","showViewAll":false,"posts":[]},"styles":{},"isActive":true,"order":0}]},"privacy-policy":{"seo":{"title":"Privacy policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Privacy Policy ","content":"<p>Welcome to our store (“we”, “our”, “us”). Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our website, mobile app, or services (collectively, the “Platform”).</p><p>By using our Platform, you agree to the collection and use of information in accordance with this policy.</p><h2>1. Information We Collect</h2><h3>a. Personal Information</h3><p>When you use our Platform, we may collect:</p><ul><li>Full name</li><li>Email address</li><li>Phone number</li><li>Shipping and billing address</li><li>Payment details (processed securely by third-party payment providers)</li><li>Account login credentials</li></ul><h3>b. Order &amp; Transaction Information</h3><ul><li>Products purchased</li><li>Order history</li><li>Payment status</li><li>Delivery and return details</li></ul><h3>c. Technical &amp; Usage Data</h3><ul><li>IP address</li><li>Browser type and version</li><li>Device information</li><li>Pages visited and time spent</li><li>Cookies and similar tracking technologies</li></ul><h2>2. How We Use Your Information</h2><p>We use your information to:</p><ul><li>Create and manage your account</li><li>Process orders and payments</li><li>Deliver products and services</li><li>Communicate order updates and support responses</li><li>Improve website performance and user experience</li><li>Send promotional messages (only if you opt in)</li><li>Prevent fraud and ensure platform security</li><li>Comply with legal obligations</li></ul><h2>3. Cookies &amp; Tracking Technologies</h2><p>We use cookies and similar technologies to:</p><ul><li>Remember your preferences</li><li>Keep you logged in</li><li>Analyze traffic and usage patterns</li><li>Improve our services</li></ul><p>You can control cookies through your browser settings. Disabling cookies may affect some features of the Platform.</p><h2>4. Sharing Your Information</h2><p>We <strong>do not sell</strong> your personal data.</p><p>We may share your information with:</p><ul><li>Payment gateways (e.g., Stripe, PayPal)</li><li>Delivery and logistics partners</li><li>Analytics and marketing tools</li><li>IT and hosting service providers</li><li>Legal or regulatory authorities (if required by law)</li></ul><p>All third parties are required to protect your data.</p><h2>5. Data Security</h2><p>We implement appropriate technical and organizational measures to protect your data, including:</p><ul><li>Secure servers</li><li>Encrypted communication (HTTPS/SSL)</li><li>Limited internal access</li></ul><p>However, no method of transmission over the internet is 100% secure.</p><h2>6. Data Retention</h2><p>We retain your personal information only as long as necessary to:</p><ul><li>Fulfill orders and services</li><li>Comply with legal, tax, and accounting requirements</li><li>Resolve disputes</li></ul><h2>7. Your Rights</h2><p>Depending on your location, you may have the right to:</p><ul><li>Access your personal data</li><li>Correct inaccurate information</li><li>Request deletion of your data</li><li>Withdraw consent for marketing communications</li></ul><p>To exercise these rights, contact us at <strong>[support@email.com</strong></p><p><strong>]</strong>.</p><h2>8. Children’s Privacy</h2><p>Our Platform is not intended for users under the age of 13. We do not knowingly collect personal information from children.</p><h2>9. Third-Party Links</h2><p>Our Platform may contain links to third-party websites. We are not responsible for their privacy practices.</p><h2>10. Changes to This Policy</h2><p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated “Last updated” date.</p><h2>11. Contact Us</h2><p>If you have any questions about this Privacy Policy, contact us:</p><p>📧 Email: <strong>[support@email.com]</strong></p><p>🏢 Address: <strong>[Company Address]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"shipping-policy":{"seo":{"title":"Shipping policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Shipping Policy","content":"<p>This Shipping Policy explains how orders are processed and delivered by <strong>[Your Store Name]</strong>.</p><h2>1. Order Processing Time</h2><ul><li>Orders are processed within <strong>[1–3] business days</strong></li><li>Orders placed on weekends or holidays are processed next business day</li></ul><h2>2. Shipping Methods &amp; Delivery Time</h2><p>Estimated delivery times:</p><ul><li><strong>Standard Shipping:</strong> [3–7] business days</li><li><strong>Express Shipping:</strong> [1–3] business days</li></ul><p>Delivery times may vary due to location, weather, or courier delays.</p><h2>3. Shipping Charges</h2><ul><li>Shipping fees are calculated at checkout</li><li>Free shipping may apply for orders above <strong>[amount]</strong></li></ul><h2>4. Delivery Areas</h2><p>We currently ship to:</p><ul><li><strong>[Domestic / International – specify regions]</strong></li></ul><h2>5. Order Tracking</h2><p>Once shipped, you will receive:</p><ul><li>A confirmation message/email</li><li>Tracking details (if available)</li></ul><h2>6. Delayed or Lost Shipments</h2><p>If your order is delayed or lost:</p><ul><li>Contact us at <strong>[support@email.com</strong></li><li><strong>]</strong></li><li>We will coordinate with the courier to resolve the issue</li></ul><h2>7. Incorrect Address</h2><p>Please ensure your shipping address is correct. We are not responsible for orders delivered to incorrect addresses provided by the customer.</p><h2>8. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"return-policy":{"seo":{"title":"Return policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Warranty, refund and returns","content":"<h2>1. Our warranty</h2><p>Each product shows its warranty period. <strong>Replacement warranty</strong>: a faulty unit is replaced. <strong>Service warranty</strong>: we repair it free of charge.</p><h2>2. What the warranty does not cover</h2><ul><li>Physical, burn or water damage</li><li>A broken warranty sticker or a unit opened elsewhere</li></ul><h2>3. How to claim</h2><ol><li>Call the hotline with your order number.</li><li>Bring or send the product with its invoice and box.</li><li>We check it and repair or replace it.</li></ol><h2>4. Returns and refunds</h2><p>A faulty or wrong item is replaced within 7 days of delivery. Refunds go back the way you paid within 7 working days.</p>"},"styles":{},"isActive":true,"order":0}]},"terms-of-service":{"seo":{"title":"Terms of service","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Terms & Conditions (Terms of Service)","content":"<p>Welcome to <strong>[Your Store Name]</strong>. By accessing or using our website, mobile app, or services, you agree to these Terms &amp; Conditions.</p><h2>1. Use of the Platform</h2><p>You agree to:</p><ul><li>Provide accurate and current information</li><li>Use the Platform for lawful purposes only</li><li>Not misuse, copy, or exploit our content or services</li></ul><p>We reserve the right to suspend or terminate accounts violating these terms.</p><h2>2. Account Responsibility</h2><p>You are responsible for:</p><ul><li>Maintaining the confidentiality of your account credentials</li><li>All activities that occur under your account</li></ul><h2>3. Product Information &amp; Pricing</h2><ul><li>We strive to display accurate product descriptions and prices</li><li>Errors may occur; we reserve the right to correct them</li><li>Prices and availability are subject to change without notice</li></ul><h2>4. Orders &amp; Payments</h2><ul><li>Orders are confirmed only after successful payment</li><li>We reserve the right to cancel or refuse any order</li><li>Payments are securely processed through third-party providers</li></ul><h2>5. Intellectual Property</h2><p>All content on the Platform (logos, text, images, software) is the property of <strong>[Your Store Name]</strong> and protected by applicable laws.</p><h2>6. Limitation of Liability</h2><p>We are not liable for:</p><ul><li>Indirect or consequential damages</li><li>Delays caused by third-party services</li><li>Losses due to misuse of the Platform</li></ul><h2>7. Termination</h2><p>We may terminate or suspend access to the Platform at any time without notice for violations of these Terms.</p><h2>8. Governing Law</h2><p>These Terms are governed by the laws of <strong>[Country/State]</strong>.</p><h2>9. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p><h1>Shipping Policy</h1><p><strong>Last updated:</strong> [Insert Date]</p><p>This Shipping Policy explain</p>"},"styles":{},"isActive":true,"order":0}]},"offers":{"isActive":true,"sections":[{"id":"offers-offers-list","type":"offers-list","variant":"v1","isActive":true,"order":0,"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{}}]},"tools":{"isActive":true,"sections":[{"id":"tools-emi-calculator","type":"emi-calculator","variant":"v1","isActive":true,"order":0,"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{}},{"id":"tools-power-calculator","type":"power-calculator","variant":"v1","isActive":true,"order":10,"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{}}]},"pc-builder":{"isActive":true,"sections":[{"id":"pc-builder-pc-builder","type":"pc-builder","variant":"v1","isActive":true,"order":0,"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"props":{}}]}}`), bL = {
  seo: uL,
  config: yL,
  pages: hL
}, mL = { title: "Fresh Basket — everyday essentials", description: "Everyday essentials delivered to your door. Cash on delivery." }, gL = { themeId: "essentials-1", appearance: { colorMode: "light" }, header: { variant: "v1", topbar: { active: !0, messages: [{ text: "Free delivery on bigger orders" }, { text: "Cash on delivery everywhere we deliver" }], dismissible: !0 }, actions: { showSearch: !0, showCart: !0, showAccount: !0, showWishlist: !0, cartAction: "sidebar" }, searchPlaceholder: "Search products…", menu: [{ label: "Shop", href: "/shop", type: "categories" }, { label: "Categories", href: "/categories", type: "link" }, { label: "Offers", href: "/shop?sort=discount", type: "link", badge: "New" }, { label: "Blog", href: "/blog", type: "link" }, { label: "Contact", href: "/contact", type: "link" }] }, footer: { variant: "v1", description: "Everyday essentials, delivered.", columns: [{ title: "Shop", links: [{ label: "All products", href: "/shop" }, { label: "Categories", href: "/categories" }, { label: "Track order", href: "/track-order" }] }, { title: "Help", links: [{ label: "Contact us", href: "/contact" }, { label: "Shipping policy", href: "/shipping-policy" }, { label: "Return policy", href: "/return-policy" }] }, { title: "Company", links: [{ label: "Privacy policy", href: "/privacy-policy" }, { label: "Terms of service", href: "/terms-of-service" }] }], socialLinks: [] }, floatingButtons: { active: !0 }, mobileBottomNav: { active: !0, items: [] } }, fL = /* @__PURE__ */ JSON.parse(`{"home":{"seo":{"title":"","description":""},"isActive":true,"sections":[{"id":"hero","type":"hero","variant":"v1","props":{"eyebrow":"Fresh every day","headline":"Everyday essentials, delivered to your door","subtext":"Hand-picked products at fair prices. Order in minutes and pay when it arrives.","primaryCta.label":"Shop now","primaryCta.url":"/shop","secondaryCta.label":"Today’s deals","secondaryCta.url":"/shop?order_by=discount_desc","showTrustChips":true,"trustChips":[{"icon":"shipping","text":"Fast delivery"},{"icon":"secure","text":"Cash on delivery"},{"icon":"refund","text":"Easy returns"}],"showCards":true,"cards":[],"slides":[],"autoplay":true,"autoplaySeconds":6},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":0},{"id":"category-bento","type":"category-bento","variant":"v2","props":{"eyebrow":"Browse","title":"Shop by category","subtitle":"","tiles":[],"limit":8},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":10},{"id":"on-sale","type":"product-rail","variant":"v1","props":{"eyebrow":"Deals","title":"Today's deals","subtitle":"Lower prices on everyday favourites.","source":{"source":"on_sale","limit":8},"layout":"grid","showViewAll":true,"viewAllLabel":"View all"},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":20},{"id":"story","type":"story","variant":"v1","props":{"eyebrow":"Our promise","title":"Why shop with us","subtitle":"Good products, honest prices and service you can count on.","points":[{"icon":"secure","title":"Quality checked","body":"Every product is checked before it leaves our store."},{"icon":"shipping","title":"Delivered fresh","body":"Packed with care and delivered quickly to your door."},{"icon":"support","title":"Real support","body":"Questions about an order? Call or message us any day."}],"ctaLabel":"","ctaLink":""},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":30},{"id":"combo-spotlight","type":"combo-spotlight","variant":"v1","props":{"eyebrow":"Bundle & save","title":"Value pack of the week","subtitle":"","description":"","mrpLabel":"Regular price","savingLabel":"You save","detailsLabel":"View details"},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":40},{"id":"new-arrivals","type":"product-rail","variant":"v1","props":{"eyebrow":"Just in","title":"New arrivals","subtitle":"The latest additions to the store.","source":{"source":"new","limit":8},"layout":"grid","showViewAll":true,"viewAllLabel":"View all"},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":50},{"id":"reviews","type":"reviews","variant":"v1","props":{"eyebrow":"Reviews","title":"What customers say","subtitle":"","items":[],"limit":6,"minRating":4},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":60},{"id":"promises","type":"promises","variant":"v1","props":{"eyebrow":"","title":"","subtitle":"","items":[{"icon":"shipping","title":"Fast delivery","body":"Quick delivery across the city."},{"icon":"secure","title":"Pay on delivery","body":"Pay in cash when your order arrives."},{"icon":"refund","title":"Easy returns","body":"Not right? We will make it right."},{"icon":"support","title":"Here to help","body":"Call or message us any day."}]},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":70},{"id":"corporate-band","type":"corporate-band","variant":"v1","props":{"eyebrow":"For businesses","title":"Bulk and corporate orders","text":"Ordering for an office, an event or gifts? Get volume pricing and scheduled delivery.","cta.label":"Contact us","cta.url":"/contact"},"styles":{"paddingTop":"md","paddingBottom":"md","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":80}]},"shop":{"seo":{"title":"Shop","description":""},"isActive":true,"sections":[{"id":"shop-grid","type":"shop-grid","variant":"v1","props":{"sidebarVariant":"v1","productCardVariant":"v1","paginationVariant":"v1","initialPriceRange.min":0,"initialPriceRange.max":50000,"itemsPerPage":12,"allCategoriesLabel":"All","filtersButtonLabel":"Filters","showingLabel":"Showing","productsSuffix":"Products","sortNewestLabel":"Sort: Newest","sortOldestLabel":"Sort: Oldest","sortPriceAscLabel":"Price: Low to High","sortPriceDescLabel":"Price: High to Low","sortNameAscLabel":"Name: A-Z","sortNameDescLabel":"Name: Z-A","activeFiltersLabel":"Active Filters:","clearAllLabel":"Clear All","noProductsTitle":"No Products Found","noProductsMessage":"We couldn't find any products matching your current filters. Try adjusting them.","backToAllText":"Back to All Products","filterDrawerTitle":"Filter Products","currentSearchLabel":"Current Search","clearSearchLabel":"Clear","applyFiltersLabel":"Apply Filters"},"styles":{},"isActive":true,"order":0}]},"categories":{"seo":{"title":"Categories","description":""},"isActive":true,"sections":[{"id":"categories","type":"categories","variant":"v1","props":{"columns":4,"emptyText":"No categories found."},"styles":{},"isActive":true,"order":0}]},"product":{"seo":{"title":"","description":""},"isActive":true,"sections":[{"id":"product-detail","type":"product-detail","variant":"v1","props":{"loadingText":"Loading Data...","notFoundCode":"404","notFoundText":"Product Not Found","quantityLabel":"Quantity","productDescTitle":"Product Description","returnPolicyTitle":"Return Policy","howToOrderTitle":"How to order","showDeliveryAreas":true},"styles":{},"isActive":true,"order":0},{"id":"similar-products","type":"similar-products","variant":"v1","props":{"productCardVariant":"v1","title":"Similar Products","limit":4},"styles":{},"isActive":true,"order":10}]},"cart":{"seo":{"title":"Cart","description":""},"isActive":true,"sections":[{"id":"cart","type":"cart","variant":"v1","props":{"pageTitle":"Shopping cart","emptyTitle":"Your cart is currently empty.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop","summaryTitle":"Cart totals","subtotalLabel":"Subtotal","shippingLabel":"Delivery","shippingCalculatedText":"Delivery charge is added at checkout.","totalLabel":"Total","checkoutButtonText":"Proceed to checkout","checkoutLink":"/checkout"},"styles":{},"isActive":true,"order":0}]},"checkout":{"seo":{"title":"Checkout","description":""},"isActive":true,"sections":[{"id":"checkout","type":"checkout","variant":"v1","props":{"pageTitle":"Billing details","emptyTitle":"Your cart is empty.","continueShoppingText":"Return to shop","continueShoppingLink":"/shop","summaryTitle":"Your order","subtotalLabel":"Subtotal","deliveryLabel":"Delivery","totalLabel":"Total","codLabel":"Cash on delivery","codDescription":"Pay with cash when your order arrives.","placeOrderText":"Place order","placingOrderText":"Placing order…"},"styles":{},"isActive":true,"order":0}]},"order-success":{"seo":{"title":"Order placed","description":""},"isActive":true,"sections":[{"id":"order-success","type":"order-success","variant":"v1","props":{"title":"Thank you. Your order has been received.","message":"We will call you to confirm your order before delivery.","errorTitle":"Your order was placed.","errorMessage":"We could not load the order details on this device, but your order was received.","viewOrderText":"View order","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"signin":{"seo":{"title":"Sign in","description":""},"isActive":true,"sections":[{"id":"signin","type":"signin","variant":"v1","props":{"title":"Sign in","intro":"Use your mobile number. We send you a code by SMS — no password needed.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"signup":{"seo":{"title":"Create account","description":""},"isActive":true,"sections":[{"id":"signup","type":"signup","variant":"v1","props":{"title":"Create your account","intro":"Use your mobile number. We send you a code by SMS — no password needed.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"account":{"seo":{"title":"My account","description":""},"isActive":true,"sections":[{"id":"account","type":"account","variant":"v1","props":{"title":"My account","tabOverviewLabel":"Overview","tabOrdersLabel":"Orders","tabDetailsLabel":"Profile","tabAddressesLabel":"Addresses","signOutLabel":"Sign out"},"styles":{},"isActive":true,"order":0}]},"contact":{"seo":{"title":"Contact us","description":""},"isActive":true,"sections":[{"id":"contact","type":"contact","variant":"v1","props":{"title":"Contact us","description":"Questions about an order or a product? We are happy to help."},"styles":{},"isActive":true,"order":0}]},"wishlist":{"seo":{"title":"Wishlist","description":""},"isActive":true,"sections":[{"id":"wishlist","type":"wishlist","variant":"v1","props":{"title":"Wishlist","subtitle":"Products you saved for later.","emptyTitle":"Your wishlist is empty","emptyText":"Tap the heart on any product to save it here.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"compare":{"seo":{"title":"Compare products","description":""},"isActive":true,"sections":[{"id":"compare","type":"compare","variant":"v1","props":{"title":"Compare products","emptyTitle":"Nothing to compare yet","emptyText":"Add up to four products to compare them side by side."},"styles":{},"isActive":true,"order":0}]},"coupon":{"seo":{"title":"Coupons","description":""},"isActive":true,"sections":[{"id":"coupon","type":"coupon","variant":"v1","props":{"title":"Coupons","subtitle":"Use these codes when you order.","coupons":[{"code":"WELCOME10","discount":"10% off","title":"Welcome offer","description":"On your first order.","expiryDate":"31 Dec 2026"},{"code":"FREESHIP","discount":"Free delivery","title":"Free delivery","description":"On orders over 1000.","expiryDate":"31 Dec 2026"}],"emptyText":"No coupons right now. Check back soon."},"styles":{},"isActive":true,"order":0}]},"track-order":{"seo":{"title":"Track your order","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Track your order","content":"<p>Sign in to follow your orders, or enter your order number and phone number below. You can also contact us with your order number.</p>"},"styles":{},"isActive":true,"order":0}]},"blog":{"seo":{"title":"Blog","description":""},"isActive":true,"sections":[{"id":"blog","type":"blog","variant":"v1","props":{"title":"From the blog","viewAllLink":"/blog","showViewAll":false,"posts":[]},"styles":{},"isActive":true,"order":0}]},"privacy-policy":{"seo":{"title":"Privacy policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Privacy Policy ","content":"<p>Welcome to our store (“we”, “our”, “us”). Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our website, mobile app, or services (collectively, the “Platform”).</p><p>By using our Platform, you agree to the collection and use of information in accordance with this policy.</p><h2>1. Information We Collect</h2><h3>a. Personal Information</h3><p>When you use our Platform, we may collect:</p><ul><li>Full name</li><li>Email address</li><li>Phone number</li><li>Shipping and billing address</li><li>Payment details (processed securely by third-party payment providers)</li><li>Account login credentials</li></ul><h3>b. Order &amp; Transaction Information</h3><ul><li>Products purchased</li><li>Order history</li><li>Payment status</li><li>Delivery and return details</li></ul><h3>c. Technical &amp; Usage Data</h3><ul><li>IP address</li><li>Browser type and version</li><li>Device information</li><li>Pages visited and time spent</li><li>Cookies and similar tracking technologies</li></ul><h2>2. How We Use Your Information</h2><p>We use your information to:</p><ul><li>Create and manage your account</li><li>Process orders and payments</li><li>Deliver products and services</li><li>Communicate order updates and support responses</li><li>Improve website performance and user experience</li><li>Send promotional messages (only if you opt in)</li><li>Prevent fraud and ensure platform security</li><li>Comply with legal obligations</li></ul><h2>3. Cookies &amp; Tracking Technologies</h2><p>We use cookies and similar technologies to:</p><ul><li>Remember your preferences</li><li>Keep you logged in</li><li>Analyze traffic and usage patterns</li><li>Improve our services</li></ul><p>You can control cookies through your browser settings. Disabling cookies may affect some features of the Platform.</p><h2>4. Sharing Your Information</h2><p>We <strong>do not sell</strong> your personal data.</p><p>We may share your information with:</p><ul><li>Payment gateways (e.g., Stripe, PayPal)</li><li>Delivery and logistics partners</li><li>Analytics and marketing tools</li><li>IT and hosting service providers</li><li>Legal or regulatory authorities (if required by law)</li></ul><p>All third parties are required to protect your data.</p><h2>5. Data Security</h2><p>We implement appropriate technical and organizational measures to protect your data, including:</p><ul><li>Secure servers</li><li>Encrypted communication (HTTPS/SSL)</li><li>Limited internal access</li></ul><p>However, no method of transmission over the internet is 100% secure.</p><h2>6. Data Retention</h2><p>We retain your personal information only as long as necessary to:</p><ul><li>Fulfill orders and services</li><li>Comply with legal, tax, and accounting requirements</li><li>Resolve disputes</li></ul><h2>7. Your Rights</h2><p>Depending on your location, you may have the right to:</p><ul><li>Access your personal data</li><li>Correct inaccurate information</li><li>Request deletion of your data</li><li>Withdraw consent for marketing communications</li></ul><p>To exercise these rights, contact us at <strong>[support@email.com</strong></p><p><strong>]</strong>.</p><h2>8. Children’s Privacy</h2><p>Our Platform is not intended for users under the age of 13. We do not knowingly collect personal information from children.</p><h2>9. Third-Party Links</h2><p>Our Platform may contain links to third-party websites. We are not responsible for their privacy practices.</p><h2>10. Changes to This Policy</h2><p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated “Last updated” date.</p><h2>11. Contact Us</h2><p>If you have any questions about this Privacy Policy, contact us:</p><p>📧 Email: <strong>[support@email.com]</strong></p><p>🏢 Address: <strong>[Company Address]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"shipping-policy":{"seo":{"title":"Shipping policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Shipping Policy","content":"<p>This Shipping Policy explains how orders are processed and delivered by <strong>[Your Store Name]</strong>.</p><h2>1. Order Processing Time</h2><ul><li>Orders are processed within <strong>[1–3] business days</strong></li><li>Orders placed on weekends or holidays are processed next business day</li></ul><h2>2. Shipping Methods &amp; Delivery Time</h2><p>Estimated delivery times:</p><ul><li><strong>Standard Shipping:</strong> [3–7] business days</li><li><strong>Express Shipping:</strong> [1–3] business days</li></ul><p>Delivery times may vary due to location, weather, or courier delays.</p><h2>3. Shipping Charges</h2><ul><li>Shipping fees are calculated at checkout</li><li>Free shipping may apply for orders above <strong>[amount]</strong></li></ul><h2>4. Delivery Areas</h2><p>We currently ship to:</p><ul><li><strong>[Domestic / International – specify regions]</strong></li></ul><h2>5. Order Tracking</h2><p>Once shipped, you will receive:</p><ul><li>A confirmation message/email</li><li>Tracking details (if available)</li></ul><h2>6. Delayed or Lost Shipments</h2><p>If your order is delayed or lost:</p><ul><li>Contact us at <strong>[support@email.com</strong></li><li><strong>]</strong></li><li>We will coordinate with the courier to resolve the issue</li></ul><h2>7. Incorrect Address</h2><p>Please ensure your shipping address is correct. We are not responsible for orders delivered to incorrect addresses provided by the customer.</p><h2>8. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"return-policy":{"seo":{"title":"Return policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Return & Refund Policy","content":"<p>At <strong>[Your Store Name]</strong>, we want you to be satisfied with your purchase. This Return &amp; Refund Policy explains when and how you can return items bought from our Platform.</p><h2>1. Eligibility for Returns</h2><p>You may request a return if:</p><ul><li>The product is damaged, defective, or incorrect</li><li>The product is unused and in original condition</li><li>The return request is made within <strong>[7/14/30] days</strong> of delivery</li></ul><p>Items must be returned with:</p><ul><li>Original packaging</li><li>Tags, labels, and accessories (if any)</li><li>Proof of purchase</li></ul><h2>2. Non-Returnable Items</h2><p>The following items are <strong>not eligible</strong> for return or refund:</p><ul><li>Perishable goods</li><li>Personal care or hygiene products</li><li>Digital products or downloadable items</li><li>Customized or made-to-order products</li><li>Items marked as “Final Sale”</li></ul><h2>3. Return Process</h2><p>To initiate a return:</p><ol><li>Contact us at <strong>[support@email.com</strong></li><li><strong>]</strong> with your order ID</li><li>Our team will review and approve the request</li><li>Ship the product to the provided return address</li></ol><p>Return shipping costs:</p><ul><li>Covered by us if the item is defective or incorrect</li><li>Covered by the customer for all other reasons</li></ul><h2>4. Refunds</h2><ul><li>Approved refunds will be processed within <strong>[5–10] business days</strong></li><li>Refunds will be issued to the original payment method</li><li>Shipping charges are non-refundable unless the return is due to our error</li></ul><h2>5. Exchanges</h2><p>We replace items only if they are defective, damaged, or incorrect. Exchange requests are subject to product availability.</p><h2>6. Contact</h2><p>For return-related questions:</p><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p><h1>Terms &amp; Conditions (Terms of Service)</h1><p><strong>Last updated:</strong> [Insert Date]</p><p>Welcome to <strong>[Your Store Name]</strong>. By accessing or using our website, mobile app, or services, you agree to these Terms &amp; Conditions.</p><h2>1. Use of the Platform</h2><p>You agree to:</p><ul><li>Provide accurate and current information</li><li>Use the Platform for lawful purposes only</li><li>Not misuse, copy, or exploit our content or services</li></ul><p>We reserve the right to suspend or terminate accounts violating these terms.</p><h2>2. Account Responsibility</h2><p>You are responsible for:</p><ul><li>Maintaining the confidentiality of your account credentials</li><li>All activities that occur under your account</li></ul><h2>3. Product Information &amp; Pricing</h2><ul><li>We strive to display accurate product descriptions and prices</li><li>Errors may occur; we reserve the right to correct them</li><li>Prices and availability are subject to change without notice</li></ul><h2>4. Orders &amp; Payments</h2><ul><li>Orders are confirmed only after successful payment</li><li>We reserve the right to cancel or refuse any order</li><li>Payments are securely processed through third-party providers</li></ul><h2>5. Intellectual Property</h2><p>All content on the Platform (logos, text, images, software) is the property of <strong>[Your Store Name]</strong> and protected by applicable laws.</p><h2>6. Limitation of Liability</h2><p>We are not liable for:</p><ul><li>Indirect or consequential damages</li><li>Delays caused by third-party services</li><li>Losses due to misuse of the Platform</li></ul><h2>7. Termination</h2><p>We may terminate or suspend access to the Platform at any time without notice for violations of these Terms.</p><h2>8. Governing Law</h2><p>These Terms are governed by the laws of <strong>[Country/State]</strong>.</p><h2>9. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"terms-of-service":{"seo":{"title":"Terms of service","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Terms & Conditions (Terms of Service)","content":"<p>Welcome to <strong>[Your Store Name]</strong>. By accessing or using our website, mobile app, or services, you agree to these Terms &amp; Conditions.</p><h2>1. Use of the Platform</h2><p>You agree to:</p><ul><li>Provide accurate and current information</li><li>Use the Platform for lawful purposes only</li><li>Not misuse, copy, or exploit our content or services</li></ul><p>We reserve the right to suspend or terminate accounts violating these terms.</p><h2>2. Account Responsibility</h2><p>You are responsible for:</p><ul><li>Maintaining the confidentiality of your account credentials</li><li>All activities that occur under your account</li></ul><h2>3. Product Information &amp; Pricing</h2><ul><li>We strive to display accurate product descriptions and prices</li><li>Errors may occur; we reserve the right to correct them</li><li>Prices and availability are subject to change without notice</li></ul><h2>4. Orders &amp; Payments</h2><ul><li>Orders are confirmed only after successful payment</li><li>We reserve the right to cancel or refuse any order</li><li>Payments are securely processed through third-party providers</li></ul><h2>5. Intellectual Property</h2><p>All content on the Platform (logos, text, images, software) is the property of <strong>[Your Store Name]</strong> and protected by applicable laws.</p><h2>6. Limitation of Liability</h2><p>We are not liable for:</p><ul><li>Indirect or consequential damages</li><li>Delays caused by third-party services</li><li>Losses due to misuse of the Platform</li></ul><h2>7. Termination</h2><p>We may terminate or suspend access to the Platform at any time without notice for violations of these Terms.</p><h2>8. Governing Law</h2><p>These Terms are governed by the laws of <strong>[Country/State]</strong>.</p><h2>9. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p><h1>Shipping Policy</h1><p><strong>Last updated:</strong> [Insert Date]</p><p>This Shipping Policy explain</p>"},"styles":{},"isActive":true,"order":0}]}}`), vL = {
  seo: mL,
  config: gL,
  pages: fL
}, kL = { title: "Prottoho — everyday essentials", description: "Everyday essentials delivered to your door. Cash on delivery." }, wL = { themeId: "essentials-2", appearance: { colorMode: "light" }, header: { variant: "v1", topbar: { active: !0, messages: [{ text: "Free delivery on bigger orders" }, { text: "Cash on delivery everywhere we deliver" }], dismissible: !0 }, actions: { showSearch: !0, showCart: !0, showAccount: !0, showWishlist: !0, cartAction: "sidebar" }, searchPlaceholder: "Search products…", menu: [{ label: "Shop", href: "/shop", type: "categories" }, { label: "Categories", href: "/categories", type: "link" }, { label: "Offers", href: "/shop?sort=discount", type: "link", badge: "New" }, { label: "Blog", href: "/blog", type: "link" }, { label: "Contact", href: "/contact", type: "link" }] }, footer: { variant: "v1", description: "Everyday essentials, delivered.", columns: [{ title: "Shop", links: [{ label: "All products", href: "/shop" }, { label: "Categories", href: "/categories" }, { label: "Track order", href: "/track-order" }] }, { title: "Help", links: [{ label: "Contact us", href: "/contact" }, { label: "Shipping policy", href: "/shipping-policy" }, { label: "Return policy", href: "/return-policy" }] }, { title: "Company", links: [{ label: "Privacy policy", href: "/privacy-policy" }, { label: "Terms of service", href: "/terms-of-service" }] }], socialLinks: [] }, floatingButtons: { active: !0 }, mobileBottomNav: { active: !0, items: [] } }, SL = /* @__PURE__ */ JSON.parse(`{"home":{"seo":{"title":"","description":""},"isActive":true,"sections":[{"id":"hero","type":"hero","variant":"v1","props":{"eyebrow":"Fresh every day","headline":"Everyday essentials, delivered to your door","subtext":"Hand-picked products at fair prices. Order in minutes and pay when it arrives.","primaryCta.label":"Shop now","primaryCta.url":"/shop","secondaryCta.label":"Today’s deals","secondaryCta.url":"/shop?order_by=discount_desc","showTrustChips":false,"trustChips":[{"icon":"shipping","text":"Fast delivery"},{"icon":"secure","text":"Cash on delivery"},{"icon":"refund","text":"Easy returns"}],"showCards":true,"cards":[],"slides":[{"title":"Weekend bazar: up to 30% off","image":"https://images.unsplash.com/photo-1552825896-8059df63a1fb?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8ZnJlc2glMjB2ZWdldGFibGVzJTIwbWFya2V0JTIwc3RhbGx8ZW58MXwwfHx8MTc5MzEzODg1MHww&ixlib=rb-4.1.0&w=1240&h=420&fit=crop&crop=entropy&auto=format&q=80","ctaLink":"/shop?order_by=discount_desc"}],"autoplay":false,"autoplaySeconds":6},"styles":{"paddingTop":"none","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":0},{"id":"promises","type":"promises","variant":"v1","props":{"eyebrow":"","title":"","subtitle":"","items":[{"icon":"shipping","title":"Fast delivery","body":"Free delivery on bigger orders"},{"icon":"secure","title":"Authentic products","body":"Easy exchange within 7 days"},{"icon":"phone","title":"Customer support","body":"Every day, 8am to 10pm"},{"icon":"cash","title":"Flexible payments","body":"Cash on delivery or pay online"}]},"styles":{"paddingTop":"sm","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":10},{"id":"new-arrivals","type":"product-rail","variant":"v1","props":{"eyebrow":"","title":"Recommended for you","subtitle":"","source":{"source":"new","limit":12},"layout":"rail","showViewAll":false,"viewAllLabel":"View all"},"styles":{"paddingTop":"sm","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":20},{"id":"weekday-deals","type":"flash-sale","variant":"v1","props":{"title":"Weekday deals!!!","endDate":"","sideImage":"https://images.unsplash.com/photo-1609842947419-ba4f04d5d60f?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8NHx8Z3JvY2VyeSUyMHNob3BwaW5nJTIwYmFza2V0fGVufDF8MXx8fDE3OTMxMzg4NTN8MA&ixlib=rb-4.1.0&w=520&h=760&fit=crop&crop=entropy&auto=format&q=80","sideLink":"/shop?order_by=discount_desc"},"styles":{"paddingTop":"sm","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":30},{"id":"offer-banner","type":"offer-banner","variant":"v1","props":{"image":"https://images.unsplash.com/photo-1589011915994-46f6a2d6c7af?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8NHx8Z3JvY2VyaWVzJTIwZmxhdCUyMGxheXxlbnwxfDB8fHwxNzkzMTM4ODU1fDA&ixlib=rb-4.1.0&w=1600&h=500&fit=crop&crop=entropy&auto=format&q=80","title":"Best deals this week","subtitle":"Fresh prices on everyday groceries","ctaText":"Shop now","ctaLink":"/shop?order_by=discount_desc","overlayOpacity":50},"styles":{"paddingTop":"sm","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":40},{"id":"on-sale","type":"product-rail","variant":"v1","props":{"eyebrow":"","title":"Hot & trending right now","subtitle":"","source":{"source":"on_sale","limit":12},"layout":"rail","showViewAll":true,"viewAllLabel":"View all"},"styles":{"paddingTop":"sm","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":50},{"id":"category-bento","type":"category-bento","variant":"v2","props":{"eyebrow":"","title":"Shop by category","subtitle":"","tiles":[],"limit":8},"styles":{"paddingTop":"sm","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":60},{"id":"most-picked","type":"product-rail","variant":"v1","props":{"eyebrow":"","title":"Most picked","subtitle":"","source":{"source":"top_rated","limit":12},"layout":"rail","showViewAll":true,"viewAllLabel":"View all"},"styles":{"paddingTop":"sm","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":70},{"id":"combo-spotlight","type":"combo-spotlight","variant":"v1","props":{"eyebrow":"Bundle & save","title":"Value pack of the week","subtitle":"","description":"","mrpLabel":"Regular price","savingLabel":"You save","detailsLabel":"View details"},"styles":{"paddingTop":"sm","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":80},{"id":"reviews","type":"reviews","variant":"v1","props":{"eyebrow":"Reviews","title":"What customers say","subtitle":"","items":[],"limit":6,"minRating":4},"styles":{"paddingTop":"sm","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":90},{"id":"corporate-band","type":"corporate-band","variant":"v1","props":{"eyebrow":"For businesses","title":"Bulk and corporate orders","text":"Ordering for an office, an event or gifts? Get volume pricing and scheduled delivery.","cta.label":"Contact us","cta.url":"/contact"},"styles":{"paddingTop":"sm","paddingBottom":"none","background":"default","containerWidth":"wide","hideOnMobile":false,"hideOnDesktop":false},"isActive":true,"order":100}]},"shop":{"seo":{"title":"Shop","description":""},"isActive":true,"sections":[{"id":"shop-grid","type":"shop-grid","variant":"v1","props":{"sidebarVariant":"v1","productCardVariant":"v1","paginationVariant":"v1","initialPriceRange.min":0,"initialPriceRange.max":50000,"itemsPerPage":12,"allCategoriesLabel":"All","filtersButtonLabel":"Filters","showingLabel":"Showing","productsSuffix":"Products","sortNewestLabel":"Sort: Newest","sortOldestLabel":"Sort: Oldest","sortPriceAscLabel":"Price: Low to High","sortPriceDescLabel":"Price: High to Low","sortNameAscLabel":"Name: A-Z","sortNameDescLabel":"Name: Z-A","activeFiltersLabel":"Active Filters:","clearAllLabel":"Clear All","noProductsTitle":"No Products Found","noProductsMessage":"We couldn't find any products matching your current filters. Try adjusting them.","backToAllText":"Back to All Products","filterDrawerTitle":"Filter Products","currentSearchLabel":"Current Search","clearSearchLabel":"Clear","applyFiltersLabel":"Apply Filters"},"styles":{},"isActive":true,"order":0}]},"categories":{"seo":{"title":"Categories","description":""},"isActive":true,"sections":[{"id":"categories","type":"categories","variant":"v1","props":{"columns":4,"emptyText":"No categories found."},"styles":{},"isActive":true,"order":0}]},"product":{"seo":{"title":"","description":""},"isActive":true,"sections":[{"id":"product-detail","type":"product-detail","variant":"v1","props":{"loadingText":"Loading Data...","notFoundCode":"404","notFoundText":"Product Not Found","quantityLabel":"Quantity","productDescTitle":"Product Description","returnPolicyTitle":"Return Policy","howToOrderTitle":"How to order","showDeliveryAreas":true},"styles":{},"isActive":true,"order":0},{"id":"similar-products","type":"similar-products","variant":"v1","props":{"productCardVariant":"v1","title":"Similar Products","limit":4},"styles":{},"isActive":true,"order":10}]},"cart":{"seo":{"title":"Cart","description":""},"isActive":true,"sections":[{"id":"cart","type":"cart","variant":"v1","props":{"pageTitle":"Shopping cart","emptyTitle":"Your cart is currently empty.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop","summaryTitle":"Cart totals","subtotalLabel":"Subtotal","shippingLabel":"Delivery","shippingCalculatedText":"Delivery charge is added at checkout.","totalLabel":"Total","checkoutButtonText":"Proceed to checkout","checkoutLink":"/checkout"},"styles":{},"isActive":true,"order":0}]},"checkout":{"seo":{"title":"Checkout","description":""},"isActive":true,"sections":[{"id":"checkout","type":"checkout","variant":"v1","props":{"pageTitle":"Billing details","emptyTitle":"Your cart is empty.","continueShoppingText":"Return to shop","continueShoppingLink":"/shop","summaryTitle":"Your order","subtotalLabel":"Subtotal","deliveryLabel":"Delivery","totalLabel":"Total","codLabel":"Cash on delivery","codDescription":"Pay with cash when your order arrives.","placeOrderText":"Place order","placingOrderText":"Placing order…"},"styles":{},"isActive":true,"order":0}]},"order-success":{"seo":{"title":"Order placed","description":""},"isActive":true,"sections":[{"id":"order-success","type":"order-success","variant":"v1","props":{"title":"Thank you. Your order has been received.","message":"We will call you to confirm your order before delivery.","errorTitle":"Your order was placed.","errorMessage":"We could not load the order details on this device, but your order was received.","viewOrderText":"View order","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"signin":{"seo":{"title":"Sign in","description":""},"isActive":true,"sections":[{"id":"signin","type":"signin","variant":"v1","props":{"title":"Sign in","intro":"Use your mobile number. We send you a code by SMS — no password needed.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"signup":{"seo":{"title":"Create account","description":""},"isActive":true,"sections":[{"id":"signup","type":"signup","variant":"v1","props":{"title":"Create your account","intro":"Use your mobile number. We send you a code by SMS — no password needed.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"account":{"seo":{"title":"My account","description":""},"isActive":true,"sections":[{"id":"account","type":"account","variant":"v1","props":{"title":"My account","tabOverviewLabel":"Overview","tabOrdersLabel":"Orders","tabDetailsLabel":"Profile","tabAddressesLabel":"Addresses","signOutLabel":"Sign out"},"styles":{},"isActive":true,"order":0}]},"contact":{"seo":{"title":"Contact us","description":""},"isActive":true,"sections":[{"id":"contact","type":"contact","variant":"v1","props":{"title":"Contact us","description":"Questions about an order or a product? We are happy to help."},"styles":{},"isActive":true,"order":0}]},"wishlist":{"seo":{"title":"Wishlist","description":""},"isActive":true,"sections":[{"id":"wishlist","type":"wishlist","variant":"v1","props":{"title":"Wishlist","subtitle":"Products you saved for later.","emptyTitle":"Your wishlist is empty","emptyText":"Tap the heart on any product to save it here.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"compare":{"seo":{"title":"Compare products","description":""},"isActive":true,"sections":[{"id":"compare","type":"compare","variant":"v1","props":{"title":"Compare products","emptyTitle":"Nothing to compare yet","emptyText":"Add up to four products to compare them side by side."},"styles":{},"isActive":true,"order":0}]},"coupon":{"seo":{"title":"Coupons","description":""},"isActive":true,"sections":[{"id":"coupon","type":"coupon","variant":"v1","props":{"title":"Coupons","subtitle":"Use these codes when you order.","coupons":[{"code":"WELCOME10","discount":"10% off","title":"Welcome offer","description":"On your first order.","expiryDate":"31 Dec 2026"},{"code":"FREESHIP","discount":"Free delivery","title":"Free delivery","description":"On orders over 1000.","expiryDate":"31 Dec 2026"}],"emptyText":"No coupons right now. Check back soon."},"styles":{},"isActive":true,"order":0}]},"track-order":{"seo":{"title":"Track your order","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Track your order","content":"<p>Sign in to follow your orders, or enter your order number and phone number below. You can also contact us with your order number.</p>"},"styles":{},"isActive":true,"order":0}]},"blog":{"seo":{"title":"Blog","description":""},"isActive":true,"sections":[{"id":"blog","type":"blog","variant":"v1","props":{"title":"From the blog","viewAllLink":"/blog","showViewAll":false,"posts":[]},"styles":{},"isActive":true,"order":0}]},"privacy-policy":{"seo":{"title":"Privacy policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Privacy Policy ","content":"<p>Welcome to our store (“we”, “our”, “us”). Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our website, mobile app, or services (collectively, the “Platform”).</p><p>By using our Platform, you agree to the collection and use of information in accordance with this policy.</p><h2>1. Information We Collect</h2><h3>a. Personal Information</h3><p>When you use our Platform, we may collect:</p><ul><li>Full name</li><li>Email address</li><li>Phone number</li><li>Shipping and billing address</li><li>Payment details (processed securely by third-party payment providers)</li><li>Account login credentials</li></ul><h3>b. Order &amp; Transaction Information</h3><ul><li>Products purchased</li><li>Order history</li><li>Payment status</li><li>Delivery and return details</li></ul><h3>c. Technical &amp; Usage Data</h3><ul><li>IP address</li><li>Browser type and version</li><li>Device information</li><li>Pages visited and time spent</li><li>Cookies and similar tracking technologies</li></ul><h2>2. How We Use Your Information</h2><p>We use your information to:</p><ul><li>Create and manage your account</li><li>Process orders and payments</li><li>Deliver products and services</li><li>Communicate order updates and support responses</li><li>Improve website performance and user experience</li><li>Send promotional messages (only if you opt in)</li><li>Prevent fraud and ensure platform security</li><li>Comply with legal obligations</li></ul><h2>3. Cookies &amp; Tracking Technologies</h2><p>We use cookies and similar technologies to:</p><ul><li>Remember your preferences</li><li>Keep you logged in</li><li>Analyze traffic and usage patterns</li><li>Improve our services</li></ul><p>You can control cookies through your browser settings. Disabling cookies may affect some features of the Platform.</p><h2>4. Sharing Your Information</h2><p>We <strong>do not sell</strong> your personal data.</p><p>We may share your information with:</p><ul><li>Payment gateways (e.g., Stripe, PayPal)</li><li>Delivery and logistics partners</li><li>Analytics and marketing tools</li><li>IT and hosting service providers</li><li>Legal or regulatory authorities (if required by law)</li></ul><p>All third parties are required to protect your data.</p><h2>5. Data Security</h2><p>We implement appropriate technical and organizational measures to protect your data, including:</p><ul><li>Secure servers</li><li>Encrypted communication (HTTPS/SSL)</li><li>Limited internal access</li></ul><p>However, no method of transmission over the internet is 100% secure.</p><h2>6. Data Retention</h2><p>We retain your personal information only as long as necessary to:</p><ul><li>Fulfill orders and services</li><li>Comply with legal, tax, and accounting requirements</li><li>Resolve disputes</li></ul><h2>7. Your Rights</h2><p>Depending on your location, you may have the right to:</p><ul><li>Access your personal data</li><li>Correct inaccurate information</li><li>Request deletion of your data</li><li>Withdraw consent for marketing communications</li></ul><p>To exercise these rights, contact us at <strong>[support@email.com</strong></p><p><strong>]</strong>.</p><h2>8. Children’s Privacy</h2><p>Our Platform is not intended for users under the age of 13. We do not knowingly collect personal information from children.</p><h2>9. Third-Party Links</h2><p>Our Platform may contain links to third-party websites. We are not responsible for their privacy practices.</p><h2>10. Changes to This Policy</h2><p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated “Last updated” date.</p><h2>11. Contact Us</h2><p>If you have any questions about this Privacy Policy, contact us:</p><p>📧 Email: <strong>[support@email.com]</strong></p><p>🏢 Address: <strong>[Company Address]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"shipping-policy":{"seo":{"title":"Shipping policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Shipping Policy","content":"<p>This Shipping Policy explains how orders are processed and delivered by <strong>[Your Store Name]</strong>.</p><h2>1. Order Processing Time</h2><ul><li>Orders are processed within <strong>[1–3] business days</strong></li><li>Orders placed on weekends or holidays are processed next business day</li></ul><h2>2. Shipping Methods &amp; Delivery Time</h2><p>Estimated delivery times:</p><ul><li><strong>Standard Shipping:</strong> [3–7] business days</li><li><strong>Express Shipping:</strong> [1–3] business days</li></ul><p>Delivery times may vary due to location, weather, or courier delays.</p><h2>3. Shipping Charges</h2><ul><li>Shipping fees are calculated at checkout</li><li>Free shipping may apply for orders above <strong>[amount]</strong></li></ul><h2>4. Delivery Areas</h2><p>We currently ship to:</p><ul><li><strong>[Domestic / International – specify regions]</strong></li></ul><h2>5. Order Tracking</h2><p>Once shipped, you will receive:</p><ul><li>A confirmation message/email</li><li>Tracking details (if available)</li></ul><h2>6. Delayed or Lost Shipments</h2><p>If your order is delayed or lost:</p><ul><li>Contact us at <strong>[support@email.com</strong></li><li><strong>]</strong></li><li>We will coordinate with the courier to resolve the issue</li></ul><h2>7. Incorrect Address</h2><p>Please ensure your shipping address is correct. We are not responsible for orders delivered to incorrect addresses provided by the customer.</p><h2>8. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"return-policy":{"seo":{"title":"Return policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Return & Refund Policy","content":"<p>At <strong>[Your Store Name]</strong>, we want you to be satisfied with your purchase. This Return &amp; Refund Policy explains when and how you can return items bought from our Platform.</p><h2>1. Eligibility for Returns</h2><p>You may request a return if:</p><ul><li>The product is damaged, defective, or incorrect</li><li>The product is unused and in original condition</li><li>The return request is made within <strong>[7/14/30] days</strong> of delivery</li></ul><p>Items must be returned with:</p><ul><li>Original packaging</li><li>Tags, labels, and accessories (if any)</li><li>Proof of purchase</li></ul><h2>2. Non-Returnable Items</h2><p>The following items are <strong>not eligible</strong> for return or refund:</p><ul><li>Perishable goods</li><li>Personal care or hygiene products</li><li>Digital products or downloadable items</li><li>Customized or made-to-order products</li><li>Items marked as “Final Sale”</li></ul><h2>3. Return Process</h2><p>To initiate a return:</p><ol><li>Contact us at <strong>[support@email.com</strong></li><li><strong>]</strong> with your order ID</li><li>Our team will review and approve the request</li><li>Ship the product to the provided return address</li></ol><p>Return shipping costs:</p><ul><li>Covered by us if the item is defective or incorrect</li><li>Covered by the customer for all other reasons</li></ul><h2>4. Refunds</h2><ul><li>Approved refunds will be processed within <strong>[5–10] business days</strong></li><li>Refunds will be issued to the original payment method</li><li>Shipping charges are non-refundable unless the return is due to our error</li></ul><h2>5. Exchanges</h2><p>We replace items only if they are defective, damaged, or incorrect. Exchange requests are subject to product availability.</p><h2>6. Contact</h2><p>For return-related questions:</p><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p><h1>Terms &amp; Conditions (Terms of Service)</h1><p><strong>Last updated:</strong> [Insert Date]</p><p>Welcome to <strong>[Your Store Name]</strong>. By accessing or using our website, mobile app, or services, you agree to these Terms &amp; Conditions.</p><h2>1. Use of the Platform</h2><p>You agree to:</p><ul><li>Provide accurate and current information</li><li>Use the Platform for lawful purposes only</li><li>Not misuse, copy, or exploit our content or services</li></ul><p>We reserve the right to suspend or terminate accounts violating these terms.</p><h2>2. Account Responsibility</h2><p>You are responsible for:</p><ul><li>Maintaining the confidentiality of your account credentials</li><li>All activities that occur under your account</li></ul><h2>3. Product Information &amp; Pricing</h2><ul><li>We strive to display accurate product descriptions and prices</li><li>Errors may occur; we reserve the right to correct them</li><li>Prices and availability are subject to change without notice</li></ul><h2>4. Orders &amp; Payments</h2><ul><li>Orders are confirmed only after successful payment</li><li>We reserve the right to cancel or refuse any order</li><li>Payments are securely processed through third-party providers</li></ul><h2>5. Intellectual Property</h2><p>All content on the Platform (logos, text, images, software) is the property of <strong>[Your Store Name]</strong> and protected by applicable laws.</p><h2>6. Limitation of Liability</h2><p>We are not liable for:</p><ul><li>Indirect or consequential damages</li><li>Delays caused by third-party services</li><li>Losses due to misuse of the Platform</li></ul><h2>7. Termination</h2><p>We may terminate or suspend access to the Platform at any time without notice for violations of these Terms.</p><h2>8. Governing Law</h2><p>These Terms are governed by the laws of <strong>[Country/State]</strong>.</p><h2>9. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p>"},"styles":{},"isActive":true,"order":0}]},"terms-of-service":{"seo":{"title":"Terms of service","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Terms & Conditions (Terms of Service)","content":"<p>Welcome to <strong>[Your Store Name]</strong>. By accessing or using our website, mobile app, or services, you agree to these Terms &amp; Conditions.</p><h2>1. Use of the Platform</h2><p>You agree to:</p><ul><li>Provide accurate and current information</li><li>Use the Platform for lawful purposes only</li><li>Not misuse, copy, or exploit our content or services</li></ul><p>We reserve the right to suspend or terminate accounts violating these terms.</p><h2>2. Account Responsibility</h2><p>You are responsible for:</p><ul><li>Maintaining the confidentiality of your account credentials</li><li>All activities that occur under your account</li></ul><h2>3. Product Information &amp; Pricing</h2><ul><li>We strive to display accurate product descriptions and prices</li><li>Errors may occur; we reserve the right to correct them</li><li>Prices and availability are subject to change without notice</li></ul><h2>4. Orders &amp; Payments</h2><ul><li>Orders are confirmed only after successful payment</li><li>We reserve the right to cancel or refuse any order</li><li>Payments are securely processed through third-party providers</li></ul><h2>5. Intellectual Property</h2><p>All content on the Platform (logos, text, images, software) is the property of <strong>[Your Store Name]</strong> and protected by applicable laws.</p><h2>6. Limitation of Liability</h2><p>We are not liable for:</p><ul><li>Indirect or consequential damages</li><li>Delays caused by third-party services</li><li>Losses due to misuse of the Platform</li></ul><h2>7. Termination</h2><p>We may terminate or suspend access to the Platform at any time without notice for violations of these Terms.</p><h2>8. Governing Law</h2><p>These Terms are governed by the laws of <strong>[Country/State]</strong>.</p><h2>9. Contact</h2><p>📧 <strong>[support@email.com</strong></p><p><strong>]</strong></p><h1>Shipping Policy</h1><p><strong>Last updated:</strong> [Insert Date]</p><p>This Shipping Policy explain</p>"},"styles":{},"isActive":true,"order":0}]}}`), xL = {
  seo: kL,
  config: wL,
  pages: SL
}, TL = { title: "Shegun — solid wood furniture", description: "Solid segun and mehogoni furniture for every room, delivered and assembled, with 0% EMI and a five-year warranty.", keywords: ["furniture", "segun furniture", "bed", "sofa", "dining table", "wardrobe"], ogImage: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d29vZGVuJTIwZnVybml0dXJlJTIwbGl2aW5nJTIwcm9vbXxlbnwxfDF8fHwxNzkzMTc4NDYyfDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80", index_allow: !0 }, CL = { themeId: "furniture-1", appearance: { colorMode: "light", product_image_aspect_ratio: "aspect-[3/4]" }, header: { variant: "v2", sticky: !0, topbar: { active: !1 }, actions: { showSearch: !0, showCart: !0, showAccount: !0, showWishlist: !0, cartAction: "sidebar" }, searchPlaceholder: "Search beds, sofas, dining…", searchConfig: { showPrice: !0, showCategory: !0, showImage: !0, maxResults: 6 }, menu: [{ label: "Shop", href: "/shop", type: "categories" }, { label: "New in", href: "/shop?order_by=newest_first", type: "link", badge: "New" }, { label: "Sale", href: "/shop?order_by=discount_desc", type: "link" }, { label: "Journal", href: "/blog", type: "link" }, { label: "Contact", href: "/contact", type: "link" }] }, footer: { variant: "v1", title: "Shegun", description: "Solid segun and mehogoni furniture, finished by hand in Dhaka and delivered assembled.", columns: [{ title: "Shop", links: [{ label: "All products", href: "/shop" }, { label: "New in", href: "/shop?order_by=newest_first" }, { label: "Categories", href: "/categories" }, { label: "Offers", href: "/coupon" }] }, { title: "Help", links: [{ label: "Track order", href: "/track-order" }, { label: "Shipping policy", href: "/shipping-policy" }, { label: "Return policy", href: "/return-policy" }, { label: "Contact us", href: "/contact" }] }, { title: "About", links: [{ label: "Journal", href: "/blog" }, { label: "Privacy policy", href: "/privacy-policy" }, { label: "Terms of service", href: "/terms-of-service" }] }], socialLinks: [], copyright: "© Shegun. All rights reserved.", paymentMethods: [{ platform: "bkash" }, { platform: "nagad" }] }, floatingButtons: { active: !0, callUsTitle: "Call us", whatsappTitle: "WhatsApp", messengerTitle: "Messenger" }, mobileBottomNav: { active: !0, items: [{ label: "Home", icon: "home", actionType: "link", href: "/", isPrimary: !1 }, { label: "Shop", icon: "shop", actionType: "categories", href: "/shop", isPrimary: !1 }, { label: "Search", icon: "search", actionType: "search", href: "", isPrimary: !1 }, { label: "Wishlist", icon: "heart", actionType: "link", href: "/wishlist", isPrimary: !1 }, { label: "Cart", icon: "cart", actionType: "link", href: "/cart", isPrimary: !1 }] } }, PL = /* @__PURE__ */ JSON.parse('{"home":{"isActive":true,"sections":[{"id":"announcement-bar","type":"announcement-bar","variant":"v1","props":{"items":[{"text":"Free delivery inside Dhaka on orders over ৳50,000"},{"text":"0% EMI for up to 12 months"},{"text":"Five-year warranty on every frame","code":"FIRST10"},{"text":"Cash on delivery everywhere we deliver"}]},"styles":{},"isActive":true,"order":0},{"id":"hero","type":"hero","variant":"v1","props":{"slides":[{"title":"Furniture that feels like home","subtitle":"Solid segun and mehogoni, finished by hand and delivered assembled.","image":"https://images.unsplash.com/photo-1633505899118-4ca6bd143043?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d2FybSUyMGxpdmluZyUyMHJvb20lMjB3b29kZW4lMjBmdXJuaXR1cmV8ZW58MXwwfHx8MTc5MzE3ODQ2M3ww&ixlib=rb-4.1.0&w=1600&h=900&fit=crop&crop=entropy&auto=format&q=80","ctaText":"Shop dining sets","ctaLink":"/shop?order_by=newest_first","badge":"New collection","room":"Living room"},{"title":"The bedroom, rested","subtitle":"Beds, wardrobes and dressing tables in seasoned hardwood.","image":"https://images.unsplash.com/photo-1547062200-f195b1c77e30?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d29vZGVuJTIwZGluaW5nJTIwcm9vbSUyMHRhYmxlfGVufDF8MHx8fDE3OTMxNzg0NjR8MA&ixlib=rb-4.1.0&w=1600&h=900&fit=crop&crop=entropy&auto=format&q=80","ctaText":"Shop essentials","ctaLink":"/shop","badge":"Bedroom","room":"Bedroom"},{"title":"Gather round","subtitle":"Dining sets for six, eight and the whole family on Eid.","image":"https://images.unsplash.com/photo-1718894071528-1108a094cc78?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8Y296eSUyMGJlZHJvb20lMjB3b29kZW4lMjBiZWR8ZW58MXwwfHx8MTc5MzE3ODQ2NHww&ixlib=rb-4.1.0&w=1600&h=900&fit=crop&crop=entropy&auto=format&q=80","ctaText":"Shop accessories","ctaLink":"/categories","badge":"Dining","room":"Dining"}],"autoplay":true,"autoplayDelay":6000},"styles":{},"isActive":true,"order":10},{"id":"categories","type":"categories","variant":"v1","props":{"title":"Shop by room","subtitle":"Bedroom, living, dining and the rest of the home","columns":4},"styles":{},"isActive":true,"order":20},{"id":"materials","type":"story","variant":"v2","props":{"eyebrow":"Choose your wood","title":"Which wood is right for your home?","subtitle":"Every piece lists its wood. Here is how they compare.","points":[{"icon":"shield","title":{"en":"Segun","bn":"সেগুন"},"body":"Teak: oily, termite resistant and the longest lasting.","swatch":"#8a5a34","note":"Hardness: Very high · Lifespan: 50+ years · Price: ৳৳৳","link":"/shop?search=segun"},{"icon":"shield","title":{"en":"Mehogoni","bn":"মেহগনি"},"body":"Mahogany: deep red grain that polishes beautifully.","swatch":"#6e2f22","note":"Hardness: High · Lifespan: 30+ years · Price: ৳৳","link":"/shop?search=mehogoni"},{"icon":"shield","title":{"en":"Gamari","bn":"গামারি"},"body":"Light, even grain and easy on the budget.","swatch":"#c9a271","note":"Hardness: Medium · Lifespan: 15+ years · Price: ৳","link":"/shop?search=gamari"},{"icon":"shield","title":{"en":"Board","bn":"বোর্ড"},"body":"Engineered board with a laminate finish, for modern pieces.","swatch":"#d8cfc2","note":"Hardness: Medium · Lifespan: 8+ years · Price: ৳","link":"/shop?search=board"}],"ctaLabel":"","ctaLink":""},"styles":{},"isActive":true,"order":30},{"id":"new-arrivals","type":"new-arrivals","variant":"v1","props":{"title":"New arrivals","subtitle":"Fresh from our workshop","slidesPerView":4},"styles":{},"isActive":true,"order":40},{"id":"lookbook-city-edit","type":"lookbook-banner","variant":"v1","props":{"image":"https://images.unsplash.com/photo-1691036561573-4b76998b60de?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8ZHJhd2luZyUyMHJvb20lMjBzb2ZhJTIwaW50ZXJpb3J8ZW58MXwxfHx8MTc5MzE3ODQ2NXww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","title":"The drawing room edit","subtitle":"Sofas, centre tables and showcases, styled in a real Dhaka flat.","ctaText":"View the lookbook","ctaLink":"/shop","imagePosition":"left","gallery":[{"image":"https://images.unsplash.com/photo-1619911013257-8f1fbc919fc9?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8Y29mZmVlJTIwdGFibGUlMjBsaXZpbmclMjByb29tfGVufDF8MXx8fDE3OTMxNzg0NjV8MA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A segun bed with white linen","link":"/shop"},{"image":"https://images.unsplash.com/photo-1792504288100-176ac499f177?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d29vZGVuJTIwZGlzcGxheSUyMGNhYmluZXR8ZW58MXwxfHx8MTc5MzE3ODQ2Nnww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A six-seat dining table by a window","link":"/shop"}]},"styles":{},"isActive":true,"order":50},{"id":"flash-sale","type":"flash-sale","variant":"v1","props":{"title":"Seasonal sale"},"styles":{},"isActive":true,"order":60},{"id":"product-grid","type":"product-grid","variant":"v1","props":{"title":"Best sellers","subtitle":"Most loved in Bangladeshi homes","viewAllLink":"/shop"},"styles":{},"isActive":true,"order":70},{"id":"testimonials","type":"testimonials","variant":"v1","props":{"title":"What our customers say","items":[{"name":"Nadia R.","designation":"Verified buyer","review":"The segun bed is solid and heavy, and the team carried it up five floors and assembled it in an hour.","rating":5},{"name":"Tanvir H.","designation":"Verified buyer","review":"Paid in 12 months EMI with no interest. The dining table seats eight and still looks new after a year.","rating":5},{"name":"Sadia K.","designation":"Verified buyer","review":"Good finish for the price. The measurements on the page helped me check it fits my small flat.","rating":4}]},"styles":{},"isActive":true,"order":80},{"id":"lookbook-monochrome","type":"lookbook-banner","variant":"v2","props":{"image":"https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8dGVhayUyMHdvb2QlMjBmdXJuaXR1cmV8ZW58MXwxfHx8MTc5MzE3ODQ2Nnww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","title":"Solid segun","subtitle":"Our teak collection","ctaText":"Shop the collection","ctaLink":"/shop","overlayOpacity":45,"gallery":[{"image":"https://images.unsplash.com/photo-1517862774645-dd398fbfaffa?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d29vZGVuJTIwYmVkJTIwYmVkcm9vbXxlbnwxfDF8fHwxNzkzMTc5MDEyfDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A segun bed with white linen","link":"/shop"},{"image":"https://images.unsplash.com/photo-1565307586367-2c27d915cc8e?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d29vZGVuJTIwY2hhaXIlMjBkZXRhaWx8ZW58MXwxfHx8MTc5MzE3ODQ2N3ww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A six-seat dining table by a window","link":"/shop"},{"image":"https://images.unsplash.com/photo-1571062618385-7cf10f16a2f4?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8d29vZCUyMGdyYWluJTIwZnVybml0dXJlJTIwZGV0YWlsfGVufDF8MXx8fDE3OTMxNzg0Njh8MA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","alt":"A teak sofa with sage cushions","link":"/shop"}]},"styles":{},"isActive":true,"order":90},{"id":"blog","type":"blog","variant":"v1","props":{"title":"Journal","posts":[],"viewAllLink":"/blog","showViewAll":true},"styles":{},"isActive":true,"order":100},{"id":"brands","type":"brands","variant":"v1","props":{"title":"Brands we carry","layout":"ticker"},"styles":{},"isActive":true,"order":110},{"id":"instagram-feed","type":"instagram-feed","variant":"v1","props":{"title":"In your homes","items":[{"image":"https://images.unsplash.com/photo-1618220179428-22790b461013?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8aG9tZSUyMGludGVyaW9yJTIwbGl2aW5nJTIwcm9vbSUyMHBsYW50c3xlbnwxfDF8fHwxNzkzMTc4NDY4fDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1552558636-f6a8f071c2b3?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8YmVkcm9vbSUyMGludGVyaW9yJTIwbmF0dXJhbCUyMGxpZ2h0fGVufDF8MXx8fDE3OTMxNzg0Njl8MA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1666585958637-698ef8559cfc?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8ZGluaW5nJTIwcm9vbSUyMGludGVyaW9yJTIwaG9tZXxlbnwxfDF8fHwxNzkzMTc4NDcwfDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1619992677751-cb736bd47e2e?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8cmVhZGluZyUyMGNvcm5lciUyMGFybWNoYWlyfGVufDF8MXx8fDE3OTMxNzg0NzB8MA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1611269154421-4e27233ac5c7?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8aG9tZSUyMG9mZmljZSUyMHdvb2RlbiUyMGRlc2t8ZW58MXwxfHx8MTc5MzE3ODQ3MXww&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"},{"image":"https://images.unsplash.com/photo-1687946803051-51da173a9f55?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8a2lkcyUyMHJvb20lMjBpbnRlcmlvcnxlbnwxfDF8fHwxNzkzMTc4NDcxfDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","link":"/shop"}]},"styles":{},"isActive":true,"order":120},{"id":"cta","type":"cta","variant":"v1","props":{"title":"Hear about new collections first","subtitle":"New arrivals, restocks and members-only offers. No spam, unsubscribe any time.","placeholder":"Your email address","buttonText":"Sign up"},"styles":{},"isActive":true,"order":130}]},"shop":{"isActive":true,"sections":[{"id":"shop-grid","type":"shop-grid","variant":"v1","props":{"title":"Shop all","description":"Beds, sofas, dining sets, wardrobes and office furniture in solid wood.","itemsPerPage":12,"allCategoriesLabel":"All","noProductsTitle":"Nothing here yet","noProductsMessage":"Try changing or clearing the filters."},"styles":{},"isActive":true,"order":0}]},"product":{"isActive":true,"sections":[{"id":"product-detail","type":"product-detail","variant":"v1","props":{"quantityLabel":"Quantity","addToCartText":"Add to cart","orderNowText":"Buy now","productDescTitle":"Description","returnPolicyTitle":"Delivery & returns","completeTheLookTitle":"Complete the room","showDeliveryAreas":true,"dimensionsTitle":"Dimensions & materials","warranty":"5 years on frame and joints","emiMinPrice":10000,"emiMonths":12,"assemblyNote":"<p>Delivered by our own team and assembled at your home. Inside Dhaka in 3–5 days, outside Dhaka in 5–10 days.</p>","quoteLabel":"Customize / request a quote"},"styles":{},"isActive":true,"order":0},{"id":"similar-products","type":"similar-products","variant":"v1","props":{"title":"You may also like"},"styles":{},"isActive":true,"order":10}]},"cart":{"isActive":true,"sections":[{"id":"cart","type":"cart","variant":"v1","props":{"pageTitle":"Cart","emptyTitle":"Your cart is empty","emptyMessage":"Find something you like and add it to your cart.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop","summaryTitle":"Summary","subtotalLabel":"Subtotal","shippingLabel":"Delivery","shippingCalculatedText":"Delivery is calculated at checkout.","totalLabel":"Total","checkoutButtonText":"Checkout","checkoutLink":"/checkout"},"styles":{},"isActive":true,"order":0}]},"checkout":{"isActive":true,"sections":[{"id":"checkout","type":"checkout","variant":"v1","props":{"pageTitle":"Checkout","emptyTitle":"Your cart is empty","emptyMessage":"Add something to your cart before you check out.","continueShoppingText":"Shop now","continueShoppingLink":"/shop","summaryTitle":"Your order","subtotalLabel":"Subtotal","shippingChargeLabel":"Delivery area","totalLabel":"Total","placeOrderText":"Place order","placingOrderText":"Placing order…"},"styles":{},"isActive":true,"order":0}]},"order-success":{"isActive":true,"sections":[{"id":"order-success","type":"order-success","variant":"v1","props":{"title":"Thank you","message":"Your order is in. We will call to confirm it before it ships.","errorTitle":"Your order was placed","errorMessage":"We could not load the order details on this device, but your order was received.","viewOrderText":"View order","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"categories":{"isActive":true,"sections":[{"id":"categories","type":"categories","variant":"v1","props":{"title":"Categories","subtitle":"Everything, sorted","columns":4,"emptyText":"No categories yet."},"styles":{},"isActive":true,"order":0}]},"wishlist":{"isActive":true,"sections":[{"id":"wishlist","type":"wishlist","variant":"v1","props":{"title":"Wishlist","subtitle":"Saved for later","emptyTitle":"Nothing saved yet","emptyText":"Tap the heart on any product to keep it here.","continueShoppingText":"Start shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"compare":{"isActive":true,"sections":[{"id":"compare","type":"compare","variant":"v1","props":{},"styles":{},"isActive":true,"order":0}]},"coupon":{"isActive":true,"sections":[{"id":"coupon","type":"coupon","variant":"v1","props":{"title":"Offers","coupons":[{"code":"FIRST10","title":"Five percent off","description":"On your first order.","discount":"10% off"},{"code":"FRIDAY","title":"EMI offer","description":"On new arrivals, every Friday.","discount":"15% off"}]},"styles":{},"isActive":true,"order":0}]},"track-order":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Track your order","content":"<p>Enter your order number and phone to see where your order is. Signed in? Your orders are under <a href=\\"/account/orders\\">My orders</a>.</p>"},"styles":{},"isActive":true,"order":0}]},"signin":{"isActive":true,"sections":[{"id":"signin","type":"signin","variant":"v1","props":{"title":"Sign in","intro":"Sign in or create an account with your mobile number.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"signup":{"isActive":true,"sections":[{"id":"signup","type":"signup","variant":"v2","props":{"title":"Create account","intro":"Create your account with your mobile number.","redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"account":{"isActive":true,"sections":[{"id":"account","type":"account","variant":"v1","props":{"tabOverviewLabel":"Overview","tabOrdersLabel":"Orders","tabAddressesLabel":"Addresses","tabDetailsLabel":"Profile","signOutLabel":"Sign out"},"styles":{},"isActive":true,"order":0}]},"contact":{"isActive":true,"sections":[{"id":"contact","type":"contact","variant":"v1","props":{"title":"Contact","description":"Questions about an order, a size or a return? Message or call us and we will get back to you within a day."},"styles":{},"isActive":true,"order":0}]},"blog":{"isActive":true,"sections":[{"id":"blog","type":"blog","variant":"v1","props":{"title":"Journal","posts":[],"showViewAll":false},"styles":{},"isActive":true,"order":0}]},"privacy-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Privacy policy","content":"<p>This policy explains what we collect when you shop with us and how we use it.</p><h2>What we collect</h2><p>Your name, phone number, delivery address and order history, so we can deliver your orders and help you with them.</p><h2>How we use it</h2><p>To process and deliver orders, to contact you about them and, if you agree, to tell you about new arrivals. We never sell your details.</p><h2>Your choices</h2><p>You can ask us to update or delete your details at any time through the contact page.</p>"},"styles":{},"isActive":true,"order":0}]},"shipping-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Shipping policy","content":"<p>We deliver to every area listed at checkout. The delivery charge for your area is shown before you place the order.</p><h2>Delivery times</h2><p>Orders inside the city usually arrive in 1–2 days and elsewhere in 3–5 days.</p><h2>Payment</h2><p>Pay in cash when your order arrives. Please check the parcel before you pay.</p>"},"styles":{},"isActive":true,"order":0}]},"terms-of-service":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Terms of service","content":"<p>By placing an order you agree to these terms.</p><h2>Orders</h2><p>An order is confirmed once we call or message you to confirm it. We may cancel an order if an item is out of stock.</p><h2>Prices</h2><p>Prices are shown in the store currency and include all taxes. Delivery is charged separately and shown at checkout.</p><h2>Changes</h2><p>We may update these terms. The version on this page applies to new orders.</p>"},"styles":{},"isActive":true,"order":0}]},"return-policy":{"isActive":true,"sections":[{"id":"content","type":"content","variant":"v2","props":{"title":"Return policy","content":"<p>Wrong size or changed your mind? You can return or exchange unworn items within 7 days of delivery.</p><h2>How to return</h2><p>Contact us with your order number. Items must be unworn, unwashed and have their tags.</p><h2>Refunds</h2><p>Once we receive and check the item, we refund the amount or send the replacement within 5 working days.</p>"},"styles":{},"isActive":true,"order":0}]}}'), AL = {
  seo: TL,
  config: CL,
  pages: PL
}, LL = { title: "Lumen & Volt — lighting and gadgets", description: "Smart lighting, LED strips, neon signs and gadgets that glow. Delivered nationwide, cash on delivery.", keywords: ["lighting", "smart lights", "LED strips", "neon signs", "gadgets"], ogImage: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8bmVvbiUyMGxpZ2h0JTIwcm9vbSUyMGludGVyaW9yfGVufDF8MXx8fDE3OTMxNTYyOTh8MA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80", index_allow: !0 }, ML = { themeId: "lightings-1", header: { variant: "v1", logo: { alt: "Lumen & Volt" }, sticky: !0, topbar: { active: !0, variant: "v1", messages: [{ text: "Free delivery on orders over ৳3,000", link: "/shipping-policy" }, { text: "Cash on delivery across the country" }, { text: "New: smart lights that follow your schedule", link: "/shop" }], dismissible: !0 }, actions: { showSearch: !0, showCart: !0, showAccount: !0, cartAction: "sidebar" }, searchConfig: { showPrice: !0, showCategory: !0, showImage: !0, maxResults: 6 }, searchPlaceholder: "Search lamps, strips, gadgets…", menu: [{ label: "Shop", href: "/shop", type: "categories" }, { label: "Deals", href: "/shop?order_by=discount_desc", type: "link", badge: "Hot" }, { label: "Guides", href: "/blog", type: "dropdown", children: [{ label: "Blog", href: "/blog" }, { label: "Compare products", href: "/compare" }, { label: "Coupons", href: "/coupon" }] }, { label: "Track order", href: "/track-order", type: "link" }, { label: "Contact", href: "/contact", type: "link" }] }, footer: { variant: "v1", title: "Lumen & Volt", description: "Lighting and gadgets that make a room glow. Delivered nationwide, cash on delivery.", copyright: "© 2026 Lumen & Volt. All rights reserved.", columns: [{ title: "Shop", links: [{ label: "All products", href: "/shop" }, { label: "Categories", href: "/categories" }, { label: "Deals", href: "/shop?order_by=discount_desc" }, { label: "Coupons", href: "/coupon" }] }, { title: "Help", links: [{ label: "Track order", href: "/track-order" }, { label: "Contact us", href: "/contact" }, { label: "Shipping policy", href: "/shipping-policy" }, { label: "Return policy", href: "/return-policy" }] }, { title: "Company", links: [{ label: "Blog", href: "/blog" }, { label: "Privacy policy", href: "/privacy-policy" }, { label: "Terms of service", href: "/terms-of-service" }] }], socialLinks: [{ platform: "facebook", href: "https://facebook.com" }, { platform: "instagram", href: "https://instagram.com" }, { platform: "youtube", href: "https://youtube.com" }], contactAddress: "House 1, Road 1, Dhaka", contactPhone: "+880 1700-000000", contactEmail: "hello@lumenvolt.example", paymentMethods: [{ platform: "bkash" }, { platform: "nagad" }, { platform: "visa" }, { platform: "mastercard" }] }, floatingButtons: { active: !0, phone: "+8801700000000", whatsapp: "+8801700000000", callUsTitle: "Call us", whatsappTitle: "WhatsApp" }, mobileBottomNav: { active: !0, items: [{ label: "Home", icon: "home", actionType: "link", href: "/", isPrimary: !1 }, { label: "Categories", icon: "categories", actionType: "categories", href: "", isPrimary: !1 }, { label: "Search", icon: "search", actionType: "search", href: "", isPrimary: !0 }, { label: "Wishlist", icon: "heart", actionType: "link", href: "/wishlist", isPrimary: !1 }, { label: "Account", icon: "account", actionType: "link", href: "/account", isPrimary: !1 }] } }, NL = /* @__PURE__ */ JSON.parse('{"home":{"seo":{"title":"Lumen & Volt — lighting and gadgets","description":"Smart lighting, LED strips, neon signs and gadgets that glow. Cash on delivery."},"isActive":true,"sections":[{"id":"hero","type":"hero","variant":"v4","props":{"slides":[{"badge":"New season","title":"Light that sets the scene","subtitle":"Smart lamps, LED strips and neon signs that turn any room into a showroom.","image":"https://images.unsplash.com/photo-1666585607888-3f6fe0b323d8?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8bGl2aW5nJTIwcm9vbSUyMGFtYmllbnQlMjBsZWQlMjBsaWdodGluZ3xlbnwxfDB8fHwxNzkzMTU2Mjk4fDA&ixlib=rb-4.1.0&w=1600&h=900&fit=crop&crop=entropy&auto=format&q=80","ctaText":"Shop lighting","ctaLink":"/shop","glow":"#ffb547"},{"badge":"Smart home","title":"Dim, tint and schedule from your phone","subtitle":"App and remote controlled lights with millions of colours and warm-to-cool white.","image":"https://images.unsplash.com/photo-1711006155490-ec01a0ecf0de?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8cmdiJTIwc21hcnQlMjBsaWdodCUyMGJ1bGIlMjBjb2xvcnxlbnwxfDB8fHwxNzkzMTU2Mjk5fDA&ixlib=rb-4.1.0&w=1600&h=900&fit=crop&crop=entropy&auto=format&q=80","ctaText":"See smart lights","ctaLink":"/shop?search=smart","glow":"#38d9f5"},{"badge":"Up to 30% off","title":"Gadgets that glow after dark","subtitle":"Desk lamps, night lights and speakers with built-in light — this week only.","image":"https://images.unsplash.com/photo-1510851896000-498520af2236?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8ZGVzayUyMGxhbXAlMjBuaWdodCUyMGRhcmt8ZW58MXwwfHx8MTc5MzE1NjI5OXww&ixlib=rb-4.1.0&w=1600&h=900&fit=crop&crop=entropy&auto=format&q=80","ctaText":"Shop the deals","ctaLink":"/shop?order_by=discount_desc","glow":"#ff4fa3"}],"autoplay":true,"autoplayDelay":6000,"buttons.cta":{"label":"Shop now"}},"styles":{},"isActive":true,"order":0},{"id":"announcement-bar","type":"announcement-bar","variant":"v1","props":{"items":[{"text":"10% off your first order","code":"GLOW10"},{"text":"Free delivery on orders over ৳3,000"},{"text":"Cash on delivery across the country"}]},"styles":{},"isActive":true,"order":1},{"id":"category","type":"category","variant":"v1","props":{"cardVariant":"v1","title":"Shop by light","subtitle":"Find your glow","autoplay":false,"autoplayDelay":4000},"styles":{},"isActive":true,"order":2},{"id":"flash-sale","type":"flash-sale","variant":"v1","props":{"title":"Flash sale — lights out soon","endDate":"2027-06-30T23:59:59"},"styles":{},"isActive":true,"order":3},{"id":"product-slider","type":"product-slider","variant":"v2","props":{"title":"New arrivals","subtitle":"Just switched on","buttons.addToCart":{"label":"Add to cart"}},"styles":{},"isActive":true,"order":4},{"id":"lookbook-banner","type":"lookbook-banner","variant":"v2","props":{"image":"https://images.unsplash.com/photo-1632466400445-a74bad6bda17?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8bmVvbiUyMHNpZ24lMjBkYXJrJTIwcm9vbXxlbnwxfDF8fHwxNzkzMTU2MzAwfDA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","title":"After dark collection","subtitle":"Ambient lamps and neon pieces made for evenings in.","ctaText":"Explore the collection","ctaLink":"/shop","overlayOpacity":55},"styles":{},"isActive":true,"order":5},{"id":"product-grid","type":"product-grid","variant":"v4","props":{"title":"Top gadgets this week","subtitle":"Most discounted","viewAllLink":"/shop?order_by=discount_desc","orderBy":"discount_desc","limit":5,"buttons.addToCart":{"label":"Add to cart"}},"styles":{},"isActive":true,"order":6},{"id":"features","type":"features","variant":"v1","props":{"title":"Why shop with us","items":[{"icon":"truck","title":"Nationwide delivery","subtitle":"Two to five days to your door"},{"icon":"shield","title":"Cash on delivery","subtitle":"Pay when your order arrives"},{"icon":"refresh-cw","title":"Easy returns","subtitle":"Seven days to change your mind"},{"icon":"headphones","title":"Real support","subtitle":"Talk to us seven days a week"}]},"styles":{},"isActive":true,"order":7},{"id":"lookbook-banner-2","type":"lookbook-banner","variant":"v1","props":{"image":"https://images.unsplash.com/photo-1659958661414-59d7bd483853?ixid=M3wxMTE1NTU5fDB8MXxzZWFyY2h8MXx8ZGVzayUyMHNldHVwJTIwbGVkJTIwYmFja2xpZ2h0fGVufDF8MXx8fDE3OTMxNTYzMDB8MA&ixlib=rb-4.1.0&w=800&h=1000&fit=crop&crop=entropy&auto=format&q=80","title":"Build a desk that glows","subtitle":"A warm lamp, a light bar and a soft backlight: the setup our team swears by.","ctaText":"Shop desk lighting","ctaLink":"/shop","imagePosition":"right"},"styles":{},"isActive":true,"order":8},{"id":"testimonials","type":"testimonials","variant":"v1","props":{"title":"Seen in their living rooms","items":[{"name":"Tanvir H.","designation":"Smart bulb set","review":"Set up in five minutes and the app schedules are spot on. The warm white is genuinely warm.","rating":5},{"name":"Nusrat J.","designation":"Neon wall sign","review":"Even brighter than the photos. Packed carefully and arrived two days after I ordered.","rating":5},{"name":"Rafiq A.","designation":"LED strip kit","review":"Good adhesive, clear instructions and the remote works from across the room.","rating":4}]},"styles":{},"isActive":true,"order":9},{"id":"brands","type":"brands","variant":"v1","props":{"title":"Brands we stock","layout":"ticker","items":[]},"styles":{},"isActive":true,"order":10},{"id":"blog","type":"blog","variant":"v1","props":{"title":"From the light lab","posts":[],"viewAllLink":"/blog","showViewAll":true},"styles":{},"isActive":true,"order":11},{"id":"cta","type":"cta","variant":"v1","props":{"title":"Get first light on new drops","subtitle":"New arrivals and flash sales, once a week. No spam.","placeholder":"Your email address","buttonText":"Subscribe"},"styles":{},"isActive":true,"order":12}]},"shop":{"seo":{"title":"Shop","description":""},"isActive":true,"sections":[{"id":"shop-grid","type":"shop-grid","variant":"v1","props":{"title":"All products","description":"Lamps, strips, signs and gadgets — filter by category, brand or price.","itemsPerPage":12,"productCardVariant":"v1","allCategoriesLabel":"All","buttons.addToCart":{"label":"Add to cart"}},"styles":{},"isActive":true,"order":0}]},"product":{"seo":{"title":"Product","description":""},"isActive":true,"sections":[{"id":"product-detail","type":"product-detail","variant":"v1","props":{"quantityLabel":"Quantity","productDescTitle":"Details","returnPolicyTitle":"Delivery and returns","buttons.addToCart":{"label":"Add to cart"},"buttons.orderNow":{"label":"Buy now"}},"styles":{},"isActive":true,"order":0},{"id":"similar-products","type":"similar-products","variant":"v1","props":{"title":"You may also like","limit":8},"styles":{},"isActive":true,"order":1},{"id":"recent-products","type":"recent-products","variant":"v1","props":{"title":"Recently viewed"},"styles":{},"isActive":true,"order":2}]},"cart":{"seo":{"title":"Cart","description":""},"isActive":true,"sections":[{"id":"cart","type":"cart","variant":"v1","props":{"pageTitle":"Your cart","emptyTitle":"Your cart is empty.","emptyMessage":"Add something that glows.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop","summaryTitle":"Summary","subtotalLabel":"Subtotal","shippingLabel":"Delivery area","totalLabel":"Total","checkoutButtonText":"Checkout","checkoutLink":"/checkout","secureCheckoutText":"Cash on delivery · confirmed by phone"},"styles":{},"isActive":true,"order":0}]},"checkout":{"seo":{"title":"Checkout","description":""},"isActive":true,"sections":[{"id":"checkout","type":"checkout","variant":"v1","props":{"pageTitle":"Checkout","summaryTitle":"Your order","subtotalLabel":"Subtotal","shippingChargeLabel":"Delivery area","totalLabel":"Total","placeOrderText":"Place order","placingOrderText":"Placing order…"},"styles":{},"isActive":true,"order":0}]},"order-success":{"seo":{"title":"Order complete","description":""},"isActive":true,"sections":[{"id":"order-success","type":"order-success","variant":"v1","props":{"title":"Thank you. Your order is in.","message":"We will call you to confirm your order before delivery.","continueShoppingText":"Continue shopping","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"categories":{"seo":{"title":"Categories","description":""},"isActive":true,"sections":[{"id":"categories","type":"categories","variant":"v1","props":{"title":"All categories","subtitle":"Every kind of light, in one place.","columns":4,"emptyText":"No categories yet."},"styles":{},"isActive":true,"order":0}]},"wishlist":{"seo":{"title":"Wishlist","description":""},"isActive":true,"sections":[{"id":"wishlist","type":"wishlist","variant":"v1","props":{"title":"Wishlist","subtitle":"The pieces you saved for later.","emptyTitle":"Nothing saved yet.","emptyText":"Tap the heart on any product to keep it here.","continueShoppingText":"Browse products","continueShoppingLink":"/shop"},"styles":{},"isActive":true,"order":0}]},"compare":{"seo":{"title":"Compare","description":""},"isActive":true,"sections":[{"id":"compare","type":"compare","variant":"v1","props":{"title":"Compare side by side"},"styles":{},"isActive":true,"order":0}]},"coupon":{"seo":{"title":"Coupons","description":""},"isActive":true,"sections":[{"id":"coupon","type":"coupon","variant":"v1","props":{"title":"Coupons","coupons":[{"code":"GLOW10","title":"First order","description":"10% off your first order.","discount":"10% off"},{"code":"DESK200","title":"Desk setups","description":"৳200 off desk lamps and light bars over ৳2,000.","discount":"৳200 off"}]},"styles":{},"isActive":true,"order":0}]},"track-order":{"seo":{"title":"Track your order","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Track your order","content":"<p>Sign in to follow your orders, or enter your order number and phone number below. You can also contact us with your order number.</p>"},"styles":{},"isActive":true,"order":0}]},"signin":{"seo":{"title":"Sign in","description":""},"isActive":true,"sections":[{"id":"signin","type":"signin","variant":"v1","props":{"redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"signup":{"seo":{"title":"Create account","description":""},"isActive":true,"sections":[{"id":"signup","type":"signup","variant":"v1","props":{"redirectUrl":"/account"},"styles":{},"isActive":true,"order":0}]},"account":{"seo":{"title":"My account","description":""},"isActive":true,"sections":[{"id":"account","type":"account","variant":"v1","props":{"tabOverviewLabel":"Overview","tabOrdersLabel":"My orders","tabAddressesLabel":"Addresses","tabDetailsLabel":"Profile","signOutLabel":"Sign out","signinRedirectPath":"/signin"},"styles":{},"isActive":true,"order":0}]},"contact":{"seo":{"title":"Contact us","description":""},"isActive":true,"sections":[{"id":"contact","type":"contact","variant":"v1","props":{"title":"Talk to us","description":"Questions about a product, an order or a custom neon sign? We reply within a day.","email":"hello@lumenvolt.example","phone":"+880 1700-000000","address":"House 1, Road 1, Dhaka"},"styles":{},"isActive":true,"order":0}]},"blog":{"seo":{"title":"Blog","description":""},"isActive":true,"sections":[{"id":"blog","type":"blog","variant":"v1","props":{"title":"From the light lab","posts":[],"viewAllLink":"/blog","showViewAll":true},"styles":{},"isActive":true,"order":0}]},"privacy-policy":{"seo":{"title":"Privacy policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Privacy policy","content":"<h2>What we collect</h2><p>Your name, phone number, delivery address and email when you place an order or create an account, and the products you view or save.</p><h2>How we use it</h2><p>To process and deliver your orders, contact you about them, and improve the store. We never sell your data.</p><h2>Your choices</h2><p>Ask us at any time to see, correct or delete the information we hold about you.</p>"},"styles":{},"isActive":true,"order":0}]},"shipping-policy":{"seo":{"title":"Shipping policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Shipping policy","content":"<h2>Delivery times</h2><p>Inside Dhaka in two to three days, elsewhere in three to five days.</p><h2>Charges</h2><p>Delivery charges depend on your area and are shown at checkout. Orders over ৳3,000 ship free.</p><h2>Cash on delivery</h2><p>Pay when your order arrives. We call to confirm every order before it ships.</p>"},"styles":{},"isActive":true,"order":0}]},"return-policy":{"seo":{"title":"Return policy","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Return policy","content":"<h2>Seven-day returns</h2><p>Return unused items in their original packaging within seven days of delivery.</p><h2>Faulty items</h2><p>If something arrives damaged or does not light up, contact us within 48 hours and we will replace it.</p><h2>Refunds</h2><p>Refunds are made within seven working days after we receive the item.</p>"},"styles":{},"isActive":true,"order":0}]},"terms-of-service":{"seo":{"title":"Terms of service","description":""},"isActive":true,"sections":[{"id":"content","type":"content","variant":"v1","props":{"title":"Terms of service","content":"<h2>Orders</h2><p>An order is confirmed once we call you to verify it. Prices and stock can change until then.</p><h2>Products</h2><p>Colours on screen can differ slightly from the light in your room.</p><h2>Contact</h2><p>Questions about these terms? Write to us from the contact page.</p>"},"styles":{},"isActive":true,"order":0}]}}'), EL = {
  seo: LL,
  config: ML,
  pages: NL
}, Nn = {
  "essentials-1": [{ name: "Taza Bazar demo", data: vL }],
  "apparels-2": [{ name: "Shohure demo", data: $A }],
  "lightings-1": [{ name: "Jhilmil demo", data: EL }],
  "apparels-3": [{ name: "Nakshi demo", data: GA }],
  "apparels-4": [{ name: "Tanabana demo", data: qA }],
  "apparels-5": [{ name: "Mohalla demo", data: QA }],
  "footwear-1": [{ name: "Juta demo", data: oL }],
  "furniture-1": [{ name: "Shegun demo", data: AL }],
  "essentials-2": [{ name: "Prottoho demo", data: xL }],
  "books-1": [{ name: "Pathok demo", data: nL }],
  "gadgets-1": [{ name: "Torongo demo", data: pL }],
  "computers-1": [{ name: "Projukti demo", data: bL }]
}, DL = (e, t, a) => [t, ...a ? Object.keys(Nn).filter((r) => r !== t) : []].flatMap((r) => (Nn[r] ?? []).flatMap(({ name: l, data: i }) => {
  var c, d;
  const n = ((d = (c = i.pages) == null ? void 0 : c[e]) == null ? void 0 : d.sections) ?? [];
  return n.length ? [{ id: `${r}:${e}`, name: l, page: e, sections: n.map(({ id: y, order: u, ...h }) => h) }] : [];
})), gu = (e) => {
  var a, o;
  const t = ((o = (a = Nn[e]) == null ? void 0 : a[0]) == null ? void 0 : o.data.pages) ?? {};
  return Object.fromEntries(Object.entries(t).map(([r, l]) => [r, (l.sections ?? []).map(({ id: i, order: n, ...c }) => c)]));
}, fu = (e) => {
  const t = /^(\w+)\.(\d+)\.(.+)$/.exec(e);
  return t ? { key: t[1], index: Number(t[2]), rest: t[3] } : null;
}, Ms = (e, t) => {
  var r;
  const a = fu(t);
  if (!a) return e[t];
  const o = (r = e[a.key]) == null ? void 0 : r[a.index];
  return o && typeof o == "object" ? Ms(o, a.rest) : void 0;
}, vu = (e, t, a) => {
  const o = fu(t);
  if (!o) return { ...e, [t]: a };
  const r = e[o.key];
  if (!Array.isArray(r) || !r[o.index] || typeof r[o.index] != "object") return e;
  const l = [...r];
  return l[o.index] = vu(r[o.index], o.rest, a), { ...e, [o.key]: l };
}, FL = (e, t, a) => e && typeof e == "object" ? { ...e, [t]: a } : t === "en" ? a : { en: typeof e == "string" ? e : "", bn: a };
function IL() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  return fe(
    () => (o) => {
      t.forEach((r) => r(o));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const Vl = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function zo(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function Ns(e) {
  return "nodeType" in e;
}
function it(e) {
  var t, a;
  return e ? zo(e) ? e : Ns(e) && (t = (a = e.ownerDocument) == null ? void 0 : a.defaultView) != null ? t : window : window;
}
function Es(e) {
  const {
    Document: t
  } = it(e);
  return e instanceof t;
}
function Sr(e) {
  return zo(e) ? !1 : e instanceof it(e).HTMLElement;
}
function ku(e) {
  return e instanceof it(e).SVGElement;
}
function Vo(e) {
  return e ? zo(e) ? e.document : Ns(e) ? Es(e) ? e : Sr(e) || ku(e) ? e.ownerDocument : document : document : document;
}
const _t = Vl ? Ep : ne;
function Ds(e) {
  const t = ve(e);
  return _t(() => {
    t.current = e;
  }), be(function() {
    for (var a = arguments.length, o = new Array(a), r = 0; r < a; r++)
      o[r] = arguments[r];
    return t.current == null ? void 0 : t.current(...o);
  }, []);
}
function OL() {
  const e = ve(null), t = be((o, r) => {
    e.current = setInterval(o, r);
  }, []), a = be(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, a];
}
function pr(e, t) {
  t === void 0 && (t = [e]);
  const a = ve(e);
  return _t(() => {
    a.current !== e && (a.current = e);
  }, t), a;
}
function xr(e, t) {
  const a = ve();
  return fe(
    () => {
      const o = e(a.current);
      return a.current = o, o;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function xl(e) {
  const t = Ds(e), a = ve(null), o = be(
    (r) => {
      r !== a.current && (t == null || t(r, a.current)), a.current = r;
    },
    //eslint-disable-next-line
    []
  );
  return [a, o];
}
function En(e) {
  const t = ve();
  return ne(() => {
    t.current = e;
  }, [e]), t.current;
}
let xi = {};
function Tr(e, t) {
  return fe(() => {
    if (t)
      return t;
    const a = xi[e] == null ? 0 : xi[e] + 1;
    return xi[e] = a, e + "-" + a;
  }, [e, t]);
}
function wu(e) {
  return function(t) {
    for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), r = 1; r < a; r++)
      o[r - 1] = arguments[r];
    return o.reduce((l, i) => {
      const n = Object.entries(i);
      for (const [c, d] of n) {
        const y = l[c];
        y != null && (l[c] = y + e * d);
      }
      return l;
    }, {
      ...t
    });
  };
}
const wo = /* @__PURE__ */ wu(1), ur = /* @__PURE__ */ wu(-1);
function RL(e) {
  return "clientX" in e && "clientY" in e;
}
function Fs(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = it(e.target);
  return t && e instanceof t;
}
function BL(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = it(e.target);
  return t && e instanceof t;
}
function Dn(e) {
  if (BL(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: a
      } = e.touches[0];
      return {
        x: t,
        y: a
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: a
      } = e.changedTouches[0];
      return {
        x: t,
        y: a
      };
    }
  }
  return RL(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const Po = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: a
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (a ? Math.round(a) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: a
      } = e;
      return "scaleX(" + t + ") scaleY(" + a + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [Po.Translate.toString(e), Po.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: a,
        easing: o
      } = e;
      return t + " " + a + "ms " + o;
    }
  }
}), Ld = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function zL(e) {
  return e.matches(Ld) ? e : e.querySelector(Ld);
}
const VL = {
  display: "none"
};
function WL(e) {
  let {
    id: t,
    value: a
  } = e;
  return W.createElement("div", {
    id: t,
    style: VL
  }, a);
}
function $L(e) {
  let {
    id: t,
    announcement: a,
    ariaLiveType: o = "assertive"
  } = e;
  const r = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return W.createElement("div", {
    id: t,
    style: r,
    role: "status",
    "aria-live": o,
    "aria-atomic": !0
  }, a);
}
function _L() {
  const [e, t] = j("");
  return {
    announce: be((o) => {
      o != null && t(o);
    }, []),
    announcement: e
  };
}
const Su = /* @__PURE__ */ xa(null);
function HL(e) {
  const t = $t(Su);
  ne(() => {
    if (!t)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return t(e);
  }, [e, t]);
}
function UL() {
  const [e] = j(() => /* @__PURE__ */ new Set()), t = be((o) => (e.add(o), () => e.delete(o)), [e]);
  return [be((o) => {
    let {
      type: r,
      event: l
    } = o;
    e.forEach((i) => {
      var n;
      return (n = i[r]) == null ? void 0 : n.call(i, l);
    });
  }, [e]), t];
}
const GL = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, YL = {
  onDragStart(e) {
    let {
      active: t
    } = e;
    return "Picked up draggable item " + t.id + ".";
  },
  onDragOver(e) {
    let {
      active: t,
      over: a
    } = e;
    return a ? "Draggable item " + t.id + " was moved over droppable area " + a.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
  },
  onDragEnd(e) {
    let {
      active: t,
      over: a
    } = e;
    return a ? "Draggable item " + t.id + " was dropped over droppable area " + a.id : "Draggable item " + t.id + " was dropped.";
  },
  onDragCancel(e) {
    let {
      active: t
    } = e;
    return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
  }
};
function XL(e) {
  let {
    announcements: t = YL,
    container: a,
    hiddenTextDescribedById: o,
    screenReaderInstructions: r = GL
  } = e;
  const {
    announce: l,
    announcement: i
  } = _L(), n = Tr("DndLiveRegion"), [c, d] = j(!1);
  if (ne(() => {
    d(!0);
  }, []), HL(fe(() => ({
    onDragStart(u) {
      let {
        active: h
      } = u;
      l(t.onDragStart({
        active: h
      }));
    },
    onDragMove(u) {
      let {
        active: h,
        over: p
      } = u;
      t.onDragMove && l(t.onDragMove({
        active: h,
        over: p
      }));
    },
    onDragOver(u) {
      let {
        active: h,
        over: p
      } = u;
      l(t.onDragOver({
        active: h,
        over: p
      }));
    },
    onDragEnd(u) {
      let {
        active: h,
        over: p
      } = u;
      l(t.onDragEnd({
        active: h,
        over: p
      }));
    },
    onDragCancel(u) {
      let {
        active: h,
        over: p
      } = u;
      l(t.onDragCancel({
        active: h,
        over: p
      }));
    }
  }), [l, t])), !c)
    return null;
  const y = W.createElement(W.Fragment, null, W.createElement(WL, {
    id: o,
    value: r.draggable
  }), W.createElement($L, {
    id: n,
    announcement: i
  }));
  return a ? Ib(y, a) : y;
}
var He;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(He || (He = {}));
function Tl() {
}
function Cl(e, t) {
  return fe(
    () => ({
      sensor: e,
      options: t ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function xu() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  return fe(
    () => [...t].filter((o) => o != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
const Lt = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function Tu(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function Cu(e, t) {
  let {
    data: {
      value: a
    }
  } = e, {
    data: {
      value: o
    }
  } = t;
  return a - o;
}
function jL(e, t) {
  let {
    data: {
      value: a
    }
  } = e, {
    data: {
      value: o
    }
  } = t;
  return o - a;
}
function Md(e) {
  let {
    left: t,
    top: a,
    height: o,
    width: r
  } = e;
  return [{
    x: t,
    y: a
  }, {
    x: t + r,
    y: a
  }, {
    x: t,
    y: a + o
  }, {
    x: t + r,
    y: a + o
  }];
}
function Pu(e, t) {
  if (!e || e.length === 0)
    return null;
  const [a] = e;
  return a[t];
}
function Nd(e, t, a) {
  return t === void 0 && (t = e.left), a === void 0 && (a = e.top), {
    x: t + e.width * 0.5,
    y: a + e.height * 0.5
  };
}
const Au = (e) => {
  let {
    collisionRect: t,
    droppableRects: a,
    droppableContainers: o
  } = e;
  const r = Nd(t, t.left, t.top), l = [];
  for (const i of o) {
    const {
      id: n
    } = i, c = a.get(n);
    if (c) {
      const d = Tu(Nd(c), r);
      l.push({
        id: n,
        data: {
          droppableContainer: i,
          value: d
        }
      });
    }
  }
  return l.sort(Cu);
}, qL = (e) => {
  let {
    collisionRect: t,
    droppableRects: a,
    droppableContainers: o
  } = e;
  const r = Md(t), l = [];
  for (const i of o) {
    const {
      id: n
    } = i, c = a.get(n);
    if (c) {
      const d = Md(c), y = r.reduce((h, p, g) => h + Tu(d[g], p), 0), u = Number((y / 4).toFixed(4));
      l.push({
        id: n,
        data: {
          droppableContainer: i,
          value: u
        }
      });
    }
  }
  return l.sort(Cu);
};
function ZL(e, t) {
  const a = Math.max(t.top, e.top), o = Math.max(t.left, e.left), r = Math.min(t.left + t.width, e.left + e.width), l = Math.min(t.top + t.height, e.top + e.height), i = r - o, n = l - a;
  if (o < r && a < l) {
    const c = t.width * t.height, d = e.width * e.height, y = i * n, u = y / (c + d - y);
    return Number(u.toFixed(4));
  }
  return 0;
}
const JL = (e) => {
  let {
    collisionRect: t,
    droppableRects: a,
    droppableContainers: o
  } = e;
  const r = [];
  for (const l of o) {
    const {
      id: i
    } = l, n = a.get(i);
    if (n) {
      const c = ZL(n, t);
      c > 0 && r.push({
        id: i,
        data: {
          droppableContainer: l,
          value: c
        }
      });
    }
  }
  return r.sort(jL);
};
function KL(e, t, a) {
  return {
    ...e,
    scaleX: t && a ? t.width / a.width : 1,
    scaleY: t && a ? t.height / a.height : 1
  };
}
function Lu(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : Lt;
}
function QL(e) {
  return function(a) {
    for (var o = arguments.length, r = new Array(o > 1 ? o - 1 : 0), l = 1; l < o; l++)
      r[l - 1] = arguments[l];
    return r.reduce((i, n) => ({
      ...i,
      top: i.top + e * n.y,
      bottom: i.bottom + e * n.y,
      left: i.left + e * n.x,
      right: i.right + e * n.x
    }), {
      ...a
    });
  };
}
const e2 = /* @__PURE__ */ QL(1);
function t2(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function a2(e, t, a) {
  const o = t2(t);
  if (!o)
    return e;
  const {
    scaleX: r,
    scaleY: l,
    x: i,
    y: n
  } = o, c = e.left - i - (1 - r) * parseFloat(a), d = e.top - n - (1 - l) * parseFloat(a.slice(a.indexOf(" ") + 1)), y = r ? e.width / r : e.width, u = l ? e.height / l : e.height;
  return {
    width: y,
    height: u,
    top: d,
    right: c + y,
    bottom: d + u,
    left: c
  };
}
const o2 = {
  ignoreTransform: !1
};
function Wo(e, t) {
  t === void 0 && (t = o2);
  let a = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: d,
      transformOrigin: y
    } = it(e).getComputedStyle(e);
    d && (a = a2(a, d, y));
  }
  const {
    top: o,
    left: r,
    width: l,
    height: i,
    bottom: n,
    right: c
  } = a;
  return {
    top: o,
    left: r,
    width: l,
    height: i,
    bottom: n,
    right: c
  };
}
function Ed(e) {
  return Wo(e, {
    ignoreTransform: !0
  });
}
function r2(e) {
  const t = e.innerWidth, a = e.innerHeight;
  return {
    top: 0,
    left: 0,
    right: t,
    bottom: a,
    width: t,
    height: a
  };
}
function l2(e, t) {
  return t === void 0 && (t = it(e).getComputedStyle(e)), t.position === "fixed";
}
function i2(e, t) {
  t === void 0 && (t = it(e).getComputedStyle(e));
  const a = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((r) => {
    const l = t[r];
    return typeof l == "string" ? a.test(l) : !1;
  });
}
function Wl(e, t) {
  const a = [];
  function o(r) {
    if (t != null && a.length >= t || !r)
      return a;
    if (Es(r) && r.scrollingElement != null && !a.includes(r.scrollingElement))
      return a.push(r.scrollingElement), a;
    if (!Sr(r) || ku(r) || a.includes(r))
      return a;
    const l = it(e).getComputedStyle(r);
    return r !== e && i2(r, l) && a.push(r), l2(r, l) ? a : o(r.parentNode);
  }
  return e ? o(e) : a;
}
function Mu(e) {
  const [t] = Wl(e, 1);
  return t ?? null;
}
function Ti(e) {
  return !Vl || !e ? null : zo(e) ? e : Ns(e) ? Es(e) || e === Vo(e).scrollingElement ? window : Sr(e) ? e : null : null;
}
function Nu(e) {
  return zo(e) ? e.scrollX : e.scrollLeft;
}
function Eu(e) {
  return zo(e) ? e.scrollY : e.scrollTop;
}
function Fn(e) {
  return {
    x: Nu(e),
    y: Eu(e)
  };
}
var Xe;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(Xe || (Xe = {}));
function Du(e) {
  return !Vl || !e ? !1 : e === document.scrollingElement;
}
function Fu(e) {
  const t = {
    x: 0,
    y: 0
  }, a = Du(e) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: e.clientHeight,
    width: e.clientWidth
  }, o = {
    x: e.scrollWidth - a.width,
    y: e.scrollHeight - a.height
  }, r = e.scrollTop <= t.y, l = e.scrollLeft <= t.x, i = e.scrollTop >= o.y, n = e.scrollLeft >= o.x;
  return {
    isTop: r,
    isLeft: l,
    isBottom: i,
    isRight: n,
    maxScroll: o,
    minScroll: t
  };
}
const n2 = {
  x: 0.2,
  y: 0.2
};
function s2(e, t, a, o, r) {
  let {
    top: l,
    left: i,
    right: n,
    bottom: c
  } = a;
  o === void 0 && (o = 10), r === void 0 && (r = n2);
  const {
    isTop: d,
    isBottom: y,
    isLeft: u,
    isRight: h
  } = Fu(e), p = {
    x: 0,
    y: 0
  }, g = {
    x: 0,
    y: 0
  }, m = {
    height: t.height * r.y,
    width: t.width * r.x
  };
  return !d && l <= t.top + m.height ? (p.y = Xe.Backward, g.y = o * Math.abs((t.top + m.height - l) / m.height)) : !y && c >= t.bottom - m.height && (p.y = Xe.Forward, g.y = o * Math.abs((t.bottom - m.height - c) / m.height)), !h && n >= t.right - m.width ? (p.x = Xe.Forward, g.x = o * Math.abs((t.right - m.width - n) / m.width)) : !u && i <= t.left + m.width && (p.x = Xe.Backward, g.x = o * Math.abs((t.left + m.width - i) / m.width)), {
    direction: p,
    speed: g
  };
}
function c2(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: l,
      innerHeight: i
    } = window;
    return {
      top: 0,
      left: 0,
      right: l,
      bottom: i,
      width: l,
      height: i
    };
  }
  const {
    top: t,
    left: a,
    right: o,
    bottom: r
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: a,
    right: o,
    bottom: r,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function Iu(e) {
  return e.reduce((t, a) => wo(t, Fn(a)), Lt);
}
function d2(e) {
  return e.reduce((t, a) => t + Nu(a), 0);
}
function p2(e) {
  return e.reduce((t, a) => t + Eu(a), 0);
}
function u2(e, t) {
  if (t === void 0 && (t = Wo), !e)
    return;
  const {
    top: a,
    left: o,
    bottom: r,
    right: l
  } = t(e);
  Mu(e) && (r <= 0 || l <= 0 || a >= window.innerHeight || o >= window.innerWidth) && e.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const y2 = [["x", ["left", "right"], d2], ["y", ["top", "bottom"], p2]];
class Is {
  constructor(t, a) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const o = Wl(a), r = Iu(o);
    this.rect = {
      ...t
    }, this.width = t.width, this.height = t.height;
    for (const [l, i, n] of y2)
      for (const c of i)
        Object.defineProperty(this, c, {
          get: () => {
            const d = n(o), y = r[l] - d;
            return this.rect[c] + y;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class ir {
  constructor(t) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((a) => {
        var o;
        return (o = this.target) == null ? void 0 : o.removeEventListener(...a);
      });
    }, this.target = t;
  }
  add(t, a, o) {
    var r;
    (r = this.target) == null || r.addEventListener(t, a, o), this.listeners.push([t, a, o]);
  }
}
function h2(e) {
  const {
    EventTarget: t
  } = it(e);
  return e instanceof t ? e : Vo(e);
}
function Ci(e, t) {
  const a = Math.abs(e.x), o = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(a ** 2 + o ** 2) > t : "x" in t && "y" in t ? a > t.x && o > t.y : "x" in t ? a > t.x : "y" in t ? o > t.y : !1;
}
var dt;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(dt || (dt = {}));
function Dd(e) {
  e.preventDefault();
}
function b2(e) {
  e.stopPropagation();
}
var ke;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(ke || (ke = {}));
const Ou = {
  start: [ke.Space, ke.Enter],
  cancel: [ke.Esc],
  end: [ke.Space, ke.Enter, ke.Tab]
}, m2 = (e, t) => {
  let {
    currentCoordinates: a
  } = t;
  switch (e.code) {
    case ke.Right:
      return {
        ...a,
        x: a.x + 25
      };
    case ke.Left:
      return {
        ...a,
        x: a.x - 25
      };
    case ke.Down:
      return {
        ...a,
        y: a.y + 25
      };
    case ke.Up:
      return {
        ...a,
        y: a.y - 25
      };
  }
};
class $l {
  constructor(t) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = t;
    const {
      event: {
        target: a
      }
    } = t;
    this.props = t, this.listeners = new ir(Vo(a)), this.windowListeners = new ir(it(a)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(dt.Resize, this.handleCancel), this.windowListeners.add(dt.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(dt.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: a
    } = this.props, o = t.node.current;
    o && u2(o), a(Lt);
  }
  handleKeyDown(t) {
    if (Fs(t)) {
      const {
        active: a,
        context: o,
        options: r
      } = this.props, {
        keyboardCodes: l = Ou,
        coordinateGetter: i = m2,
        scrollBehavior: n = "smooth"
      } = r, {
        code: c
      } = t;
      if (l.end.includes(c)) {
        this.handleEnd(t);
        return;
      }
      if (l.cancel.includes(c)) {
        this.handleCancel(t);
        return;
      }
      const {
        collisionRect: d
      } = o.current, y = d ? {
        x: d.left,
        y: d.top
      } : Lt;
      this.referenceCoordinates || (this.referenceCoordinates = y);
      const u = i(t, {
        active: a,
        context: o.current,
        currentCoordinates: y
      });
      if (u) {
        const h = ur(u, y), p = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: g
        } = o.current;
        for (const m of g) {
          const f = t.code, {
            isTop: v,
            isRight: k,
            isLeft: w,
            isBottom: S,
            maxScroll: T,
            minScroll: C
          } = Fu(m), A = c2(m), M = {
            x: Math.min(f === ke.Right ? A.right - A.width / 2 : A.right, Math.max(f === ke.Right ? A.left : A.left + A.width / 2, u.x)),
            y: Math.min(f === ke.Down ? A.bottom - A.height / 2 : A.bottom, Math.max(f === ke.Down ? A.top : A.top + A.height / 2, u.y))
          }, E = f === ke.Right && !k || f === ke.Left && !w, F = f === ke.Down && !S || f === ke.Up && !v;
          if (E && M.x !== u.x) {
            const I = m.scrollLeft + h.x, P = f === ke.Right && I <= T.x || f === ke.Left && I >= C.x;
            if (P && !h.y) {
              m.scrollTo({
                left: I,
                behavior: n
              });
              return;
            }
            P ? p.x = m.scrollLeft - I : p.x = f === ke.Right ? m.scrollLeft - T.x : m.scrollLeft - C.x, p.x && m.scrollBy({
              left: -p.x,
              behavior: n
            });
            break;
          } else if (F && M.y !== u.y) {
            const I = m.scrollTop + h.y, P = f === ke.Down && I <= T.y || f === ke.Up && I >= C.y;
            if (P && !h.x) {
              m.scrollTo({
                top: I,
                behavior: n
              });
              return;
            }
            P ? p.y = m.scrollTop - I : p.y = f === ke.Down ? m.scrollTop - T.y : m.scrollTop - C.y, p.y && m.scrollBy({
              top: -p.y,
              behavior: n
            });
            break;
          }
        }
        this.handleMove(t, wo(ur(u, this.referenceCoordinates), p));
      }
    }
  }
  handleMove(t, a) {
    const {
      onMove: o
    } = this.props;
    t.preventDefault(), o(a);
  }
  handleEnd(t) {
    const {
      onEnd: a
    } = this.props;
    t.preventDefault(), this.detach(), a();
  }
  handleCancel(t) {
    const {
      onCancel: a
    } = this.props;
    t.preventDefault(), this.detach(), a();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
$l.activators = [{
  eventName: "onKeyDown",
  handler: (e, t, a) => {
    let {
      keyboardCodes: o = Ou,
      onActivation: r
    } = t, {
      active: l
    } = a;
    const {
      code: i
    } = e.nativeEvent;
    if (o.start.includes(i)) {
      const n = l.activatorNode.current;
      return n && e.target !== n ? !1 : (e.preventDefault(), r == null || r({
        event: e.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function Fd(e) {
  return !!(e && "distance" in e);
}
function Id(e) {
  return !!(e && "delay" in e);
}
class Os {
  constructor(t, a, o) {
    var r;
    o === void 0 && (o = h2(t.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = t, this.events = a;
    const {
      event: l
    } = t, {
      target: i
    } = l;
    this.props = t, this.events = a, this.document = Vo(i), this.documentListeners = new ir(this.document), this.listeners = new ir(o), this.windowListeners = new ir(it(i)), this.initialCoordinates = (r = Dn(l)) != null ? r : Lt, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: a,
          bypassActivationConstraint: o
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), t.cancel && this.listeners.add(t.cancel.name, this.handleCancel), this.windowListeners.add(dt.Resize, this.handleCancel), this.windowListeners.add(dt.DragStart, Dd), this.windowListeners.add(dt.VisibilityChange, this.handleCancel), this.windowListeners.add(dt.ContextMenu, Dd), this.documentListeners.add(dt.Keydown, this.handleKeydown), a) {
      if (o != null && o({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (Id(a)) {
        this.timeoutId = setTimeout(this.handleStart, a.delay), this.handlePending(a);
        return;
      }
      if (Fd(a)) {
        this.handlePending(a);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handlePending(t, a) {
    const {
      active: o,
      onPending: r
    } = this.props;
    r(o, t, this.initialCoordinates, a);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: a
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add(dt.Click, b2, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(dt.SelectionChange, this.removeTextSelection), a(t));
  }
  handleMove(t) {
    var a;
    const {
      activated: o,
      initialCoordinates: r,
      props: l
    } = this, {
      onMove: i,
      options: {
        activationConstraint: n
      }
    } = l;
    if (!r)
      return;
    const c = (a = Dn(t)) != null ? a : Lt, d = ur(r, c);
    if (!o && n) {
      if (Fd(n)) {
        if (n.tolerance != null && Ci(d, n.tolerance))
          return this.handleCancel();
        if (Ci(d, n.distance))
          return this.handleStart();
      }
      if (Id(n) && Ci(d, n.tolerance))
        return this.handleCancel();
      this.handlePending(n, d);
      return;
    }
    t.cancelable && t.preventDefault(), i(c);
  }
  handleEnd() {
    const {
      onAbort: t,
      onEnd: a
    } = this.props;
    this.detach(), this.activated || t(this.props.active), a();
  }
  handleCancel() {
    const {
      onAbort: t,
      onCancel: a
    } = this.props;
    this.detach(), this.activated || t(this.props.active), a();
  }
  handleKeydown(t) {
    t.code === ke.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const g2 = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class _l extends Os {
  constructor(t) {
    const {
      event: a
    } = t, o = Vo(a.target);
    super(t, g2, o);
  }
}
_l.activators = [{
  eventName: "onPointerDown",
  handler: (e, t) => {
    let {
      nativeEvent: a
    } = e, {
      onActivation: o
    } = t;
    return !a.isPrimary || a.button !== 0 ? !1 : (o == null || o({
      event: a
    }), !0);
  }
}];
const f2 = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var In;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(In || (In = {}));
class v2 extends Os {
  constructor(t) {
    super(t, f2, Vo(t.event.target));
  }
}
v2.activators = [{
  eventName: "onMouseDown",
  handler: (e, t) => {
    let {
      nativeEvent: a
    } = e, {
      onActivation: o
    } = t;
    return a.button === In.RightClick ? !1 : (o == null || o({
      event: a
    }), !0);
  }
}];
const Pi = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class k2 extends Os {
  constructor(t) {
    super(t, Pi);
  }
  static setup() {
    return window.addEventListener(Pi.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(Pi.move.name, t);
    };
    function t() {
    }
  }
}
k2.activators = [{
  eventName: "onTouchStart",
  handler: (e, t) => {
    let {
      nativeEvent: a
    } = e, {
      onActivation: o
    } = t;
    const {
      touches: r
    } = a;
    return r.length > 1 ? !1 : (o == null || o({
      event: a
    }), !0);
  }
}];
var nr;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(nr || (nr = {}));
var Pl;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(Pl || (Pl = {}));
function w2(e) {
  let {
    acceleration: t,
    activator: a = nr.Pointer,
    canScroll: o,
    draggingRect: r,
    enabled: l,
    interval: i = 5,
    order: n = Pl.TreeOrder,
    pointerCoordinates: c,
    scrollableAncestors: d,
    scrollableAncestorRects: y,
    delta: u,
    threshold: h
  } = e;
  const p = x2({
    delta: u,
    disabled: !l
  }), [g, m] = OL(), f = ve({
    x: 0,
    y: 0
  }), v = ve({
    x: 0,
    y: 0
  }), k = fe(() => {
    switch (a) {
      case nr.Pointer:
        return c ? {
          top: c.y,
          bottom: c.y,
          left: c.x,
          right: c.x
        } : null;
      case nr.DraggableRect:
        return r;
    }
  }, [a, r, c]), w = ve(null), S = be(() => {
    const C = w.current;
    if (!C)
      return;
    const A = f.current.x * v.current.x, M = f.current.y * v.current.y;
    C.scrollBy(A, M);
  }, []), T = fe(() => n === Pl.TreeOrder ? [...d].reverse() : d, [n, d]);
  ne(
    () => {
      if (!l || !d.length || !k) {
        m();
        return;
      }
      for (const C of T) {
        if ((o == null ? void 0 : o(C)) === !1)
          continue;
        const A = d.indexOf(C), M = y[A];
        if (!M)
          continue;
        const {
          direction: E,
          speed: F
        } = s2(C, M, k, t, h);
        for (const I of ["x", "y"])
          p[I][E[I]] || (F[I] = 0, E[I] = 0);
        if (F.x > 0 || F.y > 0) {
          m(), w.current = C, g(S, i), f.current = F, v.current = E;
          return;
        }
      }
      f.current = {
        x: 0,
        y: 0
      }, v.current = {
        x: 0,
        y: 0
      }, m();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t,
      S,
      o,
      m,
      l,
      i,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(k),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(p),
      g,
      d,
      T,
      y,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(h)
    ]
  );
}
const S2 = {
  x: {
    [Xe.Backward]: !1,
    [Xe.Forward]: !1
  },
  y: {
    [Xe.Backward]: !1,
    [Xe.Forward]: !1
  }
};
function x2(e) {
  let {
    delta: t,
    disabled: a
  } = e;
  const o = En(t);
  return xr((r) => {
    if (a || !o || !r)
      return S2;
    const l = {
      x: Math.sign(t.x - o.x),
      y: Math.sign(t.y - o.y)
    };
    return {
      x: {
        [Xe.Backward]: r.x[Xe.Backward] || l.x === -1,
        [Xe.Forward]: r.x[Xe.Forward] || l.x === 1
      },
      y: {
        [Xe.Backward]: r.y[Xe.Backward] || l.y === -1,
        [Xe.Forward]: r.y[Xe.Forward] || l.y === 1
      }
    };
  }, [a, t, o]);
}
function T2(e, t) {
  const a = t != null ? e.get(t) : void 0, o = a ? a.node.current : null;
  return xr((r) => {
    var l;
    return t == null ? null : (l = o ?? r) != null ? l : null;
  }, [o, t]);
}
function C2(e, t) {
  return fe(() => e.reduce((a, o) => {
    const {
      sensor: r
    } = o, l = r.activators.map((i) => ({
      eventName: i.eventName,
      handler: t(i.handler, o)
    }));
    return [...a, ...l];
  }, []), [e, t]);
}
var yr;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(yr || (yr = {}));
var On;
(function(e) {
  e.Optimized = "optimized";
})(On || (On = {}));
const Od = /* @__PURE__ */ new Map();
function P2(e, t) {
  let {
    dragging: a,
    dependencies: o,
    config: r
  } = t;
  const [l, i] = j(null), {
    frequency: n,
    measure: c,
    strategy: d
  } = r, y = ve(e), u = f(), h = pr(u), p = be(function(v) {
    v === void 0 && (v = []), !h.current && i((k) => k === null ? v : k.concat(v.filter((w) => !k.includes(w))));
  }, [h]), g = ve(null), m = xr((v) => {
    if (u && !a)
      return Od;
    if (!v || v === Od || y.current !== e || l != null) {
      const k = /* @__PURE__ */ new Map();
      for (let w of e) {
        if (!w)
          continue;
        if (l && l.length > 0 && !l.includes(w.id) && w.rect.current) {
          k.set(w.id, w.rect.current);
          continue;
        }
        const S = w.node.current, T = S ? new Is(c(S), S) : null;
        w.rect.current = T, T && k.set(w.id, T);
      }
      return k;
    }
    return v;
  }, [e, l, a, u, c]);
  return ne(() => {
    y.current = e;
  }, [e]), ne(
    () => {
      u || p();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a, u]
  ), ne(
    () => {
      l && l.length > 0 && i(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(l)]
  ), ne(
    () => {
      u || typeof n != "number" || g.current !== null || (g.current = setTimeout(() => {
        p(), g.current = null;
      }, n));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, u, p, ...o]
  ), {
    droppableRects: m,
    measureDroppableContainers: p,
    measuringScheduled: l != null
  };
  function f() {
    switch (d) {
      case yr.Always:
        return !1;
      case yr.BeforeDragging:
        return a;
      default:
        return !a;
    }
  }
}
function Ru(e, t) {
  return xr((a) => e ? a || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function A2(e, t) {
  return Ru(e, t);
}
function L2(e) {
  let {
    callback: t,
    disabled: a
  } = e;
  const o = Ds(t), r = fe(() => {
    if (a || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: l
    } = window;
    return new l(o);
  }, [o, a]);
  return ne(() => () => r == null ? void 0 : r.disconnect(), [r]), r;
}
function Hl(e) {
  let {
    callback: t,
    disabled: a
  } = e;
  const o = Ds(t), r = fe(
    () => {
      if (a || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: l
      } = window;
      return new l(o);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a]
  );
  return ne(() => () => r == null ? void 0 : r.disconnect(), [r]), r;
}
function M2(e) {
  return new Is(Wo(e), e);
}
function Rd(e, t, a) {
  t === void 0 && (t = M2);
  const [o, r] = j(null);
  function l() {
    r((c) => {
      if (!e)
        return null;
      if (e.isConnected === !1) {
        var d;
        return (d = c ?? a) != null ? d : null;
      }
      const y = t(e);
      return JSON.stringify(c) === JSON.stringify(y) ? c : y;
    });
  }
  const i = L2({
    callback(c) {
      if (e)
        for (const d of c) {
          const {
            type: y,
            target: u
          } = d;
          if (y === "childList" && u instanceof HTMLElement && u.contains(e)) {
            l();
            break;
          }
        }
    }
  }), n = Hl({
    callback: l
  });
  return _t(() => {
    l(), e ? (n == null || n.observe(e), i == null || i.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (n == null || n.disconnect(), i == null || i.disconnect());
  }, [e]), o;
}
function N2(e) {
  const t = Ru(e);
  return Lu(e, t);
}
const Bd = [];
function E2(e) {
  const t = ve(e), a = xr((o) => e ? o && o !== Bd && e && t.current && e.parentNode === t.current.parentNode ? o : Wl(e) : Bd, [e]);
  return ne(() => {
    t.current = e;
  }, [e]), a;
}
function D2(e) {
  const [t, a] = j(null), o = ve(e), r = be((l) => {
    const i = Ti(l.target);
    i && a((n) => n ? (n.set(i, Fn(i)), new Map(n)) : null);
  }, []);
  return ne(() => {
    const l = o.current;
    if (e !== l) {
      i(l);
      const n = e.map((c) => {
        const d = Ti(c);
        return d ? (d.addEventListener("scroll", r, {
          passive: !0
        }), [d, Fn(d)]) : null;
      }).filter((c) => c != null);
      a(n.length ? new Map(n) : null), o.current = e;
    }
    return () => {
      i(e), i(l);
    };
    function i(n) {
      n.forEach((c) => {
        const d = Ti(c);
        d == null || d.removeEventListener("scroll", r);
      });
    }
  }, [r, e]), fe(() => e.length ? t ? Array.from(t.values()).reduce((l, i) => wo(l, i), Lt) : Iu(e) : Lt, [e, t]);
}
function zd(e, t) {
  t === void 0 && (t = []);
  const a = ve(null);
  return ne(
    () => {
      a.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), ne(() => {
    const o = e !== Lt;
    o && !a.current && (a.current = e), !o && a.current && (a.current = null);
  }, [e]), a.current ? ur(e, a.current) : Lt;
}
function F2(e) {
  ne(
    () => {
      if (!Vl)
        return;
      const t = e.map((a) => {
        let {
          sensor: o
        } = a;
        return o.setup == null ? void 0 : o.setup();
      });
      return () => {
        for (const a of t)
          a == null || a();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((t) => {
      let {
        sensor: a
      } = t;
      return a;
    })
  );
}
function I2(e, t) {
  return fe(() => e.reduce((a, o) => {
    let {
      eventName: r,
      handler: l
    } = o;
    return a[r] = (i) => {
      l(i, t);
    }, a;
  }, {}), [e, t]);
}
function Bu(e) {
  return fe(() => e ? r2(e) : null, [e]);
}
const Vd = [];
function O2(e, t) {
  t === void 0 && (t = Wo);
  const [a] = e, o = Bu(a ? it(a) : null), [r, l] = j(Vd);
  function i() {
    l(() => e.length ? e.map((c) => Du(c) ? o : new Is(t(c), c)) : Vd);
  }
  const n = Hl({
    callback: i
  });
  return _t(() => {
    n == null || n.disconnect(), i(), e.forEach((c) => n == null ? void 0 : n.observe(c));
  }, [e]), r;
}
function R2(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return Sr(t) ? t : e;
}
function B2(e) {
  let {
    measure: t
  } = e;
  const [a, o] = j(null), r = be((d) => {
    for (const {
      target: y
    } of d)
      if (Sr(y)) {
        o((u) => {
          const h = t(y);
          return u ? {
            ...u,
            width: h.width,
            height: h.height
          } : h;
        });
        break;
      }
  }, [t]), l = Hl({
    callback: r
  }), i = be((d) => {
    const y = R2(d);
    l == null || l.disconnect(), y && (l == null || l.observe(y)), o(y ? t(y) : null);
  }, [t, l]), [n, c] = xl(i);
  return fe(() => ({
    nodeRef: n,
    rect: a,
    setRef: c
  }), [a, n, c]);
}
const z2 = [{
  sensor: _l,
  options: {}
}, {
  sensor: $l,
  options: {}
}], V2 = {
  current: {}
}, dl = {
  draggable: {
    measure: Ed
  },
  droppable: {
    measure: Ed,
    strategy: yr.WhileDragging,
    frequency: On.Optimized
  },
  dragOverlay: {
    measure: Wo
  }
};
class sr extends Map {
  get(t) {
    var a;
    return t != null && (a = super.get(t)) != null ? a : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((t) => {
      let {
        disabled: a
      } = t;
      return !a;
    });
  }
  getNodeFor(t) {
    var a, o;
    return (a = (o = this.get(t)) == null ? void 0 : o.node.current) != null ? a : void 0;
  }
}
const W2 = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new sr(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: Tl
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: dl,
  measureDroppableContainers: Tl,
  windowRect: null,
  measuringScheduled: !1
}, $2 = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: Tl,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: Tl
}, Ul = /* @__PURE__ */ xa($2), zu = /* @__PURE__ */ xa(W2);
function _2() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new sr()
    }
  };
}
function H2(e, t) {
  switch (t.type) {
    case He.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case He.DragMove:
      return e.draggable.active == null ? e : {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      };
    case He.DragEnd:
    case He.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case He.RegisterDroppable: {
      const {
        element: a
      } = t, {
        id: o
      } = a, r = new sr(e.droppable.containers);
      return r.set(o, a), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: r
        }
      };
    }
    case He.SetDroppableDisabled: {
      const {
        id: a,
        key: o,
        disabled: r
      } = t, l = e.droppable.containers.get(a);
      if (!l || o !== l.key)
        return e;
      const i = new sr(e.droppable.containers);
      return i.set(a, {
        ...l,
        disabled: r
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: i
        }
      };
    }
    case He.UnregisterDroppable: {
      const {
        id: a,
        key: o
      } = t, r = e.droppable.containers.get(a);
      if (!r || o !== r.key)
        return e;
      const l = new sr(e.droppable.containers);
      return l.delete(a), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: l
        }
      };
    }
    default:
      return e;
  }
}
function U2(e) {
  let {
    disabled: t
  } = e;
  const {
    active: a,
    activatorEvent: o,
    draggableNodes: r
  } = $t(Ul), l = En(o), i = En(a == null ? void 0 : a.id);
  return ne(() => {
    if (!t && !o && l && i != null) {
      if (!Fs(l) || document.activeElement === l.target)
        return;
      const n = r.get(i);
      if (!n)
        return;
      const {
        activatorNode: c,
        node: d
      } = n;
      if (!c.current && !d.current)
        return;
      requestAnimationFrame(() => {
        for (const y of [c.current, d.current]) {
          if (!y)
            continue;
          const u = zL(y);
          if (u) {
            u.focus();
            break;
          }
        }
      });
    }
  }, [o, t, r, i, l]), null;
}
function G2(e, t) {
  let {
    transform: a,
    ...o
  } = t;
  return e != null && e.length ? e.reduce((r, l) => l({
    transform: r,
    ...o
  }), a) : a;
}
function Y2(e) {
  return fe(
    () => ({
      draggable: {
        ...dl.draggable,
        ...e == null ? void 0 : e.draggable
      },
      droppable: {
        ...dl.droppable,
        ...e == null ? void 0 : e.droppable
      },
      dragOverlay: {
        ...dl.dragOverlay,
        ...e == null ? void 0 : e.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e == null ? void 0 : e.draggable, e == null ? void 0 : e.droppable, e == null ? void 0 : e.dragOverlay]
  );
}
function X2(e) {
  let {
    activeNode: t,
    measure: a,
    initialRect: o,
    config: r = !0
  } = e;
  const l = ve(!1), {
    x: i,
    y: n
  } = typeof r == "boolean" ? {
    x: r,
    y: r
  } : r;
  _t(() => {
    if (!i && !n || !t) {
      l.current = !1;
      return;
    }
    if (l.current || !o)
      return;
    const d = t == null ? void 0 : t.node.current;
    if (!d || d.isConnected === !1)
      return;
    const y = a(d), u = Lu(y, o);
    if (i || (u.x = 0), n || (u.y = 0), l.current = !0, Math.abs(u.x) > 0 || Math.abs(u.y) > 0) {
      const h = Mu(d);
      h && h.scrollBy({
        top: u.y,
        left: u.x
      });
    }
  }, [t, i, n, o, a]);
}
const Vu = /* @__PURE__ */ xa({
  ...Lt,
  scaleX: 1,
  scaleY: 1
});
var ma;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(ma || (ma = {}));
const Wu = /* @__PURE__ */ Eb(function(t) {
  var a, o, r, l;
  let {
    id: i,
    accessibility: n,
    autoScroll: c = !0,
    children: d,
    sensors: y = z2,
    collisionDetection: u = JL,
    measuring: h,
    modifiers: p,
    ...g
  } = t;
  const m = Db(H2, void 0, _2), [f, v] = m, [k, w] = UL(), [S, T] = j(ma.Uninitialized), C = S === ma.Initialized, {
    draggable: {
      active: A,
      nodes: M,
      translate: E
    },
    droppable: {
      containers: F
    }
  } = f, I = A != null ? M.get(A) : null, P = ve({
    initial: null,
    translated: null
  }), O = fe(() => {
    var $e;
    return A != null ? {
      id: A,
      // It's possible for the active node to unmount while dragging
      data: ($e = I == null ? void 0 : I.data) != null ? $e : V2,
      rect: P
    } : null;
  }, [A, I]), z = ve(null), [U, Y] = j(null), [_, H] = j(null), N = pr(g, Object.values(g)), D = Tr("DndDescribedBy", i), $ = fe(() => F.getEnabled(), [F]), V = Y2(h), {
    droppableRects: X,
    measureDroppableContainers: oe,
    measuringScheduled: pe
  } = P2($, {
    dragging: C,
    dependencies: [E.x, E.y],
    config: V.droppable
  }), Se = T2(M, A), ae = fe(() => _ ? Dn(_) : null, [_]), q = di(), re = A2(Se, V.draggable.measure);
  X2({
    activeNode: A != null ? M.get(A) : null,
    config: q.layoutShiftCompensation,
    initialRect: re,
    measure: V.draggable.measure
  });
  const Z = Rd(Se, V.draggable.measure, re), ie = Rd(Se ? Se.parentElement : null), K = ve({
    activatorEvent: null,
    active: null,
    activeNode: Se,
    collisionRect: null,
    collisions: null,
    droppableRects: X,
    draggableNodes: M,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: F,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), se = F.getNodeFor((a = K.current.over) == null ? void 0 : a.id), Pe = B2({
    measure: V.dragOverlay.measure
  }), G = (o = Pe.nodeRef.current) != null ? o : Se, L = C ? (r = Pe.rect) != null ? r : Z : null, B = !!(Pe.nodeRef.current && Pe.rect), Q = N2(B ? null : Z), xe = Bu(G ? it(G) : null), ue = E2(C ? se ?? Se : null), Re = O2(ue), Je = G2(p, {
    transform: {
      x: E.x - Q.x,
      y: E.y - Q.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: _,
    active: O,
    activeNodeRect: Z,
    containerNodeRect: ie,
    draggingNodeRect: L,
    over: K.current.over,
    overlayNodeRect: Pe.rect,
    scrollableAncestors: ue,
    scrollableAncestorRects: Re,
    windowRect: xe
  }), Rt = ae ? wo(ae, E) : null, Ir = D2(ue), si = zd(Ir), ot = zd(Ir, [Z]), nt = wo(Je, si), pa = L ? e2(L, Je) : null, Aa = O && pa ? u({
    active: O,
    collisionRect: pa,
    droppableRects: X,
    droppableContainers: $,
    pointerCoordinates: Rt
  }) : null, La = Pu(Aa, "id"), [Bt, Yo] = j(null), Xo = B ? Je : wo(Je, ot), ua = KL(Xo, (l = Bt == null ? void 0 : Bt.rect) != null ? l : null, Z), po = ve(null), jt = be(
    ($e, Be) => {
      let {
        sensor: et,
        options: ee
      } = Be;
      if (z.current == null)
        return;
      const ce = M.get(z.current);
      if (!ce)
        return;
      const he = $e.nativeEvent, ze = new et({
        active: z.current,
        activeNode: ce,
        event: he,
        options: ee,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: K,
        onAbort(Ae) {
          if (!M.get(Ae))
            return;
          const {
            onDragAbort: Ve
          } = N.current, Ye = {
            id: Ae
          };
          Ve == null || Ve(Ye), k({
            type: "onDragAbort",
            event: Ye
          });
        },
        onPending(Ae, Ke, Ve, Ye) {
          if (!M.get(Ae))
            return;
          const {
            onDragPending: qo
          } = N.current, ya = {
            id: Ae,
            constraint: Ke,
            initialCoordinates: Ve,
            offset: Ye
          };
          qo == null || qo(ya), k({
            type: "onDragPending",
            event: ya
          });
        },
        onStart(Ae) {
          const Ke = z.current;
          if (Ke == null)
            return;
          const Ve = M.get(Ke);
          if (!Ve)
            return;
          const {
            onDragStart: Ye
          } = N.current, jo = {
            activatorEvent: he,
            active: {
              id: Ke,
              data: Ve.data,
              rect: P
            }
          };
          zr(() => {
            Ye == null || Ye(jo), T(ma.Initializing), v({
              type: He.DragStart,
              initialCoordinates: Ae,
              active: Ke
            }), k({
              type: "onDragStart",
              event: jo
            }), Y(po.current), H(he);
          });
        },
        onMove(Ae) {
          v({
            type: He.DragMove,
            coordinates: Ae
          });
        },
        onEnd: Ge(He.DragEnd),
        onCancel: Ge(He.DragCancel)
      });
      po.current = ze;
      function Ge(Ae) {
        return async function() {
          const {
            active: Ve,
            collisions: Ye,
            over: jo,
            scrollAdjustedTranslate: qo
          } = K.current;
          let ya = null;
          if (Ve && qo) {
            const {
              cancelDrop: Zo
            } = N.current;
            ya = {
              activatorEvent: he,
              active: Ve,
              collisions: Ye,
              delta: qo,
              over: jo
            }, Ae === He.DragEnd && typeof Zo == "function" && await Promise.resolve(Zo(ya)) && (Ae = He.DragCancel);
          }
          z.current = null, zr(() => {
            v({
              type: Ae
            }), T(ma.Uninitialized), Yo(null), Y(null), H(null), po.current = null;
            const Zo = Ae === He.DragEnd ? "onDragEnd" : "onDragCancel";
            if (ya) {
              const pi = N.current[Zo];
              pi == null || pi(ya), k({
                type: Zo,
                event: ya
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [M]
  ), ci = be(($e, Be) => (et, ee) => {
    const ce = et.nativeEvent, he = M.get(ee);
    if (
      // Another sensor is already instantiating
      z.current !== null || // No active draggable
      !he || // Event has already been captured
      ce.dndKit || ce.defaultPrevented
    )
      return;
    const ze = {
      active: he
    };
    $e(et, Be.options, ze) === !0 && (ce.dndKit = {
      capturedBy: Be.sensor
    }, z.current = ee, jt(et, Be));
  }, [M, jt]), Or = C2(y, ci);
  F2(y), _t(() => {
    Z && S === ma.Initializing && T(ma.Initialized);
  }, [Z, S]), ne(
    () => {
      const {
        onDragMove: $e
      } = N.current, {
        active: Be,
        activatorEvent: et,
        collisions: ee,
        over: ce
      } = K.current;
      if (!Be || !et)
        return;
      const he = {
        active: Be,
        activatorEvent: et,
        collisions: ee,
        delta: {
          x: nt.x,
          y: nt.y
        },
        over: ce
      };
      zr(() => {
        $e == null || $e(he), k({
          type: "onDragMove",
          event: he
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [nt.x, nt.y]
  ), ne(
    () => {
      const {
        active: $e,
        activatorEvent: Be,
        collisions: et,
        droppableContainers: ee,
        scrollAdjustedTranslate: ce
      } = K.current;
      if (!$e || z.current == null || !Be || !ce)
        return;
      const {
        onDragOver: he
      } = N.current, ze = ee.get(La), Ge = ze && ze.rect.current ? {
        id: ze.id,
        rect: ze.rect.current,
        data: ze.data,
        disabled: ze.disabled
      } : null, Ae = {
        active: $e,
        activatorEvent: Be,
        collisions: et,
        delta: {
          x: ce.x,
          y: ce.y
        },
        over: Ge
      };
      zr(() => {
        Yo(Ge), he == null || he(Ae), k({
          type: "onDragOver",
          event: Ae
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [La]
  ), _t(() => {
    K.current = {
      activatorEvent: _,
      active: O,
      activeNode: Se,
      collisionRect: pa,
      collisions: Aa,
      droppableRects: X,
      draggableNodes: M,
      draggingNode: G,
      draggingNodeRect: L,
      droppableContainers: F,
      over: Bt,
      scrollableAncestors: ue,
      scrollAdjustedTranslate: nt
    }, P.current = {
      initial: L,
      translated: pa
    };
  }, [O, Se, Aa, pa, M, G, L, X, F, Bt, ue, nt]), w2({
    ...q,
    delta: E,
    draggingRect: pa,
    pointerCoordinates: Rt,
    scrollableAncestors: ue,
    scrollableAncestorRects: Re
  });
  const Rr = fe(() => ({
    active: O,
    activeNode: Se,
    activeNodeRect: Z,
    activatorEvent: _,
    collisions: Aa,
    containerNodeRect: ie,
    dragOverlay: Pe,
    draggableNodes: M,
    droppableContainers: F,
    droppableRects: X,
    over: Bt,
    measureDroppableContainers: oe,
    scrollableAncestors: ue,
    scrollableAncestorRects: Re,
    measuringConfiguration: V,
    measuringScheduled: pe,
    windowRect: xe
  }), [O, Se, Z, _, Aa, ie, Pe, M, F, X, Bt, oe, ue, Re, V, pe, xe]), Br = fe(() => ({
    activatorEvent: _,
    activators: Or,
    active: O,
    activeNodeRect: Z,
    ariaDescribedById: {
      draggable: D
    },
    dispatch: v,
    draggableNodes: M,
    over: Bt,
    measureDroppableContainers: oe
  }), [_, Or, O, Z, v, D, M, Bt, oe]);
  return W.createElement(Su.Provider, {
    value: w
  }, W.createElement(Ul.Provider, {
    value: Br
  }, W.createElement(zu.Provider, {
    value: Rr
  }, W.createElement(Vu.Provider, {
    value: ua
  }, d)), W.createElement(U2, {
    disabled: (n == null ? void 0 : n.restoreFocus) === !1
  })), W.createElement(XL, {
    ...n,
    hiddenTextDescribedById: D
  }));
  function di() {
    const $e = (U == null ? void 0 : U.autoScrollEnabled) === !1, Be = typeof c == "object" ? c.enabled === !1 : c === !1, et = C && !$e && !Be;
    return typeof c == "object" ? {
      ...c,
      enabled: et
    } : {
      enabled: et
    };
  }
}), j2 = /* @__PURE__ */ xa(null), Wd = "button", q2 = "Draggable";
function Z2(e) {
  let {
    id: t,
    data: a,
    disabled: o = !1,
    attributes: r
  } = e;
  const l = Tr(q2), {
    activators: i,
    activatorEvent: n,
    active: c,
    activeNodeRect: d,
    ariaDescribedById: y,
    draggableNodes: u,
    over: h
  } = $t(Ul), {
    role: p = Wd,
    roleDescription: g = "draggable",
    tabIndex: m = 0
  } = r ?? {}, f = (c == null ? void 0 : c.id) === t, v = $t(f ? Vu : j2), [k, w] = xl(), [S, T] = xl(), C = I2(i, t), A = pr(a);
  _t(
    () => (u.set(t, {
      id: t,
      key: l,
      node: k,
      activatorNode: S,
      data: A
    }), () => {
      const E = u.get(t);
      E && E.key === l && u.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [u, t]
  );
  const M = fe(() => ({
    role: p,
    tabIndex: m,
    "aria-disabled": o,
    "aria-pressed": f && p === Wd ? !0 : void 0,
    "aria-roledescription": g,
    "aria-describedby": y.draggable
  }), [o, p, m, f, g, y.draggable]);
  return {
    active: c,
    activatorEvent: n,
    activeNodeRect: d,
    attributes: M,
    isDragging: f,
    listeners: o ? void 0 : C,
    node: k,
    over: h,
    setNodeRef: w,
    setActivatorNodeRef: T,
    transform: v
  };
}
function J2() {
  return $t(zu);
}
const K2 = "Droppable", Q2 = {
  timeout: 25
};
function eM(e) {
  let {
    data: t,
    disabled: a = !1,
    id: o,
    resizeObserverConfig: r
  } = e;
  const l = Tr(K2), {
    active: i,
    dispatch: n,
    over: c,
    measureDroppableContainers: d
  } = $t(Ul), y = ve({
    disabled: a
  }), u = ve(!1), h = ve(null), p = ve(null), {
    disabled: g,
    updateMeasurementsFor: m,
    timeout: f
  } = {
    ...Q2,
    ...r
  }, v = pr(m ?? o), k = be(
    () => {
      if (!u.current) {
        u.current = !0;
        return;
      }
      p.current != null && clearTimeout(p.current), p.current = setTimeout(() => {
        d(Array.isArray(v.current) ? v.current : [v.current]), p.current = null;
      }, f);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [f]
  ), w = Hl({
    callback: k,
    disabled: g || !i
  }), S = be((M, E) => {
    w && (E && (w.unobserve(E), u.current = !1), M && w.observe(M));
  }, [w]), [T, C] = xl(S), A = pr(t);
  return ne(() => {
    !w || !T.current || (w.disconnect(), u.current = !1, w.observe(T.current));
  }, [T, w]), ne(
    () => (n({
      type: He.RegisterDroppable,
      element: {
        id: o,
        key: l,
        disabled: a,
        node: T,
        rect: h,
        data: A
      }
    }), () => n({
      type: He.UnregisterDroppable,
      key: l,
      id: o
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [o]
  ), ne(() => {
    a !== y.current.disabled && (n({
      type: He.SetDroppableDisabled,
      id: o,
      key: l,
      disabled: a
    }), y.current.disabled = a);
  }, [o, l, a, n]), {
    active: i,
    rect: h,
    isOver: (c == null ? void 0 : c.id) === o,
    node: T,
    over: c,
    setNodeRef: C
  };
}
function Gl(e, t, a) {
  const o = e.slice();
  return o.splice(a < 0 ? o.length + a : a, 0, o.splice(t, 1)[0]), o;
}
function tM(e, t) {
  return e.reduce((a, o, r) => {
    const l = t.get(o);
    return l && (a[r] = l), a;
  }, Array(e.length));
}
function Kr(e) {
  return e !== null && e >= 0;
}
function aM(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let a = 0; a < e.length; a++)
    if (e[a] !== t[a])
      return !1;
  return !0;
}
function oM(e) {
  return typeof e == "boolean" ? {
    draggable: e,
    droppable: e
  } : e;
}
const $u = (e) => {
  let {
    rects: t,
    activeIndex: a,
    overIndex: o,
    index: r
  } = e;
  const l = Gl(t, o, a), i = t[r], n = l[r];
  return !n || !i ? null : {
    x: n.left - i.left,
    y: n.top - i.top,
    scaleX: n.width / i.width,
    scaleY: n.height / i.height
  };
}, Qr = {
  scaleX: 1,
  scaleY: 1
}, _u = (e) => {
  var t;
  let {
    activeIndex: a,
    activeNodeRect: o,
    index: r,
    rects: l,
    overIndex: i
  } = e;
  const n = (t = l[a]) != null ? t : o;
  if (!n)
    return null;
  if (r === a) {
    const d = l[i];
    return d ? {
      x: 0,
      y: a < i ? d.top + d.height - (n.top + n.height) : d.top - n.top,
      ...Qr
    } : null;
  }
  const c = rM(l, r, a);
  return r > a && r <= i ? {
    x: 0,
    y: -n.height - c,
    ...Qr
  } : r < a && r >= i ? {
    x: 0,
    y: n.height + c,
    ...Qr
  } : {
    x: 0,
    y: 0,
    ...Qr
  };
};
function rM(e, t, a) {
  const o = e[t], r = e[t - 1], l = e[t + 1];
  return o ? a < t ? r ? o.top - (r.top + r.height) : l ? l.top - (o.top + o.height) : 0 : l ? l.top - (o.top + o.height) : r ? o.top - (r.top + r.height) : 0 : 0;
}
const Hu = "Sortable", Uu = /* @__PURE__ */ W.createContext({
  activeIndex: -1,
  containerId: Hu,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: $u,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function Gu(e) {
  let {
    children: t,
    id: a,
    items: o,
    strategy: r = $u,
    disabled: l = !1
  } = e;
  const {
    active: i,
    dragOverlay: n,
    droppableRects: c,
    over: d,
    measureDroppableContainers: y
  } = J2(), u = Tr(Hu, a), h = n.rect !== null, p = fe(() => o.map((C) => typeof C == "object" && "id" in C ? C.id : C), [o]), g = i != null, m = i ? p.indexOf(i.id) : -1, f = d ? p.indexOf(d.id) : -1, v = ve(p), k = !aM(p, v.current), w = f !== -1 && m === -1 || k, S = oM(l);
  _t(() => {
    k && g && y(p);
  }, [k, p, g, y]), ne(() => {
    v.current = p;
  }, [p]);
  const T = fe(
    () => ({
      activeIndex: m,
      containerId: u,
      disabled: S,
      disableTransforms: w,
      items: p,
      overIndex: f,
      useDragOverlay: h,
      sortedRects: tM(p, c),
      strategy: r
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [m, u, S.draggable, S.droppable, w, p, f, c, h, r]
  );
  return W.createElement(Uu.Provider, {
    value: T
  }, t);
}
const lM = (e) => {
  let {
    id: t,
    items: a,
    activeIndex: o,
    overIndex: r
  } = e;
  return Gl(a, o, r).indexOf(t);
}, iM = (e) => {
  let {
    containerId: t,
    isSorting: a,
    wasDragging: o,
    index: r,
    items: l,
    newIndex: i,
    previousItems: n,
    previousContainerId: c,
    transition: d
  } = e;
  return !d || !o || n !== l && r === i ? !1 : a ? !0 : i !== r && t === c;
}, nM = {
  duration: 200,
  easing: "ease"
}, Yu = "transform", sM = /* @__PURE__ */ Po.Transition.toString({
  property: Yu,
  duration: 0,
  easing: "linear"
}), cM = {
  roleDescription: "sortable"
};
function dM(e) {
  let {
    disabled: t,
    index: a,
    node: o,
    rect: r
  } = e;
  const [l, i] = j(null), n = ve(a);
  return _t(() => {
    if (!t && a !== n.current && o.current) {
      const c = r.current;
      if (c) {
        const d = Wo(o.current, {
          ignoreTransform: !0
        }), y = {
          x: c.left - d.left,
          y: c.top - d.top,
          scaleX: c.width / d.width,
          scaleY: c.height / d.height
        };
        (y.x || y.y) && i(y);
      }
    }
    a !== n.current && (n.current = a);
  }, [t, a, o, r]), ne(() => {
    l && i(null);
  }, [l]), l;
}
function Xu(e) {
  let {
    animateLayoutChanges: t = iM,
    attributes: a,
    disabled: o,
    data: r,
    getNewIndex: l = lM,
    id: i,
    strategy: n,
    resizeObserverConfig: c,
    transition: d = nM
  } = e;
  const {
    items: y,
    containerId: u,
    activeIndex: h,
    disabled: p,
    disableTransforms: g,
    sortedRects: m,
    overIndex: f,
    useDragOverlay: v,
    strategy: k
  } = $t(Uu), w = pM(o, p), S = y.indexOf(i), T = fe(() => ({
    sortable: {
      containerId: u,
      index: S,
      items: y
    },
    ...r
  }), [u, r, S, y]), C = fe(() => y.slice(y.indexOf(i)), [y, i]), {
    rect: A,
    node: M,
    isOver: E,
    setNodeRef: F
  } = eM({
    id: i,
    data: T,
    disabled: w.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: C,
      ...c
    }
  }), {
    active: I,
    activatorEvent: P,
    activeNodeRect: O,
    attributes: z,
    setNodeRef: U,
    listeners: Y,
    isDragging: _,
    over: H,
    setActivatorNodeRef: N,
    transform: D
  } = Z2({
    id: i,
    data: T,
    attributes: {
      ...cM,
      ...a
    },
    disabled: w.draggable
  }), $ = IL(F, U), V = !!I, X = V && !g && Kr(h) && Kr(f), oe = !v && _, pe = oe && X ? D : null, ae = X ? pe ?? (n ?? k)({
    rects: m,
    activeNodeRect: O,
    activeIndex: h,
    overIndex: f,
    index: S
  }) : null, q = Kr(h) && Kr(f) ? l({
    id: i,
    items: y,
    activeIndex: h,
    overIndex: f
  }) : S, re = I == null ? void 0 : I.id, Z = ve({
    activeId: re,
    items: y,
    newIndex: q,
    containerId: u
  }), ie = y !== Z.current.items, K = t({
    active: I,
    containerId: u,
    isDragging: _,
    isSorting: V,
    id: i,
    index: S,
    items: y,
    newIndex: Z.current.newIndex,
    previousItems: Z.current.items,
    previousContainerId: Z.current.containerId,
    transition: d,
    wasDragging: Z.current.activeId != null
  }), se = dM({
    disabled: !K,
    index: S,
    node: M,
    rect: A
  });
  return ne(() => {
    V && Z.current.newIndex !== q && (Z.current.newIndex = q), u !== Z.current.containerId && (Z.current.containerId = u), y !== Z.current.items && (Z.current.items = y);
  }, [V, q, u, y]), ne(() => {
    if (re === Z.current.activeId)
      return;
    if (re != null && Z.current.activeId == null) {
      Z.current.activeId = re;
      return;
    }
    const G = setTimeout(() => {
      Z.current.activeId = re;
    }, 50);
    return () => clearTimeout(G);
  }, [re]), {
    active: I,
    activeIndex: h,
    attributes: z,
    data: T,
    rect: A,
    index: S,
    newIndex: q,
    items: y,
    isOver: E,
    isSorting: V,
    isDragging: _,
    listeners: Y,
    node: M,
    overIndex: f,
    over: H,
    setNodeRef: $,
    setActivatorNodeRef: N,
    setDroppableNodeRef: F,
    setDraggableNodeRef: U,
    transform: se ?? ae,
    transition: Pe()
  };
  function Pe() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      se || // Or to prevent items jumping to back to their "new" position when items change
      ie && Z.current.newIndex === S
    )
      return sM;
    if (!(oe && !Fs(P) || !d) && (V || K))
      return Po.Transition.toString({
        ...d,
        property: Yu
      });
  }
}
function pM(e, t) {
  var a, o;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (a = e == null ? void 0 : e.draggable) != null ? a : t.draggable,
    droppable: (o = e == null ? void 0 : e.droppable) != null ? o : t.droppable
  };
}
function Al(e) {
  if (!e)
    return !1;
  const t = e.data.current;
  return !!(t && "sortable" in t && typeof t.sortable == "object" && "containerId" in t.sortable && "items" in t.sortable && "index" in t.sortable);
}
const uM = [ke.Down, ke.Right, ke.Up, ke.Left], ju = (e, t) => {
  let {
    context: {
      active: a,
      collisionRect: o,
      droppableRects: r,
      droppableContainers: l,
      over: i,
      scrollableAncestors: n
    }
  } = t;
  if (uM.includes(e.code)) {
    if (e.preventDefault(), !a || !o)
      return;
    const c = [];
    l.getEnabled().forEach((u) => {
      if (!u || u != null && u.disabled)
        return;
      const h = r.get(u.id);
      if (h)
        switch (e.code) {
          case ke.Down:
            o.top < h.top && c.push(u);
            break;
          case ke.Up:
            o.top > h.top && c.push(u);
            break;
          case ke.Left:
            o.left > h.left && c.push(u);
            break;
          case ke.Right:
            o.left < h.left && c.push(u);
            break;
        }
    });
    const d = qL({
      collisionRect: o,
      droppableRects: r,
      droppableContainers: c
    });
    let y = Pu(d, "id");
    if (y === (i == null ? void 0 : i.id) && d.length > 1 && (y = d[1].id), y != null) {
      const u = l.get(a.id), h = l.get(y), p = h ? r.get(h.id) : null, g = h == null ? void 0 : h.node.current;
      if (g && p && u && h) {
        const f = Wl(g).some((C, A) => n[A] !== C), v = qu(u, h), k = yM(u, h), w = f || !v ? {
          x: 0,
          y: 0
        } : {
          x: k ? o.width - p.width : 0,
          y: k ? o.height - p.height : 0
        }, S = {
          x: p.left,
          y: p.top
        };
        return w.x && w.y ? S : ur(S, w);
      }
    }
  }
};
function qu(e, t) {
  return !Al(e) || !Al(t) ? !1 : e.data.current.sortable.containerId === t.data.current.sortable.containerId;
}
function yM(e, t) {
  return !Al(e) || !Al(t) || !qu(e, t) ? !1 : e.data.current.sortable.index < t.data.current.sortable.index;
}
function Zu(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (a = Zu(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function Yl() {
  for (var e, t, a = 0, o = "", r = arguments.length; a < r; a++) (e = arguments[a]) && (t = Zu(e)) && (o && (o += " "), o += t);
  return o;
}
const Rs = "-", hM = (e) => {
  const t = mM(e), {
    conflictingClassGroups: a,
    conflictingClassGroupModifiers: o
  } = e;
  return {
    getClassGroupId: (i) => {
      const n = i.split(Rs);
      return n[0] === "" && n.length !== 1 && n.shift(), Ju(n, t) || bM(i);
    },
    getConflictingClassGroupIds: (i, n) => {
      const c = a[i] || [];
      return n && o[i] ? [...c, ...o[i]] : c;
    }
  };
}, Ju = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const a = e[0], o = t.nextPart.get(a), r = o ? Ju(e.slice(1), o) : void 0;
  if (r)
    return r;
  if (t.validators.length === 0)
    return;
  const l = e.join(Rs);
  return (i = t.validators.find(({
    validator: n
  }) => n(l))) == null ? void 0 : i.classGroupId;
}, $d = /^\[(.+)\]$/, bM = (e) => {
  if ($d.test(e)) {
    const t = $d.exec(e)[1], a = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (a)
      return "arbitrary.." + a;
  }
}, mM = (e) => {
  const {
    theme: t,
    prefix: a
  } = e, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return fM(Object.entries(e.classGroups), a).forEach(([l, i]) => {
    Rn(i, o, l, t);
  }), o;
}, Rn = (e, t, a, o) => {
  e.forEach((r) => {
    if (typeof r == "string") {
      const l = r === "" ? t : _d(t, r);
      l.classGroupId = a;
      return;
    }
    if (typeof r == "function") {
      if (gM(r)) {
        Rn(r(o), t, a, o);
        return;
      }
      t.validators.push({
        validator: r,
        classGroupId: a
      });
      return;
    }
    Object.entries(r).forEach(([l, i]) => {
      Rn(i, _d(t, l), a, o);
    });
  });
}, _d = (e, t) => {
  let a = e;
  return t.split(Rs).forEach((o) => {
    a.nextPart.has(o) || a.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), a = a.nextPart.get(o);
  }), a;
}, gM = (e) => e.isThemeGetter, fM = (e, t) => t ? e.map(([a, o]) => {
  const r = o.map((l) => typeof l == "string" ? t + l : typeof l == "object" ? Object.fromEntries(Object.entries(l).map(([i, n]) => [t + i, n])) : l);
  return [a, r];
}) : e, vM = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  const r = (l, i) => {
    a.set(l, i), t++, t > e && (t = 0, o = a, a = /* @__PURE__ */ new Map());
  };
  return {
    get(l) {
      let i = a.get(l);
      if (i !== void 0)
        return i;
      if ((i = o.get(l)) !== void 0)
        return r(l, i), i;
    },
    set(l, i) {
      a.has(l) ? a.set(l, i) : r(l, i);
    }
  };
}, Ku = "!", kM = (e) => {
  const {
    separator: t,
    experimentalParseClassName: a
  } = e, o = t.length === 1, r = t[0], l = t.length, i = (n) => {
    const c = [];
    let d = 0, y = 0, u;
    for (let f = 0; f < n.length; f++) {
      let v = n[f];
      if (d === 0) {
        if (v === r && (o || n.slice(f, f + l) === t)) {
          c.push(n.slice(y, f)), y = f + l;
          continue;
        }
        if (v === "/") {
          u = f;
          continue;
        }
      }
      v === "[" ? d++ : v === "]" && d--;
    }
    const h = c.length === 0 ? n : n.substring(y), p = h.startsWith(Ku), g = p ? h.substring(1) : h, m = u && u > y ? u - y : void 0;
    return {
      modifiers: c,
      hasImportantModifier: p,
      baseClassName: g,
      maybePostfixModifierPosition: m
    };
  };
  return a ? (n) => a({
    className: n,
    parseClassName: i
  }) : i;
}, wM = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let a = [];
  return e.forEach((o) => {
    o[0] === "[" ? (t.push(...a.sort(), o), a = []) : a.push(o);
  }), t.push(...a.sort()), t;
}, SM = (e) => ({
  cache: vM(e.cacheSize),
  parseClassName: kM(e),
  ...hM(e)
}), xM = /\s+/, TM = (e, t) => {
  const {
    parseClassName: a,
    getClassGroupId: o,
    getConflictingClassGroupIds: r
  } = t, l = [], i = e.trim().split(xM);
  let n = "";
  for (let c = i.length - 1; c >= 0; c -= 1) {
    const d = i[c], {
      modifiers: y,
      hasImportantModifier: u,
      baseClassName: h,
      maybePostfixModifierPosition: p
    } = a(d);
    let g = !!p, m = o(g ? h.substring(0, p) : h);
    if (!m) {
      if (!g) {
        n = d + (n.length > 0 ? " " + n : n);
        continue;
      }
      if (m = o(h), !m) {
        n = d + (n.length > 0 ? " " + n : n);
        continue;
      }
      g = !1;
    }
    const f = wM(y).join(":"), v = u ? f + Ku : f, k = v + m;
    if (l.includes(k))
      continue;
    l.push(k);
    const w = r(m, g);
    for (let S = 0; S < w.length; ++S) {
      const T = w[S];
      l.push(v + T);
    }
    n = d + (n.length > 0 ? " " + n : n);
  }
  return n;
};
function CM() {
  let e = 0, t, a, o = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (a = Qu(t)) && (o && (o += " "), o += a);
  return o;
}
const Qu = (e) => {
  if (typeof e == "string")
    return e;
  let t, a = "";
  for (let o = 0; o < e.length; o++)
    e[o] && (t = Qu(e[o])) && (a && (a += " "), a += t);
  return a;
};
function Hd(e, ...t) {
  let a, o, r, l = i;
  function i(c) {
    const d = t.reduce((y, u) => u(y), e());
    return a = SM(d), o = a.cache.get, r = a.cache.set, l = n, n(c);
  }
  function n(c) {
    const d = o(c);
    if (d)
      return d;
    const y = TM(c, a);
    return r(c, y), y;
  }
  return function() {
    return l(CM.apply(null, arguments));
  };
}
const Le = (e) => {
  const t = (a) => a[e] || [];
  return t.isThemeGetter = !0, t;
}, ey = /^\[(?:([a-z-]+):)?(.+)\]$/i, PM = /^\d+\/\d+$/, AM = /* @__PURE__ */ new Set(["px", "full", "screen"]), LM = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, MM = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, NM = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, EM = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, DM = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, qt = (e) => So(e) || AM.has(e) || PM.test(e), ha = (e) => $o(e, "length", WM), So = (e) => !!e && !Number.isNaN(Number(e)), Ai = (e) => $o(e, "number", So), ar = (e) => !!e && Number.isInteger(Number(e)), FM = (e) => e.endsWith("%") && So(e.slice(0, -1)), de = (e) => ey.test(e), ba = (e) => LM.test(e), IM = /* @__PURE__ */ new Set(["length", "size", "percentage"]), OM = (e) => $o(e, IM, ty), RM = (e) => $o(e, "position", ty), BM = /* @__PURE__ */ new Set(["image", "url"]), zM = (e) => $o(e, BM, _M), VM = (e) => $o(e, "", $M), or = () => !0, $o = (e, t, a) => {
  const o = ey.exec(e);
  return o ? o[1] ? typeof t == "string" ? o[1] === t : t.has(o[1]) : a(o[2]) : !1;
}, WM = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  MM.test(e) && !NM.test(e)
), ty = () => !1, $M = (e) => EM.test(e), _M = (e) => DM.test(e), Ud = () => {
  const e = Le("colors"), t = Le("spacing"), a = Le("blur"), o = Le("brightness"), r = Le("borderColor"), l = Le("borderRadius"), i = Le("borderSpacing"), n = Le("borderWidth"), c = Le("contrast"), d = Le("grayscale"), y = Le("hueRotate"), u = Le("invert"), h = Le("gap"), p = Le("gradientColorStops"), g = Le("gradientColorStopPositions"), m = Le("inset"), f = Le("margin"), v = Le("opacity"), k = Le("padding"), w = Le("saturate"), S = Le("scale"), T = Le("sepia"), C = Le("skew"), A = Le("space"), M = Le("translate"), E = () => ["auto", "contain", "none"], F = () => ["auto", "hidden", "clip", "visible", "scroll"], I = () => ["auto", de, t], P = () => [de, t], O = () => ["", qt, ha], z = () => ["auto", So, de], U = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], Y = () => ["solid", "dashed", "dotted", "double", "none"], _ = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], H = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], N = () => ["", "0", de], D = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], $ = () => [So, de];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [or],
      spacing: [qt, ha],
      blur: ["none", "", ba, de],
      brightness: $(),
      borderColor: [e],
      borderRadius: ["none", "", "full", ba, de],
      borderSpacing: P(),
      borderWidth: O(),
      contrast: $(),
      grayscale: N(),
      hueRotate: $(),
      invert: N(),
      gap: P(),
      gradientColorStops: [e],
      gradientColorStopPositions: [FM, ha],
      inset: I(),
      margin: I(),
      opacity: $(),
      padding: P(),
      saturate: $(),
      scale: $(),
      sepia: N(),
      skew: $(),
      space: P(),
      translate: P()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", de]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ba]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": D()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": D()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...U(), de]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: F()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": F()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": F()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: E()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": E()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": E()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", ar, de]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: I()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", de]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: N()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: N()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", ar, de]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [or]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", ar, de]
        }, de]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": z()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": z()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [or]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [ar, de]
        }, de]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": z()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": z()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", de]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", de]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...H()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...H(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...H(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [k]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [k]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [k]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [k]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [k]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [k]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [k]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [k]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [k]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [f]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [f]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [f]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [f]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [f]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [f]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [f]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [f]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [f]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [A]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [A]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", de, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [de, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [de, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [ba]
        }, ba]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [de, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [de, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [de, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [de, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", ba, ha]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ai]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [or]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", de]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", So, Ai]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", qt, de]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", de]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", de]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Y(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", qt, ha]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", qt, de]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: P()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", de]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", de]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...U(), RM]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", OM]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, zM]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [l]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [l]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [l]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [l]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [l]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [l]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [l]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [l]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [l]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [l]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [l]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [l]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [l]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [l]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [l]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [n]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [n]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [n]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [n]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [n]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [n]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [n]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [n]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [n]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Y(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [n]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [n]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Y()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [r]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [r]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [r]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [r]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [r]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [r]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [r]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [r]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [r]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [r]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...Y()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [qt, de]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [qt, ha]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: O()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [qt, ha]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", ba, VM]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [or]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [..._(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": _()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [a]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", ba, de]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [d]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [y]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [u]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [T]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [a]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [d]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [y]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [u]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [T]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", de]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: $()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", de]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: $()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", de]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [S]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [S]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [S]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [ar, de]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [M]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [M]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [C]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [C]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", de]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", de]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": P()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": P()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": P()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": P()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": P()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": P()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": P()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": P()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": P()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": P()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": P()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": P()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": P()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": P()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": P()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": P()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": P()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": P()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", de]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [qt, ha, Ai]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, HM = (e, {
  cacheSize: t,
  prefix: a,
  separator: o,
  experimentalParseClassName: r,
  extend: l = {},
  override: i = {}
}) => {
  lr(e, "cacheSize", t), lr(e, "prefix", a), lr(e, "separator", o), lr(e, "experimentalParseClassName", r);
  for (const n in i)
    UM(e[n], i[n]);
  for (const n in l)
    GM(e[n], l[n]);
  return e;
}, lr = (e, t, a) => {
  a !== void 0 && (e[t] = a);
}, UM = (e, t) => {
  if (t)
    for (const a in t)
      lr(e, a, t[a]);
}, GM = (e, t) => {
  if (t)
    for (const a in t) {
      const o = t[a];
      o !== void 0 && (e[a] = (e[a] || []).concat(o));
    }
}, Bs = (e, ...t) => typeof e == "function" ? Hd(Ud, e, ...t) : Hd(() => HM(Ud(), e), ...t), YM = {
  card: "0 0 0 1px rgb(0 0 0 / 0.03), 0 1px 2px rgb(0 0 0 / 0.04), 0 4px 12px rgb(0 0 0 / 0.03)",
  dropdown: "0 0 0 1px rgb(0 0 0 / 0.06), 0 8px 24px rgb(0 0 0 / 0.12)",
  dialog: "0 20px 60px rgb(0 0 0 / 0.25)",
  z1: "0 1px 2px rgb(0 0 0 / 0.06)",
  z8: "0 4px 12px rgb(0 0 0 / 0.08)",
  bar: "0 8px 24px rgb(0 0 0 / 0.2)",
  button: "0 1px 0 rgb(0 0 0 / 0.05)"
}, XM = {
  display: ["1.75rem", { lineHeight: "2.125rem", fontWeight: "650" }],
  "heading-xl": ["1.625rem", { lineHeight: "2rem", fontWeight: "650" }],
  "heading-lg": ["1.25rem", { lineHeight: "1.5rem", fontWeight: "650" }],
  "heading-md": ["0.9375rem", { lineHeight: "1.25rem", fontWeight: "650" }],
  "body-md": ["0.875rem", { lineHeight: "1.25rem" }],
  micro: ["0.6875rem", { lineHeight: "0.875rem", fontWeight: "550" }],
  h1: ["1.75rem", { lineHeight: "2.125rem", fontWeight: "650" }],
  h2: ["1.625rem", { lineHeight: "2rem", fontWeight: "650" }],
  h3: ["1.25rem", { lineHeight: "1.5rem", fontWeight: "650" }],
  h4: ["1.0625rem", { lineHeight: "1.5rem", fontWeight: "650" }],
  h5: ["0.9375rem", { lineHeight: "1.25rem", fontWeight: "650" }],
  h6: ["0.9375rem", { lineHeight: "1.25rem", fontWeight: "650" }],
  subtitle1: ["0.875rem", { lineHeight: "1.25rem", fontWeight: "650" }],
  subtitle2: ["0.875rem", { lineHeight: "1.25rem", fontWeight: "550" }],
  body1: ["0.875rem", { lineHeight: "1.25rem" }],
  body2: ["0.875rem", { lineHeight: "1.25rem" }],
  caption: ["0.75rem", { lineHeight: "1rem" }],
  overline: ["0.6875rem", { lineHeight: "0.875rem", fontWeight: "550" }]
}, zs = {
  extend: {
    classGroups: {
      "font-size": [{ text: Object.keys(XM) }],
      shadow: [{ shadow: Object.keys(YM) }]
    }
  }
}, jM = Bs(zs);
function St(...e) {
  return jM(Yl(e));
}
var qM = Object.defineProperty, Vs = (e, t) => qM(e, "name", { value: t, configurable: !0 });
function Bn(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
Vs(Bn, "setRef");
function ay(...e) {
  return (t) => {
    let a = !1;
    const o = e.map((r) => {
      const l = Bn(r, t);
      return !a && typeof l == "function" && (a = !0), l;
    });
    if (a)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const l = o[r];
          typeof l == "function" ? l() : Bn(e[r], null);
        }
      };
  };
}
Vs(ay, "composeRefs");
function ye(...e) {
  return b.useCallback(ay(...e), e);
}
Vs(ye, "useComposedRefs");
var ZM = Object.defineProperty, It = (e, t) => ZM(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function Ht(e) {
  const t = b.forwardRef((a, o) => {
    let { children: r, ...l } = a, i = null, n = !1;
    const c = [];
    zn(r) && typeof el == "function" && (r = el(r._payload)), b.Children.forEach(r, (h) => {
      var p;
      if (iy(h)) {
        n = !0;
        const g = h;
        let m = "child" in g.props ? g.props.child : g.props.children;
        zn(m) && typeof el == "function" && (m = el(m._payload)), i = QM(g, m), c.push((p = i == null ? void 0 : i.props) == null ? void 0 : p.children);
      } else
        c.push(h);
    }), i ? i = b.cloneElement(i, void 0, c) : (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !n && b.Children.count(r) === 1 && b.isValidElement(r) && (i = r)
    );
    const d = i ? ly(i) : void 0, y = ye(o, d);
    if (!i) {
      if (r || r === 0)
        throw new Error(
          n ? aN(e) : tN(e)
        );
      return r;
    }
    const u = ry(l, i.props ?? {});
    return i.type !== b.Fragment && (u.ref = o ? y : d), b.cloneElement(i, u);
  });
  return t.displayName = `${e}.Slot`, t;
}
It(Ht, "createSlot");
var JM = /* @__PURE__ */ Ht("Slot"), oy = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function KM(e) {
  const t = /* @__PURE__ */ It((a) => "child" in a ? a.children(a.child) : a.children, "Slottable");
  return t.displayName = `${e}.Slottable`, t.__radixId = oy, t;
}
It(KM, "createSlottable");
var QM = /* @__PURE__ */ It((e, t) => {
  if ("child" in e.props) {
    const a = e.props.child;
    return b.isValidElement(a) ? b.cloneElement(a, void 0, e.props.children(a.props.children)) : null;
  }
  return b.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function ry(e, t) {
  const a = { ...t };
  for (const o in t) {
    const r = e[o], l = t[o];
    /^on[A-Z]/.test(o) ? r && l ? a[o] = (...n) => {
      const c = l(...n);
      return r(...n), c;
    } : r && (a[o] = r) : o === "style" ? a[o] = { ...r, ...l } : o === "className" && (a[o] = [r, l].filter(Boolean).join(" "));
  }
  return { ...e, ...a };
}
It(ry, "mergeProps");
function ly(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
It(ly, "getElementRef");
function iy(e) {
  return b.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === oy;
}
It(iy, "isSlottable");
var eN = Symbol.for("react.lazy");
function zn(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === eN && "_payload" in e && ny(e._payload);
}
It(zn, "isLazyComponent");
function ny(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
It(ny, "isPromiseLike");
var tN = /* @__PURE__ */ It((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), aN = /* @__PURE__ */ It((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), el = b[" use ".trim().toString()], oN = Object.defineProperty, rN = (e, t) => oN(e, "name", { value: t, configurable: !0 }), lN = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ge = lN.reduce((e, t) => {
  const a = /* @__PURE__ */ Ht(`Primitive.${t}`), o = b.forwardRef((r, l) => {
    const { asChild: i, ...n } = r, c = i ? a : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...n, ref: l });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function Ws(e, t) {
  e && wr.flushSync(() => e.dispatchEvent(t));
}
rN(Ws, "dispatchDiscreteCustomEvent");
var We = globalThis != null && globalThis.document ? b.useLayoutEffect : () => {
}, iN = Object.defineProperty, ta = (e, t) => iN(e, "name", { value: t, configurable: !0 });
function sy(e, t) {
  return b.useReducer((a, o) => t[a][o] ?? a, e);
}
ta(sy, "useStateMachine");
var bt = /* @__PURE__ */ ta((e) => {
  const { present: t, children: a } = e, o = cy(t), r = typeof a == "function" ? a({ present: o.isPresent }) : b.Children.only(a), l = dy(o.ref, py(r));
  return typeof a == "function" || o.isPresent ? b.cloneElement(r, { ref: l }) : null;
}, "Presence");
function cy(e) {
  const [t, a] = b.useState(), o = b.useRef(null), r = b.useRef(e), l = b.useRef("none"), i = b.useRef(void 0), n = e ? "mounted" : "unmounted", [c, d] = sy(n, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return b.useEffect(() => {
    c === "mounted" ? (l.current = i.current ?? vo(o.current), i.current = void 0) : l.current = "none";
  }, [c]), We(() => {
    const y = o.current, u = r.current;
    if (u !== e) {
      const p = l.current, g = vo(y);
      e ? (i.current = g, d("MOUNT")) : g === "none" || (y == null ? void 0 : y.display) === "none" ? d("UNMOUNT") : d(u && p !== g ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, d]), We(() => {
    if (t) {
      let y;
      const u = t.ownerDocument.defaultView ?? window, h = /* @__PURE__ */ ta((g) => {
        const f = vo(o.current).includes(CSS.escape(g.animationName));
        if (g.target === t && f && (d("ANIMATION_END"), !r.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", y = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, "handleAnimationEnd"), p = /* @__PURE__ */ ta((g) => {
        g.target === t && (l.current = vo(o.current));
      }, "handleAnimationStart");
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", h), t.addEventListener("animationend", h), () => {
        u.clearTimeout(y), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", h), t.removeEventListener("animationend", h);
      };
    } else
      d("ANIMATION_END");
  }, [t, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: b.useCallback((y) => {
      if (y) {
        const u = getComputedStyle(y);
        o.current = u, i.current = vo(u);
      } else
        o.current = null;
      a(y);
    }, [])
  };
}
ta(cy, "usePresence");
function Vn(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
ta(Vn, "setRef");
function dy(...e) {
  const t = b.useRef(e);
  return t.current = e, b.useCallback((a) => {
    const o = t.current;
    let r = !1;
    const l = o.map((i) => {
      const n = Vn(i, a);
      return !r && typeof n == "function" && (r = !0), n;
    });
    if (r)
      return () => {
        for (let i = 0; i < l.length; i++) {
          const n = l[i];
          typeof n == "function" ? n() : Vn(o[i], null);
        }
      };
  }, []);
}
ta(dy, "useStableComposedRefs");
function vo(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
ta(vo, "getAnimationName");
function py(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
ta(py, "getElementRef");
var nN = Object.defineProperty, pt = (e, t) => nN(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function sN(e, t) {
  const a = b.createContext(t);
  a.displayName = e + "Context";
  const o = /* @__PURE__ */ pt((l) => {
    const { children: i, ...n } = l, c = b.useMemo(() => n, Object.values(n));
    return /* @__PURE__ */ s(a.Provider, { value: c, children: i });
  }, "Provider");
  o.displayName = e + "Provider";
  function r(l, i = {}) {
    const { optional: n = !1 } = i, c = b.useContext(a);
    if (c) return c;
    if (t !== void 0) return t;
    if (!n)
      throw new Error(`\`${l}\` must be used within \`${e}\``);
  }
  return pt(r, "useContext"), [o, r];
}
pt(sN, "createContext");
// @__NO_SIDE_EFFECTS__
function Ot(e, t = []) {
  let a = [];
  function o(l, i) {
    const n = b.createContext(i);
    n.displayName = l + "Context";
    const c = a.length;
    a = [...a, i];
    const d = /* @__PURE__ */ pt((u) => {
      var v;
      const { scope: h, children: p, ...g } = u, m = ((v = h == null ? void 0 : h[e]) == null ? void 0 : v[c]) || n, f = b.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ s(m.Provider, { value: f, children: p });
    }, "Provider");
    d.displayName = l + "Provider";
    function y(u, h, p = {}) {
      var v;
      const { optional: g = !1 } = p, m = ((v = h == null ? void 0 : h[e]) == null ? void 0 : v[c]) || n, f = b.useContext(m);
      if (f) return f;
      if (i !== void 0) return i;
      if (!g)
        throw new Error(`\`${u}\` must be used within \`${l}\``);
    }
    return pt(y, "useContext"), [d, y];
  }
  pt(o, "createContext");
  const r = /* @__PURE__ */ pt(() => {
    const l = a.map((i) => b.createContext(i));
    return /* @__PURE__ */ pt(function(n) {
      const c = (n == null ? void 0 : n[e]) || l;
      return b.useMemo(
        () => ({ [`__scope${e}`]: { ...n, [e]: c } }),
        [n, c]
      );
    }, "useScope");
  }, "createScope");
  return r.scopeName = e, [o, uy(r, ...t)];
}
pt(Ot, "createContextScope");
function uy(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const a = /* @__PURE__ */ pt(() => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return /* @__PURE__ */ pt(function(l) {
      const i = o.reduce((n, { useScope: c, scopeName: d }) => {
        const u = c(l)[`__scope${d}`];
        return { ...n, ...u };
      }, {});
      return b.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    }, "useComposedScopes");
  }, "createScope");
  return a.scopeName = t.scopeName, a;
}
pt(uy, "composeContextScopes");
var cN = Object.defineProperty, dN = (e, t) => cN(e, "name", { value: t, configurable: !0 });
function Ue(e) {
  const t = b.useRef(e);
  return b.useEffect(() => {
    t.current = e;
  }), b.useMemo(() => ((...a) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...a);
  }), []);
}
dN(Ue, "useCallbackRef");
var pN = Object.defineProperty, uN = (e, t) => pN(e, "name", { value: t, configurable: !0 }), yN = b.createContext(void 0);
function Cr(e) {
  const t = b.useContext(yN);
  return e || t || "ltr";
}
uN(Cr, "useDirection");
var hN = Object.defineProperty, bN = (e, t) => hN(e, "name", { value: t, configurable: !0 });
function Ll(e, [t, a]) {
  return Math.min(a, Math.max(t, e));
}
bN(Ll, "clamp");
var mN = Object.defineProperty, _o = (e, t) => mN(e, "name", { value: t, configurable: !0 }), yy = !!(typeof window < "u" && window.document && window.document.createElement);
function J(e, t, { checkForDefaultPrevented: a = !0 } = {}) {
  return /* @__PURE__ */ _o(function(r) {
    if (e == null || e(r), a === !1 || !r || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  }, "handleEvent");
}
_o(J, "composeEventHandlers");
function gN(e) {
  var t;
  if (!yy)
    throw new Error("Cannot access window outside of the DOM");
  return ((t = e == null ? void 0 : e.ownerDocument) == null ? void 0 : t.defaultView) ?? window;
}
_o(gN, "getOwnerWindow");
function Wn(e) {
  if (!yy)
    throw new Error("Cannot access document outside of the DOM");
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
_o(Wn, "getOwnerDocument");
function hy(e, t = !1) {
  const { activeElement: a } = Wn(e);
  if (!(a != null && a.nodeName))
    return null;
  if (by(a) && a.contentDocument)
    return hy(a.contentDocument.body, t);
  if (t) {
    const o = a.getAttribute("aria-activedescendant");
    if (o) {
      const r = Wn(a).getElementById(o);
      if (r)
        return r;
    }
  }
  return a;
}
_o(hy, "getActiveElement");
function by(e) {
  return e.tagName === "IFRAME";
}
_o(by, "isFrame");
var fN = Object.defineProperty, me = (e, t) => fN(e, "name", { value: t, configurable: !0 });
function my(e, t) {
  return b.useReducer((a, o) => t[a][o] ?? a, e);
}
me(my, "useStateMachine");
var gy = "ScrollArea", [fy, IB] = /* @__PURE__ */ Ot(gy), [vN, mt] = fy(gy), kN = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ me(function(t, a) {
    const {
      __scopeScrollArea: o,
      type: r = "hover",
      dir: l,
      scrollHideDelay: i = 600,
      ...n
    } = t, [c, d] = b.useState(null), [y, u] = b.useState(null), [h, p] = b.useState(null), [g, m] = b.useState(null), [f, v] = b.useState(null), [k, w] = b.useState(0), [S, T] = b.useState(0), [C, A] = b.useState(!1), [M, E] = b.useState(!1), F = ye(a, d), I = Cr(l);
    return /* @__PURE__ */ s(
      vN,
      {
        scope: o,
        type: r,
        dir: I,
        scrollHideDelay: i,
        scrollArea: c,
        viewport: y,
        onViewportChange: u,
        content: h,
        onContentChange: p,
        scrollbarX: g,
        onScrollbarXChange: m,
        scrollbarXEnabled: C,
        onScrollbarXEnabledChange: A,
        scrollbarY: f,
        onScrollbarYChange: v,
        scrollbarYEnabled: M,
        onScrollbarYEnabledChange: E,
        onCornerWidthChange: w,
        onCornerHeightChange: T,
        children: /* @__PURE__ */ s(
          ge.div,
          {
            dir: I,
            ...n,
            ref: F,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": k + "px",
              "--radix-scroll-area-corner-height": S + "px",
              ...t.style
            }
          }
        )
      }
    );
  }, "ScrollArea")
), wN = "ScrollAreaViewport", SN = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ me(function(t, a) {
    const { __scopeScrollArea: o, children: r, nonce: l, ...i } = t, n = mt(wN, o), c = b.useRef(null), d = ye(a, c, n.onViewportChange);
    return /* @__PURE__ */ x(ut, { children: [
      /* @__PURE__ */ s(xN, { nonce: l }),
      /* @__PURE__ */ s(
        ge.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...i,
          ref: d,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: n.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: n.scrollbarYEnabled ? "scroll" : "hidden",
            ...t.style
          },
          children: /* @__PURE__ */ s("div", { ref: n.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }, "ScrollAreaViewport")
), xN = /* @__PURE__ */ b.memo(
  /* @__PURE__ */ me(function({ nonce: t }) {
    return /* @__PURE__ */ s(
      "style",
      {
        dangerouslySetInnerHTML: {
          __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
        },
        nonce: t
      }
    );
  }, "ScrollAreaViewportStyle"),
  (e, t) => e.nonce === t.nonce
), sa = "ScrollAreaScrollbar", vy = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ me(function(t, a) {
    const { forceMount: o, ...r } = t, l = mt(sa, t.__scopeScrollArea), { onScrollbarXEnabledChange: i, onScrollbarYEnabledChange: n } = l, c = t.orientation === "horizontal";
    return b.useEffect(() => (c ? i(!0) : n(!0), () => {
      c ? i(!1) : n(!1);
    }), [c, i, n]), l.type === "hover" ? /* @__PURE__ */ s(TN, { ...r, ref: a, forceMount: o }) : l.type === "scroll" ? /* @__PURE__ */ s(CN, { ...r, ref: a, forceMount: o }) : l.type === "auto" ? /* @__PURE__ */ s(ky, { ...r, ref: a, forceMount: o }) : l.type === "always" ? /* @__PURE__ */ s($s, { ...r, ref: a, "data-state": "visible" }) : null;
  }, "ScrollAreaScrollbar")
), TN = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ me(function(t, a) {
  const { forceMount: o, ...r } = t, l = mt(sa, t.__scopeScrollArea), [i, n] = b.useState(!1);
  return b.useEffect(() => {
    const c = l.scrollArea;
    let d = 0;
    if (c) {
      const y = /* @__PURE__ */ me(() => {
        window.clearTimeout(d), n(!0);
      }, "handlePointerEnter"), u = /* @__PURE__ */ me(() => {
        d = window.setTimeout(() => n(!1), l.scrollHideDelay);
      }, "handlePointerLeave");
      return c.addEventListener("pointerenter", y), c.addEventListener("pointerleave", u), () => {
        window.clearTimeout(d), c.removeEventListener("pointerenter", y), c.removeEventListener("pointerleave", u);
      };
    }
  }, [l.scrollArea, l.scrollHideDelay]), /* @__PURE__ */ s(bt, { present: o || i, children: /* @__PURE__ */ s(
    ky,
    {
      "data-state": i ? "visible" : "hidden",
      ...r,
      ref: a
    }
  ) });
}, "ScrollAreaScrollbarHover")), CN = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ me(function(t, a) {
  const { forceMount: o, ...r } = t, l = mt(sa, t.__scopeScrollArea), i = t.orientation === "horizontal", n = Ar(() => d("SCROLL_END"), 100), [c, d] = my("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return b.useEffect(() => {
    if (c === "idle") {
      const y = window.setTimeout(() => d("HIDE"), l.scrollHideDelay);
      return () => window.clearTimeout(y);
    }
  }, [c, l.scrollHideDelay, d]), b.useEffect(() => {
    const y = l.viewport, u = i ? "scrollLeft" : "scrollTop";
    if (y) {
      let h = y[u];
      const p = /* @__PURE__ */ me(() => {
        const g = y[u];
        h !== g && (d("SCROLL"), n()), h = g;
      }, "handleScroll");
      return y.addEventListener("scroll", p), () => y.removeEventListener("scroll", p);
    }
  }, [l.viewport, i, d, n]), /* @__PURE__ */ s(bt, { present: o || c !== "hidden", children: /* @__PURE__ */ s(
    $s,
    {
      "data-state": c === "hidden" ? "hidden" : "visible",
      ...r,
      ref: a,
      onPointerEnter: J(t.onPointerEnter, () => d("POINTER_ENTER")),
      onPointerLeave: J(t.onPointerLeave, () => d("POINTER_LEAVE"))
    }
  ) });
}, "ScrollAreaScrollbarScroll")), ky = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ me(function(t, a) {
  const o = mt(sa, t.__scopeScrollArea), { forceMount: r, ...l } = t, [i, n] = b.useState(!1), c = t.orientation === "horizontal", d = Ar(() => {
    if (o.viewport) {
      const y = o.viewport.offsetWidth < o.viewport.scrollWidth, u = o.viewport.offsetHeight < o.viewport.scrollHeight;
      n(c ? y : u);
    }
  }, 10);
  return Na(o.viewport, d), Na(o.content, d), /* @__PURE__ */ s(bt, { present: r || i, children: /* @__PURE__ */ s(
    $s,
    {
      "data-state": i ? "visible" : "hidden",
      ...l,
      ref: a
    }
  ) });
}, "ScrollAreaScrollbarAuto")), $s = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ me(function(t, a) {
  const { orientation: o = "vertical", ...r } = t, l = mt(sa, t.__scopeScrollArea), i = b.useRef(null), n = b.useRef(0), [c, d] = b.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), y = _s(c.viewport, c.content), u = {
    ...r,
    sizes: c,
    onSizesChange: d,
    hasThumb: y > 0 && y < 1,
    onThumbChange: /* @__PURE__ */ me((p) => i.current = p, "onThumbChange"),
    onThumbPointerUp: /* @__PURE__ */ me(() => n.current = 0, "onThumbPointerUp"),
    onThumbPointerDown: /* @__PURE__ */ me((p) => n.current = p, "onThumbPointerDown")
  };
  function h(p, g) {
    return Ty(p, n.current, c, g);
  }
  return me(h, "getScrollPosition"), o === "horizontal" ? /* @__PURE__ */ s(
    PN,
    {
      ...u,
      ref: a,
      onThumbPositionChange: () => {
        if (l.viewport && i.current) {
          const p = l.viewport.scrollLeft, g = _n(p, c, l.dir);
          i.current.style.transform = `translate3d(${g}px, 0, 0)`;
        }
      },
      onWheelScroll: (p) => {
        l.viewport && (l.viewport.scrollLeft = p);
      },
      onDragScroll: (p) => {
        l.viewport && (l.viewport.scrollLeft = h(p, l.dir));
      }
    }
  ) : o === "vertical" ? /* @__PURE__ */ s(
    AN,
    {
      ...u,
      ref: a,
      onThumbPositionChange: () => {
        if (l.viewport && i.current) {
          const p = l.viewport.scrollTop, g = _n(p, c);
          i.current.style.transform = `translate3d(0, ${g}px, 0)`;
        }
      },
      onWheelScroll: (p) => {
        l.viewport && (l.viewport.scrollTop = p);
      },
      onDragScroll: (p) => {
        l.viewport && (l.viewport.scrollTop = h(p));
      }
    }
  ) : null;
}, "ScrollAreaScrollbarVisible")), PN = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ me(function(t, a) {
  const { sizes: o, onSizesChange: r, ...l } = t, i = mt(sa, t.__scopeScrollArea), [n, c] = b.useState(), d = b.useRef(null), y = ye(a, d, i.onScrollbarXChange);
  return b.useEffect(() => {
    d.current && c(getComputedStyle(d.current));
  }, [d]), /* @__PURE__ */ s(
    Sy,
    {
      "data-orientation": "horizontal",
      ...l,
      ref: y,
      sizes: o,
      style: {
        bottom: 0,
        left: i.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: i.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Pr(o) + "px",
        ...t.style
      },
      onThumbPointerDown: (u) => t.onThumbPointerDown(u.x),
      onDragScroll: (u) => t.onDragScroll(u.x),
      onWheelScroll: (u, h) => {
        if (i.viewport) {
          const p = i.viewport.scrollLeft + u.deltaX;
          t.onWheelScroll(p), Us(p, h) && u.preventDefault();
        }
      },
      onResize: () => {
        d.current && i.viewport && n && r({
          content: i.viewport.scrollWidth,
          viewport: i.viewport.offsetWidth,
          scrollbar: {
            size: d.current.clientWidth,
            paddingStart: hr(n.paddingLeft),
            paddingEnd: hr(n.paddingRight)
          }
        });
      }
    }
  );
}, "ScrollAreaScrollbarX")), AN = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ me(function(t, a) {
  const { sizes: o, onSizesChange: r, ...l } = t, i = mt(sa, t.__scopeScrollArea), [n, c] = b.useState(), d = b.useRef(null), y = ye(a, d, i.onScrollbarYChange);
  return b.useEffect(() => {
    d.current && c(getComputedStyle(d.current));
  }, [d]), /* @__PURE__ */ s(
    Sy,
    {
      "data-orientation": "vertical",
      ...l,
      ref: y,
      sizes: o,
      style: {
        top: 0,
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Pr(o) + "px",
        ...t.style
      },
      onThumbPointerDown: (u) => t.onThumbPointerDown(u.y),
      onDragScroll: (u) => t.onDragScroll(u.y),
      onWheelScroll: (u, h) => {
        if (i.viewport) {
          const p = i.viewport.scrollTop + u.deltaY;
          t.onWheelScroll(p), Us(p, h) && u.preventDefault();
        }
      },
      onResize: () => {
        d.current && i.viewport && n && r({
          content: i.viewport.scrollHeight,
          viewport: i.viewport.offsetHeight,
          scrollbar: {
            size: d.current.clientHeight,
            paddingStart: hr(n.paddingTop),
            paddingEnd: hr(n.paddingBottom)
          }
        });
      }
    }
  );
}, "ScrollAreaScrollbarY")), [LN, wy] = fy(sa), Sy = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ me(function(t, a) {
  const {
    __scopeScrollArea: o,
    sizes: r,
    hasThumb: l,
    onThumbChange: i,
    onThumbPointerUp: n,
    onThumbPointerDown: c,
    onThumbPositionChange: d,
    onDragScroll: y,
    onWheelScroll: u,
    onResize: h,
    ...p
  } = t, g = mt(sa, o), [m, f] = b.useState(null), v = ye(a, f), k = b.useRef(null), w = b.useRef(""), S = g.viewport, T = r.content - r.viewport, C = Ue(u), A = Ue(d), M = Ar(h, 10);
  function E(F) {
    if (k.current) {
      const I = F.clientX - k.current.left, P = F.clientY - k.current.top;
      y({ x: I, y: P });
    }
  }
  return me(E, "handleDragScroll"), b.useEffect(() => {
    const F = /* @__PURE__ */ me((I) => {
      const P = I.target;
      (m == null ? void 0 : m.contains(P)) && C(I, T);
    }, "handleWheel");
    return document.addEventListener("wheel", F, { passive: !1 }), () => document.removeEventListener("wheel", F, { passive: !1 });
  }, [S, m, T, C]), b.useEffect(A, [r, A]), Na(m, M), Na(g.content, M), /* @__PURE__ */ s(
    LN,
    {
      scope: o,
      scrollbar: m,
      hasThumb: l,
      onThumbChange: Ue(i),
      onThumbPointerUp: Ue(n),
      onThumbPositionChange: A,
      onThumbPointerDown: Ue(c),
      children: /* @__PURE__ */ s(
        ge.div,
        {
          ...p,
          ref: v,
          style: { position: "absolute", ...p.style },
          onPointerDown: J(t.onPointerDown, (F) => {
            F.button === 0 && (F.target.setPointerCapture(F.pointerId), k.current = m.getBoundingClientRect(), w.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", g.viewport && (g.viewport.style.scrollBehavior = "auto"), E(F));
          }),
          onPointerMove: J(t.onPointerMove, E),
          onPointerUp: J(t.onPointerUp, (F) => {
            const I = F.target;
            I.hasPointerCapture(F.pointerId) && I.releasePointerCapture(F.pointerId), document.body.style.webkitUserSelect = w.current, g.viewport && (g.viewport.style.scrollBehavior = ""), k.current = null;
          })
        }
      )
    }
  );
}, "ScrollAreaScrollbarImpl")), $n = "ScrollAreaThumb", MN = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ me(function(t, a) {
    const { forceMount: o, ...r } = t, l = wy($n, t.__scopeScrollArea);
    return /* @__PURE__ */ s(bt, { present: o || l.hasThumb, children: /* @__PURE__ */ s(NN, { ref: a, ...r }) });
  }, "ScrollAreaThumb")
), NN = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ me(function(t, a) {
    const { __scopeScrollArea: o, style: r, ...l } = t, i = mt($n, o), n = wy($n, o), { onThumbPositionChange: c } = n, d = ye(a, n.onThumbChange), y = b.useRef(void 0), u = Ar(() => {
      y.current && (y.current(), y.current = void 0);
    }, 100);
    return b.useEffect(() => {
      const h = i.viewport;
      if (h) {
        const p = /* @__PURE__ */ me(() => {
          if (u(), !y.current) {
            const g = FN(h, c);
            y.current = g, c();
          }
        }, "handleScroll");
        return c(), h.addEventListener("scroll", p), () => h.removeEventListener("scroll", p);
      }
    }, [i.viewport, u, c]), /* @__PURE__ */ s(
      ge.div,
      {
        "data-state": n.hasThumb ? "visible" : "hidden",
        ...l,
        ref: d,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: J(t.onPointerDownCapture, (h) => {
          const g = h.target.getBoundingClientRect(), m = h.clientX - g.left, f = h.clientY - g.top;
          n.onThumbPointerDown({ x: m, y: f });
        }),
        onPointerUp: J(t.onPointerUp, n.onThumbPointerUp)
      }
    );
  }, "ScrollAreaThumbImpl")
), xy = "ScrollAreaCorner", EN = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ me(function(t, a) {
    const o = mt(xy, t.__scopeScrollArea), r = !!(o.scrollbarX && o.scrollbarY);
    return o.type !== "scroll" && r ? /* @__PURE__ */ s(DN, { ...t, ref: a }) : null;
  }, "ScrollAreaCorner")
), DN = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ me(function(t, a) {
  const { __scopeScrollArea: o, ...r } = t, l = mt(xy, o), [i, n] = b.useState(0), [c, d] = b.useState(0), y = !!(i && c), { onCornerWidthChange: u, onCornerHeightChange: h } = l;
  return Na(l.scrollbarX, () => {
    var g;
    const p = ((g = l.scrollbarX) == null ? void 0 : g.offsetHeight) || 0;
    l.onCornerHeightChange(p), d(p);
  }), Na(l.scrollbarY, () => {
    var g;
    const p = ((g = l.scrollbarY) == null ? void 0 : g.offsetWidth) || 0;
    l.onCornerWidthChange(p), n(p);
  }), b.useEffect(() => () => {
    u(0), h(0);
  }, [u, h]), y ? /* @__PURE__ */ s(
    ge.div,
    {
      ...r,
      ref: a,
      style: {
        width: i,
        height: c,
        position: "absolute",
        right: l.dir === "ltr" ? 0 : void 0,
        left: l.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...t.style
      }
    }
  ) : null;
}, "ScrollAreaCornerImpl"));
function hr(e) {
  return e ? parseInt(e, 10) : 0;
}
me(hr, "toInt");
function _s(e, t) {
  const a = e / t;
  return isNaN(a) ? 0 : a;
}
me(_s, "getThumbRatio");
function Pr(e) {
  const t = _s(e.viewport, e.content), a = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - a) * t;
  return Math.max(o, 18);
}
me(Pr, "getThumbSize");
function Ty(e, t, a, o = "ltr") {
  const r = Pr(a), l = r / 2, i = t || l, n = r - i, c = a.scrollbar.paddingStart + i, d = a.scrollbar.size - a.scrollbar.paddingEnd - n, y = a.content - a.viewport, u = o === "ltr" ? [0, y] : [y * -1, 0];
  return Hs([c, d], u)(e);
}
me(Ty, "getScrollPositionFromPointer");
function _n(e, t, a = "ltr") {
  const o = Pr(t), r = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, l = t.scrollbar.size - r, i = t.content - t.viewport, n = l - o, c = a === "ltr" ? [0, i] : [i * -1, 0], d = Ll(e, c);
  return Hs([0, i], [0, n])(d);
}
me(_n, "getThumbOffsetFromScroll");
function Hs(e, t) {
  return (a) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (a - e[0]);
  };
}
me(Hs, "linearScale");
function Us(e, t) {
  return e > 0 && e < t;
}
me(Us, "isScrollingWithinScrollbarBounds");
var FN = /* @__PURE__ */ me((e, t = () => {
}) => {
  let a = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return (/* @__PURE__ */ me((function r() {
    const l = { left: e.scrollLeft, top: e.scrollTop }, i = a.left !== l.left, n = a.top !== l.top;
    (i || n) && t(), a = l, o = window.requestAnimationFrame(r);
  }), "loop"))(), () => window.cancelAnimationFrame(o);
}, "addUnlinkedScrollListener");
function Ar(e, t) {
  const a = Ue(e), o = b.useRef(0);
  return b.useEffect(() => () => window.clearTimeout(o.current), []), b.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(a, t);
  }, [a, t]);
}
me(Ar, "useDebounceCallback");
function Na(e, t) {
  const a = Ue(t);
  We(() => {
    let o = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(a);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(o), r.unobserve(e);
      };
    }
  }, [e, a]);
}
me(Na, "useResizeObserver");
var Cy = kN, IN = SN, ON = EN;
const RN = Bs(zs);
function Ce(...e) {
  return RN(Yl(e));
}
const ao = b.forwardRef(({ className: e, children: t, ...a }, o) => /* @__PURE__ */ x(
  Cy,
  {
    ref: o,
    className: Ce("relative overflow-hidden", e),
    ...a,
    children: [
      /* @__PURE__ */ s(IN, { className: "h-full w-full rounded-[inherit]", children: t }),
      /* @__PURE__ */ s(Py, {}),
      /* @__PURE__ */ s(ON, {})
    ]
  }
));
ao.displayName = Cy.displayName;
const Py = b.forwardRef(({ className: e, orientation: t = "vertical", ...a }, o) => /* @__PURE__ */ s(
  vy,
  {
    ref: o,
    orientation: t,
    className: Ce(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...a,
    children: /* @__PURE__ */ s(MN, { className: "relative flex-1 rounded-full bg-border" })
  }
));
Py.displayName = vy.displayName;
const BN = (e, t) => Object.entries(e ?? {}).filter(([a, o]) => t[a] && Array.isArray(o) && o.length > 0).map(([a, o]) => `${o.length} ${t[a].toLowerCase()}`).join(" · "), zN = (e, t) => {
  const a = (e == null ? void 0 : e.variants.find((o) => o.id === t)) ?? (e == null ? void 0 : e.variants[0]);
  return Object.fromEntries([...(e == null ? void 0 : e.commonFields) ?? [], ...(a == null ? void 0 : a.fields) ?? []].filter((o) => o.type === "array").map((o) => [o.key, o.label]));
}, VN = (e, t) => {
  const a = e == null ? void 0 : e.variants.find((o) => o.id === t);
  return a ? a.label.replace(/^V\d+\s*[—-]\s*/, "").replace(/^V\d+\s*\((.*)\)$/, "$1") : `${t} (not in this theme)`;
}, WN = ({ section: e, label: t, lists: a, layout: o, isSelected: r, onSelect: l, onToggleActive: i, onRemove: n, onDuplicate: c, onMove: d }) => {
  const { attributes: y, listeners: u, setNodeRef: h, transform: p, transition: g, isDragging: m } = Xu({ id: e.id }), f = { transform: Po.Transform.toString(p), transition: g, zIndex: m ? 50 : "auto" };
  return /* @__PURE__ */ x(
    "div",
    {
      ref: h,
      style: f,
      role: "listitem",
      className: St(
        "group relative flex cursor-pointer items-center gap-1.5 rounded-md px-1.5 py-1.5 transition-colors",
        r ? "bg-selected text-ink" : "text-ink hover:bg-subdued",
        m && "opacity-50 shadow-card"
      ),
      onClick: () => l(e.id),
      children: [
        /* @__PURE__ */ s("div", { ...y, ...u, className: "shrink-0 cursor-grab p-0.5 text-faint active:cursor-grabbing", children: /* @__PURE__ */ s(bu, { className: "size-3.5" }) }),
        /* @__PURE__ */ x("div", { className: "min-w-0 flex-1", children: [
          /* @__PURE__ */ s("p", { className: St("truncate text-sm font-medium", e.isActive === !1 && "text-faint line-through"), children: t }),
          /* @__PURE__ */ s("p", { className: "truncate text-xs text-muted-foreground", children: BN(e.props, a) || o })
        ] }),
        /* @__PURE__ */ x("div", { className: "flex shrink-0 items-center opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100", children: [
          /* @__PURE__ */ s("button", { className: "grid size-6 place-items-center rounded-md text-muted-foreground hover:bg-fill hover:text-ink", "aria-label": "Move up", title: "Move up (Alt+↑)", onClick: (v) => {
            v.stopPropagation(), d(e.id, -1);
          }, children: /* @__PURE__ */ s(pu, { className: "size-3.5" }) }),
          /* @__PURE__ */ s("button", { className: "grid size-6 place-items-center rounded-md text-muted-foreground hover:bg-fill hover:text-ink", "aria-label": "Move down", title: "Move down (Alt+↓)", onClick: (v) => {
            v.stopPropagation(), d(e.id, 1);
          }, children: /* @__PURE__ */ s(du, { className: "size-3.5" }) }),
          /* @__PURE__ */ s("button", { className: "grid size-6 place-items-center rounded-md text-muted-foreground hover:bg-fill hover:text-ink", "aria-label": "Duplicate", title: "Duplicate", onClick: (v) => {
            v.stopPropagation(), c(e.id);
          }, children: /* @__PURE__ */ s(iA, { className: "size-3.5" }) }),
          /* @__PURE__ */ s(
            "button",
            {
              "aria-label": e.isActive !== !1 ? "Hide section" : "Show section",
              className: "grid size-6 place-items-center rounded-md text-muted-foreground transition-colors hover:bg-fill hover:text-ink",
              onClick: (v) => {
                v.stopPropagation(), i(e.id, e.isActive !== !1);
              },
              children: e.isActive !== !1 ? /* @__PURE__ */ s(dA, { className: "size-3.5" }) : /* @__PURE__ */ s(cA, { className: "size-3.5" })
            }
          ),
          /* @__PURE__ */ s(
            "button",
            {
              "aria-label": "Remove section",
              className: "grid size-6 place-items-center rounded-md text-error transition-colors hover:bg-error-lighter",
              onClick: (v) => {
                v.stopPropagation(), n(e.id);
              },
              children: /* @__PURE__ */ s(Co, { className: "size-3.5" })
            }
          )
        ] })
      ]
    }
  );
}, $N = ({ selectedPage: e, selectedSectionId: t, onSelectSection: a }) => {
  var f;
  const { localSettings: o, removeSection: r, updateSection: l, reorderSections: i, duplicateSection: n, moveSection: c, schemas: d } = at(), y = (f = o == null ? void 0 : o.pages) == null ? void 0 : f[e], u = (y == null ? void 0 : y.sections) || [], h = xu(
    Cl(_l),
    Cl($l, { coordinateGetter: ju })
  ), p = (v, k) => {
    l(e, v, (w) => ({ ...w, isActive: !k }));
  }, g = (v) => {
    const { active: k, over: w } = v;
    if (w && k.id !== w.id) {
      const S = u.findIndex((C) => C.id === k.id), T = u.findIndex((C) => C.id === w.id);
      i(e, Gl(u, S, T));
    }
  }, m = (v) => {
    r(e, v), t === v && a(null);
  };
  return /* @__PURE__ */ s(ao, { className: "h-full", children: /* @__PURE__ */ x("div", { className: "px-2 pb-3", children: [
    /* @__PURE__ */ s(Wu, { sensors: h, collisionDetection: Au, onDragEnd: g, children: /* @__PURE__ */ s(Gu, { items: u.map((v) => v.id), strategy: _u, children: /* @__PURE__ */ s("div", { className: "space-y-0.5", role: "list", "aria-label": "Page sections", children: u.map((v) => {
      var k, w, S, T;
      return /* @__PURE__ */ s(
        WN,
        {
          section: v,
          isSelected: t === v.id,
          onSelect: a,
          onToggleActive: p,
          onRemove: m,
          label: ((w = (k = d.componentSchemas) == null ? void 0 : k[v.type]) == null ? void 0 : w.label) ?? v.type,
          lists: zN((S = d.componentSchemas) == null ? void 0 : S[v.type], v.variant),
          layout: VN((T = d.componentSchemas) == null ? void 0 : T[v.type], v.variant),
          onDuplicate: (C) => {
            const A = n(e, C);
            A && a(A);
          },
          onMove: (C, A) => c(e, C, A)
        },
        v.id
      );
    }) }) }) }),
    u.length === 0 && /* @__PURE__ */ x("div", { className: "flex flex-col items-center justify-center px-4 py-10 text-center", children: [
      /* @__PURE__ */ s("span", { className: "mb-3 grid size-12 place-items-center rounded-full bg-subdued", children: /* @__PURE__ */ s(Sl, { className: "size-5 text-faint" }) }),
      /* @__PURE__ */ s("p", { className: "text-sm font-medium text-ink", children: "Showing the default layout" }),
      /* @__PURE__ */ s("p", { className: "mt-1 text-xs text-muted-foreground", children: "This page uses the theme's built-in sections. Add a section below, or pick a page template in Library, to customize it." })
    ] })
  ] }) });
}, Gd = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Yd = Yl, Gs = (e, t) => (a) => {
  var o;
  if ((t == null ? void 0 : t.variants) == null) return Yd(e, a == null ? void 0 : a.class, a == null ? void 0 : a.className);
  const { variants: r, defaultVariants: l } = t, i = Object.keys(r).map((d) => {
    const y = a == null ? void 0 : a[d], u = l == null ? void 0 : l[d];
    if (y === null) return null;
    const h = Gd(y) || Gd(u);
    return r[d][h];
  }), n = a && Object.entries(a).reduce((d, y) => {
    let [u, h] = y;
    return h === void 0 || (d[u] = h), d;
  }, {}), c = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((d, y) => {
    let { class: u, className: h, ...p } = y;
    return Object.entries(p).every((g) => {
      let [m, f] = g;
      return Array.isArray(f) ? f.includes({
        ...l,
        ...n
      }[m]) : {
        ...l,
        ...n
      }[m] === f;
    }) ? [
      ...d,
      u,
      h
    ] : d;
  }, []);
  return Yd(e, i, c, a == null ? void 0 : a.class, a == null ? void 0 : a.className);
}, _N = Gs(
  "inline-flex shrink-0 select-none items-center justify-center gap-1.5 whitespace-nowrap rounded-md text-sm font-medium transition-[color,background-color,border-color,box-shadow] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        /** The main action on a page. */
        default: "bg-primary text-primary-foreground shadow-button hover:bg-primary-hover",
        /** Same as default; kept for call sites that asked for a dark "+ New …" action. */
        dark: "bg-primary text-primary-foreground shadow-button hover:bg-primary-hover",
        /** Grey fill ("Add product", "Discard"). */
        secondary: "bg-fill text-ink hover:bg-fill-hover",
        /** White with a hairline ("Manage", "Cancel"). */
        outline: "border border-input bg-card text-ink hover:bg-subdued",
        ghost: "text-ink hover:bg-fill",
        /** Grey fill; the old brand tint has no Shopify equivalent. */
        soft: "bg-fill text-ink hover:bg-fill-hover",
        destructive: "bg-destructive text-destructive-foreground shadow-button hover:bg-error-dark",
        link: "h-auto px-0 text-link underline-offset-4 hover:underline"
      },
      size: {
        default: "h-8 px-3",
        sm: "h-7 px-2.5 text-xs",
        lg: "h-9 px-4",
        icon: "size-8",
        "icon-sm": "size-7"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), le = b.forwardRef(
  ({ className: e, variant: t, size: a, asChild: o = !1, ...r }, l) => /* @__PURE__ */ s(o ? JM : "button", { className: Ce(_N({ variant: t, size: a, className: e })), ref: l, ...r })
);
le.displayName = "Button";
var HN = Object.defineProperty, UN = (e, t) => HN(e, "name", { value: t, configurable: !0 }), GN = b[" useId ".trim().toString()] || (() => {
}), YN = 0;
function Jt(e) {
  const [t, a] = b.useState(GN());
  return We(() => {
    e || a((o) => o ?? String(YN++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
UN(Jt, "useId");
var XN = Object.defineProperty, jN = (e, t) => XN(e, "name", { value: t, configurable: !0 }), Xd = b[" useEffectEvent ".trim().toString()], jd = b[" useInsertionEffect ".trim().toString()];
function Ay(e) {
  if (typeof Xd == "function")
    return Xd(e);
  const t = b.useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return typeof jd == "function" ? jd(() => {
    t.current = e;
  }) : We(() => {
    t.current = e;
  }), b.useMemo(() => ((...a) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...a);
  }), []);
}
jN(Ay, "useEffectEvent");
var qN = Object.defineProperty, Lr = (e, t) => qN(e, "name", { value: t, configurable: !0 }), ZN = b[" useInsertionEffect ".trim().toString()] || We;
function Ea({
  prop: e,
  defaultProp: t,
  onChange: a = /* @__PURE__ */ Lr(() => {
  }, "onChange"),
  caller: o
}) {
  const [r, l, i] = Ly({
    defaultProp: t,
    onChange: a
  }), n = e !== void 0, c = n ? e : r, d = b.useCallback(
    (y) => {
      var u;
      if (n) {
        const h = My(y) ? y(e) : y;
        h !== e && ((u = i.current) == null || u.call(i, h));
      } else
        l(y);
    },
    [n, e, l, i]
  );
  return [c, d];
}
Lr(Ea, "useControllableState");
function Ly({
  defaultProp: e,
  onChange: t
}) {
  const [a, o] = b.useState(e), r = b.useRef(a), l = b.useRef(t);
  return ZN(() => {
    l.current = t;
  }, [t]), b.useEffect(() => {
    var i;
    r.current !== a && ((i = l.current) == null || i.call(l, a), r.current = a);
  }, [a, r]), [a, o, l];
}
Lr(Ly, "useUncontrolledState");
function My(e) {
  return typeof e == "function";
}
Lr(My, "isFunction");
var qd = Symbol("RADIX:SYNC_STATE");
function JN(e, t, a, o) {
  const { prop: r, defaultProp: l, onChange: i, caller: n } = t, c = r !== void 0, d = Ay(i), y = [{ ...a, state: l }];
  o && y.push(o);
  const [u, h] = b.useReducer(
    (f, v) => {
      if (v.type === qd)
        return { ...f, state: v.state };
      const k = e(f, v);
      return c && !Object.is(k.state, f.state) && d(k.state), k;
    },
    ...y
  ), p = u.state, g = b.useRef(p);
  b.useEffect(() => {
    g.current !== p && (g.current = p, c || d(p));
  }, [p, g, c]);
  const m = b.useMemo(() => r !== void 0 ? { ...u, state: r } : u, [u, r]);
  return b.useEffect(() => {
    c && !Object.is(r, u.state) && h({ type: qd, state: r });
  }, [r, u.state, c]), [m, h];
}
Lr(JN, "useControllableStateReducer");
var KN = Object.defineProperty, je = (e, t) => KN(e, "name", { value: t, configurable: !0 }), Hn = "dismissableLayer.update", QN = "dismissableLayer.pointerDownOutside", eE = "dismissableLayer.focusOutside", Zd, Ny = b.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set(),
  // Outside elements that belong to a layer's own dismiss affordance (eg, a
  // dialog overlay). Pressing them should dismiss the layer regardless of
  // whether or not they stop propagation.
  //
  // See https://github.com/radix-ui/primitives/issues/3346
  dismissableSurfaces: /* @__PURE__ */ new Set()
}), Ys = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ je(function(t, a) {
    const {
      disableOutsidePointerEvents: o = !1,
      deferPointerDownOutside: r = !1,
      onEscapeKeyDown: l,
      onPointerDownOutside: i,
      onFocusOutside: n,
      onInteractOutside: c,
      onDismiss: d,
      ...y
    } = t, u = b.useContext(Ny), [h, p] = b.useState(null), g = (h == null ? void 0 : h.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = b.useState({}), f = ye(a, p), v = Array.from(u.layers), [k] = [
      ...u.layersWithOutsidePointerEventsDisabled
    ].slice(-1), w = k ? v.indexOf(k) : -1, S = h ? v.indexOf(h) : -1, T = u.layersWithOutsidePointerEventsDisabled.size > 0, C = S >= w, A = b.useRef(!1), M = Dy(
      (P) => {
        i == null || i(P), c == null || c(P), P.defaultPrevented || d == null || d();
      },
      {
        ownerDocument: g,
        deferPointerDownOutside: r,
        isDeferredPointerDownOutsideRef: A,
        dismissableSurfaces: u.dismissableSurfaces,
        shouldHandlePointerDownOutside: b.useCallback(
          (P) => {
            if (!(P instanceof Node))
              return !1;
            const O = [...u.branches].some(
              (z) => z.contains(P)
            );
            return C && !O;
          },
          [u.branches, C]
        )
      }
    ), E = Fy((P) => {
      if (r && A.current)
        return;
      const O = P.target;
      [...u.branches].some((U) => U.contains(O)) || (n == null || n(P), c == null || c(P), P.defaultPrevented || d == null || d());
    }, g), F = h ? S === v.length - 1 : !1, I = Ue((P) => {
      P.key === "Escape" && (l == null || l(P), !P.defaultPrevented && d && (P.preventDefault(), d()));
    });
    return b.useEffect(() => {
      if (F)
        return g.addEventListener("keydown", I, { capture: !0 }), () => g.removeEventListener("keydown", I, { capture: !0 });
    }, [g, F, I]), b.useEffect(() => {
      if (h)
        return o && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Zd = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(h)), u.layers.add(h), Un(), () => {
          o && (u.layersWithOutsidePointerEventsDisabled.delete(h), u.layersWithOutsidePointerEventsDisabled.size === 0 && (g.body.style.pointerEvents = Zd));
        };
    }, [h, g, o, u]), b.useEffect(() => () => {
      h && (u.layers.delete(h), u.layersWithOutsidePointerEventsDisabled.delete(h), Un());
    }, [h, u]), b.useEffect(() => {
      const P = /* @__PURE__ */ je(() => m({}), "handleUpdate");
      return document.addEventListener(Hn, P), () => document.removeEventListener(Hn, P);
    }, []), /* @__PURE__ */ s(
      ge.div,
      {
        ...y,
        ref: f,
        style: {
          pointerEvents: T ? C ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: J(t.onFocusCapture, E.onFocusCapture),
        onBlurCapture: J(t.onBlurCapture, E.onBlurCapture),
        onPointerDownCapture: J(
          t.onPointerDownCapture,
          M.onPointerDownCapture
        )
      }
    );
  }, "DismissableLayer")
);
function Ey() {
  const e = b.useContext(Ny), [t, a] = b.useState(null);
  return b.useEffect(() => {
    if (t)
      return e.dismissableSurfaces.add(t), () => {
        e.dismissableSurfaces.delete(t);
      };
  }, [t, e.dismissableSurfaces]), a;
}
je(Ey, "useDismissableLayerSurface");
var tE = /* @__PURE__ */ je(() => !0, "IS_TRUE");
function Dy(e, t) {
  const {
    ownerDocument: a = globalThis == null ? void 0 : globalThis.document,
    deferPointerDownOutside: o = !1,
    isDeferredPointerDownOutsideRef: r,
    dismissableSurfaces: l,
    shouldHandlePointerDownOutside: i = tE
  } = t, n = Ue(e), c = b.useRef(!1), d = b.useRef(!1), y = b.useRef(/* @__PURE__ */ new Map()), u = b.useRef(() => {
  });
  return b.useEffect(() => {
    function h() {
      d.current = !1, r.current = !1, y.current.clear();
    }
    je(h, "resetOutsideInteraction");
    function p() {
      return Array.from(y.current.values()).some(Boolean);
    }
    je(p, "isOutsideInteractionIntercepted");
    function g(w) {
      if (!d.current)
        return;
      const S = w.target;
      S instanceof Node && [...l].some((C) => C.contains(S)) || y.current.set(w.type, !0), w.type === "click" && window.setTimeout(() => {
        d.current && u.current();
      }, 0);
    }
    je(g, "handleInteractionCapture");
    function m(w) {
      d.current && y.current.set(w.type, !1);
    }
    je(m, "handleInteractionBubble");
    const f = /* @__PURE__ */ je((w) => {
      if (w.target && !c.current) {
        let S = function() {
          a.removeEventListener("click", u.current);
          const C = p();
          h(), C || Xs(
            QN,
            n,
            T,
            { discrete: !0 }
          );
        };
        if (je(S, "handleAndDispatchPointerDownOutsideEvent"), !i(w.target)) {
          a.removeEventListener("click", u.current), h(), c.current = !1;
          return;
        }
        const T = { originalEvent: w };
        d.current = !0, r.current = o && w.button === 0, y.current.clear(), !o || w.button !== 0 ? S() : (a.removeEventListener("click", u.current), u.current = S, a.addEventListener("click", u.current, { once: !0 }));
      } else
        a.removeEventListener("click", u.current), h();
      c.current = !1;
    }, "handlePointerDown"), v = [
      "pointerup",
      "mousedown",
      "mouseup",
      "touchstart",
      "touchend",
      "click"
    ];
    for (const w of v)
      a.addEventListener(w, g, !0), a.addEventListener(w, m);
    const k = window.setTimeout(() => {
      a.addEventListener("pointerdown", f);
    }, 0);
    return () => {
      window.clearTimeout(k), a.removeEventListener("pointerdown", f), a.removeEventListener("click", u.current);
      for (const w of v)
        a.removeEventListener(w, g, !0), a.removeEventListener(w, m);
    };
  }, [
    a,
    n,
    o,
    r,
    l,
    i
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: /* @__PURE__ */ je(() => c.current = !0, "onPointerDownCapture")
  };
}
je(Dy, "usePointerDownOutside");
function Fy(e, t = globalThis == null ? void 0 : globalThis.document) {
  const a = Ue(e), o = b.useRef(!1);
  return b.useEffect(() => {
    const r = /* @__PURE__ */ je((l) => {
      l.target && !o.current && Xs(eE, a, { originalEvent: l }, {
        discrete: !1
      });
    }, "handleFocus");
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, a]), {
    onFocusCapture: /* @__PURE__ */ je(() => o.current = !0, "onFocusCapture"),
    onBlurCapture: /* @__PURE__ */ je(() => o.current = !1, "onBlurCapture")
  };
}
je(Fy, "useFocusOutside");
function Un() {
  const e = new CustomEvent(Hn);
  document.dispatchEvent(e);
}
je(Un, "dispatchUpdate");
function Xs(e, t, a, { discrete: o }) {
  const r = a.originalEvent.target, l = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: a });
  t && r.addEventListener(e, t, { once: !0 }), o ? Ws(r, l) : r.dispatchEvent(l);
}
je(Xs, "handleAndDispatchCustomEvent");
var aE = Object.defineProperty, tt = (e, t) => aE(e, "name", { value: t, configurable: !0 }), Li = "focusScope.autoFocusOnMount", Mi = "focusScope.autoFocusOnUnmount", Jd = { bubbles: !1, cancelable: !0 }, js = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ tt(function(t, a) {
    const {
      loop: o = !1,
      trapped: r = !1,
      onMountAutoFocus: l,
      onUnmountAutoFocus: i,
      ...n
    } = t, [c, d] = b.useState(null), y = Ue(l), u = Ue(i), h = b.useRef(null), p = ye(a, d), g = b.useRef({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }).current;
    b.useEffect(() => {
      if (r) {
        let f = function(S) {
          if (g.paused || !c) return;
          const T = S.target;
          c.contains(T) ? h.current = T : Zt(h.current, { select: !0 });
        }, v = function(S) {
          if (g.paused || !c) return;
          const T = S.relatedTarget;
          T !== null && (c.contains(T) || Zt(h.current, { select: !0 }));
        }, k = function(S) {
          if (document.activeElement === document.body)
            for (const C of S)
              C.removedNodes.length > 0 && Zt(c);
        };
        tt(f, "handleFocusIn"), tt(v, "handleFocusOut"), tt(k, "handleMutations"), document.addEventListener("focusin", f), document.addEventListener("focusout", v);
        const w = new MutationObserver(k);
        return c && w.observe(c, { childList: !0, subtree: !0 }), () => {
          document.removeEventListener("focusin", f), document.removeEventListener("focusout", v), w.disconnect();
        };
      }
    }, [r, c, g.paused]), b.useEffect(() => {
      if (c) {
        Kd.add(g);
        const f = document.activeElement;
        if (!c.contains(f)) {
          const k = new CustomEvent(Li, Jd);
          c.addEventListener(Li, y), c.dispatchEvent(k), k.defaultPrevented || (Iy(Vy(qs(c)), { select: !0 }), document.activeElement === f && Zt(c));
        }
        return () => {
          c.removeEventListener(Li, y), setTimeout(() => {
            const k = new CustomEvent(Mi, Jd);
            c.addEventListener(Mi, u), c.dispatchEvent(k), k.defaultPrevented || Zt(f ?? document.body, { select: !0 }), c.removeEventListener(Mi, u), Kd.remove(g);
          }, 0);
        };
      }
    }, [c, y, u, g]);
    const m = b.useCallback(
      (f) => {
        if (!o && !r || g.paused) return;
        const v = f.key === "Tab" && !f.altKey && !f.ctrlKey && !f.metaKey, k = document.activeElement;
        if (v && k) {
          const w = f.currentTarget, [S, T] = Oy(w);
          S && T ? !f.shiftKey && k === T ? (f.preventDefault(), o && Zt(S, { select: !0 })) : f.shiftKey && k === S && (f.preventDefault(), o && Zt(T, { select: !0 })) : k === w && f.preventDefault();
        }
      },
      [o, r, g.paused]
    );
    return /* @__PURE__ */ s(ge.div, { tabIndex: -1, ...n, ref: p, onKeyDown: m });
  }, "FocusScope")
);
function Iy(e, { select: t = !1 } = {}) {
  const a = document.activeElement;
  for (const o of e)
    if (Zt(o, { select: t }), document.activeElement !== a) return;
}
tt(Iy, "focusFirst");
function Oy(e) {
  const t = qs(e), a = Gn(t, e), o = Gn(t.reverse(), e);
  return [a, o];
}
tt(Oy, "getTabbableEdges");
function qs(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: /* @__PURE__ */ tt((o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }, "acceptNode")
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
tt(qs, "getTabbableCandidates");
function Gn(e, t) {
  const a = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
  for (const o of e)
    if (!(a ? !o.checkVisibility({ checkVisibilityCSS: !0 }) : Ry(o, { upTo: t })))
      return o;
}
tt(Gn, "findVisible");
function Ry(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
tt(Ry, "isHidden");
function By(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
tt(By, "isSelectableInput");
function Zt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const a = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== a && By(e) && t && e.select();
  }
}
tt(Zt, "focus");
var Kd = zy();
function zy() {
  let e = [];
  return {
    add(t) {
      const a = e[0];
      t !== a && (a == null || a.pause()), e = Yn(e, t), e.unshift(t);
    },
    remove(t) {
      var a;
      e = Yn(e, t), (a = e[0]) == null || a.resume();
    }
  };
}
tt(zy, "createFocusScopesStack");
function Yn(e, t) {
  const a = [...e], o = a.indexOf(t);
  return o !== -1 && a.splice(o, 1), a;
}
tt(Yn, "arrayRemove");
function Vy(e) {
  return e.filter((t) => t.tagName !== "A");
}
tt(Vy, "removeLinks");
var oE = Object.defineProperty, rE = (e, t) => oE(e, "name", { value: t, configurable: !0 }), Zs = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ rE(function(t, a) {
    var c;
    const { container: o, ...r } = t, [l, i] = b.useState(!1);
    We(() => i(!0), []);
    const n = o || l && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
    return n ? wr.createPortal(/* @__PURE__ */ s(ge.div, { ...r, ref: a }), n) : null;
  }, "Portal")
), lE = Object.defineProperty, Js = (e, t) => lE(e, "name", { value: t, configurable: !0 }), tl = 0, zt = null;
function iE(e) {
  return Mr(), e.children;
}
Js(iE, "FocusGuards");
function Mr() {
  b.useEffect(() => {
    zt || (zt = { start: Xn(), end: Xn() });
    const { start: e, end: t } = zt;
    return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), tl++, () => {
      tl === 1 && (zt == null || zt.start.remove(), zt == null || zt.end.remove(), zt = null), tl = Math.max(0, tl - 1);
    };
  }, []);
}
Js(Mr, "useFocusGuards");
function Xn() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
Js(Xn, "createFocusGuard");
var Vt = function() {
  return Vt = Object.assign || function(t) {
    for (var a, o = 1, r = arguments.length; o < r; o++) {
      a = arguments[o];
      for (var l in a) Object.prototype.hasOwnProperty.call(a, l) && (t[l] = a[l]);
    }
    return t;
  }, Vt.apply(this, arguments);
};
function Wy(e, t) {
  var a = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (a[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (a[o[r]] = e[o[r]]);
  return a;
}
function nE(e, t, a) {
  if (a || arguments.length === 2) for (var o = 0, r = t.length, l; o < r; o++)
    (l || !(o in t)) && (l || (l = Array.prototype.slice.call(t, 0, o)), l[o] = t[o]);
  return e.concat(l || Array.prototype.slice.call(t));
}
var pl = "right-scroll-bar-position", ul = "width-before-scroll-bar", sE = "with-scroll-bars-hidden", cE = "--removed-body-scroll-bar-size";
function Ni(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function dE(e, t) {
  var a = j(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return a.value;
        },
        set current(o) {
          var r = a.value;
          r !== o && (a.value = o, a.callback(o, r));
        }
      }
    };
  })[0];
  return a.callback = t, a.facade;
}
var pE = typeof window < "u" ? b.useLayoutEffect : b.useEffect, Qd = /* @__PURE__ */ new WeakMap();
function uE(e, t) {
  var a = dE(null, function(o) {
    return e.forEach(function(r) {
      return Ni(r, o);
    });
  });
  return pE(function() {
    var o = Qd.get(a);
    if (o) {
      var r = new Set(o), l = new Set(e), i = a.current;
      r.forEach(function(n) {
        l.has(n) || Ni(n, null);
      }), l.forEach(function(n) {
        r.has(n) || Ni(n, i);
      });
    }
    Qd.set(a, e);
  }, [e]), a;
}
function yE(e) {
  return e;
}
function hE(e, t) {
  t === void 0 && (t = yE);
  var a = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return a.length ? a[a.length - 1] : e;
    },
    useMedium: function(l) {
      var i = t(l, o);
      return a.push(i), function() {
        a = a.filter(function(n) {
          return n !== i;
        });
      };
    },
    assignSyncMedium: function(l) {
      for (o = !0; a.length; ) {
        var i = a;
        a = [], i.forEach(l);
      }
      a = {
        push: function(n) {
          return l(n);
        },
        filter: function() {
          return a;
        }
      };
    },
    assignMedium: function(l) {
      o = !0;
      var i = [];
      if (a.length) {
        var n = a;
        a = [], n.forEach(l), i = a;
      }
      var c = function() {
        var y = i;
        i = [], y.forEach(l);
      }, d = function() {
        return Promise.resolve().then(c);
      };
      d(), a = {
        push: function(y) {
          i.push(y), d();
        },
        filter: function(y) {
          return i = i.filter(y), a;
        }
      };
    }
  };
  return r;
}
function bE(e) {
  e === void 0 && (e = {});
  var t = hE(null);
  return t.options = Vt({ async: !0, ssr: !1 }, e), t;
}
var $y = function(e) {
  var t = e.sideCar, a = Wy(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return b.createElement(o, Vt({}, a));
};
$y.isSideCarExport = !0;
function mE(e, t) {
  return e.useMedium(t), $y;
}
var _y = bE(), Ei = function() {
}, Xl = b.forwardRef(function(e, t) {
  var a = b.useRef(null), o = b.useState({
    onScrollCapture: Ei,
    onWheelCapture: Ei,
    onTouchMoveCapture: Ei
  }), r = o[0], l = o[1], i = e.forwardProps, n = e.children, c = e.className, d = e.removeScrollBar, y = e.enabled, u = e.shards, h = e.sideCar, p = e.noRelative, g = e.noIsolation, m = e.inert, f = e.allowPinchZoom, v = e.as, k = v === void 0 ? "div" : v, w = e.gapMode, S = Wy(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), T = h, C = uE([a, t]), A = Vt(Vt({}, S), r);
  return b.createElement(
    b.Fragment,
    null,
    y && b.createElement(T, { sideCar: _y, removeScrollBar: d, shards: u, noRelative: p, noIsolation: g, inert: m, setCallbacks: l, allowPinchZoom: !!f, lockRef: a, gapMode: w }),
    i ? b.cloneElement(b.Children.only(n), Vt(Vt({}, A), { ref: C })) : b.createElement(k, Vt({}, A, { className: c, ref: C }), n)
  );
});
Xl.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Xl.classNames = {
  fullWidth: ul,
  zeroRight: pl
};
var gE = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function fE() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = gE();
  return t && e.setAttribute("nonce", t), e;
}
function vE(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function kE(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var wE = function() {
  var e = 0, t = null;
  return {
    add: function(a) {
      e == 0 && (t = fE()) && (vE(t, a), kE(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, SE = function() {
  var e = wE();
  return function(t, a) {
    b.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && a]);
  };
}, Hy = function() {
  var e = SE(), t = function(a) {
    var o = a.styles, r = a.dynamic;
    return e(o, r), null;
  };
  return t;
}, xE = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Di = function(e) {
  return parseInt(e || "", 10) || 0;
}, TE = function(e) {
  var t = window.getComputedStyle(document.body), a = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Di(a), Di(o), Di(r)];
}, CE = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return xE;
  var t = TE(e), a = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - a + t[2] - t[0])
  };
}, PE = Hy(), xo = "data-scroll-locked", AE = function(e, t, a, o) {
  var r = e.left, l = e.top, i = e.right, n = e.gap;
  return a === void 0 && (a = "margin"), `
  .`.concat(sE, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(n, "px ").concat(o, `;
  }
  body[`).concat(xo, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    a === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(l, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(n, "px ").concat(o, `;
    `),
    a === "padding" && "padding-right: ".concat(n, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(pl, ` {
    right: `).concat(n, "px ").concat(o, `;
  }
  
  .`).concat(ul, ` {
    margin-right: `).concat(n, "px ").concat(o, `;
  }
  
  .`).concat(pl, " .").concat(pl, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(ul, " .").concat(ul, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(xo, `] {
    `).concat(cE, ": ").concat(n, `px;
  }
`);
}, ep = function() {
  var e = parseInt(document.body.getAttribute(xo) || "0", 10);
  return isFinite(e) ? e : 0;
}, LE = function() {
  b.useEffect(function() {
    return document.body.setAttribute(xo, (ep() + 1).toString()), function() {
      var e = ep() - 1;
      e <= 0 ? document.body.removeAttribute(xo) : document.body.setAttribute(xo, e.toString());
    };
  }, []);
}, ME = function(e) {
  var t = e.noRelative, a = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o;
  LE();
  var l = b.useMemo(function() {
    return CE(r);
  }, [r]);
  return b.createElement(PE, { styles: AE(l, !t, r, a ? "" : "!important") });
}, jn = !1;
if (typeof window < "u")
  try {
    var al = Object.defineProperty({}, "passive", {
      get: function() {
        return jn = !0, !0;
      }
    });
    window.addEventListener("test", al, al), window.removeEventListener("test", al, al);
  } catch {
    jn = !1;
  }
var mo = jn ? { passive: !1 } : !1, NE = function(e) {
  return e.tagName === "TEXTAREA";
}, Uy = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var a = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    a[t] !== "hidden" && // contains scroll inside self
    !(a.overflowY === a.overflowX && !NE(e) && a[t] === "visible")
  );
}, EE = function(e) {
  return Uy(e, "overflowY");
}, DE = function(e) {
  return Uy(e, "overflowX");
}, tp = function(e, t) {
  var a = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var r = Gy(e, o);
    if (r) {
      var l = Yy(e, o), i = l[1], n = l[2];
      if (i > n)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== a.body);
  return !1;
}, FE = function(e) {
  var t = e.scrollTop, a = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    a,
    o
  ];
}, IE = function(e) {
  var t = e.scrollLeft, a = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    a,
    o
  ];
}, Gy = function(e, t) {
  return e === "v" ? EE(t) : DE(t);
}, Yy = function(e, t) {
  return e === "v" ? FE(t) : IE(t);
}, OE = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, RE = function(e, t, a, o, r) {
  var l = OE(e, window.getComputedStyle(t).direction), i = l * o, n = a.target, c = t.contains(n), d = !1, y = i > 0, u = 0, h = 0;
  do {
    if (!n)
      break;
    var p = Yy(e, n), g = p[0], m = p[1], f = p[2], v = m - f - l * g;
    (g || v) && Gy(e, n) && (u += v, h += g);
    var k = n.parentNode;
    n = k && k.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? k.host : k;
  } while (
    // portaled content
    !c && n !== document.body || // self content
    c && (t.contains(n) || t === n)
  );
  return (y && Math.abs(u) < 1 || !y && Math.abs(h) < 1) && (d = !0), d;
}, ol = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ap = function(e) {
  return [e.deltaX, e.deltaY];
}, op = function(e) {
  return e && "current" in e ? e.current : e;
}, BE = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, zE = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, VE = 0, go = [];
function WE(e) {
  var t = b.useRef([]), a = b.useRef([0, 0]), o = b.useRef(), r = b.useState(VE++)[0], l = b.useState(Hy)[0], i = b.useRef(e);
  b.useEffect(function() {
    i.current = e;
  }, [e]), b.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var m = nE([e.lockRef.current], (e.shards || []).map(op), !0).filter(Boolean);
      return m.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), m.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var n = b.useCallback(function(m, f) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !i.current.allowPinchZoom;
    var v = ol(m), k = a.current, w = "deltaX" in m ? m.deltaX : k[0] - v[0], S = "deltaY" in m ? m.deltaY : k[1] - v[1], T, C = m.target, A = Math.abs(w) > Math.abs(S) ? "h" : "v";
    if ("touches" in m && A === "h" && C.type === "range")
      return !1;
    var M = window.getSelection(), E = M && M.anchorNode, F = E ? E === C || E.contains(C) : !1;
    if (F)
      return !1;
    var I = tp(A, C);
    if (!I)
      return !0;
    if (I ? T = A : (T = A === "v" ? "h" : "v", I = tp(A, C)), !I)
      return !1;
    if (!o.current && "changedTouches" in m && (w || S) && (o.current = T), !T)
      return !0;
    var P = o.current || T;
    return RE(P, f, m, P === "h" ? w : S);
  }, []), c = b.useCallback(function(m) {
    var f = m;
    if (!(!go.length || go[go.length - 1] !== l)) {
      var v = "deltaY" in f ? ap(f) : ol(f), k = t.current.filter(function(T) {
        return T.name === f.type && (T.target === f.target || f.target === T.shadowParent) && BE(T.delta, v);
      })[0];
      if (k && k.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!k) {
        var w = (i.current.shards || []).map(op).filter(Boolean).filter(function(T) {
          return T.contains(f.target);
        }), S = w.length > 0 ? n(f, w[0]) : !i.current.noIsolation;
        S && f.cancelable && f.preventDefault();
      }
    }
  }, []), d = b.useCallback(function(m, f, v, k) {
    var w = { name: m, delta: f, target: v, should: k, shadowParent: $E(v) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== w;
      });
    }, 1);
  }, []), y = b.useCallback(function(m) {
    a.current = ol(m), o.current = void 0;
  }, []), u = b.useCallback(function(m) {
    d(m.type, ap(m), m.target, n(m, e.lockRef.current));
  }, []), h = b.useCallback(function(m) {
    d(m.type, ol(m), m.target, n(m, e.lockRef.current));
  }, []);
  b.useEffect(function() {
    return go.push(l), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, mo), document.addEventListener("touchmove", c, mo), document.addEventListener("touchstart", y, mo), function() {
      go = go.filter(function(m) {
        return m !== l;
      }), document.removeEventListener("wheel", c, mo), document.removeEventListener("touchmove", c, mo), document.removeEventListener("touchstart", y, mo);
    };
  }, []);
  var p = e.removeScrollBar, g = e.inert;
  return b.createElement(
    b.Fragment,
    null,
    g ? b.createElement(l, { styles: zE(r) }) : null,
    p ? b.createElement(ME, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function $E(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const _E = mE(_y, WE);
var jl = b.forwardRef(function(e, t) {
  return b.createElement(Xl, Vt({}, e, { ref: t, sideCar: _E }));
});
jl.classNames = Xl.classNames;
var HE = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, fo = /* @__PURE__ */ new WeakMap(), rl = /* @__PURE__ */ new WeakMap(), ll = {}, Fi = 0, Xy = function(e) {
  return e && (e.host || Xy(e.parentNode));
}, UE = function(e, t) {
  return t.map(function(a) {
    if (e.contains(a))
      return a;
    var o = Xy(a);
    return o && e.contains(o) ? o : (console.error("aria-hidden", a, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(a) {
    return !!a;
  });
}, GE = function(e, t, a, o) {
  var r = UE(t, Array.isArray(e) ? e : [e]);
  ll[a] || (ll[a] = /* @__PURE__ */ new WeakMap());
  var l = ll[a], i = [], n = /* @__PURE__ */ new Set(), c = new Set(r), d = function(u) {
    !u || n.has(u) || (n.add(u), d(u.parentNode));
  };
  r.forEach(d);
  var y = function(u) {
    !u || c.has(u) || Array.prototype.forEach.call(u.children, function(h) {
      if (n.has(h))
        y(h);
      else
        try {
          var p = h.getAttribute(o), g = p !== null && p !== "false", m = (fo.get(h) || 0) + 1, f = (l.get(h) || 0) + 1;
          fo.set(h, m), l.set(h, f), i.push(h), m === 1 && g && rl.set(h, !0), f === 1 && h.setAttribute(a, "true"), g || h.setAttribute(o, "true");
        } catch (v) {
          console.error("aria-hidden: cannot operate on ", h, v);
        }
    });
  };
  return y(t), n.clear(), Fi++, function() {
    i.forEach(function(u) {
      var h = fo.get(u) - 1, p = l.get(u) - 1;
      fo.set(u, h), l.set(u, p), h || (rl.has(u) || u.removeAttribute(o), rl.delete(u)), p || u.removeAttribute(a);
    }), Fi--, Fi || (fo = /* @__PURE__ */ new WeakMap(), fo = /* @__PURE__ */ new WeakMap(), rl = /* @__PURE__ */ new WeakMap(), ll = {});
  };
}, Ks = function(e, t, a) {
  a === void 0 && (a = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), r = HE(e);
  return r ? (o.push.apply(o, Array.from(r.querySelectorAll("[aria-live], script"))), GE(o, r, a, "aria-hidden")) : function() {
    return null;
  };
}, YE = Object.defineProperty, gt = (e, t) => YE(e, "name", { value: t, configurable: !0 }), Qs = "Dialog", [jy, OB] = /* @__PURE__ */ Ot(Qs), [XE, Yt] = jy(Qs), jE = /* @__PURE__ */ gt((e) => {
  const {
    __scopeDialog: t,
    children: a,
    open: o,
    defaultOpen: r,
    onOpenChange: l,
    modal: i = !0
  } = e, n = b.useRef(null), c = b.useRef(null), [d, y] = Ea({
    prop: o,
    defaultProp: r ?? !1,
    onChange: l,
    caller: Qs
  }), [u, h] = b.useState(0), [p, g] = b.useState(0);
  return /* @__PURE__ */ s(
    XE,
    {
      scope: t,
      triggerRef: n,
      contentRef: c,
      contentId: Jt(),
      titleId: Jt(),
      descriptionId: Jt(),
      titlePresent: u > 0,
      descriptionPresent: p > 0,
      setTitleCount: h,
      setDescriptionCount: g,
      open: d,
      onOpenChange: y,
      onOpenToggle: b.useCallback(() => y((m) => !m), [y]),
      modal: i,
      children: a
    }
  );
}, "Dialog"), qy = "DialogPortal", [qE, Zy] = jy(qy, {
  forceMount: void 0
}), ZE = /* @__PURE__ */ gt((e) => {
  const { __scopeDialog: t, forceMount: a, children: o, container: r } = e, l = Yt(qy, t);
  return /* @__PURE__ */ s(qE, { scope: t, forceMount: a, children: b.Children.map(o, (i) => /* @__PURE__ */ s(bt, { present: a || l.open, children: /* @__PURE__ */ s(Zs, { asChild: !0, container: r, children: i }) })) });
}, "DialogPortal"), qn = "DialogOverlay", Jy = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ gt(function(t, a) {
    const o = Zy(qn, t.__scopeDialog), { forceMount: r = o.forceMount, ...l } = t, i = Yt(qn, t.__scopeDialog);
    return i.modal ? /* @__PURE__ */ s(bt, { present: r || i.open, children: /* @__PURE__ */ s(KE, { ...l, ref: a }) }) : null;
  }, "DialogOverlay")
), JE = /* @__PURE__ */ Ht("DialogOverlay.RemoveScroll"), KE = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ gt(function(t, a) {
    const { __scopeDialog: o, ...r } = t, l = Yt(qn, o), i = Ey(), n = ye(a, i);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ s(jl, { as: JE, allowPinchZoom: !0, shards: [l.contentRef], children: /* @__PURE__ */ s(
        ge.div,
        {
          "data-state": ec(l.open),
          ...r,
          ref: n,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }, "DialogOverlayImpl")
), br = "DialogContent", Ky = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ gt(function(t, a) {
    const o = Zy(br, t.__scopeDialog), { forceMount: r = o.forceMount, ...l } = t, i = Yt(br, t.__scopeDialog);
    return /* @__PURE__ */ s(bt, { present: r || i.open, children: i.modal ? /* @__PURE__ */ s(QE, { ...l, ref: a }) : /* @__PURE__ */ s(eD, { ...l, ref: a }) });
  }, "DialogContent")
), QE = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ gt(function(t, a) {
    const o = Yt(br, t.__scopeDialog), r = b.useRef(null), l = ye(a, o.contentRef, r);
    return b.useEffect(() => {
      const i = r.current;
      if (i) return Ks(i);
    }, []), /* @__PURE__ */ s(
      Qy,
      {
        ...t,
        ref: l,
        trapFocus: o.open,
        disableOutsidePointerEvents: o.open,
        onCloseAutoFocus: J(t.onCloseAutoFocus, (i) => {
          var n;
          i.preventDefault(), (n = o.triggerRef.current) == null || n.focus();
        }),
        onPointerDownOutside: J(t.onPointerDownOutside, (i) => {
          const n = i.detail.originalEvent, c = n.button === 0 && n.ctrlKey === !0;
          (n.button === 2 || c) && i.preventDefault();
        }),
        onFocusOutside: J(
          t.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }, "DialogContentModal")
), eD = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ gt(function(t, a) {
    const o = Yt(br, t.__scopeDialog), r = b.useRef(!1), l = b.useRef(!1);
    return /* @__PURE__ */ s(
      Qy,
      {
        ...t,
        ref: a,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var n, c;
          (n = t.onCloseAutoFocus) == null || n.call(t, i), i.defaultPrevented || (r.current || (c = o.triggerRef.current) == null || c.focus(), i.preventDefault()), r.current = !1, l.current = !1;
        },
        onInteractOutside: (i) => {
          var d, y;
          (d = t.onInteractOutside) == null || d.call(t, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (l.current = !0));
          const n = i.target;
          ((y = o.triggerRef.current) == null ? void 0 : y.contains(n)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && l.current && i.preventDefault();
        }
      }
    );
  }, "DialogContentNonModal")
), Qy = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ gt(function(t, a) {
    const { __scopeDialog: o, trapFocus: r, onOpenAutoFocus: l, onCloseAutoFocus: i, ...n } = t, c = Yt(br, o);
    return Mr(), /* @__PURE__ */ s(ut, { children: /* @__PURE__ */ s(
      js,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: l,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ s(
          Ys,
          {
            role: "dialog",
            id: c.contentId,
            "aria-describedby": c.descriptionPresent ? c.descriptionId : void 0,
            "aria-labelledby": c.titlePresent ? c.titleId : void 0,
            "data-state": ec(c.open),
            ...n,
            ref: a,
            deferPointerDownOutside: !0,
            onDismiss: () => c.onOpenChange(!1)
          }
        )
      }
    ) });
  }, "DialogContentImpl")
), tD = "DialogTitle", eh = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ gt(function(t, a) {
    const { __scopeDialog: o, ...r } = t, l = Yt(tD, o), { setTitleCount: i } = l;
    return We(() => (i((n) => n + 1), () => i((n) => n - 1)), [i]), /* @__PURE__ */ s(ge.h2, { id: l.titleId, ...r, ref: a });
  }, "DialogTitle")
), aD = "DialogDescription", th = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ gt(function(t, a) {
    const { __scopeDialog: o, ...r } = t, l = Yt(aD, o), { setDescriptionCount: i } = l;
    return We(() => (i((n) => n + 1), () => i((n) => n - 1)), [i]), /* @__PURE__ */ s(ge.p, { id: l.descriptionId, ...r, ref: a });
  }, "DialogDescription")
), oD = "DialogClose", rD = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ gt(function(t, a) {
    const { __scopeDialog: o, ...r } = t, l = Yt(oD, o);
    return /* @__PURE__ */ s(
      ge.button,
      {
        type: "button",
        ...r,
        ref: a,
        onClick: J(t.onClick, () => l.onOpenChange(!1))
      }
    );
  }, "DialogClose")
);
function ec(e) {
  return e ? "open" : "closed";
}
gt(ec, "getState");
const ah = xa({ current: null }), tc = () => $t(ah).current ?? void 0, Ta = jE, lD = ZE, oh = b.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ s(
  Jy,
  {
    ref: a,
    className: Ce(
      "fixed inset-0 z-50 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
oh.displayName = Jy.displayName;
const iD = {
  sm: "sm:max-w-[420px]",
  md: "sm:max-w-[620px]",
  lg: "sm:max-w-[800px]",
  xl: "sm:max-w-[1200px]",
  full: "sm:max-w-[calc(100vw-64px)]"
}, ca = b.forwardRef(({ className: e, children: t, size: a = "md", hideClose: o, ...r }, l) => {
  const i = tc();
  return /* @__PURE__ */ x(lD, { container: i, children: [
    /* @__PURE__ */ s(oh, {}),
    /* @__PURE__ */ x(
      Ky,
      {
        ref: l,
        className: Ce(
          "group/dialog fixed left-[50%] top-[50%] z-50 grid w-[calc(100%-32px)] gap-4 rounded-xl bg-card p-6 shadow-dialog outline-none",
          iD[a],
          "translate-x-[-50%] translate-y-[-50%]",
          "max-h-[90vh] overflow-y-auto scrollbar-hide",
          "opacity-0 scale-95",
          "transition-all duration-200 ease-out",
          "data-[state=open]:opacity-100 data-[state=open]:scale-100",
          e
        ),
        ...r,
        children: [
          t,
          !o && /* @__PURE__ */ x(rD, { className: "absolute right-4 top-4 z-20 grid size-7 place-items-center rounded-full text-muted-foreground transition-colors hover:bg-fill hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none", children: [
            /* @__PURE__ */ s(dr, { className: "size-5" }),
            /* @__PURE__ */ s("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] });
});
ca.displayName = Ky.displayName;
const oo = ({ className: e, ...t }) => /* @__PURE__ */ s(
  "div",
  {
    className: Ce(
      "sticky -top-6 z-10 -mx-6 -mt-6 flex flex-col gap-1 bg-card px-6 pb-2 pr-14 pt-6 text-left",
      // Custom-layout dialogs (p-0) place their own header.
      "group-[.p-0]/dialog:static group-[.p-0]/dialog:m-0",
      e
    ),
    ...t
  }
);
oo.displayName = "DialogHeader";
const Ho = ({ className: e, ...t }) => /* @__PURE__ */ s(
  "div",
  {
    className: Ce(
      "sticky -bottom-6 z-10 -mx-6 -mb-6 flex flex-col-reverse gap-2 border-t border-border bg-card px-6 pb-6 pt-4 sm:flex-row sm:justify-end",
      "group-[.p-0]/dialog:static group-[.p-0]/dialog:m-0",
      e
    ),
    ...t
  }
);
Ho.displayName = "DialogFooter";
const ro = b.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ s(
  eh,
  {
    ref: a,
    className: Ce("text-heading-md text-ink", e),
    ...t
  }
));
ro.displayName = eh.displayName;
const Nr = b.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ s(
  th,
  {
    ref: a,
    className: Ce("text-sm text-muted-foreground", e),
    ...t
  }
));
Nr.displayName = th.displayName;
const ac = "w-full min-w-0 rounded-md border border-input bg-card px-3 text-sm text-ink outline-none transition-[border-color,box-shadow] placeholder:text-placeholder-foreground hover:border-grey-400 focus-visible:border-ring focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:bg-subdued disabled:text-faint aria-[invalid=true]:border-error-light aria-[invalid=true]:bg-error-lighter aria-[invalid=true]:focus-visible:ring-error", Ze = b.forwardRef(
  ({ className: e, type: t, ...a }, o) => /* @__PURE__ */ s(
    "input",
    {
      type: t,
      className: Ce(
        ac,
        "flex h-8 py-1 file:border-0 file:bg-transparent file:text-sm file:font-semibold file:text-ink",
        t === "file" && "h-auto",
        e
      ),
      ref: o,
      ...a
    }
  )
);
Ze.displayName = "Input";
const nD = ({ open: e, onOpenChange: t, page: a, onPick: o }) => {
  const { schemas: r } = at(), [l, i] = j(""), [n, c] = j(null), d = fe(() => Object.entries(r.componentSchemas ?? {}).filter(([, g]) => g.supportedPages.includes(a)).filter(([g, m]) => !l || `${g} ${m.label} ${m.description}`.toLowerCase().includes(l.toLowerCase())), [r, a, l]), y = Td.map((g) => ({ ...g, items: d.filter(([m]) => g.types.includes(m)) })), u = d.filter(([g]) => !Td.some((m) => m.types.includes(g)));
  u.length && y.push({ id: "other", label: "Other", types: [], items: u });
  const h = d.find(([g]) => g === n) ?? d[0], p = h ? h[1].variants.filter((g) => g.previewImage) : [];
  return /* @__PURE__ */ s(Ta, { open: e, onOpenChange: t, children: /* @__PURE__ */ x(ca, { size: "xl", className: "flex h-[min(720px,85vh)] flex-col gap-0 overflow-hidden p-0", children: [
    /* @__PURE__ */ x(oo, { className: "shrink-0 gap-3 border-b border-border px-5 py-4 pr-14", children: [
      /* @__PURE__ */ x("div", { className: "space-y-1", children: [
        /* @__PURE__ */ s(ro, { children: "Add section" }),
        /* @__PURE__ */ s(Nr, { children: "It is added below the selected section and opens for editing." })
      ] }),
      /* @__PURE__ */ x("div", { className: "relative", children: [
        /* @__PURE__ */ s(As, { className: "pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-text-2" }),
        /* @__PURE__ */ s(Ze, { autoFocus: !0, value: l, onChange: (g) => i(g.target.value), placeholder: "Search sections", className: "pl-9", "aria-label": "Search sections" })
      ] })
    ] }),
    /* @__PURE__ */ x("div", { className: "flex min-h-0 flex-1", children: [
      /* @__PURE__ */ x("div", { className: "w-full shrink-0 space-y-3 overflow-y-auto p-2 sm:w-80 sm:border-r sm:border-border", children: [
        y.filter((g) => g.items.length).map((g) => /* @__PURE__ */ x("section", { children: [
          /* @__PURE__ */ s("h3", { className: "px-2 pb-1 pt-1 text-xs font-medium text-text-2", children: g.label }),
          /* @__PURE__ */ s("ul", { children: g.items.map(([m, f]) => {
            var w;
            const v = (h == null ? void 0 : h[0]) === m, k = (w = f.variants.find((S) => S.previewImage)) == null ? void 0 : w.previewImage;
            return /* @__PURE__ */ s("li", { children: /* @__PURE__ */ x(
              "button",
              {
                type: "button",
                onClick: () => {
                  var S;
                  o(m, ((S = f.variants[0]) == null ? void 0 : S.id) ?? "v1"), t(!1), i("");
                },
                onMouseEnter: () => c(m),
                onFocus: () => c(m),
                className: `flex w-full items-center gap-2.5 rounded-md px-2 py-1.5 text-left text-sm text-ink transition-colors hover:bg-subdued ${v ? "sm:bg-fill sm:hover:bg-fill" : ""}`,
                children: [
                  k ? /* @__PURE__ */ s("img", { src: k, alt: "", className: "h-6 w-9 shrink-0 rounded-sm border border-border object-cover" }) : /* @__PURE__ */ s(fA, { className: "size-4 shrink-0 text-text-2" }),
                  /* @__PURE__ */ s("span", { className: "min-w-0 flex-1 truncate", children: f.label }),
                  /* @__PURE__ */ x("span", { className: "shrink-0 text-xs text-text-2", children: [
                    f.variants.length,
                    " layout",
                    f.variants.length === 1 ? "" : "s"
                  ] })
                ]
              }
            ) }, m);
          }) })
        ] }, g.id)),
        d.length === 0 && /* @__PURE__ */ x("p", { className: "px-2 py-10 text-center text-sm text-text-2", children: [
          "No section matches “",
          l,
          "”."
        ] })
      ] }),
      /* @__PURE__ */ s("div", { className: "hidden min-w-0 flex-1 overflow-y-auto bg-subdued p-6 sm:block", children: h && /* @__PURE__ */ x("div", { className: "mx-auto max-w-xl space-y-4", children: [
        p.length > 0 && /* @__PURE__ */ s("div", { className: "grid grid-cols-2 gap-3", children: p.map((g) => /* @__PURE__ */ x("figure", { className: "m-0 space-y-1", children: [
          /* @__PURE__ */ s("img", { src: g.previewImage, alt: "", className: "aspect-video w-full rounded-md border border-border bg-card object-cover" }),
          /* @__PURE__ */ s("figcaption", { className: "truncate text-xs text-text-2", children: g.label })
        ] }, g.id)) }),
        /* @__PURE__ */ x("div", { className: "space-y-1", children: [
          /* @__PURE__ */ s("h3", { className: "text-heading-md text-ink", children: h[1].label }),
          h[1].description && /* @__PURE__ */ s("p", { className: "text-sm text-text-2", children: h[1].description })
        ] }),
        /* @__PURE__ */ x("div", { className: "rounded-lg border border-border bg-card", children: [
          /* @__PURE__ */ x("p", { className: "border-b border-border-subtle px-3 py-2 text-xs font-medium text-text-2", children: [
            h[1].variants.length,
            " layout",
            h[1].variants.length === 1 ? "" : "s"
          ] }),
          /* @__PURE__ */ s("ul", { className: "divide-y divide-border-subtle", children: h[1].variants.map((g) => /* @__PURE__ */ x("li", { className: "flex items-center justify-between gap-3 px-3 py-2 text-sm text-ink", children: [
            /* @__PURE__ */ s("span", { className: "min-w-0 truncate", children: g.label }),
            /* @__PURE__ */ s("span", { className: "shrink-0 text-xs text-text-2", children: g.id.toUpperCase() })
          ] }, g.id)) })
        ] }),
        /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "Click a section in the list to add it." })
      ] }) })
    ] })
  ] }) });
}, sD = (e, t) => {
  var i, n, c, d, y, u, h, p, g, m, f, v, k, w;
  const a = at(), o = ((i = a.localSettings) == null ? void 0 : i.config) ?? {}, l = (((d = (c = (n = a.localSettings) == null ? void 0 : n.pages) == null ? void 0 : c.home) == null ? void 0 : d.sections) ?? []).find((S) => S.type === "hero");
  return [
    { id: "logo", label: "Add your logo", done: !!((u = (y = o.header) == null ? void 0 : y.logo) != null && u.src), action: "Header settings", go: e.header },
    { id: "look", label: "Choose colours and fonts", done: !!((h = o.appearance) != null && h.colorMode || (g = (p = o.tokens) == null ? void 0 : p.typography) != null && g.heading && o.tokens.typography.heading !== "inherit"), action: "Colour presets", go: e.library },
    { id: "hero", label: "Put your own picture in the home banner", done: !!((v = (f = (m = l == null ? void 0 : l.props) == null ? void 0 : m.slides) == null ? void 0 : f.some) != null && v.call(f, (S) => S.image)), action: "Edit home page", go: e.home },
    { id: "menu", label: "Set up your menu", done: (((w = (k = o.header) == null ? void 0 : k.menu) == null ? void 0 : w.length) ?? 0) > 0, action: "Header settings", go: e.header },
    { id: "mobile", label: "Check how it looks on a phone", done: t, action: "Phone preview", go: e.mobile },
    { id: "publish", label: "Publish", done: !!a.themeSettings && !a.hasChanges && a.listLocalVersions().length > 0, action: "", go: () => void a.publish() }
  ];
}, cD = ({ steps: e }) => /* @__PURE__ */ s(ao, { className: "h-full", children: /* @__PURE__ */ x("div", { className: "space-y-3 p-4", children: [
  /* @__PURE__ */ x("div", { className: "space-y-0.5", children: [
    /* @__PURE__ */ s("h2", { className: "text-sm font-medium text-ink", children: "Get your store ready" }),
    /* @__PURE__ */ x("p", { className: "text-xs text-text-2", children: [
      e.filter((t) => t.done).length,
      " of ",
      e.length,
      " done"
    ] })
  ] }),
  /* @__PURE__ */ s("ol", { className: "divide-y divide-border-subtle overflow-hidden rounded-md border border-border bg-card", children: e.map((t) => /* @__PURE__ */ s("li", { children: /* @__PURE__ */ x("button", { type: "button", onClick: t.go, className: "flex w-full items-center gap-2.5 px-3 py-2 text-left transition-colors hover:bg-subdued", children: [
    t.done ? /* @__PURE__ */ s(rA, { className: "size-4 shrink-0 text-ink" }) : /* @__PURE__ */ s(yu, { className: "size-4 shrink-0 text-faint" }),
    /* @__PURE__ */ s("span", { className: `min-w-0 flex-1 text-sm ${t.done ? "text-text-2 line-through" : "text-ink"}`, children: t.label }),
    !t.done && t.action && /* @__PURE__ */ s("span", { className: "shrink-0 text-xs text-text-2", children: t.action })
  ] }) }, t.id)) })
] }) }), dD = Gs(
  "inline-flex h-5 min-w-5 items-center justify-center gap-1 whitespace-nowrap rounded-sm px-1.5 text-xs font-medium leading-none",
  {
    variants: {
      tone: {
        dark: "bg-ink text-white",
        soft: "bg-muted text-text-2",
        brand: "bg-muted text-ink",
        success: "bg-success-lighter text-success-dark",
        warning: "bg-warning-lighter text-warning-dark",
        error: "bg-error-lighter text-error-dark",
        info: "bg-info-lighter text-info-dark",
        orange: "bg-cta-lighter text-cta-dark",
        outline: "border border-border text-ink"
      }
    },
    defaultVariants: {
      tone: "soft"
    }
  }
), pD = {
  default: "brand",
  secondary: "soft",
  destructive: "error",
  outline: "outline"
};
function Zn({ className: e, tone: t, variant: a, ...o }) {
  return /* @__PURE__ */ s(
    "div",
    {
      className: Ce(dD({ tone: t ?? (a ? pD[a] : void 0) }), e),
      ...o
    }
  );
}
var uD = Object.defineProperty, yD = (e, t) => uD(e, "name", { value: t, configurable: !0 });
function oc(e) {
  const [t, a] = b.useState(void 0);
  return We(() => {
    if (e) {
      a({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const l = r[0];
        let i, n;
        if ("borderBoxSize" in l) {
          const c = l.borderBoxSize, d = Array.isArray(c) ? c[0] : c;
          i = d.inlineSize, n = d.blockSize;
        } else
          i = e.offsetWidth, n = e.offsetHeight;
        a({ width: i, height: n });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      a(void 0);
  }, [e]), t;
}
yD(oc, "useSize");
var hD = Object.defineProperty, fa = (e, t) => hD(e, "name", { value: t, configurable: !0 }), rc = "Switch", [bD, RB] = /* @__PURE__ */ Ot(rc), [mD, lc] = bD(rc);
function rh(e) {
  const {
    __scopeSwitch: t,
    checked: a,
    children: o,
    defaultChecked: r,
    disabled: l,
    form: i,
    name: n,
    onCheckedChange: c,
    required: d,
    value: y = "on",
    // @ts-expect-error
    internal_do_not_use_render: u
  } = e, [h, p] = Ea({
    prop: a,
    defaultProp: r ?? !1,
    onChange: c,
    caller: rc
  }), [g, m] = b.useState(null), [f, v] = b.useState(null), k = b.useRef(!1), [w, S] = b.useReducer(
    (A) => A + 1,
    0
  ), T = g ? !!i || !!g.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), C = {
    checked: h,
    setChecked: p,
    disabled: l,
    control: g,
    setControl: m,
    name: n,
    form: i,
    value: y,
    hasConsumerStoppedPropagationRef: k,
    userInteractionCount: w,
    onUserInteraction: S,
    required: d,
    defaultChecked: r,
    isFormControl: T,
    bubbleInput: f,
    setBubbleInput: v
  };
  return /* @__PURE__ */ s(mD, { scope: t, ...C, children: ih(u) ? u(C) : o });
}
fa(rh, "SwitchProvider");
var gD = "SwitchTrigger", fD = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ fa(function({ __scopeSwitch: t, onClick: a, ...o }, r) {
    const {
      control: l,
      form: i,
      value: n,
      disabled: c,
      checked: d,
      required: y,
      setControl: u,
      setChecked: h,
      hasConsumerStoppedPropagationRef: p,
      onUserInteraction: g,
      isFormControl: m,
      bubbleInput: f
    } = lc(gD, t), v = ye(r, u), k = b.useRef(d);
    return b.useEffect(() => {
      const w = i ? l == null ? void 0 : l.ownerDocument.getElementById(i) : l == null ? void 0 : l.form;
      if (w instanceof HTMLFormElement) {
        const S = /* @__PURE__ */ fa(() => h(k.current), "reset");
        return w.addEventListener("reset", S), () => w.removeEventListener("reset", S);
      }
    }, [l, i, h]), /* @__PURE__ */ s(
      ge.button,
      {
        type: "button",
        role: "switch",
        "aria-checked": d,
        "aria-required": y,
        "data-state": ic(d),
        "data-disabled": c ? "" : void 0,
        disabled: c,
        value: n,
        ...o,
        ref: v,
        onClick: J(a, (w) => {
          g(), h((S) => !S), f && m && (p.current = w.isPropagationStopped(), p.current || w.stopPropagation());
        })
      }
    );
  }, "SwitchTrigger")
), lh = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ fa(function(t, a) {
    const {
      __scopeSwitch: o,
      name: r,
      checked: l,
      defaultChecked: i,
      required: n,
      disabled: c,
      value: d,
      onCheckedChange: y,
      form: u,
      ...h
    } = t;
    return /* @__PURE__ */ s(
      rh,
      {
        __scopeSwitch: o,
        checked: l,
        defaultChecked: i,
        disabled: c,
        required: n,
        onCheckedChange: y,
        name: r,
        form: u,
        value: d,
        internal_do_not_use_render: ({ isFormControl: p }) => /* @__PURE__ */ x(ut, { children: [
          /* @__PURE__ */ s(
            fD,
            {
              ...h,
              ref: a,
              __scopeSwitch: o
            }
          ),
          p && /* @__PURE__ */ s(
            SD,
            {
              __scopeSwitch: o
            }
          )
        ] })
      }
    );
  }, "Switch")
), vD = "SwitchThumb", kD = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ fa(function(t, a) {
    const { __scopeSwitch: o, ...r } = t, l = lc(vD, o);
    return /* @__PURE__ */ s(
      ge.span,
      {
        "data-state": ic(l.checked),
        "data-disabled": l.disabled ? "" : void 0,
        ...r,
        ref: a
      }
    );
  }, "SwitchThumb")
), wD = "SwitchBubbleInput", SD = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ fa(function({ __scopeSwitch: t, onClick: a, ...o }, r) {
    const {
      control: l,
      hasConsumerStoppedPropagationRef: i,
      userInteractionCount: n,
      checked: c,
      defaultChecked: d,
      required: y,
      disabled: u,
      name: h,
      value: p,
      form: g,
      bubbleInput: m,
      setBubbleInput: f
    } = lc(wD, t), v = ye(r, f), k = oc(l), w = b.useRef(!1), S = b.useRef(c), T = b.useRef(n);
    b.useEffect(() => {
      const A = m;
      if (!A) return;
      const M = window.HTMLInputElement.prototype, F = Object.getOwnPropertyDescriptor(
        M,
        "checked"
      ).set, I = n !== T.current;
      T.current = n;
      const P = S.current !== c;
      S.current = c;
      const O = !(I && i.current);
      if (P && F) {
        w.current = !I;
        const z = new Event("click", { bubbles: O });
        F.call(A, c), A.dispatchEvent(z), w.current = !1;
      }
    }, [m, c, i, n]);
    const C = b.useRef(c);
    return /* @__PURE__ */ s(
      ge.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: d ?? C.current,
        required: y,
        disabled: u,
        name: h,
        value: p,
        form: g,
        ...o,
        tabIndex: -1,
        ref: v,
        onClick: J(a, (A) => {
          w.current && A.stopPropagation();
        }),
        style: {
          ...o.style,
          ...k,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }, "SwitchBubbleInput")
);
function ih(e) {
  return typeof e == "function";
}
fa(ih, "isFunction");
function ic(e) {
  return e ? "checked" : "unchecked";
}
fa(ic, "getState");
const Ao = b.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ s(
  lh,
  {
    className: Ce(
      "peer inline-flex h-5 w-8 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors data-[state=checked]:bg-primary data-[state=unchecked]:bg-grey-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    ref: a,
    children: /* @__PURE__ */ s(
      kD,
      {
        className: Ce(
          "pointer-events-none block size-4 rounded-full bg-card shadow-z1 ring-0 transition-transform data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
Ao.displayName = lh.displayName;
var xD = Object.defineProperty, qe = (e, t) => xD(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function ql(e) {
  const t = e + "CollectionProvider", [a, o] = /* @__PURE__ */ Ot(t), [r, l] = a(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = /* @__PURE__ */ qe((m) => {
    const { scope: f, children: v } = m, k = b.useRef(null), w = b.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ s(r, { scope: f, itemMap: w, collectionRef: k, children: v });
  }, "CollectionProvider");
  i.displayName = t;
  const n = e + "CollectionSlot", c = /* @__PURE__ */ Ht(n), d = b.forwardRef(
    (m, f) => {
      const { scope: v, children: k } = m, w = l(n, v), S = ye(f, w.collectionRef);
      return /* @__PURE__ */ s(c, { ref: S, children: k });
    }
  );
  d.displayName = n;
  const y = e + "CollectionItemSlot", u = "data-radix-collection-item", h = /* @__PURE__ */ Ht(y), p = b.forwardRef(
    (m, f) => {
      const { scope: v, children: k, ...w } = m, S = b.useRef(null), T = ye(f, S), C = l(y, v);
      return b.useEffect(() => (C.itemMap.set(S, { ref: S, ...w }), () => void C.itemMap.delete(S))), /* @__PURE__ */ s(h, { [u]: "", ref: T, children: k });
    }
  );
  p.displayName = y;
  function g(m) {
    const f = l(e + "CollectionConsumer", m);
    return b.useCallback(() => {
      const k = f.collectionRef.current;
      if (!k) return [];
      const w = Array.from(k.querySelectorAll(`[${u}]`));
      return Array.from(f.itemMap.values()).sort(
        (C, A) => w.indexOf(C.ref.current) - w.indexOf(A.ref.current)
      );
    }, [f.collectionRef, f.itemMap]);
  }
  return qe(g, "useCollection"), [
    { Provider: i, Slot: d, ItemSlot: p },
    g,
    o
  ];
}
qe(ql, "createCollection");
var rp = /* @__PURE__ */ new WeakMap(), _e, st, Ii = (st = class extends Map {
  constructor(a) {
    super(a);
    Lc(this, _e);
    ui(this, _e, [...super.keys()]), rp.set(this, !0);
  }
  set(a, o) {
    return rp.get(this) && (this.has(a) ? Qe(this, _e)[Qe(this, _e).indexOf(a)] = a : Qe(this, _e).push(a)), super.set(a, o), this;
  }
  insert(a, o, r) {
    const l = this.has(o), i = Qe(this, _e).length, n = nc(a);
    let c = n >= 0 ? n : i + n;
    const d = c < 0 || c >= i ? -1 : c;
    if (d === this.size || l && d === this.size - 1 || d === -1)
      return this.set(o, r), this;
    const y = this.size + (l ? 0 : 1);
    n < 0 && c++;
    const u = [...Qe(this, _e)];
    let h, p = !1;
    for (let g = c; g < y; g++)
      if (c === g) {
        let m = u[g];
        u[g] === o && (m = u[g + 1]), l && this.delete(o), h = this.get(m), this.set(o, r);
      } else {
        !p && u[g - 1] === o && (p = !0);
        const m = u[p ? g : g - 1], f = h;
        h = this.get(m), this.delete(m), this.set(m, f);
      }
    return this;
  }
  with(a, o, r) {
    const l = new st(this);
    return l.insert(a, o, r), l;
  }
  before(a) {
    const o = Qe(this, _e).indexOf(a) - 1;
    if (!(o < 0))
      return this.entryAt(o);
  }
  /**
   * Sets a new key-value pair at the position before the given key.
   */
  setBefore(a, o, r) {
    const l = Qe(this, _e).indexOf(a);
    return l === -1 ? this : this.insert(l, o, r);
  }
  after(a) {
    let o = Qe(this, _e).indexOf(a);
    if (o = o === -1 || o === this.size - 1 ? -1 : o + 1, o !== -1)
      return this.entryAt(o);
  }
  /**
   * Sets a new key-value pair at the position after the given key.
   */
  setAfter(a, o, r) {
    const l = Qe(this, _e).indexOf(a);
    return l === -1 ? this : this.insert(l + 1, o, r);
  }
  first() {
    return this.entryAt(0);
  }
  last() {
    return this.entryAt(-1);
  }
  clear() {
    return ui(this, _e, []), super.clear();
  }
  delete(a) {
    const o = super.delete(a);
    return o && Qe(this, _e).splice(Qe(this, _e).indexOf(a), 1), o;
  }
  deleteAt(a) {
    const o = this.keyAt(a);
    return o !== void 0 ? this.delete(o) : !1;
  }
  at(a) {
    const o = yl(Qe(this, _e), a);
    if (o !== void 0)
      return this.get(o);
  }
  entryAt(a) {
    const o = yl(Qe(this, _e), a);
    if (o !== void 0)
      return [o, this.get(o)];
  }
  indexOf(a) {
    return Qe(this, _e).indexOf(a);
  }
  keyAt(a) {
    return yl(Qe(this, _e), a);
  }
  from(a, o) {
    const r = this.indexOf(a);
    if (r === -1)
      return;
    let l = r + o;
    return l < 0 && (l = 0), l >= this.size && (l = this.size - 1), this.at(l);
  }
  keyFrom(a, o) {
    const r = this.indexOf(a);
    if (r === -1)
      return;
    let l = r + o;
    return l < 0 && (l = 0), l >= this.size && (l = this.size - 1), this.keyAt(l);
  }
  find(a, o) {
    let r = 0;
    for (const l of this) {
      if (Reflect.apply(a, o, [l, r, this]))
        return l;
      r++;
    }
  }
  findIndex(a, o) {
    let r = 0;
    for (const l of this) {
      if (Reflect.apply(a, o, [l, r, this]))
        return r;
      r++;
    }
    return -1;
  }
  filter(a, o) {
    const r = [];
    let l = 0;
    for (const i of this)
      Reflect.apply(a, o, [i, l, this]) && r.push(i), l++;
    return new st(r);
  }
  map(a, o) {
    const r = [];
    let l = 0;
    for (const i of this)
      r.push([i[0], Reflect.apply(a, o, [i, l, this])]), l++;
    return new st(r);
  }
  reduce(...a) {
    const [o, r] = a;
    let l = 0, i = r ?? this.at(0);
    for (const n of this)
      l === 0 && a.length === 1 ? i = n : i = Reflect.apply(o, this, [i, n, l, this]), l++;
    return i;
  }
  reduceRight(...a) {
    const [o, r] = a;
    let l = r ?? this.at(-1);
    for (let i = this.size - 1; i >= 0; i--) {
      const n = this.at(i);
      i === this.size - 1 && a.length === 1 ? l = n : l = Reflect.apply(o, this, [l, n, i, this]);
    }
    return l;
  }
  toSorted(a) {
    const o = [...this.entries()].sort(a);
    return new st(o);
  }
  toReversed() {
    const a = new st();
    for (let o = this.size - 1; o >= 0; o--) {
      const r = this.keyAt(o), l = this.get(r);
      a.set(r, l);
    }
    return a;
  }
  toSpliced(...a) {
    const o = [...this.entries()];
    return o.splice(...a), new st(o);
  }
  slice(a, o) {
    const r = new st();
    let l = this.size - 1;
    if (a === void 0)
      return r;
    a < 0 && (a = a + this.size), o !== void 0 && o > 0 && (l = o - 1);
    for (let i = a; i <= l; i++) {
      const n = this.keyAt(i), c = this.get(n);
      r.set(n, c);
    }
    return r;
  }
  every(a, o) {
    let r = 0;
    for (const l of this) {
      if (!Reflect.apply(a, o, [l, r, this]))
        return !1;
      r++;
    }
    return !0;
  }
  some(a, o) {
    let r = 0;
    for (const l of this) {
      if (Reflect.apply(a, o, [l, r, this]))
        return !0;
      r++;
    }
    return !1;
  }
}, _e = new WeakMap(), qe(st, "OrderedDict"), st);
function yl(e, t) {
  if ("at" in Array.prototype)
    return Array.prototype.at.call(e, t);
  const a = nh(e, t);
  return a === -1 ? void 0 : e[a];
}
qe(yl, "at");
function nh(e, t) {
  const a = e.length, o = nc(t), r = o >= 0 ? o : a + o;
  return r < 0 || r >= a ? -1 : r;
}
qe(nh, "toSafeIndex");
function nc(e) {
  return e !== e || e === 0 ? 0 : Math.trunc(e);
}
qe(nc, "toSafeInteger");
// @__NO_SIDE_EFFECTS__
function TD(e) {
  const t = e + "CollectionProvider", [a, o] = /* @__PURE__ */ Ot(t), [r, l] = a(
    t,
    {
      collectionElement: null,
      collectionRef: { current: null },
      collectionRefObject: { current: null },
      itemMap: new Ii(),
      setItemMap: /* @__PURE__ */ qe(() => {
      }, "setItemMap")
    }
  ), i = /* @__PURE__ */ qe(({ state: w, ...S }) => w ? /* @__PURE__ */ s(c, { ...S, state: w }) : /* @__PURE__ */ s(n, { ...S }), "CollectionProvider");
  i.displayName = t;
  const n = /* @__PURE__ */ qe((w) => {
    const S = f();
    return /* @__PURE__ */ s(c, { ...w, state: S });
  }, "CollectionInit");
  n.displayName = t + "Init";
  const c = /* @__PURE__ */ qe((w) => {
    const { scope: S, children: T, state: C } = w, A = b.useRef(null), [M, E] = b.useState(
      null
    ), F = ye(A, E), [I, P] = C;
    return b.useEffect(() => {
      if (!M) return;
      const O = dh(() => {
      });
      return O.observe(M, {
        childList: !0,
        subtree: !0
      }), () => {
        O.disconnect();
      };
    }, [M]), /* @__PURE__ */ s(
      r,
      {
        scope: S,
        itemMap: I,
        setItemMap: P,
        collectionRef: F,
        collectionRefObject: A,
        collectionElement: M,
        children: T
      }
    );
  }, "CollectionProviderImpl");
  c.displayName = t + "Impl";
  const d = e + "CollectionSlot", y = /* @__PURE__ */ Ht(d), u = b.forwardRef(
    (w, S) => {
      const { scope: T, children: C } = w, A = l(d, T), M = ye(S, A.collectionRef);
      return /* @__PURE__ */ s(y, { ref: M, children: C });
    }
  );
  u.displayName = d;
  const h = e + "CollectionItemSlot", p = "data-radix-collection-item", g = /* @__PURE__ */ Ht(h), m = b.forwardRef(
    (w, S) => {
      const { scope: T, children: C, ...A } = w, M = b.useRef(null), [E, F] = b.useState(null), I = ye(S, M, F), P = l(h, T), { setItemMap: O } = P, z = b.useRef(A);
      sh(z.current, A) || (z.current = A);
      const U = z.current;
      return b.useEffect(() => {
        const Y = U;
        return O((_) => E ? _.has(E) ? _.set(E, { ...Y, element: E }).toSorted(Jn) : (_.set(E, { ...Y, element: E }), _.toSorted(Jn)) : _), () => {
          O((_) => !E || !_.has(E) ? _ : (_.delete(E), new Ii(_)));
        };
      }, [E, U, O]), /* @__PURE__ */ s(g, { [p]: "", ref: I, children: C });
    }
  );
  m.displayName = h;
  function f() {
    return b.useState(new Ii());
  }
  qe(f, "useInitCollection");
  function v(w) {
    const { itemMap: S } = l(e + "CollectionConsumer", w);
    return S;
  }
  return qe(v, "useCollection"), [
    { Provider: i, Slot: u, ItemSlot: m },
    {
      createCollectionScope: o,
      useCollection: v,
      useInitCollection: f
    }
  ];
}
qe(TD, "createCollection");
function sh(e, t) {
  if (e === t) return !0;
  if (typeof e != "object" || typeof t != "object" || e == null || t == null) return !1;
  const a = Object.keys(e), o = Object.keys(t);
  if (a.length !== o.length) return !1;
  for (const r of a)
    if (!Object.prototype.hasOwnProperty.call(t, r) || e[r] !== t[r]) return !1;
  return !0;
}
qe(sh, "shallowEqual");
function ch(e, t) {
  return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
qe(ch, "isElementPreceding");
function Jn(e, t) {
  return !e[1].element || !t[1].element ? 0 : ch(e[1].element, t[1].element) ? -1 : 1;
}
qe(Jn, "sortByDocumentPosition");
function dh(e) {
  return new MutationObserver((a) => {
    for (const o of a)
      if (o.type === "childList") {
        e();
        return;
      }
  });
}
qe(dh, "getChildListObserver");
const CD = ["top", "right", "bottom", "left"], va = Math.min, Kt = Math.max, Ml = Math.round, il = Math.floor, Qt = (e) => ({
  x: e,
  y: e
}), PD = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ph(e, t, a) {
  return Kt(e, va(t, a));
}
function aa(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ka(e) {
  return e.split("-")[0];
}
function Uo(e) {
  return e.split("-")[1];
}
function sc(e) {
  return e === "x" ? "y" : "x";
}
function cc(e) {
  return e === "y" ? "height" : "width";
}
function Wt(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function dc(e) {
  return sc(Wt(e));
}
function AD(e, t, a) {
  a === void 0 && (a = !1);
  const o = Uo(e), r = dc(e), l = cc(r);
  let i = r === "x" ? o === (a ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[l] > t.floating[l] && (i = Nl(i)), [i, Nl(i)];
}
function LD(e) {
  const t = Nl(e);
  return [Kn(e), t, Kn(t)];
}
function Kn(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const lp = ["left", "right"], ip = ["right", "left"], MD = ["top", "bottom"], ND = ["bottom", "top"];
function ED(e, t, a) {
  switch (e) {
    case "top":
    case "bottom":
      return a ? t ? ip : lp : t ? lp : ip;
    case "left":
    case "right":
      return t ? MD : ND;
    default:
      return [];
  }
}
function DD(e, t, a, o) {
  const r = Uo(e);
  let l = ED(ka(e), a === "start", o);
  return r && (l = l.map((i) => i + "-" + r), t && (l = l.concat(l.map(Kn)))), l;
}
function Nl(e) {
  const t = ka(e);
  return PD[t] + e.slice(t.length);
}
function FD(e) {
  var t, a, o, r;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (a = e.right) != null ? a : 0,
    bottom: (o = e.bottom) != null ? o : 0,
    left: (r = e.left) != null ? r : 0
  };
}
function uh(e) {
  return typeof e != "number" ? FD(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function El(e) {
  const {
    x: t,
    y: a,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: a,
    left: t,
    right: t + o,
    bottom: a + r,
    x: t,
    y: a
  };
}
function np(e, t, a) {
  let {
    reference: o,
    floating: r
  } = e;
  const l = Wt(t), i = dc(t), n = cc(i), c = ka(t), d = l === "y", y = o.x + o.width / 2 - r.width / 2, u = o.y + o.height / 2 - r.height / 2, h = o[n] / 2 - r[n] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: y,
        y: o.y - r.height
      };
      break;
    case "bottom":
      p = {
        x: y,
        y: o.y + o.height
      };
      break;
    case "right":
      p = {
        x: o.x + o.width,
        y: u
      };
      break;
    case "left":
      p = {
        x: o.x - r.width,
        y: u
      };
      break;
    default:
      p = {
        x: o.x,
        y: o.y
      };
  }
  const g = Uo(t);
  return g && (p[i] += h * (g === "end" ? 1 : -1) * (a && d ? -1 : 1)), p;
}
async function ID(e, t) {
  var a;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: l,
    rects: i,
    elements: n,
    strategy: c
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: y = "viewport",
    elementContext: u = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = aa(t, e), g = uh(p), f = n[h ? u === "floating" ? "reference" : "floating" : u], v = El(await l.getClippingRect({
    element: (a = await (l.isElement == null ? void 0 : l.isElement(f))) == null || a ? f : f.contextElement || await (l.getDocumentElement == null ? void 0 : l.getDocumentElement(n.floating)),
    boundary: d,
    rootBoundary: y,
    strategy: c
  })), k = u === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, w = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(n.floating)), S = await (l.isElement == null ? void 0 : l.isElement(w)) && await (l.getScale == null ? void 0 : l.getScale(w)) || {
    x: 1,
    y: 1
  }, T = El(l.convertOffsetParentRelativeRectToViewportRelativeRect ? await l.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: n,
    rect: k,
    offsetParent: w,
    strategy: c
  }) : k);
  return {
    top: (v.top - T.top + g.top) / S.y,
    bottom: (T.bottom - v.bottom + g.bottom) / S.y,
    left: (v.left - T.left + g.left) / S.x,
    right: (T.right - v.right + g.right) / S.x
  };
}
const OD = 50, RD = async (e, t, a) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: l = [],
    platform: i
  } = a, n = i.detectOverflow ? i : {
    ...i,
    detectOverflow: ID
  }, c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let d = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: y,
    y: u
  } = np(d, o, c), h = o, p = 0;
  const g = {};
  for (let m = 0; m < l.length; m++) {
    const f = l[m];
    if (!f)
      continue;
    const {
      name: v,
      fn: k
    } = f, {
      x: w,
      y: S,
      data: T,
      reset: C
    } = await k({
      x: y,
      y: u,
      initialPlacement: o,
      placement: h,
      strategy: r,
      middlewareData: g,
      rects: d,
      platform: n,
      elements: {
        reference: e,
        floating: t
      }
    });
    y = w ?? y, u = S ?? u, g[v] = {
      ...g[v],
      ...T
    }, C && p < OD && (p++, typeof C == "object" && (C.placement && (h = C.placement), C.rects && (d = C.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : C.rects), {
      x: y,
      y: u
    } = np(d, h, c)), m = -1);
  }
  return {
    x: y,
    y: u,
    placement: h,
    strategy: r,
    middlewareData: g
  };
}, BD = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: a,
      y: o,
      placement: r,
      rects: l,
      platform: i,
      elements: n,
      middlewareData: c
    } = t, {
      element: d,
      padding: y = 0
    } = aa(e, t) || {};
    if (d == null)
      return {};
    const u = uh(y), h = {
      x: a,
      y: o
    }, p = dc(r), g = cc(p), m = await i.getDimensions(d), f = p === "y", v = f ? "top" : "left", k = f ? "bottom" : "right", w = f ? "clientHeight" : "clientWidth", S = l.reference[g] + l.reference[p] - h[p] - l.floating[g], T = h[p] - l.reference[p], C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(d));
    let A = C ? C[w] : 0;
    (!A || !await (i.isElement == null ? void 0 : i.isElement(C))) && (A = n.floating[w] || l.floating[g]);
    const M = S / 2 - T / 2, E = A / 2 - m[g] / 2 - 1, F = va(u[v], E), I = va(u[k], E), P = A - m[g] - I, O = A / 2 - m[g] / 2 + M, z = ph(F, O, P), U = !c.arrow && Uo(r) != null && O !== z && l.reference[g] / 2 - (O < F ? F : I) - m[g] / 2 < 0, Y = U ? O < F ? O - F : O - P : 0;
    return {
      [p]: h[p] + Y,
      data: {
        [p]: z,
        centerOffset: O - z - Y,
        ...U && {
          alignmentOffset: Y
        }
      },
      reset: U
    };
  }
}), zD = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var a, o;
      const {
        placement: r,
        middlewareData: l,
        rects: i,
        initialPlacement: n,
        platform: c,
        elements: d
      } = t, {
        mainAxis: y = !0,
        crossAxis: u = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: m = !0,
        ...f
      } = aa(e, t);
      if ((a = l.arrow) != null && a.alignmentOffset)
        return {};
      const v = ka(r), k = Wt(n), w = ka(n) === n, S = await (c.isRTL == null ? void 0 : c.isRTL(d.floating)), T = h || (w || !m ? [Nl(n)] : LD(n)), C = g !== "none";
      !h && C && T.push(...DD(n, m, g, S));
      const A = [n, ...T], M = await c.detectOverflow(t, f), E = [];
      let F = ((o = l.flip) == null ? void 0 : o.overflows) || [];
      if (y && E.push(M[v]), u) {
        const z = AD(r, i, S);
        E.push(M[z[0]], M[z[1]]);
      }
      if (F = [...F, {
        placement: r,
        overflows: E
      }], !E.every((z) => z <= 0)) {
        var I, P;
        const z = (((I = l.flip) == null ? void 0 : I.index) || 0) + 1, U = A[z];
        if (U && (!(u === "alignment" ? k !== Wt(U) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        F.every((H) => Wt(H.placement) === k ? H.overflows[0] > 0 : !0)))
          return {
            data: {
              index: z,
              overflows: F
            },
            reset: {
              placement: U
            }
          };
        let Y = (P = F.filter((_) => _.overflows[0] <= 0).sort((_, H) => _.overflows[1] - H.overflows[1])[0]) == null ? void 0 : P.placement;
        if (!Y)
          switch (p) {
            case "bestFit": {
              var O;
              const _ = (O = F.filter((H) => {
                if (C) {
                  const N = Wt(H.placement);
                  return N === k || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  N === "y";
                }
                return !0;
              }).map((H) => [H.placement, H.overflows.filter((N) => N > 0).reduce((N, D) => N + D, 0)]).sort((H, N) => H[1] - N[1])[0]) == null ? void 0 : O[0];
              _ && (Y = _);
              break;
            }
            case "initialPlacement":
              Y = n;
              break;
          }
        if (r !== Y)
          return {
            reset: {
              placement: Y
            }
          };
      }
      return {};
    }
  };
};
function sp(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function cp(e) {
  return CD.some((t) => e[t] >= 0);
}
const VD = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: a,
        platform: o
      } = t, {
        strategy: r = "referenceHidden",
        ...l
      } = aa(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await o.detectOverflow(t, {
            ...l,
            elementContext: "reference"
          }), n = sp(i, a.reference);
          return {
            data: {
              referenceHiddenOffsets: n,
              referenceHidden: cp(n)
            }
          };
        }
        case "escaped": {
          const i = await o.detectOverflow(t, {
            ...l,
            altBoundary: !0
          }), n = sp(i, a.floating);
          return {
            data: {
              escapedOffsets: n,
              escaped: cp(n)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, yh = /* @__PURE__ */ new Set(["left", "top"]);
async function WD(e, t) {
  const {
    placement: a,
    platform: o,
    elements: r
  } = e, l = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = ka(a), n = Uo(a), c = Wt(a) === "y", d = yh.has(i) ? -1 : 1, y = l && c ? -1 : 1, u = aa(t, e);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: g
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return n && typeof g == "number" && (p = n === "end" ? g * -1 : g), c ? {
    x: p * y,
    y: h * d
  } : {
    x: h * d,
    y: p * y
  };
}
const $D = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var a, o;
      const {
        x: r,
        y: l,
        placement: i,
        middlewareData: n
      } = t, c = await WD(t, e);
      return i === ((a = n.offset) == null ? void 0 : a.placement) && (o = n.arrow) != null && o.alignmentOffset ? {} : {
        x: r + c.x,
        y: l + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, _D = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: a,
        y: o,
        placement: r,
        platform: l
      } = t, {
        mainAxis: i = !0,
        crossAxis: n = !1,
        limiter: c = {
          fn: (k) => {
            let {
              x: w,
              y: S
            } = k;
            return {
              x: w,
              y: S
            };
          }
        },
        ...d
      } = aa(e, t), y = {
        x: a,
        y: o
      }, u = await l.detectOverflow(t, d), h = Wt(r), p = sc(h);
      let g = y[p], m = y[h];
      const f = (k, w) => ph(w + u[k === "y" ? "top" : "left"], w, w - u[k === "y" ? "bottom" : "right"]);
      i && (g = f(p, g)), n && (m = f(h, m));
      const v = c.fn({
        ...t,
        [p]: g,
        [h]: m
      });
      return {
        ...v,
        data: {
          x: v.x - a,
          y: v.y - o,
          enabled: {
            [p]: i,
            [h]: n
          }
        }
      };
    }
  };
}, HD = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      var a, o;
      const {
        x: r,
        y: l,
        placement: i,
        rects: n,
        middlewareData: c
      } = t, {
        offset: d = 0,
        mainAxis: y = !0,
        crossAxis: u = !0
      } = aa(e, t), h = {
        x: r,
        y: l
      }, p = Wt(i), g = sc(p);
      let m = h[g], f = h[p];
      const v = aa(d, t), k = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: (a = v.mainAxis) != null ? a : 0,
        crossAxis: (o = v.crossAxis) != null ? o : 0
      };
      if (y) {
        const T = g === "y" ? "height" : "width", C = n.reference[g] - n.floating[T] + k.mainAxis, A = n.reference[g] + n.reference[T] - k.mainAxis;
        m < C ? m = C : m > A && (m = A);
      }
      if (u) {
        var w, S;
        const T = g === "y" ? "width" : "height", C = yh.has(ka(i)), A = n.reference[p] - n.floating[T] + (C && ((w = c.offset) == null ? void 0 : w[p]) || 0) + (C ? 0 : k.crossAxis), M = n.reference[p] + n.reference[T] + (C ? 0 : ((S = c.offset) == null ? void 0 : S[p]) || 0) - (C ? k.crossAxis : 0);
        f < A ? f = A : f > M && (f = M);
      }
      return {
        [g]: m,
        [p]: f
      };
    }
  };
}, UD = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: a,
        rects: o,
        platform: r,
        elements: l
      } = t, {
        apply: i = () => {
        },
        ...n
      } = aa(e, t), c = await r.detectOverflow(t, n), d = ka(a), y = Uo(a), u = Wt(a) === "y", {
        width: h,
        height: p
      } = o.floating;
      let g, m;
      d === "top" || d === "bottom" ? (g = d, m = y === (await (r.isRTL == null ? void 0 : r.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (m = d, g = y === "end" ? "top" : "bottom");
      const f = p - c.top - c.bottom, v = h - c.left - c.right, k = va(p - c[g], f), w = va(h - c[m], v), S = t.middlewareData.shift, T = !S;
      let C = k, A = w;
      S != null && S.enabled.x && (A = v), S != null && S.enabled.y && (C = f), T && !y && (u ? A = h - 2 * Kt(c.left, c.right) : C = p - 2 * Kt(c.top, c.bottom)), await i({
        ...t,
        availableWidth: A,
        availableHeight: C
      });
      const M = await r.getDimensions(l.floating);
      return h !== M.width || p !== M.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Zl() {
  return typeof window < "u";
}
function Go(e) {
  return hh(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function lt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function da(e) {
  var t;
  return (t = (hh(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function hh(e) {
  return Zl() ? e instanceof Node || e instanceof lt(e).Node : !1;
}
function Ut(e) {
  return Zl() ? e instanceof Element || e instanceof lt(e).Element : !1;
}
function Ca(e) {
  return Zl() ? e instanceof HTMLElement || e instanceof lt(e).HTMLElement : !1;
}
function dp(e) {
  return !Zl() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof lt(e).ShadowRoot;
}
function Jl(e) {
  const {
    overflow: t,
    overflowX: a,
    overflowY: o,
    display: r
  } = Gt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + a) && r !== "inline" && r !== "contents";
}
function GD(e) {
  return /^(table|td|th)$/.test(Go(e));
}
function Kl(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const YD = /transform|translate|scale|rotate|perspective|filter/, XD = /paint|layout|strict|content/, Ma = (e) => !!e && e !== "none";
let Oi;
function pc(e) {
  const t = Ut(e) ? Gt(e) : e;
  return Ma(t.transform) || Ma(t.translate) || Ma(t.scale) || Ma(t.rotate) || Ma(t.perspective) || !uc() && (Ma(t.backdropFilter) || Ma(t.filter)) || YD.test(t.willChange || "") || XD.test(t.contain || "");
}
function jD(e) {
  let t = Da(e);
  for (; Ca(t) && !mr(t); ) {
    if (pc(t))
      return t;
    if (Kl(t))
      return null;
    t = Da(t);
  }
  return null;
}
function uc() {
  return Oi == null && (Oi = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Oi;
}
function mr(e) {
  return /^(html|body|#document)$/.test(Go(e));
}
function Gt(e) {
  return lt(e).getComputedStyle(e);
}
function Ql(e) {
  return Ut(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Da(e) {
  if (Go(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    dp(e) && e.host || // Fallback.
    da(e)
  );
  return dp(t) ? t.host : t;
}
function bh(e) {
  const t = Da(e);
  return mr(t) ? (e.ownerDocument || e).body : Ca(t) && Jl(t) ? t : bh(t);
}
function gr(e, t, a) {
  var o;
  t === void 0 && (t = []), a === void 0 && (a = !0);
  const r = bh(e), l = r === ((o = e.ownerDocument) == null ? void 0 : o.body), i = lt(r);
  if (l) {
    const n = Qn(i);
    return t.concat(i, i.visualViewport || [], Jl(r) ? r : [], n && a ? gr(n) : []);
  } else
    return t.concat(r, gr(r, [], a));
}
function Qn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function mh(e) {
  const t = Gt(e);
  let a = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = Ca(e), l = r ? e.offsetWidth : a, i = r ? e.offsetHeight : o, n = Ml(a) !== l || Ml(o) !== i;
  return n && (a = l, o = i), {
    width: a,
    height: o,
    $: n
  };
}
function yc(e) {
  return Ut(e) ? e : e.contextElement;
}
function To(e) {
  const t = yc(e);
  if (!Ca(t))
    return Qt(1);
  const a = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: l
  } = mh(t);
  let i = (l ? Ml(a.width) : a.width) / o, n = (l ? Ml(a.height) : a.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!n || !Number.isFinite(n)) && (n = 1), {
    x: i,
    y: n
  };
}
const qD = /* @__PURE__ */ Qt(0);
function gh(e) {
  const t = lt(e);
  return !uc() || !t.visualViewport ? qD : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function ZD(e, t, a) {
  return t === void 0 && (t = !1), !!a && t && a === lt(e);
}
function Fa(e, t, a, o) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  const r = e.getBoundingClientRect(), l = yc(e);
  let i = Qt(1);
  t && (o ? Ut(o) && (i = To(o)) : i = To(e));
  const n = ZD(l, a, o) ? gh(l) : Qt(0);
  let c = (r.left + n.x) / i.x, d = (r.top + n.y) / i.y, y = r.width / i.x, u = r.height / i.y;
  if (l && o) {
    const h = lt(l), p = Ut(o) ? lt(o) : o;
    let g = h, m = Qn(g);
    for (; m && p !== g; ) {
      const f = To(m), v = m.getBoundingClientRect(), k = Gt(m), w = v.left + (m.clientLeft + parseFloat(k.paddingLeft)) * f.x, S = v.top + (m.clientTop + parseFloat(k.paddingTop)) * f.y;
      c *= f.x, d *= f.y, y *= f.x, u *= f.y, c += w, d += S, g = lt(m), m = Qn(g);
    }
  }
  return El({
    width: y,
    height: u,
    x: c,
    y: d
  });
}
function ei(e, t) {
  const a = Ql(e).scrollLeft;
  return t ? t.left + a : Fa(da(e)).left + a;
}
function fh(e, t) {
  const a = e.getBoundingClientRect(), o = a.left + t.scrollLeft - ei(e, a), r = a.top + t.scrollTop;
  return {
    x: o,
    y: r
  };
}
function JD(e) {
  let {
    elements: t,
    rect: a,
    offsetParent: o,
    strategy: r
  } = e;
  const l = r === "fixed", i = da(o), n = t ? Kl(t.floating) : !1;
  if (o === i || n && l)
    return a;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = Qt(1);
  const y = Qt(0), u = Ca(o);
  if ((u || !l) && ((Go(o) !== "body" || Jl(i)) && (c = Ql(o)), u)) {
    const p = Fa(o);
    d = To(o), y.x = p.x + o.clientLeft, y.y = p.y + o.clientTop;
  }
  const h = i && !u && !l ? fh(i, c) : Qt(0);
  return {
    width: a.width * d.x,
    height: a.height * d.y,
    x: a.x * d.x - c.scrollLeft * d.x + y.x + h.x,
    y: a.y * d.y - c.scrollTop * d.y + y.y + h.y
  };
}
function KD(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function QD(e) {
  const t = Ql(e), a = e.ownerDocument.body, o = Kt(e.scrollWidth, e.clientWidth, a.scrollWidth, a.clientWidth), r = Kt(e.scrollHeight, e.clientHeight, a.scrollHeight, a.clientHeight);
  let l = -t.scrollLeft + ei(e);
  const i = -t.scrollTop;
  return Gt(a).direction === "rtl" && (l += Kt(e.clientWidth, a.clientWidth) - o), {
    width: o,
    height: r,
    x: l,
    y: i
  };
}
const eF = 25;
function tF(e, t, a) {
  a === void 0 && (a = "viewport");
  const o = a === "layoutViewport", r = lt(e), l = da(e), i = r.visualViewport;
  let n = l.clientWidth, c = l.clientHeight, d = 0, y = 0;
  if (i) {
    const h = !uc() || t === "fixed";
    o ? h || (d = -i.offsetLeft, y = -i.offsetTop) : (n = i.width, c = i.height, h && (d = i.offsetLeft, y = i.offsetTop));
  }
  if (ei(l) <= 0) {
    const h = l.ownerDocument, p = h.body, g = getComputedStyle(p), m = h.compatMode === "CSS1Compat" && parseFloat(g.marginLeft) + parseFloat(g.marginRight) || 0, f = Math.abs(l.clientWidth - p.clientWidth - m), v = getComputedStyle(l).scrollbarGutter === "stable both-edges" ? f / 2 : f;
    v <= eF && (n -= v);
  }
  return {
    width: n,
    height: c,
    x: d,
    y
  };
}
function aF(e, t) {
  const a = Fa(e, !0, t === "fixed"), o = a.top + e.clientTop, r = a.left + e.clientLeft, l = To(e), i = e.clientWidth * l.x, n = e.clientHeight * l.y, c = r * l.x, d = o * l.y;
  return {
    width: i,
    height: n,
    x: c,
    y: d
  };
}
function pp(e, t, a) {
  let o;
  if (t === "viewport" || t === "layoutViewport")
    o = tF(e, a, t);
  else if (t === "document")
    o = QD(da(e));
  else if (Ut(t))
    o = aF(t, a);
  else {
    const r = gh(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return El(o);
}
function oF(e, t) {
  const a = t.get(e);
  if (a)
    return a;
  let o = gr(e, [], !1).filter((n) => Ut(n) && Go(n) !== "body"), r = null;
  const l = Gt(e).position === "fixed";
  let i = l ? Da(e) : e;
  for (; Ut(i) && !mr(i); ) {
    const n = Gt(i), c = pc(i), d = r ? r.position : l ? "fixed" : "";
    !c && (d === "fixed" || d === "absolute" && n.position === "static") ? o = o.filter((u) => u !== i) : r = n, i = Da(i);
  }
  return t.set(e, o), o;
}
function rF(e) {
  let {
    element: t,
    boundary: a,
    rootBoundary: o,
    strategy: r
  } = e;
  const i = [...a === "clippingAncestors" ? Kl(t) ? [] : oF(t, this._c) : [].concat(a), o], n = pp(t, i[0], r);
  let c = n.top, d = n.right, y = n.bottom, u = n.left;
  for (let h = 1; h < i.length; h++) {
    const p = pp(t, i[h], r);
    c = Kt(p.top, c), d = va(p.right, d), y = va(p.bottom, y), u = Kt(p.left, u);
  }
  return {
    width: d - u,
    height: y - c,
    x: u,
    y: c
  };
}
function lF(e) {
  const {
    width: t,
    height: a
  } = mh(e);
  return {
    width: t,
    height: a
  };
}
function iF(e, t, a) {
  const o = Ca(t), r = da(t), l = a === "fixed", i = Fa(e, !0, l, t);
  let n = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Qt(0);
  if ((o || !l) && ((Go(t) !== "body" || Jl(r)) && (n = Ql(t)), o)) {
    const h = Fa(t, !0, l, t);
    c.x = h.x + t.clientLeft, c.y = h.y + t.clientTop;
  }
  !o && r && (c.x = ei(r));
  const d = r && !o && !l ? fh(r, n) : Qt(0), y = i.left + n.scrollLeft - c.x - d.x, u = i.top + n.scrollTop - c.y - d.y;
  return {
    x: y,
    y: u,
    width: i.width,
    height: i.height
  };
}
function Ri(e) {
  return Gt(e).position === "static";
}
function up(e, t) {
  if (!Ca(e) || Gt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let a = e.offsetParent;
  return da(e) === a && (a = a.ownerDocument.body), a;
}
function vh(e, t) {
  const a = lt(e);
  if (Kl(e))
    return a;
  if (!Ca(e)) {
    let r = Da(e);
    for (; r && !mr(r); ) {
      if (Ut(r) && !Ri(r))
        return r;
      r = Da(r);
    }
    return a;
  }
  let o = up(e, t);
  for (; o && GD(o) && Ri(o); )
    o = up(o, t);
  return o && mr(o) && Ri(o) && !pc(o) ? a : o || jD(e) || a;
}
const nF = async function(e) {
  const t = this.getOffsetParent || vh, a = this.getDimensions, o = await a(e.floating);
  return {
    reference: iF(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function sF(e) {
  return Gt(e).direction === "rtl";
}
const cF = {
  convertOffsetParentRelativeRectToViewportRelativeRect: JD,
  getDocumentElement: da,
  getClippingRect: rF,
  getOffsetParent: vh,
  getElementRects: nF,
  getClientRects: KD,
  getDimensions: lF,
  getScale: To,
  isElement: Ut,
  isRTL: sF
};
function kh(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function dF(e, t, a) {
  let o = null, r;
  const l = da(e);
  function i() {
    var y;
    clearTimeout(r), (y = o) == null || y.disconnect(), o = null;
  }
  function n(y, u) {
    y === void 0 && (y = !1), u === void 0 && (u = 1), i();
    const h = e.getBoundingClientRect(), {
      left: p,
      top: g,
      width: m,
      height: f
    } = h;
    if (y || t(), !m || !f)
      return;
    const v = il(g), k = il(l.clientWidth - (p + m)), w = il(l.clientHeight - (g + f)), S = il(p), C = {
      rootMargin: -v + "px " + -k + "px " + -w + "px " + -S + "px",
      threshold: Kt(0, va(1, u)) || 1
    };
    let A = !0;
    function M(E) {
      const F = E[0].intersectionRatio;
      if (!kh(h, e.getBoundingClientRect()))
        return n();
      if (F !== u) {
        if (!A)
          return n();
        F ? n(!1, F) : r = setTimeout(() => {
          n(!1, 1e-7);
        }, 1e3);
      }
      A = !1;
    }
    try {
      o = new IntersectionObserver(M, {
        ...C,
        // Handle <iframe>s
        root: l.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(M, C);
    }
    o.observe(e);
  }
  const c = lt(e), d = () => n(a);
  return c.addEventListener("resize", d), n(!0), () => {
    c.removeEventListener("resize", d), i();
  };
}
function pF(e, t, a, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: l = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: n = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = o, d = yc(e), y = r || l ? [...d ? gr(d) : [], ...t ? gr(t) : []] : [];
  y.forEach((v) => {
    r && v.addEventListener("scroll", a), l && v.addEventListener("resize", a);
  });
  const u = d && n ? dF(d, a, l) : null;
  let h = -1, p = null;
  i && (p = new ResizeObserver((v) => {
    let [k] = v;
    k && k.target === d && p && t && (p.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var w;
      (w = p) == null || w.observe(t);
    })), a();
  }), d && !c && p.observe(d), t && p.observe(t));
  let g, m = c ? Fa(e) : null;
  c && f();
  function f() {
    const v = Fa(e);
    m && !kh(m, v) && a(), m = v, g = requestAnimationFrame(f);
  }
  return a(), () => {
    var v;
    y.forEach((k) => {
      r && k.removeEventListener("scroll", a), l && k.removeEventListener("resize", a);
    }), u == null || u(), (v = p) == null || v.disconnect(), p = null, c && cancelAnimationFrame(g);
  };
}
const uF = $D, yF = _D, hF = zD, bF = UD, mF = VD, yp = BD, gF = HD, fF = (e, t, a) => {
  const o = /* @__PURE__ */ new Map(), r = a ?? {}, l = {
    ...cF,
    ...r.platform,
    _c: o
  };
  return RD(e, t, {
    ...r,
    platform: l
  });
};
var vF = typeof document < "u", kF = function() {
}, hl = vF ? Ep : kF;
function Dl(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let a, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (a = e.length, a !== t.length) return !1;
      for (o = a; o-- !== 0; )
        if (!Dl(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), a = r.length, a !== Object.keys(t).length)
      return !1;
    for (o = a; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = a; o-- !== 0; ) {
      const l = r[o];
      if (!(l === "_owner" && e.$$typeof) && !Dl(e[l], t[l]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function wh(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function hp(e, t) {
  const a = wh(e);
  return Math.round(t * a) / a;
}
function Bi(e) {
  const t = b.useRef(e);
  return hl(() => {
    t.current = e;
  }), t;
}
function wF(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: a = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: l,
      floating: i
    } = {},
    transform: n = !0,
    whileElementsMounted: c,
    open: d
  } = e, [y, u] = b.useState({
    x: 0,
    y: 0,
    strategy: a,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, p] = b.useState(o);
  Dl(h, o) || p(o);
  const [g, m] = b.useState(null), [f, v] = b.useState(null), k = b.useCallback((H) => {
    H !== C.current && (C.current = H, m(H));
  }, []), w = b.useCallback((H) => {
    H !== A.current && (A.current = H, v(H));
  }, []), S = l || g, T = i || f, C = b.useRef(null), A = b.useRef(null), M = b.useRef(y), E = c != null, F = Bi(c), I = Bi(r), P = Bi(d), O = b.useCallback(() => {
    if (!C.current || !A.current)
      return;
    const H = {
      placement: t,
      strategy: a,
      middleware: h
    };
    I.current && (H.platform = I.current), fF(C.current, A.current, H).then((N) => {
      const D = {
        ...N,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: P.current !== !1
      };
      z.current && !Dl(M.current, D) && (M.current = D, wr.flushSync(() => {
        u(D);
      }));
    });
  }, [h, t, a, I, P]);
  hl(() => {
    d === !1 && M.current.isPositioned && (M.current.isPositioned = !1, u((H) => ({
      ...H,
      isPositioned: !1
    })));
  }, [d]);
  const z = b.useRef(!1);
  hl(() => (z.current = !0, () => {
    z.current = !1;
  }), []), hl(() => {
    if (S && (C.current = S), T && (A.current = T), S && T) {
      if (F.current)
        return F.current(S, T, O);
      O();
    }
  }, [S, T, O, F, E]);
  const U = b.useMemo(() => ({
    reference: C,
    floating: A,
    setReference: k,
    setFloating: w
  }), [k, w]), Y = b.useMemo(() => ({
    reference: S,
    floating: T
  }), [S, T]), _ = b.useMemo(() => {
    const H = {
      position: a,
      left: 0,
      top: 0
    };
    if (!Y.floating)
      return H;
    const N = hp(Y.floating, y.x), D = hp(Y.floating, y.y);
    return n ? {
      ...H,
      transform: "translate(" + N + "px, " + D + "px)",
      ...wh(Y.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: a,
      left: N,
      top: D
    };
  }, [a, n, Y.floating, y.x, y.y]);
  return b.useMemo(() => ({
    ...y,
    update: O,
    refs: U,
    elements: Y,
    floatingStyles: _
  }), [y, O, U, Y, _]);
}
const SF = (e) => {
  function t(a) {
    return {}.hasOwnProperty.call(a, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(a) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(a) : e;
      return o && t(o) ? o.current != null ? yp({
        element: o.current,
        padding: r
      }).fn(a) : {} : o ? yp({
        element: o,
        padding: r
      }).fn(a) : {};
    }
  };
}, xF = (e, t) => {
  const a = uF(e);
  return {
    name: a.name,
    fn: a.fn,
    options: [e, t]
  };
}, TF = (e, t) => {
  const a = yF(e);
  return {
    name: a.name,
    fn: a.fn,
    options: [e, t]
  };
}, CF = (e, t) => ({
  fn: gF(e).fn,
  options: [e, t]
}), PF = (e, t) => {
  const a = hF(e);
  return {
    name: a.name,
    fn: a.fn,
    options: [e, t]
  };
}, AF = (e, t) => {
  const a = bF(e);
  return {
    name: a.name,
    fn: a.fn,
    options: [e, t]
  };
}, LF = (e, t) => {
  const a = mF(e);
  return {
    name: a.name,
    fn: a.fn,
    options: [e, t]
  };
}, MF = (e, t) => {
  const a = SF(e);
  return {
    name: a.name,
    fn: a.fn,
    options: [e, t]
  };
};
var NF = Object.defineProperty, ga = (e, t) => NF(e, "name", { value: t, configurable: !0 }), Sh = "Popper", [xh, ti] = /* @__PURE__ */ Ot(Sh), [EF, Th] = xh(Sh), DF = /* @__PURE__ */ ga((e) => {
  const { __scopePopper: t, children: a } = e, [o, r] = b.useState(null), [l, i] = b.useState(void 0);
  return /* @__PURE__ */ s(
    EF,
    {
      scope: t,
      anchor: o,
      onAnchorChange: r,
      placementState: l,
      setPlacementState: i,
      children: a
    }
  );
}, "Popper"), FF = "PopperAnchor", IF = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ ga(function(t, a) {
    const { __scopePopper: o, virtualRef: r, ...l } = t, i = Th(FF, o), n = b.useRef(null), c = i.onAnchorChange, d = b.useCallback(
      (m) => {
        n.current = m, m && c(m);
      },
      [c]
    ), y = ye(a, d), u = b.useRef(null);
    b.useEffect(() => {
      if (!r)
        return;
      const m = u.current;
      u.current = r.current, m !== u.current && c(u.current);
    });
    const h = i.placementState && ai(i.placementState), p = h == null ? void 0 : h[0], g = h == null ? void 0 : h[1];
    return r ? null : /* @__PURE__ */ s(
      ge.div,
      {
        "data-radix-popper-side": p,
        "data-radix-popper-align": g,
        ...l,
        ref: y
      }
    );
  }, "PopperAnchor")
), Ch = "PopperContent", [OF, BB] = xh(Ch), RF = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ ga(function(t, a) {
    var re, Z, ie, K, se, Pe, G;
    const {
      __scopePopper: o,
      side: r = "bottom",
      sideOffset: l = 0,
      align: i = "center",
      alignOffset: n = 0,
      arrowPadding: c = 0,
      avoidCollisions: d = !0,
      collisionBoundary: y = [],
      collisionPadding: u = 0,
      sticky: h = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: g = "optimized",
      onPlaced: m,
      ...f
    } = t, v = Th(Ch, o), [k, w] = b.useState(null), S = ye(a, w), [T, C] = b.useState(null), A = oc(T), M = (A == null ? void 0 : A.width) ?? 0, E = (A == null ? void 0 : A.height) ?? 0, F = r + (i !== "center" ? "-" + i : ""), I = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, P = Array.isArray(y) ? y : [y], O = P.length > 0, z = {
      padding: I,
      boundary: P.filter(Ph),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: O
    }, { refs: U, floatingStyles: Y, placement: _, isPositioned: H, middlewareData: N } = wF({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: F,
      whileElementsMounted: /* @__PURE__ */ ga((...L) => pF(...L, {
        animationFrame: g === "always"
      }), "whileElementsMounted"),
      elements: {
        reference: v.anchor
      },
      middleware: [
        xF({ mainAxis: l + E, alignmentAxis: n }),
        d && TF({
          mainAxis: !0,
          crossAxis: !1,
          limiter: h === "partial" ? CF() : void 0,
          ...z
        }),
        d && PF({ ...z }),
        AF({
          ...z,
          apply: /* @__PURE__ */ ga(({ elements: L, rects: B, availableWidth: Q, availableHeight: xe }) => {
            const { width: ue, height: Re } = B.reference, Je = L.floating.style;
            Je.setProperty("--radix-popper-available-width", `${Q}px`), Je.setProperty("--radix-popper-available-height", `${xe}px`), Je.setProperty("--radix-popper-anchor-width", `${ue}px`), Je.setProperty("--radix-popper-anchor-height", `${Re}px`);
          }, "apply")
        }),
        T && MF({ element: T, padding: c }),
        BF({ arrowWidth: M, arrowHeight: E }),
        p && LF({
          strategy: "referenceHidden",
          ...z,
          // `hide` detects whether the anchor (reference) is clipped, so when
          // no explicit `collisionBoundary` is set we fall back to Floating
          // UI's default clipping ancestors (e.g. a scrollable menu). This
          // lets an occluded submenu hide once its anchor scrolls out of view
          // (#3237). The collision/size middlewares deliberately keep the
          // viewport-based default to avoid clamping content rendered inside
          // transformed or overflow-clipping portal containers.
          boundary: O ? z.boundary : void 0
        })
      ]
    }), D = v.setPlacementState;
    We(() => (D(_), () => {
      D(void 0);
    }), [_, D]);
    const [$, V] = ai(_), X = Ue(m);
    We(() => {
      H && (X == null || X());
    }, [H, X]);
    const oe = (re = N.arrow) == null ? void 0 : re.x, pe = (Z = N.arrow) == null ? void 0 : Z.y, Se = ((ie = N.arrow) == null ? void 0 : ie.centerOffset) !== 0, [ae, q] = b.useState();
    return We(() => {
      k && q(window.getComputedStyle(k).zIndex);
    }, [k]), /* @__PURE__ */ s(
      "div",
      {
        ref: U.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...Y,
          transform: H ? Y.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ae,
          "--radix-popper-transform-origin": [
            (K = N.transformOrigin) == null ? void 0 : K.x,
            (se = N.transformOrigin) == null ? void 0 : se.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Pe = N.hide) == null ? void 0 : Pe.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ s(
          OF,
          {
            scope: o,
            placedSide: $,
            placedAlign: V,
            onArrowChange: C,
            arrowX: oe,
            arrowY: pe,
            shouldHideArrow: Se,
            children: /* @__PURE__ */ s(
              ge.div,
              {
                "data-side": $,
                "data-align": V,
                ...f,
                ref: S,
                style: {
                  ...f.style,
                  // if the PopperContent hasn't been placed yet (not all
                  // measurements done) we prevent animations so that users'
                  // animations don't kick in too early from the wrong sides.
                  animation: H ? (G = f.style) == null ? void 0 : G.animation : "none"
                }
              }
            )
          }
        )
      }
    );
  }, "PopperContent")
);
function Ph(e) {
  return e !== null;
}
ga(Ph, "isNotNull");
var BF = /* @__PURE__ */ ga((e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var f, v, k;
    const { placement: a, rects: o, middlewareData: r } = t, i = ((f = r.arrow) == null ? void 0 : f.centerOffset) !== 0, n = i ? 0 : e.arrowWidth, c = i ? 0 : e.arrowHeight, [d, y] = ai(a), u = { start: "0%", center: "50%", end: "100%" }[y], h = (((v = r.arrow) == null ? void 0 : v.x) ?? 0) + n / 2, p = (((k = r.arrow) == null ? void 0 : k.y) ?? 0) + c / 2;
    let g = "", m = "";
    return d === "bottom" ? (g = i ? u : `${h}px`, m = `${-c}px`) : d === "top" ? (g = i ? u : `${h}px`, m = `${o.floating.height + c}px`) : d === "right" ? (g = `${-c}px`, m = i ? u : `${p}px`) : d === "left" && (g = `${o.floating.width + c}px`, m = i ? u : `${p}px`), { data: { x: g, y: m } };
  }
}), "transformOrigin");
function ai(e) {
  const [t, a = "center"] = e.split("-");
  return [t, a];
}
ga(ai, "getSideAndAlignFromPlacement");
var Ah = DF, Lh = IF, Mh = RF, zF = Object.defineProperty, VF = (e, t) => zF(e, "name", { value: t, configurable: !0 });
function Nh(e) {
  const t = b.useRef({ value: e, previous: e });
  return b.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
VF(Nh, "usePrevious");
var WF = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), $F = Object.defineProperty, we = (e, t) => $F(e, "name", { value: t, configurable: !0 }), _F = [" ", "Enter", "ArrowUp", "ArrowDown"], HF = [" ", "Enter"], Lo = "Select", [oi, ri, UF] = /* @__PURE__ */ ql(Lo), [lo, zB] = /* @__PURE__ */ Ot(Lo, [
  UF,
  ti
]), hc = ti(), [GF, Pa] = lo(Lo), [YF, XF] = lo(Lo);
function Eh(e) {
  const {
    __scopeSelect: t,
    children: a,
    open: o,
    defaultOpen: r,
    onOpenChange: l,
    value: i,
    defaultValue: n,
    onValueChange: c,
    dir: d,
    name: y,
    autoComplete: u,
    disabled: h,
    required: p,
    form: g,
    // @ts-expect-error internal render prop used by `Select` to compose its default parts
    internal_do_not_use_render: m
  } = e, f = hc(t), [v, k] = b.useState(null), [w, S] = b.useState(null), [T, C] = b.useState(!1), A = Cr(d), [M, E] = Ea({
    prop: o,
    defaultProp: r ?? !1,
    onChange: l,
    caller: Lo
  }), [F, I] = Ea({
    prop: i,
    defaultProp: n,
    onChange: c,
    caller: Lo
  }), P = b.useRef(null), O = b.useRef(F);
  b.useEffect(() => {
    const V = g ? v == null ? void 0 : v.ownerDocument.getElementById(g) : v == null ? void 0 : v.form;
    if (V instanceof HTMLFormElement) {
      const X = /* @__PURE__ */ we(() => I(O.current), "reset");
      return V.addEventListener("reset", X), () => V.removeEventListener("reset", X);
    }
  }, [g, v, I]);
  const z = v ? !!g || !!v.closest("form") : !0, [U, Y] = b.useState(/* @__PURE__ */ new Set()), _ = Jt(), H = Array.from(U).map((V) => V.props.value).join(";"), N = b.useCallback((V) => {
    Y((X) => new Set(X).add(V));
  }, []), D = b.useCallback((V) => {
    Y((X) => {
      const oe = new Set(X);
      return oe.delete(V), oe;
    });
  }, []), $ = {
    required: p,
    trigger: v,
    onTriggerChange: k,
    valueNode: w,
    onValueNodeChange: S,
    valueNodeHasChildren: T,
    onValueNodeHasChildrenChange: C,
    contentId: _,
    value: F,
    onValueChange: I,
    open: M,
    onOpenChange: E,
    dir: A,
    triggerPointerDownPosRef: P,
    disabled: h,
    name: y,
    autoComplete: u,
    form: g,
    nativeOptions: U,
    nativeSelectKey: H,
    isFormControl: z
  };
  return /* @__PURE__ */ s(Ah, { ...f, children: /* @__PURE__ */ s(GF, { scope: t, ...$, children: /* @__PURE__ */ s(oi.Provider, { scope: t, children: /* @__PURE__ */ s(
    YF,
    {
      scope: t,
      onNativeOptionAdd: N,
      onNativeOptionRemove: D,
      children: _h(m) ? m($) : a
    }
  ) }) }) });
}
we(Eh, "SelectProvider");
var jF = /* @__PURE__ */ we((e) => {
  const { __scopeSelect: t, children: a, ...o } = e;
  return /* @__PURE__ */ s(
    Eh,
    {
      __scopeSelect: t,
      ...o,
      internal_do_not_use_render: ({ isFormControl: r }) => /* @__PURE__ */ x(ut, { children: [
        a,
        r ? /* @__PURE__ */ s(
          gI,
          {
            __scopeSelect: t
          }
        ) : null
      ] })
    }
  );
}, "Select"), qF = "SelectTrigger", Dh = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ we(function(t, a) {
    const { __scopeSelect: o, disabled: r = !1, ...l } = t, i = hc(o), n = Pa(qF, o), c = n.disabled || r, d = ye(a, n.onTriggerChange), y = ri(o), u = b.useRef("touch"), [h, p, g] = mc((f) => {
      const v = y().filter((S) => !S.disabled), k = v.find((S) => S.value === n.value), w = gc(v, f, k);
      w !== void 0 && n.onValueChange(w.value);
    }), m = /* @__PURE__ */ we((f) => {
      c || (n.onOpenChange(!0), g()), f && (n.triggerPointerDownPosRef.current = {
        x: Math.round(f.pageX),
        y: Math.round(f.pageY)
      });
    }, "handleOpen");
    return /* @__PURE__ */ s(Lh, { asChild: !0, ...i, children: /* @__PURE__ */ s(
      ge.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": n.open ? n.contentId : void 0,
        "aria-expanded": n.open,
        "aria-required": n.required,
        "aria-autocomplete": "none",
        dir: n.dir,
        "data-state": n.open ? "open" : "closed",
        disabled: c,
        "data-disabled": c ? "" : void 0,
        "data-placeholder": Er(n.value) ? "" : void 0,
        ...l,
        ref: d,
        onClick: J(l.onClick, (f) => {
          f.currentTarget.focus(), u.current !== "mouse" && m(f);
        }),
        onPointerDown: J(l.onPointerDown, (f) => {
          u.current = f.pointerType;
          const v = f.target;
          v.hasPointerCapture(f.pointerId) && v.releasePointerCapture(f.pointerId), f.button === 0 && f.ctrlKey === !1 && f.pointerType === "mouse" && (m(f), f.preventDefault());
        }),
        onKeyDown: J(l.onKeyDown, (f) => {
          const v = h.current !== "";
          !(f.ctrlKey || f.altKey || f.metaKey) && f.key.length === 1 && p(f.key), !(v && f.key === " ") && _F.includes(f.key) && (m(), f.preventDefault());
        })
      }
    ) });
  }, "SelectTrigger")
), ZF = "SelectValue", JF = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ we(function(t, a) {
    const { __scopeSelect: o, className: r, style: l, children: i, placeholder: n = "", ...c } = t, d = Pa(ZF, o), { onValueNodeHasChildrenChange: y } = d, u = i !== void 0, h = ye(a, d.onValueNodeChange);
    We(() => {
      y(u);
    }, [y, u]);
    const p = Er(d.value);
    return /* @__PURE__ */ s(
      ge.span,
      {
        ...c,
        asChild: p ? !1 : c.asChild,
        ref: h,
        style: { pointerEvents: "none" },
        children: /* @__PURE__ */ s(b.Fragment, { children: p ? n : i }, p ? "placeholder" : "value")
      }
    );
  }, "SelectValue")
), KF = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ we(function(t, a) {
    const { __scopeSelect: o, children: r, ...l } = t;
    return /* @__PURE__ */ s(ge.span, { "aria-hidden": !0, ...l, ref: a, children: r || "▼" });
  }, "SelectIcon")
), QF = "SelectPortal", [eI, tI] = lo(QF, {
  forceMount: void 0
}), aI = /* @__PURE__ */ we((e) => {
  const { __scopeSelect: t, forceMount: a, ...o } = e;
  return /* @__PURE__ */ s(eI, { scope: e.__scopeSelect, forceMount: a, children: /* @__PURE__ */ s(Zs, { asChild: !0, ...o }) });
}, "SelectPortal"), Ia = "SelectContent", Fh = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ we(function(t, a) {
    const o = tI(Ia, t.__scopeSelect), { forceMount: r = o.forceMount, ...l } = t, i = Pa(Ia, t.__scopeSelect), [n, c] = b.useState();
    return We(() => {
      c(new DocumentFragment());
    }, []), /* @__PURE__ */ s(bt, { present: r || i.open, children: ({ present: d }) => d ? /* @__PURE__ */ s(lI, { ...l, ref: a }) : /* @__PURE__ */ s(oI, { ...l, fragment: n }) });
  }, "SelectContent")
), oI = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ we(function(t, a) {
  const { __scopeSelect: o, children: r, fragment: l } = t;
  return l ? wr.createPortal(
    /* @__PURE__ */ s(Ih, { scope: o, children: /* @__PURE__ */ s(oi.Slot, { scope: o, children: /* @__PURE__ */ s("div", { ref: a, children: r }) }) }),
    l
  ) : null;
}, "SelectContentFragment")), wt = 10, [Ih, io] = lo(Ia), rI = /* @__PURE__ */ Ht("SelectContent.RemoveScroll"), lI = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ we(function(t, a) {
    const { __scopeSelect: o } = t, {
      position: r = "item-aligned",
      onCloseAutoFocus: l,
      onEscapeKeyDown: i,
      onPointerDownOutside: n,
      //
      // PopperContent props
      side: c,
      sideOffset: d,
      align: y,
      alignOffset: u,
      arrowPadding: h,
      collisionBoundary: p,
      collisionPadding: g,
      sticky: m,
      hideWhenDetached: f,
      avoidCollisions: v,
      //
      ...k
    } = t, w = Pa(Ia, o), [S, T] = b.useState(null), [C, A] = b.useState(null), M = ye(a, T), [E, F] = b.useState(null), [I, P] = b.useState(
      null
    ), O = ri(o), [z, U] = b.useState(!1), Y = b.useRef(!1);
    b.useEffect(() => {
      if (S) return Ks(S);
    }, [S]), Mr();
    const _ = b.useCallback(
      (q) => {
        const [re, ...Z] = O().map((se) => se.ref.current), [ie] = Z.slice(-1), K = document.activeElement;
        for (const se of q)
          if (se === K || (se == null || se.scrollIntoView({ block: "nearest" }), se === re && C && (C.scrollTop = 0), se === ie && C && (C.scrollTop = C.scrollHeight), se == null || se.focus(), document.activeElement !== K)) return;
      },
      [O, C]
    ), H = b.useCallback(
      () => _([E, S]),
      [_, E, S]
    );
    b.useEffect(() => {
      z && H();
    }, [z, H]);
    const { onOpenChange: N, triggerPointerDownPosRef: D } = w;
    b.useEffect(() => {
      if (S) {
        let q = { x: 0, y: 0 };
        const re = /* @__PURE__ */ we((ie) => {
          var K, se;
          q = {
            x: Math.abs(Math.round(ie.pageX) - (((K = D.current) == null ? void 0 : K.x) ?? 0)),
            y: Math.abs(Math.round(ie.pageY) - (((se = D.current) == null ? void 0 : se.y) ?? 0))
          };
        }, "handlePointerMove"), Z = /* @__PURE__ */ we((ie) => {
          q.x <= 10 && q.y <= 10 ? ie.preventDefault() : ie.composedPath().includes(S) || N(!1), document.removeEventListener("pointermove", re), D.current = null;
        }, "handlePointerUp");
        return D.current !== null && (document.addEventListener("pointermove", re), document.addEventListener("pointerup", Z, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", re), document.removeEventListener("pointerup", Z, { capture: !0 });
        };
      }
    }, [S, N, D]), b.useEffect(() => {
      const q = /* @__PURE__ */ we(() => N(!1), "close");
      return window.addEventListener("blur", q), window.addEventListener("resize", q), () => {
        window.removeEventListener("blur", q), window.removeEventListener("resize", q);
      };
    }, [N]);
    const [$, V] = mc((q) => {
      const re = O().filter((K) => !K.disabled), Z = re.find((K) => K.ref.current === document.activeElement), ie = gc(re, q, Z);
      ie && setTimeout(() => {
        var K;
        return (K = ie.ref.current) == null ? void 0 : K.focus();
      });
    }), X = b.useCallback(
      (q, re, Z) => {
        const ie = !Y.current && !Z;
        (w.value !== void 0 && w.value === re || ie) && (F(q), ie && (Y.current = !0));
      },
      [w.value]
    ), oe = b.useCallback(() => S == null ? void 0 : S.focus(), [S]), pe = b.useCallback(
      (q, re, Z) => {
        const ie = !Y.current && !Z;
        (w.value !== void 0 && w.value === re || ie) && P(q);
      },
      [w.value]
    ), Se = r === "popper" ? bp : iI, ae = Se === bp ? {
      side: c,
      sideOffset: d,
      align: y,
      alignOffset: u,
      arrowPadding: h,
      collisionBoundary: p,
      collisionPadding: g,
      sticky: m,
      hideWhenDetached: f,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ s(
      Ih,
      {
        scope: o,
        content: S,
        viewport: C,
        onViewportChange: A,
        itemRefCallback: X,
        selectedItem: E,
        onItemLeave: oe,
        itemTextRefCallback: pe,
        focusSelectedItem: H,
        selectedItemText: I,
        position: r,
        isPositioned: z,
        searchRef: $,
        children: /* @__PURE__ */ s(jl, { as: rI, allowPinchZoom: !0, children: /* @__PURE__ */ s(
          js,
          {
            asChild: !0,
            trapped: w.open,
            onMountAutoFocus: (q) => {
              q.preventDefault();
            },
            onUnmountAutoFocus: J(l, (q) => {
              var re;
              (re = w.trigger) == null || re.focus({ preventScroll: !0 }), q.preventDefault();
            }),
            children: /* @__PURE__ */ s(
              Ys,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: n,
                onFocusOutside: (q) => q.preventDefault(),
                onDismiss: () => w.onOpenChange(!1),
                children: /* @__PURE__ */ s(
                  Se,
                  {
                    role: "listbox",
                    id: w.contentId,
                    "data-state": w.open ? "open" : "closed",
                    dir: w.dir,
                    onContextMenu: (q) => q.preventDefault(),
                    ...k,
                    ...ae,
                    onPlaced: () => U(!0),
                    ref: M,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...k.style
                    },
                    onKeyDown: J(k.onKeyDown, (q) => {
                      const re = q.ctrlKey || q.altKey || q.metaKey;
                      if (q.key === "Tab" && q.preventDefault(), !re && q.key.length === 1 && V(q.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(q.key)) {
                        let ie = O().filter((K) => !K.disabled).map((K) => K.ref.current);
                        if (["ArrowUp", "End"].includes(q.key) && (ie = ie.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(q.key)) {
                          const K = q.target, se = ie.indexOf(K);
                          ie = ie.slice(se + 1);
                        }
                        setTimeout(() => _(ie)), q.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }, "SelectContentImpl")
), iI = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ we(function(t, a) {
  const { __scopeSelect: o, onPlaced: r, ...l } = t, i = Pa(Ia, o), n = io(Ia, o), [c, d] = b.useState(null), [y, u] = b.useState(null), h = ye(a, u), p = ri(o), g = b.useRef(!1), m = b.useRef(!0), { viewport: f, selectedItem: v, selectedItemText: k, focusSelectedItem: w } = n, S = b.useCallback(() => {
    if (i.trigger && i.valueNode && c && y && f && v && k) {
      const M = i.trigger.getBoundingClientRect(), E = y.getBoundingClientRect(), F = i.valueNode.getBoundingClientRect(), I = k.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const K = I.left - E.left, se = F.left - K, Pe = M.left - se, G = M.width + Pe, L = Math.max(G, E.width), B = window.innerWidth - wt, Q = Ll(se, [
          wt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(wt, B - L)
        ]);
        c.style.minWidth = G + "px", c.style.left = Q + "px";
      } else {
        const K = E.right - I.right, se = window.innerWidth - F.right - K, Pe = window.innerWidth - M.right - se, G = M.width + Pe, L = Math.max(G, E.width), B = window.innerWidth - wt, Q = Ll(se, [
          wt,
          Math.max(wt, B - L)
        ]);
        c.style.minWidth = G + "px", c.style.right = Q + "px";
      }
      const P = p(), O = window.innerHeight - wt * 2, z = f.scrollHeight, U = window.getComputedStyle(y), Y = parseInt(U.borderTopWidth, 10), _ = parseInt(U.paddingTop, 10), H = parseInt(U.borderBottomWidth, 10), N = parseInt(U.paddingBottom, 10), D = Y + _ + z + N + H, $ = Math.min(v.offsetHeight * 5, D), V = window.getComputedStyle(f), X = parseInt(V.paddingTop, 10), oe = parseInt(V.paddingBottom, 10), pe = M.top + M.height / 2 - wt, Se = O - pe, ae = v.offsetHeight / 2, q = v.offsetTop + ae, re = Y + _ + q, Z = D - re;
      if (re <= pe) {
        const K = P.length > 0 && v === P[P.length - 1].ref.current;
        c.style.bottom = "0px";
        const se = y.clientHeight - f.offsetTop - f.offsetHeight, Pe = Math.max(
          Se,
          ae + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (K ? oe : 0) + se + H
        ), G = re + Pe;
        c.style.height = G + "px";
      } else {
        const K = P.length > 0 && v === P[0].ref.current;
        c.style.top = "0px";
        const Pe = Math.max(
          pe,
          Y + f.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (K ? X : 0) + ae
        ) + Z;
        c.style.height = Pe + "px", f.scrollTop = re - pe + f.offsetTop;
      }
      c.style.margin = `${wt}px 0`, c.style.minHeight = $ + "px", c.style.maxHeight = O + "px", r == null || r(), requestAnimationFrame(() => g.current = !0);
    }
  }, [
    p,
    i.trigger,
    i.valueNode,
    c,
    y,
    f,
    v,
    k,
    i.dir,
    r
  ]);
  We(() => S(), [S]);
  const [T, C] = b.useState();
  We(() => {
    y && C(window.getComputedStyle(y).zIndex);
  }, [y]);
  const A = b.useCallback(
    (M) => {
      M && m.current === !0 && (S(), w == null || w(), m.current = !1);
    },
    [S, w]
  );
  return /* @__PURE__ */ s(
    nI,
    {
      scope: o,
      contentWrapper: c,
      shouldExpandOnScrollRef: g,
      onScrollButtonChange: A,
      children: /* @__PURE__ */ s(
        "div",
        {
          ref: d,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: T
          },
          children: /* @__PURE__ */ s(
            ge.div,
            {
              ...l,
              ref: h,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...l.style
              }
            }
          )
        }
      )
    }
  );
}, "SelectItemAlignedPosition")), bp = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ we(function(t, a) {
  const {
    __scopeSelect: o,
    align: r = "start",
    collisionPadding: l = wt,
    ...i
  } = t, n = hc(o);
  return /* @__PURE__ */ s(
    Mh,
    {
      ...n,
      ...i,
      ref: a,
      align: r,
      collisionPadding: l,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
}, "SelectPopperPosition")), [nI, bc] = lo(Ia, {}), mp = "SelectViewport", sI = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ we(function(t, a) {
    const { __scopeSelect: o, nonce: r, ...l } = t, i = io(mp, o), n = bc(mp, o), c = ye(a, i.onViewportChange), d = b.useRef(0);
    return /* @__PURE__ */ x(ut, { children: [
      /* @__PURE__ */ s(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ s(oi.Slot, { scope: o, children: /* @__PURE__ */ s(
        ge.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...l,
          ref: c,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...l.style
          },
          onScroll: J(l.onScroll, (y) => {
            const u = y.currentTarget, { contentWrapper: h, shouldExpandOnScrollRef: p } = n;
            if (p != null && p.current && h) {
              const g = Math.abs(d.current - u.scrollTop);
              if (g > 0) {
                const m = window.innerHeight - wt * 2, f = parseFloat(h.style.minHeight), v = parseFloat(h.style.height), k = Math.max(f, v);
                if (k < m) {
                  const w = k + g, S = Math.min(m, w), T = w - S;
                  h.style.height = S + "px", h.style.bottom === "0px" && (u.scrollTop = T > 0 ? T : 0, h.style.justifyContent = "flex-end");
                }
              }
            }
            d.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }, "SelectViewport")
), cI = "SelectGroup", [VB, dI] = lo(cI), pI = "SelectLabel", Oh = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ we(function(t, a) {
    const { __scopeSelect: o, ...r } = t, l = dI(pI, o);
    return /* @__PURE__ */ s(ge.div, { id: l.id, ...r, ref: a });
  }, "SelectLabel")
), es = "SelectItem", [uI, Rh] = lo(es), Bh = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ we(function(t, a) {
    const {
      __scopeSelect: o,
      value: r,
      disabled: l = !1,
      textValue: i,
      ...n
    } = t, c = Pa(es, o), d = io(es, o), y = c.value === r, [u, h] = b.useState(i ?? ""), [p, g] = b.useState(!1), m = Ue(
      (S) => {
        var T;
        return (T = d.itemRefCallback) == null ? void 0 : T.call(d, S, r, l);
      }
    ), f = ye(a, m), v = Jt(), k = b.useRef("touch"), w = /* @__PURE__ */ we(() => {
      l || (c.onValueChange(r), c.onOpenChange(!1));
    }, "handleSelect");
    return /* @__PURE__ */ s(
      uI,
      {
        scope: o,
        value: r,
        disabled: l,
        textId: v,
        isSelected: y,
        onItemTextChange: b.useCallback((S) => {
          h((T) => T || ((S == null ? void 0 : S.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ s(
          oi.ItemSlot,
          {
            scope: o,
            value: r,
            disabled: l,
            textValue: u,
            children: /* @__PURE__ */ s(
              ge.div,
              {
                role: "option",
                "aria-labelledby": v,
                "data-highlighted": p ? "" : void 0,
                "aria-selected": y && p,
                "data-state": y ? "checked" : "unchecked",
                "aria-disabled": l || void 0,
                "data-disabled": l ? "" : void 0,
                tabIndex: l ? void 0 : -1,
                ...n,
                ref: f,
                onFocus: J(n.onFocus, () => g(!0)),
                onBlur: J(n.onBlur, () => g(!1)),
                onClick: J(n.onClick, () => {
                  k.current !== "mouse" && w();
                }),
                onPointerUp: J(n.onPointerUp, () => {
                  k.current === "mouse" && w();
                }),
                onPointerDown: J(n.onPointerDown, (S) => {
                  k.current = S.pointerType;
                }),
                onPointerMove: J(n.onPointerMove, (S) => {
                  var T;
                  k.current = S.pointerType, l ? (T = d.onItemLeave) == null || T.call(d) : k.current === "mouse" && S.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: J(n.onPointerLeave, (S) => {
                  var T;
                  S.currentTarget === document.activeElement && ((T = d.onItemLeave) == null || T.call(d));
                }),
                onKeyDown: J(n.onKeyDown, (S) => {
                  var C;
                  l || S.target !== S.currentTarget || ((C = d.searchRef) == null ? void 0 : C.current) !== "" && S.key === " " || (HF.includes(S.key) && w(), S.key === " " && S.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }, "SelectItem")
), nl = "SelectItemText", yI = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ we(function(t, a) {
    const { __scopeSelect: o, className: r, style: l, ...i } = t, n = Pa(nl, o), c = io(nl, o), d = Rh(nl, o), y = XF(nl, o), [u, h] = b.useState(null), p = Ue(
      (w) => {
        var S;
        return (S = c.itemTextRefCallback) == null ? void 0 : S.call(c, w, d.value, d.disabled);
      }
    ), g = ye(
      a,
      h,
      d.onItemTextChange,
      p
    ), m = u == null ? void 0 : u.textContent, f = b.useMemo(
      () => /* @__PURE__ */ s("option", { value: d.value, disabled: d.disabled, children: m }, d.value),
      [d.disabled, d.value, m]
    ), { onNativeOptionAdd: v, onNativeOptionRemove: k } = y;
    return We(() => (v(f), () => k(f)), [v, k, f]), /* @__PURE__ */ x(ut, { children: [
      /* @__PURE__ */ s(ge.span, { id: d.textId, ...i, ref: g }),
      d.isSelected && n.valueNode && !n.valueNodeHasChildren && !Er(n.value) ? wr.createPortal(i.children, n.valueNode) : null
    ] });
  }, "SelectItemText")
), hI = "SelectItemIndicator", bI = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ we(function(t, a) {
    const { __scopeSelect: o, ...r } = t;
    return Rh(hI, o).isSelected ? /* @__PURE__ */ s(ge.span, { "aria-hidden": !0, ...r, ref: a }) : null;
  }, "SelectItemIndicator")
), gp = "SelectScrollUpButton", zh = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ we(function(t, a) {
  const o = io(gp, t.__scopeSelect), r = bc(gp, t.__scopeSelect), [l, i] = b.useState(!1), n = ye(a, r.onScrollButtonChange);
  return We(() => {
    if (o.viewport && o.isPositioned) {
      let c = function() {
        const y = d.scrollTop > 0;
        i(y);
      };
      we(c, "handleScroll");
      const d = o.viewport;
      return c(), d.addEventListener("scroll", c), () => d.removeEventListener("scroll", c);
    }
  }, [o.viewport, o.isPositioned]), l ? /* @__PURE__ */ s(
    Wh,
    {
      ...t,
      ref: n,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: d } = o;
        c && d && (c.scrollTop = c.scrollTop - d.offsetHeight);
      }
    }
  ) : null;
}, "SelectScrollUpButton")), fp = "SelectScrollDownButton", Vh = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ we(function(t, a) {
  const o = io(fp, t.__scopeSelect), r = bc(fp, t.__scopeSelect), [l, i] = b.useState(!1), n = ye(a, r.onScrollButtonChange);
  return We(() => {
    if (o.viewport && o.isPositioned) {
      let c = function() {
        const y = d.scrollHeight - d.clientHeight, u = Math.ceil(d.scrollTop) < y;
        i(u);
      };
      we(c, "handleScroll");
      const d = o.viewport;
      return c(), d.addEventListener("scroll", c), () => d.removeEventListener("scroll", c);
    }
  }, [o.viewport, o.isPositioned]), l ? /* @__PURE__ */ s(
    Wh,
    {
      ...t,
      ref: n,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: d } = o;
        c && d && (c.scrollTop = c.scrollTop + d.offsetHeight);
      }
    }
  ) : null;
}, "SelectScrollDownButton")), Wh = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ we(function(t, a) {
  const { __scopeSelect: o, onAutoScroll: r, ...l } = t, i = io("SelectScrollButton", o), n = b.useRef(null), c = ri(o), d = b.useCallback(() => {
    n.current !== null && (window.clearInterval(n.current), n.current = null);
  }, []);
  return b.useEffect(() => () => d(), [d]), We(() => {
    var u;
    const y = c().find((h) => h.ref.current === document.activeElement);
    (u = y == null ? void 0 : y.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [c]), /* @__PURE__ */ s(
    ge.div,
    {
      "aria-hidden": !0,
      ...l,
      ref: a,
      style: { flexShrink: 0, ...l.style },
      onPointerDown: J(l.onPointerDown, () => {
        n.current === null && (n.current = window.setInterval(r, 50));
      }),
      onPointerMove: J(l.onPointerMove, () => {
        var y;
        (y = i.onItemLeave) == null || y.call(i), n.current === null && (n.current = window.setInterval(r, 50));
      }),
      onPointerLeave: J(l.onPointerLeave, () => {
        d();
      })
    }
  );
}, "SelectScrollButtonImpl")), $h = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ we(function(t, a) {
    const { __scopeSelect: o, ...r } = t;
    return /* @__PURE__ */ s(ge.div, { "aria-hidden": !0, ...r, ref: a });
  }, "SelectSeparator")
), mI = "SelectBubbleInput", gI = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ we(function({ __scopeSelect: t, ...a }, o) {
    const r = Pa(mI, t), { value: l, onValueChange: i, required: n, disabled: c, name: d, autoComplete: y, form: u } = r, { nativeOptions: h, nativeSelectKey: p } = r, g = b.useRef(null), m = ye(o, g), f = l ?? "", v = Nh(f), k = Array.from(h).some(
      (w) => (w.props.value ?? "") === ""
    );
    return b.useEffect(() => {
      const w = g.current;
      if (!w) return;
      const S = window.HTMLSelectElement.prototype, C = Object.getOwnPropertyDescriptor(
        S,
        "value"
      ).set;
      if (v !== f && C) {
        const A = new Event("change", { bubbles: !0 });
        C.call(w, f), w.dispatchEvent(A);
      }
    }, [v, f]), /* @__PURE__ */ x(
      ge.select,
      {
        "aria-hidden": !0,
        required: n,
        tabIndex: -1,
        name: d,
        autoComplete: y,
        disabled: c,
        form: u,
        onChange: (w) => i(w.target.value),
        ...a,
        style: { ...WF, ...a.style },
        ref: m,
        defaultValue: f,
        children: [
          Er(l) && !k ? /* @__PURE__ */ s("option", { value: "" }) : null,
          Array.from(h)
        ]
      },
      p
    );
  }, "SelectBubbleInput")
);
function _h(e) {
  return typeof e == "function";
}
we(_h, "isFunction");
function Er(e) {
  return e === "" || e === void 0;
}
we(Er, "shouldShowPlaceholder");
function mc(e) {
  const t = Ue(e), a = b.useRef(""), o = b.useRef(0), r = b.useCallback(
    (i) => {
      const n = a.current + i;
      t(n), (/* @__PURE__ */ we((function c(d) {
        a.current = d, window.clearTimeout(o.current), d !== "" && (o.current = window.setTimeout(() => c(""), 1e3));
      }), "updateSearch"))(n);
    },
    [t]
  ), l = b.useCallback(() => {
    a.current = "", window.clearTimeout(o.current);
  }, []);
  return b.useEffect(() => () => window.clearTimeout(o.current), []), [a, r, l];
}
we(mc, "useTypeaheadSearch");
function gc(e, t, a) {
  const r = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, l = a ? e.indexOf(a) : -1;
  let i = Hh(e, Math.max(l, 0));
  r.length === 1 && (i = i.filter((d) => d !== a));
  const c = i.find(
    (d) => d.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return c !== a ? c : void 0;
}
we(gc, "findNextItem");
function Hh(e, t) {
  return e.map((a, o) => e[(t + o) % e.length]);
}
we(Hh, "wrapArray");
const wa = jF, Sa = JF, oa = b.forwardRef(({ className: e, children: t, ...a }, o) => /* @__PURE__ */ x(
  Dh,
  {
    ref: o,
    className: Ce(
      ac,
      "flex h-8 items-center justify-between py-1 focus:border-ring focus:ring-1 focus:ring-ring data-[placeholder]:text-placeholder-foreground [&>span]:line-clamp-1",
      e
    ),
    ...a,
    children: [
      t,
      /* @__PURE__ */ s(KF, { asChild: !0, children: /* @__PURE__ */ s(Bl, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
oa.displayName = Dh.displayName;
const Uh = b.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ s(
  zh,
  {
    ref: a,
    className: Ce("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ s(oA, { className: "h-4 w-4" })
  }
));
Uh.displayName = zh.displayName;
const Gh = b.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ s(
  Vh,
  {
    ref: a,
    className: Ce("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ s(Bl, { className: "h-4 w-4" })
  }
));
Gh.displayName = Vh.displayName;
const ra = b.forwardRef(({ className: e, children: t, position: a = "popper", ...o }, r) => {
  const l = tc();
  return /* @__PURE__ */ s(aI, { container: l, children: /* @__PURE__ */ x(
    Fh,
    {
      ref: r,
      className: Ce(
        "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-lg bg-popover text-popover-foreground shadow-dropdown data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        a === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: a,
      ...o,
      children: [
        /* @__PURE__ */ s(Uh, {}),
        /* @__PURE__ */ s(
          sI,
          {
            className: Ce(
              "p-1",
              a === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ s(Gh, {})
      ]
    }
  ) });
});
ra.displayName = Fh.displayName;
const fI = b.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ s(
  Oh,
  {
    ref: a,
    className: Ce("py-1.5 pl-8 pr-2 text-xs font-medium text-muted-foreground", e),
    ...t
  }
));
fI.displayName = Oh.displayName;
const la = b.forwardRef(({ className: e, children: t, ...a }, o) => /* @__PURE__ */ x(
  Bh,
  {
    ref: o,
    className: Ce(
      "relative flex w-full cursor-default select-none items-center rounded-md py-1.5 pl-8 pr-2 text-sm outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 focus:bg-accent focus:text-ink",
      e
    ),
    ...a,
    children: [
      /* @__PURE__ */ s("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ s(bI, { children: /* @__PURE__ */ s(cr, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ s(yI, { children: t })
    ]
  }
));
la.displayName = Bh.displayName;
const vI = b.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ s(
  $h,
  {
    ref: a,
    className: Ce("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
vI.displayName = $h.displayName;
var kI = Object.defineProperty, fc = (e, t) => kI(e, "name", { value: t, configurable: !0 }), zi = !1;
function Yh() {
  const [e, t] = b.useState(zi);
  return b.useEffect(() => {
    zi || (zi = !0, t(!0));
  }, []), e;
}
fc(Yh, "useIsHydrated");
var Xh = b[" useSyncExternalStore ".trim().toString()];
function jh() {
  return () => {
  };
}
fc(jh, "subscribe");
function qh() {
  return Xh(
    jh,
    () => !0,
    () => !1
  );
}
fc(qh, "useIsHydratedModern");
var wI = typeof Xh == "function" ? qh : Yh, SI = Object.defineProperty, no = (e, t) => SI(e, "name", { value: t, configurable: !0 }), Vi = "rovingFocusGroup.onEntryFocus", xI = { bubbles: !1, cancelable: !0 }, li = "RovingFocusGroup", [ts, Zh, TI] = /* @__PURE__ */ ql(li), [CI, Jh] = /* @__PURE__ */ Ot(
  li,
  [TI]
), [PI, AI] = CI(li), LI = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ no(function(t, a) {
    return /* @__PURE__ */ s(ts.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ s(ts.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ s(MI, { ...t, ref: a }) }) });
  }, "RovingFocusGroup")
), MI = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ no(function(t, a) {
  const {
    __scopeRovingFocusGroup: o,
    orientation: r,
    loop: l = !1,
    dir: i,
    currentTabStopId: n,
    defaultCurrentTabStopId: c,
    onCurrentTabStopIdChange: d,
    onEntryFocus: y,
    preventScrollOnEntryFocus: u = !1,
    ...h
  } = t, p = b.useRef(null), g = ye(a, p), m = Cr(i), [f, v] = Ea({
    prop: n,
    defaultProp: c ?? null,
    onChange: d,
    caller: li
  }), [k, w] = b.useState(!1), S = Ue(y), T = Zh(o), C = b.useRef(!1), [A, M] = b.useState(0);
  return b.useEffect(() => {
    const E = p.current;
    if (E)
      return E.addEventListener(Vi, S), () => E.removeEventListener(Vi, S);
  }, [S]), /* @__PURE__ */ s(
    PI,
    {
      scope: o,
      orientation: r,
      dir: m,
      loop: l,
      currentTabStopId: f,
      onItemFocus: b.useCallback(
        (E) => v(E),
        [v]
      ),
      onItemShiftTab: b.useCallback(() => w(!0), []),
      onFocusableItemAdd: b.useCallback(
        () => M((E) => E + 1),
        []
      ),
      onFocusableItemRemove: b.useCallback(
        () => M((E) => E - 1),
        []
      ),
      children: /* @__PURE__ */ s(
        ge.div,
        {
          tabIndex: k || A === 0 ? -1 : 0,
          "data-orientation": r,
          ...h,
          ref: g,
          style: { outline: "none", ...t.style },
          onMouseDown: J(t.onMouseDown, () => {
            C.current = !0;
          }),
          onFocus: J(t.onFocus, (E) => {
            const F = !C.current;
            if (E.target === E.currentTarget && F && !k) {
              const I = new CustomEvent(Vi, xI);
              if (E.currentTarget.dispatchEvent(I), !I.defaultPrevented) {
                const P = T().filter((_) => _.focusable), O = P.find((_) => _.active), z = P.find((_) => _.id === f), Y = [O, z, ...P].filter(
                  Boolean
                ).map((_) => _.ref.current);
                vc(Y, u);
              }
            }
            C.current = !1;
          }),
          onBlur: J(t.onBlur, () => w(!1))
        }
      )
    }
  );
}, "RovingFocusGroupImpl")), NI = "RovingFocusGroupItem", EI = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ no(function(t, a) {
    const {
      __scopeRovingFocusGroup: o,
      focusable: r = !0,
      active: l = !1,
      tabStopId: i,
      children: n,
      ...c
    } = t, d = Jt(), y = i || d, u = AI(NI, o), h = u.currentTabStopId === y, p = Zh(o), { onFocusableItemAdd: g, onFocusableItemRemove: m, currentTabStopId: f } = u, v = wI();
    return We(() => {
      if (!(!v || !r))
        return g(), () => m();
    }, [v, r, g, m]), b.useEffect(() => {
      if (!(v || !r))
        return g(), () => m();
    }, [v, r, g, m]), /* @__PURE__ */ s(
      ts.ItemSlot,
      {
        scope: o,
        id: y,
        focusable: r,
        active: l,
        children: /* @__PURE__ */ s(
          ge.span,
          {
            tabIndex: h ? 0 : -1,
            "data-orientation": u.orientation,
            ...c,
            ref: a,
            onMouseDown: J(t.onMouseDown, (k) => {
              r ? u.onItemFocus(y) : k.preventDefault();
            }),
            onFocus: J(t.onFocus, () => u.onItemFocus(y)),
            onKeyDown: J(t.onKeyDown, (k) => {
              if (k.key === "Tab" && k.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (k.target !== k.currentTarget) return;
              const w = Qh(k, u.orientation, u.dir);
              if (w !== void 0) {
                if (k.metaKey || k.ctrlKey || k.altKey || k.shiftKey) return;
                k.preventDefault();
                let T = p().filter((C) => C.focusable).map((C) => C.ref.current);
                if (w === "last") T.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && T.reverse();
                  const C = T.indexOf(k.currentTarget);
                  T = u.loop ? eb(T, C + 1) : T.slice(C + 1);
                }
                setTimeout(() => vc(T));
              }
            }),
            children: typeof n == "function" ? n({ isCurrentTabStop: h, hasTabStop: f != null }) : n
          }
        )
      }
    );
  }, "RovingFocusGroupItem")
), DI = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Kh(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
no(Kh, "getDirectionAwareKey");
function Qh(e, t, a) {
  const o = Kh(e.key, a);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return DI[o];
}
no(Qh, "getFocusIntent");
function vc(e, t = !1) {
  const a = document.activeElement;
  for (const o of e)
    if (o === a || (o.focus({ preventScroll: t }), document.activeElement !== a)) return;
}
no(vc, "focusFirst");
function eb(e, t) {
  return e.map((a, o) => e[(t + o) % e.length]);
}
no(eb, "wrapArray");
var FI = LI, II = EI, OI = Object.defineProperty, Te = (e, t) => OI(e, "name", { value: t, configurable: !0 }), as = ["Enter", " "], RI = ["ArrowDown", "PageUp", "Home"], tb = ["ArrowUp", "PageDown", "End"], BI = [...RI, ...tb], zI = {
  ltr: [...as, "ArrowRight"],
  rtl: [...as, "ArrowLeft"]
}, VI = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, ii = "Menu", [fr, WI, $I] = /* @__PURE__ */ ql(ii), [so, ab] = /* @__PURE__ */ Ot(ii, [
  $I,
  ti,
  Jh
]), kc = ti(), ob = Jh(), [_I, co] = so(ii), [HI, Dr] = so(ii), UI = /* @__PURE__ */ Te((e) => {
  const { __scopeMenu: t, open: a = !1, children: o, dir: r, onOpenChange: l, modal: i = !0 } = e, n = kc(t), [c, d] = b.useState(null), y = b.useRef(!1), u = Ue(l), h = Cr(r);
  return b.useEffect(() => {
    const p = /* @__PURE__ */ Te(() => {
      y.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, "handleKeyDown"), g = /* @__PURE__ */ Te(() => y.current = !1, "handlePointer");
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), b.useEffect(() => {
    if (!a)
      return;
    const p = /* @__PURE__ */ Te(() => u(!1), "handleBlur");
    return window.addEventListener("blur", p), () => window.removeEventListener("blur", p);
  }, [a, u]), /* @__PURE__ */ s(Ah, { ...n, children: /* @__PURE__ */ s(
    _I,
    {
      scope: t,
      open: a,
      onOpenChange: u,
      content: c,
      onContentChange: d,
      children: /* @__PURE__ */ s(
        HI,
        {
          scope: t,
          onClose: b.useCallback(() => u(!1), [u]),
          isUsingKeyboardRef: y,
          dir: h,
          modal: i,
          children: o
        }
      )
    }
  ) });
}, "Menu"), rb = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ Te(function(t, a) {
    const { __scopeMenu: o, ...r } = t, l = kc(o);
    return /* @__PURE__ */ s(Lh, { ...l, ...r, ref: a });
  }, "MenuAnchor")
), lb = "MenuPortal", [GI, ib] = so(lb, {
  forceMount: void 0
}), YI = /* @__PURE__ */ Te((e) => {
  const { __scopeMenu: t, forceMount: a, children: o, container: r } = e, l = co(lb, t);
  return /* @__PURE__ */ s(GI, { scope: t, forceMount: a, children: /* @__PURE__ */ s(bt, { present: a || l.open, children: /* @__PURE__ */ s(Zs, { asChild: !0, container: r, children: o }) }) });
}, "MenuPortal"), Tt = "MenuContent", [XI, wc] = so(Tt), jI = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ Te(function(t, a) {
    const o = ib(Tt, t.__scopeMenu), { forceMount: r = o.forceMount, ...l } = t, i = co(Tt, t.__scopeMenu), n = Dr(Tt, t.__scopeMenu);
    return /* @__PURE__ */ s(fr.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ s(bt, { present: r || i.open, children: /* @__PURE__ */ s(fr.Slot, { scope: t.__scopeMenu, children: n.modal ? /* @__PURE__ */ s(qI, { ...l, ref: a }) : /* @__PURE__ */ s(ZI, { ...l, ref: a }) }) }) });
  }, "MenuContent")
), qI = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Te(function(t, a) {
    const o = co(Tt, t.__scopeMenu), r = b.useRef(null), l = ye(a, r);
    return b.useEffect(() => {
      const i = r.current;
      if (i) return Ks(i);
    }, []), /* @__PURE__ */ s(
      Sc,
      {
        ...t,
        ref: l,
        trapFocus: o.open,
        disableOutsidePointerEvents: o.open,
        disableOutsideScroll: !0,
        onFocusOutside: J(
          t.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => o.onOpenChange(!1)
      }
    );
  }, "MenuRootContentModal")
), ZI = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ Te(function(t, a) {
  const o = co(Tt, t.__scopeMenu);
  return /* @__PURE__ */ s(
    Sc,
    {
      ...t,
      ref: a,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => o.onOpenChange(!1)
    }
  );
}, "MenuRootContentNonModal")), JI = /* @__PURE__ */ Ht("MenuContent.ScrollLock"), Sc = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Te(function(t, a) {
    const {
      __scopeMenu: o,
      loop: r = !1,
      trapFocus: l,
      onOpenAutoFocus: i,
      onCloseAutoFocus: n,
      disableOutsidePointerEvents: c,
      onEntryFocus: d,
      onEscapeKeyDown: y,
      onPointerDownOutside: u,
      onFocusOutside: h,
      onInteractOutside: p,
      onDismiss: g,
      disableOutsideScroll: m,
      ...f
    } = t, v = co(Tt, o), k = Dr(Tt, o), w = kc(o), S = ob(o), T = WI(o), [C, A] = b.useState(null), M = b.useRef(null), E = ye(a, M, v.onContentChange), F = b.useRef(0), I = b.useRef(""), P = b.useRef(0), O = b.useRef(null), z = b.useRef("right"), U = b.useRef(0), Y = m ? jl : b.Fragment, _ = m ? { as: JI, allowPinchZoom: !0 } : void 0, H = /* @__PURE__ */ Te((D) => {
      var q, re;
      const $ = I.current + D, V = T().filter((Z) => !Z.disabled), X = document.activeElement, oe = (q = V.find((Z) => Z.ref.current === X)) == null ? void 0 : q.textValue, pe = V.map((Z) => Z.textValue), Se = yb(pe, $, oe), ae = (re = V.find((Z) => Z.textValue === Se)) == null ? void 0 : re.ref.current;
      (/* @__PURE__ */ Te((function Z(ie) {
        I.current = ie, window.clearTimeout(F.current), ie !== "" && (F.current = window.setTimeout(() => Z(""), 1e3));
      }), "updateSearch"))($), ae && setTimeout(() => ae.focus());
    }, "handleTypeaheadSearch");
    b.useEffect(() => () => window.clearTimeout(F.current), []), Mr();
    const N = b.useCallback((D) => {
      var V, X;
      return z.current === ((V = O.current) == null ? void 0 : V.side) && bb(D, (X = O.current) == null ? void 0 : X.area);
    }, []);
    return /* @__PURE__ */ s(
      XI,
      {
        scope: o,
        searchRef: I,
        onItemEnter: b.useCallback(
          (D) => {
            N(D) && D.preventDefault();
          },
          [N]
        ),
        onItemLeave: b.useCallback(
          (D) => {
            var $;
            N(D) || (($ = M.current) == null || $.focus(), A(null));
          },
          [N]
        ),
        onTriggerLeave: b.useCallback(
          (D) => {
            N(D) && D.preventDefault();
          },
          [N]
        ),
        pointerGraceTimerRef: P,
        onPointerGraceIntentChange: b.useCallback((D) => {
          O.current = D;
        }, []),
        children: /* @__PURE__ */ s(Y, { ..._, children: /* @__PURE__ */ s(
          js,
          {
            asChild: !0,
            trapped: l,
            onMountAutoFocus: J(i, (D) => {
              var $;
              D.preventDefault(), ($ = M.current) == null || $.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: n,
            children: /* @__PURE__ */ s(
              Ys,
              {
                asChild: !0,
                disableOutsidePointerEvents: c,
                onEscapeKeyDown: y,
                onPointerDownOutside: u,
                onFocusOutside: h,
                onInteractOutside: p,
                onDismiss: g,
                children: /* @__PURE__ */ s(
                  FI,
                  {
                    asChild: !0,
                    ...S,
                    dir: k.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: C,
                    onCurrentTabStopIdChange: A,
                    onEntryFocus: J(d, (D) => {
                      k.isUsingKeyboardRef.current || D.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ s(
                      Mh,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Tc(v.open),
                        "data-radix-menu-content": "",
                        dir: k.dir,
                        ...w,
                        ...f,
                        ref: E,
                        style: { outline: "none", ...f.style },
                        onKeyDown: J(f.onKeyDown, (D) => {
                          const V = D.target.closest("[data-radix-menu-content]") === D.currentTarget, X = D.ctrlKey || D.altKey || D.metaKey, oe = D.key.length === 1;
                          V && (D.key === "Tab" && D.preventDefault(), !X && oe && H(D.key));
                          const pe = M.current;
                          if (D.target !== pe || !BI.includes(D.key)) return;
                          D.preventDefault();
                          const ae = T().filter((q) => !q.disabled).map((q) => q.ref.current);
                          tb.includes(D.key) && ae.reverse(), pb(ae);
                        }),
                        onBlur: J(t.onBlur, (D) => {
                          D.currentTarget.contains(D.target) || (window.clearTimeout(F.current), I.current = "");
                        }),
                        onPointerMove: J(
                          t.onPointerMove,
                          Mo((D) => {
                            const $ = D.target, V = U.current !== D.clientX;
                            if (D.currentTarget.contains($) && V) {
                              const X = D.clientX > U.current ? "right" : "left";
                              z.current = X, U.current = D.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }, "MenuContentImpl")
), KI = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ Te(function(t, a) {
    const { __scopeMenu: o, ...r } = t;
    return /* @__PURE__ */ s(ge.div, { ...r, ref: a });
  }, "MenuLabel")
), os = "MenuItem", vp = "menu.itemSelect", xc = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Te(function(t, a) {
    const { disabled: o = !1, onSelect: r, ...l } = t, i = b.useRef(null), n = Dr(os, t.__scopeMenu), c = wc(os, t.__scopeMenu), d = ye(a, i), y = b.useRef(!1), u = /* @__PURE__ */ Te(() => {
      const h = i.current;
      if (!o && h) {
        const p = new CustomEvent(vp, { bubbles: !0, cancelable: !0 });
        h.addEventListener(vp, (g) => r == null ? void 0 : r(g), { once: !0 }), Ws(h, p), p.defaultPrevented ? y.current = !1 : n.onClose();
      }
    }, "handleSelect");
    return /* @__PURE__ */ s(
      nb,
      {
        ...l,
        ref: d,
        disabled: o,
        onClick: J(t.onClick, u),
        onPointerDown: (h) => {
          var p;
          (p = t.onPointerDown) == null || p.call(t, h), y.current = !0;
        },
        onPointerUp: J(t.onPointerUp, (h) => {
          var p;
          y.current || (p = h.currentTarget) == null || p.click();
        }),
        onKeyDown: J(t.onKeyDown, (h) => {
          o || h.target !== h.currentTarget || c.searchRef.current !== "" && h.key === " " || as.includes(h.key) && (h.currentTarget.click(), h.preventDefault());
        })
      }
    );
  }, "MenuItem")
), nb = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ Te(function(t, a) {
    const { __scopeMenu: o, disabled: r = !1, textValue: l, ...i } = t, n = wc(os, o), c = ob(o), d = b.useRef(null), y = ye(a, d), [u, h] = b.useState(!1), [p, g] = b.useState("");
    return b.useEffect(() => {
      const m = d.current;
      m && g((m.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ s(
      fr.ItemSlot,
      {
        scope: o,
        disabled: r,
        textValue: l ?? p,
        children: /* @__PURE__ */ s(II, { asChild: !0, ...c, focusable: !r, children: /* @__PURE__ */ s(
          ge.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: y,
            onPointerMove: J(
              t.onPointerMove,
              Mo((m) => {
                r ? n.onItemLeave(m) : (n.onItemEnter(m), m.defaultPrevented || m.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: J(
              t.onPointerLeave,
              Mo((m) => n.onItemLeave(m))
            ),
            onFocus: J(t.onFocus, () => h(!0)),
            onBlur: J(t.onBlur, () => h(!1))
          }
        ) })
      }
    );
  }, "MenuItemImpl")
), QI = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Te(function(t, a) {
    const { checked: o = !1, onCheckedChange: r, ...l } = t;
    return /* @__PURE__ */ s(cb, { scope: t.__scopeMenu, checked: o, children: /* @__PURE__ */ s(
      xc,
      {
        role: "menuitemcheckbox",
        "aria-checked": vr(o) ? "mixed" : o,
        ...l,
        ref: a,
        "data-state": ni(o),
        onSelect: J(
          l.onSelect,
          () => r == null ? void 0 : r(vr(o) ? !0 : !o),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }, "MenuCheckboxItem")
), eO = "MenuRadioGroup", [WB, tO] = so(
  eO,
  { value: void 0, onValueChange: /* @__PURE__ */ Te(() => {
  }, "onValueChange") }
), aO = "MenuRadioItem", oO = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ Te(function(t, a) {
    const { value: o, ...r } = t, l = tO(aO, t.__scopeMenu), i = o === l.value;
    return /* @__PURE__ */ s(cb, { scope: t.__scopeMenu, checked: i, children: /* @__PURE__ */ s(
      xc,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: a,
        "data-state": ni(i),
        onSelect: J(
          r.onSelect,
          () => {
            var n;
            return (n = l.onValueChange) == null ? void 0 : n.call(l, o);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }, "MenuRadioItem")
), sb = "MenuItemIndicator", [cb, rO] = so(
  sb,
  { checked: !1 }
), lO = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Te(function(t, a) {
    const { __scopeMenu: o, forceMount: r, ...l } = t, i = rO(sb, o);
    return /* @__PURE__ */ s(
      bt,
      {
        present: r || vr(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ s(
          ge.span,
          {
            ...l,
            ref: a,
            "data-state": ni(i.checked)
          }
        )
      }
    );
  }, "MenuItemIndicator")
), iO = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ Te(function(t, a) {
    const { __scopeMenu: o, ...r } = t;
    return /* @__PURE__ */ s(
      ge.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: a
      }
    );
  }, "MenuSeparator")
), nO = "MenuSub", [$B, db] = so(nO), sl = "MenuSubTrigger", sO = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ Te(function(t, a) {
    const o = co(sl, t.__scopeMenu), r = Dr(sl, t.__scopeMenu), l = db(sl, t.__scopeMenu), i = wc(sl, t.__scopeMenu), n = b.useRef(null), { pointerGraceTimerRef: c, onPointerGraceIntentChange: d } = i, y = { __scopeMenu: t.__scopeMenu }, u = b.useCallback(() => {
      n.current && window.clearTimeout(n.current), n.current = null;
    }, []);
    b.useEffect(() => u, [u]), b.useEffect(() => {
      const p = c.current;
      return () => {
        window.clearTimeout(p), d(null);
      };
    }, [c, d]);
    const h = ye(a, l.onTriggerChange);
    return /* @__PURE__ */ s(rb, { asChild: !0, ...y, children: /* @__PURE__ */ s(
      nb,
      {
        id: l.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": o.open,
        "aria-controls": o.open ? l.contentId : void 0,
        "data-state": Tc(o.open),
        ...t,
        ref: h,
        onClick: (p) => {
          var g;
          (g = t.onClick) == null || g.call(t, p), !(t.disabled || p.defaultPrevented) && (p.currentTarget.focus(), o.open || o.onOpenChange(!0));
        },
        onPointerMove: J(
          t.onPointerMove,
          Mo((p) => {
            i.onItemEnter(p), !p.defaultPrevented && !t.disabled && !o.open && !n.current && (i.onPointerGraceIntentChange(null), n.current = window.setTimeout(() => {
              o.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: J(
          t.onPointerLeave,
          Mo((p) => {
            var m, f;
            u();
            const g = (m = o.content) == null ? void 0 : m.getBoundingClientRect();
            if (g) {
              const v = (f = o.content) == null ? void 0 : f.dataset.side, k = v === "right", w = k ? -5 : 5, S = g[k ? "left" : "right"], T = g[k ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: p.clientX + w, y: p.clientY },
                  { x: S, y: g.top },
                  { x: T, y: g.top },
                  { x: T, y: g.bottom },
                  { x: S, y: g.bottom }
                ],
                side: v
              }), window.clearTimeout(c.current), c.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(p), p.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: J(t.onKeyDown, (p) => {
          var m;
          t.disabled || p.target !== p.currentTarget || i.searchRef.current !== "" && p.key === " " || zI[r.dir].includes(p.key) && (o.onOpenChange(!0), (m = o.content) == null || m.focus(), p.preventDefault());
        })
      }
    ) });
  }, "MenuSubTrigger")
), cO = "MenuSubContent", dO = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ Te(function(t, a) {
    const o = ib(Tt, t.__scopeMenu), { forceMount: r = o.forceMount, align: l = "start", ...i } = t, n = co(Tt, t.__scopeMenu), c = Dr(Tt, t.__scopeMenu), d = db(cO, t.__scopeMenu), y = b.useRef(null), u = ye(a, y);
    return /* @__PURE__ */ s(fr.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ s(bt, { present: r || n.open, children: /* @__PURE__ */ s(fr.Slot, { scope: t.__scopeMenu, children: /* @__PURE__ */ s(
      Sc,
      {
        id: d.contentId,
        "aria-labelledby": d.triggerId,
        ...i,
        ref: u,
        align: l,
        side: c.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (h) => {
          var p;
          c.isUsingKeyboardRef.current && ((p = y.current) == null || p.focus()), h.preventDefault();
        },
        onCloseAutoFocus: (h) => h.preventDefault(),
        onFocusOutside: J(t.onFocusOutside, (h) => {
          h.target !== d.trigger && n.onOpenChange(!1);
        }),
        onEscapeKeyDown: J(t.onEscapeKeyDown, (h) => {
          c.onClose(), h.preventDefault();
        }),
        onKeyDown: J(t.onKeyDown, (h) => {
          var m;
          const p = h.currentTarget.contains(h.target), g = VI[c.dir].includes(h.key);
          p && g && (n.onOpenChange(!1), (m = d.trigger) == null || m.focus(), h.preventDefault());
        })
      }
    ) }) }) });
  }, "MenuSubContent")
);
function Tc(e) {
  return e ? "open" : "closed";
}
Te(Tc, "getOpenState");
function vr(e) {
  return e === "indeterminate";
}
Te(vr, "isIndeterminate");
function ni(e) {
  return vr(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
Te(ni, "getCheckedState");
function pb(e) {
  const t = document.activeElement;
  for (const a of e)
    if (a === t || (a.focus(), document.activeElement !== t)) return;
}
Te(pb, "focusFirst");
function ub(e, t) {
  return e.map((a, o) => e[(t + o) % e.length]);
}
Te(ub, "wrapArray");
function yb(e, t, a) {
  const r = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, l = a ? e.indexOf(a) : -1;
  let i = ub(e, Math.max(l, 0));
  r.length === 1 && (i = i.filter((d) => d !== a));
  const c = i.find(
    (d) => d.toLowerCase().startsWith(r.toLowerCase())
  );
  return c !== a ? c : void 0;
}
Te(yb, "getNextMatch");
function hb(e, t) {
  const { x: a, y: o } = e;
  let r = !1;
  for (let l = 0, i = t.length - 1; l < t.length; i = l++) {
    const n = t[l], c = t[i], d = n.x, y = n.y, u = c.x, h = c.y;
    y > o != h > o && a < (u - d) * (o - y) / (h - y) + d && (r = !r);
  }
  return r;
}
Te(hb, "isPointInPolygon");
function bb(e, t) {
  if (!t) return !1;
  const a = { x: e.clientX, y: e.clientY };
  return hb(a, t);
}
Te(bb, "isPointerInGraceArea");
function Mo(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
Te(Mo, "whenMouse");
var pO = UI, uO = rb, yO = YI, hO = jI, bO = KI, mO = xc, gO = QI, fO = oO, vO = lO, kO = iO, wO = sO, SO = dO, xO = Object.defineProperty, ft = (e, t) => xO(e, "name", { value: t, configurable: !0 }), Cc = "DropdownMenu", [TO, _B] = /* @__PURE__ */ Ot(
  Cc,
  [ab]
), vt = ab(), [CO, mb] = TO(Cc), PO = /* @__PURE__ */ ft((e) => {
  const {
    __scopeDropdownMenu: t,
    children: a,
    dir: o,
    open: r,
    defaultOpen: l,
    onOpenChange: i,
    modal: n = !0
  } = e, c = vt(t), d = b.useRef(null), [y, u] = Ea({
    prop: r,
    defaultProp: l ?? !1,
    onChange: i,
    caller: Cc
  });
  return /* @__PURE__ */ s(
    CO,
    {
      scope: t,
      triggerId: Jt(),
      triggerRef: d,
      contentId: Jt(),
      open: y,
      onOpenChange: u,
      onOpenToggle: b.useCallback(() => u((h) => !h), [u]),
      modal: n,
      children: /* @__PURE__ */ s(pO, { ...c, open: y, onOpenChange: u, dir: o, modal: n, children: a })
    }
  );
}, "DropdownMenu"), AO = "DropdownMenuTrigger", LO = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ ft(function(t, a) {
    const { __scopeDropdownMenu: o, disabled: r = !1, ...l } = t, i = mb(AO, o), n = vt(o), c = ye(a, i.triggerRef);
    return /* @__PURE__ */ s(uO, { asChild: !0, ...n, children: /* @__PURE__ */ s(
      ge.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...l,
        ref: c,
        onPointerDown: J(t.onPointerDown, (d) => {
          !r && d.button === 0 && d.ctrlKey === !1 && (i.onOpenToggle(), i.open || d.preventDefault());
        }),
        onKeyDown: J(t.onKeyDown, (d) => {
          r || (["Enter", " "].includes(d.key) && i.onOpenToggle(), d.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(d.key) && d.preventDefault());
        })
      }
    ) });
  }, "DropdownMenuTrigger")
), MO = /* @__PURE__ */ ft((e) => {
  const { __scopeDropdownMenu: t, ...a } = e, o = vt(t);
  return /* @__PURE__ */ s(yO, { ...o, ...a });
}, "DropdownMenuPortal"), NO = "DropdownMenuContent", EO = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ ft(function(t, a) {
    const { __scopeDropdownMenu: o, ...r } = t, l = mb(NO, o), i = vt(o), n = b.useRef(!1);
    return /* @__PURE__ */ s(
      hO,
      {
        id: l.contentId,
        "aria-labelledby": l.triggerId,
        ...i,
        ...r,
        ref: a,
        onCloseAutoFocus: J(t.onCloseAutoFocus, (c) => {
          var d;
          n.current || (d = l.triggerRef.current) == null || d.focus(), n.current = !1, c.preventDefault();
        }),
        onInteractOutside: J(t.onInteractOutside, (c) => {
          const d = c.detail.originalEvent, y = d.button === 0 && d.ctrlKey === !0, u = d.button === 2 || y;
          (!l.modal || u) && (n.current = !0);
        }),
        style: {
          ...t.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }, "DropdownMenuContent")
), DO = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ ft(function(t, a) {
    const { __scopeDropdownMenu: o, ...r } = t, l = vt(o);
    return /* @__PURE__ */ s(bO, { ...l, ...r, ref: a });
  }, "DropdownMenuLabel")
), FO = /* @__PURE__ */ b.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ ft(function(t, a) {
    const { __scopeDropdownMenu: o, ...r } = t, l = vt(o);
    return /* @__PURE__ */ s(mO, { ...l, ...r, ref: a });
  }, "DropdownMenuItem")
), IO = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ ft(function(t, a) {
  const { __scopeDropdownMenu: o, ...r } = t, l = vt(o);
  return /* @__PURE__ */ s(gO, { ...l, ...r, ref: a });
}, "DropdownMenuCheckboxItem")), OO = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ ft(function(t, a) {
  const { __scopeDropdownMenu: o, ...r } = t, l = vt(o);
  return /* @__PURE__ */ s(fO, { ...l, ...r, ref: a });
}, "DropdownMenuRadioItem")), RO = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ ft(function(t, a) {
  const { __scopeDropdownMenu: o, ...r } = t, l = vt(o);
  return /* @__PURE__ */ s(vO, { ...l, ...r, ref: a });
}, "DropdownMenuItemIndicator")), BO = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ ft(function(t, a) {
  const { __scopeDropdownMenu: o, ...r } = t, l = vt(o);
  return /* @__PURE__ */ s(kO, { ...l, ...r, ref: a });
}, "DropdownMenuSeparator")), zO = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ ft(function(t, a) {
  const { __scopeDropdownMenu: o, ...r } = t, l = vt(o);
  return /* @__PURE__ */ s(wO, { ...l, ...r, ref: a });
}, "DropdownMenuSubTrigger")), VO = /* @__PURE__ */ b.forwardRef(/* @__PURE__ */ ft(function(t, a) {
  const { __scopeDropdownMenu: o, ...r } = t, l = vt(o);
  return /* @__PURE__ */ s(
    SO,
    {
      ...l,
      ...r,
      ref: a,
      style: {
        ...t.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
}, "DropdownMenuSubContent")), WO = PO, $O = LO, _O = MO, gb = EO, fb = DO, vb = FO, kb = IO, wb = OO, Sb = RO, xb = BO, Tb = zO, Cb = VO;
const Fl = WO, Il = $O, HO = b.forwardRef(({ className: e, inset: t, children: a, ...o }, r) => /* @__PURE__ */ x(
  Tb,
  {
    ref: r,
    className: Ce(
      "flex cursor-default select-none items-center rounded-md px-2 py-1.5 text-sm outline-none data-[state=open]:bg-accent focus:bg-accent",
      t && "pl-8",
      e
    ),
    ...o,
    children: [
      a,
      /* @__PURE__ */ s(Cs, { className: "ml-auto h-4 w-4" })
    ]
  }
));
HO.displayName = Tb.displayName;
const UO = b.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ s(
  Cb,
  {
    ref: a,
    className: Ce(
      "z-50 min-w-[8rem] overflow-hidden rounded-lg bg-popover p-1.5 text-popover-foreground shadow-dropdown data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
UO.displayName = Cb.displayName;
const kr = b.forwardRef(({ className: e, sideOffset: t = 4, ...a }, o) => {
  const r = tc();
  return /* @__PURE__ */ s(_O, { container: r, children: /* @__PURE__ */ s(
    gb,
    {
      ref: o,
      sideOffset: t,
      className: Ce(
        "z-50 min-w-[8rem] overflow-hidden rounded-lg bg-popover p-1.5 text-popover-foreground shadow-dropdown data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        e
      ),
      ...a
    }
  ) });
});
kr.displayName = gb.displayName;
const No = b.forwardRef(({ className: e, inset: t, ...a }, o) => /* @__PURE__ */ s(
  vb,
  {
    ref: o,
    className: Ce(
      "relative flex cursor-default select-none items-center rounded-md px-2 py-1.5 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50 focus:bg-accent focus:text-ink",
      t && "pl-8",
      e
    ),
    ...a
  }
));
No.displayName = vb.displayName;
const GO = b.forwardRef(({ className: e, children: t, checked: a, ...o }, r) => /* @__PURE__ */ x(
  kb,
  {
    ref: r,
    className: Ce(
      "relative flex cursor-default select-none items-center rounded-md py-1.5 pl-8 pr-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50 focus:bg-accent focus:text-ink",
      e
    ),
    checked: a,
    ...o,
    children: [
      /* @__PURE__ */ s("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ s(Sb, { children: /* @__PURE__ */ s(cr, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
GO.displayName = kb.displayName;
const YO = b.forwardRef(({ className: e, children: t, ...a }, o) => /* @__PURE__ */ x(
  wb,
  {
    ref: o,
    className: Ce(
      "relative flex cursor-default select-none items-center rounded-md py-1.5 pl-8 pr-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50 focus:bg-accent focus:text-ink",
      e
    ),
    ...a,
    children: [
      /* @__PURE__ */ s("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ s(Sb, { children: /* @__PURE__ */ s(yu, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
YO.displayName = wb.displayName;
const XO = b.forwardRef(({ className: e, inset: t, ...a }, o) => /* @__PURE__ */ s(
  fb,
  {
    ref: o,
    className: Ce("px-2 py-1.5 text-xs font-medium text-muted-foreground", t && "pl-8", e),
    ...a
  }
));
XO.displayName = fb.displayName;
const jO = b.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ s(
  xb,
  {
    ref: a,
    className: Ce("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
jO.displayName = xb.displayName;
const qO = 1, ZO = 2e3, JO = (e) => typeof e == "object" && e !== null && !Array.isArray(e), rr = (e) => typeof e == "string" && e.length > 0 && e.length <= 200, Wi = (e) => typeof e == "string" && e.length <= 120 && /^[A-Za-z]\w*(\.(\d{1,3}|[A-Za-z]\w*))*$/.test(e), kp = (e) => e === "header" || e === "footer", KO = (e) => {
  if (!JO(e) || e.v !== qO) return null;
  switch (e.type) {
    case "ready":
      return { v: 1, type: "ready" };
    case "section:clicked":
      return rr(e.id) ? { v: 1, type: "section:clicked", id: e.id } : null;
    case "section:hover":
      return e.id === null || rr(e.id) ? { v: 1, type: "section:hover", id: e.id } : null;
    case "navigate":
      return typeof e.path == "string" && e.path.startsWith("/") && !e.path.startsWith("//") ? { v: 1, type: "navigate", path: e.path } : null;
    case "region:clicked":
      return kp(e.region) ? { v: 1, type: "region:clicked", region: e.region } : null;
    case "region:hover":
      return e.region === null || kp(e.region) ? { v: 1, type: "region:hover", region: e.region } : null;
    case "field:edit":
      return rr(e.sectionId) && Wi(e.path) && (e.locale === "en" || e.locale === "bn") && typeof e.value == "string" && e.value.length <= ZO ? { v: 1, type: "field:edit", sectionId: e.sectionId, path: e.path, locale: e.locale, value: e.value } : null;
    case "image:pick":
      return rr(e.sectionId) && Wi(e.path) ? { v: 1, type: "image:pick", sectionId: e.sectionId, path: e.path } : null;
    case "fields:open":
      return rr(e.sectionId) && Array.isArray(e.paths) && e.paths.length > 0 && e.paths.length <= 8 && e.paths.every(Wi) ? { v: 1, type: "fields:open", sectionId: e.sectionId, paths: e.paths, ...typeof e.label == "string" ? { label: e.label.slice(0, 80) } : {} } : null;
    case "shortcut":
      return e.action === "undo" || e.action === "redo" || e.action === "save" ? { v: 1, type: "shortcut", action: e.action } : null;
    case "error":
      return typeof e.message == "string" ? { v: 1, type: "error", message: e.message.slice(0, 500) } : null;
    default:
      return null;
  }
}, QO = {
  home: "/",
  shop: "/shop",
  categories: "/categories",
  cart: "/cart",
  checkout: "/checkout",
  contact: "/contact",
  signin: "/signin",
  signup: "/signup",
  account: "/account",
  wishlist: "/wishlist",
  compare: "/compare",
  coupon: "/coupon",
  blog: "/blog",
  "track-order": "/track-order",
  "privacy-policy": "/privacy-policy",
  "terms-of-service": "/terms-of-service",
  "shipping-policy": "/shipping-policy",
  "return-policy": "/return-policy",
  offers: "/offers",
  tools: "/tools",
  "pc-builder": "/pc-builder"
}, eR = [
  [/^\/product\/[^/]+$/, () => ["product"]],
  [/^\/category\/([^/]+)$/, (e) => [`category-${e}`, "category"]],
  [/^\/blog\/([^/]+)$/, (e) => [`blog-${e}`, "blog"]],
  [/^\/order-success\/[^/]+$/, () => ["order-success"]],
  [/^\/reset-password\/[^/]+$/, () => ["reset-password"]],
  [/^\/account\/orders(\/.*)?$/, () => ["orders", "account"]],
  [/^\/account\/(profile|addresses)$/, (e) => [e, "account"]]
], tR = (e, t) => {
  var l;
  const a = (e.split(/[?#]/)[0] ?? "/").replace(/(.)\/$/, "$1"), o = (l = Object.entries(QO).find(([, i]) => i === a)) == null ? void 0 : l[0];
  let r = o ? [o] : [a.slice(1)];
  for (const [i, n] of eR) {
    const c = i.exec(a);
    if (c) {
      r = n(decodeURIComponent(c[1] ?? ""));
      break;
    }
  }
  return r.find((i) => t.includes(i)) ?? null;
}, aR = (e) => {
  if (!(e.metaKey || e.ctrlKey) || e.altKey) return null;
  const t = e.key.toLowerCase();
  return t === "z" ? e.shiftKey ? "redo" : "undo" : t === "y" ? "redo" : t === "s" ? "save" : null;
}, rs = [
  { id: "mobile", label: "Mobile", width: 390, Icon: FA },
  { id: "tablet", label: "Tablet", width: 768, Icon: IA },
  { id: "desktop", label: "Desktop", width: 1440, Icon: xA }
], oR = { header: "Header", footer: "Footer" }, rR = ({ device: e, onDeviceChange: t, preview: a, settings: o, page: r, pages: l, selectedSectionId: i, onSectionClick: n, onPageChange: c, onRegionClick: d, sectionLabel: y, onFieldEdit: u, onImagePick: h, onFieldsOpen: p, onShortcut: g }) => {
  var H;
  const m = ve(null), [f, v] = j(null), [k, w] = j(!1), [S, T] = j(null), [C, A] = j(null), M = ve(null), E = ve(l);
  E.current = l;
  const F = ve(null), [I, P] = j({ w: 0, h: 0 });
  ne(() => {
    const N = F.current;
    if (!N) return;
    const D = new ResizeObserver(([$]) => {
      $ && P({ w: $.contentRect.width, h: $.contentRect.height });
    });
    return D.observe(N), () => D.disconnect();
  }, []);
  const O = a.storefrontOrigin.replace(/\/$/, ""), z = be((N) => {
    var D, $;
    ($ = (D = m.current) == null ? void 0 : D.contentWindow) == null || $.postMessage(N, O);
  }, [O]), U = be(async () => {
    w(!1), T(null), M.current = null;
    try {
      const N = await a.getToken();
      v(`${O}/__preview?token=${encodeURIComponent(N)}&page=${encodeURIComponent(r)}`);
    } catch {
      T(`The storefront at ${O || "(no storefront URL configured)"} did not issue a preview token. Make sure it is running and you are signed in.`);
    }
  }, [O, a]);
  ne(() => {
    U();
  }, [U]), ne(() => {
    const N = (D) => {
      var V;
      if (D.origin !== O || D.source !== ((V = m.current) == null ? void 0 : V.contentWindow)) return;
      const $ = KO(D.data);
      if ($)
        if ($.type === "ready") w(!0);
        else if ($.type === "section:clicked") n($.id);
        else if ($.type === "section:hover") A($.id && y($.id));
        else if ($.type === "shortcut") g($.action);
        else if ($.type === "field:edit") u($);
        else if ($.type === "image:pick") h($.sectionId, $.path);
        else if ($.type === "fields:open") p($.sectionId, $.paths, $.label);
        else if ($.type === "region:clicked") d($.region);
        else if ($.type === "region:hover") A($.region && oR[$.region]);
        else if ($.type === "navigate") {
          const X = tR($.path, E.current);
          X && (M.current = X, c(X));
        } else $.type === "error" && T($.message);
    };
    return window.addEventListener("message", N), () => window.removeEventListener("message", N);
  }, [O, n, c, d, y, u, h, p, g]), ne(() => {
    if (!k || !o) return;
    const N = setTimeout(() => z({ v: 1, type: "config:replace", settings: { config: o.config, pages: o.pages, seo: o.seo } }), 150);
    return () => clearTimeout(N);
  }, [k, o, z]), ne(() => {
    !k || r === M.current || (M.current = null, z({ v: 1, type: "page:change", page: r }));
  }, [k, r, z]), ne(() => {
    k && z({ v: 1, type: "section:select", id: i });
  }, [k, i, z]);
  const Y = ((H = rs.find((N) => N.id === e)) == null ? void 0 : H.width) ?? 1440, _ = I.w > 0 ? Math.min(1, I.w / Y) : 1;
  return /* @__PURE__ */ x("div", { className: "flex h-full flex-col bg-subdued", children: [
    /* @__PURE__ */ x("div", { className: "flex h-9 shrink-0 items-center justify-between gap-2 px-3", children: [
      /* @__PURE__ */ s("div", { className: "flex gap-0.5 rounded-md bg-fill p-0.5 lg:hidden", role: "group", "aria-label": "Preview size", children: rs.map(({ id: N, label: D, Icon: $ }) => /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          "aria-pressed": e === N,
          "aria-label": D,
          title: D,
          onClick: () => t(N),
          className: St("grid size-7 place-items-center rounded-sm", e === N ? "bg-card text-ink shadow-z1" : "text-muted-foreground hover:text-ink"),
          children: /* @__PURE__ */ s($, { className: "size-4" })
        },
        N
      )) }),
      /* @__PURE__ */ s("span", { className: "min-w-0 flex-1 truncate text-xs text-muted-foreground lg:text-center", children: S ? "Preview unavailable" : C ? `Click to edit: ${C}` : k ? "Live preview" : "Loading preview…" }),
      /* @__PURE__ */ s("button", { type: "button", onClick: () => void U(), "aria-label": "Reload preview", title: "Reload preview", className: "grid size-7 place-items-center rounded-md text-muted-foreground hover:bg-fill hover:text-ink", children: /* @__PURE__ */ s(Ad, { className: "size-4" }) })
    ] }),
    /* @__PURE__ */ s("div", { ref: F, className: "relative flex min-h-0 flex-1 justify-center overflow-hidden px-4 pb-4", children: S ? /* @__PURE__ */ x("div", { className: "max-w-sm self-center text-center", children: [
      /* @__PURE__ */ s("span", { className: "mx-auto mb-4 grid size-14 place-items-center rounded-full bg-fill", children: /* @__PURE__ */ s(SA, { className: "size-6 text-muted-foreground" }) }),
      /* @__PURE__ */ s("p", { className: "text-heading-md text-ink", children: "Preview unavailable" }),
      /* @__PURE__ */ s("p", { className: "mt-1 break-words text-sm text-muted-foreground", children: S }),
      /* @__PURE__ */ x(le, { variant: "outline", className: "mt-4", onClick: () => void U(), children: [
        /* @__PURE__ */ s(Ad, {}),
        " Try again"
      ] })
    ] }) : f ? /* @__PURE__ */ s("div", { className: "shrink-0", style: { width: Y * _, height: I.h }, children: /* @__PURE__ */ s(
      "iframe",
      {
        ref: m,
        src: f,
        title: "Storefront preview",
        className: "origin-top-left rounded-lg border border-border bg-card shadow-card",
        style: { width: Y, height: _ ? I.h / _ : "100%", transform: `scale(${_})` },
        sandbox: "allow-scripts allow-same-origin allow-forms allow-popups"
      }
    ) }) : null })
  ] });
}, lR = { "order-success": "Order success", "track-order": "Track order", "privacy-policy": "Privacy policy", "terms-of-service": "Terms of service", "shipping-policy": "Shipping policy", "return-policy": "Return policy", "order-detail": "Order detail", "pc-builder": "PC Builder", offers: "Offers", tools: "Tools" }, Ol = (e) => lR[e] ?? e.charAt(0).toUpperCase() + e.slice(1), iR = ({ pages: e, selectedPage: t, onSelectPage: a, device: o, onDeviceChange: r, panelToggle: l }) => {
  var f, v, k, w, S;
  const i = at(), n = ia(), c = ve(null), d = ((k = (v = (f = i.localSettings) == null ? void 0 : f.pages) == null ? void 0 : v[t]) == null ? void 0 : k.isActive) !== !1, y = i.issues.filter((T) => T.level === "error").length, u = (S = (w = i.localSettings) == null ? void 0 : w.config) == null ? void 0 : S.themeId, h = u ? BA(u) : null, p = i.isSaving ? "Publishing…" : i.hasChanges ? i.draftState === "saved" ? "Draft saved in this browser" : i.draftState === "unavailable" ? "Unpublished changes (could not save a draft here)" : "Unpublished changes" : "All changes published", g = () => {
    const T = new Blob([i.exportSettings()], { type: "application/json" }), C = document.createElement("a");
    C.href = URL.createObjectURL(T), C.download = `theme-settings-${(/* @__PURE__ */ new Date()).toISOString().slice(0, 10)}.json`, C.click(), URL.revokeObjectURL(C.href);
  }, m = async (T) => {
    if (!T) return;
    const C = i.importSettings(await T.text());
    C.length && Me.error(`This file can't be imported: ${C.slice(0, 3).join("; ")}`);
  };
  return /* @__PURE__ */ x("header", { className: "z-30 flex h-[52px] shrink-0 items-center gap-2 border-b border-border bg-card px-2 md:grid md:grid-cols-[1fr_auto_1fr] md:gap-3", children: [
    /* @__PURE__ */ x("div", { className: "flex shrink-0 items-center gap-2 md:min-w-0", children: [
      /* @__PURE__ */ x(
        "a",
        {
          href: n.exitHref ?? "/",
          className: "flex h-8 shrink-0 items-center gap-1 rounded-md pl-1 pr-2 text-sm font-medium text-ink outline-none hover:bg-subdued focus-visible:ring-2 focus-visible:ring-ring",
          children: [
            /* @__PURE__ */ s(uu, { className: "size-4", "aria-hidden": "true" }),
            "Exit"
          ]
        }
      ),
      /* @__PURE__ */ s("span", { className: "hidden h-5 w-px bg-border md:block", "aria-hidden": "true" }),
      h && /* @__PURE__ */ s("span", { className: "hidden truncate text-sm font-semibold text-ink md:block", children: zl(h) }),
      /* @__PURE__ */ s(Zn, { tone: i.hasChanges ? "warning" : "success", className: "hidden shrink-0 sm:inline-flex", children: i.hasChanges ? "Unpublished" : "Live" })
    ] }),
    /* @__PURE__ */ x("div", { className: "flex min-w-0 flex-1 items-center gap-2 md:flex-none", children: [
      /* @__PURE__ */ x(wa, { value: t, onValueChange: a, children: [
        /* @__PURE__ */ s(oa, { className: "w-full justify-center gap-1.5 border-0 bg-fill font-medium hover:bg-fill/80 md:w-48", "aria-label": "Page", children: /* @__PURE__ */ s(Sa, {}) }),
        /* @__PURE__ */ s(ra, { children: e.map((T) => /* @__PURE__ */ s(la, { value: T, children: Ol(T) }, T)) })
      ] }),
      /* @__PURE__ */ x("label", { className: "hidden items-center gap-2 text-sm text-text-2 xl:flex", title: d ? "This page is visible on the store" : "This page is hidden from the store", children: [
        /* @__PURE__ */ s(Ao, { checked: d, onCheckedChange: (T) => i.updatePageSettings(t, { isActive: T }), "aria-label": "Page visible" }),
        d ? "Visible" : "Hidden"
      ] })
    ] }),
    /* @__PURE__ */ x("div", { className: "flex shrink-0 items-center justify-end gap-1.5 md:min-w-0", children: [
      /* @__PURE__ */ s("span", { className: "hidden min-w-0 truncate text-xs text-muted-foreground lg:block", role: "status", children: p }),
      /* @__PURE__ */ x("div", { className: "flex items-center", children: [
        /* @__PURE__ */ s(le, { variant: "ghost", size: "icon-sm", onClick: i.undo, disabled: !i.canUndo, "aria-label": "Undo", title: "Undo (Ctrl+Z)", children: /* @__PURE__ */ s(OA, {}) }),
        /* @__PURE__ */ s(le, { variant: "ghost", size: "icon-sm", onClick: i.redo, disabled: !i.canRedo, "aria-label": "Redo", title: "Redo (Ctrl+Shift+Z)", children: /* @__PURE__ */ s(MA, {}) })
      ] }),
      (l || o && r) && /* @__PURE__ */ x("div", { className: "hidden items-center gap-1 lg:flex", children: [
        l,
        o && r && /* @__PURE__ */ s("div", { className: "flex gap-0.5 rounded-md bg-fill p-0.5", role: "group", "aria-label": "Preview size", children: rs.map(({ id: T, label: C, Icon: A }) => /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            "aria-pressed": o === T,
            "aria-label": C,
            title: C,
            onClick: () => r(T),
            className: St("grid size-7 place-items-center rounded-sm outline-none focus-visible:ring-2 focus-visible:ring-ring", o === T ? "bg-card text-ink shadow-z1" : "text-muted-foreground hover:text-ink"),
            children: /* @__PURE__ */ s(A, { className: "size-4" })
          },
          T
        )) })
      ] }),
      y > 0 && /* @__PURE__ */ x(Zn, { tone: "error", className: "shrink-0", children: [
        y,
        " to fix"
      ] }),
      /* @__PURE__ */ x(Fl, { children: [
        /* @__PURE__ */ s(Il, { asChild: !0, children: /* @__PURE__ */ s(le, { variant: "ghost", size: "icon-sm", "aria-label": "More", children: /* @__PURE__ */ s(sA, {}) }) }),
        /* @__PURE__ */ x(kr, { align: "end", children: [
          /* @__PURE__ */ x(No, { onClick: g, children: [
            /* @__PURE__ */ s(nA, { className: "size-4" }),
            " Export settings"
          ] }),
          /* @__PURE__ */ x(No, { onClick: () => {
            var T;
            return (T = c.current) == null ? void 0 : T.click();
          }, children: [
            /* @__PURE__ */ s(RA, { className: "size-4" }),
            " Import settings…"
          ] })
        ] })
      ] }),
      i.hasChanges && /* @__PURE__ */ s(le, { variant: "secondary", onClick: i.discardChanges, children: "Discard" }),
      /* @__PURE__ */ s(le, { onClick: () => void i.publish(), disabled: !i.hasChanges || i.isSaving, "data-copilot-id": "theme_publish_button", children: i.isSaving ? "Publishing…" : "Publish" })
    ] }),
    /* @__PURE__ */ s("input", { ref: c, type: "file", accept: "application/json,.json", className: "hidden", onChange: (T) => {
      var C;
      m((C = T.target.files) == null ? void 0 : C[0]), T.target.value = "";
    } })
  ] });
}, nR = (e) => {
  const t = new Date(e);
  if (Number.isNaN(t.getTime())) return "";
  const a = (o) => String(o).padStart(2, "0");
  return `${t.getFullYear()}-${a(t.getMonth() + 1)}-${a(t.getDate())}T${a(t.getHours())}:${a(t.getMinutes())}`;
}, ls = ({ value: e, onChange: t }) => /* @__PURE__ */ x("div", { className: "flex items-center gap-2", children: [
  /* @__PURE__ */ s(
    Ze,
    {
      type: "datetime-local",
      value: e ? nR(e) : "",
      onChange: (a) => t(a.target.value ? new Date(a.target.value).toISOString() : "")
    }
  ),
  e && /* @__PURE__ */ s("button", { type: "button", className: "shrink-0 text-sm text-link hover:underline", onClick: () => t(""), children: "Clear" })
] }), sR = ({
  idx: e,
  item: t,
  field: a,
  value: o,
  expandedIndex: r,
  handleToggle: l,
  handleRemove: i,
  onChange: n,
  onImageRequest: c,
  path: d,
  renderField: y
}) => {
  const { attributes: u, listeners: h, setNodeRef: p, transform: g, transition: m, isDragging: f } = Xu({ id: e.toString() }), v = {
    transform: Po.Transform.toString(g),
    transition: m,
    zIndex: f ? 10 : 0,
    position: "relative",
    opacity: f ? 0.5 : 1
  }, k = String(t.label ?? t.title ?? t.name ?? ""), w = r === e;
  return /* @__PURE__ */ x("div", { ref: p, style: v, className: "overflow-hidden rounded-md border border-border bg-card", children: [
    /* @__PURE__ */ x(
      "div",
      {
        className: "flex h-9 cursor-pointer items-center gap-1 pl-1 pr-1.5 transition-colors hover:bg-subdued",
        onClick: () => l(e),
        children: [
          /* @__PURE__ */ s("div", { ...u, ...h, className: "grid size-6 shrink-0 cursor-grab place-items-center rounded-sm text-faint hover:text-text-2 active:cursor-grabbing", children: /* @__PURE__ */ s(bu, { className: "size-4" }) }),
          w ? /* @__PURE__ */ s(Bl, { className: "size-4 shrink-0 text-text-2" }) : /* @__PURE__ */ s(Cs, { className: "size-4 shrink-0 text-text-2" }),
          /* @__PURE__ */ s("span", { className: "min-w-0 flex-1 truncate text-sm text-ink", children: k || `Item ${e + 1}` }),
          /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              "aria-label": `Remove ${k || `item ${e + 1}`}`,
              className: "grid size-6 shrink-0 place-items-center rounded-sm text-text-2 transition-colors hover:bg-error-lighter hover:text-error-dark",
              onClick: (S) => i(S, e),
              children: /* @__PURE__ */ s(Co, { className: "size-3.5" })
            }
          )
        ]
      }
    ),
    w && a.itemSchema && /* @__PURE__ */ s("div", { className: "space-y-4 border-t border-border-subtle p-3", children: a.itemSchema.map((S) => S.dependency && t[S.dependency.field] !== S.dependency.value ? null : /* @__PURE__ */ s(W.Fragment, { children: y(
      S,
      t[S.key],
      (T) => {
        const C = [...o];
        C[e] = { ...C[e], [S.key]: T }, n(C);
      },
      `${d || a.key}.${e}.${S.key}`,
      S.label
    ) }, S.key)) })
  ] });
}, cR = ({ field: e, value: t, onChange: a, onImageRequest: o, path: r, renderField: l }) => {
  const [i, n] = j(null), c = xu(
    Cl(_l),
    Cl($l, { coordinateGetter: ju })
  ), d = (g) => n(i === g ? null : g), y = (g, m) => {
    g.stopPropagation();
    const f = [...t || []];
    f.splice(m, 1), a(f), i === m && n(null);
  }, u = () => {
    var f;
    const g = ((f = e.itemSchema) == null ? void 0 : f.reduce((v, k) => (v[k.key] = k.default ?? (k.type === "number" ? 0 : k.type === "boolean" ? !1 : ""), v), {})) ?? {}, m = [...t || [], g];
    a(m), n(m.length - 1);
  }, h = (g) => {
    const { active: m, over: f } = g;
    if (m.id !== (f == null ? void 0 : f.id)) {
      const v = parseInt(m.id.toString()), k = parseInt(f.id.toString());
      a(Gl(t, v, k)), i === v ? n(k) : i !== null && (v < i && k >= i ? n(i - 1) : v > i && k <= i && n(i + 1));
    }
  }, p = (t || []).map((g, m) => m.toString());
  return /* @__PURE__ */ x("div", { className: "space-y-2", children: [
    /* @__PURE__ */ s(Wu, { sensors: c, collisionDetection: Au, onDragEnd: h, children: /* @__PURE__ */ s(Gu, { items: p, strategy: _u, children: /* @__PURE__ */ s("div", { className: "space-y-1.5", children: (t || []).map((g, m) => /* @__PURE__ */ s(
      sR,
      {
        idx: m,
        item: g,
        field: e,
        value: t || [],
        expandedIndex: i,
        handleToggle: d,
        handleRemove: y,
        onChange: a,
        onImageRequest: o,
        path: r,
        renderField: l
      },
      m
    )) }) }) }),
    /* @__PURE__ */ x(
      le,
      {
        variant: "ghost",
        className: "w-full justify-start px-2 text-link hover:bg-subdued",
        onClick: u,
        children: [
          /* @__PURE__ */ s(Sl, {}),
          " Add ",
          e.label ? e.label.replace(/s$/, "") : "item"
        ]
      }
    )
  ] });
}, dR = ({ field: e, value: t, onChange: a }) => /* @__PURE__ */ s(Ao, { checked: !!t, onCheckedChange: a, "aria-label": e.label }), Pb = ({ field: e, value: t, onChange: a }) => {
  const o = ia(), [r, l] = j([]), [i, n] = j(!0);
  return ne(() => {
    o.fetchCategories().then((c) => {
      l(c), n(!1);
    }).catch(() => n(!1));
  }, []), /* @__PURE__ */ x(wa, { value: t || "", onValueChange: a, children: [
    /* @__PURE__ */ s(oa, { children: /* @__PURE__ */ s(Sa, { placeholder: i ? "Loading categories..." : "Select category" }) }),
    /* @__PURE__ */ s(ra, { children: r.map((c) => /* @__PURE__ */ s(la, { value: c._id, children: c.name }, c._id)) })
  ] });
}, pR = ({ field: e, value: t, onChange: a }) => /* @__PURE__ */ x("div", { className: "flex items-center gap-2", children: [
  /* @__PURE__ */ s("div", { className: "relative size-8 shrink-0 overflow-hidden rounded-md border border-input", children: /* @__PURE__ */ s(
    Ze,
    {
      type: "color",
      value: t || "#000000",
      onChange: (o) => a(o.target.value),
      "aria-label": `${e.label} picker`,
      className: "absolute inset-0 h-[200%] w-[200%] -translate-x-1/4 -translate-y-1/4 cursor-pointer border-0 p-0"
    }
  ) }),
  /* @__PURE__ */ s(
    Ze,
    {
      value: t || "#000000",
      onChange: (o) => a(o.target.value),
      className: "font-mono"
    }
  )
] }), uR = ({ field: e, value: t, onChange: a, onImageRequest: o, path: r }) => {
  const { resolveImageUrl: l } = ia();
  return t ? /* @__PURE__ */ x("div", { className: "overflow-hidden rounded-md border border-border bg-card", children: [
    /* @__PURE__ */ s("div", { className: "flex aspect-video items-center justify-center bg-subdued", children: /* @__PURE__ */ s("img", { src: l(t), className: "h-full w-full object-contain", alt: e.label }) }),
    /* @__PURE__ */ x("div", { className: "flex items-center justify-end gap-2 border-t border-border-subtle p-2", children: [
      /* @__PURE__ */ s(le, { size: "sm", variant: "ghost", onClick: () => a(""), children: "Remove" }),
      /* @__PURE__ */ s(le, { size: "sm", variant: "secondary", onClick: () => o(r || e.key), children: "Change" })
    ] })
  ] }) : /* @__PURE__ */ x(
    le,
    {
      variant: "outline",
      className: "h-24 w-full flex-col gap-2 rounded-md border-dashed bg-subdued text-text-2 hover:bg-fill",
      onClick: () => o(r || e.key),
      children: [
        /* @__PURE__ */ s(Ps, { className: "size-5 text-text-2" }),
        /* @__PURE__ */ s("span", { className: "text-sm", children: "Select image" })
      ]
    }
  );
}, yR = ({ field: e, value: t, onChange: a }) => /* @__PURE__ */ s(
  Ze,
  {
    type: "number",
    value: t || 0,
    onChange: (o) => a(Number(o.target.value)),
    placeholder: e.placeholder
  }
);
function hR({ value: e, preview: t }) {
  const [a, o] = j(!1), r = t.variant === "primary", l = a && (e != null && e.hoverBg) ? e.hoverBg : (e == null ? void 0 : e.bg) || (r ? "var(--btn-primary-bg)" : "transparent"), i = (e == null ? void 0 : e.text) || (r ? "var(--btn-primary-text)" : "var(--btn-outline-text)"), n = (e == null ? void 0 : e.radius) || (r ? "var(--btn-primary-radius)" : "var(--btn-outline-radius)"), c = (e == null ? void 0 : e.height) || "44px", d = (e == null ? void 0 : e.paddingX) || "20px", y = r ? void 0 : (e == null ? void 0 : e.borderColor) || "var(--btn-outline-border)", u = (e == null ? void 0 : e.label) || t.defaultLabel || "Button Text";
  return /* @__PURE__ */ x("div", { className: "space-y-1.5 border-b border-border-subtle p-3", children: [
    /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "Preview" }),
    /* @__PURE__ */ s("div", { className: "flex items-center justify-center rounded-md bg-subdued p-4", children: /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        tabIndex: -1,
        onMouseEnter: () => o(!0),
        onMouseLeave: () => o(!1),
        style: {
          background: l,
          color: i,
          borderRadius: n,
          height: c,
          paddingLeft: d,
          paddingRight: d,
          border: y ? `2px solid ${y}` : "none",
          fontWeight: 600,
          fontSize: "14px",
          cursor: "default",
          transition: "background 150ms ease",
          whiteSpace: "nowrap"
        },
        children: u
      }
    ) })
  ] });
}
const bR = ({ field: e, value: t, onChange: a, onImageRequest: o, path: r, renderField: l }) => {
  var n, c;
  const i = t && Object.values(t).some((d) => d != null && d !== "");
  return /* @__PURE__ */ x("div", { className: "overflow-hidden rounded-md border border-border bg-card", children: [
    ((n = e.preview) == null ? void 0 : n.type) === "button" && /* @__PURE__ */ s(hR, { value: t || {}, preview: e.preview }),
    i && /* @__PURE__ */ s("div", { className: "flex justify-end px-3 pt-2", children: /* @__PURE__ */ x(
      "button",
      {
        type: "button",
        onClick: () => a({}),
        className: "flex items-center gap-1 text-xs text-text-2 transition-colors hover:text-ink",
        title: "Reset to theme defaults",
        children: [
          /* @__PURE__ */ s(NA, { className: "size-3" }),
          "Reset to defaults"
        ]
      }
    ) }),
    /* @__PURE__ */ s("div", { className: "space-y-4 p-3", children: (c = e.fields) == null ? void 0 : c.map((d) => d.dependency && (t == null ? void 0 : t[d.dependency.field]) !== d.dependency.value ? null : /* @__PURE__ */ s(W.Fragment, { children: l(
      d,
      t == null ? void 0 : t[d.key],
      (y) => a({ ...t || {}, [d.key]: y }),
      `${r ? r + "." : ""}${d.key}`,
      d.label
    ) }, d.key)) })
  ] });
}, Fr = b.forwardRef(
  ({ className: e, ...t }, a) => /* @__PURE__ */ s(
    "textarea",
    {
      className: Ce(ac, "flex min-h-[88px] py-2", e),
      ref: a,
      ...t
    }
  )
);
Fr.displayName = "Textarea";
const mR = ({ field: e, value: t, onChange: a }) => /* @__PURE__ */ s(
  Fr,
  {
    value: t || "",
    onChange: (o) => a(o.target.value),
    className: "min-h-40 font-mono text-xs",
    placeholder: e.placeholder || "Enter HTML content..."
  }
), gR = ({ field: e, value: t, onChange: a }) => {
  var o;
  return /* @__PURE__ */ x(wa, { value: t || "", onValueChange: a, children: [
    /* @__PURE__ */ s(oa, { children: /* @__PURE__ */ s(Sa, { placeholder: e.placeholder || "Select..." }) }),
    /* @__PURE__ */ s(ra, { children: (o = e.options) == null ? void 0 : o.map((r) => /* @__PURE__ */ s(la, { value: String(r.value), children: r.label }, String(r.value))) })
  ] });
}, fR = ({ field: e, value: t, onChange: a }) => /* @__PURE__ */ s(
  Ze,
  {
    value: t || "",
    onChange: (o) => a(o.target.value),
    placeholder: e.placeholder
  }
), vR = ({ field: e, value: t, onChange: a }) => /* @__PURE__ */ s(
  Fr,
  {
    value: t || "",
    onChange: (o) => a(o.target.value),
    className: "min-h-24 text-sm",
    placeholder: e.placeholder
  }
), kR = [
  ["/", "Home"],
  ["/shop", "Shop"],
  ["/categories", "Categories"],
  ["/search", "Search"],
  ["/cart", "Cart"],
  ["/checkout", "Checkout"],
  ["/wishlist", "Wishlist"],
  ["/compare", "Compare"],
  ["/coupon", "Coupons"],
  ["/blog", "Blog"],
  ["/contact", "Contact"],
  ["/track-order", "Track order"],
  ["/account", "My account"],
  ["/signin", "Sign in"],
  ["/privacy-policy", "Privacy policy"],
  ["/return-policy", "Return policy"],
  ["/shipping-policy", "Shipping policy"],
  ["/terms-of-service", "Terms of service"]
], wR = ({ field: e, value: t, onChange: a }) => {
  const o = `links-${e.key}`, r = !!t && !/^(\/|https?:\/\/|mailto:|tel:|#)/.test(t);
  return /* @__PURE__ */ x("div", { className: "space-y-1", children: [
    /* @__PURE__ */ s(
      Ze,
      {
        list: o,
        value: t || "",
        onChange: (l) => a(l.target.value),
        placeholder: e.placeholder || "Choose a page or paste a link",
        "aria-invalid": r
      }
    ),
    /* @__PURE__ */ s("datalist", { id: o, children: kR.map(([l, i]) => /* @__PURE__ */ s("option", { value: l, children: i }, l)) }),
    r && /* @__PURE__ */ s("p", { className: "text-sm text-error", children: "Links start with / (a store page), https://, mailto: or tel:" })
  ] });
}, SR = /(youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|vimeo\.com\/\d+)/, xR = ({ value: e, onChange: t }) => /* @__PURE__ */ x("div", { className: "space-y-1", children: [
  /* @__PURE__ */ s(Ze, { value: e || "", onChange: (a) => t(a.target.value), placeholder: "YouTube or Vimeo link" }),
  e && !SR.test(e) && /* @__PURE__ */ s("p", { className: "text-sm text-error", children: "Paste a YouTube or Vimeo video link." })
] }), TR = ["inherit", "Inter", "Plus Jakarta Sans", "Poppins", "Roboto", "Open Sans", "Lato", "Montserrat", "DM Sans", "Space Grotesk", "Archivo Narrow", "Playfair Display", "Lora", "Hind Siliguri", "Noto Sans Bengali"], CR = ({ field: e, value: t, onChange: a }) => {
  const o = `fonts-${e.key}`;
  return /* @__PURE__ */ x("div", { className: "space-y-1", children: [
    /* @__PURE__ */ s(Ze, { list: o, value: t || "", onChange: (r) => a(r.target.value), placeholder: "Theme default", style: t && t !== "inherit" ? { fontFamily: t } : void 0 }),
    /* @__PURE__ */ s("datalist", { id: o, children: TR.map((r) => /* @__PURE__ */ s("option", { value: r, children: r === "inherit" ? "Theme default" : r }, r)) }),
    /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "“inherit” keeps the theme's own font." })
  ] });
}, PR = ["shipping", "refund", "support", "secure", "gift", "home", "shop", "search", "cart", "account", "heart", "phone", "star"], AR = ({ field: e, value: t, onChange: a }) => {
  var o;
  return /* @__PURE__ */ s("div", { className: "flex flex-wrap gap-2", role: "radiogroup", "aria-label": "Icon", children: (((o = e.options) == null ? void 0 : o.map((r) => String(r.value))) ?? PR).map((r) => /* @__PURE__ */ s(
    "button",
    {
      type: "button",
      role: "radio",
      "aria-checked": t === r,
      onClick: () => a(r),
      className: `h-7 rounded-full border px-3 text-xs capitalize transition-colors ${t === r ? "border-ink bg-selected font-medium text-ink" : "border-input bg-card text-ink hover:bg-subdued"}`,
      children: r
    },
    r
  )) });
}, LR = (e) => typeof e == "string" || !e ? { en: e ?? "", bn: "" } : { en: e.en ?? "", bn: e.bn ?? "" }, wp = ({ field: e, value: t, multiline: a, onChange: o }) => {
  const { en: r, bn: l } = LR(t), [i, n] = j(!!l), c = (y) => o(y.bn.trim() ? y : y.en), d = a ? Fr : Ze;
  return /* @__PURE__ */ x("div", { className: "space-y-2", children: [
    /* @__PURE__ */ s(d, { value: r, placeholder: e.placeholder, onChange: (y) => c({ en: y.target.value, bn: l }) }),
    i ? /* @__PURE__ */ x("div", { className: "space-y-1", children: [
      /* @__PURE__ */ s("span", { className: "text-xs text-text-2", children: "বাংলা" }),
      /* @__PURE__ */ s(d, { lang: "bn", value: l, onChange: (y) => c({ en: r, bn: y.target.value }) })
    ] }) : /* @__PURE__ */ s("button", { type: "button", className: "text-sm text-link hover:underline", onClick: () => n(!0), children: "+ Add বাংলা" })
  ] });
}, is = ({ value: e, multiple: t, max: a = 24, onChange: o }) => {
  const r = ia(), l = fe(() => Array.isArray(e) ? e : e ? [e] : [], [e]), [i, n] = j(""), [c, d] = j([]), [y, u] = j({}), [h, p] = j(!1);
  if (ne(() => {
    if (!r.searchProducts) return;
    const k = window.setTimeout(() => {
      p(!0), r.searchProducts(i.trim()).then((w) => {
        d(w), u((S) => ({ ...S, ...Object.fromEntries(w.map((T) => [T._id, T])) }));
      }).catch((w) => console.warn("Product search failed", w)).finally(() => p(!1));
    }, 250);
    return () => window.clearTimeout(k);
  }, [i, r]), !r.searchProducts) return /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "Product search is not available here." });
  const g = (k) => o(t ? k : k[0] ?? ""), m = (k) => g(t ? l.includes(k) ? l : [...l, k].slice(0, a) : [k]), f = (k, w) => {
    const S = [...l], [T] = S.splice(k, 1);
    S.splice(k + w, 0, T), g(S);
  }, v = (k) => {
    var w;
    return ((w = y[k]) == null ? void 0 : w.name) ?? "Product (not in the latest results)";
  };
  return /* @__PURE__ */ x("div", { className: "space-y-2", children: [
    l.length > 0 && /* @__PURE__ */ s("ul", { className: "space-y-1", children: l.map((k, w) => /* @__PURE__ */ x("li", { className: "flex items-center gap-1 rounded-md border border-border bg-card py-1 pl-2.5 pr-1 text-sm text-ink", children: [
      /* @__PURE__ */ s("span", { className: "min-w-0 flex-1 truncate", children: v(k) }),
      t && /* @__PURE__ */ x(ut, { children: [
        /* @__PURE__ */ s("button", { type: "button", "aria-label": "Move up", disabled: w === 0, onClick: () => f(w, -1), className: "grid size-6 place-items-center rounded-sm text-text-2 hover:bg-fill disabled:opacity-30", children: /* @__PURE__ */ s(pu, { className: "size-3.5" }) }),
        /* @__PURE__ */ s("button", { type: "button", "aria-label": "Move down", disabled: w === l.length - 1, onClick: () => f(w, 1), className: "grid size-6 place-items-center rounded-sm text-text-2 hover:bg-fill disabled:opacity-30", children: /* @__PURE__ */ s(du, { className: "size-3.5" }) })
      ] }),
      /* @__PURE__ */ s("button", { type: "button", "aria-label": `Remove ${v(k)}`, onClick: () => g(l.filter((S) => S !== k)), className: "grid size-6 place-items-center rounded-sm text-text-2 hover:bg-error-lighter hover:text-error-dark", children: /* @__PURE__ */ s(dr, { className: "size-3.5" }) })
    ] }, k)) }),
    /* @__PURE__ */ x("div", { className: "relative", children: [
      /* @__PURE__ */ s(As, { className: "pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-faint" }),
      /* @__PURE__ */ s(Ze, { value: i, onChange: (k) => n(k.target.value), placeholder: "Search products", className: "pl-9" })
    ] }),
    /* @__PURE__ */ x("ul", { className: "max-h-48 overflow-y-auto rounded-md border border-border bg-card", children: [
      h && /* @__PURE__ */ s("li", { className: "px-3 py-2 text-xs text-text-2", children: "Searching…" }),
      !h && c.length === 0 && /* @__PURE__ */ s("li", { className: "px-3 py-2 text-xs text-text-2", children: "No products found" }),
      c.map((k) => /* @__PURE__ */ s("li", { children: /* @__PURE__ */ x("button", { type: "button", disabled: l.includes(k._id), onClick: () => m(k._id), className: "flex w-full items-center gap-2 px-3 py-1.5 text-left text-sm text-ink hover:bg-subdued disabled:text-faint", children: [
        k.thumbnail && /* @__PURE__ */ s("img", { src: r.resolveImageUrl(k.thumbnail), alt: "", className: "size-7 rounded-sm border border-border object-cover" }),
        /* @__PURE__ */ s("span", { className: "min-w-0 flex-1 truncate", children: k.name }),
        l.includes(k._id) && /* @__PURE__ */ s("span", { className: "text-xs text-text-2", children: "Added" })
      ] }) }, k._id))
    ] })
  ] });
}, Ab = ["new", "on_sale", "category", "top_rated", "manual"], MR = {
  new: "New arrivals",
  on_sale: "On sale",
  category: "From a category",
  top_rated: "Top rated",
  manual: "Hand-picked"
}, NR = (e, t) => {
  const a = e && typeof e == "object" ? e : {};
  return {
    source: Ab.includes(a.source) ? a.source : "new",
    categoryId: a.categoryId ?? t ?? null,
    productIds: Array.isArray(a.productIds) ? a.productIds.filter((r) => typeof r == "string") : [],
    limit: Math.min(24, Math.max(1, Number(a.limit) || 8))
  };
}, ER = ({ field: e, value: t, onChange: a }) => {
  const o = NR(t), r = (l) => a({ ...o, ...l });
  return /* @__PURE__ */ x("div", { className: "space-y-3", children: [
    /* @__PURE__ */ x(wa, { value: o.source, onValueChange: (l) => r({ source: l }), children: [
      /* @__PURE__ */ s(oa, { children: /* @__PURE__ */ s(Sa, {}) }),
      /* @__PURE__ */ s(ra, { children: Ab.map((l) => /* @__PURE__ */ s(la, { value: l, children: MR[l] }, l)) })
    ] }),
    o.source === "category" && /* @__PURE__ */ s(Pb, { field: e, value: o.categoryId ?? "", onChange: (l) => r({ categoryId: String(l) }) }),
    o.source === "manual" && /* @__PURE__ */ s(is, { field: e, multiple: !0, value: o.productIds, onChange: (l) => r({ productIds: l }) }),
    o.source === "top_rated" && /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "Recent products ranked by rating; products without reviews are left out." }),
    /* @__PURE__ */ x("label", { className: "flex items-center justify-between gap-3 text-sm text-ink", children: [
      /* @__PURE__ */ s("span", { children: "Number of products" }),
      /* @__PURE__ */ s(Ze, { type: "number", min: 1, max: 24, value: o.limit, onChange: (l) => r({ limit: Number(l.target.value) }), className: "w-20" })
    ] })
  ] });
}, DR = /^(href|link|ctaLink|viewAllLink|continueShoppingLink|viewOrderLink|checkoutLink|button_link|link_url|signinRedirectPath|redirectUrl)$/, FR = /^(endDate|saleEndDate|offerEndsAt|expiryDate|startDate)$/, Sp = (e) => e.type !== "string" && e.type !== "text" ? e.type : DR.test(e.key) ? "link" : FR.test(e.key) ? "datetime" : e.key === "videoUrl" ? "video" : e.key === "heading" || e.key === "body" ? "font" : e.key === "icon" ? "icon" : e.type;
var IR = Object.defineProperty, OR = (e, t) => IR(e, "name", { value: t, configurable: !0 }), RR = /* @__PURE__ */ b.forwardRef(
  /* @__PURE__ */ OR(function(t, a) {
    return /* @__PURE__ */ s(
      ge.label,
      {
        ...t,
        ref: a,
        onMouseDown: (o) => {
          var l;
          o.target.closest("button, input, select, textarea") || ((l = t.onMouseDown) == null || l.call(t, o), !o.defaultPrevented && o.detail > 1 && o.preventDefault());
        }
      }
    );
  }, "Label")
), Lb = RR;
const BR = Gs(
  "text-sm text-ink peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), xt = b.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ s(Lb, { ref: a, className: Ce(BR(), e), ...t }));
xt.displayName = Lb.displayName;
const Xt = ({ field: e, value: t, onChange: a, onImageRequest: o, path: r = "", label: l }) => {
  const i = (d, y, u, h, p) => /* @__PURE__ */ s(Xt, { field: d, value: y, onChange: u, onImageRequest: o, path: h, label: p }), n = (() => {
    switch (Sp(e)) {
      case "string":
        return /* @__PURE__ */ s(fR, { field: e, value: t, onChange: a });
      case "text":
        return /* @__PURE__ */ s(vR, { field: e, value: t, onChange: a });
      case "rich-text":
        return /* @__PURE__ */ s(mR, { field: e, value: t, onChange: a });
      case "number":
        return /* @__PURE__ */ s(yR, { field: e, value: t, onChange: a });
      case "boolean":
        return /* @__PURE__ */ s(dR, { field: e, value: t, onChange: a });
      case "select":
        return /* @__PURE__ */ s(gR, { field: e, value: t, onChange: a });
      case "category-select":
        return /* @__PURE__ */ s(Pb, { field: e, value: t, onChange: a });
      case "color":
        return /* @__PURE__ */ s(pR, { field: e, value: t, onChange: a });
      case "image":
        return /* @__PURE__ */ s(uR, { field: e, value: t, onChange: a, onImageRequest: o, path: r });
      case "object":
        return /* @__PURE__ */ s(bR, { field: e, value: t, onChange: a, onImageRequest: o, path: r, renderField: i });
      case "array":
        return /* @__PURE__ */ s(cR, { field: e, value: t, onChange: a, onImageRequest: o, path: r, renderField: i });
      case "link":
        return /* @__PURE__ */ s(wR, { field: e, value: t, onChange: a });
      case "datetime":
        return /* @__PURE__ */ s(ls, { field: e, value: t, onChange: a });
      case "video":
        return /* @__PURE__ */ s(xR, { field: e, value: t, onChange: a });
      case "font":
        return /* @__PURE__ */ s(CR, { field: e, value: t, onChange: a });
      case "icon":
        return /* @__PURE__ */ s(AR, { field: e, value: t, onChange: a });
      case "localized-string":
        return /* @__PURE__ */ s(wp, { field: e, value: t, onChange: a });
      case "localized-text":
        return /* @__PURE__ */ s(wp, { field: e, multiline: !0, value: t, onChange: a });
      case "product-source":
        return /* @__PURE__ */ s(ER, { field: e, value: t, onChange: a });
      case "product-select":
        return /* @__PURE__ */ s(is, { field: e, value: t, onChange: a });
      case "product-multi-select":
        return /* @__PURE__ */ s(is, { field: e, multiple: !0, value: t, onChange: a });
      default:
        return null;
    }
  })(), c = e.help ? /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: e.help }) : null;
  return l === void 0 ? c ? /* @__PURE__ */ x("div", { className: "space-y-1", children: [
    n,
    c
  ] }) : n : Sp(e) === "boolean" ? /* @__PURE__ */ x("div", { className: "space-y-1", children: [
    /* @__PURE__ */ x("label", { className: "flex min-h-8 cursor-pointer items-center justify-between gap-3 text-sm text-ink", children: [
      /* @__PURE__ */ s("span", { className: "min-w-0", children: l }),
      n
    ] }),
    c
  ] }) : /* @__PURE__ */ x("div", { className: "space-y-1.5", children: [
    /* @__PURE__ */ s(xt, { className: "block", children: l }),
    n,
    c
  ] });
}, zR = ({ section: e, fields: t, updateProp: a, onOpenGallery: o }) => /* @__PURE__ */ s("div", { className: "space-y-4", children: t.map((r) => {
  var l;
  return /* @__PURE__ */ s(
    Xt,
    {
      label: r.label,
      field: r,
      value: (l = e.props) == null ? void 0 : l[r.key],
      onChange: (i) => a(r.key, i),
      path: r.key,
      onImageRequest: o
    },
    r.key
  );
}) }), VR = (e) => {
  const t = e.replace(/[-_]+/g, " ").trim();
  return t.charAt(0).toUpperCase() + t.slice(1);
}, WR = ({ type: e, variant: t, id: a }) => /* @__PURE__ */ x("div", { className: "shrink-0 border-b border-border bg-card px-4 py-3", children: [
  /* @__PURE__ */ x("div", { className: "flex min-w-0 items-center gap-2", children: [
    /* @__PURE__ */ s("h3", { className: "truncate text-heading-md text-ink", children: VR(e) }),
    /* @__PURE__ */ s(Zn, { tone: "soft", className: "shrink-0", children: t })
  ] }),
  /* @__PURE__ */ s("p", { className: "mt-0.5 truncate font-mono text-xs text-faint", title: a, children: a })
] }), $R = ({ selectedPage: e, selectedSectionId: t }) => {
  var M, E, F, I;
  const { localSettings: a, updateSection: o, schemas: r, issues: l } = at(), i = ia(), { componentSchemas: n } = r, c = (M = a == null ? void 0 : a.pages) == null ? void 0 : M[e], d = (E = c == null ? void 0 : c.sections) == null ? void 0 : E.find((P) => P.id === t);
  if (!d)
    return /* @__PURE__ */ x("div", { className: "flex h-full flex-col items-center justify-center gap-1 p-8 text-center", children: [
      /* @__PURE__ */ s(EA, { className: "mb-2 size-8 text-faint" }),
      /* @__PURE__ */ s("h3", { className: "text-sm font-medium text-ink", children: "No section selected" }),
      /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "Select a section in the list to edit its settings." })
    ] });
  const y = n == null ? void 0 : n[d.type], u = y == null ? void 0 : y.variants.find((P) => P.id === d.variant), h = u || y == null ? void 0 : y.variants[0], p = u ?? h, g = [...(y == null ? void 0 : y.commonFields) || [], ...(p == null ? void 0 : p.fields) || []], m = g.filter((P) => !P.key.startsWith("styles.")), f = g.filter((P) => P.key.startsWith("styles.") && !/^styles\.(hideOn|schedule)/.test(P.key)), v = (P) => P.replace(/^V\d+\s*[—-]\s*/, "").replace(/^V\d+\s*\((.*)\)$/, "$1"), k = (P, O) => {
    o(e, d.id, (z) => ({
      ...z,
      props: { ...z.props ?? {}, [P]: O }
    }), `${d.id}:${P}`);
  }, w = d.styles ?? {}, S = (P) => {
    o(e, d.id, (O) => ({ ...O, styles: { ...O.styles ?? {}, ...P } }));
  }, T = l.filter((P) => P.sectionId === d.id), C = (P) => {
    o(e, d.id, (O) => ({ ...O, variant: P }));
  }, A = (P) => {
    var O;
    (O = i.openMediaPicker) == null || O.call(i, (z) => {
      const U = P.split(".");
      o(e, d.id, (Y) => {
        const _ = Y, H = { ..._.props ?? {} };
        if (U.length === 1)
          H[U[0]] = z;
        else if (U.length === 3) {
          const [N, D, $] = U, V = [...H[N] || []];
          V[Number(D)] && (V[Number(D)] = { ...V[Number(D)], [$]: z }), H[N] = V;
        } else if (U.length === 2) {
          const [N, D] = U;
          H[N] = { ...H[N] || {}, [D]: z };
        }
        return { ..._, props: H };
      });
    });
  };
  return /* @__PURE__ */ x("div", { className: "flex h-full flex-col overflow-hidden bg-card", children: [
    /* @__PURE__ */ s(WR, { type: d.type, variant: p ? v(p.label) : d.variant, id: d.id }),
    /* @__PURE__ */ s(ao, { className: "flex-1", children: /* @__PURE__ */ x("div", { className: "divide-y divide-border-subtle", children: [
      (T.length > 0 || h) && /* @__PURE__ */ x("div", { className: "space-y-2 p-4", children: [
        T.length > 0 && /* @__PURE__ */ s("ul", { className: "space-y-1", children: T.map((P, O) => /* @__PURE__ */ s("li", { className: `rounded-md px-3 py-2 text-sm ${P.level === "error" ? "bg-error-lighter text-error-dark" : "bg-warning-lighter text-warning-dark"}`, children: P.message }, O)) }),
        h && /* @__PURE__ */ x("div", { className: "rounded-md border border-warning-light bg-warning-lighter p-3 text-sm text-warning-dark", role: "status", children: [
          /* @__PURE__ */ x("p", { children: [
            "This section was saved with layout ",
            d.variant.toUpperCase(),
            ", which this theme does not have. The store shows it as “",
            v(h.label),
            "”."
          ] }),
          /* @__PURE__ */ x("button", { type: "button", className: "mt-1.5 font-medium underline underline-offset-2", onClick: () => C(h.id), children: [
            "Use “",
            v(h.label),
            "”"
          ] })
        ] })
      ] }),
      ((y == null ? void 0 : y.variants.length) ?? 0) > 1 && /* @__PURE__ */ s("div", { className: "p-4", children: /* @__PURE__ */ x("fieldset", { className: "m-0 min-w-0 border-0 p-0", children: [
        /* @__PURE__ */ s("legend", { className: "mb-2 p-0 text-sm font-medium text-ink", children: "Layout" }),
        /* @__PURE__ */ s("div", { className: "grid grid-cols-2 gap-2", role: "radiogroup", children: y.variants.map((P) => /* @__PURE__ */ x(
          "button",
          {
            type: "button",
            role: "radio",
            "aria-checked": (p == null ? void 0 : p.id) === P.id,
            onClick: () => C(P.id),
            className: `min-w-0 rounded-md border bg-card p-2 text-left text-sm transition-colors ${(p == null ? void 0 : p.id) === P.id ? "border-ink ring-1 ring-inset ring-ink" : "border-border hover:border-border-strong hover:bg-subdued"}`,
            children: [
              P.previewImage && /* @__PURE__ */ s("img", { src: P.previewImage, alt: "", className: "mb-2 aspect-video w-full rounded-sm bg-subdued object-cover" }),
              /* @__PURE__ */ s("span", { className: "block truncate text-ink", children: v(P.label) }),
              /* @__PURE__ */ s("span", { className: "text-xs text-text-2", children: P.id.toUpperCase() })
            ]
          },
          P.id
        )) })
      ] }) }),
      /* @__PURE__ */ s("div", { className: "p-4", children: /* @__PURE__ */ s(
        zR,
        {
          section: d,
          schema: y,
          fields: m,
          updateVariant: C,
          updateProp: k,
          onOpenGallery: A
        }
      ) }),
      f.length > 0 && /* @__PURE__ */ s("div", { className: "p-4", children: /* @__PURE__ */ x("fieldset", { className: "m-0 min-w-0 space-y-4 border-0 p-0", children: [
        /* @__PURE__ */ s("legend", { className: "mb-3 p-0 text-sm font-medium text-ink", children: "Spacing and background" }),
        f.map((P) => {
          const O = P.key.slice(7);
          return /* @__PURE__ */ s(Xt, { label: P.label, field: { ...P, placeholder: "Theme default" }, value: w[O], onChange: (z) => S({ [O]: z }), path: P.key, onImageRequest: A }, P.key);
        })
      ] }) }),
      /* @__PURE__ */ s("div", { className: "p-4", children: /* @__PURE__ */ x("fieldset", { className: "m-0 min-w-0 space-y-3 border-0 p-0", children: [
        /* @__PURE__ */ s("legend", { className: "mb-3 p-0 text-sm font-medium text-ink", children: "Visibility" }),
        /* @__PURE__ */ x("label", { className: "flex min-h-8 cursor-pointer items-center justify-between gap-3 text-sm text-ink", children: [
          "Show on phones ",
          /* @__PURE__ */ s(Ao, { checked: !w.hideOnMobile, onCheckedChange: (P) => S({ hideOnMobile: !P }) })
        ] }),
        /* @__PURE__ */ x("label", { className: "flex min-h-8 cursor-pointer items-center justify-between gap-3 text-sm text-ink", children: [
          "Show on computers ",
          /* @__PURE__ */ s(Ao, { checked: !w.hideOnDesktop, onCheckedChange: (P) => S({ hideOnDesktop: !P }) })
        ] }),
        /* @__PURE__ */ x("div", { className: "space-y-1.5 text-sm text-ink", children: [
          /* @__PURE__ */ s("span", { className: "block", children: "Show from" }),
          /* @__PURE__ */ s(ls, { field: { key: "start", label: "Show from", type: "datetime" }, value: ((F = w.schedule) == null ? void 0 : F.start) ?? "", onChange: (P) => S({ schedule: { ...w.schedule, start: P || void 0 } }) })
        ] }),
        /* @__PURE__ */ x("div", { className: "space-y-1.5 text-sm text-ink", children: [
          /* @__PURE__ */ s("span", { className: "block", children: "Show until" }),
          /* @__PURE__ */ s(ls, { field: { key: "end", label: "Show until", type: "datetime" }, value: ((I = w.schedule) == null ? void 0 : I.end) ?? "", onChange: (P) => S({ schedule: { ...w.schedule, end: P || void 0 } }) })
        ] }),
        /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "Use dates for drops and sales: the section appears and disappears on its own." })
      ] }) })
    ] }) })
  ] });
}, _R = [
  { key: "hotline", label: "Hotline", type: "string", placeholder: "01XXXXXXXXX" },
  { key: "whatsapp", label: "WhatsApp number", type: "string", placeholder: "8801XXXXXXXXX" },
  { key: "email", label: "Support email", type: "string" },
  { key: "freeDeliveryThreshold", label: "Free delivery over (amount, display only)", type: "number" },
  { key: "returnWindowDays", label: "Return window (days)", type: "number" },
  { key: "deliveryEta", label: "Delivery time (shown on product cards)", type: "string", placeholder: "1–2 hours inside Dhaka", help: "Leave empty to hide. Only promise what you deliver." },
  {
    key: "addresses",
    label: "Addresses",
    type: "array",
    itemSchema: [
      { key: "label", label: "Label", type: "string", placeholder: "Head office" },
      { key: "text", label: "Address", type: "text" }
    ]
  },
  {
    key: "paymentBadges",
    label: "Payment methods shown in the footer",
    type: "array",
    itemSchema: [{ key: "name", label: "Name", type: "string", placeholder: "bKash" }]
  },
  { key: "tradeLicense", label: "Trade licence", type: "string" },
  { key: "bilingual", label: "Show Bangla text where written", type: "boolean" }
], HR = ({ hidden: e = [], storeInfo: t, onChange: a }) => /* @__PURE__ */ x("div", { className: "space-y-4", children: [
  /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "Shown across your store: header, footer, product page, cart and checkout." }),
  _R.filter((o) => !e.includes(o.key)).map((o) => /* @__PURE__ */ s(Xt, { label: o.label, field: o, value: t == null ? void 0 : t[o.key], onChange: (r) => a(o.key, r), onImageRequest: () => {
  } }, o.key))
] }), UR = ({ footer: e, footerSchema: t, handleFooterChange: a, handleDeepUpdate: o, onImageRequest: r }) => {
  var l, i;
  return /* @__PURE__ */ x("div", { className: "space-y-4", children: [
    ((l = t == null ? void 0 : t.variants) == null ? void 0 : l.length) > 1 && /* @__PURE__ */ x("div", { className: "space-y-1.5", children: [
      /* @__PURE__ */ s(xt, { className: "block", children: "Layout" }),
      /* @__PURE__ */ x(wa, { value: e.variant, onValueChange: (n) => a({ variant: n }), children: [
        /* @__PURE__ */ s(oa, { children: /* @__PURE__ */ s(Sa, {}) }),
        /* @__PURE__ */ s(ra, { children: t.variants.map((n) => /* @__PURE__ */ s(la, { value: n.id, children: n.label }, n.id)) })
      ] }),
      /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "The layout of your store's footer." })
    ] }),
    (i = t == null ? void 0 : t.commonFields) == null ? void 0 : i.filter((n) => n.key !== "styles").map((n) => /* @__PURE__ */ s(
      Xt,
      {
        label: n.label,
        field: n,
        value: n.key.includes(".") ? n.key.split(".").reduce((c, d) => c == null ? void 0 : c[d], e) : e[n.key],
        onChange: (c) => {
          if (n.key.includes(".")) {
            const d = n.key.split(".");
            d.length === 2 && a({ [d[0]]: { ...e[d[0]] || {}, [d[1]]: c } });
          } else
            o("footer", n.key, c);
        },
        onImageRequest: (c) => r(`footer.${c}`)
      },
      n.key
    ))
  ] });
}, GR = [
  { label: "None", value: "none" },
  { label: "Small (4px)", value: "sm" },
  { label: "Medium (8px)", value: "md" },
  { label: "Large (12px)", value: "lg" },
  { label: "X-Large (16px)", value: "xl" },
  { label: "2X-Large (20px)", value: "2xl" },
  { label: "Full (pill)", value: "full" }
], YR = [
  { label: "Inter", value: "'Inter', sans-serif" },
  { label: "Poppins", value: "'Poppins', sans-serif" },
  { label: "Roboto", value: "'Roboto', sans-serif" },
  { label: "Montserrat", value: "'Montserrat', sans-serif" },
  { label: "Playfair Display", value: "'Playfair Display', serif" },
  { label: "Open Sans", value: "'Open Sans', sans-serif" },
  { label: "Lato", value: "'Lato', sans-serif" },
  { label: "Noto Sans Bengali", value: "'Noto Sans Bengali', sans-serif" },
  { label: "Hind Siliguri", value: "'Hind Siliguri', sans-serif" },
  { label: "Noto Serif Bengali", value: "'Noto Serif Bengali', serif" },
  { label: "Atma", value: "'Atma', cursive" },
  { label: "Mina", value: "'Mina', sans-serif" }
], XR = ({
  hidden: e = [],
  typography: t,
  handleTypographyChange: a,
  radius: o,
  handleRadiusChange: r
}) => /* @__PURE__ */ x("div", { className: "space-y-4", children: [
  !e.includes("radius") && /* @__PURE__ */ x("div", { className: "space-y-1.5", children: [
    /* @__PURE__ */ s(xt, { className: "block", children: "Corner roundness" }),
    /* @__PURE__ */ x(wa, { value: o || void 0, onValueChange: r, children: [
      /* @__PURE__ */ s(oa, { children: /* @__PURE__ */ s(Sa, { placeholder: "Theme default" }) }),
      /* @__PURE__ */ s(ra, { children: GR.map((l) => /* @__PURE__ */ s(la, { value: l.value, children: l.label }, l.value)) })
    ] }),
    /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "Buttons, inputs, tags and cards. Empty = the theme’s own corners." })
  ] }),
  ["heading", "body"].map((l) => /* @__PURE__ */ x("div", { className: "space-y-1.5", children: [
    /* @__PURE__ */ s(xt, { className: "block", children: l === "heading" ? "Heading font" : "Body font" }),
    /* @__PURE__ */ x(wa, { value: t[l], onValueChange: (i) => a(l, i), children: [
      /* @__PURE__ */ s(oa, { children: /* @__PURE__ */ s(Sa, { placeholder: "Theme default" }) }),
      /* @__PURE__ */ s(ra, { children: YR.map((i) => /* @__PURE__ */ s(la, { value: i.value, children: i.label }, i.value)) })
    ] })
  ] }, l))
] }), jR = ({ header: e, headerSchema: t, handleHeaderChange: a, handleDeepUpdate: o, onImageRequest: r }) => {
  var l, i;
  return /* @__PURE__ */ x("div", { className: "space-y-4", children: [
    ((l = t == null ? void 0 : t.variants) == null ? void 0 : l.length) > 1 && /* @__PURE__ */ x("div", { className: "space-y-1.5", children: [
      /* @__PURE__ */ s(xt, { className: "block", children: "Layout" }),
      /* @__PURE__ */ x(wa, { value: e.variant, onValueChange: (n) => a({ variant: n }), children: [
        /* @__PURE__ */ s(oa, { children: /* @__PURE__ */ s(Sa, {}) }),
        /* @__PURE__ */ s(ra, { children: t.variants.map((n) => /* @__PURE__ */ s(la, { value: n.id, children: n.label }, n.id)) })
      ] }),
      /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "The layout of your store's navigation." })
    ] }),
    (i = t == null ? void 0 : t.commonFields) == null ? void 0 : i.filter((n) => n.key !== "styles").map((n) => n.key === "logo.alt" ? null : /* @__PURE__ */ s(
      Xt,
      {
        label: n.key.startsWith("logo") ? "Logo" : n.label,
        field: n,
        value: n.key.includes(".") ? n.key.split(".").reduce((c, d) => c == null ? void 0 : c[d], e) : e[n.key],
        onChange: (c) => {
          if (n.key.includes(".")) {
            const d = n.key.split(".");
            d.length === 2 && a({ [d[0]]: { ...e[d[0]] || {}, [d[1]]: c } });
          } else
            o("header", n.key, c);
        },
        onImageRequest: (c) => r(`header.${c}`)
      },
      n.key
    ))
  ] });
}, qR = ({ onImageRequest: e }) => {
  var n, c;
  const { localSettings: t, updateGlobalSEO: a } = at(), o = (t == null ? void 0 : t.seo) ?? {}, r = (d, y) => a({ [d]: y }), l = ((n = o.title) == null ? void 0 : n.length) || 0, i = ((c = o.description) == null ? void 0 : c.length) || 0;
  return /* @__PURE__ */ x("div", { className: "space-y-4", children: [
    /* @__PURE__ */ x("div", { className: "space-y-1.5", children: [
      /* @__PURE__ */ x("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ s(xt, { children: "Meta title" }),
        /* @__PURE__ */ x("span", { className: `text-xs tabular-nums ${l > 60 ? "text-warning-dark" : "text-text-2"}`, children: [
          l,
          " / 60"
        ] })
      ] }),
      /* @__PURE__ */ s(Ze, { value: o.title || "", onChange: (d) => r("title", d.target.value), placeholder: "e.g. My Store - Premium Products" })
    ] }),
    /* @__PURE__ */ x("div", { className: "space-y-1.5", children: [
      /* @__PURE__ */ x("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ s(xt, { children: "Meta description" }),
        /* @__PURE__ */ x("span", { className: `text-xs tabular-nums ${i > 160 ? "text-warning-dark" : "text-text-2"}`, children: [
          i,
          " / 160"
        ] })
      ] }),
      /* @__PURE__ */ s(Fr, { value: o.description || "", onChange: (d) => r("description", d.target.value), placeholder: "Briefly describe what your store sells.", className: "min-h-24" })
    ] }),
    /* @__PURE__ */ x("div", { className: "space-y-1.5", children: [
      /* @__PURE__ */ s(xt, { className: "block", children: "Keywords" }),
      /* @__PURE__ */ s(Ze, { value: (o.keywords ?? []).join(", "), onChange: (d) => r("keywords", d.target.value.split(",").map((y) => y.trim())), placeholder: "gadgets, electronics, accessories" })
    ] }),
    /* @__PURE__ */ x("label", { className: "flex cursor-pointer items-start justify-between gap-3", children: [
      /* @__PURE__ */ x("span", { className: "min-w-0 space-y-0.5", children: [
        /* @__PURE__ */ s("span", { className: "block text-sm text-ink", children: "Search engine indexing" }),
        /* @__PURE__ */ s("span", { className: "block text-xs text-text-2", children: "Allow Google to index your store." })
      ] }),
      /* @__PURE__ */ s(Ao, { checked: o.index_allow !== !1, onCheckedChange: (d) => r("index_allow", d) })
    ] }),
    /* @__PURE__ */ x("div", { className: "space-y-3 border-t border-border-subtle pt-4", children: [
      /* @__PURE__ */ x("div", { className: "space-y-0.5", children: [
        /* @__PURE__ */ s("p", { className: "text-sm font-medium text-ink", children: "Social sharing image" }),
        /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "This image appears when your store link is shared on social platforms." })
      ] }),
      /* @__PURE__ */ x("div", { className: "overflow-hidden rounded-md border border-border bg-card", children: [
        /* @__PURE__ */ s("div", { className: "flex aspect-[1200/630] items-center justify-center bg-subdued", children: o.ogImage ? /* @__PURE__ */ s("img", { src: o.ogImage, alt: "Social sharing preview", className: "h-full w-full object-cover" }) : /* @__PURE__ */ x("div", { className: "flex flex-col items-center gap-1.5 text-text-2", children: [
          /* @__PURE__ */ s(Ps, { className: "size-6" }),
          /* @__PURE__ */ s("span", { className: "text-xs", children: "No image selected" })
        ] }) }),
        /* @__PURE__ */ s("div", { className: "flex justify-end border-t border-border-subtle p-2", children: /* @__PURE__ */ s(le, { size: "sm", variant: "secondary", onClick: () => e("seo.ogImage"), children: o.ogImage ? "Change" : "Select image" }) })
      ] }),
      /* @__PURE__ */ x("div", { className: "space-y-1.5", children: [
        /* @__PURE__ */ s(xt, { className: "block", children: "Image URL" }),
        /* @__PURE__ */ s(Ze, { value: o.ogImage || "", onChange: (d) => r("ogImage", d.target.value), className: "font-mono text-xs", placeholder: "https://..." })
      ] })
    ] })
  ] });
}, ZR = ({ floatingButtons: e, floatingButtonsSchema: t, handleDeepUpdate: a }) => {
  var o;
  return /* @__PURE__ */ s("div", { className: "space-y-4", children: (o = t == null ? void 0 : t.commonFields) == null ? void 0 : o.map((r) => /* @__PURE__ */ s(Xt, { label: r.label, field: r, value: e == null ? void 0 : e[r.key], onChange: (l) => a("floatingButtons", r.key, l), onImageRequest: () => {
  } }, r.key)) });
}, JR = ({ mobileBottomNav: e, mobileNavSchema: t, handleDeepUpdate: a }) => {
  var o;
  return /* @__PURE__ */ s("div", { className: "space-y-4", children: (o = t == null ? void 0 : t.commonFields) == null ? void 0 : o.map((r) => /* @__PURE__ */ s(Xt, { label: r.label, field: r, value: e == null ? void 0 : e[r.key], onChange: (l) => a("mobileBottomNav", r.key, l), onImageRequest: () => {
  } }, r.key)) });
}, KR = ({ buttons: e, buttonsSchema: t, onButtonsChange: a }) => {
  var o;
  return /* @__PURE__ */ s("div", { className: "space-y-4", children: (o = t == null ? void 0 : t.commonFields) == null ? void 0 : o.map((r) => {
    const l = r.key.split(".").pop() ?? r.key;
    return /* @__PURE__ */ s(
      Xt,
      {
        label: r.label,
        field: { ...r, key: l },
        value: e == null ? void 0 : e[l],
        onChange: (i) => a(l, i),
        onImageRequest: () => {
        }
      },
      r.key
    );
  }) });
}, QR = ({ title: e, open: t, onToggle: a, children: o }) => /* @__PURE__ */ x("div", { className: "border-b border-border-subtle", children: [
  /* @__PURE__ */ x(
    "button",
    {
      type: "button",
      onClick: a,
      "aria-expanded": t,
      className: "flex h-11 w-full items-center justify-between px-4 text-left text-sm font-medium text-ink outline-none hover:bg-subdued focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring",
      children: [
        e,
        /* @__PURE__ */ s(Bl, { className: St("size-4 text-muted-foreground transition-transform", t && "rotate-180"), "aria-hidden": "true" })
      ]
    }
  ),
  t && /* @__PURE__ */ s("div", { className: "px-4 pb-5 pt-1", children: o })
] }), eB = () => {
  var C, A;
  const [e, t] = j("design"), a = (M) => t((E) => E === M ? null : M), { localSettings: o, updateThemeConfig: r, updateGlobalSEO: l, schemas: i } = at(), n = ia(), c = (o == null ? void 0 : o.config) ?? {}, d = c.tokens ?? { typography: {}, radius: "" }, y = d.typography ?? {}, u = d.radius ?? "", h = c.header ?? {}, p = c.footer ?? {}, g = c.floatingButtons ?? {}, m = c.appearance ?? {}, f = m.buttons ?? {}, v = c.mobileBottomNav ?? {}, k = c.storeInfo ?? {}, w = (M, E, F) => {
    const P = { ...{ header: h, footer: p, floatingButtons: g, mobileBottomNav: v }[M] };
    P[E] = F, r({ [M]: P });
  }, S = (M) => {
    var E;
    (E = n.openMediaPicker) == null || E.call(n, (F) => {
      const I = M.trim().split("."), P = I[0], O = I.slice(1), z = (U, Y, _) => {
        if (Y.length === 0) return U;
        const [H, ...N] = Y;
        if (Array.isArray(U)) {
          const $ = Number(H), V = [...U];
          return V[$] = N.length === 0 ? _ : z(V[$] ?? {}, N, _), V;
        }
        if (N.length === 0) return { ...U, [H]: _ };
        const D = U[H];
        return { ...U, [H]: z(Array.isArray(D) ? D : D ?? {}, N, _) };
      };
      P === "header" ? r({ header: z(h, O, F) }) : P === "footer" ? r({ footer: z(p, O, F) }) : P === "seo" ? l(z((o == null ? void 0 : o.seo) ?? {}, O, F)) : P === "mobileBottomNav" ? r({ mobileBottomNav: z(v, O, F) }) : P === "floatingButtons" && r({ floatingButtons: z(g, O, F) });
    });
  }, T = [
    {
      key: "design",
      title: "Design",
      content: /* @__PURE__ */ s(
        XR,
        {
          hidden: (C = i == null ? void 0 : i.hiddenSettings) == null ? void 0 : C.design,
          radius: u,
          handleRadiusChange: (M) => r({ tokens: { ...d, radius: M } }),
          typography: y,
          handleTypographyChange: (M, E) => r({ tokens: { ...d, typography: { ...y, [M]: E } } })
        }
      )
    },
    {
      key: "store",
      title: "Store",
      content: /* @__PURE__ */ s(HR, { hidden: (A = i == null ? void 0 : i.hiddenSettings) == null ? void 0 : A.storeInfo, storeInfo: k, onChange: (M, E) => r({ storeInfo: { ...k, [M]: E } }) })
    },
    { key: "seo", title: "SEO", content: /* @__PURE__ */ s(qR, { onImageRequest: S }) },
    {
      key: "header",
      title: "Header",
      content: /* @__PURE__ */ s(jR, { header: h, headerSchema: i == null ? void 0 : i.headerSchema, handleHeaderChange: (M) => r({ header: { ...h, ...M } }), handleDeepUpdate: w, onImageRequest: S })
    },
    {
      key: "footer",
      title: "Footer",
      content: /* @__PURE__ */ s(UR, { footer: p, footerSchema: i == null ? void 0 : i.footerSchema, handleFooterChange: (M) => r({ footer: { ...p, ...M } }), handleDeepUpdate: w, onImageRequest: S })
    },
    {
      key: "floating",
      title: "Floating actions",
      content: /* @__PURE__ */ s(ZR, { floatingButtons: g, floatingButtonsSchema: i == null ? void 0 : i.floatingButtonsSchema, handleDeepUpdate: w })
    },
    {
      key: "mobile_nav",
      title: "Mobile navigation",
      content: /* @__PURE__ */ s(JR, { mobileBottomNav: v, mobileNavSchema: i == null ? void 0 : i.mobileNavSchema, handleMobileBottomNavChange: (M) => r({ mobileBottomNav: { ...v, ...M } }), handleDeepUpdate: w })
    },
    {
      key: "buttons",
      title: "Buttons",
      content: /* @__PURE__ */ s(
        KR,
        {
          buttons: f,
          buttonsSchema: i == null ? void 0 : i.buttonsSchema,
          onButtonsChange: (M, E) => r({ appearance: { ...m, buttons: { ...f, [M]: E } } })
        }
      )
    }
  ];
  return /* @__PURE__ */ s(ao, { className: "h-full", children: /* @__PURE__ */ s("div", { className: "pb-4", children: T.map((M) => /* @__PURE__ */ s(QR, { title: M.title, open: e === M.key, onToggle: () => a(M.key), children: M.content }, M.key)) }) });
}, xp = ({ editMode: e, selectedPage: t, selectedSectionId: a }) => e === "global" ? /* @__PURE__ */ s(eB, {}) : a ? /* @__PURE__ */ s($R, { selectedPage: t, selectedSectionId: a }) : /* @__PURE__ */ x("div", { className: "flex h-full flex-col items-center justify-center bg-background p-8 text-center", children: [
  /* @__PURE__ */ s("span", { className: "mb-4 grid size-14 place-items-center rounded-full bg-subdued", children: /* @__PURE__ */ s(TA, { className: "size-6 text-faint" }) }),
  /* @__PURE__ */ s("p", { className: "text-sm font-medium text-ink", children: "Select a section to edit" }),
  /* @__PURE__ */ s("p", { className: "mt-1 max-w-56 text-xs text-muted-foreground", children: "Choose a section in the list to change its content." })
] }), tB = () => {
  const e = ia(), t = at(), [a, o] = j([]);
  ne(() => {
    e.versions ? e.versions.list().then((l) => o(l.map((i) => ({ id: i.id, label: i.label ?? "Published", at: Date.parse(i.publishedAt) })))).catch(() => Me.error("Could not load the version history")) : o(t.listLocalVersions().map((l) => ({ id: l.id, label: l.label, at: l.publishedAt })));
  }, [e.versions, t.themeSettings]);
  const r = async (l) => {
    var i;
    try {
      const n = e.versions ? await e.versions.get(l) : (i = t.listLocalVersions().find((c) => c.id === l)) == null ? void 0 : i.settings;
      n && t.restoreVersion(n);
    } catch {
      Me.error("Could not load that version");
    }
  };
  return /* @__PURE__ */ s(ao, { className: "h-full", children: /* @__PURE__ */ x("div", { className: "space-y-3 p-4", children: [
    /* @__PURE__ */ s("h2", { className: "text-sm font-medium text-ink", children: "Published versions" }),
    !e.versions && /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "Kept in this browser (last 20) until version history is stored on the server." }),
    a.length === 0 && /* @__PURE__ */ s("p", { className: "text-sm text-text-2", children: "Nothing published from here yet." }),
    /* @__PURE__ */ s("ul", { className: "divide-y divide-border-subtle rounded-md border border-border bg-card", children: a.map((l) => /* @__PURE__ */ x("li", { className: "flex items-center justify-between gap-2 px-3 py-2", children: [
      /* @__PURE__ */ x("span", { className: "min-w-0", children: [
        /* @__PURE__ */ s("span", { className: "block truncate text-sm text-ink", children: l.label }),
        /* @__PURE__ */ s("span", { className: "text-xs text-text-2", children: new Date(l.at).toLocaleString() })
      ] }),
      /* @__PURE__ */ s(le, { size: "sm", variant: "outline", onClick: () => void r(l.id), children: "Restore" })
    ] }, l.id)) })
  ] }) });
}, aB = {
  // Fresh Basket derives tints, CTA and link colour from the primary (brandShades), so one colour is enough.
  "essentials-1": [
    { id: "cyan", name: "Fresh cyan", mode: "light" },
    { id: "leaf", name: "Leaf", mode: "light", colors: { primary: "#2fa84f" } },
    { id: "berry", name: "Berry", mode: "light", colors: { primary: "#d6336c" } },
    { id: "night", name: "Night", mode: "dark" }
  ],
  "lightings-1": [
    { id: "amber", name: "Amber glow", mode: "dark" },
    { id: "ice", name: "Ice", mode: "dark", colors: { primary: "#3ee6ff", accent: "#ffb547" } },
    { id: "daylight", name: "Daylight", mode: "light" }
  ],
  "apparels-2": [
    { id: "ink", name: "Ink", mode: "light" },
    { id: "volt", name: "Volt", mode: "light", colors: { primary: "#c6f432" } },
    { id: "midnight", name: "Midnight", mode: "dark" }
  ],
  "apparels-3": [
    { id: "maroon", name: "Maroon", mode: "light" },
    { id: "jamdani", name: "Jamdani teal", mode: "light", colors: { primary: "#0f5c5a", accent: "#7a1f2b" } },
    { id: "raat", name: "Raat", mode: "dark" }
  ],
  "apparels-4": [
    { id: "teal", name: "Teal thread", mode: "light" },
    { id: "indigo", name: "Indigo", mode: "light", colors: { primary: "#2f3e8f" } },
    { id: "raat", name: "Raat", mode: "dark" }
  ],
  "apparels-5": [
    { id: "holud", name: "Holud", mode: "light" },
    { id: "shobuj", name: "Shobuj", mode: "light", colors: { primary: "#1d6b45" } },
    { id: "raat", name: "Raat", mode: "dark" }
  ],
  "footwear-1": [
    { id: "volt", name: "Volt", mode: "light" },
    { id: "lal", name: "Lal", mode: "light", colors: { primary: "#e4471d" } },
    { id: "neel", name: "Neel", mode: "light", colors: { primary: "#2b4cf0" } },
    { id: "raat", name: "Raat", mode: "dark" }
  ],
  "furniture-1": [
    { id: "teak", name: "Teak", mode: "light" },
    { id: "sage", name: "Sage", mode: "light", colors: { primary: "#566a48", accent: "#7b4a2a" } },
    { id: "shondhya", name: "Shondhya", mode: "dark" }
  ],
  "essentials-2": [
    { id: "red", name: "Bazar red", mode: "light" },
    { id: "green", name: "Fresh green", mode: "light", colors: { primary: "#1e7a34" } },
    { id: "raat", name: "Raat", mode: "dark" }
  ],
  "books-1": [
    { id: "blue", name: "Cream and amber", mode: "light" },
    { id: "teal", name: "Teal", mode: "light", colors: { primary: "#00796b" } },
    { id: "night", name: "Night reading (charcoal)", mode: "dark" }
  ],
  "gadgets-1": [
    { id: "electric", name: "Electric blue", mode: "light" },
    { id: "teal", name: "Signal teal", mode: "light", colors: { primary: "#0b7a75" } },
    { id: "raat", name: "Raat", mode: "dark" }
  ],
  "computers-1": [
    { id: "teal", name: "Circuit teal", mode: "light" },
    { id: "amber", name: "Amber", mode: "light", colors: { primary: "#b45309" } },
    { id: "raat", name: "Raat", mode: "dark" }
  ]
}, oB = ({ themeId: e, onClose: t }) => {
  const a = at(), [o, r] = j(!0), [l, i] = j(!0), n = fe(() => {
    if (!e || !a.localSettings) return null;
    const u = new Set(Object.keys(ou(e, "theme").componentSchemas ?? {}));
    return HP(a.localSettings, u, gu(e));
  }, [e, a.localSettings]), c = e ? Ls[e] : null, d = Object.keys((n == null ? void 0 : n.fill) ?? {}), y = () => {
    !e || !n || (a.switchTheme(e, { fill: o ? n.fill : {}, themeLook: l ? { mode: (c == null ? void 0 : c.defaultMode) ?? "light" } : void 0 }), t());
  };
  return /* @__PURE__ */ s(Ta, { open: !!e, onOpenChange: (u) => !u && t(), children: /* @__PURE__ */ x(ca, { size: "md", children: [
    /* @__PURE__ */ x(oo, { children: [
      /* @__PURE__ */ x(ro, { children: [
        "Switch to ",
        c ? zl(c) : "",
        "?"
      ] }),
      /* @__PURE__ */ s(Nr, { children: "Your pages and content stay; only the look changes. Undo switches back." })
    ] }),
    n && /* @__PURE__ */ x("div", { className: "space-y-3 text-sm text-ink", children: [
      n.pages.length > 0 && /* @__PURE__ */ s("ul", { className: "divide-y divide-border-subtle rounded-lg border border-border", children: n.pages.map((u) => /* @__PURE__ */ x("li", { className: "px-3 py-2", children: [
        /* @__PURE__ */ s("span", { className: "font-medium", children: Ol(u.page) }),
        /* @__PURE__ */ x("span", { className: "text-text-2", children: [
          " · ",
          u.own,
          " of ",
          u.sections,
          " sections in the ",
          c == null ? void 0 : c.name,
          " style"
        ] }),
        u.shared.length > 0 && /* @__PURE__ */ x("p", { className: "mt-0.5 text-xs text-text-2", children: [
          "Shared look: ",
          u.shared.join(", ")
        ] })
      ] }, u.page)) }),
      /* @__PURE__ */ x("label", { className: "flex cursor-pointer items-start gap-2.5 rounded-md bg-subdued p-3", children: [
        /* @__PURE__ */ s("input", { type: "checkbox", className: "mt-0.5 size-4 shrink-0 accent-primary", checked: l, onChange: (u) => i(u.target.checked) }),
        /* @__PURE__ */ x("span", { children: [
          "Start from ",
          c == null ? void 0 : c.name,
          "'s own look: ",
          (c == null ? void 0 : c.defaultMode) === "dark" ? "dark" : "light",
          " mode, its colours and fonts. Undo brings yours back."
        ] })
      ] }),
      d.length > 0 && /* @__PURE__ */ x("label", { className: "flex cursor-pointer items-start gap-2.5 rounded-md bg-subdued p-3", children: [
        /* @__PURE__ */ s("input", { type: "checkbox", className: "mt-0.5 size-4 shrink-0 accent-primary", checked: o, onChange: (u) => r(u.target.checked) }),
        /* @__PURE__ */ x("span", { children: [
          "Use ",
          c == null ? void 0 : c.name,
          "'s layout for ",
          d.length,
          " empty ",
          d.length === 1 ? "page" : "pages",
          ": ",
          d.map(Ol).join(", ")
        ] })
      ] })
    ] }),
    /* @__PURE__ */ x(Ho, { children: [
      /* @__PURE__ */ s(le, { variant: "outline", onClick: t, children: "Cancel" }),
      /* @__PURE__ */ s(le, { onClick: y, children: "Switch theme" })
    ] })
  ] }) });
}, rB = ({ page: e }) => {
  var n, c, d, y;
  const t = at(), a = ((c = (n = t.localSettings) == null ? void 0 : n.config) == null ? void 0 : c.themeId) ?? "", o = ((y = (d = t.localSettings) == null ? void 0 : d.config) == null ? void 0 : y.appearance) ?? {}, r = DL(e, a, t.library === "all"), [l, i] = j(null);
  return /* @__PURE__ */ s(ao, { className: "h-full", children: /* @__PURE__ */ x("div", { className: "divide-y divide-border-subtle", children: [
    /* @__PURE__ */ x("section", { className: "p-4", children: [
      /* @__PURE__ */ s("h2", { className: "mb-2 text-sm font-medium text-ink", children: "Theme" }),
      /* @__PURE__ */ s("ul", { className: "space-y-1.5", children: mu().map((u) => /* @__PURE__ */ s("li", { children: /* @__PURE__ */ x(
        "button",
        {
          type: "button",
          onClick: () => u.id !== a && i(u.id),
          className: `flex w-full items-end justify-between gap-2 rounded-md border bg-card p-2 text-left transition-colors ${u.id === a ? "border-ink ring-1 ring-inset ring-ink" : "border-border hover:border-border-strong hover:bg-subdued"}`,
          children: [
            /* @__PURE__ */ x("span", { className: "min-w-0", children: [
              u.thumbnail && /* @__PURE__ */ s("img", { src: u.thumbnail, alt: "", loading: "lazy", className: "mb-2 aspect-[16/10] w-full rounded-sm border border-border-subtle object-cover object-top", onError: (h) => {
                h.currentTarget.hidden = !0;
              } }),
              /* @__PURE__ */ s("span", { className: "block truncate text-sm text-ink", children: zl(u) }),
              /* @__PURE__ */ x("span", { className: "text-xs text-text-2", children: [
                u.category,
                " · ",
                u.defaultMode === "dark" ? "dark" : "light",
                " by default"
              ] })
            ] }),
            u.id === a && /* @__PURE__ */ s(cr, { className: "size-4 shrink-0 text-ink" })
          ]
        }
      ) }, u.id)) }),
      /* @__PURE__ */ s("p", { className: "mt-2 text-xs text-text-2", children: "Switching theme keeps your pages and content; only the look changes." }),
      /* @__PURE__ */ s(oB, { themeId: l, onClose: () => i(null) })
    ] }),
    /* @__PURE__ */ x("section", { className: "p-4", children: [
      /* @__PURE__ */ s("h2", { className: "mb-2 text-sm font-medium text-ink", children: "Colour presets" }),
      /* @__PURE__ */ s("div", { className: "space-y-1.5", children: (aB[a] ?? []).map((u) => /* @__PURE__ */ x(le, { variant: "outline", className: "h-8 w-full justify-between rounded-md px-3 text-sm font-normal", onClick: () => t.applyPreset(u), children: [
        u.name,
        /* @__PURE__ */ x("span", { className: "text-xs text-text-2", children: [
          u.mode,
          o.colorMode === u.mode && !u.colors ? " · current" : ""
        ] })
      ] }, u.id)) })
    ] }),
    /* @__PURE__ */ x("section", { className: "p-4", children: [
      /* @__PURE__ */ x("h2", { className: "mb-2 text-sm font-medium text-ink", children: [
        Ol(e),
        " templates"
      ] }),
      r.length === 0 && /* @__PURE__ */ s("p", { className: "text-xs text-text-2", children: "No template for this page yet." }),
      /* @__PURE__ */ s("ul", { className: "space-y-1.5", children: r.map((u) => /* @__PURE__ */ x("li", { className: "rounded-md border border-border bg-card p-3", children: [
        /* @__PURE__ */ s("p", { className: "text-sm text-ink", children: u.name }),
        /* @__PURE__ */ x("p", { className: "mb-2 text-xs text-text-2", children: [
          u.sections.length,
          " sections: ",
          u.sections.map((h) => h.type).slice(0, 5).join(", "),
          u.sections.length > 5 ? "…" : ""
        ] }),
        /* @__PURE__ */ s(le, { size: "sm", variant: "secondary", onClick: () => t.applyTemplate(u), children: "Use for this page" })
      ] }, u.id)) }),
      /* @__PURE__ */ s("p", { className: "mt-2 text-xs text-text-2", children: "A template replaces this page's sections. Undo brings yours back." })
    ] })
  ] }) });
}, lB = () => {
  const e = at();
  return e.pendingDraft ? /* @__PURE__ */ x("div", { className: "flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-info-light bg-info-lighter px-4 py-2 text-sm text-info-dark", role: "status", children: [
    /* @__PURE__ */ s(mA, { className: "size-4 shrink-0", "aria-hidden": !0 }),
    /* @__PURE__ */ x("span", { className: "min-w-0 flex-1", children: [
      "You have unpublished changes from ",
      new Date(e.pendingDraft.savedAt).toLocaleString(),
      ".",
      e.pendingDraft.stale && " The live theme has been published since then; check before publishing."
    ] }),
    /* @__PURE__ */ s(le, { onClick: e.restoreDraft, children: "Continue editing" }),
    /* @__PURE__ */ s(le, { variant: "ghost", className: "text-info-dark hover:bg-info-light", onClick: e.dismissDraft, children: "Start from the live theme" })
  ] }) : null;
}, iB = () => {
  const e = at();
  return /* @__PURE__ */ s(Ta, { open: !!e.conflict, onOpenChange: () => {
  }, children: /* @__PURE__ */ x(ca, { size: "sm", children: [
    /* @__PURE__ */ x(oo, { children: [
      /* @__PURE__ */ s(ro, { children: "The theme changed while you were editing" }),
      /* @__PURE__ */ s(Nr, { children: "Someone published a newer version. Publishing yours replaces it; loading theirs keeps your edits in undo." })
    ] }),
    /* @__PURE__ */ x(Ho, { children: [
      /* @__PURE__ */ s(le, { variant: "outline", onClick: () => e.resolveConflict("reload"), children: "Load their version" }),
      /* @__PURE__ */ s(le, { variant: "destructive", onClick: () => e.resolveConflict("overwrite"), children: "Publish mine anyway" })
    ] })
  ] }) });
}, Tp = ({ onOpen: e }) => {
  const { issues: t } = at();
  return t.length ? /* @__PURE__ */ x("div", { className: "space-y-2 border-b border-border p-3", children: [
    /* @__PURE__ */ s("p", { className: "text-sm font-medium text-ink", children: "Before publishing" }),
    /* @__PURE__ */ s("ul", { className: "max-h-40 space-y-1 overflow-y-auto", children: t.map((a, o) => /* @__PURE__ */ s("li", { children: /* @__PURE__ */ x("button", { type: "button", onClick: () => e(a.page, a.sectionId), className: `w-full rounded-md px-2.5 py-1.5 text-left text-sm transition-colors ${a.level === "error" ? "bg-error-lighter text-error-dark hover:bg-error-light" : "bg-warning-lighter text-warning-dark hover:bg-warning-light"}`, children: [
      a.level === "error" ? "Must fix: " : "",
      a.message,
      " ",
      /* @__PURE__ */ x("span", { className: "text-xs opacity-75", children: [
        "(",
        a.page,
        ")"
      ] })
    ] }) }, o)) })
  ] }) : null;
}, nB = [
  { id: "sections", label: "Sections", Icon: vA },
  { id: "theme", label: "Theme settings", Icon: PA },
  { id: "library", label: "Library", Icon: DA },
  { id: "history", label: "History", Icon: hA },
  { id: "setup", label: "Setup", Icon: kA }
], Cp = ({ value: e, onChange: t, setupLeft: a }) => /* @__PURE__ */ s("nav", { className: "flex w-12 shrink-0 flex-col items-center gap-1 border-r border-border bg-card py-2", "aria-label": "Editor panels", children: nB.map(({ id: o, label: r, Icon: l }) => /* @__PURE__ */ x(
  "button",
  {
    type: "button",
    onClick: () => t(o),
    "aria-current": e === o ? "page" : void 0,
    "aria-label": o === "setup" && a > 0 ? `${r} (${a} left)` : r,
    title: r,
    className: St(
      "relative grid size-9 place-items-center rounded-md outline-none transition-colors focus-visible:ring-2 focus-visible:ring-ring",
      e === o ? "bg-selected text-ink" : "text-muted-foreground hover:bg-subdued hover:text-ink"
    ),
    children: [
      /* @__PURE__ */ s(l, { className: "size-5" }),
      o === "setup" && a > 0 && /* @__PURE__ */ s("span", { className: "absolute -right-0.5 -top-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-destructive px-1 text-xs font-semibold leading-none text-destructive-foreground", "aria-hidden": "true", children: a })
    ]
  },
  o
)) }), ns = 300, ss = 260, cs = 560, Pp = 16, Ap = "theme-builder:sidebar-width", Lp = (e) => Math.min(cs, Math.max(ss, Math.round(e)));
function sB() {
  const [e, t] = j(() => {
    try {
      const o = Number(localStorage.getItem(Ap));
      return o ? Lp(o) : ns;
    } catch {
      return ns;
    }
  }), a = be((o) => {
    const r = Lp(o);
    t(r);
    try {
      localStorage.setItem(Ap, String(r));
    } catch {
    }
  }, []);
  return [e, a];
}
function cB({ width: e, onResize: t }) {
  const a = ve(null), [o, r] = j(!1), l = (d) => {
    d.button === 0 && (d.preventDefault(), d.currentTarget.setPointerCapture(d.pointerId), a.current = { x: d.clientX, width: e }, r(!0));
  }, i = (d) => {
    a.current && t(a.current.width + d.clientX - a.current.x);
  }, n = () => {
    a.current = null, r(!1);
  };
  return /* @__PURE__ */ s(
    "div",
    {
      role: "separator",
      "aria-orientation": "vertical",
      "aria-label": "Resize sidebar",
      "aria-valuenow": e,
      "aria-valuemin": ss,
      "aria-valuemax": cs,
      tabIndex: 0,
      title: "Drag to resize · double-click to reset",
      onPointerDown: l,
      onPointerMove: i,
      onPointerUp: n,
      onPointerCancel: n,
      onDoubleClick: () => t(ns),
      onKeyDown: (d) => {
        if (d.key === "ArrowLeft") t(e - Pp);
        else if (d.key === "ArrowRight") t(e + Pp);
        else if (d.key === "Home") t(ss);
        else if (d.key === "End") t(cs);
        else return;
        d.preventDefault();
      },
      className: "group relative z-10 -ml-1 w-2 shrink-0 cursor-col-resize touch-none outline-none",
      children: /* @__PURE__ */ s(
        "span",
        {
          "aria-hidden": "true",
          className: St(
            "absolute inset-y-0 left-1/2 w-0.5 -translate-x-1/2 transition-colors",
            o ? "bg-ink" : "bg-transparent group-hover:bg-border group-focus-visible:bg-ring"
          )
        }
      )
    }
  );
}
const dB = 'input, textarea, select, [contenteditable]:not([contenteditable="false"])', Mb = (e, t) => {
  t === "undo" ? e.undo() : t === "redo" ? e.redo() : e.publish();
}, pB = (e) => {
  ne(() => {
    const t = (a) => {
      const o = a.target, r = o == null ? void 0 : o.closest(dB), l = aR(a);
      if (l && (l === "save" || !r)) {
        a.preventDefault(), Mb(e, l);
        return;
      }
      r || (a.key === "Delete" ? e.remove() : a.altKey && a.key === "ArrowUp" ? (a.preventDefault(), e.moveUp()) : a.altKey && a.key === "ArrowDown" ? (a.preventDefault(), e.moveDown()) : a.key === "Escape" && e.deselect());
    };
    return window.addEventListener("keydown", t), () => window.removeEventListener("keydown", t);
  }, [e]);
}, ds = (e, t) => {
  const a = e.find((l) => l.key === t);
  if (a) return a;
  const o = e.find((l) => t.startsWith(`${l.key}.`));
  if (!o) return;
  const r = t.slice(o.key.length + 1);
  if (o.type === "array" && o.itemSchema) {
    const l = /^\d+\.(.+)$/.exec(r);
    return l ? ds(o.itemSchema, l[1]) : void 0;
  }
  return o.fields ? ds(o.fields, r) : void 0;
}, uB = ({ page: e, edit: t, onClose: a, onChange: o, onImageRequest: r, onMoreSettings: l }) => {
  var p, g, m, f;
  const { localSettings: i, schemas: n } = at(), c = t ? (m = (g = (p = i == null ? void 0 : i.pages) == null ? void 0 : p[e]) == null ? void 0 : g.sections) == null ? void 0 : m.find((v) => v.id === t.sectionId) : void 0, d = c ? (f = n == null ? void 0 : n.componentSchemas) == null ? void 0 : f[c.type] : void 0, y = (d == null ? void 0 : d.variants.find((v) => v.id === (c == null ? void 0 : c.variant))) ?? (d == null ? void 0 : d.variants[0]), u = [...(d == null ? void 0 : d.commonFields) ?? [], ...(y == null ? void 0 : y.fields) ?? []], h = ((t == null ? void 0 : t.paths) ?? []).map((v) => ({ path: v, field: ds(u, v) })).filter((v) => !!v.field);
  return /* @__PURE__ */ s(Ta, { open: !!(c && h.length), onOpenChange: (v) => !v && a(), children: /* @__PURE__ */ x(ca, { size: "sm", children: [
    /* @__PURE__ */ x(oo, { children: [
      /* @__PURE__ */ x(ro, { children: [
        (d == null ? void 0 : d.label) ?? "Section",
        t != null && t.label ? ` · ${t.label[0].toUpperCase()}${t.label.slice(1)}` : ""
      ] }),
      /* @__PURE__ */ s(Nr, { children: "Changes show in the preview as you make them. Undo with ⌘Z." })
    ] }),
    /* @__PURE__ */ s("div", { className: "space-y-4", children: c && h.map(({ path: v, field: k }) => /* @__PURE__ */ s(
      Xt,
      {
        label: k.label,
        field: k,
        path: v,
        value: Ms(c.props ?? {}, v),
        onChange: (w) => o(c.id, v, w),
        onImageRequest: (w) => r(c.id, w)
      },
      v
    )) }),
    /* @__PURE__ */ x(Ho, { children: [
      /* @__PURE__ */ s(le, { variant: "ghost", onClick: () => {
        c && l(c.id), a();
      }, children: "All settings" }),
      /* @__PURE__ */ s(le, { onClick: a, children: "Done" })
    ] })
  ] }) });
}, yB = () => {
  const e = "(max-width: 1023px)", [t, a] = j(() => window.matchMedia(e).matches);
  return ne(() => {
    const o = window.matchMedia(e), r = () => a(o.matches);
    return o.addEventListener("change", r), () => o.removeEventListener("change", r);
  }, []), t;
}, hB = { sections: "Sections", theme: "Theme settings", library: "Library", history: "History", setup: "Setup" }, bB = () => {
  var G;
  const e = ia(), t = at(), { localSettings: a, schemas: o, isLoading: r } = t, [l, i] = j("sections"), [n, c] = j("home"), [d, y] = j(null), [u, h] = j(!1), [p, g] = j("desktop"), [m, f] = j(!1), [v, k] = j("panel"), w = yB(), [S, T] = j(!0), [C, A] = sB(), M = (L) => {
    g(L), T(L !== "desktop");
  }, E = (L) => {
    i(L), T(!0);
  };
  ne(() => {
    p === "mobile" && f(!0);
  }, [p]);
  const F = fe(() => Array.from(/* @__PURE__ */ new Set([
    "home",
    ...Object.values((o == null ? void 0 : o.componentSchemas) ?? {}).flatMap((L) => L.supportedPages),
    ...Object.keys((a == null ? void 0 : a.pages) ?? {})
  ])), [o, a == null ? void 0 : a.pages]), I = fe(() => {
    var L, B;
    return ((B = (L = a == null ? void 0 : a.pages) == null ? void 0 : L[n]) == null ? void 0 : B.sections) ?? [];
  }, [a == null ? void 0 : a.pages, n]);
  ne(() => {
    d && !I.some((L) => L.id === d) && y(null);
  }, [I, d]);
  const P = be((L) => {
    y(L), L && (i("sections"), T(!0), w && k("editor"));
  }, [w]), O = W.useRef(null);
  ne(() => {
    var Q, xe;
    if (r || !a) return;
    const L = `${((Q = e.pendingEdits) == null ? void 0 : Q.key) ?? ""}|${JSON.stringify(e.initialView ?? {})}`;
    if (O.current === L) return;
    O.current = L;
    const B = e.initialView;
    if (B != null && B.page && c(B.page), B != null && B.panel && i(B.panel === "settings" ? "theme" : B.panel), B != null && B.sectionId && P(B.sectionId), (xe = e.pendingEdits) != null && xe.ops.length) {
      const ue = e.pendingEdits.ops[0];
      ue.page && c(ue.page), t.applyEdits(e.pendingEdits.ops);
    }
  }, [r, a, e.initialView, e.pendingEdits, t, P]);
  const z = be((L) => {
    var Q, xe;
    const B = I.find((ue) => ue.id === L);
    return (B == null ? void 0 : B.type) && ((xe = (Q = o == null ? void 0 : o.componentSchemas) == null ? void 0 : Q[B.type]) == null ? void 0 : xe.label) || (B == null ? void 0 : B.type) || "Section";
  }, [I, o]), U = be((L, B, Q, xe) => {
    I.some((ue) => ue.id === L) && t.updateSection(n, L, (ue) => {
      const Re = ue.props ?? {};
      return { ...ue, props: vu(Re, B, Q(Ms(Re, B))) };
    }, xe);
  }, [t, I, n]), Y = be((L) => {
    U(L.sectionId, L.path, (B) => FL(B, L.locale, L.value), `${L.sectionId}:${L.path}`);
  }, [U]), [_, H] = j(null), N = be((L, B, Q) => H({ sectionId: L, paths: B, label: Q }), []), D = be((L, B, Q) => {
    U(L, B, () => Q, `${L}:${B}`);
  }, [U]), $ = be((L, B) => {
    var Q;
    (Q = e.openMediaPicker) == null || Q.call(e, (xe) => U(L, B, () => xe));
  }, [e, U]), V = be(() => {
    y(null), i("theme"), T(!0), w && k("editor");
  }, [w]), X = (L, B) => {
    c(L), P(B ?? null);
  }, oe = (L, B) => {
    const Q = d ? I.findIndex((ue) => ue.id === d) + 1 : void 0, xe = t.insertSection(n, L, B, Q);
    xe && P(xe);
  }, pe = fe(() => ({
    undo: t.undo,
    redo: t.redo,
    publish: () => {
      t.hasChanges && t.publish();
    },
    remove: () => {
      d && (t.removeSection(n, d), y(null));
    },
    moveUp: () => {
      d && t.moveSection(n, d, -1);
    },
    moveDown: () => {
      d && t.moveSection(n, d, 1);
    },
    deselect: () => y(null)
  }), [t, n, d]);
  pB(pe);
  const Se = be((L) => Mb(pe, L), [pe]), ae = sD({
    library: () => E("library"),
    home: () => {
      c("home"), i("sections");
    },
    header: () => E("theme"),
    mobile: () => {
      M("mobile"), w && k("preview");
    }
  }, m);
  if (ne(() => {
    ae.filter((L) => L.done).forEach((L) => {
      var B;
      return (B = e.track) == null ? void 0 : B.call(e, "theme_editor_setup_step_done", { step: L.id });
    });
  }, [ae.filter((L) => L.done).length]), r)
    return /* @__PURE__ */ x("div", { className: "theme-builder-root flex h-dvh flex-col items-center justify-center bg-background", role: "status", children: [
      /* @__PURE__ */ s("div", { className: "size-8 animate-spin rounded-full border-2 border-border border-t-ink" }),
      /* @__PURE__ */ s("p", { className: "mt-3 text-sm text-muted-foreground", children: "Opening the theme editor" })
    ] });
  const q = (G = a == null ? void 0 : a.config) == null ? void 0 : G.themeId;
  if (!q || !FP.has(q))
    return /* @__PURE__ */ s("div", { className: "theme-builder-root flex min-h-dvh flex-col items-center justify-center bg-background p-6", children: /* @__PURE__ */ x("div", { className: "w-full max-w-2xl space-y-6 text-center", children: [
      /* @__PURE__ */ s("span", { className: "inline-grid size-14 place-items-center rounded-full bg-fill", children: /* @__PURE__ */ s(gA, { className: "size-6 text-ink" }) }),
      /* @__PURE__ */ x("div", { className: "space-y-1", children: [
        /* @__PURE__ */ s("h1", { className: "text-heading-xl text-ink", children: "Choose a theme" }),
        /* @__PURE__ */ s("p", { className: "text-sm text-muted-foreground", children: "You can switch later; your content stays." })
      ] }),
      /* @__PURE__ */ s("div", { className: "grid grid-cols-1 gap-3 sm:grid-cols-2", children: mu().map((L) => /* @__PURE__ */ x("button", { type: "button", onClick: () => t.switchTheme(L.id, { fill: gu(L.id), themeLook: { mode: L.defaultMode ?? "light" } }), className: "rounded-lg border border-border bg-card p-4 text-left shadow-card outline-none transition-colors hover:border-ink focus-visible:ring-2 focus-visible:ring-ring", children: [
        L.thumbnail && /* @__PURE__ */ s("img", { src: L.thumbnail, alt: "", className: "mb-3 aspect-video w-full rounded-md object-cover object-top", onError: (B) => {
          B.currentTarget.hidden = !0;
        } }),
        /* @__PURE__ */ s("span", { className: "block text-sm font-semibold text-ink", children: zl(L) }),
        /* @__PURE__ */ s("span", { className: "text-xs text-muted-foreground", children: L.category })
      ] }, L.id)) })
    ] }) });
  const Z = l === "sections" ? /* @__PURE__ */ x("div", { className: "flex h-full flex-col", children: [
    /* @__PURE__ */ s(Tp, { onOpen: X }),
    /* @__PURE__ */ s("div", { className: "flex-1 overflow-hidden pt-1", children: /* @__PURE__ */ s($N, { selectedPage: n, selectedSectionId: d, onSelectSection: P }) }),
    /* @__PURE__ */ s("div", { className: "shrink-0 border-t border-border p-3", children: /* @__PURE__ */ s(le, { variant: "secondary", className: "w-full", onClick: () => h(!0), "data-copilot-id": "theme_add_section_button", children: "Add section" }) })
  ] }) : l === "library" ? /* @__PURE__ */ s(rB, { page: n }) : l === "history" ? /* @__PURE__ */ s(tB, {}) : l === "setup" ? /* @__PURE__ */ s(cD, { steps: ae }) : /* @__PURE__ */ s(xp, { editMode: "global", selectedPage: n, selectedSectionId: d }), ie = /* @__PURE__ */ s(xp, { editMode: l === "theme" ? "global" : "section", selectedPage: n, selectedSectionId: d }), K = e.preview && /* @__PURE__ */ s(
    rR,
    {
      preview: e.preview,
      settings: a,
      page: n,
      pages: F,
      selectedSectionId: d,
      onSectionClick: P,
      onPageChange: c,
      onRegionClick: V,
      sectionLabel: z,
      onFieldEdit: Y,
      onImagePick: $,
      onFieldsOpen: N,
      onShortcut: Se,
      device: p,
      onDeviceChange: M
    }
  ), se = l === "sections" && d ? /* @__PURE__ */ x("div", { className: "flex h-full flex-col", children: [
    /* @__PURE__ */ x("div", { className: "flex h-11 shrink-0 items-center gap-1 border-b border-border px-2", children: [
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          onClick: () => y(null),
          "aria-label": "Back to sections",
          className: "grid size-7 place-items-center rounded-md text-muted-foreground outline-none hover:bg-subdued hover:text-ink focus-visible:ring-2 focus-visible:ring-ring",
          children: /* @__PURE__ */ s(uu, { className: "size-4" })
        }
      ),
      /* @__PURE__ */ s("span", { className: "truncate text-sm font-semibold text-ink", children: z(d) })
    ] }),
    /* @__PURE__ */ s(Tp, { onOpen: X }),
    /* @__PURE__ */ s("div", { className: "min-h-0 flex-1", children: ie })
  ] }) : /* @__PURE__ */ x("div", { className: "flex h-full flex-col", children: [
    /* @__PURE__ */ s("div", { className: "flex h-11 shrink-0 items-center border-b border-border px-4", children: /* @__PURE__ */ s("h2", { className: "text-sm font-semibold text-ink", children: hB[l] }) }),
    /* @__PURE__ */ s("div", { className: "min-h-0 flex-1", children: Z })
  ] }), Pe = K && /* @__PURE__ */ s(
    "button",
    {
      type: "button",
      "aria-pressed": S,
      "aria-label": S ? "Hide sidebar" : "Show sidebar",
      title: S ? "Hide sidebar" : "Show sidebar",
      onClick: () => T((L) => !L),
      className: St("grid size-7 place-items-center rounded-md outline-none hover:bg-subdued focus-visible:ring-2 focus-visible:ring-ring", S ? "text-ink" : "text-muted-foreground"),
      children: S ? /* @__PURE__ */ s(AA, { className: "size-4" }) : /* @__PURE__ */ s(LA, { className: "size-4" })
    }
  );
  return /* @__PURE__ */ x("div", { className: "theme-builder-root flex h-dvh flex-col overflow-hidden bg-background", children: [
    /* @__PURE__ */ s(
      iR,
      {
        pages: F,
        selectedPage: n,
        onSelectPage: (L) => {
          c(L), y(null);
        },
        device: K ? p : void 0,
        onDeviceChange: K ? M : void 0,
        panelToggle: w ? void 0 : Pe
      }
    ),
    /* @__PURE__ */ s(lB, {}),
    /* @__PURE__ */ s(iB, {}),
    /* @__PURE__ */ s(nD, { open: u, onOpenChange: h, page: n, onPick: oe }),
    /* @__PURE__ */ s(
      uB,
      {
        page: n,
        edit: _,
        onClose: () => H(null),
        onChange: D,
        onImageRequest: $,
        onMoreSettings: P
      }
    ),
    w ? /* @__PURE__ */ x(ut, { children: [
      /* @__PURE__ */ s("div", { className: "flex shrink-0 border-b border-border bg-card", role: "tablist", children: ["panel", "editor", ...K ? ["preview"] : []].map((L) => /* @__PURE__ */ s("button", { type: "button", role: "tab", "aria-selected": v === L, onClick: () => k(L), className: St("flex-1 border-b-2 py-2.5 text-sm font-medium", v === L ? "border-ink text-ink" : "border-transparent text-muted-foreground"), children: L === "panel" ? "Sections" : L === "editor" ? "Settings" : "Preview" }, L)) }),
      /* @__PURE__ */ x("div", { className: "flex flex-1 overflow-hidden", children: [
        v === "panel" && /* @__PURE__ */ x(ut, { children: [
          /* @__PURE__ */ s(Cp, { value: l, onChange: i, setupLeft: ae.filter((L) => !L.done).length }),
          /* @__PURE__ */ s("div", { className: "flex-1 overflow-hidden", children: Z })
        ] }),
        v === "editor" && /* @__PURE__ */ s("div", { className: "flex-1 overflow-hidden", children: ie }),
        v === "preview" && /* @__PURE__ */ s("div", { className: "flex-1 overflow-hidden", children: K })
      ] })
    ] }) : /* @__PURE__ */ x("div", { className: "flex flex-1 overflow-hidden", children: [
      /* @__PURE__ */ s(Cp, { value: l, onChange: E, setupLeft: ae.filter((L) => !L.done).length }),
      S && /* @__PURE__ */ s(
        "aside",
        {
          "aria-label": "Editor sidebar",
          className: St("flex flex-col overflow-hidden border-r border-border bg-card", K ? "shrink-0" : "min-w-0 flex-1"),
          style: K ? { width: C } : void 0,
          children: /* @__PURE__ */ s("div", { className: St("flex h-full flex-col", !K && "mx-auto w-full max-w-2xl"), children: se })
        }
      ),
      S && K && /* @__PURE__ */ s(cB, { width: C, onResize: A }),
      K && /* @__PURE__ */ s("div", { className: "min-w-0 flex-1", children: K })
    ] })
  ] });
}, mB = ({ service: e, open: t, multiple: a = !1 }) => {
  const [o, r] = j([]), [l, i] = j(null), [n, c] = j([]), [d, y] = j(""), [u, h] = j(!1), [p, g] = j(!1), [m, f] = j(!1), [v, k] = j(null), w = (l == null ? void 0 : l._id) ?? null, S = be(async () => {
    h(!0);
    try {
      const N = await e.getRootFolders();
      r(N);
    } catch {
      Me.error("Failed to load media library");
    } finally {
      h(!1);
    }
  }, [e]);
  ne(() => {
    t === void 0 || t ? S() : (i(null), c([]), y(""), g(!1), f(!1), k(null));
  }, [t]);
  const T = be(async () => {
    if (w) {
      h(!0);
      try {
        const N = await e.getFolder(w);
        i(N);
      } catch {
        Me.error("Failed to refresh folder");
      } finally {
        h(!1);
      }
    } else
      await S();
  }, [w, e, S]), C = be(async (N) => {
    if (!N) {
      i(null), c([]);
      return;
    }
    h(!0);
    try {
      const D = await e.getFolder(N);
      i(D), c([]);
    } catch {
      Me.error("Failed to open folder");
    } finally {
      h(!1);
    }
  }, [e]), A = be((N) => {
    c(a ? (D) => D.find((V) => V._id === N._id) ? D.filter((V) => V._id !== N._id) : [...D, N] : [N]);
  }, [a]), M = be(() => {
    c([]);
  }, []), E = be(async (N) => {
    if (e.createFolder)
      try {
        await e.createFolder(N, w), Me.success("Folder created"), g(!1), await T();
      } catch {
        Me.error("Failed to create folder");
      }
  }, [e, w, T]), F = be(async (N) => {
    if (e.uploadFile) {
      h(!0);
      try {
        await e.uploadFile(N, w), Me.success("File uploaded"), await T();
      } catch {
        Me.error("Upload failed");
      } finally {
        h(!1);
      }
    }
  }, [e, w, T]), I = be(async (N) => {
    if (e.deleteFile)
      try {
        await e.deleteFile(N), Me.success("File deleted"), c((D) => D.filter(($) => $._id !== N)), await T();
      } catch {
        Me.error("Failed to delete file");
      }
  }, [e, T]), P = be(async (N) => {
    if (e.deleteFolder)
      try {
        await e.deleteFolder(N), Me.success("Folder deleted"), await T();
      } catch {
        Me.error("Failed to delete folder");
      }
  }, [e, T]), O = (l == null ? void 0 : l.folders) ?? o, z = (l == null ? void 0 : l.files) ?? [], U = d.toLowerCase(), Y = O.filter((N) => N.name.toLowerCase().includes(U)), _ = z.filter((N) => N.name.toLowerCase().includes(U)), H = (N) => {
    if (!N) return "0 B";
    const D = 1024, $ = ["B", "KB", "MB", "GB"], V = Math.floor(Math.log(N) / Math.log(D));
    return `${parseFloat((N / Math.pow(D, V)).toFixed(1))} ${$[V]}`;
  };
  return {
    // navigation
    currentFolderId: w,
    currentFolderName: (l == null ? void 0 : l.name) ?? "Media Library",
    navigateToFolder: C,
    // data
    filteredFolders: Y,
    filteredFiles: _,
    isLoading: u,
    // selection
    selectedFiles: n,
    toggleSelect: A,
    clearSelection: M,
    // search
    searchTerm: d,
    setSearchTerm: y,
    // dialogs
    isUploadOpen: m,
    setIsUploadOpen: f,
    isNewFolderOpen: p,
    setIsNewFolderOpen: g,
    deleteTarget: v,
    setDeleteTarget: k,
    // actions
    handleUpload: F,
    handleCreateFolder: E,
    handleDeleteFile: I,
    handleDeleteFolder: P,
    // capabilities
    canUpload: !!e.uploadFile,
    canCreateFolder: !!e.createFolder,
    canDelete: !!(e.deleteFile || e.deleteFolder),
    // utils
    formatSize: H
  };
}, gB = ({
  mode: e,
  currentFolderId: t,
  currentFolderName: a,
  folderCount: o,
  fileCount: r,
  searchTerm: l,
  canUpload: i,
  canCreateFolder: n,
  onBack: c,
  onClose: d,
  onUpload: y,
  onNewFolder: u,
  onSearchChange: h
}) => {
  const p = e === "modal";
  return /* @__PURE__ */ x("div", { className: "z-10 flex shrink-0 flex-col border-b border-border-subtle bg-card", children: [
    p && /* @__PURE__ */ x("div", { className: "flex items-center justify-between gap-3 px-4 pb-1 pt-4", children: [
      /* @__PURE__ */ s("h2", { className: "text-heading-md text-ink", children: "Select file" }),
      d && /* @__PURE__ */ s(le, { size: "icon", variant: "ghost", "aria-label": "Close", onClick: d, children: /* @__PURE__ */ s(dr, {}) })
    ] }),
    /* @__PURE__ */ x("div", { className: "flex items-center justify-between gap-3 px-4 py-3", children: [
      /* @__PURE__ */ x("nav", { "aria-label": "Folder path", className: "flex min-w-0 items-center gap-1.5", children: [
        /* @__PURE__ */ s("div", { className: "grid size-7 shrink-0 place-items-center rounded-md bg-fill", children: /* @__PURE__ */ s(yA, { className: "size-4 text-ink" }) }),
        t ? /* @__PURE__ */ x(ut, { children: [
          /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              onClick: c,
              className: "shrink-0 rounded-sm text-sm text-text-2 outline-none transition-colors hover:text-ink hover:underline focus-visible:ring-2 focus-visible:ring-ring",
              children: "All files"
            }
          ),
          /* @__PURE__ */ s(Cs, { className: "size-4 shrink-0 text-muted-foreground", "aria-hidden": "true" }),
          /* @__PURE__ */ s("p", { className: "truncate text-sm font-semibold text-ink", "aria-current": "page", children: a })
        ] }) : /* @__PURE__ */ s("p", { className: "truncate text-sm font-semibold text-ink", children: "All files" }),
        /* @__PURE__ */ x("p", { className: "ml-1 hidden shrink-0 text-xs tabular-nums text-text-2 sm:block", children: [
          o,
          " ",
          o === 1 ? "folder" : "folders",
          " · ",
          r,
          " ",
          r === 1 ? "file" : "files"
        ] })
      ] }),
      /* @__PURE__ */ x("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ x("div", { className: "hidden items-center gap-2 sm:flex", children: [
          n && /* @__PURE__ */ x(
            le,
            {
              variant: "outline",
              onClick: u,
              children: [
                /* @__PURE__ */ s(Sl, {}),
                "New folder"
              ]
            }
          ),
          i && /* @__PURE__ */ x(
            le,
            {
              variant: p ? "secondary" : "default",
              disabled: !t,
              title: t ? void 0 : "Open a folder to upload",
              onClick: y,
              children: [
                /* @__PURE__ */ s(Ln, {}),
                p ? "Add media" : "Upload files"
              ]
            }
          )
        ] }),
        /* @__PURE__ */ x("div", { className: "flex items-center gap-1 sm:hidden", children: [
          n && /* @__PURE__ */ s(le, { size: "icon", variant: "ghost", "aria-label": "New folder", onClick: u, children: /* @__PURE__ */ s(Sl, {}) }),
          i && /* @__PURE__ */ s(le, { size: "icon", variant: "ghost", "aria-label": "Upload files", disabled: !t, onClick: y, children: /* @__PURE__ */ s(Ln, {}) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ s("div", { className: "px-4 pb-3", children: /* @__PURE__ */ x("div", { className: "relative w-full sm:max-w-md", children: [
      /* @__PURE__ */ s(As, { className: "absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" }),
      /* @__PURE__ */ s(
        Ze,
        {
          type: "search",
          placeholder: t ? `Search in ${a}` : "Search folders",
          className: "pl-8",
          value: l,
          onChange: (g) => h(g.target.value)
        }
      ),
      l && /* @__PURE__ */ s(
        le,
        {
          variant: "ghost",
          size: "icon-sm",
          "aria-label": "Clear search",
          className: "absolute right-1 top-1/2 -translate-y-1/2",
          onClick: () => h(""),
          children: /* @__PURE__ */ s(dr, {})
        }
      )
    ] }) })
  ] });
}, fB = Bs(zs);
function ko(...e) {
  return fB(Yl(e));
}
const Mp = (e) => e.includes("image") ? /* @__PURE__ */ s(Ps, { className: "size-6 text-muted-foreground" }) : e.includes("video") ? /* @__PURE__ */ s(pA, { className: "size-6 text-muted-foreground" }) : e.includes("audio") ? /* @__PURE__ */ s(CA, { className: "size-6 text-muted-foreground" }) : e.includes("pdf") ? /* @__PURE__ */ s(hu, { className: "size-6 text-muted-foreground" }) : e.includes("text") || e.includes("code") || e.includes("json") ? /* @__PURE__ */ s(lA, { className: "size-6 text-muted-foreground" }) : /* @__PURE__ */ s(aA, { className: "size-6 text-muted-foreground" }), vB = /\.(avif|bmp|gif|ico|jpe?g|png|svg|webp)$/i, Np = ({
  file: e,
  viewMode: t = "grid",
  resolveUrl: a,
  formatSize: o,
  selectable: r = !1,
  selected: l = !1,
  onSelect: i,
  onActivate: n,
  onDelete: c,
  canDelete: d = !1
}) => {
  var m, f;
  const y = ((m = e.type) == null ? void 0 : m.includes("image")) || vB.test(e.name), u = a(e.path), h = (e.name.split(".").pop() ?? ((f = e.type) == null ? void 0 : f.split("/")[1]) ?? "").toUpperCase(), p = () => {
    r && i && i();
  }, g = {
    role: r ? "checkbox" : void 0,
    "aria-checked": r ? l : void 0,
    "aria-label": e.name,
    tabIndex: 0,
    onClick: p,
    onDoubleClick: n,
    onKeyDown: (v) => {
      v.target === v.currentTarget && (v.key === " " ? (v.preventDefault(), p()) : v.key === "Enter" && (v.preventDefault(), n ? n() : p()));
    }
  };
  return t === "list" ? /* @__PURE__ */ x(
    "div",
    {
      className: ko(
        "group flex cursor-pointer items-center gap-3 border-b border-border-subtle px-3 py-2 outline-none transition-colors last:border-0 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring",
        l ? "bg-fill" : "hover:bg-subdued"
      ),
      ...g,
      children: [
        r && /* @__PURE__ */ s(
          "span",
          {
            "aria-hidden": "true",
            className: ko(
              "grid size-4 shrink-0 place-items-center rounded border",
              l ? "border-ink bg-ink text-primary-foreground" : "border-input bg-card"
            ),
            children: l && /* @__PURE__ */ s(cr, { className: "size-3", strokeWidth: 3 })
          }
        ),
        /* @__PURE__ */ s("div", { className: "grid size-10 shrink-0 place-items-center overflow-hidden rounded-md border border-border-subtle bg-subdued", children: y ? /* @__PURE__ */ s("img", { src: u, alt: "", className: "size-full object-cover", loading: "lazy" }) : Mp(e.type) }),
        /* @__PURE__ */ x("div", { className: "min-w-0 flex-1", children: [
          /* @__PURE__ */ s("p", { className: "truncate text-sm text-ink", children: e.name }),
          /* @__PURE__ */ s("p", { className: "text-xs tabular-nums text-text-2", children: o(e.size) })
        ] }),
        /* @__PURE__ */ s("span", { className: "hidden shrink-0 text-sm text-text-2 sm:block", children: h }),
        d && c && /* @__PURE__ */ x(Fl, { children: [
          /* @__PURE__ */ s(Il, { asChild: !0, children: /* @__PURE__ */ s(le, { variant: "ghost", size: "icon-sm", "aria-label": "File actions", className: "opacity-0 transition-opacity focus-visible:opacity-100 group-hover:opacity-100", onClick: (v) => v.stopPropagation(), children: /* @__PURE__ */ s(Mn, {}) }) }),
          /* @__PURE__ */ s(kr, { align: "end", children: /* @__PURE__ */ x(
            No,
            {
              className: "text-error focus:bg-error-lighter focus:text-error-dark",
              onClick: (v) => {
                v.stopPropagation(), c(e._id);
              },
              children: [
                /* @__PURE__ */ s(Co, { className: "mr-2 size-4" }),
                " Delete"
              ]
            }
          ) })
        ] })
      ]
    }
  ) : /* @__PURE__ */ x(
    "div",
    {
      className: ko(
        "group relative cursor-pointer overflow-hidden rounded-lg border bg-card outline-none transition-[border-color,box-shadow] focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        l ? "border-ink ring-1 ring-ink" : "border-border-subtle hover:border-border hover:shadow-card"
      ),
      title: e.name,
      ...g,
      children: [
        d && c && /* @__PURE__ */ s("div", { className: "absolute right-2 top-2 z-10 opacity-0 transition-opacity focus-within:opacity-100 group-hover:opacity-100 group-focus-visible:opacity-100", children: /* @__PURE__ */ x(Fl, { children: [
          /* @__PURE__ */ s(Il, { asChild: !0, children: /* @__PURE__ */ s(
            le,
            {
              variant: "outline",
              size: "icon-sm",
              "aria-label": "File actions",
              className: "shadow-card",
              onClick: (v) => v.stopPropagation(),
              children: /* @__PURE__ */ s(Mn, {})
            }
          ) }),
          /* @__PURE__ */ s(kr, { align: "end", children: /* @__PURE__ */ x(
            No,
            {
              className: "text-error focus:bg-error-lighter focus:text-error-dark",
              onClick: (v) => {
                v.stopPropagation(), c(e._id);
              },
              children: [
                /* @__PURE__ */ s(Co, { className: "mr-2 size-4" }),
                " Delete"
              ]
            }
          ) })
        ] }) }),
        /* @__PURE__ */ x("div", { className: "relative grid aspect-square place-items-center overflow-hidden border-b border-border-subtle bg-subdued", children: [
          y ? /* @__PURE__ */ s(
            "img",
            {
              src: u,
              alt: "",
              className: "size-full object-contain p-2",
              loading: "lazy"
            }
          ) : Mp(e.type),
          r && /* @__PURE__ */ s(
            "div",
            {
              className: ko(
                "absolute left-2 top-2 grid size-5 place-items-center rounded border transition-opacity",
                l ? "border-ink bg-ink text-primary-foreground" : "border-input bg-card opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100"
              ),
              children: l && /* @__PURE__ */ s(cr, { className: "size-3", strokeWidth: 3 })
            }
          )
        ] }),
        /* @__PURE__ */ x("div", { className: "px-2.5 py-2", children: [
          /* @__PURE__ */ s("p", { className: "truncate text-sm text-ink", children: e.name }),
          /* @__PURE__ */ x("p", { className: "mt-0.5 truncate text-xs tabular-nums text-text-2", children: [
            h,
            " · ",
            o(e.size)
          ] })
        ] })
      ]
    }
  );
}, kB = ({
  folder: e,
  onNavigate: t,
  onDelete: a,
  canDelete: o = !1
}) => /* @__PURE__ */ x("div", { className: "relative group", children: [
  /* @__PURE__ */ x(
    "div",
    {
      className: ko(
        "flex cursor-pointer items-center gap-3 rounded-lg border border-border-subtle bg-card p-3 pr-10 outline-none transition-colors",
        "hover:bg-subdued focus-visible:ring-2 focus-visible:ring-ring"
      ),
      role: "button",
      tabIndex: 0,
      onClick: () => t(e._id),
      onKeyDown: (r) => {
        (r.key === "Enter" || r.key === " ") && (r.preventDefault(), t(e._id));
      },
      children: [
        /* @__PURE__ */ s("div", { className: "grid size-8 shrink-0 place-items-center rounded-md bg-fill", children: /* @__PURE__ */ s(uA, { className: "size-4 text-text-2" }) }),
        /* @__PURE__ */ x("div", { className: "min-w-0 flex-1", children: [
          /* @__PURE__ */ s("p", { className: "truncate text-sm font-medium text-ink", children: e.name }),
          e.item_count !== void 0 && /* @__PURE__ */ x("p", { className: "text-xs tabular-nums text-text-2", children: [
            e.item_count,
            " items"
          ] })
        ] })
      ]
    }
  ),
  o && a && /* @__PURE__ */ x(Fl, { children: [
    /* @__PURE__ */ s(Il, { asChild: !0, children: /* @__PURE__ */ s(
      le,
      {
        variant: "ghost",
        size: "icon-sm",
        "aria-label": "Folder actions",
        className: "absolute right-2 top-1/2 z-10 -translate-y-1/2 opacity-0 transition-opacity focus-visible:opacity-100 group-hover:opacity-100",
        children: /* @__PURE__ */ s(Mn, {})
      }
    ) }),
    /* @__PURE__ */ s(kr, { align: "end", children: /* @__PURE__ */ x(
      No,
      {
        className: "text-error focus:bg-error-lighter focus:text-error-dark",
        onClick: (r) => {
          r.stopPropagation(), a(e._id, e.name);
        },
        children: [
          /* @__PURE__ */ s(Co, { className: "mr-2 size-4" }),
          " Delete folder"
        ]
      }
    ) })
  ] })
] }), Nb = ({ className: e }) => /* @__PURE__ */ s(wA, { "aria-hidden": "true", className: Ce("animate-spin", e) }), wB = ({
  isLoading: e,
  folders: t,
  files: a,
  searchTerm: o,
  selectedFiles: r,
  multiple: l,
  resolveUrl: i,
  formatSize: n,
  canDelete: c,
  navigateToFolder: d,
  toggleSelect: y,
  onActivateFile: u,
  onDeleteFolder: h,
  onDeleteFile: p,
  viewMode: g = "grid"
}) => e ? /* @__PURE__ */ s("div", { className: "flex min-w-0 flex-1 items-center justify-center", children: /* @__PURE__ */ s(Nb, { className: "w-6 h-6 text-muted-foreground" }) }) : /* @__PURE__ */ s("div", { className: "min-h-0 min-w-0 flex-1 overflow-y-auto", children: /* @__PURE__ */ s("div", { className: "p-4", children: t.length === 0 && a.length === 0 ? /* @__PURE__ */ x("div", { className: "flex h-[40vh] flex-col items-center justify-center", children: [
  /* @__PURE__ */ s("span", { className: "mb-4 grid size-14 place-items-center rounded-full bg-fill", children: /* @__PURE__ */ s(bA, { className: "size-6 text-muted-foreground" }) }),
  /* @__PURE__ */ s("p", { className: "text-heading-md text-ink", children: o ? "No files found" : "This folder is empty" }),
  /* @__PURE__ */ s("p", { className: "mt-1 text-sm text-text-2", children: o ? "Try changing the search term." : "Upload files to get started." })
] }) : /* @__PURE__ */ x("div", { className: "space-y-4", children: [
  t.length > 0 && /* @__PURE__ */ x("div", { children: [
    /* @__PURE__ */ s("p", { className: "mb-2 text-sm font-medium text-ink", children: "Folders" }),
    /* @__PURE__ */ s("div", { className: "grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-3", children: t.map((m) => /* @__PURE__ */ s(
      kB,
      {
        folder: m,
        onNavigate: d,
        onDelete: h,
        canDelete: c
      },
      m._id
    )) })
  ] }),
  a.length > 0 && /* @__PURE__ */ x("div", { children: [
    /* @__PURE__ */ s("p", { className: "mb-2 text-sm font-medium text-ink", children: "Files" }),
    g === "list" ? /* @__PURE__ */ s("div", { className: "overflow-hidden rounded-lg border border-border bg-card", children: a.map((m) => {
      const f = !!r.find((v) => v._id === m._id);
      return /* @__PURE__ */ s(
        Np,
        {
          file: m,
          viewMode: "list",
          resolveUrl: i,
          formatSize: n,
          selectable: !0,
          selected: f,
          onSelect: () => y(m),
          onActivate: u ? () => u(m) : void 0,
          onDelete: p ? (v) => p(v, m.name) : void 0,
          canDelete: c
        },
        m._id
      );
    }) }) : /* @__PURE__ */ s("div", { className: "grid grid-cols-[repeat(auto-fill,minmax(132px,1fr))] gap-3", children: a.map((m) => {
      const f = !!r.find((v) => v._id === m._id);
      return /* @__PURE__ */ s(
        Np,
        {
          file: m,
          viewMode: "grid",
          resolveUrl: i,
          formatSize: n,
          selectable: !0,
          selected: f,
          onSelect: () => y(m),
          onActivate: u ? () => u(m) : void 0,
          onDelete: p ? (v) => p(v, m.name) : void 0,
          canDelete: c
        },
        m._id
      );
    }) })
  ] })
] }) }) }), SB = /\.(avif|bmp|gif|ico|jpe?g|png|svg|webp)$/i, xB = ({
  selectedFile: e,
  resolveUrl: t,
  formatSize: a,
  onConfirm: o,
  onDelete: r,
  onOptimize: l,
  onConvert: i
}) => {
  const n = e.type.includes("image") || SB.test(e.name), d = [
    ["Type", (e.name.split(".").pop() ?? e.type.split("/")[1] ?? "").toUpperCase()],
    ["Size", a(e.size)]
  ];
  return e.width && e.height && d.push(["Dimensions", `${e.width} × ${e.height}`]), /* @__PURE__ */ x("aside", { className: "hidden w-80 shrink-0 flex-col border-l border-border-subtle bg-card lg:flex", children: [
    /* @__PURE__ */ x("div", { className: "min-h-0 flex-1 space-y-4 overflow-y-auto p-4", children: [
      /* @__PURE__ */ s("div", { className: "grid aspect-[4/3] place-items-center overflow-hidden rounded-lg border border-border-subtle bg-subdued", children: n ? /* @__PURE__ */ s(
        "img",
        {
          src: t(e.path),
          className: "max-h-full max-w-full object-contain",
          alt: e.name
        }
      ) : /* @__PURE__ */ s(hu, { className: "size-12 text-muted-foreground" }) }),
      /* @__PURE__ */ s("p", { className: "break-all text-sm font-semibold text-ink", children: e.name }),
      /* @__PURE__ */ s("dl", { className: "divide-y divide-border-subtle rounded-lg border border-border-subtle", children: d.map(([y, u]) => /* @__PURE__ */ x("div", { className: "flex items-center justify-between gap-3 px-3 py-2 text-sm", children: [
        /* @__PURE__ */ s("dt", { className: "text-text-2", children: y }),
        /* @__PURE__ */ s("dd", { className: "tabular-nums text-ink", children: u })
      ] }, y)) }),
      (o || l || i) && /* @__PURE__ */ x("div", { className: "space-y-2", children: [
        o && /* @__PURE__ */ s(le, { className: "w-full", onClick: o, children: "Use file" }),
        l && /* @__PURE__ */ s(le, { variant: "outline", className: "w-full", onClick: l, children: "Optimize" }),
        i && /* @__PURE__ */ s(le, { variant: "outline", className: "w-full", onClick: i, children: "Convert" })
      ] })
    ] }),
    r && /* @__PURE__ */ s("div", { className: "border-t border-border-subtle p-3", children: /* @__PURE__ */ x(
      le,
      {
        variant: "ghost",
        size: "sm",
        className: "w-full text-error hover:bg-error-lighter hover:text-error-dark",
        onClick: r,
        children: [
          /* @__PURE__ */ s(Co, {}),
          " Delete file"
        ]
      }
    ) })
  ] });
}, TB = ({ open: e, onOpenChange: t, onUpload: a, disabled: o }) => {
  const r = ve(null), [l, i] = j(!1), [n, c] = j([]), [d, y] = j(!1), u = (m) => {
    m && c(Array.from(m));
  }, h = (m) => {
    m.preventDefault(), i(!1), u(m.dataTransfer.files);
  }, p = async () => {
    y(!0);
    try {
      for (const m of n)
        await a(m), await new Promise((f) => setTimeout(f, 200));
      c([]), t(!1);
    } finally {
      y(!1);
    }
  }, g = () => {
    d || (c([]), t(!1));
  };
  return /* @__PURE__ */ s(Ta, { open: e, onOpenChange: g, children: /* @__PURE__ */ x(ca, { className: "sm:max-w-[420px]", children: [
    /* @__PURE__ */ s(oo, { children: /* @__PURE__ */ s(ro, { children: "Upload files" }) }),
    /* @__PURE__ */ s("div", { className: "space-y-4", children: n.length === 0 ? /* @__PURE__ */ x(
      "div",
      {
        className: ko(
          "cursor-pointer rounded-lg border border-dashed p-8 text-center transition-colors",
          l ? "border-ink bg-subdued" : "border-input bg-card hover:bg-subdued"
        ),
        onDragOver: (m) => {
          m.preventDefault(), i(!0);
        },
        onDragLeave: () => i(!1),
        onDrop: h,
        onClick: () => {
          var m;
          return (m = r.current) == null ? void 0 : m.click();
        },
        children: [
          /* @__PURE__ */ s(Ln, { className: "mx-auto mb-3 size-6 text-muted-foreground" }),
          /* @__PURE__ */ s("span", { className: "inline-flex h-7 items-center rounded-full bg-fill px-3 text-xs font-medium text-ink", children: "Add files" }),
          /* @__PURE__ */ s("p", { className: "mt-2 text-sm text-text-2", children: "or drop images, videos and documents to upload" }),
          /* @__PURE__ */ s(
            "input",
            {
              ref: r,
              type: "file",
              multiple: !0,
              className: "hidden",
              onChange: (m) => u(m.target.files)
            }
          )
        ]
      }
    ) : /* @__PURE__ */ s("div", { className: "max-h-48 space-y-2 overflow-y-auto", children: n.map((m, f) => /* @__PURE__ */ x("div", { className: "flex items-center gap-3 rounded-lg border border-border-subtle px-3 py-2", children: [
      /* @__PURE__ */ x("div", { className: "flex-1 min-w-0", children: [
        /* @__PURE__ */ s("p", { className: "truncate text-sm text-ink", children: m.name }),
        /* @__PURE__ */ x("p", { className: "text-xs tabular-nums text-text-2", children: [
          (m.size / 1024).toFixed(1),
          " KB"
        ] })
      ] }),
      !d && /* @__PURE__ */ s(
        le,
        {
          variant: "ghost",
          size: "icon-sm",
          "aria-label": "Remove file",
          onClick: () => c((v) => v.filter((k, w) => w !== f)),
          children: /* @__PURE__ */ s(dr, {})
        }
      )
    ] }, f)) }) }),
    /* @__PURE__ */ x(Ho, { children: [
      /* @__PURE__ */ s(le, { variant: "outline", onClick: g, disabled: d, children: "Cancel" }),
      /* @__PURE__ */ x(
        le,
        {
          onClick: p,
          disabled: n.length === 0 || d || o,
          children: [
            d && /* @__PURE__ */ s(Nb, {}),
            "Upload ",
            n.length > 0 && `(${n.length})`
          ]
        }
      )
    ] })
  ] }) });
}, CB = ({ open: e, onOpenChange: t, onCreate: a }) => {
  const [o, r] = j(""), l = () => {
    o.trim() && (a(o.trim()), r(""));
  };
  return /* @__PURE__ */ s(Ta, { open: e, onOpenChange: (n) => {
    r(""), t(n);
  }, children: /* @__PURE__ */ x(ca, { className: "sm:max-w-[420px]", children: [
    /* @__PURE__ */ s(oo, { children: /* @__PURE__ */ s(ro, { children: "Create folder" }) }),
    /* @__PURE__ */ x("div", { className: "space-y-1.5", children: [
      /* @__PURE__ */ s(xt, { htmlFor: "folder-name", className: "text-sm text-ink", children: "Folder name" }),
      /* @__PURE__ */ s(
        Ze,
        {
          id: "folder-name",
          value: o,
          onChange: (n) => r(n.target.value),
          onKeyDown: (n) => {
            n.key === "Enter" && l();
          },
          placeholder: "e.g., Product Images",
          autoFocus: !0
        }
      )
    ] }),
    /* @__PURE__ */ x(Ho, { children: [
      /* @__PURE__ */ s(le, { variant: "outline", onClick: () => t(!1), children: "Cancel" }),
      /* @__PURE__ */ s(le, { onClick: l, disabled: !o.trim(), children: "Create folder" })
    ] })
  ] }) });
}, PB = ({
  open: e,
  onOpenChange: t,
  title: a,
  description: o,
  onConfirm: r,
  confirmText: l = "Delete"
}) => /* @__PURE__ */ s(Ta, { open: e, onOpenChange: t, children: /* @__PURE__ */ x(ca, { className: "sm:max-w-[420px]", children: [
  /* @__PURE__ */ x("div", { className: "flex flex-col gap-1 pr-8", children: [
    /* @__PURE__ */ s("h3", { className: "text-heading-md text-ink", children: a }),
    /* @__PURE__ */ s("p", { className: "text-sm text-text-2", children: o })
  ] }),
  /* @__PURE__ */ x("div", { className: "-mx-6 flex justify-end gap-2 border-t border-border px-6 pt-4", children: [
    /* @__PURE__ */ s(le, { variant: "outline", onClick: () => t(!1), children: "Cancel" }),
    /* @__PURE__ */ s(
      le,
      {
        variant: "destructive",
        onClick: () => {
          r(), t(!1);
        },
        children: l
      }
    )
  ] })
] }) }), AB = ({
  open: e,
  onOpenChange: t,
  service: a,
  resolveUrl: o,
  onSelect: r,
  multiple: l = !1
}) => {
  var m, f;
  const i = mB({ service: a, open: e, multiple: l }), [n, c] = j(!1), d = (v) => {
    r(
      v.map((k) => ({
        _id: k._id,
        name: k.name,
        path: k.path,
        url: o(k.path),
        type: k.type,
        size: k.size
      }))
    ), t(!1);
  }, y = () => d(i.selectedFiles), u = (v, k, w) => {
    i.setDeleteTarget({ type: v, id: k, name: w }), c(!0);
  }, h = async () => {
    i.deleteTarget && (i.deleteTarget.type === "file" ? await i.handleDeleteFile(i.deleteTarget.id) : await i.handleDeleteFolder(i.deleteTarget.id), i.setDeleteTarget(null));
  }, p = i.selectedFiles.length > 0, g = i.selectedFiles.length === 1 ? i.selectedFiles[0] : null;
  return /* @__PURE__ */ x(ut, { children: [
    /* @__PURE__ */ s(Ta, { open: e, onOpenChange: t, children: /* @__PURE__ */ x(
      ca,
      {
        hideClose: !0,
        size: "xl",
        className: "flex h-[100dvh] max-h-none w-full flex-col gap-0 overflow-hidden rounded-none p-0 sm:h-[85vh] sm:max-h-[85vh] sm:w-[calc(100%-64px)] sm:rounded-xl",
        children: [
          /* @__PURE__ */ s(
            gB,
            {
              mode: "modal",
              currentFolderId: i.currentFolderId,
              currentFolderName: i.currentFolderName,
              folderCount: i.filteredFolders.length,
              fileCount: i.filteredFiles.length,
              searchTerm: i.searchTerm,
              canUpload: i.canUpload,
              canCreateFolder: i.canCreateFolder,
              onBack: () => i.navigateToFolder(null),
              onClose: () => t(!1),
              onUpload: () => i.setIsUploadOpen(!0),
              onNewFolder: () => i.setIsNewFolderOpen(!0),
              onSearchChange: i.setSearchTerm
            }
          ),
          /* @__PURE__ */ x("div", { className: "relative flex min-h-0 flex-1 overflow-hidden", children: [
            /* @__PURE__ */ s(
              wB,
              {
                isLoading: i.isLoading,
                folders: i.filteredFolders,
                files: i.filteredFiles,
                searchTerm: i.searchTerm,
                selectedFiles: i.selectedFiles,
                multiple: l,
                resolveUrl: o,
                formatSize: i.formatSize,
                canDelete: i.canDelete,
                navigateToFolder: i.navigateToFolder,
                toggleSelect: i.toggleSelect,
                onActivateFile: l ? void 0 : (v) => d([v]),
                onDeleteFolder: (v, k) => u("folder", v, k),
                onDeleteFile: (v, k) => u("file", v, k)
              }
            ),
            g && /* @__PURE__ */ s(
              xB,
              {
                selectedFile: g,
                resolveUrl: o,
                formatSize: i.formatSize,
                onDelete: () => u("file", g._id, g.name)
              }
            )
          ] }),
          /* @__PURE__ */ x("div", { className: "flex shrink-0 items-center justify-between gap-3 border-t border-border-subtle bg-card px-4 py-3", children: [
            /* @__PURE__ */ s("div", { className: "flex min-w-0 items-center gap-2 text-sm", children: p ? /* @__PURE__ */ x(ut, { children: [
              /* @__PURE__ */ s("span", { className: "truncate text-ink", children: g ? g.name : `${i.selectedFiles.length} files selected` }),
              /* @__PURE__ */ s(le, { variant: "ghost", size: "sm", onClick: i.clearSelection, children: "Clear" })
            ] }) : /* @__PURE__ */ s("span", { className: "hidden text-text-2 sm:inline", children: l ? "Select one or more files" : "Select a file · double-click to insert" }) }),
            /* @__PURE__ */ x("div", { className: "flex shrink-0 items-center gap-2", children: [
              /* @__PURE__ */ s(le, { variant: "outline", onClick: () => t(!1), children: "Cancel" }),
              /* @__PURE__ */ s(le, { onClick: y, disabled: !p, children: l && i.selectedFiles.length > 1 ? `Insert ${i.selectedFiles.length} files` : "Insert" })
            ] })
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ s(
      PB,
      {
        open: n,
        onOpenChange: c,
        title: `Delete ${((m = i.deleteTarget) == null ? void 0 : m.type) === "file" ? "file" : "folder"}?`,
        description: `Are you sure you want to delete "${(f = i.deleteTarget) == null ? void 0 : f.name}"? This action cannot be undone.`,
        onConfirm: h
      }
    ),
    /* @__PURE__ */ s(
      CB,
      {
        open: i.isNewFolderOpen,
        onOpenChange: i.setIsNewFolderOpen,
        onCreate: i.handleCreateFolder
      }
    ),
    /* @__PURE__ */ s(
      TB,
      {
        open: i.isUploadOpen,
        onOpenChange: i.setIsUploadOpen,
        onUpload: i.handleUpload,
        disabled: !i.currentFolderId
      }
    )
  ] });
}, LB = ({ config: e }) => {
  const [t, a] = j(!1), o = ve(null), r = ve(null), l = {
    ...e,
    openMediaPicker: e.mediaService ? (i) => {
      o.current = i, a(!0);
    } : e.openMediaPicker ?? ((i) => {
      const n = window.prompt("Enter image URL:");
      n && i(n);
    })
  };
  return /* @__PURE__ */ x("div", { className: "theme-builder-root", style: { display: "contents" }, children: [
    /* @__PURE__ */ s(Dp.Provider, { value: l, children: /* @__PURE__ */ s(ah.Provider, { value: r, children: /* @__PURE__ */ x(KP, { children: [
      /* @__PURE__ */ s(bB, {}),
      e.mediaService && /* @__PURE__ */ s(
        AB,
        {
          open: t,
          onOpenChange: a,
          service: e.mediaService,
          resolveUrl: e.resolveImageUrl,
          onSelect: (i) => {
            var c;
            const n = i[0];
            n && ((c = o.current) == null || c.call(o, n.url)), o.current = null, a(!1);
          },
          multiple: !1
        }
      )
    ] }) }) }),
    /* @__PURE__ */ s("div", { ref: r, className: "theme-builder-root" })
  ] });
}, ps = /* @__PURE__ */ new Map();
function HB(e, t) {
  const a = Ob.createRoot(e);
  ps.set(e, a), a.render(W.createElement(LB, { config: t }));
}
function UB(e) {
  const t = ps.get(e);
  t && (t.unmount(), ps.delete(e));
}
export {
  LB as ThemeBuilderEmbed,
  HB as mount,
  UB as unmount
};
